'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var antd = require('antd');
var jsxRuntime = require('react/jsx-runtime');
var React = require('react');
var PropTypes = require('prop-types');
var dayjs = require('dayjs');
var camelCase = require('lodash.camelcase');
require('react-is');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var dayjs__default = /*#__PURE__*/_interopDefaultLegacy(dayjs);
var camelCase__default = /*#__PURE__*/_interopDefaultLegacy(camelCase);

function DafTheme(_ref) {
  var children = _ref.children,
    theme = _ref.theme;
  return /*#__PURE__*/jsxRuntime.jsx(antd.ConfigProvider, {
    theme: {
      token: theme
    },
    children: children
  });
}

function _iterableToArrayLimit$1(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return {
          value: void 0,
          done: !0
        };
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable || "" === iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    throw new TypeError(typeof iterable + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function _typeof$1(obj) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof$1(obj);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty$1(obj, key, value) {
  key = _toPropertyKey$1(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _slicedToArray$1(arr, i) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
}
function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive$1(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey$1(arg) {
  var key = _toPrimitive$1(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var SCROLL = {
  y: 550,
  x: 1000
};

var capitalize = function capitalize(string) {
  return string && string.charAt(0).toUpperCase() + string.slice(1);
};
var camelCaseToTitle = function camelCaseToTitle(string) {
  return string && typeof string === 'string' ? string.split(/(?=[A-Z])/).map(function (word) {
    return capitalize(word);
  }).join(' ') : string;
};

var CustomSelect = function CustomSelect(_ref) {
  var value = _ref.value,
    filterSelectOptions = _ref.filterSelectOptions,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    _ref$i = _ref.i,
    i = _ref$i === void 0 ? 0 : _ref$i,
    k = _ref.k,
    filters = _ref.filters,
    _ref$config = _ref.config,
    config = _ref$config === void 0 ? {} : _ref$config;
  var filteredOptions = React.useMemo(function () {
    if (typeof config.filterOptions === 'function') {
      return options.filter(function (option) {
        return config.filterOptions({
          option: option,
          filters: filters
        });
      });
    }
    return options;
  }, [config, filters, options]);
  React.useEffect(function () {
    if (value) {
      filteredOptions.find(function (o) {
        return o.value === value;
      });
    }
  }, [filteredOptions]);
  return /*#__PURE__*/jsxRuntime.jsx(antd.Select, {
    style: {
      width: '100%'
    },
    value: value,
    placeholder: placeholder,
    filterOption: filterSelectOptions,
    onChange: onChange,
    disabled: disabled,
    showSearch: true,
    allowClear: true,
    mode: config.isMulti ? 'multiple' : undefined,
    children: filteredOptions.map(function (o, j) {
      return /*#__PURE__*/jsxRuntime.jsx(antd.Select.Option, {
        value: o.value || o,
        children: o.label || camelCaseToTitle(o)
      }, "".concat(i, "-").concat(j, "-").concat(k));
    })
  });
};
CustomSelect.propTypes = {
  value: PropTypes__default["default"].object,
  filterSelectOptions: PropTypes__default["default"].func,
  placeholder: PropTypes__default["default"].string,
  onChange: PropTypes__default["default"].func,
  disabled: PropTypes__default["default"].bool,
  options: PropTypes__default["default"].any,
  i: PropTypes__default["default"].number,
  k: PropTypes__default["default"].string,
  filters: PropTypes__default["default"].object,
  config: PropTypes__default["default"].object
};

var config$1G = {
  viewBox: '0 0 16 14',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M10.7716 6.45312L6.26851 2.20312C6.05288 1.99906 5.73101 1.94281 5.45601 2.06094C5.18101 2.18125 5.00288 2.45 5.00288 2.75V5H1.00038C0.447568 5 -0.000244141 5.44688 -0.000244141 6V8C-0.000244141 8.5525 0.447568 9 1.00038 9H5.00351V11.25C5.00351 11.5493 5.18185 11.8203 5.45694 11.9391C5.73204 12.0572 6.05163 12.0011 6.26944 11.7955L10.7726 7.5455C11.0716 7.2625 11.0716 6.7375 10.7716 6.45312ZM12.9998 0H10.9998C10.4476 0 9.99976 0.447812 9.99976 1C9.99976 1.55219 10.4476 2 10.9998 2H12.9998C13.5519 2 13.9998 2.44781 13.9998 3V11C13.9998 11.5522 13.5519 12 12.9998 12H10.9998C10.4476 12 9.99976 12.4478 9.99976 13C9.99976 13.5522 10.4476 14 10.9998 14H12.9998C14.6566 14 15.9998 12.6569 15.9998 11V3C15.9998 1.34312 14.656 0 12.9998 0Z",
    fill: "currentColor"
  })
};

var config$1F = {
  viewBox: '0 0 21 20',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M10.25 18.3337C14.8524 18.3337 18.5834 14.6027 18.5834 10.0003C18.5834 5.39795 14.8524 1.66699 10.25 1.66699C5.64765 1.66699 1.91669 5.39795 1.91669 10.0003C1.91669 14.6027 5.64765 18.3337 10.25 18.3337Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$1E = {
  viewBox: '0 0 19 19',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M9.20001 7.625V4.41667M9.20001 10.8333H9.20918M7.27501 15.6L8.61335 17.3844C8.81237 17.6498 8.91188 17.7825 9.03388 17.8299C9.14074 17.8715 9.25929 17.8715 9.36614 17.8299C9.48814 17.7825 9.58765 17.6498 9.78668 17.3844L11.125 15.6C11.3937 15.2417 11.5281 15.0626 11.692 14.9258C11.9105 14.7434 12.1685 14.6144 12.4455 14.549C12.6532 14.5 12.8771 14.5 13.325 14.5C14.6064 14.5 15.247 14.5 15.7524 14.2907C16.4262 14.0116 16.9616 13.4762 17.2407 12.8024C17.45 12.297 17.45 11.6563 17.45 10.375V5.15C17.45 3.60986 17.45 2.83978 17.1503 2.25153C16.8866 1.73408 16.4659 1.31338 15.9485 1.04973C15.3602 0.75 14.5902 0.75 13.05 0.75H5.35001C3.80987 0.75 3.0398 0.75 2.45154 1.04973C1.93409 1.31338 1.5134 1.73408 1.24974 2.25153C0.950012 2.83978 0.950012 3.60986 0.950012 5.15V10.375C0.950012 11.6563 0.950012 12.297 1.15934 12.8024C1.43845 13.4762 1.97381 14.0116 2.64763 14.2907C3.153 14.5 3.79367 14.5 5.07501 14.5C5.52288 14.5 5.74681 14.5 5.95456 14.549C6.23156 14.6144 6.48954 14.7434 6.70805 14.9258C6.87194 15.0626 7.00629 15.2417 7.27501 15.6Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$1D = {
  viewBox: '0 0 22 22',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M12.8334 2.08044V5.86677C12.8334 6.38015 12.8334 6.63684 12.9333 6.83293C13.0211 7.00541 13.1614 7.14564 13.3339 7.23353C13.5299 7.33344 13.7866 7.33344 14.3 7.33344H18.0863M8.25002 14.6667L10.0834 16.5L14.2084 12.375M12.8334 1.83337H8.06669C6.52654 1.83337 5.75647 1.83337 5.16821 2.13311C4.65077 2.39676 4.23007 2.81745 3.96642 3.3349C3.66669 3.92316 3.66669 4.69323 3.66669 6.23337V15.7667C3.66669 17.3069 3.66669 18.0769 3.96642 18.6652C4.23007 19.1826 4.65077 19.6033 5.16821 19.867C5.75647 20.1667 6.52654 20.1667 8.06669 20.1667H13.9334C15.4735 20.1667 16.2436 20.1667 16.8318 19.867C17.3493 19.6033 17.77 19.1826 18.0336 18.6652C18.3334 18.0769 18.3334 17.3069 18.3334 15.7667V7.33337L12.8334 1.83337Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$1C = {
  viewBox: '0 0 23 22',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M10.5834 4.12504H17.275C18.3018 4.12504 18.8152 4.12504 19.2074 4.32486C19.5523 4.50063 19.8328 4.78109 20.0086 5.12606C20.2084 5.51823 20.2084 6.03161 20.2084 7.05837V8.25004C20.2084 9.10427 20.2084 9.53138 20.0688 9.86829C19.8827 10.3175 19.5258 10.6744 19.0766 10.8605C18.7397 11 18.3126 11 17.4584 11M12.4167 17.875H5.72504C4.69828 17.875 4.1849 17.875 3.79272 17.6752C3.44776 17.4995 3.1673 17.219 2.99153 16.874C2.79171 16.4819 2.79171 15.9685 2.79171 14.9417V13.75C2.79171 12.8958 2.79171 12.4687 2.93126 12.1318C3.11733 11.6826 3.47424 11.3257 3.92345 11.1396C4.26037 11 4.68748 11 5.54171 11M9.94171 13.2917H13.0584C13.3151 13.2917 13.4434 13.2917 13.5415 13.2418C13.6277 13.1978 13.6978 13.1277 13.7418 13.0415C13.7917 12.9434 13.7917 12.8151 13.7917 12.5584V9.44171C13.7917 9.18502 13.7917 9.05667 13.7418 8.95863C13.6978 8.87239 13.6277 8.80227 13.5415 8.75833C13.4434 8.70837 13.3151 8.70837 13.0584 8.70837H9.94171C9.68502 8.70837 9.55667 8.70837 9.45863 8.75833C9.37239 8.80227 9.30227 8.87239 9.25833 8.95863C9.20837 9.05667 9.20837 9.18502 9.20837 9.44171V12.5584C9.20837 12.8151 9.20837 12.9434 9.25833 13.0415C9.30227 13.1277 9.37239 13.1978 9.45863 13.2418C9.55667 13.2917 9.68502 13.2917 9.94171 13.2917ZM16.8167 20.1667H19.9334C20.1901 20.1667 20.3184 20.1667 20.4165 20.1168C20.5027 20.0728 20.5728 20.0027 20.6168 19.9165C20.6667 19.8184 20.6667 19.6901 20.6667 19.4334V16.3167C20.6667 16.06 20.6667 15.9317 20.6168 15.8336C20.5728 15.7474 20.5027 15.6773 20.4165 15.6333C20.3184 15.5834 20.1901 15.5834 19.9334 15.5834H16.8167C16.56 15.5834 16.4317 15.5834 16.3336 15.6333C16.2474 15.6773 16.1773 15.7474 16.1333 15.8336C16.0834 15.9317 16.0834 16.06 16.0834 16.3167V19.4334C16.0834 19.6901 16.0834 19.8184 16.1333 19.9165C16.1773 20.0027 16.2474 20.0728 16.3336 20.1168C16.4317 20.1667 16.56 20.1667 16.8167 20.1667ZM3.06671 6.41671H6.18337C6.44006 6.41671 6.56841 6.41671 6.66645 6.36675C6.75269 6.32281 6.82281 6.25269 6.86675 6.16645C6.91671 6.06841 6.91671 5.94006 6.91671 5.68337V2.56671C6.91671 2.31002 6.91671 2.18167 6.86675 2.08363C6.82281 1.99739 6.75269 1.92727 6.66645 1.88333C6.56841 1.83337 6.44006 1.83337 6.18337 1.83337H3.06671C2.81002 1.83337 2.68167 1.83337 2.58363 1.88333C2.49739 1.92727 2.42727 1.99739 2.38333 2.08363C2.33337 2.18167 2.33337 2.31002 2.33337 2.56671V5.68337C2.33337 5.94006 2.33337 6.06841 2.38333 6.16645C2.42727 6.25269 2.49739 6.32281 2.58363 6.36675C2.68167 6.41671 2.81002 6.41671 3.06671 6.41671Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$1B = {
  viewBox: '0 0 12 12',
  children: /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M8.33699 6.62475C8.19697 7.13022 7.8957 7.57613 7.47901 7.89467C7.06231 8.21322 6.55299 8.38697 6.02849 8.3895H3.60975V5.95875C3.61492 5.43641 3.78989 4.92993 4.10824 4.51579C4.4266 4.10164 4.87105 3.80232 5.3745 3.663V0C3.9082 0.157295 2.55074 0.847643 1.55994 1.93993C0.56914 3.03222 0.014015 4.45036 0 5.925V12H6.04725C7.52624 11.9918 8.95043 11.4393 10.0479 10.4478C11.1454 9.45628 11.8392 8.09533 11.997 6.62475H8.33699Z",
      fill: "#002A52"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M6.54004 5.46V0C9.53479 0 12 2.4645 12 5.46H6.54004Z",
      fill: "#3D8EDB"
    })]
  })
};

var config$1A = {
  viewBox: '0 0 23 22',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M15.1667 3.66666C16.0191 3.66666 16.4454 3.66666 16.7951 3.76037C17.7441 4.01465 18.4853 4.75591 18.7396 5.70491C18.8333 6.05462 18.8333 6.48085 18.8333 7.33333V15.7667C18.8333 17.3068 18.8333 18.0769 18.5336 18.6651C18.2699 19.1826 17.8492 19.6033 17.3318 19.8669C16.7435 20.1667 15.9735 20.1667 14.4333 20.1667H8.56666C7.02652 20.1667 6.25645 20.1667 5.66819 19.8669C5.15074 19.6033 4.73005 19.1826 4.4664 18.6651C4.16666 18.0769 4.16666 17.3068 4.16666 15.7667V7.33333C4.16666 6.48085 4.16666 6.05462 4.26037 5.70491C4.51465 4.75591 5.25591 4.01465 6.20491 3.76037C6.55462 3.66666 6.98086 3.66666 7.83333 3.66666M8.75 13.75L10.5833 15.5833L14.7083 11.4583M9.3 5.49999H13.7C14.2134 5.49999 14.4701 5.49999 14.6662 5.40008C14.8386 5.3122 14.9789 5.17197 15.0668 4.99949C15.1667 4.8034 15.1667 4.54671 15.1667 4.03333V3.29999C15.1667 2.78661 15.1667 2.52992 15.0668 2.33384C14.9789 2.16136 14.8386 2.02112 14.6662 1.93324C14.4701 1.83333 14.2134 1.83333 13.7 1.83333H9.3C8.78662 1.83333 8.52993 1.83333 8.33384 1.93324C8.16136 2.02112 8.02113 2.16136 7.93324 2.33384C7.83333 2.52992 7.83333 2.78661 7.83333 3.29999V4.03333C7.83333 4.54671 7.83333 4.8034 7.93324 4.99949C8.02113 5.17197 8.16136 5.3122 8.33384 5.40008C8.52993 5.49999 8.78662 5.49999 9.3 5.49999Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$1z = {
  viewBox: '0 0 22 22',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M7.87417 12.3842L14.135 16.0325M14.1258 5.96749L7.87417 9.61583M19.25 4.58333C19.25 6.10211 18.0188 7.33333 16.5 7.33333C14.9812 7.33333 13.75 6.10211 13.75 4.58333C13.75 3.06455 14.9812 1.83333 16.5 1.83333C18.0188 1.83333 19.25 3.06455 19.25 4.58333ZM8.25 11C8.25 12.5188 7.01878 13.75 5.5 13.75C3.98122 13.75 2.75 12.5188 2.75 11C2.75 9.48121 3.98122 8.24999 5.5 8.24999C7.01878 8.24999 8.25 9.48121 8.25 11ZM19.25 17.4167C19.25 18.9354 18.0188 20.1667 16.5 20.1667C14.9812 20.1667 13.75 18.9354 13.75 17.4167C13.75 15.8979 14.9812 14.6667 16.5 14.6667C18.0188 14.6667 19.25 15.8979 19.25 17.4167Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$1y = {
  viewBox: '0 0 57 57',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M36.8475 36.9451V20.1003M36.8475 20.1003H20.0027M36.8475 20.1003L20.0027 36.9448M16.6332 53.7898H40.2159C44.9329 53.7898 47.2914 53.7898 49.0931 52.8718C50.6779 52.0644 51.9663 50.7759 52.7738 49.1911C53.6918 47.3895 53.6918 45.031 53.6918 40.314V16.7312C53.6918 12.0142 53.6918 9.65569 52.7738 7.85403C51.9663 6.26925 50.6779 4.98078 49.0931 4.1733C47.2914 3.25531 44.9329 3.25531 40.216 3.25531H16.6332C11.9162 3.25531 9.55768 3.25531 7.75602 4.1733C6.17124 4.98078 4.88278 6.26925 4.07529 7.85403C3.1573 9.65569 3.1573 12.0142 3.1573 16.7312V40.314C3.1573 45.031 3.1573 47.3895 4.07529 49.1911C4.88278 50.7759 6.17124 52.0644 7.75602 52.8718C9.55768 53.7898 11.9162 53.7898 16.6332 53.7898Z",
    stroke: "currentColor",
    strokeWidth: "5.05345",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$1x = {
  viewBox: '0 0 18 18',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M12.3333 13.3916L16.5 9.22498M16.5 9.22498L12.3333 5.05831M16.5 9.22498H6.5M6.5 1.72498H5.5C4.09987 1.72498 3.3998 1.72498 2.86502 1.99746C2.39462 2.23714 2.01217 2.61959 1.77248 3.09C1.5 3.62478 1.5 4.32484 1.5 5.72498V12.725C1.5 14.1251 1.5 14.8252 1.77248 15.36C2.01217 15.8304 2.39462 16.2128 2.86502 16.4525C3.3998 16.725 4.09987 16.725 5.5 16.725H6.5",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$1w = {
  viewBox: '0 0 18 18',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M17.4713 14.764C18.1744 15.4476 18.1744 16.555 17.4713 17.2386C17.1225 17.5804 16.6612 17.7499 16.2 17.7499C15.7387 17.7499 15.2786 17.579 14.9276 17.2372L9 11.4772L3.07294 17.2358C2.72137 17.5804 2.26069 17.7499 1.8 17.7499C1.33931 17.7499 0.879187 17.5804 0.527344 17.2358C-0.175781 16.5522 -0.175781 15.4448 0.527344 14.7612L6.45609 8.99716L0.527344 3.23584C-0.175781 2.55225 -0.175781 1.44482 0.527344 0.76123C1.23047 0.0776368 2.36953 0.0776368 3.07266 0.76123L9 6.52803L14.9287 0.763965C15.6319 0.0803713 16.7709 0.0803713 17.4741 0.763965C18.1772 1.44756 18.1772 2.55498 17.4741 3.23857L11.5453 9.00263L17.4713 14.764Z",
    fill: "currentColor"
  })
};

var config$1v = {
  viewBox: '0 0 16 16',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M9.99999 5.99998L5.99999 9.99998M5.99999 5.99998L9.99999 9.99998M14.6667 7.99998C14.6667 11.6819 11.6819 14.6666 7.99999 14.6666C4.3181 14.6666 1.33333 11.6819 1.33333 7.99998C1.33333 4.31808 4.3181 1.33331 7.99999 1.33331C11.6819 1.33331 14.6667 4.31808 14.6667 7.99998Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$1u = {
  viewBox: '0 0 17 16',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M8.5 0.518125C8.5 0.236094 8.69063 0 9 0C12.8656 0 16 3.13438 16 7C16 7.28125 15.7625 7.5 15.4813 7.5H8.5V0.518125ZM0 8.5C0 4.70937 2.81563 1.57313 6.44063 1.07031C6.75625 1.03094 7 1.26125 7 1.55031V9L11.8906 13.8906C12.1 14.1 12.0844 14.4438 11.8438 14.6156C10.6187 15.4875 9.11875 16 7.5 16C3.35938 16 0 12.6438 0 8.5ZM16.45 9C16.7375 9 16.9688 9.24375 16.9312 9.53125C16.6906 11.2781 15.8469 12.8312 14.6219 13.9781C14.4344 14.1281 14.1406 14.1406 13.9594 13.9594L9 9H16.45Z",
    fill: "currentColor"
  })
};

var config$1t = {
  viewBox: '0 0 18 14',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M6.5 1.5C6.5 0.671562 7.17188 0 8 0H10C10.8281 0 11.5 0.671562 11.5 1.5V3.5C11.5 4.32812 10.8281 5 10 5H9.75V6.25H14.5C15.4656 6.25 16.25 7.03438 16.25 8V9H16.5C17.3281 9 18 9.67188 18 10.5V12.5C18 13.3281 17.3281 14 16.5 14H14.5C13.6719 14 13 13.3281 13 12.5V10.5C13 9.67188 13.6719 9 14.5 9H14.75V8C14.75 7.8625 14.6375 7.75 14.5 7.75H9.75V9H10C10.8281 9 11.5 9.67188 11.5 10.5V12.5C11.5 13.3281 10.8281 14 10 14H8C7.17188 14 6.5 13.3281 6.5 12.5V10.5C6.5 9.67188 7.17188 9 8 9H8.25V7.75H3.5C3.3625 7.75 3.25 7.8625 3.25 8V9H3.5C4.32812 9 5 9.67188 5 10.5V12.5C5 13.3281 4.32812 14 3.5 14H1.5C0.671562 14 0 13.3281 0 12.5V10.5C0 9.67188 0.671562 9 1.5 9H1.75V8C1.75 7.03438 2.53344 6.25 3.5 6.25H8.25V5H8C7.17188 5 6.5 4.32812 6.5 3.5V1.5Z",
    fill: "currentColor"
  })
};

var config$1s = {
  viewBox: '0 0 18 14',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M1.5 3.66699L11.5 3.66699M11.5 3.66699C11.5 5.0477 12.6193 6.16699 14 6.16699C15.3807 6.16699 16.5 5.0477 16.5 3.66699C16.5 2.28628 15.3807 1.16699 14 1.16699C12.6193 1.16699 11.5 2.28628 11.5 3.66699ZM6.5 10.3337L16.5 10.3337M6.5 10.3337C6.5 11.7144 5.38071 12.8337 4 12.8337C2.61929 12.8337 1.5 11.7144 1.5 10.3337C1.5 8.95295 2.61929 7.83366 4 7.83366C5.38071 7.83366 6.5 8.95295 6.5 10.3337Z",
    stroke: "currentColor",
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$1r = {
  viewBox: '0 0 21 18',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M0 1.5C0 0.671719 0.671719 0 1.5 0H19.5C20.3297 0 21 0.671719 21 1.5C21 2.32969 20.3297 3 19.5 3H1.5C0.671719 3 0 2.32969 0 1.5ZM0 9C0 8.17031 0.671719 7.5 1.5 7.5H19.5C20.3297 7.5 21 8.17031 21 9C21 9.82969 20.3297 10.5 19.5 10.5H1.5C0.671719 10.5 0 9.82969 0 9ZM19.5 18H1.5C0.671719 18 0 17.3297 0 16.5C0 15.6703 0.671719 15 1.5 15H19.5C20.3297 15 21 15.6703 21 16.5C21 17.3297 20.3297 18 19.5 18Z",
    fill: "black"
  })
};

var config$1q = {
  viewBox: '0 0 14 14',
  children: /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M13 5.00001L13 1.00001M13 1.00001H8.99999M13 1.00001L7 7M5.66667 1H4.2C3.0799 1 2.51984 1 2.09202 1.21799C1.71569 1.40973 1.40973 1.71569 1.21799 2.09202C1 2.51984 1 3.07989 1 4.2V9.8C1 10.9201 1 11.4802 1.21799 11.908C1.40973 12.2843 1.71569 12.5903 2.09202 12.782C2.51984 13 3.07989 13 4.2 13H9.8C10.9201 13 11.4802 13 11.908 12.782C12.2843 12.5903 12.5903 12.2843 12.782 11.908C13 11.4802 13 10.9201 13 9.8V8.33333",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  })
};

var config$1p = {
  viewBox: '0 0 19 19',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M13.2344 2.53483C15.6162 3.91266 17.2188 6.48794 17.2188 9.4375C17.2188 13.8385 13.651 17.4062 9.25 17.4062C4.84898 17.4062 1.28125 13.8385 1.28125 9.4375C1.28125 6.48794 2.88376 3.91266 5.26563 2.53483M6.0625 9.43744L9.25 12.6249M9.25 12.6249L12.4375 9.43744M9.25 12.6249L9.25 1.46869",
    stroke: "#344054",
    strokeWidth: "1.59375",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$1o = {
  viewBox: '0 0 20 18',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M1.6665 2.83333C1.6665 2.36662 1.6665 2.13327 1.75733 1.95501C1.83723 1.79821 1.96471 1.67072 2.12151 1.59083C2.29977 1.5 2.53313 1.5 2.99984 1.5H16.9998C17.4665 1.5 17.6999 1.5 17.8782 1.59083C18.035 1.67072 18.1624 1.79821 18.2423 1.95501C18.3332 2.13327 18.3332 2.36662 18.3332 2.83333V3.39116C18.3332 3.61516 18.3332 3.72716 18.3058 3.8313C18.2815 3.92359 18.2416 4.01103 18.1878 4.0898C18.127 4.17869 18.0424 4.25204 17.8731 4.39875L12.5433 9.01792C12.374 9.16462 12.2894 9.23797 12.2286 9.32687C12.1747 9.40564 12.1348 9.49308 12.1105 9.58536C12.0832 9.68951 12.0832 9.80151 12.0832 10.0255V14.382C12.0832 14.5449 12.0832 14.6264 12.0569 14.6969C12.0337 14.7591 11.9959 14.8149 11.9467 14.8596C11.8911 14.9102 11.8154 14.9404 11.6641 15.001L8.83076 16.1343C8.52448 16.2568 8.37133 16.3181 8.2484 16.2925C8.14089 16.2702 8.04655 16.2063 7.98588 16.1148C7.9165 16.0101 7.9165 15.8452 7.9165 15.5153V10.0255C7.9165 9.80151 7.9165 9.68951 7.88913 9.58536C7.86488 9.49308 7.82495 9.40564 7.77109 9.32687C7.71032 9.23797 7.62568 9.16462 7.45641 9.01792L2.1266 4.39875C1.95732 4.25204 1.87269 4.17869 1.81191 4.0898C1.75806 4.01103 1.71813 3.92359 1.69388 3.8313C1.6665 3.72716 1.6665 3.61516 1.6665 3.39116V2.83333Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$1n = {
  viewBox: '0 0 12 12',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M11.875 10.375H1.125V0.625C1.125 0.55625 1.06875 0.5 1 0.5H0.125C0.05625 0.5 0 0.55625 0 0.625V11.375C0 11.4438 0.05625 11.5 0.125 11.5H11.875C11.9438 11.5 12 11.4438 12 11.375V10.5C12 10.4312 11.9438 10.375 11.875 10.375ZM2.5 9.125H3.375C3.44375 9.125 3.5 9.06875 3.5 9V6.75C3.5 6.68125 3.44375 6.625 3.375 6.625H2.5C2.43125 6.625 2.375 6.68125 2.375 6.75V9C2.375 9.06875 2.43125 9.125 2.5 9.125ZM4.875 9.125H5.75C5.81875 9.125 5.875 9.06875 5.875 9V4C5.875 3.93125 5.81875 3.875 5.75 3.875H4.875C4.80625 3.875 4.75 3.93125 4.75 4V9C4.75 9.06875 4.80625 9.125 4.875 9.125ZM7.25 9.125H8.125C8.19375 9.125 8.25 9.06875 8.25 9V5.21875C8.25 5.15 8.19375 5.09375 8.125 5.09375H7.25C7.18125 5.09375 7.125 5.15 7.125 5.21875V9C7.125 9.06875 7.18125 9.125 7.25 9.125ZM9.625 9.125H10.5C10.5688 9.125 10.625 9.06875 10.625 9V2.75C10.625 2.68125 10.5688 2.625 10.5 2.625H9.625C9.55625 2.625 9.5 2.68125 9.5 2.75V9C9.5 9.06875 9.55625 9.125 9.625 9.125Z",
    fill: "#FF7875"
  })
};

var config$1m = {
  viewBox: '0 0 12 12',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M6.96953 8.39766C6.94604 8.37439 6.91431 8.36134 6.88125 8.36134C6.84819 8.36134 6.81646 8.37439 6.79297 8.39766L4.97734 10.2133C4.13672 11.0539 2.71797 11.143 1.78984 10.2133C0.860156 9.28359 0.949219 7.86641 1.78984 7.02578L3.60547 5.21016C3.65391 5.16172 3.65391 5.08203 3.60547 5.03359L2.98359 4.41172C2.9601 4.38846 2.92838 4.37541 2.89531 4.37541C2.86225 4.37541 2.83053 4.38846 2.80703 4.41172L0.991406 6.22734C-0.330469 7.54922 -0.330469 9.68828 0.991406 11.0086C2.31328 12.3289 4.45234 12.3305 5.77266 11.0086L7.58828 9.19297C7.63672 9.14453 7.63672 9.06485 7.58828 9.01641L6.96953 8.39766ZM11.0102 0.991406C9.68828 -0.330469 7.54922 -0.330469 6.22891 0.991406L4.41172 2.80703C4.38846 2.83053 4.37541 2.86225 4.37541 2.89531C4.37541 2.92838 4.38846 2.9601 4.41172 2.98359L5.03203 3.60391C5.08047 3.65234 5.16016 3.65234 5.20859 3.60391L7.02422 1.78828C7.86484 0.947656 9.2836 0.858594 10.2117 1.78828C11.1414 2.71797 11.0523 4.13516 10.2117 4.97578L8.39609 6.79141C8.37283 6.8149 8.35978 6.84663 8.35978 6.87969C8.35978 6.91275 8.37283 6.94448 8.39609 6.96797L9.01797 7.58985C9.06641 7.63828 9.1461 7.63828 9.19453 7.58985L11.0102 5.77422C12.3305 4.45234 12.3305 2.31328 11.0102 0.991406ZM7.53359 3.81797C7.5101 3.79471 7.47838 3.78166 7.44531 3.78166C7.41225 3.78166 7.38053 3.79471 7.35703 3.81797L3.81797 7.35547C3.79471 7.37896 3.78166 7.41069 3.78166 7.44375C3.78166 7.47681 3.79471 7.50854 3.81797 7.53203L4.43672 8.15078C4.48516 8.19922 4.56484 8.19922 4.61328 8.15078L8.15078 4.61328C8.19922 4.56484 8.19922 4.48516 8.15078 4.43672L7.53359 3.81797Z",
    fill: "#52C41A"
  })
};

var config$1l = {
  viewBox: '0 0 16 18',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M11.2587 4.51039V3.91178C11.2587 3.07364 11.2587 2.65458 11.0956 2.33445C10.9521 2.05286 10.7232 1.82392 10.4416 1.68045C10.1214 1.51733 9.70237 1.51733 8.86424 1.51733H7.66701C6.82888 1.51733 6.40981 1.51733 6.08969 1.68045C5.8081 1.82392 5.57916 2.05286 5.43568 2.33445C5.27257 2.65458 5.27257 3.07364 5.27257 3.91178V4.51039M6.7691 8.62584V12.3672M9.76215 8.62584V12.3672M1.53125 4.51039H15M13.5035 4.51039V12.8909C13.5035 14.1481 13.5035 14.7767 13.2588 15.2569C13.0436 15.6793 12.7002 16.0227 12.2778 16.2379C11.7976 16.4826 11.169 16.4826 9.91181 16.4826H6.61944C5.36224 16.4826 4.73364 16.4826 4.25346 16.2379C3.83107 16.0227 3.48766 15.6793 3.27245 15.2569C3.02778 14.7767 3.02778 14.1481 3.02778 12.8909V4.51039",
    stroke: "currentColor",
    strokeWidth: "1.28274",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$1k = {
  viewBox: '0 0 15 14',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M6.56745 2.02839H3.93741C2.88529 2.02839 2.35923 2.02839 1.95738 2.23314C1.60389 2.41325 1.3165 2.70064 1.1364 3.05412C0.931641 3.45598 0.931641 3.98204 0.931641 5.03415V10.2942C0.931641 11.3464 0.931641 11.8724 1.1364 12.2743C1.3165 12.6278 1.60389 12.9151 1.95738 13.0953C2.35923 13.3 2.88529 13.3 3.93741 13.3H9.1975C10.2496 13.3 10.7757 13.3 11.1775 13.0953C11.531 12.9151 11.8184 12.6278 11.9985 12.2743C12.2033 11.8724 12.2033 11.3464 12.2033 10.2942V7.6642M4.68883 9.5428H5.73743C6.04376 9.5428 6.19692 9.5428 6.34106 9.5082C6.46885 9.47752 6.59101 9.42692 6.70307 9.35825C6.82946 9.2808 6.93776 9.1725 7.15437 8.95589L13.1426 2.96769C13.6613 2.44893 13.6613 1.60785 13.1426 1.08908C12.6238 0.570322 11.7827 0.570321 11.264 1.08908L5.27575 7.07729C5.05914 7.29389 4.95084 7.40219 4.87339 7.52858C4.80472 7.64064 4.75412 7.7628 4.72344 7.89059C4.68883 8.03473 4.68883 8.18789 4.68883 8.49422V9.5428Z",
    stroke: "currentColor",
    strokeWidth: "1.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$1j = {
  viewBox: '0 0 12 12',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M1.56667 6.83068L2.40648 10.1899C2.4301 10.2844 2.44191 10.3316 2.45588 10.3729C2.59236 10.7758 2.95521 11.0591 3.37921 11.0938C3.42261 11.0973 3.47131 11.0973 3.56869 11.0973C3.69063 11.0973 3.75161 11.0973 3.80297 11.0924C4.31066 11.0431 4.71244 10.6413 4.76168 10.1337C4.76667 10.0823 4.76667 10.0213 4.76667 9.89937V2.29735M9.3 6.56401C10.3309 6.56401 11.1667 5.72828 11.1667 4.69735C11.1667 3.66642 10.3309 2.83068 9.3 2.83068M4.9 2.29735H2.9C1.57452 2.29735 0.499999 3.37187 0.5 4.69735C0.500001 6.02283 1.57452 7.09735 2.9 7.09735H4.9C5.84209 7.09735 6.99453 7.60235 7.88362 8.08702C8.40231 8.36977 8.66165 8.51115 8.8315 8.49034C8.98901 8.47105 9.10811 8.40033 9.20043 8.27127C9.3 8.13209 9.3 7.85361 9.3 7.29666V2.09803C9.3 1.54108 9.3 1.2626 9.20043 1.12342C9.10811 0.994363 8.98901 0.923642 8.8315 0.904351C8.66165 0.883547 8.40231 1.02492 7.88362 1.30767C6.99453 1.79234 5.84209 2.29735 4.9 2.29735Z",
    stroke: "currentColor",
    strokeWidth: "0.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$1i = {
  viewBox: '0 0 16 16',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M4.59798 13.7748C2.60531 12.6221 1.26465 10.4676 1.26465 7.99998C1.26465 4.31808 4.24942 1.33331 7.93132 1.33331C11.6132 1.33331 14.598 4.31808 14.598 7.99998C14.598 10.4676 13.2573 12.6221 11.2646 13.7748M10.598 8.00003L7.93131 5.33336M7.93131 5.33336L5.26465 8.00003M7.93131 5.33336V14.6667",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$1h = {
  viewBox: '0 0 21 21',
  children: /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsxs("g", {
      clipPath: "url(#clip0_3831_40731)",
      children: [/*#__PURE__*/jsxRuntime.jsx("path", {
        d: "M10.6464 19.3276C15.5689 19.3276 19.5595 15.337 19.5595 10.4145C19.5595 8.88563 19.1745 7.44666 18.4963 6.18923L13.3203 1.90951C12.4762 1.64439 11.578 1.50146 10.6464 1.50146C5.72387 1.50146 1.73337 5.49197 1.73337 10.4145C1.73337 15.337 5.72387 19.3276 10.6464 19.3276Z",
        fill: "#667085",
        stroke: "white",
        strokeWidth: "1.78261",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/jsxRuntime.jsx("path", {
        d: "M15.1029 10.4145C16.8855 8.6319 18.6682 7.0357 18.6682 5.06668C18.6682 3.09767 17.072 1.50146 15.1029 1.50146C13.1339 1.50146 11.5377 3.09767 11.5377 5.06668C11.5377 7.0357 13.3203 8.6319 15.1029 10.4145Z",
        fill: "#667085",
        stroke: "white",
        strokeWidth: "1.78261",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/jsxRuntime.jsx("path", {
        d: "M9.15655 16.9834C9.15656 16.8879 9.19384 16.7955 9.26167 16.7229L11.4325 14.4012C11.6109 14.2104 11.5557 13.9179 11.3176 13.7932L8.82327 12.4865C8.7555 12.451 8.69935 12.3995 8.66066 12.3374L7.03466 9.72534C6.95003 9.58939 6.78674 9.51114 6.61667 9.52502L1.73337 10.0306C1.73337 12.4323 2.16993 14.4337 3.91656 16.0348C5.66318 17.6359 7.26426 18.3031 7.84647 18.4365L9.15655 16.9834Z",
        fill: "#667085",
        stroke: "white",
        strokeWidth: "1.78261",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/jsxRuntime.jsx("circle", {
        cx: "15.1029",
        cy: "5.0666",
        r: "0.891304",
        fill: "white"
      })]
    }), /*#__PURE__*/jsxRuntime.jsx("defs", {
      children: /*#__PURE__*/jsxRuntime.jsx("clipPath", {
        id: "clip0_3831_40731",
        children: /*#__PURE__*/jsxRuntime.jsx("rect", {
          width: "20.5",
          height: "20.5",
          fill: "white",
          transform: "translate(0.5)"
        })
      })
    })]
  })
};

var config$1g = {
  viewBox: '0 0 17 17',
  children: /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M8.5 1.25C4.63438 1.25 1.5 4.38438 1.5 8.25C1.5 12.1156 4.63438 15.25 8.5 15.25C12.3656 15.25 15.5 12.1156 15.5 8.25C15.5 4.38438 12.3656 1.25 8.5 1.25ZM8.5 14.0625C5.29063 14.0625 2.6875 11.4594 2.6875 8.25C2.6875 5.04063 5.29063 2.4375 8.5 2.4375C11.7094 2.4375 14.3125 5.04063 14.3125 8.25C14.3125 11.4594 11.7094 14.0625 8.5 14.0625Z",
      fill: "#F97066"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M8.5 2.4375C5.29063 2.4375 2.6875 5.04063 2.6875 8.25C2.6875 11.4594 5.29063 14.0625 8.5 14.0625C11.7094 14.0625 14.3125 11.4594 14.3125 8.25C14.3125 5.04063 11.7094 2.4375 8.5 2.4375ZM11.5 8.625C11.5 8.69375 11.4438 8.75 11.375 8.75H5.625C5.55625 8.75 5.5 8.69375 5.5 8.625V7.875C5.5 7.80625 5.55625 7.75 5.625 7.75H11.375C11.4438 7.75 11.5 7.80625 11.5 7.875V8.625Z",
      fill: "#FFFBFA"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M11.375 7.75H5.625C5.55625 7.75 5.5 7.80625 5.5 7.875V8.625C5.5 8.69375 5.55625 8.75 5.625 8.75H11.375C11.4438 8.75 11.5 8.69375 11.5 8.625V7.875C11.5 7.80625 11.4438 7.75 11.375 7.75Z",
      fill: "#F97066"
    })]
  })
};

var config$1f = {
  viewBox: '0 0 16 17',
  children: /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M8 1.25C4.13438 1.25 1 4.38438 1 8.25C1 12.1156 4.13438 15.25 8 15.25C11.8656 15.25 15 12.1156 15 8.25C15 4.38438 11.8656 1.25 8 1.25ZM8 14.0625C4.79063 14.0625 2.1875 11.4594 2.1875 8.25C2.1875 5.04063 4.79063 2.4375 8 2.4375C11.2094 2.4375 13.8125 5.04063 13.8125 8.25C13.8125 11.4594 11.2094 14.0625 8 14.0625Z",
      fill: "#2E90FA"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M8 2.4375C4.79063 2.4375 2.1875 5.04063 2.1875 8.25C2.1875 11.4594 4.79063 14.0625 8 14.0625C11.2094 14.0625 13.8125 11.4594 13.8125 8.25C13.8125 5.04063 11.2094 2.4375 8 2.4375ZM11 8.625C11 8.69375 10.9438 8.75 10.875 8.75H8.5V11.125C8.5 11.1938 8.44375 11.25 8.375 11.25H7.625C7.55625 11.25 7.5 11.1938 7.5 11.125V8.75H5.125C5.05625 8.75 5 8.69375 5 8.625V7.875C5 7.80625 5.05625 7.75 5.125 7.75H7.5V5.375C7.5 5.30625 7.55625 5.25 7.625 5.25H8.375C8.44375 5.25 8.5 5.30625 8.5 5.375V7.75H10.875C10.9438 7.75 11 7.80625 11 7.875V8.625Z",
      fill: "#E6F7FF"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M10.875 7.75H8.5V5.375C8.5 5.30625 8.44375 5.25 8.375 5.25H7.625C7.55625 5.25 7.5 5.30625 7.5 5.375V7.75H5.125C5.05625 7.75 5 7.80625 5 7.875V8.625C5 8.69375 5.05625 8.75 5.125 8.75H7.5V11.125C7.5 11.1937 7.55625 11.25 7.625 11.25H8.375C8.44375 11.25 8.5 11.1937 8.5 11.125V8.75H10.875C10.9437 8.75 11 8.69375 11 8.625V7.875C11 7.80625 10.9437 7.75 10.875 7.75Z",
      fill: "#2E90FA"
    })]
  })
};

var config$1e = {
  viewBox: '0 0 16 16',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M7.99998 3.83331V13.1666M3.33331 8.49998H12.6666",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$1d = {
  viewBox: '0 0 3 14',
  children: /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx("circle", {
      cx: "1.5",
      cy: "2",
      r: "1.5",
      fill: "#667085"
    }), /*#__PURE__*/jsxRuntime.jsx("circle", {
      cx: "1.5",
      cy: "7",
      r: "1.5",
      fill: "#667085"
    }), /*#__PURE__*/jsxRuntime.jsx("circle", {
      cx: "1.5",
      cy: "12",
      r: "1.5",
      fill: "#667085"
    })]
  })
};

var config$1c = {
  viewBox: '0 0 22 20',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M10.9571 7.68584V11.4216M10.9571 15.1574H10.9664M9.66385 2.91499L1.98225 16.1832C1.55618 16.9191 1.34315 17.2871 1.37463 17.5891C1.40209 17.8525 1.5401 18.0919 1.75431 18.2477C1.9999 18.4262 2.42509 18.4262 3.27547 18.4262H18.6387C19.489 18.4262 19.9142 18.4262 20.1598 18.2477C20.374 18.0919 20.512 17.8525 20.5395 17.5891C20.571 17.2871 20.358 16.9191 19.9319 16.1832L12.2503 2.91498C11.8257 2.18168 11.6135 1.81503 11.3365 1.69189C11.095 1.58447 10.8192 1.58447 10.5776 1.69189C10.3007 1.81503 10.0884 2.18168 9.66385 2.91499Z",
    stroke: "currentColor",
    strokeWidth: "1.86789",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$1b = {
  viewBox: '0 0 18 18',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M16.5 16.5L13.5834 13.5833M15.6667 8.58333C15.6667 12.4954 12.4954 15.6667 8.58333 15.6667C4.67132 15.6667 1.5 12.4954 1.5 8.58333C1.5 4.67132 4.67132 1.5 8.58333 1.5C12.4954 1.5 15.6667 4.67132 15.6667 8.58333Z",
    stroke: "currentColor",
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$1a = {
  viewBox: '0 0 16 18',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M14.75 7.5H1.25M11 1.5V4.5M5 1.5V4.5M4.85 16.5H11.15C12.4101 16.5 13.0402 16.5 13.5215 16.2548C13.9448 16.039 14.289 15.6948 14.5048 15.2715C14.75 14.7902 14.75 14.1601 14.75 12.9V6.6C14.75 5.33988 14.75 4.70982 14.5048 4.22852C14.289 3.80516 13.9448 3.46095 13.5215 3.24524C13.0402 3 12.4101 3 11.15 3H4.85C3.58988 3 2.95982 3 2.47852 3.24524C2.05516 3.46095 1.71095 3.80516 1.49524 4.22852C1.25 4.70982 1.25 5.33988 1.25 6.6V12.9C1.25 14.1601 1.25 14.7902 1.49524 15.2715C1.71095 15.6948 2.05516 16.039 2.47852 16.2548C2.95982 16.5 3.58988 16.5 4.85 16.5Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$19 = {
  viewBox: '0 0 18 16',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M16.5 14.75V13.25C16.5 11.8521 15.5439 10.6775 14.25 10.3445M11.625 1.46807C12.7244 1.91311 13.5 2.99098 13.5 4.25C13.5 5.50902 12.7244 6.58689 11.625 7.03193M12.75 14.75C12.75 13.3522 12.75 12.6533 12.5216 12.1019C12.2172 11.3669 11.6331 10.7828 10.8981 10.4784C10.3467 10.25 9.64783 10.25 8.25 10.25H6C4.60218 10.25 3.90326 10.25 3.35195 10.4784C2.61687 10.7828 2.03284 11.3669 1.72836 12.1019C1.5 12.6533 1.5 13.3522 1.5 14.75M10.125 4.25C10.125 5.90685 8.78185 7.25 7.125 7.25C5.46815 7.25 4.125 5.90685 4.125 4.25C4.125 2.59315 5.46815 1.25 7.125 1.25C8.78185 1.25 10.125 2.59315 10.125 4.25Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$18 = {
  viewBox: '0 0 18 17',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M16.5 6.08057L11.1262 9.91898C10.963 10.0356 10.8813 10.0939 10.7939 10.1115C10.7168 10.127 10.637 10.1204 10.5635 10.0924C10.4801 10.0607 10.4092 9.98977 10.2673 9.84789L7.73267 7.31324C7.5908 7.17137 7.51986 7.10043 7.43652 7.0687C7.36305 7.04074 7.28317 7.03413 7.2061 7.04963C7.11868 7.06723 7.03704 7.12553 6.87378 7.24215L1.5 11.0806M5.5 16.0806H12.5C13.9001 16.0806 14.6002 16.0806 15.135 15.8081C15.6054 15.5684 15.9878 15.1859 16.2275 14.7155C16.5 14.1808 16.5 13.4807 16.5 12.0806V5.08057C16.5 3.68044 16.5 2.98037 16.2275 2.44559C15.9878 1.97518 15.6054 1.59273 15.135 1.35305C14.6002 1.08057 13.9001 1.08057 12.5 1.08057H5.5C4.09987 1.08057 3.3998 1.08057 2.86502 1.35305C2.39462 1.59273 2.01217 1.97518 1.77248 2.44559C1.5 2.98037 1.5 3.68044 1.5 5.08057V12.0806C1.5 13.4807 1.5 14.1808 1.77248 14.7155C2.01217 15.1859 2.39462 15.5684 2.86502 15.8081C3.3998 16.0806 4.09987 16.0806 5.5 16.0806Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$17 = {
  viewBox: '0 0 20 17',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M10.8334 4.4139L9.9038 2.55466C9.63625 2.01957 9.50247 1.75201 9.30289 1.55654C9.1264 1.38368 8.91368 1.25221 8.68014 1.17166C8.41605 1.08057 8.11692 1.08057 7.51866 1.08057H4.33341C3.39999 1.08057 2.93328 1.08057 2.57676 1.26222C2.26316 1.42201 2.00819 1.67698 1.8484 1.99058C1.66675 2.3471 1.66675 2.81381 1.66675 3.74723V4.4139M1.66675 4.4139H14.3334C15.7335 4.4139 16.4336 4.4139 16.9684 4.68638C17.4388 4.92607 17.8212 5.30852 18.0609 5.77892C18.3334 6.3137 18.3334 7.01377 18.3334 8.4139V12.0806C18.3334 13.4807 18.3334 14.1808 18.0609 14.7155C17.8212 15.1859 17.4388 15.5684 16.9684 15.8081C16.4336 16.0806 15.7335 16.0806 14.3334 16.0806H5.66675C4.26662 16.0806 3.56655 16.0806 3.03177 15.8081C2.56137 15.5684 2.17892 15.1859 1.93923 14.7155C1.66675 14.1808 1.66675 13.4807 1.66675 12.0806V4.4139Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$16 = {
  viewBox: '0 0 20 17',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M18.3334 5.24722V8.58056M8.54175 3.16389H5.66675C4.26662 3.16389 3.56655 3.16389 3.03177 3.43637C2.56137 3.67605 2.17891 4.05851 1.93923 4.52891C1.66675 5.06369 1.66675 5.76376 1.66675 7.16389L1.66675 8.16389C1.66675 8.94046 1.66675 9.32874 1.79362 9.63503C1.96277 10.0434 2.28723 10.3679 2.69561 10.537C3.00189 10.6639 3.39018 10.6639 4.16675 10.6639V14.2056C4.16675 14.399 4.16675 14.4958 4.17478 14.5772C4.25271 15.3685 4.87876 15.9946 5.67005 16.0725C5.75154 16.0806 5.84828 16.0806 6.04175 16.0806C6.23522 16.0806 6.33196 16.0806 6.41345 16.0725C7.20474 15.9946 7.83079 15.3685 7.90872 14.5772C7.91675 14.4958 7.91675 14.399 7.91675 14.2056V10.6639H8.54175C10.0138 10.6639 11.8145 11.453 13.2037 12.2103C14.0141 12.6521 14.4193 12.873 14.6847 12.8404C14.9308 12.8103 15.1169 12.6998 15.2612 12.4981C15.4167 12.2807 15.4167 11.8456 15.4167 10.9753V2.85246C15.4167 1.98222 15.4167 1.5471 15.2612 1.32963C15.1169 1.12797 14.9308 1.01747 14.6847 0.987328C14.4193 0.954822 14.0141 1.17572 13.2037 1.61752C11.8145 2.37481 10.0138 3.16389 8.54175 3.16389Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$15 = {
  viewBox: '0 0 16 19',
  children: /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M7.99992 10.4139C9.38063 10.4139 10.4999 9.29462 10.4999 7.9139C10.4999 6.53319 9.38063 5.4139 7.99992 5.4139C6.61921 5.4139 5.49992 6.53319 5.49992 7.9139C5.49992 9.29462 6.61921 10.4139 7.99992 10.4139Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M7.99992 17.9139C11.3333 14.5806 14.6666 11.5958 14.6666 7.9139C14.6666 4.23201 11.6818 1.24724 7.99992 1.24724C4.31802 1.24724 1.33325 4.23201 1.33325 7.9139C1.33325 11.5958 4.66659 14.5806 7.99992 17.9139Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  })
};

var config$14 = {
  viewBox: '0 0 18 18',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M1.5 17.0806H16.5M4 14.5806V7.91391M7.33333 14.5806V7.91391M10.6667 14.5806V7.91391M14 14.5806V7.91391M15.6667 5.41391L9.35333 1.46808C9.22515 1.38796 9.16106 1.34791 9.09233 1.33229C9.03155 1.31848 8.96845 1.31848 8.90767 1.33229C8.83894 1.34791 8.77485 1.38796 8.64667 1.46808L2.33333 5.41391H15.6667Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$13 = {
  viewBox: '0 0 18 19',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M7.125 16.8722L8.35248 17.5542C8.58881 17.6855 8.70698 17.7511 8.83213 17.7768C8.94288 17.7996 9.05712 17.7996 9.16788 17.7768C9.29302 17.7511 9.41119 17.6855 9.64753 17.5542L10.875 16.8722M3.375 14.7889L2.18581 14.1282C1.93621 13.9896 1.8114 13.9202 1.72053 13.8216C1.64013 13.7344 1.57929 13.631 1.54207 13.5183C1.5 13.391 1.5 13.2482 1.5 12.9627V11.6639M1.5 7.49723V6.19844C1.5 5.9129 1.5 5.77014 1.54207 5.6428C1.57929 5.53016 1.64013 5.42676 1.72053 5.33951C1.8114 5.2409 1.93621 5.17156 2.18581 5.0329L3.375 4.37223M7.125 2.2889L8.35248 1.60697C8.58881 1.47567 8.70698 1.41002 8.83213 1.38428C8.94288 1.3615 9.05712 1.3615 9.16788 1.38428C9.29302 1.41002 9.41119 1.47567 9.64753 1.60697L10.875 2.2889M14.625 4.37223L15.8142 5.03289C16.0638 5.17156 16.1886 5.2409 16.2795 5.33951C16.3599 5.42675 16.4207 5.53016 16.4579 5.6428C16.5 5.77013 16.5 5.9129 16.5 6.19844V7.49723M16.5 11.6639V12.9627C16.5 13.2482 16.5 13.391 16.4579 13.5183C16.4207 13.631 16.3599 13.7344 16.2795 13.8216C16.1886 13.9202 16.0638 13.9896 15.8142 14.1282L14.625 14.7889M7.125 8.5389L9 9.58057M9 9.58057L10.875 8.5389M9 9.58057V11.6639M1.5 5.4139L3.375 6.45557M14.625 6.45557L16.5 5.4139M9 15.8306V17.9139",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$12 = {
  viewBox: '0 0 20 22',
  children: /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M11.3726 9.78863V2.74451C15.1104 3.02287 18.1383 6.05001 18.4167 9.78863H11.3726Z",
      stroke: "currentColor",
      strokeWidth: "1.125"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M10.0427 15.3079L10.0455 15.3079C10.9548 15.3035 11.8377 15.0023 12.5601 14.45C13.1669 13.9862 13.6325 13.3665 13.9099 12.6608H18.3459C18.0111 14.4885 17.0822 16.1619 15.6948 17.4154C14.1516 18.8096 12.1491 19.5867 10.0695 19.5986H1.5625V11.0513C1.58285 8.97819 2.36356 6.9846 3.75654 5.44895C5.00875 4.06848 6.67735 3.14446 8.49924 2.8107V7.25115C7.79683 7.52701 7.17962 7.9894 6.7164 8.592C6.16447 9.31001 5.86111 10.1881 5.85215 11.0937L5.85212 11.0937V11.0993V14.7454V15.3079H6.41462L10.0427 15.3079Z",
      stroke: "currentColor",
      strokeWidth: "1.125"
    })]
  })
};

var config$11 = {
  viewBox: '0 0 24 24',
  children: /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: /*#__PURE__*/jsxRuntime.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM14.0484 6.54376C15.8953 6.68439 17.4562 7.90782 17.4562 7.90782C17.4562 7.90782 19.2 10.4391 19.5094 15.4078C17.7516 17.4375 15.0797 17.4516 15.0797 17.4516L14.5219 16.7063C15.4687 16.3781 16.5422 15.7875 17.4656 14.7234C16.3594 15.5625 14.6953 16.4297 12.0094 16.4297C9.32344 16.4297 7.65469 15.5578 6.55312 14.7234C7.47656 15.7875 8.55 16.3781 9.49687 16.7063L8.93906 17.4516C8.93906 17.4516 6.26719 17.4375 4.50937 15.4078C4.80937 10.4391 6.55312 7.90782 6.55312 7.90782C6.55312 7.90782 8.025 6.72657 9.96093 6.54376L10.125 6.87657C8.60156 7.21876 7.69219 7.87032 6.89062 8.58751C8.26875 7.88439 9.63281 7.22345 12.0047 7.22345C14.3766 7.22345 15.7406 7.88439 17.1187 8.58751C16.3172 7.87032 15.5531 7.28439 13.8844 6.87657L14.0484 6.54376ZM8.5875 12.6797C8.5875 13.4344 9.12187 14.0438 9.78281 14.0438C10.4437 14.0438 10.9781 13.4344 10.9781 12.6797C10.9781 11.925 10.4437 11.3156 9.78281 11.3156C9.12187 11.3156 8.5875 11.925 8.5875 12.6797ZM13.0219 12.6797C13.0219 13.4344 13.5562 14.0438 14.2172 14.0438C14.8734 14.0438 15.4125 13.4344 15.4125 12.6797C15.4125 11.925 14.8781 11.3156 14.2172 11.3156C13.5562 11.3156 13.0219 11.925 13.0219 12.6797Z",
      fill: "#92A6B9"
    })
  })
};

var config$10 = {
  viewBox: '0 0 24 24',
  children: /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: /*#__PURE__*/jsxRuntime.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM18.2511 6.35894C18.9395 6.55647 19.4817 7.13853 19.6657 7.87759C20 9.21719 20 12.0121 20 12.0121C20 12.0121 20 14.8071 19.6657 16.1467C19.4817 16.8857 18.9395 17.4435 18.2511 17.6411C17.0033 18 12 18 12 18C12 18 6.99669 18 5.7489 17.6411C5.06052 17.4435 4.51835 16.8857 4.33434 16.1467C4 14.8071 4 12.0121 4 12.0121C4 12.0121 4 9.21719 4.33434 7.87759C4.51835 7.13853 5.06052 6.5565 5.7489 6.35894C6.99669 6 12 6 12 6C12 6 17.0033 6 18.2511 6.35894ZM14.5454 12.0122L10.3636 9.47453V14.5497L14.5454 12.0122Z",
      fill: "#92A6B9"
    })
  })
};

var config$$ = {
  viewBox: '0 0 24 24',
  children: /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx("g", {
      clipPath: "url(#clip0_104_502)",
      children: /*#__PURE__*/jsxRuntime.jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.0036 0C18.6283 0 24.0072 5.37174 24.0072 12.0036C24.0072 18.6283 18.6355 24.0072 12.0036 24.0072C5.37894 24.0072 0 18.6355 0 12.0036C0 5.37894 5.37174 0 12.0036 0ZM10.4554 9.62016H12.9181V10.8803H12.9541C13.2997 10.261 14.135 9.62016 15.3879 9.62016C17.9874 9.62016 18.4698 11.2403 18.4698 13.3429V17.6346H15.8992V13.8326C15.8992 12.9253 15.8776 11.7588 14.5599 11.7588C13.2205 11.7588 13.0189 12.7453 13.0189 13.7678V17.6346H10.4482V9.62016H10.4554ZM8.67687 7.39514C8.67687 8.12961 8.07921 8.73447 7.33753 8.73447C6.60306 8.73447 5.9982 8.13681 5.9982 7.39514C5.9982 6.66067 6.59586 6.05581 7.33753 6.05581C8.07201 6.05581 8.67687 6.65347 8.67687 7.39514ZM6.0054 9.62016H8.67687V17.6346H6.0054V9.62016Z",
        fill: "#92A6B9"
      })
    }), /*#__PURE__*/jsxRuntime.jsx("defs", {
      children: /*#__PURE__*/jsxRuntime.jsx("clipPath", {
        id: "clip0_104_502",
        children: /*#__PURE__*/jsxRuntime.jsx("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      })
    })]
  })
};

var config$_ = {
  viewBox: '0 0 24 24',
  children: /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx("g", {
      clipPath: "url(#clip0_104_504)",
      children: /*#__PURE__*/jsxRuntime.jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.0036 0C18.6283 0 24.0072 5.37174 24.0072 12.0036C24.0072 18.6283 18.6355 24.0072 12.0036 24.0072C5.37894 24.0072 0 18.6355 0 12.0036C0 5.37894 5.37174 0 12.0036 0ZM18.4843 7.9784C18.009 8.19442 17.4978 8.33123 16.9577 8.39604C17.505 8.06481 17.9298 7.54636 18.1242 6.92709C17.613 7.22952 17.0369 7.45275 16.4392 7.57516C15.9496 7.05671 15.2655 6.73987 14.4951 6.73987C13.0261 6.73987 11.838 7.92799 11.838 9.39694C11.838 9.60576 11.8596 9.80738 11.9028 10.0018C9.69217 9.88659 7.73357 8.83528 6.42304 7.22232C6.18542 7.62556 6.06301 8.08641 6.06301 8.56166C6.06301 9.48335 6.53105 10.297 7.24393 10.7723C6.80468 10.7579 6.40144 10.6355 6.0414 10.441V10.477C6.0414 11.766 6.9559 12.8389 8.17282 13.0837C7.9496 13.1413 7.71197 13.1773 7.47435 13.1773C7.30153 13.1773 7.13591 13.1629 6.9703 13.1269C7.30873 14.1854 8.28803 14.9487 9.45455 14.9775C8.54005 15.6904 7.40234 16.1152 6.14942 16.1152C5.93339 16.1152 5.72457 16.1008 5.51575 16.0792C6.69667 16.8353 8.09361 17.2745 9.59136 17.2745C14.4806 17.2745 17.1593 13.2205 17.1593 9.70657C17.1593 9.59136 17.1593 9.47615 17.1521 9.36094C17.6706 8.9865 18.1242 8.51845 18.477 7.9856L18.4843 7.9784Z",
        fill: "#92A6B9"
      })
    }), /*#__PURE__*/jsxRuntime.jsx("defs", {
      children: /*#__PURE__*/jsxRuntime.jsx("clipPath", {
        id: "clip0_104_504",
        children: /*#__PURE__*/jsxRuntime.jsx("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      })
    })]
  })
};

var config$Z = {
  viewBox: '0 0 3 14',
  children: /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx("circle", {
      cx: "1.5",
      cy: "2",
      r: "1.5",
      fill: "currentColor"
    }), /*#__PURE__*/jsxRuntime.jsx("circle", {
      cx: "1.5",
      cy: "7",
      r: "1.5",
      fill: "currentColor"
    }), /*#__PURE__*/jsxRuntime.jsx("circle", {
      cx: "1.5",
      cy: "12",
      r: "1.5",
      fill: "currentColor"
    })]
  })
};

var config$Y = {
  viewBox: '0 0 16 16',
  children: /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M7.99992 9.99998C9.10449 9.99998 9.99992 9.10455 9.99992 7.99998C9.99992 6.89541 9.10449 5.99998 7.99992 5.99998C6.89535 5.99998 5.99992 6.89541 5.99992 7.99998C5.99992 9.10455 6.89535 9.99998 7.99992 9.99998Z",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M12.4848 9.81816C12.4041 10.001 12.38 10.2037 12.4157 10.4003C12.4513 10.5969 12.545 10.7784 12.6848 10.9212L12.7211 10.9576C12.8338 11.0701 12.9232 11.2038 12.9842 11.351C13.0452 11.4981 13.0766 11.6558 13.0766 11.8151C13.0766 11.9744 13.0452 12.1322 12.9842 12.2793C12.9232 12.4265 12.8338 12.5601 12.7211 12.6727C12.6086 12.7854 12.4749 12.8748 12.3277 12.9358C12.1806 12.9968 12.0228 13.0282 11.8636 13.0282C11.7043 13.0282 11.5465 12.9968 11.3994 12.9358C11.2522 12.8748 11.1186 12.7854 11.006 12.6727L10.9696 12.6363C10.8268 12.4966 10.6454 12.4029 10.4488 12.3672C10.2522 12.3316 10.0494 12.3557 9.86658 12.4363C9.68733 12.5132 9.53445 12.6407 9.42677 12.8033C9.31909 12.9659 9.2613 13.1565 9.26052 13.3515V13.4545C9.26052 13.776 9.13282 14.0843 8.9055 14.3116C8.67819 14.5389 8.36988 14.6666 8.0484 14.6666C7.72693 14.6666 7.41862 14.5389 7.1913 14.3116C6.96399 14.0843 6.83628 13.776 6.83628 13.4545V13.4C6.83159 13.1994 6.76666 13.0048 6.64992 12.8416C6.53319 12.6784 6.37006 12.5541 6.18174 12.4848C5.99894 12.4042 5.79616 12.3801 5.59956 12.4157C5.40296 12.4514 5.22154 12.5451 5.07871 12.6848L5.04234 12.7212C4.92977 12.8339 4.79609 12.9233 4.64894 12.9843C4.50179 13.0453 4.34406 13.0767 4.18477 13.0767C4.02548 13.0767 3.86775 13.0453 3.7206 12.9843C3.57345 12.9233 3.43976 12.8339 3.32719 12.7212C3.21449 12.6086 3.12509 12.4749 3.06409 12.3278C3.00309 12.1806 2.97169 12.0229 2.97169 11.8636C2.97169 11.7043 3.00309 11.5466 3.06409 11.3994C3.12509 11.2523 3.21449 11.1186 3.32719 11.006L3.36355 10.9697C3.50327 10.8268 3.597 10.6454 3.63265 10.4488C3.6683 10.2522 3.64423 10.0494 3.56355 9.86665C3.48673 9.68739 3.35916 9.53451 3.19656 9.42683C3.03396 9.31915 2.84343 9.26136 2.6484 9.26059H2.54537C2.2239 9.26059 1.91559 9.13288 1.68827 8.90556C1.46096 8.67825 1.33325 8.36994 1.33325 8.04846C1.33325 7.72699 1.46096 7.41868 1.68827 7.19137C1.91559 6.96405 2.2239 6.83634 2.54537 6.83634H2.59992C2.80052 6.83165 2.99507 6.76672 3.15828 6.64999C3.32149 6.53325 3.44581 6.37012 3.51507 6.1818C3.59575 5.999 3.61981 5.79623 3.58416 5.59962C3.54852 5.40302 3.45479 5.2216 3.31507 5.07877L3.27871 5.0424C3.16601 4.92983 3.0766 4.79615 3.0156 4.649C2.9546 4.50185 2.92321 4.34412 2.92321 4.18483C2.92321 4.02554 2.9546 3.86781 3.0156 3.72066C3.0766 3.57351 3.16601 3.43983 3.27871 3.32725C3.39128 3.21455 3.52496 3.12515 3.67211 3.06415C3.81926 3.00315 3.97699 2.97175 4.13628 2.97175C4.29557 2.97175 4.4533 3.00315 4.60045 3.06415C4.7476 3.12515 4.88128 3.21455 4.99386 3.32725L5.03022 3.36362C5.17306 3.50334 5.35447 3.59706 5.55108 3.63271C5.74768 3.66836 5.95045 3.64429 6.13325 3.56362H6.18174C6.36099 3.48679 6.51387 3.35923 6.62155 3.19663C6.72923 3.03403 6.78702 2.84349 6.7878 2.64846V2.54543C6.7878 2.22396 6.9155 1.91565 7.14282 1.68834C7.37014 1.46102 7.67844 1.33331 7.99992 1.33331C8.32139 1.33331 8.6297 1.46102 8.85702 1.68834C9.08433 1.91565 9.21204 2.22396 9.21204 2.54543V2.59998C9.21282 2.795 9.2706 2.98554 9.37829 3.14814C9.48597 3.31074 9.63885 3.43831 9.8181 3.51513C10.0009 3.59581 10.2037 3.61987 10.4003 3.58422C10.5969 3.54858 10.7783 3.45485 10.9211 3.31513L10.9575 3.27877C11.0701 3.16607 11.2038 3.07666 11.3509 3.01566C11.498 2.95467 11.6558 2.92327 11.8151 2.92327C11.9744 2.92327 12.1321 2.95467 12.2792 3.01566C12.4264 3.07666 12.5601 3.16607 12.6726 3.27877C12.7853 3.39134 12.8747 3.52502 12.9357 3.67217C12.9967 3.81932 13.0281 3.97705 13.0281 4.13634C13.0281 4.29563 12.9967 4.45336 12.9357 4.60051C12.8747 4.74766 12.7853 4.88135 12.6726 4.99392L12.6363 5.03028C12.4966 5.17312 12.4028 5.35453 12.3672 5.55114C12.3315 5.74774 12.3556 5.95052 12.4363 6.13331V6.1818C12.5131 6.36105 12.6407 6.51393 12.8033 6.62161C12.9659 6.72929 13.1564 6.78708 13.3514 6.78786H13.4545C13.7759 6.78786 14.0842 6.91556 14.3116 7.14288C14.5389 7.3702 14.6666 7.6785 14.6666 7.99998C14.6666 8.32145 14.5389 8.62976 14.3116 8.85708C14.0842 9.08439 13.7759 9.2121 13.4545 9.2121H13.3999C13.2049 9.21288 13.0144 9.27067 12.8518 9.37835C12.6892 9.48603 12.5616 9.63891 12.4848 9.81816Z",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  })
};

var config$X = {
  viewBox: '0 0 16 16',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M10.6666 5.33331V3.46665C10.6666 2.71991 10.6666 2.34654 10.5213 2.06133C10.3934 1.81044 10.1895 1.60647 9.93857 1.47864C9.65336 1.33331 9.27999 1.33331 8.53325 1.33331H3.46659C2.71985 1.33331 2.34648 1.33331 2.06126 1.47864C1.81038 1.60647 1.60641 1.81044 1.47858 2.06133C1.33325 2.34654 1.33325 2.71991 1.33325 3.46665V8.53331C1.33325 9.28005 1.33325 9.65342 1.47858 9.93863C1.60641 10.1895 1.81038 10.3935 2.06126 10.5213C2.34648 10.6666 2.71985 10.6666 3.46659 10.6666H5.33325M7.99992 9.99998L9.33325 11.3333L12.3333 8.33331M7.46658 14.6666H12.5333C13.28 14.6666 13.6534 14.6666 13.9386 14.5213C14.1895 14.3935 14.3934 14.1895 14.5213 13.9386C14.6666 13.6534 14.6666 13.28 14.6666 12.5333V7.46665C14.6666 6.71991 14.6666 6.34654 14.5213 6.06133C14.3934 5.81044 14.1895 5.60647 13.9386 5.47864C13.6534 5.33331 13.28 5.33331 12.5333 5.33331H7.46658C6.71985 5.33331 6.34648 5.33331 6.06126 5.47864C5.81038 5.60647 5.60641 5.81044 5.47858 6.06133C5.33325 6.34654 5.33325 6.71991 5.33325 7.46665V12.5333C5.33325 13.28 5.33325 13.6534 5.47858 13.9386C5.60641 14.1895 5.81038 14.3935 6.06126 14.5213C6.34648 14.6666 6.71985 14.6666 7.46658 14.6666Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$W = {
  viewBox: '0 0 20 19',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M3.33333 14.5804V14.4137C3.33333 13.0136 3.33333 12.3135 3.60582 11.7788C3.8455 11.3084 4.22795 10.9259 4.69836 10.6862C5.23314 10.4137 5.9332 10.4137 7.33333 10.4137H12.6667C14.0668 10.4137 14.7669 10.4137 15.3016 10.6862C15.772 10.9259 16.1545 11.3084 16.3942 11.7788C16.6667 12.3135 16.6667 13.0136 16.6667 14.4137V14.5804M3.33333 14.5804C2.41286 14.5804 1.66667 15.3266 1.66667 16.2471C1.66667 17.1675 2.41286 17.9137 3.33333 17.9137C4.25381 17.9137 5 17.1675 5 16.2471C5 15.3266 4.25381 14.5804 3.33333 14.5804ZM16.6667 14.5804C15.7462 14.5804 15 15.3266 15 16.2471C15 17.1675 15.7462 17.9137 16.6667 17.9137C17.5871 17.9137 18.3333 17.1675 18.3333 16.2471C18.3333 15.3266 17.5871 14.5804 16.6667 14.5804ZM10 14.5804C9.07952 14.5804 8.33333 15.3266 8.33333 16.2471C8.33333 17.1675 9.07952 17.9137 10 17.9137C10.9205 17.9137 11.6667 17.1675 11.6667 16.2471C11.6667 15.3266 10.9205 14.5804 10 14.5804ZM10 14.5804V6.24707M5 6.24707H15C15.7766 6.24707 16.1649 6.24707 16.4711 6.1202C16.8795 5.95105 17.204 5.62659 17.3731 5.21821C17.5 4.91192 17.5 4.52364 17.5 3.74707C17.5 2.9705 17.5 2.58222 17.3731 2.27593C17.204 1.86755 16.8795 1.54309 16.4711 1.37394C16.1649 1.24707 15.7766 1.24707 15 1.24707H5C4.22343 1.24707 3.83515 1.24707 3.52886 1.37394C3.12048 1.54309 2.79602 1.86755 2.62687 2.27593C2.5 2.58222 2.5 2.9705 2.5 3.74707C2.5 4.52364 2.5 4.91192 2.62687 5.21821C2.79602 5.62659 3.12048 5.95105 3.52886 6.1202C3.83515 6.24707 4.22343 6.24707 5 6.24707Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$V = {
  viewBox: '0 0 20 17',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M18.3333 16.0806V14.4139C18.3333 12.8607 17.271 11.5556 15.8333 11.1856M12.9167 1.32287C14.1383 1.81735 15 3.01499 15 4.4139C15 5.81281 14.1383 7.01044 12.9167 7.50493M14.1667 16.0806C14.1667 14.5274 14.1667 13.7509 13.9129 13.1383C13.5746 12.3215 12.9257 11.6726 12.1089 11.3343C11.4964 11.0806 10.7198 11.0806 9.16667 11.0806H6.66667C5.11353 11.0806 4.33696 11.0806 3.72439 11.3343C2.90763 11.6726 2.25871 12.3215 1.9204 13.1383C1.66667 13.7509 1.66667 14.5274 1.66667 16.0806M11.25 4.4139C11.25 6.25485 9.75761 7.74723 7.91667 7.74723C6.07572 7.74723 4.58333 6.25485 4.58333 4.4139C4.58333 2.57295 6.07572 1.08057 7.91667 1.08057C9.75761 1.08057 11.25 2.57295 11.25 4.4139Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$U = {
  viewBox: '0 0 45 45',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M30 33.75L33.75 37.5L41.25 30M22.5 28.125H15C11.5054 28.125 9.75816 28.125 8.37987 28.6959C6.54216 29.4571 5.08211 30.9172 4.3209 32.7549C3.75 34.1332 3.75 35.8804 3.75 39.375M29.0625 6.17017C31.8111 7.28277 33.75 9.97746 33.75 13.125C33.75 16.2725 31.8111 18.9672 29.0625 20.0798M25.3125 13.125C25.3125 17.2671 21.9546 20.625 17.8125 20.625C13.6704 20.625 10.3125 17.2671 10.3125 13.125C10.3125 8.98286 13.6704 5.625 17.8125 5.625C21.9546 5.625 25.3125 8.98286 25.3125 13.125Z",
    stroke: "currentColor",
    strokeWidth: "3.375",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$T = {
  viewBox: '0 0 14 14',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M9.03367 5H2.66667C1.74619 5 1 4.25381 1 3.33333C1 2.41286 1.74619 1.66667 2.66667 1.66667H9.03367M4.96633 12.3333H11.3333C12.2538 12.3333 13 11.5871 13 10.6667C13 9.74619 12.2538 9 11.3333 9H4.96633M1 10.6667C1 11.9553 2.04467 13 3.33333 13C4.622 13 5.66667 11.9553 5.66667 10.6667C5.66667 9.378 4.622 8.33333 3.33333 8.33333C2.04467 8.33333 1 9.378 1 10.6667ZM13 3.33333C13 4.622 11.9553 5.66667 10.6667 5.66667C9.378 5.66667 8.33333 4.622 8.33333 3.33333C8.33333 2.04467 9.378 1 10.6667 1C11.9553 1 13 2.04467 13 3.33333Z",
    stroke: "#08979C",
    strokeWidth: "1.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$S = {
  viewBox: '0 0 14 14',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M6.33333 1.66667H4.2C3.0799 1.66667 2.51984 1.66667 2.09202 1.88465C1.71569 2.0764 1.40973 2.38236 1.21799 2.75869C1 3.18651 1 3.74656 1 4.86667V9.8C1 10.9201 1 11.4802 1.21799 11.908C1.40973 12.2843 1.71569 12.5903 2.09202 12.782C2.51984 13 3.07989 13 4.2 13H9.13333C10.2534 13 10.8135 13 11.2413 12.782C11.6176 12.5903 11.9236 12.2843 12.1153 11.908C12.3333 11.4802 12.3333 10.9201 12.3333 9.8V7.66667M7.66667 10.3333H3.66667M9 7.66667H3.66667M12.4142 1.58579C13.1953 2.36683 13.1953 3.63317 12.4142 4.41421C11.6332 5.19526 10.3668 5.19526 9.58579 4.41421C8.80474 3.63317 8.80474 2.36683 9.58579 1.58579C10.3668 0.804738 11.6332 0.804738 12.4142 1.58579Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$R = {
  viewBox: '0 0 18 18',
  children: /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M6.5 16.8878V10.7211C6.5 10.2544 6.5 10.0211 6.59083 9.84281C6.67072 9.68601 6.79821 9.55853 6.95501 9.47863C7.13327 9.3878 7.36662 9.3878 7.83333 9.3878H10.1667C10.6334 9.3878 10.8667 9.3878 11.045 9.47863C11.2018 9.55853 11.3293 9.68601 11.4092 9.84281C11.5 10.0211 11.5 10.2544 11.5 10.7211V16.8878M8.18141 1.69115L2.52949 6.08709C2.15168 6.38094 1.96278 6.52786 1.82669 6.71186C1.70614 6.87485 1.61633 7.05847 1.56169 7.25369C1.5 7.47408 1.5 7.7134 1.5 8.19203V14.2211C1.5 15.1546 1.5 15.6213 1.68166 15.9778C1.84144 16.2914 2.09641 16.5464 2.41002 16.7061C2.76654 16.8878 3.23325 16.8878 4.16667 16.8878H13.8333C14.7668 16.8878 15.2335 16.8878 15.59 16.7061C15.9036 16.5464 16.1586 16.2914 16.3183 15.9778C16.5 15.6213 16.5 15.1546 16.5 14.2211V8.19203C16.5 7.7134 16.5 7.47408 16.4383 7.25369C16.3837 7.05847 16.2939 6.87485 16.1733 6.71186C16.0372 6.52786 15.8483 6.38094 15.4705 6.08709L9.81859 1.69115C9.52582 1.46344 9.37943 1.34958 9.21779 1.30582C9.07516 1.2672 8.92484 1.2672 8.78221 1.30582C8.62057 1.34958 8.47418 1.46344 8.18141 1.69115Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  })
};

var config$Q = {
  viewBox: '0 0 20 22',
  children: /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M0.75 20.5H18.75M3.75 17.5V9.49998M7.75 17.5V9.49998M11.75 17.5V9.49998M15.75 17.5V9.49998M17.75 6.49998L10.174 1.76498C10.0202 1.66884 9.94327 1.62077 9.86079 1.60203C9.78786 1.58546 9.71214 1.58546 9.63921 1.60203C9.55673 1.62077 9.47982 1.66884 9.326 1.76498L1.75 6.49998H17.75Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  })
};

var config$P = {
  viewBox: '0 0 23 20',
  children: /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M15.5 1.96776C16.9817 2.70411 18 4.23314 18 6C18 7.76686 16.9817 9.29589 15.5 10.0322M17.5 15.2664C19.0115 15.9503 20.3725 17.065 21.5 18.5M1.5 18.5C3.44649 16.0226 6.08918 14.5 9 14.5C11.9108 14.5 14.5535 16.0226 16.5 18.5M13.5 6C13.5 8.48528 11.4853 10.5 9 10.5C6.51472 10.5 4.5 8.48528 4.5 6C4.5 3.51472 6.51472 1.5 9 1.5C11.4853 1.5 13.5 3.51472 13.5 6Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  })
};

var config$O = {
  viewBox: '0 0 23 23',
  children: /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M21.5 11.5H17.5M5.5 11.5H1.5M11.5 5.5V1.5M11.5 21.5V17.5M19.5 11.5C19.5 15.9183 15.9183 19.5 11.5 19.5C7.08172 19.5 3.5 15.9183 3.5 11.5C3.5 7.08172 7.08172 3.5 11.5 3.5C15.9183 3.5 19.5 7.08172 19.5 11.5Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  })
};

var config$N = {
  viewBox: '0 0 28 17',
  children: /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsxs("mask", {
      id: "path-1-outside-1_241_9861",
      maskUnits: "userSpaceOnUse",
      x: "-0.118134",
      y: "-0.560303",
      width: "28",
      height: "18",
      fill: "black",
      children: [/*#__PURE__*/jsxRuntime.jsx("rect", {
        fill: "white",
        x: "-0.118134",
        y: "-0.560303",
        width: "28",
        height: "18"
      }), /*#__PURE__*/jsxRuntime.jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24.3387 10.5915C23.7337 10.5915 23.2284 10.2428 22.9704 9.69304L21.4818 10.65L21.6349 10.8979C22.043 11.5611 21.839 12.4283 21.1758 12.7854C20.9765 12.9348 20.7287 13.0356 20.4796 13.0403C20.5126 13.2272 20.5132 13.4208 20.4616 13.6013C20.3596 13.9584 20.1555 14.2645 19.8494 14.4685C19.5944 14.6216 19.3393 14.6726 19.0842 14.6726C18.9282 14.6726 18.7722 14.6432 18.6242 14.5883C18.5295 14.9091 18.3207 15.1974 18.0129 15.3868C17.7578 15.5398 17.5028 15.5909 17.2477 15.5909C17.1065 15.5909 16.9652 15.5667 16.8299 15.5214C16.725 15.8645 16.5241 16.1583 16.2274 16.3561C15.9723 16.4581 15.7173 16.5601 15.4622 16.5601C15.0031 16.5601 14.5439 16.3051 14.2889 15.8969L13.9054 15.2754L12.5544 15.9992C12.3504 16.1522 12.1463 16.2032 11.9423 16.2032C11.7382 16.2032 11.5341 16.1012 11.3301 15.9992C10.871 15.7441 10.5139 15.1319 10.4118 14.5198C10.0547 14.5708 9.69764 14.4687 9.44257 14.2647C9.08547 14.0096 8.93243 13.5505 8.88142 13.2444C8.37128 13.2954 7.96316 13.1424 7.65708 12.8873C7.35099 12.5812 7.24897 12.1731 7.24897 11.816C6.43274 11.918 6.12666 11.5099 5.97361 11.2549C5.79768 10.8678 5.84018 10.3837 6.0174 10.0201L5.01452 9.43015L4.90236 9.6735C4.64728 10.2347 4.13714 10.5918 3.52498 10.5918C3.26991 10.5918 3.06585 10.5407 2.86179 10.4387L1.7905 9.92857C1.38239 9.77553 1.12731 9.41843 0.974273 9.06133C0.821231 8.65322 0.872245 8.2451 1.02529 7.88801L4.03512 1.35821C4.29019 0.797054 4.85134 0.439955 5.4125 0.439955C5.66757 0.439955 5.87162 0.490969 6.07568 0.592997L7.19799 1.10314C7.94624 1.45232 8.25549 2.33806 7.93495 3.0926H8.52432L11.6872 1.6132C11.8797 1.51697 12.8436 1.14844 14.2794 1.62051C14.9165 1.24423 15.9857 1.3836 16.4315 1.56193C17.3481 1.91112 17.8166 2.26032 18.1565 2.51364L18.1565 2.51369C18.2138 2.55641 18.2675 2.59641 18.319 2.63322L18.3662 2.67001C18.7312 2.95519 18.9619 3.13541 19.9693 3.18221L19.9515 3.14344C19.5944 2.37823 19.9005 1.45998 20.6657 1.10288L21.788 0.592739C21.992 0.490711 22.1961 0.439697 22.4512 0.439697C23.0123 0.439697 23.5735 0.796796 23.8285 1.35795L26.8384 7.88775C26.9914 8.24485 27.0424 8.65296 26.8894 9.06107C26.7363 9.41817 26.4813 9.77527 26.0732 9.92831L25.0019 10.4385C24.7978 10.5405 24.5938 10.5915 24.3387 10.5915ZM7.55951 3.90883L5.34206 8.71957L6.57731 9.44619C7.20931 8.99416 7.8413 8.53754 8.4733 8.04097C8.79013 7.81154 9.1093 7.57977 9.43031 7.34667L9.43198 7.34545L9.43274 7.3449L9.43396 7.34402L9.43401 7.34398L9.43433 7.34375L9.43438 7.34371C10.611 6.48929 11.8123 5.61696 13.0136 4.77607C13.0646 4.72505 13.1666 4.67404 13.2176 4.67404H13.9828C14.8501 4.67404 15.8193 5.69432 16.4315 6.40852L16.5845 6.56156C16.8396 6.86764 17.2477 6.86764 17.4518 6.7146C17.7579 6.51055 17.7579 6.05142 17.4518 5.54128C17.4188 5.44248 17.3646 5.34367 17.3029 5.23114L17.3029 5.23109L17.3029 5.23106C17.269 5.16931 17.2328 5.10343 17.1967 5.03114C17.0929 4.78896 16.9657 4.54679 16.8468 4.32053C16.7904 4.21315 16.7358 4.10936 16.6866 4.01086C16.2522 3.43172 14.9047 2.76127 14.3286 2.47463L14.2379 2.42942C12.9115 1.86827 12.0443 2.27638 11.9933 2.32739L8.77939 3.85782C8.75388 3.85782 8.72837 3.87057 8.70287 3.88332C8.67736 3.89608 8.65185 3.90883 8.62635 3.90883H7.55951ZM20.3504 4.00897L22.6573 9.01378L21.0759 9.99278L20.5636 9.16341C20.1555 8.50023 19.2882 8.29617 18.6761 8.70428C18.4453 8.84631 18.2701 9.04395 18.157 9.26924C17.9113 9.07253 17.605 8.95902 17.2987 8.95902C17.0437 8.95902 16.7886 9.01004 16.5335 9.16308C16.2274 9.36714 16.0234 9.67322 15.9213 10.0303C15.8958 10.1199 15.883 10.2094 15.8807 10.299C15.5523 10.2548 15.2597 10.3183 15.0031 10.4895C14.697 10.6935 14.4419 10.9996 14.3909 11.3567C14.3859 11.3741 14.3813 11.3916 14.3771 11.4092C14.2512 11.3748 14.1188 11.3567 13.9828 11.3567C13.7277 11.3567 13.4726 11.4077 13.2686 11.5608C12.9625 11.7648 12.7074 12.0709 12.6564 12.428C12.5544 12.7851 12.6054 13.1422 12.8095 13.4993L13.5081 14.6316L12.1463 15.336C11.9933 15.438 11.8912 15.438 11.7382 15.336C11.4266 15.1579 11.1927 14.6692 11.1381 14.2763L11.9933 13.6013C12.1463 13.4482 12.1463 13.1932 12.0443 13.0401C11.8912 12.8871 11.6362 12.8361 11.4831 12.9891L10.6189 13.7169C10.2913 13.8052 10.0988 13.7986 9.95271 13.6525C9.74839 13.4891 9.675 13.1292 9.65389 12.9138L11.1771 11.7137C11.3301 11.5607 11.3811 11.3056 11.2281 11.1526C11.0751 10.9995 10.871 10.9485 10.6669 11.1016L9.13926 12.3905C8.79427 12.4832 8.41315 12.5211 8.21823 12.3261C8.00308 12.154 8.00571 11.7641 8.04241 11.5545L10.0038 9.92797C10.1568 9.77493 10.2078 9.51986 10.0548 9.36682C9.90173 9.21378 9.64666 9.21378 9.49362 9.3158L7.48468 11.0234C7.21424 11.0735 6.81928 11.1241 6.68781 10.9488C6.58578 10.6937 6.68781 10.3366 6.78984 10.2856C7.50403 9.72444 8.21822 9.2143 8.9324 8.70417L8.93243 8.70415C10.4118 7.63286 11.8912 6.56156 13.3707 5.43925H13.9828C14.4538 5.43925 15.1405 6.1581 15.6205 6.66055C15.7123 6.75669 15.7966 6.84491 15.8703 6.91866C15.8958 6.94417 15.9214 6.98243 15.9469 7.02069C15.9724 7.05895 15.9979 7.09721 16.0234 7.12271C16.5335 7.63286 17.3497 7.73488 17.9109 7.32677C18.37 6.96967 18.6761 6.25548 18.166 5.18418C18.115 5.10766 18.0767 5.03114 18.0384 4.95462C18.0002 4.8781 17.9619 4.80158 17.9109 4.72505L17.9109 4.72496C17.7068 4.31688 17.5028 3.9088 17.2987 3.55173C16.911 3.01489 16.1048 2.51292 15.4612 2.16815C15.7212 2.17491 15.9845 2.21215 16.1764 2.27612C17.0947 2.63322 17.5028 2.93931 17.8089 3.24539C18.3951 3.68508 18.7943 3.98442 20.3504 4.00897ZM22.4512 1.20491C22.2981 1.20491 22.1961 1.25592 22.0941 1.30694L21.0228 1.81708C20.6147 1.97012 20.4616 2.42924 20.6147 2.83736L23.6245 9.36716C23.7775 9.62223 24.0326 9.82628 24.3387 9.82628C24.4407 9.82628 24.5938 9.77527 24.6958 9.72425L25.7671 9.21411C25.9426 9.17024 26.0426 9.0132 26.132 8.87275C26.1466 8.84987 26.1609 8.82744 26.1752 8.806C26.2262 8.60194 26.2262 8.39789 26.1242 8.19383L23.1143 1.66403C23.0123 1.40896 22.7062 1.20491 22.4512 1.20491ZM14.5439 12.428C14.527 12.4025 14.5111 12.3764 14.4962 12.3497C14.3849 12.1978 14.2028 12.1219 13.9828 12.1219C13.8808 12.1219 13.7787 12.1219 13.6512 12.1984C13.5099 12.2832 13.3961 12.428 13.3706 12.581C13.3706 12.7851 13.3706 12.9381 13.4726 13.0912L14.9521 15.4888C15.0541 15.6419 15.2581 15.7949 15.4622 15.7949C15.5642 15.7949 15.7173 15.7439 15.8193 15.6929C15.9213 15.5909 16.0233 15.4378 16.0744 15.2848C16.1254 15.1317 16.0744 14.9277 16.0233 14.8257L14.5668 12.465C14.5578 12.4528 14.5501 12.4404 14.5439 12.428ZM15.1051 11.5607C15.1051 11.707 15.1051 11.8532 15.194 11.9994L15.2071 12.0199L16.6865 14.4175C16.6987 14.4419 16.7106 14.4666 16.722 14.4916C16.7275 14.5006 16.7327 14.5099 16.7375 14.5196C16.8906 14.8256 17.2987 14.9277 17.6048 14.7236C17.9109 14.5196 17.9619 14.1625 17.8088 13.8564C17.8035 13.8458 17.7987 13.8352 17.7942 13.8246L16.1373 11.2012C16.0559 11.1352 15.9631 11.0916 15.8703 11.0761C15.7173 11.0506 15.5642 11.0506 15.4112 11.1526C15.2581 11.2547 15.1561 11.4077 15.1051 11.5607ZM19.6454 12.9381L19.415 12.5733C19.3495 12.5006 19.29 12.4185 19.2372 12.3263C19.2168 12.2956 19.2025 12.2608 19.1943 12.224L17.8089 10.0303C17.7068 9.82626 17.5028 9.72423 17.2987 9.72423C17.1457 9.72423 17.0436 9.74974 16.9416 9.82626C16.8217 9.91622 16.7376 10.0303 16.6866 10.1834C16.6355 10.3874 16.6866 10.5405 16.7376 10.6935L18.5741 13.6013C18.6761 13.8054 18.8802 13.9074 19.0842 13.9074C19.1862 13.9074 19.3393 13.8564 19.4413 13.8054C19.5433 13.7033 19.6454 13.6013 19.6964 13.4483C19.7474 13.2442 19.6964 13.0912 19.6454 12.9381ZM18.7832 10.1149L20.0176 12.0694C20.1045 12.1336 20.2065 12.1903 20.3085 12.2243C20.4616 12.2753 20.6146 12.2243 20.7677 12.1732C21.0737 11.9692 21.1758 11.5611 20.9717 11.306L19.9004 9.57152C19.7474 9.26544 19.3393 9.16341 19.0332 9.36747C18.8102 9.50124 18.7042 9.82988 18.7832 10.1149ZM4.74931 1.66429C4.85134 1.40922 5.15743 1.20517 5.4125 1.20517C5.56554 1.20517 5.66757 1.25618 5.76959 1.30719L6.84089 1.81733C7.249 1.97038 7.40204 2.4295 7.249 2.83762L4.23917 9.36741C4.08613 9.62248 3.83106 9.82654 3.52498 9.82654C3.42295 9.82654 3.26991 9.77553 3.16788 9.72451L2.09658 9.21437C1.92111 9.1705 1.82108 9.01346 1.73162 8.873C1.71705 8.85013 1.70276 8.82769 1.68847 8.80626C1.63746 8.6022 1.63746 8.39815 1.73948 8.19409L4.74931 1.66429Z"
      })]
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24.3387 10.5915C23.7337 10.5915 23.2284 10.2428 22.9704 9.69304L21.4818 10.65L21.6349 10.8979C22.043 11.5611 21.839 12.4283 21.1758 12.7854C20.9765 12.9348 20.7287 13.0356 20.4796 13.0403C20.5126 13.2272 20.5132 13.4208 20.4616 13.6013C20.3596 13.9584 20.1555 14.2645 19.8494 14.4685C19.5944 14.6216 19.3393 14.6726 19.0842 14.6726C18.9282 14.6726 18.7722 14.6432 18.6242 14.5883C18.5295 14.9091 18.3207 15.1974 18.0129 15.3868C17.7578 15.5398 17.5028 15.5909 17.2477 15.5909C17.1065 15.5909 16.9652 15.5667 16.8299 15.5214C16.725 15.8645 16.5241 16.1583 16.2274 16.3561C15.9723 16.4581 15.7173 16.5601 15.4622 16.5601C15.0031 16.5601 14.5439 16.3051 14.2889 15.8969L13.9054 15.2754L12.5544 15.9992C12.3504 16.1522 12.1463 16.2032 11.9423 16.2032C11.7382 16.2032 11.5341 16.1012 11.3301 15.9992C10.871 15.7441 10.5139 15.1319 10.4118 14.5198C10.0547 14.5708 9.69764 14.4687 9.44257 14.2647C9.08547 14.0096 8.93243 13.5505 8.88142 13.2444C8.37128 13.2954 7.96316 13.1424 7.65708 12.8873C7.35099 12.5812 7.24897 12.1731 7.24897 11.816C6.43274 11.918 6.12666 11.5099 5.97361 11.2549C5.79768 10.8678 5.84018 10.3837 6.0174 10.0201L5.01452 9.43015L4.90236 9.6735C4.64728 10.2347 4.13714 10.5918 3.52498 10.5918C3.26991 10.5918 3.06585 10.5407 2.86179 10.4387L1.7905 9.92857C1.38239 9.77553 1.12731 9.41843 0.974273 9.06133C0.821231 8.65322 0.872245 8.2451 1.02529 7.88801L4.03512 1.35821C4.29019 0.797054 4.85134 0.439955 5.4125 0.439955C5.66757 0.439955 5.87162 0.490969 6.07568 0.592997L7.19799 1.10314C7.94624 1.45232 8.25549 2.33806 7.93495 3.0926H8.52432L11.6872 1.6132C11.8797 1.51697 12.8436 1.14844 14.2794 1.62051C14.9165 1.24423 15.9857 1.3836 16.4315 1.56193C17.3481 1.91112 17.8166 2.26032 18.1565 2.51364L18.1565 2.51369C18.2138 2.55641 18.2675 2.59641 18.319 2.63322L18.3662 2.67001C18.7312 2.95519 18.9619 3.13541 19.9693 3.18221L19.9515 3.14344C19.5944 2.37823 19.9005 1.45998 20.6657 1.10288L21.788 0.592739C21.992 0.490711 22.1961 0.439697 22.4512 0.439697C23.0123 0.439697 23.5735 0.796796 23.8285 1.35795L26.8384 7.88775C26.9914 8.24485 27.0424 8.65296 26.8894 9.06107C26.7363 9.41817 26.4813 9.77527 26.0732 9.92831L25.0019 10.4385C24.7978 10.5405 24.5938 10.5915 24.3387 10.5915ZM7.55951 3.90883L5.34206 8.71957L6.57731 9.44619C7.20931 8.99416 7.8413 8.53754 8.4733 8.04097C8.79013 7.81154 9.1093 7.57977 9.43031 7.34667L9.43198 7.34545L9.43274 7.3449L9.43396 7.34402L9.43401 7.34398L9.43433 7.34375L9.43438 7.34371C10.611 6.48929 11.8123 5.61696 13.0136 4.77607C13.0646 4.72505 13.1666 4.67404 13.2176 4.67404H13.9828C14.8501 4.67404 15.8193 5.69432 16.4315 6.40852L16.5845 6.56156C16.8396 6.86764 17.2477 6.86764 17.4518 6.7146C17.7579 6.51055 17.7579 6.05142 17.4518 5.54128C17.4188 5.44248 17.3646 5.34367 17.3029 5.23114L17.3029 5.23109L17.3029 5.23106C17.269 5.16931 17.2328 5.10343 17.1967 5.03114C17.0929 4.78896 16.9657 4.54679 16.8468 4.32053C16.7904 4.21315 16.7358 4.10936 16.6866 4.01086C16.2522 3.43172 14.9047 2.76127 14.3286 2.47463L14.2379 2.42942C12.9115 1.86827 12.0443 2.27638 11.9933 2.32739L8.77939 3.85782C8.75388 3.85782 8.72837 3.87057 8.70287 3.88332C8.67736 3.89608 8.65185 3.90883 8.62635 3.90883H7.55951ZM20.3504 4.00897L22.6573 9.01378L21.0759 9.99278L20.5636 9.16341C20.1555 8.50023 19.2882 8.29617 18.6761 8.70428C18.4453 8.84631 18.2701 9.04395 18.157 9.26924C17.9113 9.07253 17.605 8.95902 17.2987 8.95902C17.0437 8.95902 16.7886 9.01004 16.5335 9.16308C16.2274 9.36714 16.0234 9.67322 15.9213 10.0303C15.8958 10.1199 15.883 10.2094 15.8807 10.299C15.5523 10.2548 15.2597 10.3183 15.0031 10.4895C14.697 10.6935 14.4419 10.9996 14.3909 11.3567C14.3859 11.3741 14.3813 11.3916 14.3771 11.4092C14.2512 11.3748 14.1188 11.3567 13.9828 11.3567C13.7277 11.3567 13.4726 11.4077 13.2686 11.5608C12.9625 11.7648 12.7074 12.0709 12.6564 12.428C12.5544 12.7851 12.6054 13.1422 12.8095 13.4993L13.5081 14.6316L12.1463 15.336C11.9933 15.438 11.8912 15.438 11.7382 15.336C11.4266 15.1579 11.1927 14.6692 11.1381 14.2763L11.9933 13.6013C12.1463 13.4482 12.1463 13.1932 12.0443 13.0401C11.8912 12.8871 11.6362 12.8361 11.4831 12.9891L10.6189 13.7169C10.2913 13.8052 10.0988 13.7986 9.95271 13.6525C9.74839 13.4891 9.675 13.1292 9.65389 12.9138L11.1771 11.7137C11.3301 11.5607 11.3811 11.3056 11.2281 11.1526C11.0751 10.9995 10.871 10.9485 10.6669 11.1016L9.13926 12.3905C8.79427 12.4832 8.41315 12.5211 8.21823 12.3261C8.00308 12.154 8.00571 11.7641 8.04241 11.5545L10.0038 9.92797C10.1568 9.77493 10.2078 9.51986 10.0548 9.36682C9.90173 9.21378 9.64666 9.21378 9.49362 9.3158L7.48468 11.0234C7.21424 11.0735 6.81928 11.1241 6.68781 10.9488C6.58578 10.6937 6.68781 10.3366 6.78984 10.2856C7.50403 9.72444 8.21822 9.2143 8.9324 8.70417L8.93243 8.70415C10.4118 7.63286 11.8912 6.56156 13.3707 5.43925H13.9828C14.4538 5.43925 15.1405 6.1581 15.6205 6.66055C15.7123 6.75669 15.7966 6.84491 15.8703 6.91866C15.8958 6.94417 15.9214 6.98243 15.9469 7.02069C15.9724 7.05895 15.9979 7.09721 16.0234 7.12271C16.5335 7.63286 17.3497 7.73488 17.9109 7.32677C18.37 6.96967 18.6761 6.25548 18.166 5.18418C18.115 5.10766 18.0767 5.03114 18.0384 4.95462C18.0002 4.8781 17.9619 4.80158 17.9109 4.72505L17.9109 4.72496C17.7068 4.31688 17.5028 3.9088 17.2987 3.55173C16.911 3.01489 16.1048 2.51292 15.4612 2.16815C15.7212 2.17491 15.9845 2.21215 16.1764 2.27612C17.0947 2.63322 17.5028 2.93931 17.8089 3.24539C18.3951 3.68508 18.7943 3.98442 20.3504 4.00897ZM22.4512 1.20491C22.2981 1.20491 22.1961 1.25592 22.0941 1.30694L21.0228 1.81708C20.6147 1.97012 20.4616 2.42924 20.6147 2.83736L23.6245 9.36716C23.7775 9.62223 24.0326 9.82628 24.3387 9.82628C24.4407 9.82628 24.5938 9.77527 24.6958 9.72425L25.7671 9.21411C25.9426 9.17024 26.0426 9.0132 26.132 8.87275C26.1466 8.84987 26.1609 8.82744 26.1752 8.806C26.2262 8.60194 26.2262 8.39789 26.1242 8.19383L23.1143 1.66403C23.0123 1.40896 22.7062 1.20491 22.4512 1.20491ZM14.5439 12.428C14.527 12.4025 14.5111 12.3764 14.4962 12.3497C14.3849 12.1978 14.2028 12.1219 13.9828 12.1219C13.8808 12.1219 13.7787 12.1219 13.6512 12.1984C13.5099 12.2832 13.3961 12.428 13.3706 12.581C13.3706 12.7851 13.3706 12.9381 13.4726 13.0912L14.9521 15.4888C15.0541 15.6419 15.2581 15.7949 15.4622 15.7949C15.5642 15.7949 15.7173 15.7439 15.8193 15.6929C15.9213 15.5909 16.0233 15.4378 16.0744 15.2848C16.1254 15.1317 16.0744 14.9277 16.0233 14.8257L14.5668 12.465C14.5578 12.4528 14.5501 12.4404 14.5439 12.428ZM15.1051 11.5607C15.1051 11.707 15.1051 11.8532 15.194 11.9994L15.2071 12.0199L16.6865 14.4175C16.6987 14.4419 16.7106 14.4666 16.722 14.4916C16.7275 14.5006 16.7327 14.5099 16.7375 14.5196C16.8906 14.8256 17.2987 14.9277 17.6048 14.7236C17.9109 14.5196 17.9619 14.1625 17.8088 13.8564C17.8035 13.8458 17.7987 13.8352 17.7942 13.8246L16.1373 11.2012C16.0559 11.1352 15.9631 11.0916 15.8703 11.0761C15.7173 11.0506 15.5642 11.0506 15.4112 11.1526C15.2581 11.2547 15.1561 11.4077 15.1051 11.5607ZM19.6454 12.9381L19.415 12.5733C19.3495 12.5006 19.29 12.4185 19.2372 12.3263C19.2168 12.2956 19.2025 12.2608 19.1943 12.224L17.8089 10.0303C17.7068 9.82626 17.5028 9.72423 17.2987 9.72423C17.1457 9.72423 17.0436 9.74974 16.9416 9.82626C16.8217 9.91622 16.7376 10.0303 16.6866 10.1834C16.6355 10.3874 16.6866 10.5405 16.7376 10.6935L18.5741 13.6013C18.6761 13.8054 18.8802 13.9074 19.0842 13.9074C19.1862 13.9074 19.3393 13.8564 19.4413 13.8054C19.5433 13.7033 19.6454 13.6013 19.6964 13.4483C19.7474 13.2442 19.6964 13.0912 19.6454 12.9381ZM18.7832 10.1149L20.0176 12.0694C20.1045 12.1336 20.2065 12.1903 20.3085 12.2243C20.4616 12.2753 20.6146 12.2243 20.7677 12.1732C21.0737 11.9692 21.1758 11.5611 20.9717 11.306L19.9004 9.57152C19.7474 9.26544 19.3393 9.16341 19.0332 9.36747C18.8102 9.50124 18.7042 9.82988 18.7832 10.1149ZM4.74931 1.66429C4.85134 1.40922 5.15743 1.20517 5.4125 1.20517C5.56554 1.20517 5.66757 1.25618 5.76959 1.30719L6.84089 1.81733C7.249 1.97038 7.40204 2.4295 7.249 2.83762L4.23917 9.36741C4.08613 9.62248 3.83106 9.82654 3.52498 9.82654C3.42295 9.82654 3.26991 9.77553 3.16788 9.72451L2.09658 9.21437C1.92111 9.1705 1.82108 9.01346 1.73162 8.873C1.71705 8.85013 1.70276 8.82769 1.68847 8.80626C1.63746 8.6022 1.63746 8.39815 1.73948 8.19409L4.74931 1.66429Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M22.9704 9.69304L23.0798 9.64171L23.0212 9.51677L22.9051 9.5914L22.9704 9.69304ZM21.4818 10.65L21.4165 10.5484L21.3166 10.6126L21.379 10.7135L21.4818 10.65ZM21.6349 10.8979L21.7378 10.8346L21.7377 10.8344L21.6349 10.8979ZM21.1758 12.7854L21.1185 12.679L21.1105 12.6833L21.1033 12.6887L21.1758 12.7854ZM20.4796 13.0403L20.4774 12.9195L20.3361 12.9221L20.3606 13.0613L20.4796 13.0403ZM20.4616 13.6013L20.3454 13.5681L20.4616 13.6013ZM19.8494 14.4685L19.9117 14.5723L19.9165 14.5691L19.8494 14.4685ZM18.6242 14.5883L18.6663 14.475L18.545 14.43L18.5084 14.5541L18.6242 14.5883ZM18.0129 15.3868L18.0751 15.4904L18.0762 15.4897L18.0129 15.3868ZM16.8299 15.5214L16.8683 15.4068L16.7507 15.3675L16.7144 15.4861L16.8299 15.5214ZM16.2274 16.3561L16.2723 16.4683L16.284 16.4636L16.2944 16.4566L16.2274 16.3561ZM14.2889 15.8969L14.186 15.9604L14.1864 15.961L14.2889 15.8969ZM13.9054 15.2754L14.0082 15.212L13.9485 15.1152L13.8483 15.1689L13.9054 15.2754ZM12.5544 15.9992L12.4974 15.8926L12.4893 15.897L12.4819 15.9025L12.5544 15.9992ZM11.3301 15.9992L11.2714 16.1049L11.2761 16.1072L11.3301 15.9992ZM10.4118 14.5198L10.531 14.4999L10.5116 14.3834L10.3947 14.4001L10.4118 14.5198ZM9.44257 14.2647L9.51817 14.1702L9.5128 14.1664L9.44257 14.2647ZM8.88142 13.2444L9.0006 13.2245L8.982 13.1129L8.86939 13.1242L8.88142 13.2444ZM7.65708 12.8873L7.57128 12.9731L7.57972 12.9801L7.65708 12.8873ZM7.24897 11.816H7.3698V11.6791L7.23398 11.6961L7.24897 11.816ZM5.97361 11.2549L5.8629 11.3052L5.87 11.317L5.97361 11.2549ZM6.0174 10.0201L6.12602 10.073L6.17497 9.97258L6.07866 9.91593L6.0174 10.0201ZM5.01452 9.43015L5.07579 9.326L4.96069 9.2583L4.90479 9.37957L5.01452 9.43015ZM4.90236 9.6735L4.79262 9.62292L4.79235 9.6235L4.90236 9.6735ZM2.86179 10.4387L2.91584 10.3306L2.91374 10.3296L2.86179 10.4387ZM1.7905 9.92857L1.84264 9.81907L1.83293 9.81543L1.7905 9.92857ZM0.974273 9.06133L0.861013 9.1038L0.863209 9.10893L0.974273 9.06133ZM1.02529 7.88801L0.91551 7.83741L0.914223 7.84041L1.02529 7.88801ZM4.03512 1.35821L4.14485 1.40879L4.14512 1.40821L4.03512 1.35821ZM6.07568 0.592997L6.0216 0.701148L6.02568 0.703L6.07568 0.592997ZM7.19799 1.10314L7.24909 0.993635L7.24799 0.993135L7.19799 1.10314ZM7.93495 3.0926L7.82374 3.04536L7.75234 3.21344H7.93495V3.0926ZM8.52432 3.0926V3.21344H8.55118L8.57551 3.20206L8.52432 3.0926ZM11.6872 1.6132L11.7384 1.72269L11.7412 1.72127L11.6872 1.6132ZM14.2794 1.62051L14.2417 1.7353L14.2937 1.75241L14.3409 1.72455L14.2794 1.62051ZM16.4315 1.56193L16.3866 1.67413L16.3885 1.67484L16.4315 1.56193ZM18.1565 2.51364L18.0842 2.61052L18.0847 2.61084L18.1565 2.51364ZM18.1565 2.51369L18.2287 2.41681L18.2283 2.4165L18.1565 2.51369ZM18.319 2.63322L18.3934 2.53786L18.3893 2.53489L18.319 2.63322ZM18.3662 2.67001L18.4406 2.57479L18.4405 2.57474L18.3662 2.67001ZM19.9693 3.18221L19.9637 3.30292L20.1623 3.31214L20.0791 3.13163L19.9693 3.18221ZM19.9515 3.14344L20.0612 3.09286L20.061 3.09234L19.9515 3.14344ZM20.6657 1.10288L20.6157 0.992872L20.6146 0.993383L20.6657 1.10288ZM21.788 0.592739L21.838 0.702817L21.842 0.700816L21.788 0.592739ZM23.8285 1.35795L23.7185 1.40795L23.7188 1.40853L23.8285 1.35795ZM26.8384 7.88775L26.9495 7.84013L26.9481 7.83717L26.8384 7.88775ZM26.8894 9.06107L27.0006 9.10872L27.0025 9.1035L26.8894 9.06107ZM26.0732 9.92831L26.0306 9.81475L26.0212 9.81921L26.0732 9.92831ZM25.0019 10.4385L24.9499 10.3293L24.9478 10.3304L25.0019 10.4385ZM7.55951 3.90883V3.788H7.48215L7.44977 3.85825L7.55951 3.90883ZM5.34206 8.71957L5.23232 8.66899L5.18655 8.76828L5.28079 8.82372L5.34206 8.71957ZM6.57731 9.44619L6.51604 9.55034L6.58373 9.59015L6.6476 9.54447L6.57731 9.44619ZM8.4733 8.04097L8.40238 7.94302L8.39865 7.94595L8.4733 8.04097ZM9.43031 7.34667L9.35931 7.24889L9.35931 7.24889L9.43031 7.34667ZM9.43198 7.34545L9.361 7.24766L9.36099 7.24767L9.43198 7.34545ZM9.43274 7.3449L9.50372 7.44269L9.50373 7.44268L9.43274 7.3449ZM9.43396 7.34402L9.50494 7.4418L9.50564 7.44129L9.43396 7.34402ZM9.43401 7.34398L9.36294 7.24625L9.36234 7.2467L9.43401 7.34398ZM9.43433 7.34375L9.36434 7.24524L9.36326 7.24602L9.43433 7.34375ZM9.43438 7.34371L9.50437 7.44221L9.50538 7.44148L9.43438 7.34371ZM13.0136 4.77607L13.0828 4.87506L13.0915 4.86899L13.099 4.86151L13.0136 4.77607ZM16.4315 6.40852L16.3395 6.48739L16.3461 6.49396L16.4315 6.40852ZM16.5845 6.56156L16.6777 6.48389L16.67 6.47612L16.5845 6.56156ZM17.4518 6.7146L17.3846 6.61391L17.3793 6.61794L17.4518 6.7146ZM17.4518 5.54128L17.3371 5.57949L17.3413 5.59207L17.3482 5.60345L17.4518 5.54128ZM17.3029 5.23114L17.196 5.28743L17.197 5.28926L17.3029 5.23114ZM17.3029 5.23109L17.4104 5.17451L17.4034 5.16406L17.3029 5.23109ZM17.3029 5.23106L17.1965 5.28939L17.2023 5.29809L17.3029 5.23106ZM17.1967 5.03114L17.0855 5.07882L17.0886 5.08518L17.1967 5.03114ZM16.8468 4.32053L16.9537 4.26432V4.26432L16.8468 4.32053ZM16.6866 4.01086L16.7946 3.95682L16.7898 3.94707L16.7832 3.93836L16.6866 4.01086ZM14.3286 2.47463L14.2747 2.58278L14.2748 2.58282L14.3286 2.47463ZM14.2379 2.42942L14.2919 2.32106L14.285 2.31814L14.2379 2.42942ZM11.9933 2.32739L12.0452 2.43649L12.064 2.42755L12.0787 2.41284L11.9933 2.32739ZM8.77939 3.85782V3.97865H8.80669L8.83134 3.96691L8.77939 3.85782ZM22.6573 9.01378L22.7209 9.11652L22.8118 9.06026L22.7671 8.9632L22.6573 9.01378ZM20.3504 4.00897L20.4602 3.95839L20.4283 3.88935L20.3523 3.88815L20.3504 4.00897ZM21.0759 9.99278L20.9731 10.0563L21.0366 10.1592L21.1395 10.0955L21.0759 9.99278ZM20.5636 9.16341L20.4607 9.22674L20.4608 9.22691L20.5636 9.16341ZM18.6761 8.70428L18.7395 8.80726L18.7431 8.80482L18.6761 8.70428ZM18.157 9.26924L18.0814 9.36357L18.198 9.45686L18.2649 9.32347L18.157 9.26924ZM16.5335 9.16308L16.4713 9.05935L16.4665 9.06254L16.5335 9.16308ZM15.9213 10.0303L15.8052 9.99712L15.9213 10.0303ZM15.8807 10.299L15.8646 10.4187L15.998 10.4366L16.0015 10.3021L15.8807 10.299ZM15.0031 10.4895L14.936 10.3889V10.3889L15.0031 10.4895ZM14.3909 11.3567L14.5071 11.3899L14.5093 11.3819L14.5105 11.3738L14.3909 11.3567ZM14.3771 11.4092L14.3453 11.5257L14.4654 11.5585L14.4946 11.4375L14.3771 11.4092ZM13.2686 11.5608L13.3357 11.6614L13.3411 11.6574L13.2686 11.5608ZM12.6564 12.428L12.7726 12.4612L12.7749 12.4533L12.776 12.4451L12.6564 12.428ZM12.8095 13.4993L12.7045 13.5593L12.7066 13.5627L12.8095 13.4993ZM13.5081 14.6316L13.5636 14.7389L13.6794 14.6791L13.611 14.5681L13.5081 14.6316ZM12.1463 15.336L12.0905 15.228L12.0793 15.2354L12.1463 15.336ZM11.7382 15.336L11.8054 15.2352L11.7982 15.2311L11.7382 15.336ZM11.1381 14.2763L11.0633 14.1815L11.0089 14.2244L11.0185 14.293L11.1381 14.2763ZM11.9933 13.6013L12.0681 13.6961L12.0737 13.6917L12.0787 13.6867L11.9933 13.6013ZM12.0443 13.0401L12.1448 12.9731L12.1382 12.9631L12.1297 12.9547L12.0443 13.0401ZM11.4831 12.9891L11.5612 13.0819L11.5686 13.0745L11.4831 12.9891ZM10.6189 13.7169L10.6503 13.8335L10.6762 13.8266L10.6967 13.8093L10.6189 13.7169ZM9.95271 13.6525L10.0387 13.5665L10.0282 13.5582L9.95271 13.6525ZM9.65389 12.9138L9.57911 12.8189L9.52718 12.8598L9.53363 12.9256L9.65389 12.9138ZM11.1771 11.7137L11.2519 11.8086L11.2575 11.8042L11.2625 11.7992L11.1771 11.7137ZM11.2281 11.1526L11.3135 11.0671H11.3135L11.2281 11.1526ZM10.6669 11.1016L10.5943 11.0047L10.589 11.0092L10.6669 11.1016ZM9.13926 12.3905L9.17062 12.5072L9.19661 12.5002L9.21718 12.4829L9.13926 12.3905ZM8.21823 12.3261L8.3042 12.2402L8.29372 12.2318L8.21823 12.3261ZM8.04241 11.5545L7.96528 11.4614L7.93106 11.4898L7.92339 11.5336L8.04241 11.5545ZM10.0038 9.92797L10.0812 10.0214L10.0892 10.0134L10.0038 9.92797ZM10.0548 9.36682L9.96933 9.45226L10.0548 9.36682ZM9.49362 9.3158L9.42613 9.21458L9.41536 9.22374L9.49362 9.3158ZM7.48468 11.0234L7.50668 11.1422L7.53837 11.1363L7.56294 11.1155L7.48468 11.0234ZM6.68781 10.9488L6.57562 10.9936L6.58156 11.0085L6.59114 11.0213L6.68781 10.9488ZM6.78984 10.2856L6.84388 10.3937L6.85485 10.3882L6.86449 10.3806L6.78984 10.2856ZM8.9324 8.70417L8.86534 8.60358L8.86217 8.60584L8.9324 8.70417ZM8.93243 8.70415L8.99951 8.80476L9.0033 8.80202L8.93243 8.70415ZM13.3707 5.43925V5.31842H13.33L13.2976 5.34298L13.3707 5.43925ZM15.6205 6.66055L15.5331 6.74401V6.74401L15.6205 6.66055ZM15.8703 6.91866L15.7849 7.0041V7.0041L15.8703 6.91866ZM17.9109 7.32677L17.982 7.42454L17.9851 7.42215L17.9109 7.32677ZM18.166 5.18418L18.2751 5.13223L18.2713 5.12438L18.2665 5.11715L18.166 5.18418ZM17.9109 4.72505L17.8028 4.77909L17.8062 4.78582L17.8104 4.79208L17.9109 4.72505ZM17.9109 4.72496L18.0189 4.67092V4.67092L17.9109 4.72496ZM17.2987 3.55173L17.4042 3.49144L17.3967 3.48098L17.2987 3.55173ZM15.4612 2.16815L15.4643 2.04736L15.4041 2.27467L15.4612 2.16815ZM16.1764 2.27612L16.2203 2.16337L16.2146 2.16149L16.1764 2.27612ZM17.8089 3.24539L17.7234 3.33083L17.7295 3.3369L17.7364 3.34206L17.8089 3.24539ZM22.0941 1.30694L22.146 1.41605L22.1481 1.41501L22.0941 1.30694ZM21.0228 1.81708L21.0654 1.93063L21.0747 1.92617L21.0228 1.81708ZM20.6147 2.83736L20.5012 2.8799L20.5049 2.88794L20.6147 2.83736ZM23.6245 9.36716L23.5141 9.41804L23.5209 9.42932L23.6245 9.36716ZM24.6958 9.72425L24.6438 9.61514L24.6417 9.61618L24.6958 9.72425ZM25.7671 9.21411L25.7378 9.09689L25.726 9.09982L25.7151 9.10502L25.7671 9.21411ZM26.132 8.87275L26.0301 8.80783L26.0301 8.80783L26.132 8.87275ZM26.1752 8.806L26.2757 8.87303L26.2873 8.85561L26.2924 8.83531L26.1752 8.806ZM26.1242 8.19383L26.0144 8.24444L26.0161 8.24787L26.1242 8.19383ZM23.1143 1.66403L23.002 1.70897L23.0046 1.71462L23.1143 1.66403ZM14.4962 12.3497L14.6019 12.291L14.5982 12.2843L14.5937 12.2782L14.4962 12.3497ZM14.5439 12.428L14.652 12.3739L14.6486 12.3672L14.6445 12.361L14.5439 12.428ZM13.6512 12.1984L13.7134 12.302L13.6512 12.1984ZM13.3706 12.581L13.2514 12.5612L13.2498 12.571V12.581H13.3706ZM13.4726 13.0912L13.5755 13.0277L13.5732 13.0242L13.4726 13.0912ZM14.9521 15.4888L14.8492 15.5523L14.8515 15.5559L14.9521 15.4888ZM15.8193 15.6929L15.8733 15.801L15.8909 15.7922L15.9047 15.7783L15.8193 15.6929ZM16.0744 15.2848L16.189 15.323L16.0744 15.2848ZM16.0233 14.8257L16.1319 14.7714L16.1262 14.7622L16.0233 14.8257ZM14.5668 12.465L14.6699 12.4013L14.6643 12.3936L14.5668 12.465ZM15.194 11.9994L15.0908 12.0622L15.0922 12.0643L15.194 11.9994ZM15.1051 11.5607L14.9905 11.5225L14.9843 11.5411V11.5607H15.1051ZM15.2071 12.0199L15.31 11.9564L15.309 11.9549L15.2071 12.0199ZM16.6865 14.4175L16.795 14.3633L16.7894 14.3541L16.6865 14.4175ZM16.722 14.4916L16.6122 14.5419L16.6152 14.5485L16.619 14.5547L16.722 14.4916ZM17.6048 14.7236L17.5378 14.6231L17.6048 14.7236ZM17.8088 13.8564L17.7008 13.9104L17.7008 13.9104L17.8088 13.8564ZM17.7942 13.8246L17.9054 13.7775L17.9016 13.7684L17.8963 13.7601L17.7942 13.8246ZM16.1373 11.2012L16.2394 11.1367L16.2288 11.1199L16.2134 11.1073L16.1373 11.2012ZM15.8703 11.0761L15.8902 10.9569L15.8703 11.0761ZM15.4112 11.1526L15.4782 11.2532L15.4112 11.1526ZM19.415 12.5733L19.5171 12.5088L19.5116 12.5001L19.5048 12.4925L19.415 12.5733ZM19.6454 12.9381L19.76 12.8999L19.7554 12.886L19.7475 12.8736L19.6454 12.9381ZM19.2372 12.3263L19.3424 12.2662L19.3378 12.2593L19.2372 12.3263ZM19.1943 12.224L19.3123 12.1979L19.3077 12.1773L19.2965 12.1594L19.1943 12.224ZM17.8089 10.0303L17.7002 10.0846L17.7067 10.0948L17.8089 10.0303ZM16.9416 9.82626L17.0141 9.92293L17.0141 9.92293L16.9416 9.82626ZM16.6866 10.1834L16.5716 10.145L16.5693 10.1541L16.6866 10.1834ZM16.7376 10.6935L16.6229 10.7317L16.6276 10.7456L16.6354 10.758L16.7376 10.6935ZM18.5741 13.6013L18.6827 13.547L18.6762 13.5368L18.5741 13.6013ZM19.4413 13.8054L19.4954 13.9134L19.5129 13.9047L19.5268 13.8908L19.4413 13.8054ZM19.6964 13.4483L19.8114 13.4866L19.8136 13.4776L19.6964 13.4483ZM20.0176 12.0694L19.9155 12.1339L19.9276 12.1531L19.9458 12.1665L20.0176 12.0694ZM18.7832 10.1149L18.6668 10.1472L18.6716 10.1644L18.6811 10.1794L18.7832 10.1149ZM20.3085 12.2243L20.2703 12.3389L20.3085 12.2243ZM20.7677 12.1732L20.8059 12.2879L20.8212 12.2828L20.8347 12.2738L20.7677 12.1732ZM20.9717 11.306L20.8689 11.3695L20.8728 11.3757L20.8774 11.3815L20.9717 11.306ZM19.9004 9.57152L19.7919 9.62578L19.7976 9.63502L19.9004 9.57152ZM19.0332 9.36747L19.0954 9.4712L19.1002 9.468L19.0332 9.36747ZM4.74931 1.66429L4.85919 1.71494L4.8615 1.70917L4.74931 1.66429ZM5.76959 1.30719L5.71555 1.41529L5.71764 1.41629L5.76959 1.30719ZM6.84089 1.81733L6.78875 1.92683L6.79846 1.93047L6.84089 1.81733ZM7.249 2.83762L7.35903 2.88833L7.36214 2.88004L7.249 2.83762ZM4.23917 9.36741L4.3434 9.42995L4.34891 9.418L4.23917 9.36741ZM3.16788 9.72451L3.22193 9.61642L3.21983 9.61542L3.16788 9.72451ZM2.09658 9.21437L2.14853 9.10528L2.13762 9.10008L2.12589 9.09715L2.09658 9.21437ZM1.73162 8.873L1.6297 8.93792L1.6297 8.93792L1.73162 8.873ZM1.68847 8.80626L1.57124 8.83557L1.57632 8.85587L1.58793 8.87328L1.68847 8.80626ZM1.73948 8.19409L1.84761 8.24816L1.84922 8.24467L1.73948 8.19409ZM22.8611 9.74438C23.1372 10.3328 23.6829 10.7123 24.3387 10.7123V10.4707C23.7846 10.4707 23.3197 10.1528 23.0798 9.64171L22.8611 9.74438ZM21.5471 10.7517L23.0358 9.79468L22.9051 9.5914L21.4165 10.5484L21.5471 10.7517ZM21.7377 10.8344L21.5846 10.5865L21.379 10.7135L21.5321 10.9614L21.7377 10.8344ZM21.2331 12.8918C21.9628 12.4989 22.179 11.5516 21.7378 10.8346L21.532 10.9612C21.907 11.5706 21.7151 12.3578 21.1185 12.679L21.2331 12.8918ZM20.4819 13.1611C20.761 13.1559 21.0329 13.0436 21.2483 12.8821L21.1033 12.6887C20.9202 12.826 20.6963 12.9154 20.4774 12.9195L20.4819 13.1611ZM20.5778 13.6345C20.6356 13.4321 20.6339 13.2192 20.5986 13.0193L20.3606 13.0613C20.3913 13.2351 20.3907 13.4095 20.3454 13.5681L20.5778 13.6345ZM19.9165 14.5691C20.2495 14.347 20.469 14.0153 20.5778 13.6345L20.3454 13.5681C20.2502 13.9015 20.0615 14.1819 19.7824 14.368L19.9165 14.5691ZM19.0842 14.7934C19.3568 14.7934 19.6343 14.7385 19.9116 14.5722L19.7873 14.3649C19.5544 14.5046 19.3218 14.5518 19.0842 14.5518V14.7934ZM18.5822 14.7016C18.7429 14.7611 18.9131 14.7934 19.0842 14.7934V14.5518C18.9434 14.5518 18.8016 14.5252 18.6663 14.475L18.5822 14.7016ZM18.0762 15.4897C18.4103 15.2841 18.6373 14.9709 18.7401 14.6225L18.5084 14.5541C18.4218 14.8474 18.231 15.1107 17.9496 15.2839L18.0762 15.4897ZM17.2477 15.7117C17.5202 15.7117 17.7978 15.6568 18.0751 15.4904L17.9507 15.2832C17.7179 15.4229 17.4853 15.47 17.2477 15.47V15.7117ZM16.7916 15.636C16.9386 15.6852 17.0927 15.7117 17.2477 15.7117V15.47C17.1202 15.47 16.9919 15.4482 16.8683 15.4068L16.7916 15.636ZM16.2944 16.4566C16.6173 16.2414 16.8335 15.923 16.9455 15.5568L16.7144 15.4861C16.6165 15.8061 16.431 16.0751 16.1604 16.2555L16.2944 16.4566ZM15.4622 16.681C15.7449 16.681 16.0224 16.5682 16.2723 16.4683L16.1825 16.2439C15.9223 16.348 15.6897 16.4393 15.4622 16.4393V16.681ZM14.1864 15.961C14.4629 16.4034 14.9603 16.681 15.4622 16.681V16.4393C15.0459 16.4393 14.6249 16.2067 14.3913 15.8329L14.1864 15.961ZM13.8025 15.3389L14.186 15.9604L14.3917 15.8335L14.0082 15.212L13.8025 15.3389ZM12.6115 16.1057L13.9624 15.3819L13.8483 15.1689L12.4974 15.8926L12.6115 16.1057ZM11.9423 16.324C12.1692 16.324 12.3995 16.2664 12.6269 16.0958L12.4819 15.9025C12.3013 16.038 12.1235 16.0824 11.9423 16.0824V16.324ZM11.2761 16.1072C11.4731 16.2058 11.7041 16.324 11.9423 16.324V16.0824C11.7723 16.0824 11.5952 15.9966 11.3841 15.8911L11.2761 16.1072ZM10.2926 14.5396C10.3986 15.1755 10.7704 15.8264 11.2714 16.1048L11.3888 15.8935C10.9715 15.6617 10.6291 15.0883 10.531 14.4999L10.2926 14.5396ZM9.36709 14.359C9.64867 14.5843 10.0394 14.695 10.4289 14.6394L10.3947 14.4001C10.0701 14.4465 9.74661 14.3532 9.51805 14.1703L9.36709 14.359ZM8.76223 13.2643C8.81501 13.581 8.97585 14.0798 9.37234 14.363L9.5128 14.1664C9.19509 13.9394 9.04985 13.52 9.0006 13.2245L8.76223 13.2643ZM7.57972 12.9801C7.90999 13.2554 8.35011 13.419 8.89344 13.3646L8.86939 13.1242C8.39244 13.1719 8.01633 13.0294 7.73443 12.7945L7.57972 12.9801ZM7.12813 11.816C7.12813 12.1938 7.23597 12.6371 7.57164 12.9727L7.74252 12.8019C7.46602 12.5254 7.3698 12.1524 7.3698 11.816H7.12813ZM5.87 11.317C5.95017 11.4506 6.07715 11.6361 6.29945 11.7724C6.52385 11.9099 6.8328 11.9898 7.26395 11.9359L7.23398 11.6961C6.84891 11.7442 6.5967 11.6711 6.42574 11.5663C6.25269 11.4603 6.1501 11.3141 6.07723 11.1927L5.87 11.317ZM5.90878 9.96714C5.71874 10.357 5.67017 10.8793 5.86361 11.3049L6.08362 11.2049C5.92519 10.8563 5.96161 10.4103 6.12602 10.073L5.90878 9.96714ZM4.95326 9.5343L5.95613 10.1242L6.07866 9.91593L5.07579 9.326L4.95326 9.5343ZM4.90479 9.37957L4.79262 9.62292L5.01209 9.72408L5.12426 9.48073L4.90479 9.37957ZM4.79235 9.6235C4.5551 10.1454 4.08559 10.4709 3.52498 10.4709V10.7126C4.1887 10.7126 4.73946 10.3239 5.01236 9.7235L4.79235 9.6235ZM3.52498 10.4709C3.28854 10.4709 3.103 10.4242 2.91583 10.3306L2.80775 10.5468C3.0287 10.6573 3.25127 10.7126 3.52498 10.7126V10.4709ZM2.91374 10.3296L1.84245 9.81947L1.73855 10.0377L2.80984 10.5478L2.91374 10.3296ZM1.83293 9.81543C1.46881 9.67889 1.23222 9.35646 1.08534 9.01373L0.863209 9.10893C1.02241 9.48039 1.29596 9.87217 1.74807 10.0417L1.83293 9.81543ZM1.08741 9.0189C0.947695 8.64632 0.9926 8.27102 1.13635 7.93561L0.914223 7.84041C0.751889 8.21919 0.694766 8.66011 0.861133 9.10376L1.08741 9.0189ZM1.13502 7.93859L4.14485 1.40879L3.92538 1.30763L0.91555 7.83742L1.13502 7.93859ZM4.14512 1.40821C4.38137 0.888465 4.90059 0.560789 5.4125 0.560789V0.319122C4.80209 0.319122 4.19901 0.705642 3.92511 1.30821L4.14512 1.40821ZM5.4125 0.560789C5.64893 0.560789 5.83447 0.607489 6.02164 0.701074L6.12972 0.484921C5.90877 0.374449 5.6862 0.319122 5.4125 0.319122V0.560789ZM6.02568 0.703L7.14799 1.21314L7.24799 0.993135L6.12568 0.482995L6.02568 0.703ZM7.14689 1.21264C7.83269 1.53267 8.12035 2.34714 7.82374 3.04536L8.04617 3.13985C8.39063 2.32898 8.05979 1.37197 7.24909 0.993641L7.14689 1.21264ZM8.52432 2.97177H7.93495V3.21344H8.52432V2.97177ZM11.636 1.50374L8.47312 2.98315L8.57551 3.20206L11.7384 1.72265L11.636 1.50374ZM14.3172 1.50573C12.8465 1.02222 11.8496 1.39691 11.6332 1.50512L11.7412 1.72127C11.9097 1.63702 12.8406 1.27467 14.2417 1.7353L14.3172 1.50573ZM16.4764 1.44974C16.2375 1.35418 15.8441 1.27282 15.4302 1.26244C15.0177 1.2521 14.5646 1.3117 14.218 1.51647L14.3409 1.72455C14.6312 1.55304 15.0314 1.49419 15.4241 1.50404C15.8156 1.51385 16.1797 1.59134 16.3866 1.67412L16.4764 1.44974ZM18.2287 2.41676C17.8847 2.16036 17.406 1.80386 16.4745 1.44901L16.3885 1.67484C17.2903 2.01838 17.7485 2.36027 18.0842 2.61052L18.2287 2.41676ZM18.2283 2.4165L18.2282 2.41645L18.0847 2.61084L18.0847 2.61088L18.2283 2.4165ZM18.3893 2.53489C18.3389 2.49893 18.2863 2.4597 18.2287 2.41681L18.0843 2.61057C18.1414 2.65313 18.1961 2.69389 18.2488 2.73155L18.3893 2.53489ZM18.4405 2.57474L18.3933 2.53795L18.2447 2.72849L18.2919 2.76528L18.4405 2.57474ZM19.975 3.06151C19.4766 3.03836 19.1815 2.98252 18.9695 2.90246C18.7595 2.82315 18.6236 2.71776 18.4406 2.57479L18.2918 2.76523C18.4738 2.90743 18.6357 3.03475 18.8842 3.12855C19.1306 3.2216 19.4546 3.27927 19.9637 3.30292L19.975 3.06151ZM19.8417 3.19403L19.8596 3.2328L20.0791 3.13163L20.0612 3.09286L19.8417 3.19403ZM20.6146 0.993383C19.7855 1.3803 19.4583 2.37234 19.842 3.19454L20.061 3.09234C19.7305 2.38413 20.0155 1.53966 20.7168 1.21238L20.6146 0.993383ZM21.738 0.482737L20.6157 0.992877L20.7157 1.21288L21.838 0.702742L21.738 0.482737ZM22.4512 0.318864C22.1775 0.318864 21.9549 0.374191 21.7339 0.484663L21.842 0.700816C22.0292 0.607231 22.2147 0.560531 22.4512 0.560531V0.318864ZM23.9385 1.30795C23.6646 0.705384 23.0616 0.318864 22.4512 0.318864V0.560531C22.9631 0.560531 23.4823 0.888207 23.7185 1.40795L23.9385 1.30795ZM26.9481 7.83717L23.9383 1.30737L23.7188 1.40853L26.7286 7.93833L26.9481 7.83717ZM27.0025 9.1035C27.1689 8.65985 27.1118 8.21893 26.9494 7.84015L26.7273 7.93535C26.8711 8.27076 26.916 8.64606 26.7762 9.01864L27.0025 9.1035ZM26.1156 10.0414C26.5677 9.87191 26.8412 9.48013 27.0004 9.10867L26.7783 9.01347C26.6314 9.3562 26.3948 9.67863 26.0307 9.81517L26.1156 10.0414ZM25.0538 10.5475L26.1251 10.0374L26.0212 9.81921L24.9499 10.3294L25.0538 10.5475ZM24.3387 10.7123C24.6124 10.7123 24.835 10.657 25.0559 10.5465L24.9478 10.3304C24.7607 10.424 24.5751 10.4707 24.3387 10.4707V10.7123ZM7.44977 3.85825L5.23232 8.66899L5.45179 8.77015L7.66924 3.95941L7.44977 3.85825ZM6.63857 9.34204L5.40332 8.61542L5.28079 8.82372L6.51604 9.55034L6.63857 9.34204ZM8.39865 7.94595C7.76896 8.44071 7.13888 8.89597 6.50701 9.3479L6.6476 9.54447C7.27973 9.09235 7.91365 8.63437 8.54796 8.13598L8.39865 7.94595ZM9.35931 7.24889C9.03829 7.48201 8.71919 7.71373 8.40243 7.9431L8.54417 8.13884C8.86108 7.90935 9.18031 7.67754 9.50131 7.44444L9.35931 7.24889ZM9.36099 7.24767L9.35931 7.24889L9.5013 7.44445L9.50297 7.44323L9.36099 7.24767ZM9.36177 7.2471L9.361 7.24766L9.50295 7.44325L9.50372 7.44269L9.36177 7.2471ZM9.36298 7.24623L9.36176 7.24711L9.50373 7.44268L9.50494 7.4418L9.36298 7.24623ZM9.36234 7.2467L9.36228 7.24674L9.50564 7.44129L9.50569 7.44125L9.36234 7.2467ZM9.36326 7.24602L9.36294 7.24625L9.50508 7.4417L9.5054 7.44147L9.36326 7.24602ZM9.3644 7.24521L9.36434 7.24524L9.50432 7.44225L9.50437 7.44221L9.3644 7.24521ZM12.9443 4.67708C11.742 5.51868 10.5398 6.39162 9.36338 7.24593L9.50538 7.44148C10.6821 6.58696 11.8826 5.71525 13.0828 4.87506L12.9443 4.67708ZM13.2176 4.55321C13.1628 4.55321 13.1035 4.57688 13.0615 4.59785C13.0158 4.62073 12.9656 4.65316 12.9281 4.69063L13.099 4.86151C13.1125 4.84796 13.1389 4.82938 13.1696 4.814C13.1843 4.80668 13.1975 4.80129 13.208 4.79795C13.2199 4.79416 13.2225 4.79487 13.2176 4.79487V4.55321ZM13.9828 4.55321H13.2176V4.79487H13.9828V4.55321ZM16.5232 6.32988C16.2159 5.97137 15.8148 5.53089 15.3786 5.17937C14.9465 4.83112 14.4597 4.55321 13.9828 4.55321V4.79487C14.3732 4.79487 14.8046 5.0271 15.227 5.36754C15.6453 5.70471 16.0349 6.13147 16.3398 6.48716L16.5232 6.32988ZM16.67 6.47612L16.5169 6.32308L16.3461 6.49396L16.4991 6.647L16.67 6.47612ZM17.3793 6.61794C17.2272 6.73196 16.8917 6.74141 16.6774 6.4842L16.4917 6.63892C16.7875 6.99388 17.2682 7.00333 17.5243 6.81127L17.3793 6.61794ZM17.3482 5.60345C17.494 5.84645 17.5605 6.06725 17.5605 6.24272C17.5605 6.41472 17.4978 6.53871 17.3848 6.61406L17.5188 6.81514C17.7119 6.68644 17.8022 6.47884 17.8022 6.24272C17.8022 6.01008 17.7157 5.74625 17.5554 5.47911L17.3482 5.60345ZM17.197 5.28926C17.2601 5.40429 17.3083 5.49305 17.3371 5.57949L17.5664 5.50307C17.5294 5.3919 17.4692 5.28305 17.4089 5.17303L17.197 5.28926ZM17.196 5.28736L17.196 5.28742L17.4098 5.17486L17.4098 5.17481L17.196 5.28736ZM17.2023 5.29809L17.2023 5.29811L17.4034 5.16406L17.4034 5.16403L17.2023 5.29809ZM17.0886 5.08518C17.1259 5.15981 17.1632 5.22762 17.1969 5.28918L17.4088 5.17294C17.3748 5.111 17.3398 5.04704 17.3048 4.9771L17.0886 5.08518ZM16.7398 4.37673C16.8591 4.60375 16.9841 4.84169 17.0856 5.07874L17.3078 4.98354C17.2018 4.73623 17.0722 4.48983 16.9537 4.26432L16.7398 4.37673ZM16.5785 4.0649C16.6284 4.16469 16.6835 4.2696 16.7398 4.37673L16.9537 4.26432C16.8972 4.15671 16.8433 4.05404 16.7946 3.95682L16.5785 4.0649ZM14.2748 2.58282C14.5631 2.72625 15.0402 2.96367 15.4989 3.23688C15.9629 3.51319 16.3887 3.81508 16.5899 4.08336L16.7832 3.93836C16.5501 3.6275 16.085 3.3046 15.6226 3.02924C15.155 2.75078 14.6703 2.50966 14.3825 2.36645L14.2748 2.58282ZM14.184 2.53757L14.2747 2.58278L14.3825 2.36648L14.2918 2.32127L14.184 2.53757ZM12.0787 2.41284C12.0706 2.42095 12.0659 2.42273 12.0742 2.41774C12.0798 2.4144 12.089 2.40939 12.1022 2.40308C12.1284 2.39053 12.167 2.3744 12.2175 2.35745C12.3183 2.3236 12.464 2.28731 12.6492 2.2691C13.0187 2.23275 13.5468 2.26823 14.1908 2.5407L14.285 2.31814C13.6026 2.02946 13.0339 1.98842 12.6255 2.02859C12.4217 2.04864 12.2581 2.08887 12.1405 2.12835C12.0818 2.14807 12.0339 2.16781 11.9977 2.18515C11.9797 2.19378 11.9638 2.20222 11.9504 2.2102C11.9398 2.21652 11.9223 2.22746 11.9078 2.24195L12.0787 2.41284ZM8.83134 3.96691L12.0452 2.43649L11.9413 2.2183L8.72744 3.74872L8.83134 3.96691ZM8.75691 3.9914C8.76352 3.98809 8.76853 3.9856 8.77328 3.98337C8.77792 3.98119 8.78118 3.97982 8.78355 3.97893C8.7888 3.97696 8.78643 3.97865 8.77939 3.97865V3.73698C8.71981 3.73698 8.66732 3.766 8.64883 3.77525L8.75691 3.9914ZM8.62635 4.02966C8.68593 4.02966 8.73841 4.00064 8.75691 3.9914L8.64883 3.77525C8.64221 3.77855 8.63721 3.78105 8.63245 3.78328C8.62782 3.78545 8.62456 3.78683 8.62218 3.78772C8.61693 3.78969 8.61931 3.788 8.62635 3.788V4.02966ZM7.55951 4.02966H8.62635V3.788H7.55951V4.02966ZM22.7671 8.9632L20.4602 3.95839L20.2407 4.05955L22.5476 9.06436L22.7671 8.9632ZM21.1395 10.0955L22.7209 9.11652L22.5937 8.91104L21.0123 9.89004L21.1395 10.0955ZM20.4608 9.22691L20.9731 10.0563L21.1787 9.92929L20.6664 9.09991L20.4608 9.22691ZM18.7431 8.80482C19.2944 8.43732 20.0859 8.61773 20.4607 9.22674L20.6665 9.10008C20.2251 8.38272 19.2821 8.15502 18.6091 8.60374L18.7431 8.80482ZM18.2649 9.32347C18.3683 9.11768 18.5283 8.93713 18.7394 8.80719L18.6128 8.60137C18.3623 8.75549 18.1719 8.97022 18.049 9.21502L18.2649 9.32347ZM17.2987 9.07986C17.5756 9.07986 17.8556 9.18277 18.0814 9.36357L18.2325 9.17492C17.9669 8.96228 17.6344 8.83819 17.2987 8.83819V9.07986ZM16.5957 9.26669C16.8285 9.12699 17.0611 9.07986 17.2987 9.07986V8.83819C17.0262 8.83819 16.7486 8.89308 16.4713 9.05947L16.5957 9.26669ZM16.0375 10.0635C16.1328 9.73011 16.3215 9.44967 16.6005 9.26362L16.4665 9.06254C16.1334 9.2846 15.914 9.61633 15.8052 9.99712L16.0375 10.0635ZM16.0015 10.3021C16.0035 10.2221 16.0149 10.1426 16.0375 10.0635L15.8052 9.99712C15.7766 10.0971 15.7625 10.1968 15.7599 10.2958L16.0015 10.3021ZM15.0701 10.59C15.3004 10.4364 15.5629 10.3782 15.8646 10.4187L15.8968 10.1792C15.5416 10.1315 15.219 10.2002 14.936 10.3889L15.0701 10.59ZM14.5105 11.3738C14.555 11.0626 14.7808 10.7828 15.0701 10.59L14.936 10.3889C14.6131 10.6042 14.3288 10.9366 14.2713 11.3396L14.5105 11.3738ZM14.4946 11.4375C14.4984 11.4215 14.5026 11.4056 14.5071 11.3899L14.2747 11.3235C14.2693 11.3425 14.2642 11.3616 14.2596 11.3809L14.4946 11.4375ZM13.9828 11.4775C14.1081 11.4775 14.2298 11.4942 14.3453 11.5257L14.4089 11.2926C14.2727 11.2554 14.1296 11.2359 13.9828 11.2359V11.4775ZM13.3411 11.6574C13.5163 11.526 13.7419 11.4775 13.9828 11.4775V11.2359C13.7136 11.2359 13.429 11.2894 13.1961 11.4641L13.3411 11.6574ZM12.776 12.4451C12.8205 12.1339 13.0464 11.8541 13.3356 11.6613L13.2016 11.4602C12.8787 11.6755 12.5944 12.0079 12.5368 12.4109L12.776 12.4451ZM12.9144 13.4393C12.7246 13.1072 12.6805 12.7835 12.7726 12.4612L12.5402 12.3948C12.4283 12.7867 12.4863 13.1772 12.7046 13.5592L12.9144 13.4393ZM13.611 14.5681L12.9123 13.4358L12.7066 13.5627L13.4053 14.695L13.611 14.5681ZM12.2018 15.4433L13.5636 14.7389L13.4526 14.5243L12.0908 15.2287L12.2018 15.4433ZM11.6712 15.4365C11.7566 15.4935 11.8442 15.5333 11.9423 15.5333C12.0403 15.5333 12.1279 15.4935 12.2133 15.4365L12.0793 15.2354C12.0117 15.2805 11.9718 15.2917 11.9423 15.2917C11.9128 15.2917 11.8728 15.2805 11.8052 15.2354L11.6712 15.4365ZM11.0185 14.293C11.0478 14.5043 11.1247 14.7384 11.2354 14.944C11.3451 15.1477 11.4951 15.3362 11.6783 15.4409L11.7982 15.2311C11.6698 15.1577 11.5469 15.0128 11.4482 14.8294C11.3504 14.6479 11.283 14.4412 11.2578 14.2597L11.0185 14.293ZM11.9184 13.5064L11.0633 14.1815L11.213 14.3712L12.0681 13.6961L11.9184 13.5064ZM11.9437 13.1071C12.0181 13.2187 12.0149 13.4087 11.9078 13.5158L12.0787 13.6867C12.2777 13.4877 12.2745 13.1676 12.1448 12.9731L11.9437 13.1071ZM11.5686 13.0745C11.614 13.0291 11.6764 13.0107 11.7487 13.0197C11.8226 13.029 11.9002 13.067 11.9588 13.1256L12.1297 12.9547C12.0353 12.8602 11.9088 12.7962 11.7787 12.7799C11.6469 12.7634 11.5053 12.796 11.3977 12.9037L11.5686 13.0745ZM10.6967 13.8093L11.5609 13.0815L11.4053 12.8967L10.541 13.6245L10.6967 13.8093ZM9.86727 13.738C10.0636 13.9343 10.3178 13.9232 10.6503 13.8335L10.5874 13.6002C10.2647 13.6872 10.1339 13.6628 10.0382 13.5671L9.86727 13.738ZM9.53363 12.9256C9.54477 13.0392 9.56977 13.1927 9.62016 13.3414C9.66972 13.4877 9.74874 13.6441 9.87723 13.7469L10.0282 13.5582C9.95236 13.4975 9.89253 13.3922 9.84904 13.2639C9.80638 13.1379 9.78413 13.0038 9.77415 12.902L9.53363 12.9256ZM11.1023 11.6188L9.57911 12.8189L9.72867 13.0087L11.2519 11.8086L11.1023 11.6188ZM11.1427 11.238C11.1881 11.2834 11.2065 11.3459 11.1975 11.4182C11.1882 11.4921 11.1502 11.5697 11.0916 11.6283L11.2625 11.7992C11.357 11.7047 11.421 11.5783 11.4373 11.4481C11.4537 11.3163 11.4212 11.1748 11.3135 11.0671L11.1427 11.238ZM10.7394 11.1982C10.8194 11.1382 10.8902 11.124 10.9507 11.1321C11.0136 11.1404 11.0798 11.1751 11.1427 11.238L11.3135 11.0671C11.2234 10.977 11.111 10.9096 10.9826 10.8925C10.8518 10.8751 10.7185 10.9118 10.5944 11.0049L10.7394 11.1982ZM9.21718 12.4829L10.7449 11.1939L10.589 11.0092L9.06134 12.2982L9.21718 12.4829ZM8.13279 12.4116C8.2618 12.5406 8.44272 12.5834 8.62001 12.587C8.79891 12.5907 8.99285 12.555 9.17062 12.5072L9.1079 12.2738C8.94068 12.3188 8.77157 12.3484 8.62494 12.3454C8.47669 12.3424 8.36959 12.3066 8.30368 12.2407L8.13279 12.4116ZM7.92339 11.5336C7.90331 11.6483 7.89241 11.8116 7.91636 11.9722C7.93992 12.1302 8.00049 12.3067 8.14275 12.4205L8.29372 12.2318C8.22082 12.1735 8.17513 12.069 8.15539 11.9366C8.13604 11.8068 8.14481 11.6702 8.16144 11.5753L7.92339 11.5336ZM9.92663 9.83496L7.96528 11.4614L8.11955 11.6475L10.0809 10.021L9.92663 9.83496ZM9.96933 9.45226C10.0147 9.49766 10.0332 9.56015 10.0241 9.63241C10.0149 9.70631 9.97691 9.78394 9.91832 9.84253L10.0892 10.0134C10.1837 9.91896 10.2477 9.79254 10.2639 9.66238C10.2804 9.53058 10.2479 9.38902 10.1402 9.28138L9.96933 9.45226ZM9.56064 9.41634C9.67219 9.34198 9.86224 9.34517 9.96933 9.45226L10.1402 9.28138C9.94122 9.08238 9.62113 9.08557 9.42659 9.21526L9.56064 9.41634ZM7.56294 11.1155L9.57188 9.40787L9.41536 9.22374L7.40642 10.9313L7.56294 11.1155ZM6.59114 11.0213C6.64368 11.0913 6.71788 11.1325 6.79291 11.1565C6.86776 11.1805 6.9506 11.1898 7.03169 11.1914C7.19359 11.1947 7.37 11.1675 7.50668 11.1422L7.46268 10.9046C7.32892 10.9294 7.17263 10.9525 7.03657 10.9498C6.96868 10.9484 6.91122 10.9406 6.8666 10.9263C6.82215 10.9121 6.79767 10.8939 6.78448 10.8763L6.59114 11.0213ZM6.7358 10.1775C6.67391 10.2085 6.63361 10.2705 6.60843 10.3208C6.58041 10.3769 6.55824 10.4448 6.54382 10.517C6.51535 10.6593 6.51325 10.8377 6.57562 10.9936L6.8 10.9039C6.76035 10.8048 6.75824 10.6771 6.78079 10.5644C6.79188 10.5089 6.80797 10.4621 6.82458 10.4289C6.84404 10.39 6.85476 10.3882 6.84388 10.3937L6.7358 10.1775ZM8.86217 8.60584C8.1483 9.11575 7.43189 9.62745 6.71519 10.1906L6.86449 10.3806C7.57617 9.82143 8.28813 9.31286 9.00264 8.80249L8.86217 8.60584ZM8.8654 8.60361L8.86538 8.60363L8.99943 8.80471L8.99946 8.80469L8.8654 8.60361ZM13.2976 5.34298C11.8195 6.46435 10.3411 7.53487 8.86156 8.60628L9.0033 8.80202C10.4825 7.73084 11.963 6.65877 13.4437 5.53552L13.2976 5.34298ZM13.9828 5.31842H13.3707V5.56008H13.9828V5.31842ZM15.7079 6.57708C15.4688 6.32686 15.1724 6.01638 14.8757 5.76872C14.7272 5.64476 14.5755 5.53379 14.4277 5.45331C14.2815 5.37364 14.1294 5.31842 13.9828 5.31842V5.56008C14.0717 5.56008 14.1821 5.59472 14.3121 5.66553C14.4406 5.73554 14.5788 5.83568 14.7209 5.95424C15.0052 6.19161 15.2922 6.49178 15.5331 6.74401L15.7079 6.57708ZM15.9558 6.83322C15.8832 6.76065 15.8 6.67353 15.7079 6.57708L15.5331 6.74401C15.6247 6.83985 15.71 6.92917 15.7849 7.0041L15.9558 6.83322ZM16.0474 6.95366C16.0242 6.91886 15.9916 6.86904 15.9558 6.83322L15.7849 7.0041C15.8001 7.01929 15.8185 7.046 15.8463 7.08771L16.0474 6.95366ZM16.1088 7.03727C16.0936 7.02208 16.0752 6.99538 16.0474 6.95366L15.8463 7.08771C15.8695 7.12252 15.9021 7.17234 15.9379 7.20816L16.1088 7.03727ZM17.8398 7.22905C17.3325 7.59799 16.5822 7.51063 16.1088 7.03727L15.9379 7.20816C16.4849 7.75508 17.367 7.87178 17.982 7.42449L17.8398 7.22905ZM18.0569 5.23613C18.3034 5.75386 18.3474 6.17374 18.2833 6.50001C18.2193 6.82599 18.0454 7.06909 17.8367 7.23139L17.9851 7.42215C18.2355 7.22735 18.4442 6.93481 18.5205 6.54659C18.5967 6.15866 18.5387 5.6858 18.2751 5.13223L18.0569 5.23613ZM17.9304 5.00865C17.9682 5.08441 18.0096 5.1675 18.0654 5.25121L18.2665 5.11715C18.2203 5.04782 18.1852 4.97786 18.1465 4.90058L17.9304 5.00865ZM17.8104 4.79208C17.8566 4.86142 17.8917 4.93137 17.9304 5.00865L18.1465 4.90058C18.1086 4.82482 18.0672 4.74173 18.0114 4.65803L17.8104 4.79208ZM17.8028 4.779L17.8028 4.77909L18.019 4.67102L18.0189 4.67092L17.8028 4.779ZM17.1938 3.61168C17.3959 3.96528 17.5984 4.37019 17.8028 4.779L18.0189 4.67092C17.8153 4.26357 17.6097 3.85232 17.4036 3.49178L17.1938 3.61168ZM15.4041 2.27467C15.7234 2.44567 16.081 2.65464 16.4058 2.88629C16.7319 3.11891 17.0182 3.36962 17.2008 3.62248L17.3967 3.48098C17.1916 3.197 16.8809 2.92831 16.5461 2.68954C16.21 2.4498 15.8427 2.23541 15.5183 2.06164L15.4041 2.27467ZM16.2146 2.16149C16.0077 2.09249 15.7316 2.05431 15.4643 2.04736L15.4581 2.28894C15.7109 2.29552 15.9613 2.3318 16.1382 2.39076L16.2146 2.16149ZM17.8943 3.15995C17.5742 2.83985 17.151 2.52546 16.2202 2.16351L16.1326 2.38874C17.0384 2.74099 17.4314 3.03877 17.7234 3.33083L17.8943 3.15995ZM20.3523 3.88815C19.5808 3.87598 19.1069 3.79569 18.757 3.66922C18.4084 3.54322 18.1751 3.36902 17.8814 3.14872L17.7364 3.34206C18.0289 3.56146 18.2883 3.75677 18.6749 3.8965C19.0602 4.03576 19.5639 4.11741 20.3485 4.12979L20.3523 3.88815ZM22.1481 1.41501C22.2492 1.36447 22.3289 1.32574 22.4512 1.32574V1.08407C22.2673 1.08407 22.143 1.14737 22.04 1.19886L22.1481 1.41501ZM21.0747 1.92617L22.146 1.41603L22.0421 1.19784L20.9708 1.70798L21.0747 1.92617ZM20.7278 2.79493C20.5929 2.4352 20.7328 2.05487 21.0652 1.93022L20.9803 1.70394C20.4965 1.88537 20.3303 2.42329 20.5015 2.87978L20.7278 2.79493ZM23.7342 9.31657L20.7244 2.78678L20.5049 2.88794L23.5147 9.41774L23.7342 9.31657ZM24.3387 9.70545C24.0896 9.70545 23.868 9.53813 23.7281 9.30499L23.5209 9.42932C23.6871 9.70632 23.9756 9.94712 24.3387 9.94712V9.70545ZM24.6417 9.61618C24.5466 9.66377 24.4133 9.70545 24.3387 9.70545V9.94712C24.4681 9.94712 24.641 9.88676 24.7498 9.83233L24.6417 9.61618ZM25.7151 9.10502L24.6438 9.61516L24.7477 9.83335L25.819 9.32321L25.7151 9.10502ZM26.0301 8.80783C25.9347 8.95766 25.8586 9.06669 25.7378 9.09689L25.7964 9.33134C26.0265 9.2738 26.1505 9.06874 26.234 8.93766L26.0301 8.80783ZM26.0746 8.73897C26.0595 8.76164 26.0446 8.78516 26.0301 8.80783L26.234 8.93766C26.2487 8.91458 26.2623 8.89323 26.2757 8.87303L26.0746 8.73897ZM26.0161 8.24787C26.1019 8.41938 26.1041 8.59231 26.058 8.7767L26.2924 8.83531C26.3483 8.61158 26.3505 8.3764 26.2322 8.13979L26.0161 8.24787ZM23.0046 1.71462L26.0144 8.24441L26.2339 8.14325L23.2241 1.61345L23.0046 1.71462ZM22.4512 1.32574C22.5486 1.32574 22.6655 1.36576 22.7719 1.43854C22.878 1.5111 22.9619 1.60832 23.0022 1.70891L23.2265 1.61916C23.1647 1.46468 23.0446 1.33233 22.9084 1.2391C22.7724 1.14609 22.6088 1.08407 22.4512 1.08407V1.32574ZM14.3906 12.4083C14.407 12.4378 14.4246 12.4668 14.4434 12.495L14.6445 12.361C14.6294 12.3383 14.6152 12.315 14.6019 12.291L14.3906 12.4083ZM13.9828 12.2427C14.1753 12.2427 14.316 12.3082 14.3988 12.4211L14.5937 12.2782C14.4538 12.0875 14.2304 12.0011 13.9828 12.0011V12.2427ZM13.7134 12.302C13.8108 12.2436 13.884 12.2427 13.9828 12.2427V12.0011C13.8776 12.0011 13.7467 12.0002 13.589 12.0948L13.7134 12.302ZM13.4898 12.6009C13.5083 12.4902 13.5953 12.3729 13.7134 12.302L13.589 12.0948C13.4244 12.1936 13.284 12.3658 13.2514 12.5612L13.4898 12.6009ZM13.5732 13.0242C13.4945 12.9061 13.4915 12.7905 13.4915 12.581H13.2498C13.2498 12.7797 13.2468 12.9702 13.3721 13.1582L13.5732 13.0242ZM15.0549 15.4254L13.5755 13.0277L13.3698 13.1546L14.8492 15.5523L15.0549 15.4254ZM15.4622 15.6741C15.3897 15.6741 15.3102 15.6465 15.2342 15.5976C15.1586 15.549 15.0941 15.4841 15.0526 15.4218L14.8515 15.5559C14.912 15.6466 15.0006 15.7348 15.1035 15.8009C15.2061 15.8669 15.3306 15.9158 15.4622 15.9158V15.6741ZM15.7653 15.5848C15.6701 15.6324 15.5368 15.6741 15.4622 15.6741V15.9158C15.5916 15.9158 15.7645 15.8554 15.8733 15.801L15.7653 15.5848ZM15.9597 15.2466C15.9153 15.3798 15.8242 15.5171 15.7339 15.6075L15.9047 15.7783C16.0184 15.6646 16.1314 15.4958 16.189 15.323L15.9597 15.2466ZM15.9153 14.8797C15.9347 14.9185 15.9567 14.9829 15.9677 15.0545C15.9788 15.1268 15.977 15.1949 15.9597 15.2466L16.189 15.323C16.2228 15.2216 16.2209 15.1112 16.2065 15.0177C16.192 14.9235 16.163 14.8348 16.1314 14.7716L15.9153 14.8797ZM14.4639 12.5284L15.9205 14.8891L16.1262 14.7622L14.6696 12.4015L14.4639 12.5284ZM14.4359 12.482C14.4455 12.5013 14.4569 12.5195 14.4692 12.5363L14.6643 12.3936C14.6587 12.3861 14.6548 12.3794 14.652 12.3739L14.4359 12.482ZM15.2973 11.9366C15.2281 11.8229 15.2259 11.7097 15.2259 11.5607H14.9843C14.9843 11.7042 14.9821 11.8834 15.0908 12.0622L15.2973 11.9366ZM15.309 11.9549L15.2959 11.9344L15.0922 12.0643L15.1052 12.0848L15.309 11.9549ZM16.7894 14.3541L15.31 11.9564L15.1043 12.0833L16.5837 14.481L16.7894 14.3541ZM16.8319 14.4413C16.8198 14.4149 16.8074 14.389 16.7946 14.3635L16.5785 14.4716C16.5901 14.4948 16.6013 14.5182 16.6122 14.5419L16.8319 14.4413ZM16.8456 14.4655C16.8392 14.4528 16.8324 14.4404 16.8251 14.4285L16.619 14.5547C16.6227 14.5607 16.6262 14.567 16.6295 14.5736L16.8456 14.4655ZM17.5378 14.6231C17.2872 14.7901 16.9636 14.7014 16.8456 14.4655L16.6295 14.5736C16.8176 14.9499 17.3102 15.0653 17.6718 14.8242L17.5378 14.6231ZM17.7008 13.9104C17.8319 14.1727 17.7837 14.4591 17.5378 14.6231L17.6718 14.8242C18.038 14.58 18.0918 14.1522 17.9169 13.8023L17.7008 13.9104ZM17.6829 13.8717C17.6884 13.8847 17.6943 13.8976 17.7008 13.9104L17.9169 13.8023C17.9127 13.794 17.9089 13.7857 17.9054 13.7775L17.6829 13.8717ZM16.0351 11.2657L17.692 13.8891L17.8963 13.7601L16.2394 11.1367L16.0351 11.2657ZM15.8504 11.1953C15.9202 11.2069 15.994 11.2406 16.0612 11.295L16.2134 11.1073C16.1177 11.0298 16.006 10.9762 15.8902 10.9569L15.8504 11.1953ZM15.4782 11.2532C15.5945 11.1756 15.7112 11.1721 15.8504 11.1953L15.8902 10.9569C15.7233 10.9291 15.5339 10.9256 15.3441 11.0521L15.4782 11.2532ZM15.2197 11.599C15.2635 11.4675 15.3507 11.3382 15.4782 11.2532L15.3441 11.0521C15.1655 11.1712 15.0487 11.3479 14.9905 11.5225L15.2197 11.599ZM19.3128 12.6378L19.5432 13.0026L19.7475 12.8736L19.5171 12.5088L19.3128 12.6378ZM19.1323 12.3862C19.1892 12.4858 19.2538 12.5749 19.3252 12.6542L19.5048 12.4925C19.4452 12.4263 19.3907 12.3513 19.3421 12.2663L19.1323 12.3862ZM19.0763 12.2501C19.0875 12.3003 19.1073 12.3492 19.1367 12.3933L19.3378 12.2593C19.3263 12.242 19.3175 12.2213 19.3123 12.1979L19.0763 12.2501ZM17.7067 10.0948L19.0922 12.2885L19.2965 12.1594L17.911 9.96579L17.7067 10.0948ZM17.2987 9.84507C17.4637 9.84507 17.6221 9.92691 17.7008 10.0844L17.9169 9.97628C17.7916 9.72562 17.5418 9.6034 17.2987 9.6034V9.84507ZM17.0141 9.92293C17.0889 9.86688 17.1625 9.84507 17.2987 9.84507V9.6034C17.1288 9.6034 16.9984 9.63261 16.8691 9.7296L17.0141 9.92293ZM16.8012 10.2216C16.8445 10.0918 16.9139 9.99808 17.0141 9.92293L16.8691 9.7296C16.7294 9.83436 16.6307 9.96889 16.5719 10.1452L16.8012 10.2216ZM16.8522 10.6553C16.8012 10.5023 16.7621 10.3795 16.8038 10.2127L16.5693 10.1541C16.509 10.3953 16.5719 10.5786 16.6229 10.7317L16.8522 10.6553ZM18.6762 13.5368L16.8397 10.629L16.6354 10.758L18.4719 13.6658L18.6762 13.5368ZM19.0842 13.7866C18.9192 13.7866 18.7609 13.7047 18.6821 13.5473L18.466 13.6553C18.5913 13.906 18.8411 14.0282 19.0842 14.0282V13.7866ZM19.3873 13.6973C19.2921 13.7449 19.1589 13.7866 19.0842 13.7866V14.0282C19.2136 14.0282 19.3865 13.9679 19.4954 13.9134L19.3873 13.6973ZM19.5818 13.4101C19.541 13.5323 19.4601 13.6157 19.3559 13.7199L19.5268 13.8908C19.6266 13.7909 19.7497 13.6703 19.811 13.4865L19.5818 13.4101ZM19.5307 12.9763C19.5817 13.1293 19.6209 13.2521 19.5792 13.419L19.8136 13.4776C19.8739 13.2363 19.811 13.053 19.76 12.8999L19.5307 12.9763ZM20.1198 12.0048L18.8854 10.0504L18.6811 10.1794L19.9155 12.1339L20.1198 12.0048ZM20.3467 12.1096C20.259 12.0804 20.1682 12.0304 20.0894 11.9722L19.9458 12.1665C20.0409 12.2368 20.1541 12.3001 20.2703 12.3389L20.3467 12.1096ZM20.7294 12.0586C20.5681 12.1124 20.4551 12.1457 20.3467 12.1096L20.2703 12.3389C20.4681 12.4048 20.6611 12.3361 20.8059 12.2879L20.7294 12.0586ZM20.8774 11.3815C21.0255 11.5666 20.9645 11.8968 20.7006 12.0727L20.8347 12.2738C21.183 12.0416 21.3261 11.5555 21.0661 11.2305L20.8774 11.3815ZM19.7976 9.63502L20.8689 11.3695L21.0745 11.2425L20.0032 9.50802L19.7976 9.63502ZM19.1002 9.468C19.3507 9.30099 19.6744 9.38966 19.7923 9.62556L20.0085 9.51748C19.8204 9.14121 19.3278 9.02583 18.9662 9.26693L19.1002 9.468ZM18.8997 10.0826C18.8318 9.83768 18.9291 9.57085 19.0953 9.47108L18.971 9.26385C18.6914 9.43162 18.5767 9.82207 18.6668 10.1472L18.8997 10.0826ZM5.4125 1.08433C5.25488 1.08433 5.09122 1.14634 4.95528 1.23935C4.81901 1.33259 4.69891 1.46493 4.63712 1.61942L4.8615 1.70917C4.90174 1.60858 4.9857 1.51136 5.09175 1.4388C5.19813 1.36602 5.31505 1.326 5.4125 1.326V1.08433ZM5.82363 1.19912C5.72066 1.14763 5.59633 1.08433 5.4125 1.08433V1.326C5.53475 1.326 5.61447 1.36473 5.71556 1.41527L5.82363 1.19912ZM6.89284 1.70824L5.82154 1.1981L5.71764 1.41629L6.78894 1.92643L6.89284 1.70824ZM7.36214 2.88004C7.53333 2.42355 7.36714 1.88563 6.88332 1.70419L6.79846 1.93047C7.13087 2.05513 7.27076 2.43546 7.13586 2.79519L7.36214 2.88004ZM4.34891 9.418L7.35874 2.8882L7.13927 2.78703L4.12944 9.31683L4.34891 9.418ZM3.52498 9.94737C3.88802 9.94737 4.17659 9.70658 4.34279 9.42958L4.13556 9.30525C3.99567 9.53839 3.7741 9.70571 3.52498 9.70571V9.94737ZM3.11384 9.83259C3.22271 9.88702 3.39557 9.94737 3.52498 9.94737V9.70571C3.45033 9.70571 3.3171 9.66403 3.22192 9.61644L3.11384 9.83259ZM2.04463 9.32347L3.11593 9.83361L3.21983 9.61542L2.14853 9.10528L2.04463 9.32347ZM1.6297 8.93792C1.71319 9.069 1.83713 9.27406 2.06728 9.3316L2.12589 9.09715C2.00508 9.06695 1.92897 8.95792 1.83354 8.80809L1.6297 8.93792ZM1.58793 8.87328C1.6014 8.89349 1.615 8.91483 1.6297 8.93792L1.83354 8.80809C1.8191 8.78542 1.80412 8.7619 1.78901 8.73923L1.58793 8.87328ZM1.63141 8.14005C1.5131 8.37666 1.51531 8.61184 1.57124 8.83557L1.8057 8.77695C1.7596 8.59257 1.76181 8.41964 1.84756 8.24813L1.63141 8.14005ZM4.63958 1.61371L1.62975 8.14351L1.84922 8.24467L4.85905 1.71487L4.63958 1.61371Z",
      fill: "currentColor",
      mask: "url(#path-1-outside-1_241_9861)"
    })]
  })
};

var config$M = {
  viewBox: '0 0 19 23',
  children: /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M6.5 11L8.5 13L13 8.49999M17.5 11.5C17.5 16.4084 12.146 19.9784 10.198 21.1149C9.9766 21.244 9.8659 21.3086 9.70968 21.3421C9.58844 21.3681 9.41156 21.3681 9.29032 21.3421C9.1341 21.3086 9.0234 21.244 8.80201 21.1149C6.85396 19.9784 1.5 16.4084 1.5 11.5V6.71759C1.5 5.91808 1.5 5.51833 1.63076 5.1747C1.74627 4.87113 1.93398 4.60027 2.17766 4.38552C2.4535 4.14243 2.8278 4.00207 3.5764 3.72134L8.9382 1.71067C9.1461 1.63271 9.25005 1.59373 9.35698 1.57827C9.45184 1.56457 9.54816 1.56457 9.64302 1.57827C9.74995 1.59373 9.8539 1.63271 10.0618 1.71067L15.4236 3.72134C16.1722 4.00207 16.5465 4.14243 16.8223 4.38552C17.066 4.60027 17.2537 4.87113 17.3692 5.1747C17.5 5.51833 17.5 5.91808 17.5 6.71759V11.5Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  })
};

var config$L = {
  viewBox: '0 0 21 22',
  children: /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M8.75 2.5H5.55C3.86984 2.5 3.02976 2.5 2.38803 2.82698C1.82354 3.1146 1.3646 3.57354 1.07698 4.13803C0.75 4.77976 0.75 5.61984 0.75 7.3V15.7C0.75 17.3802 0.75 18.2202 1.07698 18.862C1.3646 19.4265 1.82354 19.8854 2.38803 20.173C3.02976 20.5 3.86984 20.5 5.55 20.5H13.95C15.6302 20.5 16.4702 20.5 17.112 20.173C17.6765 19.8854 18.1354 19.4265 18.423 18.862C18.75 18.2202 18.75 17.3802 18.75 15.7V12.5M9.75 7.5H13.75V11.5M13.25 3V1.5M17.1893 4.06066L18.25 3M18.2603 8H19.7603M0.75 12.8471C1.40194 12.9478 2.06987 13 2.75 13C7.13636 13 11.0153 10.8276 13.3697 7.5",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  })
};

var config$K = {
  viewBox: '0 0 18 19',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M9.66665 8.55444H4.66665M6.33331 11.8878H4.66665M11.3333 5.22111H4.66665M14.6666 8.13778V5.05444C14.6666 3.65431 14.6666 2.95425 14.3942 2.41947C14.1545 1.94906 13.772 1.56661 13.3016 1.32693C12.7668 1.05444 12.0668 1.05444 10.6666 1.05444H5.33331C3.93318 1.05444 3.23312 1.05444 2.69834 1.32693C2.22793 1.56661 1.84548 1.94906 1.6058 2.41947C1.33331 2.95425 1.33331 3.65431 1.33331 5.05444V13.7211C1.33331 15.1212 1.33331 15.8213 1.6058 16.3561C1.84548 16.8265 2.22793 17.2089 2.69834 17.4486C3.23312 17.7211 3.93318 17.7211 5.33331 17.7211H7.58331M16.3333 17.7211L15.0833 16.4711M15.9166 14.3878C15.9166 15.9986 14.6108 17.3044 13 17.3044C11.3891 17.3044 10.0833 15.9986 10.0833 14.3878C10.0833 12.7769 11.3891 11.4711 13 11.4711C14.6108 11.4711 15.9166 12.7769 15.9166 14.3878Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$J = {
  viewBox: '0 0 17 19',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M13.3334 9.53306C16.2765 10.1117 18.3334 11.4333 18.3334 12.971C18.3334 15.0421 14.6024 16.721 10 16.721C5.39765 16.721 1.66669 15.0421 1.66669 12.971C1.66669 11.4333 3.72351 10.1117 6.66669 9.53306M10 12.5544V5.8877M10 5.8877C11.3807 5.8877 12.5 4.76841 12.5 3.3877C12.5 2.00698 11.3807 0.887695 10 0.887695C8.61931 0.887695 7.50002 2.00698 7.50002 3.3877C7.50002 4.76841 8.61931 5.8877 10 5.8877Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$I = {
  viewBox: '0 0 14 14',
  children: /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M12.2387 3.3602C12.2416 3.35736 12.2444 3.35445 12.2473 3.35156C12.6293 2.9698 12.6293 2.35084 12.2473 1.96908C11.8653 1.58733 11.246 1.58733 10.864 1.96908C10.8611 1.97197 10.8582 1.97481 10.8554 1.97773L9.80712 3.02536C9.77711 3.05535 9.77876 3.10444 9.81055 3.13254C10.034 3.33001 10.2527 3.53556 10.4665 3.74918C10.6801 3.9627 10.8857 4.18122 11.0832 4.40439C11.1113 4.43616 11.1604 4.43781 11.1904 4.40782L12.2387 3.3602Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.33501 1.10558C1.94512 0.928806 2.04774 0.372911 2.47387 0.414303C5.28255 0.687122 8.01719 1.89847 10.1684 4.04835C12.3195 6.19823 13.5316 8.93124 13.8046 11.7382C13.846 12.1641 13.2898 12.2667 13.1129 11.877C12.0666 9.57202 10.5951 7.41264 8.6986 5.51723C6.80206 3.62183 4.6414 2.15128 2.33501 1.10558Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M0.631616 12.1963C0.628988 12.1988 0.626427 12.2015 0.623825 12.2041C0.279575 12.5481 0.31016 13.1365 0.692138 13.5182C1.07412 13.9 1.66285 13.9306 2.0071 13.5865C2.0097 13.5839 2.01233 13.5813 2.01489 13.5787L9.03888 6.55892C9.066 6.53182 9.06767 6.48839 9.04253 6.45944C8.84467 6.23161 8.63742 6.00961 8.42117 5.79349C8.20503 5.57748 7.98301 5.37047 7.75513 5.17284C7.72616 5.14772 7.68272 5.14939 7.6556 5.17649L0.631616 12.1963Z",
      fill: "currentColor"
    })]
  })
};

var config$H = {
  viewBox: '0 0 16 17',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M5.49998 7.1377L7.16665 8.80436L10.9166 5.05436M14.6666 15.8877V4.8877C14.6666 3.48756 14.6666 2.7875 14.3942 2.25272C14.1545 1.78231 13.772 1.39986 13.3016 1.16018C12.7668 0.887695 12.0668 0.887695 10.6666 0.887695H5.33331C3.93318 0.887695 3.23312 0.887695 2.69834 1.16018C2.22793 1.39986 1.84548 1.78231 1.6058 2.25272C1.33331 2.7875 1.33331 3.48756 1.33331 4.88769V15.8877L3.62498 14.221L5.70831 15.8877L7.99998 14.221L10.2916 15.8877L12.375 14.221L14.6666 15.8877Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$G = {
  viewBox: '0 0 16 20',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M2.091 2.65064V10.4584M5.79541 2.65064V4.75687M13.909 18.1248V10.3169M10.2046 18.1248V16.0262M13.9084 10.3759C13.9084 13.6177 11.263 16.2458 7.99969 16.2458C4.73641 16.2458 2.091 13.6177 2.091 10.3759C2.091 7.13398 4.73641 4.50591 7.99969 4.50591C11.263 4.50591 13.9084 7.13398 13.9084 10.3759ZM10.0509 10.3759C10.0509 11.5013 9.13254 12.4136 7.99969 12.4136C6.86684 12.4136 5.94849 11.5013 5.94849 10.3759C5.94849 9.25044 6.86684 8.33811 7.99969 8.33811C9.13254 8.33811 10.0509 9.25044 10.0509 10.3759ZM1.23096 2.64965H6.1658C6.29335 2.64965 6.39676 2.54692 6.39676 2.4202V1.61714C6.39676 1.49042 6.29335 1.3877 6.1658 1.3877H1.23096C1.1034 1.3877 1 1.49042 1 1.61714V2.4202C1 2.54692 1.1034 2.64965 1.23096 2.64965ZM14.769 18.1257H9.8342C9.70665 18.1257 9.60324 18.2285 9.60324 18.3552V19.1582C9.60324 19.285 9.70665 19.3877 9.8342 19.3877H14.769C14.8966 19.3877 15 19.285 15 19.1582V18.3552C15 18.2285 14.8966 18.1257 14.769 18.1257Z",
    stroke: "currentColor",
    strokeWidth: "1.1"
  })
};

var config$F = {
  viewBox: '0 0 20 19',
  children: /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M7.5 11.6377L6.25 6.0127C8.625 4.8252 11.375 4.8252 13.75 6.0127L12.5 11.6377",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M13.5625 7.0127C15.5625 8.2002 16.875 10.3877 16.875 12.8877V14.1377L18.125 15.3877H10H1.875L3.125 14.1377V12.8877C3.125 10.3877 4.4375 8.2002 6.4375 7.0127",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  })
};

var config$E = {
  viewBox: '0 0 20 19',
  children: /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M9.01977 0.63817C8.32718 0.71085 7.7715 0.829966 7.58023 0.880439L8.4057 3.78767C8.5869 3.74729 9.02581 3.65846 9.33184 3.62616C9.63787 3.59385 10.0768 3.6127 10.258 3.62616L10.5298 0.607886C10.315 0.587697 9.71236 0.565489 9.01977 0.63817Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M12.5938 0.964511C11.923 0.776983 11.3625 0.683075 11.1661 0.659562L10.8689 3.6676C11.0522 3.69679 11.493 3.77585 11.7894 3.85854C12.0859 3.94123 12.4872 4.12043 12.6508 4.1997L14.0093 1.49258C13.817 1.39469 13.2646 1.15204 12.5938 0.964511Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M15.8061 2.5534C15.2468 2.13737 14.7571 1.84838 14.5821 1.75589L13.2301 4.45756C13.3908 4.55066 13.7741 4.78279 14.0213 4.96648C14.2686 5.15017 14.5793 5.46163 14.7037 5.5944L16.9391 3.55487C16.7944 3.39439 16.3654 2.96942 15.8061 2.5534Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M18.2194 5.21706C17.8516 4.62409 17.502 4.17491 17.3731 4.02443L15.1259 6.03916C15.2413 6.18496 15.5127 6.54204 15.6754 6.80397C15.8381 7.06589 16.0129 7.47002 16.08 7.63935L18.9063 6.56585C18.8306 6.36332 18.5872 5.81002 18.2194 5.21706Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M19.5513 8.56874C19.4177 7.88341 19.2501 7.33895 19.183 7.15238L16.3684 8.23465C16.4246 8.41205 16.5517 8.84256 16.611 9.14537C16.6702 9.44817 16.6904 9.88823 16.6931 10.0704L19.7153 10.0743C19.7163 9.85798 19.6849 9.25406 19.5513 8.56874Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M19.5441 12.1675C19.6709 11.4809 19.7145 10.9127 19.7205 10.7145L16.7062 10.6843C16.6934 10.87 16.654 11.3172 16.5981 11.6207C16.5423 11.9241 16.3999 12.3409 16.3356 12.5113L19.1451 13.6282C19.2253 13.4274 19.4173 12.8541 19.5441 12.1675Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M18.2506 15.5169C18.6142 14.9213 18.8578 14.4066 18.9342 14.2236L16.1307 13.1127C16.0525 13.2815 15.8559 13.6849 15.6954 13.9482C15.5348 14.2114 15.253 14.5493 15.1321 14.6854L17.3562 16.7373C17.5028 16.5786 17.8869 16.1124 18.2506 15.5169Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M15.8425 18.1684C16.3912 17.7384 16.7992 17.3418 16.9346 17.1973L14.6968 15.172C14.5646 15.3026 14.2395 15.6114 13.9972 15.8016C13.7549 15.9918 13.3729 16.2093 13.2122 16.2943L14.5785 18.9974C14.7713 18.9003 15.2939 18.5985 15.8425 18.1684Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M5.63271 1.60864C6.25934 1.30404 6.79409 1.11131 6.98313 1.05302L7.81116 3.95952C7.63597 4.02106 7.21637 4.17775 6.93939 4.31218C6.6624 4.44661 6.29944 4.69478 6.15258 4.80206L4.33394 2.38163C4.50577 2.25088 5.00609 1.91324 5.63271 1.60864Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M2.75267 3.77381C3.22825 3.26372 3.65818 2.89113 3.8137 2.7686L5.62817 5.18244C5.48675 5.30301 5.15135 5.60046 4.94106 5.82574C4.73077 6.05102 4.48101 6.41342 4.38242 6.56646L1.81776 4.96324C1.93124 4.7793 2.2771 4.2839 2.75267 3.77381Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M0.858837 6.82883C1.11632 6.18002 1.38126 5.67594 1.48155 5.505L4.04852 7.08972C3.96065 7.25368 3.75642 7.65325 3.64247 7.93989C3.52852 8.22652 3.42765 8.65528 3.39146 8.83382L0.420509 8.27813C0.459335 8.06537 0.601356 7.47764 0.858837 6.82883Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M0.179383 10.3343C0.189172 9.63604 0.257415 9.07035 0.290312 8.87479L3.2521 9.43726C3.22832 9.62186 3.17964 10.0682 3.17512 10.3767C3.17061 10.6853 3.22887 11.1219 3.25856 11.3017L0.285342 11.845C0.245943 11.6324 0.169593 11.0325 0.179383 10.3343Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M0.844209 13.8908C0.598375 13.2375 0.45533 12.686 0.414537 12.492L3.37603 11.9279C3.42131 12.1085 3.53897 12.5417 3.64743 12.8304C3.75589 13.1192 3.96953 13.5041 4.06279 13.6605L1.49443 15.2578C1.38012 15.0743 1.09004 14.5441 0.844209 13.8908Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M2.70138 16.9434C2.23935 16.421 1.90959 15.9569 1.80246 15.7902L4.36863 14.2042C4.47513 14.3566 4.73913 14.7193 4.94315 14.9503C5.14718 15.1813 5.48367 15.4645 5.62641 15.5772L3.795 17.988C3.62297 17.8575 3.16341 17.4659 2.70138 16.9434Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M5.55348 19.1224C4.93548 18.8006 4.46184 18.4858 4.30227 18.3686L6.13162 15.9661C6.28551 16.0702 6.66154 16.3139 6.93454 16.4563C7.20754 16.5987 7.62287 16.7423 7.79641 16.7962L6.94765 19.7048C6.74042 19.6448 6.17148 19.4443 5.55348 19.1224Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M8.99858 20.1105C8.30589 20.0388 7.75003 19.9205 7.5587 19.8703L8.38002 16.9619C8.56127 17.002 9.00031 17.0902 9.30638 17.1221C9.61246 17.1539 10.0513 17.1345 10.2325 17.1207L10.5086 20.1386C10.2939 20.1591 9.69127 20.1822 8.99858 20.1105Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M12.5961 19.8146C11.9248 20.0002 11.3641 20.0926 11.1676 20.1155L10.8787 17.1067C11.0621 17.078 11.5031 17.0002 11.7998 16.9183C12.0965 16.8365 12.4983 16.6584 12.6621 16.5796L14.0131 19.2905C13.8205 19.3878 13.2674 19.6289 12.5961 19.8146Z",
      fill: "currentColor"
    })]
  })
};

var config$D = {
  viewBox: '0 0 18 18',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M1.5 16.8878H16.5M4 14.3878V7.72113M7.33333 14.3878V7.72113M10.6667 14.3878V7.72113M14 14.3878V7.72113M15.6667 5.22113L9.35333 1.2753C9.22515 1.19518 9.16106 1.15513 9.09233 1.13951C9.03155 1.1257 8.96845 1.1257 8.90767 1.13951C8.83894 1.15513 8.77485 1.19518 8.64667 1.2753L2.33333 5.22113H15.6667Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$C = {
  viewBox: '0 0 6 10',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M1 9L5 5L1 1",
    stroke: "#D2D6DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$B = {
  viewBox: '0 0 14 10',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M12.3334 1L5.00008 8.33333L1.66675 5",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$A = {
  viewBox: '0 0 16 16',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M8.5 9V5M6.5 7H10.5M5.16667 12V13.557C5.16667 13.9122 5.16667 14.0899 5.23949 14.1811C5.30282 14.2604 5.39885 14.3066 5.50036 14.3065C5.61708 14.3063 5.75578 14.1954 6.03317 13.9735L7.62348 12.7012C7.94834 12.4413 8.11078 12.3114 8.29166 12.219C8.45213 12.137 8.62295 12.0771 8.79948 12.0408C8.99845 12 9.20646 12 9.6225 12H11.3C12.4201 12 12.9802 12 13.408 11.782C13.7843 11.5903 14.0903 11.2843 14.282 10.908C14.5 10.4802 14.5 9.92011 14.5 8.8V5.2C14.5 4.0799 14.5 3.51984 14.282 3.09202C14.0903 2.71569 13.7843 2.40973 13.408 2.21799C12.9802 2 12.4201 2 11.3 2H5.7C4.5799 2 4.01984 2 3.59202 2.21799C3.21569 2.40973 2.90973 2.71569 2.71799 3.09202C2.5 3.51984 2.5 4.07989 2.5 5.2V9.33333C2.5 9.95331 2.5 10.2633 2.56815 10.5176C2.75308 11.2078 3.29218 11.7469 3.98236 11.9319C4.2367 12 4.54669 12 5.16667 12Z",
    stroke: "currentColor"
  })
};

var config$z = {
  viewBox: '0 0 16 16',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M9.83335 7.33333H5.83335M7.16669 9.99999H5.83335M11.1667 4.66666H5.83335M13.8334 7.99999V4.53333C13.8334 3.41322 13.8334 2.85317 13.6154 2.42535C13.4236 2.04902 13.1177 1.74306 12.7413 1.55132C12.3135 1.33333 11.7535 1.33333 10.6334 1.33333H6.36669C5.24658 1.33333 4.68653 1.33333 4.25871 1.55132C3.88238 1.74306 3.57642 2.04902 3.38467 2.42535C3.16669 2.85317 3.16669 3.41322 3.16669 4.53333V11.4667C3.16669 12.5868 3.16669 13.1468 3.38467 13.5746C3.57642 13.951 3.88238 14.2569 4.25871 14.4487C4.68653 14.6667 5.24658 14.6667 6.36669 14.6667H8.50002M11.1667 10.6667L14.5 14M14.5 10.6667L11.1667 14",
    stroke: "currentColor"
  })
};

var config$y = {
  viewBox: '0 0 16 16',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M13.8334 6.33333V4.53333C13.8334 3.41322 13.8334 2.85317 13.6154 2.42535C13.4236 2.04902 13.1177 1.74306 12.7413 1.55132C12.3135 1.33333 11.7535 1.33333 10.6334 1.33333H6.36669C5.24658 1.33333 4.68653 1.33333 4.25871 1.55132C3.88238 1.74306 3.57642 2.04902 3.38467 2.42535C3.16669 2.85317 3.16669 3.41322 3.16669 4.53333V11.4667C3.16669 12.5868 3.16669 13.1468 3.38467 13.5746C3.57642 13.951 3.88238 14.2569 4.25871 14.4487C4.68653 14.6667 5.24658 14.6667 6.36669 14.6667H9.83335M9.83335 7.33333H5.83335M7.16669 9.99999H5.83335M11.1667 4.66666H5.83335M11.5 10.0015C11.6175 9.66757 11.8493 9.386 12.1545 9.20664C12.4597 9.02729 12.8185 8.96173 13.1674 9.02157C13.5162 9.08141 13.8327 9.2628 14.0606 9.5336C14.2886 9.8044 14.4134 10.1471 14.4128 10.5011C14.4128 11.5004 12.914 12 12.914 12M12.9333 14H12.94",
    stroke: "currentColor"
  })
};

var config$x = {
  viewBox: '0 0 16 16',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M5.16667 5.66667H8.5M5.16667 8H10.5M6.95583 12H11.3C12.4201 12 12.9802 12 13.408 11.782C13.7843 11.5903 14.0903 11.2843 14.282 10.908C14.5 10.4802 14.5 9.92011 14.5 8.8V5.2C14.5 4.0799 14.5 3.51984 14.282 3.09202C14.0903 2.71569 13.7843 2.40973 13.408 2.21799C12.9802 2 12.4201 2 11.3 2H5.7C4.5799 2 4.01984 2 3.59202 2.21799C3.21569 2.40973 2.90973 2.71569 2.71799 3.09202C2.5 3.51984 2.5 4.0799 2.5 5.2V13.557C2.5 13.9122 2.5 14.0899 2.57282 14.1811C2.63615 14.2604 2.73218 14.3066 2.83369 14.3065C2.95042 14.3063 3.08911 14.1954 3.3665 13.9735L4.95681 12.7012C5.28168 12.4413 5.44411 12.3114 5.62499 12.219C5.78547 12.137 5.95628 12.0771 6.13281 12.0408C6.33178 12 6.5398 12 6.95583 12Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$w = {
  viewBox: '0 0 17 16',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M10.6815 3.01422V5.42817C10.6815 5.75547 10.6815 5.91912 10.7459 6.04414C10.8026 6.1541 10.893 6.24351 11.0042 6.29954C11.1306 6.36323 11.2961 6.36323 11.6271 6.36323H14.0682M11.8635 9.28527H7.13556M11.8635 11.6229H7.13556M8.31755 6.94761H7.13556M4.77158 13.1424C3.77862 13.1424 4.12028 13.1424 3.74101 12.9513C3.40741 12.7832 3.13617 12.515 2.96619 12.1851C2.77295 11.8101 2.77295 11.3191 2.77295 10.3372V4.2593C2.77295 3.27739 2.77295 2.78643 2.96619 2.41139C3.13617 2.0815 3.40741 1.81328 3.74101 1.64519C4.12028 1.4541 5.4549 1.4541 6.44786 1.4541H8.55395C9.54691 1.4541 10.0434 1.4541 10.4227 1.64519C10.7563 1.81328 11.0275 2.0815 11.1975 2.41139C11.2922 2.59518 11.3405 2.80681 11.3651 3.09041V3.34991M10.6815 2.8567H7.60836C6.61539 2.8567 6.11891 2.8567 5.73965 3.04779C5.40604 3.21588 5.13481 3.48409 4.96483 3.81399C4.77158 4.18903 4.77158 4.67998 4.77158 5.66189V11.7398C4.77158 12.7217 4.77158 13.2127 4.96483 13.5877C5.13481 13.9176 5.40604 14.1858 5.73965 14.3539C6.11891 14.545 6.61539 14.545 7.60836 14.545H11.3907C12.3837 14.545 12.8802 14.545 13.2594 14.3539C13.593 14.1858 13.8643 13.9176 14.0343 13.5877C14.2275 13.2127 14.2275 12.7217 14.2275 11.7398V6.36319L10.6815 2.8567Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$v = {
  viewBox: '0 0 16 16',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M15.1668 14V12.6667C15.1668 11.4241 14.317 10.38 13.1668 10.084M10.8335 2.19384C11.8108 2.58943 12.5002 3.54754 12.5002 4.66667C12.5002 5.78579 11.8108 6.7439 10.8335 7.13949M11.8335 14C11.8335 12.7575 11.8335 12.1362 11.6305 11.6462C11.3599 10.9928 10.8407 10.4736 10.1873 10.203C9.69726 10 9.07601 10 7.8335 10H5.8335C4.59099 10 3.96973 10 3.47967 10.203C2.82627 10.4736 2.30713 10.9928 2.03648 11.6462C1.8335 12.1362 1.8335 12.7575 1.8335 14M9.50016 4.66667C9.50016 6.13943 8.30625 7.33333 6.8335 7.33333C5.36074 7.33333 4.16683 6.13943 4.16683 4.66667C4.16683 3.19391 5.36074 2 6.8335 2C8.30625 2 9.50016 3.19391 9.50016 4.66667Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$u = {
  viewBox: '0 0 14 17',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M1.16669 4.88769C1.16669 3.48756 1.16669 2.7875 1.43917 2.25272C1.67885 1.78231 2.06131 1.39986 2.53171 1.16018C3.06649 0.887695 3.76656 0.887695 5.16669 0.887695H8.83335C10.2335 0.887695 10.9336 0.887695 11.4683 1.16018C11.9387 1.39986 12.3212 1.78231 12.5609 2.25272C12.8334 2.7875 12.8334 3.48756 12.8334 4.8877V15.8877L7.00002 12.5544L1.16669 15.8877V4.88769Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$t = {
  viewBox: '0 0 20 16',
  children: /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M16.6665 6.30452V4.38786C16.6665 3.45444 16.6665 2.98773 16.4848 2.63121C16.3251 2.31761 16.0701 2.06264 15.7565 1.90285C15.4 1.72119 14.9333 1.72119 13.9998 1.72119H4.33317C3.39975 1.72119 2.93304 1.72119 2.57652 1.90285C2.26292 2.06264 2.00795 2.3176 1.84816 2.63121C1.6665 2.98773 1.6665 3.45444 1.6665 4.38786V12.3879C1.6665 13.3213 1.6665 13.788 1.84816 14.1445C2.00795 14.4581 2.26292 14.7131 2.57652 14.8729C2.93304 15.0545 3.39975 15.0545 4.33317 15.0545L13.9998 15.0545C14.9333 15.0545 15.4 15.0545 15.7565 14.8729C16.0701 14.7131 16.3251 14.4581 16.4848 14.1445C16.6665 13.788 16.6665 13.3213 16.6665 12.3879V10.4712M12.4998 8.38786C12.4998 8.00065 12.4998 7.80704 12.5319 7.64604C12.6634 6.98489 13.1802 6.46806 13.8414 6.33655C14.0024 6.30452 14.196 6.30452 14.5832 6.30453H16.2498C16.637 6.30453 16.8307 6.30452 16.9917 6.33655C17.6528 6.46806 18.1696 6.98489 18.3011 7.64604C18.3332 7.80704 18.3332 8.00065 18.3332 8.38786C18.3332 8.77507 18.3332 8.96868 18.3011 9.12968C18.1696 9.79083 17.6528 10.3077 16.9917 10.4392C16.8307 10.4712 16.637 10.4712 16.2498 10.4712H14.5832C14.196 10.4712 14.0024 10.4712 13.8414 10.4392C13.1802 10.3077 12.6634 9.79083 12.5319 9.12967C12.4998 8.96868 12.4998 8.77507 12.4998 8.38786Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  })
};

var config$s = {
  viewBox: '0 0 16 17',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M16.5 15.8877L11.5001 10.8877M13.1667 6.72103C13.1667 9.94269 10.555 12.5544 7.33333 12.5544C4.11167 12.5544 1.5 9.94269 1.5 6.72103C1.5 3.49937 4.11167 0.887695 7.33333 0.887695C10.555 0.887695 13.1667 3.49937 13.1667 6.72103Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$r = {
  viewBox: '0 0 9 10',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M1.1665 8.33329L7.83317 1.66663M7.83317 1.66663H1.1665M7.83317 1.66663V8.33329",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$q = {
  viewBox: '0 0 20 19',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M5.7652 2.20891C7.0062 1.47524 8.45394 1.0542 10 1.0542C14.6024 1.0542 18.3334 4.78516 18.3334 9.38753C18.3334 9.41514 18.3332 9.44272 18.333 9.47027M2.81764 5.15907C2.08629 6.39866 1.66669 7.84409 1.66669 9.38753C1.66669 13.2705 4.32246 16.5332 7.91669 17.4583M17.2564 13.488C16.156 15.431 14.2978 16.8884 12.0834 17.4583M11.7411 4.69901C11.1989 4.49759 10.6123 4.38753 10 4.38753C7.2386 4.38753 5.00002 6.62611 5.00002 9.38753C5.00002 10.0032 5.11128 10.5928 5.31479 11.1374M14.6876 7.64392C14.8896 8.18681 15 8.77428 15 9.38753C15 12.149 12.7614 14.3875 10 14.3875C9.3918 14.3875 8.80895 14.2789 8.2698 14.0801M10 7.72087V11.0542",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$p = {
  viewBox: '0 0 13 14',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M11.5835 6.24095H1.0835M8.66683 1.57428V3.90761M4.00016 1.57428V3.90761M3.8835 13.2409H8.7835C9.76359 13.2409 10.2536 13.2409 10.628 13.0502C10.9573 12.8824 11.225 12.6147 11.3928 12.2854C11.5835 11.9111 11.5835 11.421 11.5835 10.4409V5.54095C11.5835 4.56085 11.5835 4.07081 11.3928 3.69646C11.225 3.36718 10.9573 3.09946 10.628 2.93168C10.2536 2.74095 9.76359 2.74095 8.7835 2.74095H3.8835C2.9034 2.74095 2.41336 2.74095 2.03901 2.93168C1.70973 3.09946 1.44201 3.36718 1.27423 3.69646C1.0835 4.07081 1.0835 4.56085 1.0835 5.54095V10.4409C1.0835 11.421 1.0835 11.9111 1.27423 12.2854C1.44201 12.6147 1.70973 12.8824 2.03901 13.0502C2.41336 13.2409 2.9034 13.2409 3.8835 13.2409Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$o = {
  viewBox: '0 0 16 17',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M4.66699 11.5661L11.3337 4.89941M11.3337 4.89941H4.66699M11.3337 4.89941V11.5661",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$n = {
  viewBox: '0 0 16 19',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M9.66671 1.27905V4.72117C9.66671 5.18788 9.66671 5.42123 9.75754 5.59949C9.83743 5.7563 9.96491 5.88378 10.1217 5.96367C10.3 6.0545 10.5333 6.0545 11 6.0545H14.4422M11.3334 10.2211H4.66671M11.3334 13.5544H4.66671M6.33337 6.88778H4.66671M9.66671 1.05444H5.33337C3.93324 1.05444 3.23318 1.05444 2.6984 1.32693C2.22799 1.56661 1.84554 1.94906 1.60586 2.41947C1.33337 2.95425 1.33337 3.65431 1.33337 5.05444V13.7211C1.33337 15.1212 1.33337 15.8213 1.60586 16.3561C1.84554 16.8265 2.22799 17.2089 2.6984 17.4486C3.23318 17.7211 3.93324 17.7211 5.33337 17.7211H10.6667C12.0668 17.7211 12.7669 17.7211 13.3017 17.4486C13.7721 17.2089 14.1545 16.8265 14.3942 16.3561C14.6667 15.8213 14.6667 15.1212 14.6667 13.7211V6.05444L9.66671 1.05444Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$m = {
  viewBox: '0 0 20 20',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M6.25033 6.22103H8.54199M6.25033 9.55436H8.54199M6.25033 12.8877H8.54199M11.4587 6.22103H13.7503M11.4587 9.55436H13.7503M11.4587 12.8877H13.7503M16.667 17.8877V5.55436C16.667 4.62094 16.667 4.15423 16.4853 3.79771C16.3255 3.48411 16.0706 3.22914 15.757 3.06935C15.4005 2.8877 14.9337 2.8877 14.0003 2.8877H6.00033C5.0669 2.8877 4.60019 2.8877 4.24367 3.06935C3.93007 3.22914 3.6751 3.48411 3.51531 3.79771C3.33366 4.15423 3.33366 4.62094 3.33366 5.55436V17.8877M18.3337 17.8877H1.66699",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$l = {
  viewBox: '0 0 20 20',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M16.6667 5.83333V5.66667C16.6667 4.26654 16.6667 3.56647 16.3942 3.03169C16.1545 2.56129 15.7721 2.17884 15.3017 1.93915C14.7669 1.66667 14.0668 1.66667 12.6667 1.66667H7.33337C5.93324 1.66667 5.23318 1.66667 4.6984 1.93915C4.22799 2.17884 3.84554 2.56129 3.60586 3.03169C3.33337 3.56647 3.33337 4.26654 3.33337 5.66667V14.3333C3.33337 15.7335 3.33337 16.4335 3.60586 16.9683C3.84554 17.4387 4.22799 17.8212 4.6984 18.0609C5.23318 18.3333 5.93324 18.3333 7.33337 18.3333H10.4167M15 15V10.4167C15 9.72631 15.5597 9.16667 16.25 9.16667C16.9404 9.16667 17.5 9.72631 17.5 10.4167V15C17.5 16.3807 16.3808 17.5 15 17.5C13.6193 17.5 12.5 16.3807 12.5 15V11.6667",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$k = {
  viewBox: '0 0 12 12',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M1.3335 6.00004H10.6668M10.6668 6.00004L6.00016 1.33337M10.6668 6.00004L6.00016 10.6667",
    stroke: "#D2D6DB",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$j = {
  viewBox: '0 0 16 19',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M9.66634 8.5542H4.66634M6.33301 11.8875H4.66634M11.333 5.22087H4.66634M14.6663 5.0542V13.7209C14.6663 15.121 14.6663 15.8211 14.3939 16.3558C14.1542 16.8262 13.7717 17.2087 13.3013 17.4484C12.7665 17.7209 12.0665 17.7209 10.6663 17.7209H5.33301C3.93288 17.7209 3.23281 17.7209 2.69803 17.4484C2.22763 17.2087 1.84517 16.8262 1.60549 16.3558C1.33301 15.8211 1.33301 15.121 1.33301 13.7209V5.0542C1.33301 3.65407 1.33301 2.954 1.60549 2.41922C1.84517 1.94882 2.22763 1.56637 2.69803 1.32668C3.23281 1.0542 3.93288 1.0542 5.33301 1.0542H10.6663C12.0665 1.0542 12.7665 1.0542 13.3013 1.32668C13.7717 1.56637 14.1542 1.94882 14.3939 2.41922C14.6663 2.954 14.6663 3.65407 14.6663 5.0542Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$i = {
  viewBox: '0 0 45 45',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M26.4212 12.6042H37.5845C38.4698 12.6042 38.9124 12.6042 39.1713 12.7903C39.3971 12.9527 39.5442 13.2026 39.5765 13.479C39.6135 13.7956 39.3985 14.1826 38.9686 14.9564L36.3044 19.7519C36.1485 20.0325 36.0706 20.1729 36.04 20.3215C36.0129 20.453 36.0129 20.5887 36.04 20.7202C36.0706 20.8688 36.1485 21.0091 36.3044 21.2898L38.9686 26.0852C39.3985 26.8591 39.6135 27.246 39.5765 27.5627C39.5442 27.839 39.3971 28.089 39.1713 28.2514C38.9124 28.4375 38.4698 28.4375 37.5845 28.4375H23.6504C22.542 28.4375 21.9877 28.4375 21.5644 28.2218C21.192 28.032 20.8892 27.7293 20.6994 27.3569C20.4837 26.9335 20.4837 26.3793 20.4837 25.2708V20.5208M13.5566 40.3125L5.63997 8.64583M8.60881 20.5208H23.2546C24.363 20.5208 24.9172 20.5208 25.3406 20.3051C25.713 20.1154 26.0158 19.8126 26.2055 19.4402C26.4212 19.0168 26.4212 18.4626 26.4212 17.3542V7.85417C26.4212 6.74573 26.4212 6.19151 26.2055 5.76814C26.0158 5.39574 25.713 5.09297 25.3406 4.90322C24.9172 4.6875 24.363 4.6875 23.2546 4.6875H8.70615C7.32366 4.6875 6.63242 4.6875 6.15963 4.97396C5.74525 5.22502 5.43736 5.61936 5.2943 6.08226C5.13107 6.61041 5.29873 7.28102 5.63404 8.62223L8.60881 20.5208Z",
    stroke: "currentColor",
    strokeWidth: "3.38",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$h = {
  viewBox: '0 0 45 45',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M30 15V9.375L35.625 3.75L37.5 7.5L41.25 9.375L35.625 15H30ZM30 15L22.5 22.4999M41.2501 22.5C41.2501 32.8553 32.8554 41.25 22.5001 41.25C12.1447 41.25 3.75006 32.8553 3.75006 22.5C3.75006 12.1447 12.1447 3.75 22.5001 3.75M31.8751 22.5C31.8751 27.6777 27.6777 31.875 22.5001 31.875C17.3224 31.875 13.1251 27.6777 13.1251 22.5C13.1251 17.3223 17.3224 13.125 22.5001 13.125",
    stroke: "currentColor",
    strokeWidth: "3.38",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$g = {
  viewBox: '0 0 16 22',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M3.96668 13.7219L3 21L7.5884 18.247C7.73805 18.1572 7.81288 18.1123 7.89276 18.0947C7.96341 18.0792 8.03659 18.0792 8.10724 18.0947C8.18712 18.1123 8.26195 18.1572 8.4116 18.247L13 21L12.0343 13.7212M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$f = {
  viewBox: '0 0 24 24',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M7.10102 10H7V8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V10H16.899M12 14V16M19 15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15C5 11.134 8.13401 8 12 8C15.866 8 19 11.134 19 15Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$e = {
  viewBox: '0 0 24 24',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M17 8.99994C17 8.48812 16.8047 7.9763 16.4142 7.58579C16.0237 7.19526 15.5118 7 15 7M15 15C18.3137 15 21 12.3137 21 9C21 5.68629 18.3137 3 15 3C11.6863 3 9 5.68629 9 9C9 9.27368 9.01832 9.54308 9.05381 9.80704C9.11218 10.2412 9.14136 10.4583 9.12172 10.5956C9.10125 10.7387 9.0752 10.8157 9.00469 10.9419C8.937 11.063 8.81771 11.1823 8.57913 11.4209L3.46863 16.5314C3.29568 16.7043 3.2092 16.7908 3.14736 16.8917C3.09253 16.9812 3.05213 17.0787 3.02763 17.1808C3 17.2959 3 17.4182 3 17.6627V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H7V19H9V17H11L12.5791 15.4209C12.8177 15.1823 12.937 15.063 13.0581 14.9953C13.1843 14.9248 13.2613 14.8987 13.4044 14.8783C13.5417 14.8586 13.7588 14.8878 14.193 14.9462C14.4569 14.9817 14.7263 15 15 15Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$d = {
  viewBox: '0 0 17 16',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M12.5 6.66668L9.83331 4.00001M2.16663 14.3333L4.42287 14.0826C4.69853 14.052 4.83636 14.0367 4.96519 13.995C5.07949 13.958 5.18826 13.9057 5.28855 13.8396C5.4016 13.765 5.49966 13.667 5.69578 13.4709L14.5 4.66668C15.2364 3.9303 15.2364 2.73639 14.5 2.00001C13.7636 1.26363 12.5697 1.26363 11.8333 2.00001L3.02911 10.8042C2.83299 11.0003 2.73493 11.0984 2.66038 11.2114C2.59425 11.3117 2.54197 11.4205 2.50497 11.5348C2.46326 11.6636 2.44795 11.8014 2.41732 12.0771L2.16663 14.3333Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$c = {
  viewBox: '0 0 26 26',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M8.48612 7.37796H3.15152V15.6671M3.15152 15.6671H4.05948C4.80059 15.6671 5.52034 15.9154 6.10382 16.3723L11.326 20.462C11.7339 20.7814 12.3041 20.7915 12.7231 20.4868V20.4868C13.2994 20.0677 13.3649 19.2328 12.861 18.7289L10.62 16.4878L14.104 19.9022C14.4631 20.2541 15.0221 20.3002 15.4341 20.0119V20.0119C15.935 19.6612 16.029 18.9572 15.6375 18.4874L13.4924 15.9133L16.3268 19.263C16.7573 19.7717 17.5169 19.8396 18.0306 19.4151V19.4151C18.5574 18.98 18.6227 18.1965 18.1752 17.6801L15.7904 14.9285L18.6608 18.1903C19.0766 18.6628 19.7888 18.7289 20.2845 18.341V18.341C20.8274 17.9161 20.8957 17.1199 20.4332 16.6087L19.7298 15.8312M3.15152 15.6671V7.29589C3.15152 7.02393 2.93105 6.80347 2.6591 6.80347H1.67425C1.40229 6.80347 1.18182 7.02393 1.18182 7.29589V15.6671C1.18182 15.9391 1.40229 16.1595 1.67425 16.1595H2.6591C2.93105 16.1595 3.15152 15.9391 3.15152 15.6671ZM11.2355 8.8142L12.2271 8.06294C12.4318 7.90787 12.7213 7.93614 12.8922 8.12789L20.3857 16.539C20.5319 16.703 20.769 16.7504 20.967 16.6551L22.5697 15.8834C22.7401 15.8014 22.8485 15.6289 22.8485 15.4397V7.73167C22.8485 7.5203 22.7136 7.33251 22.5133 7.26502L16.1396 5.28149C15.5822 5.09369 14.998 4.99791 14.4099 4.99791H13.6645C12.4876 4.99791 11.3428 5.21705 10.4031 5.92563L7.25903 8.29658C7.07659 8.43416 7.11386 8.71814 7.32562 8.80399L8.3069 9.20181C9.2832 9.59761 10.3958 9.45036 11.2355 8.8142ZM23.3409 16.1595H24.3258C24.5977 16.1595 24.8182 15.9391 24.8182 15.6671V7.29589C24.8182 7.02393 24.5977 6.80347 24.3258 6.80347H23.3409C23.069 6.80347 22.8485 7.02393 22.8485 7.29589V15.6671C22.8485 15.9391 23.069 16.1595 23.3409 16.1595Z",
    stroke: "currentColor",
    strokeWidth: "1.18182",
    strokeLinejoin: "round"
  })
};

var config$b = {
  viewBox: '0 0 18 17',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M14.6666 12.5544H1.33331M1.33331 12.5544L4.66665 9.22103M1.33331 12.5544L4.66665 15.8877M1.33331 4.22103H14.6666M14.6666 4.22103L11.3333 0.887695M14.6666 4.22103L11.3333 7.55436",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$a = {
  viewBox: '0 0 7 7',
  children: /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M6.10415 1.43572C6.10557 1.43433 6.10695 1.43292 6.10836 1.43151C6.2944 1.24558 6.2944 0.944115 6.10836 0.758181C5.92231 0.572247 5.62067 0.572247 5.43463 0.758181C5.43322 0.759586 5.4318 0.760971 5.43041 0.762389L4.91986 1.27264C4.90525 1.28724 4.90605 1.31115 4.92153 1.32484C5.03035 1.42101 5.1369 1.52113 5.24101 1.62517C5.34506 1.72916 5.44518 1.8356 5.54137 1.94429C5.55507 1.95976 5.57899 1.96056 5.5936 1.94596L6.10415 1.43572Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.27959 0.337752C1.08969 0.251655 1.13967 -0.0190912 1.34722 0.00106847C2.71518 0.133944 4.04708 0.723927 5.09479 1.77102C6.14251 2.81811 6.73285 4.14921 6.8658 5.51636C6.88597 5.72378 6.61507 5.77373 6.52892 5.58395C6.01931 4.4613 5.30266 3.40958 4.37895 2.48643C3.45525 1.56328 2.40291 0.847055 1.27959 0.337752Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M0.450551 5.73945C0.449271 5.7407 0.448024 5.74198 0.446757 5.74324C0.279091 5.91081 0.293987 6.19738 0.480028 6.38331C0.66607 6.56924 0.952808 6.58412 1.12047 6.41656C1.12174 6.41529 1.12302 6.41404 1.12427 6.41277L4.54528 2.9938C4.55849 2.9806 4.5593 2.95945 4.54706 2.94535C4.45069 2.83438 4.34975 2.72626 4.24443 2.621C4.13916 2.51579 4.03102 2.41497 3.92003 2.31871C3.90592 2.30647 3.88476 2.30729 3.87156 2.32049L0.450551 5.73945Z",
      fill: "currentColor"
    })]
  })
};

var config$9 = {
  viewBox: '0 0 12 12',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.99642C12 9.145 9.57186 11.7268 6.48492 11.9735C6.31006 11.9901 6.13391 11.999 5.95697 12H0.00327066V6.1963C0.00109587 6.12994 0 6.06331 0 5.99642C0 2.68469 2.68629 0 6 0C9.31371 0 12 2.68469 12 5.99642ZM2.21594 6.25106C2.16328 6.16773 2.13695 6.12606 2.12221 6.0618C2.11114 6.01353 2.11114 5.9374 2.12221 5.88913C2.13695 5.82486 2.16328 5.78319 2.21594 5.69986C2.6511 5.01124 3.9464 3.27039 5.92035 3.27039C7.8943 3.27039 9.1896 5.01124 9.62476 5.69986C9.67742 5.78319 9.70375 5.82486 9.71849 5.88913C9.72956 5.9374 9.72956 6.01353 9.71849 6.0618C9.70375 6.12607 9.67742 6.16773 9.62476 6.25106C9.1896 6.93969 7.8943 8.68054 5.92035 8.68054C3.9464 8.68054 2.6511 6.93969 2.21594 6.25106L2.21594 6.25106ZM5.94149 4.55719C5.17739 4.55719 4.55797 5.17624 4.55797 5.93989C4.55797 6.70353 5.17739 7.32258 5.94149 7.32258C6.70559 7.32258 7.32502 6.70353 7.32502 5.93989C7.32502 5.17624 6.70559 4.55719 5.94149 4.55719ZM5.19641 5.94016C5.19641 5.52896 5.52994 5.19563 5.94138 5.19563C6.35282 5.19563 6.68636 5.52896 6.68636 5.94016C6.68636 6.35135 6.35282 6.68468 5.94138 6.68468C5.52994 6.68468 5.19641 6.35135 5.19641 5.94016Z",
    fill: "currentColor"
  })
};

var config$8 = {
  viewBox: '0 0 25 26',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0001 12.5C25.0001 19.0635 19.9415 24.4454 13.5104 24.9598C13.1461 24.9944 12.7791 25.0129 12.4105 25.0149H0.00693594V12.9167C0.00240514 12.7783 0.00012207 12.6394 0.00012207 12.5C0.00012207 5.59644 5.59656 0 12.5001 0C19.4037 0 25.0001 5.59644 25.0001 12.5ZM19.6881 9.69561V9.6646C19.6881 9.05459 19.6882 8.55158 19.6547 8.14193C19.6199 7.71659 19.5454 7.32628 19.3587 6.95986C19.0689 6.39113 18.6065 5.92874 18.0378 5.63895C17.6714 5.45226 17.2811 5.37772 16.8557 5.34297C16.4461 5.3095 15.9431 5.3095 15.3331 5.30951L15.302 5.30951L8.93886 5.30951H8.90784H8.90782C8.29782 5.3095 7.79482 5.3095 7.38517 5.34297C6.95983 5.37772 6.56952 5.45226 6.20311 5.63895C5.63438 5.92874 5.17198 6.39113 4.8822 6.95986C4.6955 7.32628 4.62096 7.71659 4.58621 8.14193C4.55274 8.55157 4.55275 9.05454 4.55276 9.66452V9.66458V9.69561V16.0588V16.0898V16.0899C4.55275 16.6999 4.55274 17.2028 4.58621 17.6125C4.62096 18.0378 4.6955 18.4281 4.8822 18.7945C5.17198 19.3633 5.63437 19.8257 6.20311 20.1154C6.56952 20.3021 6.95983 20.3767 7.38517 20.4114C7.79482 20.4449 8.29782 20.4449 8.90782 20.4449H8.93886H15.302H15.3331H15.3332C15.9431 20.4449 16.4461 20.4449 16.8557 20.4114C17.2811 20.3767 17.6714 20.3021 18.0378 20.1154C18.6065 19.8257 19.0689 19.3633 19.3587 18.7945C19.5454 18.4281 19.6199 18.0378 19.6547 17.6125C19.6882 17.2028 19.6881 16.6998 19.6881 16.0898L19.6881 16.0588L19.6881 9.69561ZM18.0222 7.64085C18.0832 7.76056 18.1325 7.9315 18.1597 8.26407C18.1875 8.6054 18.1881 9.04686 18.1881 9.69561L18.1881 16.0588C18.1881 16.7075 18.1875 17.149 18.1597 17.4903C18.1325 17.8229 18.0832 17.9938 18.0222 18.1136C17.8762 18.4 17.6433 18.633 17.3568 18.7789C17.2371 18.8399 17.0661 18.8892 16.7336 18.9164C16.3922 18.9443 15.9508 18.9449 15.302 18.9449H8.93886C8.2901 18.9449 7.84865 18.9443 7.50732 18.9164C7.17474 18.8892 7.00381 18.8399 6.88409 18.7789C6.5976 18.633 6.36468 18.4 6.21871 18.1136C6.15771 17.9938 6.1084 17.8229 6.08123 17.4903C6.05334 17.149 6.05276 16.7075 6.05276 16.0588V9.69561C6.05276 9.04686 6.05334 8.6054 6.08123 8.26407C6.1084 7.9315 6.15771 7.76056 6.21871 7.64085C6.36468 7.35436 6.5976 7.12144 6.88409 6.97546C7.00381 6.91447 7.17474 6.86516 7.50732 6.83799C7.84865 6.8101 8.2901 6.80951 8.93886 6.80951L15.302 6.80951C15.9508 6.80951 16.3922 6.8101 16.7336 6.83799C17.0661 6.86516 17.2371 6.91447 17.3568 6.97546C17.6433 7.12144 17.8762 7.35436 18.0222 7.64085ZM16.7414 9.31692C17.0343 9.02403 17.0343 8.54915 16.7414 8.25626C16.4485 7.96337 15.9736 7.96337 15.6807 8.25626L13.6907 10.2463C13.2313 9.97149 12.6939 9.81354 12.1197 9.81354C11.5454 9.81354 11.0081 9.97149 10.5487 10.2463L8.55862 8.25626C8.26573 7.96337 7.79085 7.96337 7.49796 8.25626C7.20507 8.54915 7.20507 9.02403 7.49796 9.31692L9.48802 11.307C9.2132 11.7664 9.05525 12.3037 9.05525 12.878C9.05525 13.4518 9.21298 13.9888 9.48745 14.448L7.49796 16.4375C7.20506 16.7304 7.20506 17.2053 7.49796 17.4981C7.79085 17.791 8.26573 17.791 8.55862 17.4981L10.5477 15.509C11.0073 15.7842 11.545 15.9424 12.1197 15.9424C12.6943 15.9424 13.232 15.7842 13.6916 15.5091L15.6807 17.4981C15.9736 17.791 16.4485 17.791 16.7414 17.4981C17.0343 17.2053 17.0343 16.7304 16.7414 16.4375L14.7519 14.448C15.0264 13.9888 15.1841 13.4518 15.1841 12.878C15.1841 12.3037 15.0262 11.7664 14.7513 11.307L16.7414 9.31692ZM12.1197 11.3135C12.9837 11.3135 13.6841 12.014 13.6841 12.878C13.6841 13.742 12.9837 14.4424 12.1197 14.4424C11.2557 14.4424 10.5552 13.742 10.5552 12.878C10.5552 12.014 11.2557 11.3135 12.1197 11.3135Z",
    fill: "currentColor"
  })
};

var config$7 = {
  viewBox: '0 0 12 12',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.99642C12 9.145 9.57186 11.7268 6.48492 11.9735C6.31005 11.9901 6.13391 11.999 5.95697 12H0.00327066V6.1963C0.00109587 6.12994 0 6.06331 0 5.99642C0 2.68469 2.68629 0 6 0C9.31371 0 12 2.68469 12 5.99642ZM2.53892 6.00508C2.53892 5.32696 3.08864 4.77724 3.76676 4.77724C4.10884 4.77724 4.378 4.9181 4.63911 5.17194C4.8917 5.41749 5.11119 5.74234 5.36318 6.11529L5.42951 6.21337C5.95869 6.99458 6.64534 7.97547 7.97232 7.97547H7.99825L8.00179 7.97498C9.07728 7.9604 9.94463 7.08403 9.94463 6.00508C9.94463 4.91704 9.0626 4.035 7.97455 4.035C7.17407 4.035 6.48589 4.51239 6.17766 5.19642C6.09346 5.38328 6.17668 5.60303 6.36355 5.68723C6.55042 5.77143 6.77016 5.68821 6.85437 5.50134C7.04706 5.07371 7.47658 4.77724 7.97455 4.77724C8.65267 4.77724 9.2024 5.32696 9.2024 6.00508C9.2024 6.6832 8.65267 7.23293 7.97455 7.23293H7.94862L7.94754 7.23308C7.0741 7.22169 6.5929 6.60738 6.04403 5.79711L5.97128 5.68938C5.73011 5.33168 5.46732 4.94192 5.15649 4.63975C4.80076 4.29392 4.35572 4.035 3.76676 4.035C2.67872 4.035 1.79668 4.91704 1.79668 6.00508C1.79668 7.09313 2.67872 7.97516 3.76676 7.97516C4.15271 7.97516 4.51378 7.8638 4.81828 7.67132C4.99153 7.5618 5.04319 7.33257 4.93367 7.15932C4.82415 6.98607 4.59492 6.93441 4.42168 7.04393C4.23236 7.16361 4.00822 7.23293 3.76676 7.23293C3.08864 7.23293 2.53892 6.6832 2.53892 6.00508ZM5.52004 6.89488L5.52135 6.89395C5.57905 6.85264 5.59234 6.77237 5.55103 6.71467C5.50973 6.65696 5.42946 6.64367 5.37176 6.68498L5.37045 6.68592L5.25855 6.76602C5.22888 6.78726 5.22345 6.82912 5.24562 6.85811C5.25796 6.87425 5.27009 6.89065 5.28201 6.90729C5.29391 6.92392 5.30551 6.94067 5.3168 6.95755C5.3371 6.98787 5.37847 6.99622 5.40815 6.97498L5.52004 6.89488ZM4.22231 6.3704C4.15577 6.3619 4.13518 6.451 4.19395 6.48336C4.49004 6.64642 4.74647 6.8679 4.94647 7.14727C5.14646 7.42664 5.27346 7.74078 5.33237 8.07363C5.34406 8.13969 5.43504 8.14892 5.44844 8.08319C5.53251 7.67084 5.46955 7.26471 5.23673 6.93948C5.00391 6.61426 4.63976 6.42374 4.22231 6.3704Z",
    fill: "currentColor"
  })
};

var config$6 = {
  viewBox: '0 0 12 14',
  children: /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M6 7.625C7.03553 7.625 7.875 6.78553 7.875 5.75C7.875 4.71447 7.03553 3.875 6 3.875C4.96447 3.875 4.125 4.71447 4.125 5.75C4.125 6.78553 4.96447 7.625 6 7.625Z",
      stroke: "currentColor",
      strokeWidth: "1.1",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M6 13.25C8.5 10.75 11 8.51142 11 5.75C11 2.98858 8.76142 0.75 6 0.75C3.23858 0.75 1 2.98858 1 5.75C1 8.51142 3.5 10.75 6 13.25Z",
      stroke: "currentColor",
      strokeWidth: "1.1",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  })
};

var config$5 = {
  viewBox: '0 0 16 16',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M3 9.25001L3.98415 13.1866C4.01183 13.2973 4.02567 13.3527 4.04204 13.401C4.20198 13.8732 4.6272 14.2052 5.12408 14.2458C5.17494 14.25 5.232 14.25 5.34612 14.25C5.48903 14.25 5.56048 14.25 5.62067 14.2442C6.21562 14.1865 6.68646 13.7156 6.74416 13.1207C6.75 13.0605 6.75 12.989 6.75 12.8461V3.93751M12.0625 8.93751C13.2706 8.93751 14.25 7.95813 14.25 6.75001C14.25 5.54188 13.2706 4.56251 12.0625 4.56251M6.90625 3.93751H4.5625C3.0092 3.93751 1.75 5.19671 1.75 6.75001C1.75 8.30331 3.0092 9.56251 4.5625 9.56251H6.90625C8.01027 9.56251 9.36078 10.1543 10.4027 10.7223C11.0105 11.0536 11.3144 11.2193 11.5135 11.1949C11.6981 11.1723 11.8376 11.0894 11.9458 10.9382C12.0625 10.7751 12.0625 10.4488 12.0625 9.79608V3.70393C12.0625 3.05125 12.0625 2.72491 11.9458 2.56181C11.8376 2.41057 11.6981 2.32769 11.5135 2.30509C11.3144 2.28071 11.0105 2.44638 10.4027 2.77773C9.36078 3.3457 8.01027 3.93751 6.90625 3.93751Z",
    stroke: "currentColor",
    strokeWidth: "1.1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$4 = {
  viewBox: '0 0 16 13',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M5.49349 3.09782H2.53125V8.8514M2.53125 8.8514H3.00366C3.43116 8.8514 3.84165 9.01888 4.14715 9.31793L6.96782 12.0791C7.2403 12.3459 7.6735 12.3539 7.95564 12.0974V12.0974C8.23679 11.8418 8.27089 11.4117 8.03353 11.115L6.67839 9.42106L8.54249 11.7046C8.7691 11.9822 9.18068 12.0167 9.45037 11.7807V11.7807C9.68963 11.5714 9.73665 11.2171 9.56031 10.9526L8.27344 9.0223L9.77212 11.2363C10.0333 11.6221 10.5832 11.6701 10.9073 11.3354V11.3354C11.1511 11.0836 11.1829 10.6946 10.9832 10.4066L9.54948 8.33871L11.0677 10.4953C11.323 10.8579 11.8424 10.9056 12.1594 10.5954V10.5954C12.4142 10.3462 12.4481 9.94786 12.2391 9.65907L11.737 8.96533M2.53125 8.8514V3.04085C2.53125 2.85208 2.40883 2.69906 2.25781 2.69906H1.71094C1.55992 2.69906 1.4375 2.85208 1.4375 3.04085V8.8514C1.4375 9.04017 1.55992 9.1932 1.71094 9.1932H2.25781C2.40883 9.1932 2.53125 9.04017 2.53125 8.8514ZM7.02018 4.09473L7.57084 3.57327C7.68451 3.46563 7.84526 3.48525 7.94012 3.61835L12.1012 9.45657C12.1823 9.57045 12.314 9.60333 12.424 9.53717L13.3139 9.00154C13.4086 8.94458 13.4688 8.82489 13.4688 8.69358V3.34333C13.4688 3.19662 13.3938 3.06627 13.2826 3.01942L9.74336 1.64263C9.43388 1.51228 9.10949 1.4458 8.78291 1.4458H8.36896C7.71546 1.4458 7.07975 1.59791 6.55798 2.08974L4.81211 3.73544C4.7108 3.83093 4.73149 4.02805 4.84908 4.08764L5.39397 4.36377C5.9361 4.6385 6.55389 4.53629 7.02018 4.09473ZM13.7422 9.1932H14.2891C14.4401 9.1932 14.5625 9.04017 14.5625 8.8514V3.04085C14.5625 2.85208 14.4401 2.69906 14.2891 2.69906H13.7422C13.5912 2.69906 13.4688 2.85208 13.4688 3.04085V8.8514C13.4688 9.04017 13.5912 9.1932 13.7422 9.1932Z",
    stroke: "currentColor",
    strokeWidth: "1.1",
    strokeLinejoin: "round"
  })
};

var config$3 = {
  viewBox: '0 0 16 16',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M6.59375 13.4686L7.51436 13.9801C7.69161 14.0785 7.78024 14.1278 7.87409 14.1471C7.95716 14.1642 8.04284 14.1642 8.12591 14.1471C8.21977 14.1278 8.30839 14.0785 8.48564 13.9801L9.40625 13.4686M3.78125 11.9061L2.88936 11.4106C2.70216 11.3066 2.60855 11.2546 2.5404 11.1807C2.4801 11.1152 2.43447 11.0377 2.40655 10.9532C2.375 10.8577 2.375 10.7506 2.375 10.5365V9.56237M2.375 6.43737V5.46327C2.375 5.24912 2.375 5.14205 2.40655 5.04655C2.43447 4.96206 2.4801 4.88451 2.5404 4.81908C2.60855 4.74512 2.70216 4.69312 2.88936 4.58912L3.78125 4.09362M6.59375 2.53112L7.51436 2.01967C7.69161 1.9212 7.78024 1.87196 7.87409 1.85266C7.95716 1.83557 8.04284 1.83557 8.12591 1.85266C8.21977 1.87196 8.30839 1.9212 8.48564 2.01967L9.40625 2.53112M12.2188 4.09362L13.1106 4.58912C13.2978 4.69312 13.3914 4.74512 13.4596 4.81908C13.5199 4.88451 13.5655 4.96206 13.5934 5.04655C13.625 5.14205 13.625 5.24912 13.625 5.46327V6.43737M13.625 9.56237V10.5365C13.625 10.7506 13.625 10.8577 13.5934 10.9532C13.5655 11.0377 13.5199 11.1152 13.4596 11.1807C13.3914 11.2546 13.2978 11.3066 13.1106 11.4106L12.2188 11.9061M6.59375 7.21862L8 7.99987M8 7.99987L9.40625 7.21862M8 7.99987V9.56237M2.375 4.87487L3.78125 5.65612M12.2188 5.65612L13.625 4.87487M8 12.6874V14.2499",
    stroke: "currentColor",
    strokeWidth: "1.1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$2 = {
  viewBox: '0 0 16 16',
  children: /*#__PURE__*/jsxRuntime.jsx("path", {
    d: "M7.375 3.3125H11.9375C12.6376 3.3125 12.9876 3.3125 13.255 3.44874C13.4902 3.56858 13.6814 3.75981 13.8013 3.99501C13.9375 4.2624 13.9375 4.61243 13.9375 5.3125V6.125C13.9375 6.70743 13.9375 6.99864 13.8423 7.22835C13.7155 7.53464 13.4721 7.77798 13.1659 7.90485C12.9361 8 12.6449 8 12.0625 8M8.625 12.6875H4.0625C3.36243 12.6875 3.0124 12.6875 2.74501 12.5513C2.50981 12.4314 2.31858 12.2402 2.19874 12.005C2.0625 11.7376 2.0625 11.3876 2.0625 10.6875V9.875C2.0625 9.29257 2.0625 9.00136 2.15765 8.77165C2.28452 8.46536 2.52786 8.22202 2.83415 8.09515C3.06386 8 3.35507 8 3.9375 8M6.9375 9.5625H9.0625C9.23752 9.5625 9.32502 9.5625 9.39187 9.52844C9.45067 9.49848 9.49848 9.45067 9.52844 9.39187C9.5625 9.32502 9.5625 9.23752 9.5625 9.0625V6.9375C9.5625 6.76248 9.5625 6.67498 9.52844 6.60813C9.49848 6.54933 9.45067 6.50152 9.39187 6.47156C9.32502 6.4375 9.23752 6.4375 9.0625 6.4375H6.9375C6.76248 6.4375 6.67498 6.4375 6.60813 6.47156C6.54933 6.50152 6.50152 6.54933 6.47156 6.60813C6.4375 6.67498 6.4375 6.76248 6.4375 6.9375V9.0625C6.4375 9.23752 6.4375 9.32502 6.47156 9.39187C6.50152 9.45067 6.54933 9.49848 6.60813 9.52844C6.67498 9.5625 6.76248 9.5625 6.9375 9.5625ZM11.625 14.25H13.75C13.925 14.25 14.0125 14.25 14.0794 14.2159C14.1382 14.186 14.186 14.1382 14.2159 14.0794C14.25 14.0125 14.25 13.925 14.25 13.75V11.625C14.25 11.45 14.25 11.3625 14.2159 11.2956C14.186 11.2368 14.1382 11.189 14.0794 11.1591C14.0125 11.125 13.925 11.125 13.75 11.125H11.625C11.45 11.125 11.3625 11.125 11.2956 11.1591C11.2368 11.189 11.189 11.2368 11.1591 11.2956C11.125 11.3625 11.125 11.45 11.125 11.625V13.75C11.125 13.925 11.125 14.0125 11.1591 14.0794C11.189 14.1382 11.2368 14.186 11.2956 14.2159C11.3625 14.25 11.45 14.25 11.625 14.25ZM2.25 4.875H4.375C4.55002 4.875 4.63752 4.875 4.70437 4.84094C4.76317 4.81098 4.81098 4.76317 4.84094 4.70437C4.875 4.63752 4.875 4.55002 4.875 4.375V2.25C4.875 2.07498 4.875 1.98748 4.84094 1.92063C4.81098 1.86183 4.76317 1.81402 4.70437 1.78406C4.63752 1.75 4.55002 1.75 4.375 1.75H2.25C2.07498 1.75 1.98748 1.75 1.92063 1.78406C1.86183 1.81402 1.81402 1.86183 1.78406 1.92063C1.75 1.98748 1.75 2.07498 1.75 2.25V4.375C1.75 4.55002 1.75 4.63752 1.78406 4.70437C1.81402 4.76317 1.86183 4.81098 1.92063 4.84094C1.98748 4.875 2.07498 4.875 2.25 4.875Z",
    stroke: "currentColor",
    strokeWidth: "1.1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
};

var config$1 = {
  Right: config$k,
  ApplicationForm: config$n,
  Alert: config$1j,
  Enter: config$1G,
  NavToggle: config$1r,
  Close: config$1w,
  CloseCircle: config$1v,
  Filters: config$1s,
  Monitor: config$1u,
  SupplyChain: config$1t,
  BrokeUp: config$1p,
  Filter: config$1o,
  PmeIcon: config$1n,
  CaddIcon: config$1m,
  Delete: config$1l,
  Edit: config$1k,
  Publish: config$1i,
  Globe: config$1h,
  RedDelete: config$1g,
  BlueAdd: config$1f,
  Warning: config$1c,
  More: config$1d,
  Search: config$1b,
  Event: config$1a,
  Source: config$19,
  DashboardDashboard: config$18,
  DashboardDocuments: config$17,
  DashboardEvents: config$16,
  DashboardLocations: config$15,
  DashboardOwnOrg: config$14,
  DashboardStakeholder: config$13,
  DashboardWallet: config$12,
  Discord: config$11,
  Twitter: config$_,
  Youtube: config$10,
  Linkedin: config$$,
  MoreCustom: config$Z,
  Settings: config$Y,
  CheckDone: config$X,
  NotificationText: config$S,
  AdminIcon: config$T,
  LogOut: config$1x,
  Subjects: config$W,
  Users: config$V,
  TifDashboard: config$R,
  DDSystems: config$K,
  MineSites: config$J,
  ProductionReports: config$H,
  Equipment: config$G,
  MineOperators: config$F,
  ESGPerformance: config$E,
  KYC: config$D,
  ChevronRight: config$C,
  Check: config$B,
  TifLegacyRegistered: config$Q,
  TifManagers: config$P,
  TifMercuryFocus: config$O,
  TifPartnerSince: config$N,
  TifSafety: config$M,
  TifStrongGrowth: config$L,
  AddComment: config$A,
  NotApplicable: config$y,
  NotAvailable: config$z,
  Comment: config$x,
  Versions: config$w,
  Sources: config$v,
  Programs: config$u,
  Query: config$s,
  DataStore: config$t,
  View: config$r,
  TifAmp: config$q,
  Calendar: config$p,
  InformationChannels: config$b,
  MineProfile: config$j,
  OwnershipKYC: config$m,
  LinkedSubjects: config$l,
  Link: config$1y,
  MineSite: config$I,
  ArrowUpRight: config$o,
  Add: config$1e,
  LinkNewTab: config$1q,
  ClipboardCheck: config$1A,
  Share: config$1z,
  UsersCheck: config$U,
  Flag05: config$i,
  Award01: config$g,
  Target04: config$h,
  Handshake: config$c,
  Lock04: config$f,
  Key01: config$e,
  PMESmallLogo: config$a,
  TazamaSmallLogo: config$9,
  TifSmallLogo: config$7,
  DatastakeSmallLogo: config$1B,
  DataFlow: config$1C,
  CorrectiveAction: config$1D,
  Pencil: config$d,
  ProjectLocation: config$6,
  ProjectEvents: config$5,
  ProjectNetwork: config$4,
  ProjectStakeholders: config$3,
  ProjectDueDilligence: config$2,
  Annotation: config$1E,
  Placeholder: config$1F,
  SBGSmallLogo: config$8
};

var _excluded$7 = ["width", "height", "name", "fill"];
var CustomIcon = function CustomIcon(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 14 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 6 : _ref$height,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? '' : _ref$name,
    _ref$fill = _ref.fill,
    fill = _ref$fill === void 0 ? 'none' : _ref$fill,
    props = _objectWithoutProperties$1(_ref, _excluded$7);
  var conf = config$1[name];
  if (conf) {
    return /*#__PURE__*/jsxRuntime.jsx("svg", _objectSpread2$1(_objectSpread2$1({}, props), {}, {
      viewBox: conf.viewBox,
      fill: fill,
      xmlns: "http://www.w3.org/2000/svg",
      width: width,
      height: height,
      children: conf.children
    }));
  }
  return null;
};
CustomIcon.propTypes = {
  width: PropTypes__default["default"].number,
  height: PropTypes__default["default"].number,
  fill: PropTypes__default["default"].any,
  name: PropTypes__default["default"].string
};

var Timeframe = function Timeframe(_ref) {
  var value = _ref.value,
    _ref$onChange = _ref.onChange,
    _onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function (s) {
      return s;
    } : _ref$t;
  var getValue = function getValue() {
    if (value && _typeof$1(value) === 'object') {
      var _startDate = value.startDate,
        _endDate = value.endDate;
      var _start = typeof _startDate === 'string' ? dayjs__default["default"](_startDate) : _startDate;
      var _end = typeof _endDate === 'string' ? dayjs__default["default"](_endDate) : _endDate;
      return {
        startDate: _start,
        endDate: _end
      };
    }
    return {};
  };
  var _getValue = getValue(),
    startDate = _getValue.startDate,
    endDate = _getValue.endDate;
  return /*#__PURE__*/jsxRuntime.jsx(antd.DatePicker.RangePicker, {
    value: [startDate, endDate],
    className: "w-100",
    separator: /*#__PURE__*/jsxRuntime.jsx(CustomIcon, {
      name: "Right",
      width: 10,
      height: 10,
      color: "#D2D6DB"
    }),
    placeholder: [t('Start Date'), t('End Date')],
    disabled: disabled,
    format: "DD MM YYYY",
    onChange: function onChange(val) {
      if (val) {
        var _val = _slicedToArray$1(val, 2),
          _startDate2 = _val[0],
          _endDate2 = _val[1];
        _onChange({
          startDate: _startDate2,
          endDate: _endDate2
        });
      } else {
        _onChange({});
      }
    }
  });
};
Timeframe.propTypes = {
  t: PropTypes__default["default"].func,
  value: PropTypes__default["default"].string,
  disabled: PropTypes__default["default"].bool,
  onChange: PropTypes__default["default"].object
};

var global$1 = (typeof global !== "undefined" ? global :
  typeof self !== "undefined" ? self :
  typeof window !== "undefined" ? window : {});

function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

// utils is a library of generic helper functions non-specific to axios

const {toString: toString$1} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = toString$1.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
};

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray: isArray$1} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer$1(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
};

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray$1(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : global$1)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray$1(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  };

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
};

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
};

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
};

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
};

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
};


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray$1(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
};

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
};

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
};

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    if (reducer(descriptor, name, obj) !== false) {
      reducedDescriptors[name] = descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
};

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
};

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  };

  isArray$1(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
};

const noop$1 = () => {};

const toFiniteNumber = (value, defaultValue) => {
  value = +value;
  return Number.isFinite(value) ? value : defaultValue;
};

const ALPHA = 'abcdefghijklmnopqrstuvwxyz';

const DIGIT = '0123456789';

const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
};

const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {length} = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length|0];
  }

  return str;
};

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray$1(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  };

  return visit(obj, 0);
};

const isAsyncFn = kindOfTest('AsyncFunction');

const isThenable = (thing) =>
  thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);

var utils = {
  isArray: isArray$1,
  isArrayBuffer,
  isBuffer: isBuffer$1,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop: noop$1,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable
};

var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var inited = false;
function init () {
  inited = true;
  var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
  for (var i = 0, len = code.length; i < len; ++i) {
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
  }

  revLookup['-'.charCodeAt(0)] = 62;
  revLookup['_'.charCodeAt(0)] = 63;
}

function toByteArray (b64) {
  if (!inited) {
    init();
  }
  var i, j, l, tmp, placeHolders, arr;
  var len = b64.length;

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  placeHolders = b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;

  // base64 is 4/3 + up to two characters of the original data
  arr = new Arr(len * 3 / 4 - placeHolders);

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len;

  var L = 0;

  for (i = 0, j = 0; i < l; i += 4, j += 3) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)];
    arr[L++] = (tmp >> 16) & 0xFF;
    arr[L++] = (tmp >> 8) & 0xFF;
    arr[L++] = tmp & 0xFF;
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4);
    arr[L++] = tmp & 0xFF;
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2);
    arr[L++] = (tmp >> 8) & 0xFF;
    arr[L++] = tmp & 0xFF;
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp;
  var output = [];
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2]);
    output.push(tripletToBase64(tmp));
  }
  return output.join('')
}

function fromByteArray (uint8) {
  if (!inited) {
    init();
  }
  var tmp;
  var len = uint8.length;
  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
  var output = '';
  var parts = [];
  var maxChunkLength = 16383; // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)));
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1];
    output += lookup[tmp >> 2];
    output += lookup[(tmp << 4) & 0x3F];
    output += '==';
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1]);
    output += lookup[tmp >> 10];
    output += lookup[(tmp >> 4) & 0x3F];
    output += lookup[(tmp << 2) & 0x3F];
    output += '=';
  }

  parts.push(output);

  return parts.join('')
}

function read (buffer, offset, isLE, mLen, nBytes) {
  var e, m;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = -7;
  var i = isLE ? (nBytes - 1) : 0;
  var d = isLE ? -1 : 1;
  var s = buffer[offset + i];

  i += d;

  e = s & ((1 << (-nBits)) - 1);
  s >>= (-nBits);
  nBits += eLen;
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1);
  e >>= (-nBits);
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen);
    e = e - eBias;
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

function write (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0);
  var i = isLE ? 0 : (nBytes - 1);
  var d = isLE ? 1 : -1;
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;

  value = Math.abs(value);

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0;
    e = eMax;
  } else {
    e = Math.floor(Math.log(value) / Math.LN2);
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * Math.pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }

    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
      e = 0;
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m;
  eLen += mLen;
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128;
}

var toString = {}.toString;

var isArray = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */

var INSPECT_MAX_BYTES = 50;

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global$1.TYPED_ARRAY_SUPPORT !== undefined
  ? global$1.TYPED_ARRAY_SUPPORT
  : true;

/*
 * Export kMaxLength after typed array support is determined.
 */
kMaxLength();

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length);
    that.__proto__ = Buffer.prototype;
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length);
    }
    that.length = length;
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192; // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype;
  return arr
};

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
};

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype;
  Buffer.__proto__ = Uint8Array;
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size);
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
};

function allocUnsafe (that, size) {
  assertSize(size);
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0;
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
};

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8';
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0;
  that = createBuffer(that, length);

  var actual = that.write(string, encoding);

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0;
  that = createBuffer(that, length);
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255;
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength; // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array);
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset);
  } else {
    array = new Uint8Array(array, byteOffset, length);
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array;
    that.__proto__ = Buffer.prototype;
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
  }
  return that
}

function fromObject (that, obj) {
  if (internalIsBuffer(obj)) {
    var len = checked(obj.length) | 0;
    that = createBuffer(that, len);

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len);
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}
Buffer.isBuffer = isBuffer;
function internalIsBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!internalIsBuffer(a) || !internalIsBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
};

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
};

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i;
  if (length === undefined) {
    length = 0;
    for (i = 0; i < list.length; ++i) {
      length += list[i].length;
    }
  }

  var buffer = Buffer.allocUnsafe(length);
  var pos = 0;
  for (i = 0; i < list.length; ++i) {
    var buf = list[i];
    if (!internalIsBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos);
    pos += buf.length;
  }
  return buffer
};

function byteLength (string, encoding) {
  if (internalIsBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string;
  }

  var len = string.length;
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
}
Buffer.byteLength = byteLength;

function slowToString (encoding, start, end) {
  var loweredCase = false;

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0;
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length;
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0;
  start >>>= 0;

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8';

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase();
        loweredCase = true;
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true;

function swap (b, n, m) {
  var i = b[n];
  b[n] = b[m];
  b[m] = i;
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length;
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1);
  }
  return this
};

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length;
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3);
    swap(this, i + 1, i + 2);
  }
  return this
};

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length;
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7);
    swap(this, i + 1, i + 6);
    swap(this, i + 2, i + 5);
    swap(this, i + 3, i + 4);
  }
  return this
};

Buffer.prototype.toString = function toString () {
  var length = this.length | 0;
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
};

Buffer.prototype.equals = function equals (b) {
  if (!internalIsBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
};

Buffer.prototype.inspect = function inspect () {
  var str = '';
  var max = INSPECT_MAX_BYTES;
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
    if (this.length > max) str += ' ... ';
  }
  return '<Buffer ' + str + '>'
};

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!internalIsBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0;
  }
  if (end === undefined) {
    end = target ? target.length : 0;
  }
  if (thisStart === undefined) {
    thisStart = 0;
  }
  if (thisEnd === undefined) {
    thisEnd = this.length;
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0;
  end >>>= 0;
  thisStart >>>= 0;
  thisEnd >>>= 0;

  if (this === target) return 0

  var x = thisEnd - thisStart;
  var y = end - start;
  var len = Math.min(x, y);

  var thisCopy = this.slice(thisStart, thisEnd);
  var targetCopy = target.slice(start, end);

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i];
      y = targetCopy[i];
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
};

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset;
    byteOffset = 0;
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff;
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000;
  }
  byteOffset = +byteOffset;  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1);
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1;
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0;
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding);
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (internalIsBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF; // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1;
  var arrLength = arr.length;
  var valLength = val.length;

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase();
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2;
      arrLength /= 2;
      valLength /= 2;
      byteOffset /= 2;
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i;
  if (dir) {
    var foundIndex = -1;
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i;
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex;
        foundIndex = -1;
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
    for (i = byteOffset; i >= 0; i--) {
      var found = true;
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false;
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
};

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
};

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
};

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0;
  var remaining = buf.length - offset;
  if (!length) {
    length = remaining;
  } else {
    length = Number(length);
    if (length > remaining) {
      length = remaining;
    }
  }

  // must be an even number of digits
  var strLen = string.length;
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2;
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16);
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed;
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8';
    length = this.length;
    offset = 0;
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset;
    length = this.length;
    offset = 0;
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0;
    if (isFinite(length)) {
      length = length | 0;
      if (encoding === undefined) encoding = 'utf8';
    } else {
      encoding = length;
      length = undefined;
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset;
  if (length === undefined || length > remaining) length = remaining;

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8';

  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
};

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
};

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return fromByteArray(buf)
  } else {
    return fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end);
  var res = [];

  var i = start;
  while (i < end) {
    var firstByte = buf[i];
    var codePoint = null;
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1;

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint;

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte;
          }
          break
        case 2:
          secondByte = buf[i + 1];
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F);
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint;
            }
          }
          break
        case 3:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F);
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint;
            }
          }
          break
        case 4:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          fourthByte = buf[i + 3];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F);
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint;
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD;
      bytesPerSequence = 1;
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000;
      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
      codePoint = 0xDC00 | codePoint & 0x3FF;
    }

    res.push(codePoint);
    i += bytesPerSequence;
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length;
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = '';
  var i = 0;
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    );
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F);
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i]);
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length;

  if (!start || start < 0) start = 0;
  if (!end || end < 0 || end > len) end = len;

  var out = '';
  for (var i = start; i < end; ++i) {
    out += toHex$1(buf[i]);
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end);
  var res = '';
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length;
  start = ~~start;
  end = end === undefined ? len : ~~end;

  if (start < 0) {
    start += len;
    if (start < 0) start = 0;
  } else if (start > len) {
    start = len;
  }

  if (end < 0) {
    end += len;
    if (end < 0) end = 0;
  } else if (end > len) {
    end = len;
  }

  if (end < start) end = start;

  var newBuf;
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end);
    newBuf.__proto__ = Buffer.prototype;
  } else {
    var sliceLen = end - start;
    newBuf = new Buffer(sliceLen, undefined);
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start];
    }
  }

  return newBuf
};

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }

  return val
};

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length);
  }

  var val = this[offset + --byteLength];
  var mul = 1;
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul;
  }

  return val
};

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length);
  return this[offset]
};

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] | (this[offset + 1] << 8)
};

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  return (this[offset] << 8) | this[offset + 1]
};

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
};

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
};

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }
  mul *= 0x80;

  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

  return val
};

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var i = byteLength;
  var mul = 1;
  var val = this[offset + --i];
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul;
  }
  mul *= 0x80;

  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

  return val
};

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length);
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
};

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset] | (this[offset + 1] << 8);
  return (val & 0x8000) ? val | 0xFFFF0000 : val
};

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset + 1] | (this[offset] << 8);
  return (val & 0x8000) ? val | 0xFFFF0000 : val
};

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
};

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
};

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);
  return read(this, offset, true, 23, 4)
};

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);
  return read(this, offset, false, 23, 4)
};

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length);
  return read(this, offset, true, 52, 8)
};

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length);
  return read(this, offset, false, 52, 8)
};

function checkInt (buf, value, offset, ext, max, min) {
  if (!internalIsBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }

  var mul = 1;
  var i = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF;
  }

  return offset + byteLength
};

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }

  var i = byteLength - 1;
  var mul = 1;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF;
  }

  return offset + byteLength
};

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
  this[offset] = (value & 0xff);
  return offset + 1
};

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1;
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8;
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff);
    this[offset + 1] = (value >>> 8);
  } else {
    objectWriteUInt16(this, value, offset, true);
  }
  return offset + 2
};

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8);
    this[offset + 1] = (value & 0xff);
  } else {
    objectWriteUInt16(this, value, offset, false);
  }
  return offset + 2
};

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1;
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff;
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24);
    this[offset + 2] = (value >>> 16);
    this[offset + 1] = (value >>> 8);
    this[offset] = (value & 0xff);
  } else {
    objectWriteUInt32(this, value, offset, true);
  }
  return offset + 4
};

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24);
    this[offset + 1] = (value >>> 16);
    this[offset + 2] = (value >>> 8);
    this[offset + 3] = (value & 0xff);
  } else {
    objectWriteUInt32(this, value, offset, false);
  }
  return offset + 4
};

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);

    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }

  var i = 0;
  var mul = 1;
  var sub = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
  }

  return offset + byteLength
};

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);

    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }

  var i = byteLength - 1;
  var mul = 1;
  var sub = 0;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
  }

  return offset + byteLength
};

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
  if (value < 0) value = 0xff + value + 1;
  this[offset] = (value & 0xff);
  return offset + 1
};

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff);
    this[offset + 1] = (value >>> 8);
  } else {
    objectWriteUInt16(this, value, offset, true);
  }
  return offset + 2
};

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8);
    this[offset + 1] = (value & 0xff);
  } else {
    objectWriteUInt16(this, value, offset, false);
  }
  return offset + 2
};

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff);
    this[offset + 1] = (value >>> 8);
    this[offset + 2] = (value >>> 16);
    this[offset + 3] = (value >>> 24);
  } else {
    objectWriteUInt32(this, value, offset, true);
  }
  return offset + 4
};

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (value < 0) value = 0xffffffff + value + 1;
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24);
    this[offset + 1] = (value >>> 16);
    this[offset + 2] = (value >>> 8);
    this[offset + 3] = (value & 0xff);
  } else {
    objectWriteUInt32(this, value, offset, false);
  }
  return offset + 4
};

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4);
  }
  write(buf, value, offset, littleEndian, 23, 4);
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
};

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
};

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8);
  }
  write(buf, value, offset, littleEndian, 52, 8);
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
};

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
};

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0;
  if (!end && end !== 0) end = this.length;
  if (targetStart >= target.length) targetStart = target.length;
  if (!targetStart) targetStart = 0;
  if (end > 0 && end < start) end = start;

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length;
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start;
  }

  var len = end - start;
  var i;

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start];
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start];
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    );
  }

  return len
};

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start;
      start = 0;
      end = this.length;
    } else if (typeof end === 'string') {
      encoding = end;
      end = this.length;
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0);
      if (code < 256) {
        val = code;
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255;
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0;
  end = end === undefined ? this.length : end >>> 0;

  if (!val) val = 0;

  var i;
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val;
    }
  } else {
    var bytes = internalIsBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString());
    var len = bytes.length;
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len];
    }
  }

  return this
};

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '');
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '=';
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex$1 (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity;
  var codePoint;
  var length = string.length;
  var leadSurrogate = null;
  var bytes = [];

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i);

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue
        }

        // valid lead
        leadSurrogate = codePoint;

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        leadSurrogate = codePoint;
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    }

    leadSurrogate = null;

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint);
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      );
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      );
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      );
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo;
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i);
    hi = c >> 8;
    lo = c % 256;
    byteArray.push(lo);
    byteArray.push(hi);
  }

  return byteArray
}


function base64ToBytes (str) {
  return toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i];
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}


// the following is from is-buffer, also by Feross Aboukhadijeh and with same lisence
// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
function isBuffer(obj) {
  return obj != null && (!!obj._isBuffer || isFastBuffer(obj) || isSlowBuffer(obj))
}

function isFastBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isFastBuffer(obj.slice(0, 0))
}

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

const prototype$1 = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype$1, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(prototype$1);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

// eslint-disable-next-line strict
var httpAdapter = null;

/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return utils.isPlainObject(thing) || utils.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return utils.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return utils.isArray(arr) && !arr.some(isVisitable);
}

const predicates = utils.toFlatObject(utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!utils.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils.isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && utils.isSpecCompliantForm(formData);

  if (!utils.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils.isBlob(value)) {
      throw new AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils.isArray(value) && isFlatArray(value)) ||
        ((utils.isFileList(value) || utils.endsWith(key, '[]')) && (arr = utils.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(utils.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (utils.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils.forEach(value, function each(el, key) {
      const result = !(utils.isUndefined(el) || el === null) && visitor.call(
        formData, el, utils.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode$1(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && toFormData(params, this, options);
}

const prototype = AxiosURLSearchParams.prototype;

prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode$1);
  } : encode$1;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || encode;

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils.isURLSearchParams(params) ?
      params.toString() :
      new AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

var InterceptorManager$1 = InterceptorManager;

var transitionalDefaults = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};

var URLSearchParams$1 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : AxiosURLSearchParams;

var FormData$1 = typeof FormData !== 'undefined' ? FormData : null;

var Blob$1 = typeof Blob !== 'undefined' ? Blob : null;

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const isStandardBrowserEnv = (() => {
  let product;
  if (typeof navigator !== 'undefined' && (
    (product = navigator.product) === 'ReactNative' ||
    product === 'NativeScript' ||
    product === 'NS')
  ) {
    return false;
  }

  return typeof window !== 'undefined' && typeof document !== 'undefined';
})();

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
 const isStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();


var platform$1 = {
  isBrowser: true,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  isStandardBrowserEnv,
  isStandardBrowserWebWorkerEnv,
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
};

function toURLEncodedForm(data, options) {
  return toFormData(data, new platform$1.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform$1.isNode && utils.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];
    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
    const obj = {};

    utils.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

const DEFAULT_CONTENT_TYPE = {
  'Content-Type': undefined
};

/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: transitionalDefaults,

  adapter: ['xhr', 'http'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils.isObject(data);

    if (isObjectPayload && utils.isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = utils.isFormData(data);

    if (isFormData) {
      if (!hasJSONContentType) {
        return data;
      }
      return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
    }

    if (utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (data && utils.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform$1.classes.FormData,
    Blob: platform$1.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

var defaults$1 = defaults;

// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils.toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
var parseHeaders = rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};

const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils.isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!utils.isString(value)) return;

  if (utils.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = utils.toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = utils.findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      utils.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (utils.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite);
    } else if(utils.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (utils.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (utils.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = utils.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (utils.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    utils.forEach(this, (value, header) => {
      const key = utils.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    utils.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils.isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

utils.freezeMethods(AxiosHeaders.prototype);
utils.freezeMethods(AxiosHeaders);

var AxiosHeaders$1 = AxiosHeaders;

/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || defaults$1;
  const context = response || config;
  const headers = AxiosHeaders$1.from(context.headers);
  let data = context.data;

  utils.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}

var cookies = platform$1.isStandardBrowserEnv ?

// Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        const cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

// Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })();

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

var isURLSameOrigin = platform$1.isStandardBrowserEnv ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      let href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
          urlParsingNode.pathname :
          '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      const parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
          parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })();

function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

function progressEventReducer(listener, isDownloadStream) {
  let bytesNotified = 0;
  const _speedometer = speedometer(50, 250);

  return e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e
    };

    data[isDownloadStream ? 'download' : 'upload'] = true;

    listener(data);
  };
}

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

var xhrAdapter = isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    let requestData = config.data;
    const requestHeaders = AxiosHeaders$1.from(config.headers).normalize();
    const responseType = config.responseType;
    let onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData)) {
      if (platform$1.isStandardBrowserEnv || platform$1.isStandardBrowserWebWorkerEnv) {
        requestHeaders.setContentType(false); // Let the browser set it
      } else {
        requestHeaders.setContentType('multipart/form-data;', false); // mobile/desktop app frameworks
      }
    }

    let request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      const username = config.auth.username || '';
      const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.set('Authorization', 'Basic ' + btoa(username + ':' + password));
    }

    const fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = AxiosHeaders$1.from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (platform$1.isStandardBrowserEnv) {
      // Add xsrf header
      const xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath))
        && config.xsrfCookieName && cookies.read(config.xsrfCookieName);

      if (xsrfValue) {
        requestHeaders.set(config.xsrfHeaderName, xsrfValue);
      }
    }

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', progressEventReducer(config.onDownloadProgress, true));
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', progressEventReducer(config.onUploadProgress));
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(fullPath);

    if (protocol && platform$1.protocols.indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
};

const knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter
};

utils.forEach(knownAdapters, (fn, value) => {
  if(fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

var adapters = {
  getAdapter: (adapters) => {
    adapters = utils.isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      if((adapter = utils.isString(nameOrAdapter) ? knownAdapters[nameOrAdapter.toLowerCase()] : nameOrAdapter)) {
        break;
      }
    }

    if (!adapter) {
      if (adapter === false) {
        throw new AxiosError(
          `Adapter ${nameOrAdapter} is not supported by the environment`,
          'ERR_NOT_SUPPORT'
        );
      }

      throw new Error(
        utils.hasOwnProp(knownAdapters, nameOrAdapter) ?
          `Adapter '${nameOrAdapter}' is not available in the build` :
          `Unknown adapter '${nameOrAdapter}'`
      );
    }

    if (!utils.isFunction(adapter)) {
      throw new TypeError('adapter is not a function');
    }

    return adapter;
  },
  adapters: knownAdapters
};

/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = AxiosHeaders$1.from(config.headers);

  // Transform request data
  config.data = transformData.call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || defaults$1.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );

    response.headers = AxiosHeaders$1.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = AxiosHeaders$1.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}

const headersToObject = (thing) => thing instanceof AxiosHeaders$1 ? thing.toJSON() : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, caseless) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge.call({caseless}, target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, caseless) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };

  utils.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

const VERSION = "1.4.0";

const validators$1 = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators$1[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators$1.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

var validator = {
  assertOptions,
  validators: validators$1
};

const validators = validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new InterceptorManager$1(),
      response: new InterceptorManager$1()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (utils.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        };
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: validators.function,
          serialize: validators.function
        }, true);
      }
    }

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    let contextHeaders;

    // Flatten headers
    contextHeaders = headers && utils.merge(
      headers.common,
      headers[config.method]
    );

    contextHeaders && utils.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = AxiosHeaders$1.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

var Axios$1 = Axios;

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

var CancelToken$1 = CancelToken;

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
}

const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

var HttpStatusCode$1 = HttpStatusCode;

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new Axios$1(defaultConfig);
  const instance = bind(Axios$1.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios$1.prototype, context, {allOwnKeys: true});

  // Copy context to instance
  utils.extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(defaults$1);

// Expose Axios class to allow class inheritance
axios.Axios = Axios$1;

// Expose Cancel & CancelToken
axios.CanceledError = CanceledError;
axios.CancelToken = CancelToken$1;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = toFormData;

// Expose AxiosError class
axios.AxiosError = AxiosError;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios.mergeConfig = mergeConfig;

axios.AxiosHeaders = AxiosHeaders$1;

axios.formToJSON = thing => formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);

axios.HttpStatusCode = HttpStatusCode$1;

axios.default = axios;

// this module should only have a default export
var axios$1 = axios;

/**
 * @description Manages window.storage
 * @returns storage objects
 * @class StorageManager
 */
var StorageManager = /*#__PURE__*/function () {
  function StorageManager() {
    _classCallCheck(this, StorageManager);
  }
  _createClass(StorageManager, null, [{
    key: "set",
    value:
    /**
     * @description Set or update given value in localStorage
     * @static
     * @returns Object
     * @memberof StorageManager
     */
    function set(key, value) {
      if (key && value) {
        window.localStorage.setItem(key, value);
        return {
          success: true,
          data: "Storage has been set successfully."
        };
      }
      return {
        error: true,
        data: "Storage was not set. Storage key and value is required!"
      };
    }

    /**
     * @description Set or update given value in sessionStorage, used to not remember user after closing opened tab.
     * @static
     * @returns Object
     * @memberof StorageManager
     */
  }, {
    key: "setToSession",
    value: function setToSession(key, value) {
      if (key && value) {
        window.sessionStorage.setItem(key, value);
        return {
          success: true,
          data: "Storage has been set successfully."
        };
      }
      return {
        error: true,
        data: "Storage was not set. Storage key and value is required!"
      };
    }

    /**
     * @description Fetch data from localStorage
     * @static
     * @returns Object
     * @memberof StorageManager
     */
  }, {
    key: "get",
    value: function get(key) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      if (key) {
        var val = window.localStorage.getItem(key) || window.sessionStorage.getItem(key);
        return val || defaultValue;
      }
      return {
        error: true,
        data: "Storage key is required!"
      };
    }

    /**
     * @description Clear only one value from localStorage
     * @static
     * @returns Object
     * @memberof StorageManager
     */
  }, {
    key: "clearOne",
    value: function clearOne(key) {
      if (key === 'token') {
        localStorage.removeItem('trade-type');
        localStorage.removeItem('trade-value');
      }
      if (key) {
        window.localStorage.removeItem(key) || window.sessionStorage.removeItem(key);
      }
      return "Storage key is required!";
    }

    /**
     * @description Clear all values from localStorage
     * @static
     * @returns Object
     * @memberof StorageManager
     */
  }, {
    key: "clearAll",
    value: function clearAll() {
      window.localStorage.clear();
      window.sessionStorage.clear();
    }
  }, {
    key: "hasKey",
    value: function hasKey(key) {
      return typeof this.get(key) === 'string';
    }
  }, {
    key: "saveFilters",
    value: function saveFilters(module, namespace) {
      var filters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var merge = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var savedFilters = this.get('filters');
      try {
        savedFilters = JSON.parse(savedFilters);
      } catch (e) {
        savedFilters = {};
      }
      if (!savedFilters) {
        savedFilters = {};
      }
      if (!savedFilters[module]) {
        savedFilters[module] = {};
      }
      if (!savedFilters[module][namespace]) {
        savedFilters[module][namespace] = {};
      }
      if (Object.keys(filters).length) {
        savedFilters[module][namespace] = merge ? Object.assign(savedFilters[module][namespace], filters) : filters;
      } else {
        savedFilters[module][namespace] = {};
      }
      this.set('filters', JSON.stringify(savedFilters));
      return savedFilters[module][namespace];
    }
  }, {
    key: "getFilters",
    value: function getFilters(module, namespace) {
      var savedFilters = this.get('filters');
      try {
        savedFilters = JSON.parse(savedFilters);
      } catch (e) {
        savedFilters = {};
      }
      if (!savedFilters) {
        savedFilters = {};
      }
      if (!savedFilters[module]) {
        savedFilters[module] = {};
      }
      if (!savedFilters[module][namespace]) {
        savedFilters[module][namespace] = {};
      }
      return savedFilters[module][namespace];
    }
  }]);
  return StorageManager;
}();

var isProxy = function isProxy() {
  var pathname = window.location.pathname;
  if (pathname.includes('/proxy/pme') || pathname.includes('/proxy/cadd')) {
    return window.opener || !!StorageManager.get('proxy_token');
  }
  return false;
};
var getToken = function getToken() {
  return isProxy() ? StorageManager.get('proxy_token') : StorageManager.get('token');
};

var filterString = function filterString(str1, str2) {
  str1 = str1.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
  str2 = str2.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
  return str1.toLowerCase().indexOf(str2.toLowerCase()) >= 0;
};
var filterSelectOptions = function filterSelectOptions(inputValue, option) {
  return filterString(typeof option.children === 'string' ? option.children : typeof option.label === 'string' ? option.label : '', inputValue);
};

var Text$1 = antd.Typography.Text;

// eslint-disable-next-line no-undef
var endpoint = process.env.REACT_APP_ENV === "local" &&
// eslint-disable-next-line no-undef
!process.env.REACT_APP_API_GATEWAY_ENDPOINT
// eslint-disable-next-line no-undef
? "http://localhost:".concat(process.env.REACT_APP_API_PORT, "/query/options") // eslint-disable-next-line no-undef
: "".concat(process.env.REACT_APP_API_GATEWAY_ENDPOINT, "/query/options");
var getAjaxData = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var entity, filterValues, mapper, method, setModel, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          entity = _ref.entity, filterValues = _ref.filterValues, mapper = _ref.mapper, method = _ref.method, setModel = _ref.setModel;
          _context.next = 3;
          return axios$1.post(endpoint, {
            entity: entity,
            method: method,
            mapper: mapper,
            filters: filterValues
          }, {
            headers: {
              Authorization: "Bearer ".concat(getToken())
            }
          });
        case 3:
          data = _context.sent;
          setModel(data.data);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getAjaxData(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var AjaxSelect = function AjaxSelect(_ref3) {
  var config = _ref3.config,
    _ref3$filters = _ref3.filters,
    filters = _ref3$filters === void 0 ? {} : _ref3$filters,
    _ref3$k = _ref3.k,
    k = _ref3$k === void 0 ? '' : _ref3$k,
    _ref3$setValue = _ref3.setValue,
    setValue = _ref3$setValue === void 0 ? function () {} : _ref3$setValue,
    _ref3$isEdit = _ref3.isEdit,
    isEdit = _ref3$isEdit === void 0 ? false : _ref3$isEdit,
    _ref3$placeholder = _ref3.placeholder,
    placeholder = _ref3$placeholder === void 0 ? '' : _ref3$placeholder;
  var _useState = React.useState([]),
    _useState2 = _slicedToArray$1(_useState, 2),
    model = _useState2[0],
    setModel = _useState2[1];
  var _useState3 = React.useState(false),
    _useState4 = _slicedToArray$1(_useState3, 2),
    initFetch = _useState4[0],
    setInitFetch = _useState4[1];
  var filterValues = React.useMemo(function () {
    return typeof config.filters === 'function' ? config.filters(filters) : {};
  }, [config, filters]);
  var _useState5 = React.useState(filterValues),
    _useState6 = _slicedToArray$1(_useState5, 2),
    lastFilterValues = _useState6[0],
    setLastFilterValues = _useState6[1];
  var disabled = React.useMemo(function () {
    return typeof config.disabled === 'function' ? config.disabled(filters) : true;
  }, [config, filters]);
  var value = React.useMemo(function () {
    return filters[k] || null;
  }, [k, filters]);
  var label = React.useMemo(function () {
    var v = model.find(function (m) {
      return m.value === value;
    });
    if (v) {
      return v.label;
    }
    return '';
  }, [model, value]);
  React.useEffect(function () {
    if (Object.keys(lastFilterValues) && !disabled) {
      getAjaxData({
        entity: config.entity,
        filterValues: lastFilterValues,
        mapper: config.mapper,
        method: config.method,
        setModel: setModel
      });
      setInitFetch(true);
    }
  }, [lastFilterValues]);
  React.useEffect(function () {
    if (!model.find(function (m) {
      return m.value === value;
    }) && initFetch) {
      setValue(undefined);
    }
  }, [model]);
  React.useEffect(function () {
    var changedPath = Object.keys(lastFilterValues).reduce(function (all, key) {
      var now = filterValues[key];
      var old = lastFilterValues[key];
      if (old !== now) {
        all.push(key);
      }
      return all;
    }, []);
    if (changedPath.length) {
      setLastFilterValues(filterValues);
    }
  }, [filterValues]);
  return !isEdit ? /*#__PURE__*/jsxRuntime.jsx(Text$1, {
    style: config.labelStyle || {},
    ellipsis: {
      tooltip: label
    },
    children: label
  }) : /*#__PURE__*/jsxRuntime.jsx(antd.Select, {
    autoComplete: "new-password",
    allowClear: true,
    showSearch: true,
    value: value,
    style: {
      width: '100%'
    },
    disabled: disabled,
    placeholder: placeholder,
    filterOption: filterSelectOptions,
    optionFilterProp: "label",
    options: model,
    onChange: function onChange(val) {
      setValue(val);
    }
  });
};
AjaxSelect.propTypes = {
  config: PropTypes__default["default"].object,
  filters: PropTypes__default["default"].object,
  k: PropTypes__default["default"].string,
  setValue: PropTypes__default["default"].func,
  isEdit: PropTypes__default["default"].bool,
  placeholder: PropTypes__default["default"].string
};

var formatClassname = function formatClassname(classNames) {
  return classNames.filter(function (c) {
    return c;
  }).join(' ');
};

var SelectFilters = function SelectFilters(_ref) {
  var onApply = _ref.onApply,
    className = _ref.className,
    _ref$setShowFilters = _ref.setShowFilters,
    setShowFilters = _ref$setShowFilters === void 0 ? function () {} : _ref$setShowFilters,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? {} : _ref$options,
    filtersConfig = _ref.filtersConfig,
    _ref$showFilters = _ref.showFilters,
    showFilters = _ref$showFilters === void 0 ? false : _ref$showFilters,
    _ref$selectedFilters = _ref.selectedFilters,
    selectedFilters = _ref$selectedFilters === void 0 ? {} : _ref$selectedFilters,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function (s) {
      return s;
    } : _ref$t,
    _ref$language = _ref.language,
    language = _ref$language === void 0 ? 'en' : _ref$language,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type;
  var _useState = React.useState(selectedFilters || {}),
    _useState2 = _slicedToArray$1(_useState, 2),
    filters = _useState2[0],
    setFilters = _useState2[1];
  var _useState3 = React.useState(selectedFilters || {}),
    _useState4 = _slicedToArray$1(_useState3, 2),
    initFilters = _useState4[0],
    setInitFilters = _useState4[1];
  var getClearLabel = function getClearLabel() {
    switch (type) {
      case 'small':
        return 'Clear';
      default:
        return 'Clear Filters';
    }
  };
  var getApplyLabel = function getApplyLabel() {
    switch (type) {
      case 'small':
        return 'Apply';
      default:
        return 'Apply Filters';
    }
  };
  var showIcon = type !== 'small';
  var hasChanges = React.useMemo(function () {
    var _hasChanges = false;
    var activeFiltersKeys = Object.keys(filters);
    if (activeFiltersKeys.length !== Object.keys(initFilters).length) {
      return true;
    }
    activeFiltersKeys.forEach(function (k) {
      if (!_hasChanges && initFilters[k] !== filters[k]) {
        _hasChanges = true;
      }
    });
    return _hasChanges;
  }, [initFilters, filters]);
  var entries = Object.entries(filtersConfig).filter(function (_ref2) {
    var _ref3 = _slicedToArray$1(_ref2, 2),
      k = _ref3[0],
      v = _ref3[1];
    if (!showFilters) {
      return false;
    }
    if (v.type === 'select') {
      return !!options[k];
    }
    return true;
  });
  var _onChange = function onChange(val, key) {
    setFilters(function (prev) {
      var o = {};
      var entries = Object.entries(prev);
      entries.forEach(function (_ref4) {
        var _ref5 = _slicedToArray$1(_ref4, 2),
          kk = _ref5[0],
          vv = _ref5[1];
        o[kk] = vv;
      });
      o[key] = val;
      return o;
    });
  };
  var getPlaceholder = function getPlaceholder(p) {
    if (typeof p === 'function') {
      return p(t);
    }
    if (typeof p === 'string') {
      return t(p);
    }
    return t('Filter');
  };
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    className: formatClassname([className, 'daf-select-filters', type]),
    children: /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: formatClassname(['filters', entries.length === 0 && 'empty']),
      children: [/*#__PURE__*/jsxRuntime.jsx("div", {
        className: "filters-cont",
        children: entries.filter(function (_ref6) {
          var _ref7 = _slicedToArray$1(_ref6, 2),
            v = _ref7[1];
          return !(typeof v.show === 'function' ? v.show(filters) : false);
        }).map(function (_ref8, i) {
          var _ref9 = _slicedToArray$1(_ref8, 2),
            k = _ref9[0],
            v = _ref9[1];
          return /*#__PURE__*/jsxRuntime.jsxs("div", {
            style: v.style,
            className: "cont",
            children: [/*#__PURE__*/jsxRuntime.jsx("label", {
              children: typeof v.label === 'function' ? v.label({
                filters: filters,
                options: options,
                t: t,
                language: language
              }) : t(v.label)
            }), /*#__PURE__*/jsxRuntime.jsxs("div", {
              children: [v.type === 'select' && options[k] && /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
                children: /*#__PURE__*/jsxRuntime.jsx(CustomSelect, {
                  config: v,
                  k: k,
                  filters: filters,
                  value: filters[k],
                  filterSelectOptions: filterSelectOptions,
                  placeholder: getPlaceholder(v.placeholder),
                  onChange: function onChange(e) {
                    return _onChange(e, k);
                  },
                  disabled: typeof v.disabled === 'function' ? v.disabled(filters) : false,
                  options: typeof v.getOptions === 'function' ? v.getOptions(filters) : options[k],
                  i: i
                })
              }), v.type === 'timeframe' && /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
                children: /*#__PURE__*/jsxRuntime.jsx(Timeframe, {
                  t: t,
                  value: filters[k],
                  onChange: function onChange(e) {
                    return _onChange(e, k);
                  },
                  disabled: typeof v.disabled === 'function' ? v.disabled(filters) : false
                })
              }), v.type === 'ajaxSelect' && /*#__PURE__*/jsxRuntime.jsx(AjaxSelect, {
                k: k,
                filters: filters,
                config: v,
                setValue: function setValue(v) {
                  return _onChange(v, k);
                },
                allowClear: true,
                isEdit: showFilters,
                placeholder: getPlaceholder(v.placeholder)
              }), v.type === 'text' && /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
                children: /*#__PURE__*/jsxRuntime.jsx(antd.Input, {
                  type: "text",
                  value: filters[k],
                  placeholder: getPlaceholder(v.placeholder),
                  onChange: function onChange(e) {
                    return _onChange(e.target.value, k);
                  }
                })
              })]
            })]
          }, i.toString());
        })
      }), showFilters && /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "cont apply-cont",
        children: /*#__PURE__*/jsxRuntime.jsxs(antd.Button, {
          type: hasChanges ? 'primary' : 'default',
          danger: !hasChanges,
          onClick: function onClick() {
            if (hasChanges) {
              var obj = filters;
              Object.keys(obj).forEach(function (key) {
                return obj[key] === undefined && delete obj[key];
              });
              onApply(obj);
              setInitFilters(filters);
              if (!Object.keys(filters).length) {
                setShowFilters(false);
              }
            } else {
              setFilters({});
              onApply({});
              setInitFilters({});
              setShowFilters(false);
            }
          },
          children: [t(hasChanges ? getApplyLabel() : getClearLabel()), showIcon ? /*#__PURE__*/jsxRuntime.jsx(CustomIcon, {
            color: hasChanges ? 'white' : 'red',
            width: hasChanges ? 13 : 16,
            height: hasChanges ? 10 : 16,
            name: hasChanges ? 'Check' : 'CloseCircle'
          }) : null]
        })
      })]
    })
  });
};
SelectFilters.propTypes = {
  t: PropTypes__default["default"].func,
  onApply: PropTypes__default["default"].func,
  options: PropTypes__default["default"].object,
  className: PropTypes__default["default"].string,
  showFilters: PropTypes__default["default"].bool,
  setShowFilters: PropTypes__default["default"].func,
  filtersConfig: PropTypes__default["default"].object,
  selectedFilters: PropTypes__default["default"].object,
  language: PropTypes__default["default"].string
};

var _excluded$6 = ["columns", "data", "defaultFilters", "style", "pagination", "loading", "onChange", "onFilterChange", "selectOptions", "filtersConfig", "rowSelection", "setShowFilters", "rowKey", "showFilters", "hideOnLoading", "sourcesKey", "className", "projects", "t", "selectedProject", "sourceId", "projectSources", "language", "scrollX"];
function DAFTable(_ref) {
  var _ref$columns = _ref.columns,
    columns = _ref$columns === void 0 ? [] : _ref$columns,
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? [] : _ref$data,
    _ref$defaultFilters = _ref.defaultFilters,
    defaultFilters = _ref$defaultFilters === void 0 ? {} : _ref$defaultFilters,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$pagination = _ref.pagination,
    pagination = _ref$pagination === void 0 ? null : _ref$pagination,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$onFilterChange = _ref.onFilterChange,
    onFilterChange = _ref$onFilterChange === void 0 ? function () {} : _ref$onFilterChange,
    selectOptions = _ref.selectOptions,
    filtersConfig = _ref.filtersConfig,
    _ref$rowSelection = _ref.rowSelection,
    rowSelection = _ref$rowSelection === void 0 ? false : _ref$rowSelection,
    _ref$setShowFilters = _ref.setShowFilters,
    setShowFilters = _ref$setShowFilters === void 0 ? function () {} : _ref$setShowFilters,
    _ref$rowKey = _ref.rowKey,
    rowKey = _ref$rowKey === void 0 ? 'id' : _ref$rowKey,
    _ref$showFilters = _ref.showFilters,
    showFilters = _ref$showFilters === void 0 ? false : _ref$showFilters,
    _ref$hideOnLoading = _ref.hideOnLoading,
    hideOnLoading = _ref$hideOnLoading === void 0 ? true : _ref$hideOnLoading,
    sourcesKey = _ref.sourcesKey,
    className = _ref.className,
    _ref$projects = _ref.projects,
    projects = _ref$projects === void 0 ? [] : _ref$projects,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function (s) {
      return s;
    } : _ref$t,
    selectedProject = _ref.selectedProject,
    _ref$sourceId = _ref.sourceId,
    sourceId = _ref$sourceId === void 0 ? '' : _ref$sourceId,
    _ref$projectSources = _ref.projectSources,
    projectSources = _ref$projectSources === void 0 ? [] : _ref$projectSources,
    _ref$language = _ref.language,
    language = _ref$language === void 0 ? 'en' : _ref$language,
    _ref$scrollX = _ref.scrollX,
    scrollX = _ref$scrollX === void 0 ? true : _ref$scrollX,
    rest = _objectWithoutProperties$1(_ref, _excluded$6);
  var _useState = React.useState([]),
    _useState2 = _slicedToArray$1(_useState, 2),
    source = _useState2[0],
    setSource = _useState2[1];
  var projectData = (projects || []).find(function (p) {
    return p.id === selectedProject;
  });
  var _useState3 = React.useState(!loading),
    _useState4 = _slicedToArray$1(_useState3, 2),
    filtersInit = _useState4[0],
    setFiltersInit = _useState4[1];
  React.useEffect(function () {
    if (!filtersInit && !loading) {
      setFiltersInit(true);
    }
  }, [loading]);
  var sources = React.useMemo(function () {
    if (projectData) {
      if (sourceId === 'overview') {
        return projectSources.map(function (val) {
          var _val$company;
          return {
            label: ((_val$company = val.company) === null || _val$company === void 0 ? void 0 : _val$company.name) || '',
            value: val.authorId
          };
        });
      }
    }
    return undefined;
  }, [projectData, sourceId, projectSources]);
  var _selectOptions = typeof sourcesKey === 'string' && sources ? _objectSpread2$1(_objectSpread2$1({}, selectOptions), {}, _defineProperty$1({}, sourcesKey, sources)) : selectOptions;
  var _filtersConfig = typeof sourcesKey === 'string' && sources ? _objectSpread2$1(_objectSpread2$1({}, filtersConfig), {}, _defineProperty$1({}, sourcesKey, {
    type: "select",
    label: t("Source"),
    placeholder: function placeholder(t) {
      return "".concat(t("Filter By"), " ").concat(t('Source'));
    },
    labelStyle: {
      flex: 1
    },
    style: {
      flex: 1
    },
    getLabel: function getLabel(opt) {
      return opt.label;
    },
    getValue: function getValue(opt) {
      return opt.value;
    }
  })) : filtersConfig;
  React.useEffect(function () {
    if (data) {
      setSource(data);
    }
  }, [data]);
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [showFilters && filtersConfig && onFilterChange && filtersInit && /*#__PURE__*/jsxRuntime.jsx(SelectFilters, {
      language: language,
      t: t,
      className: className,
      options: _selectOptions,
      filtersConfig: _filtersConfig,
      onApply: function onApply(filters) {
        onFilterChange(filters);
      },
      showFilters: showFilters,
      setShowFilters: setShowFilters,
      selectedFilters: defaultFilters
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      style: style,
      className: formatClassname(['daf-table', className]),
      children: (!loading || !hideOnLoading) && /*#__PURE__*/jsxRuntime.jsx(antd.Table, _objectSpread2$1({
        size: "small",
        sort: true,
        rowKey: rowKey,
        scroll: scrollX ? {
          x: SCROLL.x
        } : undefined,
        rowSelection: rowSelection,
        columns: columns,
        loading: !hideOnLoading ? loading : false,
        dataSource: source,
        pagination: pagination,
        onChange: onChange
      }, rest))
    })]
  });
}
var expandIcon = function expandIcon(_ref2) {
  var _ref2$onExpand = _ref2.onExpand,
    onExpand = _ref2$onExpand === void 0 ? function () {} : _ref2$onExpand,
    _ref2$record = _ref2.record,
    record = _ref2$record === void 0 ? {} : _ref2$record,
    _ref2$expandable = _ref2.expandable,
    expandable = _ref2$expandable === void 0 ? false : _ref2$expandable,
    _ref2$toggledKeys = _ref2.toggledKeys,
    toggledKeys = _ref2$toggledKeys === void 0 ? [] : _ref2$toggledKeys,
    _ref2$setToggledKeys = _ref2.setToggledKeys,
    setToggledKeys = _ref2$setToggledKeys === void 0 ? function () {} : _ref2$setToggledKeys,
    _ref2$loadingKeys = _ref2.loadingKeys,
    loadingKeys = _ref2$loadingKeys === void 0 ? {} : _ref2$loadingKeys,
    onExpandCallback = _ref2.onExpandCallback;
  return expandable ? toggledKeys.includes(record.key) ? /*#__PURE__*/jsxRuntime.jsx("button", {
    className: "expand-btn mr-3",
    onClick: function onClick(e) {
      if (loadingKeys.current[record.key]) {
        return;
      }
      setToggledKeys(_toConsumableArray(toggledKeys.filter(function (k) {
        return k !== record.key;
      })));
      loadingKeys.current[record.key] = true;
      setTimeout(function () {
        onExpand(record, e);
        loadingKeys.current[record.key] = false;
      }, 400);
    },
    children: /*#__PURE__*/jsxRuntime.jsxs("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/jsxRuntime.jsx("circle", {
        cx: "8",
        cy: "8",
        r: "8",
        transform: "rotate(90 8 8)",
        fill: "#F3F4F6"
      }), /*#__PURE__*/jsxRuntime.jsx("path", {
        d: "M5 6L8 9.75L11 6",
        fill: "#F3F4F6"
      }), /*#__PURE__*/jsxRuntime.jsx("path", {
        d: "M5 6L8 9.75L11 6",
        stroke: "var(--mmt-primary-60)",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    })
  }) : /*#__PURE__*/jsxRuntime.jsx("button", {
    className: "expand-btn mr-3",
    onClick: function onClick(e) {
      if (loadingKeys.current[record.key]) {
        return;
      }
      if (typeof onExpandCallback === 'function') {
        onExpandCallback(record, e);
      }
      onExpand(record, e);
      setToggledKeys([].concat(_toConsumableArray(toggledKeys), [record.key]));
    },
    children: /*#__PURE__*/jsxRuntime.jsxs("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/jsxRuntime.jsx("circle", {
        cx: "8",
        cy: "8",
        r: "8",
        fill: "#F3F4F6"
      }), /*#__PURE__*/jsxRuntime.jsx("path", {
        d: "M6 11L9.75 8L6 5",
        fill: "#F3F4F6"
      }), /*#__PURE__*/jsxRuntime.jsx("path", {
        d: "M6 11L9.75 8L6 5",
        stroke: "var(--mmt-primary-60)",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    })
  }) : /*#__PURE__*/jsxRuntime.jsx("button", {
    className: "expand-btn mr-3",
    style: {
      opacity: 0
    },
    children: /*#__PURE__*/jsxRuntime.jsxs("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/jsxRuntime.jsx("circle", {
        cx: "8",
        cy: "8",
        r: "8",
        fill: "#F3F4F6"
      }), /*#__PURE__*/jsxRuntime.jsx("path", {
        d: "M6 11L9.75 8L6 5",
        fill: "#F3F4F6"
      }), /*#__PURE__*/jsxRuntime.jsx("path", {
        d: "M6 11L9.75 8L6 5",
        stroke: "var(--mmt-primary-60)",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    })
  });
};
DAFTable.propTypes = {
  columns: PropTypes__default["default"].any,
  data: PropTypes__default["default"].any,
  defaultFilters: PropTypes__default["default"].object,
  style: PropTypes__default["default"].object,
  pagination: PropTypes__default["default"].any,
  loading: PropTypes__default["default"].bool,
  onChange: PropTypes__default["default"].func,
  onFilterChange: PropTypes__default["default"].func,
  selectOptions: PropTypes__default["default"].object,
  filtersConfig: PropTypes__default["default"].any,
  rowSelection: PropTypes__default["default"].bool,
  rowKey: PropTypes__default["default"].any,
  showFilters: PropTypes__default["default"].bool,
  hideOnLoading: PropTypes__default["default"].bool,
  sourcesKey: PropTypes__default["default"].any,
  className: PropTypes__default["default"].any,
  projects: PropTypes__default["default"].any,
  t: PropTypes__default["default"].func,
  selectedProject: PropTypes__default["default"].any,
  sourceId: PropTypes__default["default"].any,
  projectSources: PropTypes__default["default"].any,
  language: PropTypes__default["default"].string,
  setShowFilters: PropTypes__default["default"].func,
  scrollX: PropTypes__default["default"].any
};

function MoreMenu(_ref) {
  var _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items;
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    className: "daf-more-menu",
    children: /*#__PURE__*/jsxRuntime.jsx(antd.Dropdown, {
      menu: {
        items: items
      },
      trigger: "click",
      placement: "bottomRight",
      children: /*#__PURE__*/jsxRuntime.jsx("a", {
        onClick: function onClick(e) {
          return e.preventDefault();
        },
        children: /*#__PURE__*/jsxRuntime.jsx("div", {
          className: "flex-row justify-content-center",
          children: /*#__PURE__*/jsxRuntime.jsx(CustomIcon, {
            name: "More",
            width: 3,
            height: 13
          })
        })
      })
    })
  });
}
MoreMenu.propTypes = {
  items: PropTypes__default["default"].array
};

var Text = antd.Typography.Text;
function MoreTags(_ref) {
  var _ref$values = _ref.values,
    values = _ref$values === void 0 ? [] : _ref$values,
    _ref$maxWidthCont = _ref.maxWidthCont,
    maxWidthCont = _ref$maxWidthCont === void 0 ? 120 : _ref$maxWidthCont,
    _ref$maxTextCont = _ref.maxTextCont,
    maxTextCont = _ref$maxTextCont === void 0 ? 100 : _ref$maxTextCont,
    _ref$diff = _ref.diff,
    diff = _ref$diff === void 0 ? 30 : _ref$diff;
  var ref = React.useRef();
  var _useState = React.useState(0),
    _useState2 = _slicedToArray$1(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  var _useState3 = React.useState(0),
    _useState4 = _slicedToArray$1(_useState3, 2),
    indexToReturn = _useState4[0],
    setIndexToReturn = _useState4[1];
  var _maxWidthCont = values.length <= 1 ? maxWidthCont : maxWidthCont - 20;
  var _maxWidthTxt = values.length <= 1 ? maxTextCont : 80;
  React.useEffect(function () {
    var resizeObserver = new ResizeObserver(function (entries) {
      setWidth(entries[0].contentRect.width);
    });
    resizeObserver.observe(ref.current);
    return function () {
      return resizeObserver.disconnect();
    };
  }, []);
  var _calculate = function _calculate() {
    var tabs = ref.current.querySelectorAll('.check-tabs');
    var filled = 0;
    var indexToReturn;
    if (values.length === 1) {
      setIndexToReturn(1);
      return;
    }
    tabs.forEach(function (t, i) {
      if (typeof indexToReturn === 'number') {
        return;
      }
      filled = filled + t.clientWidth + 25;
      var dif = width - filled;
      if (dif < diff) {
        indexToReturn = dif < 0 ? i - 1 : i;
        setIndexToReturn(indexToReturn);
        return;
      }
    });
    setIndexToReturn(typeof indexToReturn === 'number' ? indexToReturn : tabs.length - 1);
  };
  var hasMore = values.length && indexToReturn !== values.length - 1;
  var toShow = hasMore ? values.slice(0, indexToReturn + 1) : values;
  var other = hasMore ? values.slice(indexToReturn + 1, values.length + 1) : [];
  React.useEffect(function () {
    _calculate();
  }, [width, values]);
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "daf-more-tags",
    children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "list",
      children: [toShow.map(function (ac, i) {
        return typeof ac.renderTag === 'function' ? ac.renderTag() : /*#__PURE__*/jsxRuntime.jsx(antd.Tag, {
          style: {
            maxWidth: _maxWidthCont
          },
          color: ac.color,
          children: /*#__PURE__*/jsxRuntime.jsx(Text, {
            ellipsis: {
              tooltip: _typeof$1(ac) === 'object' ? ac.label : ac
            },
            style: {
              maxWidth: _maxWidthTxt
            },
            children: _typeof$1(ac) === 'object' ? ac.label : ac
          })
        }, "".concat(_typeof$1(ac) === 'object' ? ac.value : ac, "-").concat(i));
      }), other.length ? /*#__PURE__*/jsxRuntime.jsx(antd.Tooltip, {
        title: other.map(function (ac) {
          return _typeof$1(ac) === 'object' ? ac.label : ac;
        }).join(', '),
        children: /*#__PURE__*/jsxRuntime.jsxs(antd.Tag, {
          children: ["+", other.length]
        })
      }) : null]
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "list hidden",
      ref: ref,
      children: values.map(function (ac, i) {
        return typeof ac.renderTag === 'function' ? ac.renderTag("check-tabs") : /*#__PURE__*/jsxRuntime.jsx(antd.Tag, {
          color: ac.color,
          className: "check-tabs",
          style: {
            maxWidth: _maxWidthCont
          },
          children: /*#__PURE__*/jsxRuntime.jsx(Text, {
            ellipsis: {
              tooltip: _typeof$1(ac) === 'object' ? ac.label : ac
            },
            style: {
              maxWidth: _maxWidthTxt
            },
            children: _typeof$1(ac) === 'object' ? ac.label : ac
          })
        }, "".concat(ac, "-").concat(i));
      })
    })]
  });
}
MoreTags.propTypes = {
  values: PropTypes__default["default"].array,
  maxWidthCont: PropTypes__default["default"].number,
  maxTextCont: PropTypes__default["default"].number,
  diff: PropTypes__default["default"].number
};

var IconContext = /*#__PURE__*/React.createContext({});
var Context = IconContext;

// shim for using process in browser
// based off https://github.com/defunctzombie/node-process/blob/master/browser.js

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
var cachedSetTimeout = defaultSetTimout;
var cachedClearTimeout = defaultClearTimeout;
if (typeof global$1.setTimeout === 'function') {
    cachedSetTimeout = setTimeout;
}
if (typeof global$1.clearTimeout === 'function') {
    cachedClearTimeout = clearTimeout;
}

function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
function nextTick(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
}
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
var title = 'browser';
var platform = 'browser';
var browser = true;
var env = {};
var argv = [];
var version = ''; // empty string to avoid regexp issues
var versions = {};
var release = {};
var config = {};

function noop() {}

var on = noop;
var addListener = noop;
var once = noop;
var off = noop;
var removeListener = noop;
var removeAllListeners = noop;
var emit = noop;

function binding(name) {
    throw new Error('process.binding is not supported');
}

function cwd () { return '/' }
function chdir (dir) {
    throw new Error('process.chdir is not supported');
}function umask() { return 0; }

// from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
var performance = global$1.performance || {};
var performanceNow =
  performance.now        ||
  performance.mozNow     ||
  performance.msNow      ||
  performance.oNow       ||
  performance.webkitNow  ||
  function(){ return (new Date()).getTime() };

// generate timestamp or delta
// see http://nodejs.org/api/process.html#process_process_hrtime
function hrtime(previousTimestamp){
  var clocktime = performanceNow.call(performance)*1e-3;
  var seconds = Math.floor(clocktime);
  var nanoseconds = Math.floor((clocktime%1)*1e9);
  if (previousTimestamp) {
    seconds = seconds - previousTimestamp[0];
    nanoseconds = nanoseconds - previousTimestamp[1];
    if (nanoseconds<0) {
      seconds--;
      nanoseconds += 1e9;
    }
  }
  return [seconds,nanoseconds]
}

var startTime = new Date();
function uptime() {
  var currentTime = new Date();
  var dif = currentTime - startTime;
  return dif / 1000;
}

var browser$1 = {
  nextTick: nextTick,
  title: title,
  browser: browser,
  env: env,
  argv: argv,
  version: version,
  versions: versions,
  on: on,
  addListener: addListener,
  once: once,
  off: off,
  removeListener: removeListener,
  removeAllListeners: removeAllListeners,
  emit: emit,
  binding: binding,
  cwd: cwd,
  chdir: chdir,
  umask: umask,
  hrtime: hrtime,
  platform: platform,
  release: release,
  config: config,
  uptime: uptime
};

var process$1 = browser$1;

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

// This icon file is generated automatically.
var AccountBookFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zM648.3 426.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V752c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3 73.2-144.3a10 10 0 018.9-5.5h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8z" } }] }, "name": "account-book", "theme": "filled" };
var AccountBookFilledSvg = AccountBookFilled$2;

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var classnames = createCommonjsModule(function (module) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

/**
 * Take input from [0, n] and return it as [0, 1]
 * @hidden
 */
function bound01(n, max) {
    if (isOnePointZero(n)) {
        n = '100%';
    }
    var isPercent = isPercentage(n);
    n = max === 360 ? n : Math.min(max, Math.max(0, parseFloat(n)));
    // Automatically convert percentage into number
    if (isPercent) {
        n = parseInt(String(n * max), 10) / 100;
    }
    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) {
        return 1;
    }
    // Convert into [0, 1] range if it isn't already
    if (max === 360) {
        // If n is a hue given in degrees,
        // wrap around out-of-range values into [0, 360] range
        // then convert into [0, 1].
        n = (n < 0 ? (n % max) + max : n % max) / parseFloat(String(max));
    }
    else {
        // If n not a hue given in degrees
        // Convert into [0, 1] range if it isn't already.
        n = (n % max) / parseFloat(String(max));
    }
    return n;
}
/**
 * Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
 * <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
 * @hidden
 */
function isOnePointZero(n) {
    return typeof n === 'string' && n.indexOf('.') !== -1 && parseFloat(n) === 1;
}
/**
 * Check to see if string passed in is a percentage
 * @hidden
 */
function isPercentage(n) {
    return typeof n === 'string' && n.indexOf('%') !== -1;
}
/**
 * Return a valid alpha value [0,1] with all invalid values being set to 1
 * @hidden
 */
function boundAlpha(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
    }
    return a;
}
/**
 * Replace a decimal with it's percentage value
 * @hidden
 */
function convertToPercentage(n) {
    if (n <= 1) {
        return "".concat(Number(n) * 100, "%");
    }
    return n;
}
/**
 * Force a hex value to have 2 characters
 * @hidden
 */
function pad2(c) {
    return c.length === 1 ? '0' + c : String(c);
}

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
/**
 * Handle bounds / percentage checking to conform to CSS color spec
 * <http://www.w3.org/TR/css3-color/>
 * *Assumes:* r, g, b in [0, 255] or [0, 1]
 * *Returns:* { r, g, b } in [0, 255]
 */
function rgbToRgb(r, g, b) {
    return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255,
    };
}
function hue2rgb(p, q, t) {
    if (t < 0) {
        t += 1;
    }
    if (t > 1) {
        t -= 1;
    }
    if (t < 1 / 6) {
        return p + (q - p) * (6 * t);
    }
    if (t < 1 / 2) {
        return q;
    }
    if (t < 2 / 3) {
        return p + (q - p) * (2 / 3 - t) * 6;
    }
    return p;
}
/**
 * Converts an HSL color value to RGB.
 *
 * *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
 * *Returns:* { r, g, b } in the set [0, 255]
 */
function hslToRgb(h, s, l) {
    var r;
    var g;
    var b;
    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);
    if (s === 0) {
        // achromatic
        g = l;
        b = l;
        r = l;
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return { r: r * 255, g: g * 255, b: b * 255 };
}
/**
 * Converts an RGB color value to HSV
 *
 * *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
 * *Returns:* { h, s, v } in [0,1]
 */
function rgbToHsv(r, g, b) {
    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var v = max;
    var d = max - min;
    var s = max === 0 ? 0 : d / max;
    if (max === min) {
        h = 0; // achromatic
    }
    else {
        switch (max) {
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}
/**
 * Converts an HSV color value to RGB.
 *
 * *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
 * *Returns:* { r, g, b } in the set [0, 255]
 */
function hsvToRgb(h, s, v) {
    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);
    var i = Math.floor(h);
    var f = h - i;
    var p = v * (1 - s);
    var q = v * (1 - f * s);
    var t = v * (1 - (1 - f) * s);
    var mod = i % 6;
    var r = [v, q, p, p, t, v][mod];
    var g = [t, v, v, q, p, p][mod];
    var b = [p, p, t, v, v, q][mod];
    return { r: r * 255, g: g * 255, b: b * 255 };
}
/**
 * Converts an RGB color to hex
 *
 * Assumes r, g, and b are contained in the set [0, 255]
 * Returns a 3 or 6 character hex
 */
function rgbToHex(r, g, b, allow3Char) {
    var hex = [
        pad2(Math.round(r).toString(16)),
        pad2(Math.round(g).toString(16)),
        pad2(Math.round(b).toString(16)),
    ];
    // Return a 3 character hex if possible
    if (allow3Char &&
        hex[0].startsWith(hex[0].charAt(1)) &&
        hex[1].startsWith(hex[1].charAt(1)) &&
        hex[2].startsWith(hex[2].charAt(1))) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }
    return hex.join('');
}
/** Converts a hex value to a decimal */
function convertHexToDecimal(h) {
    return parseIntFromHex(h) / 255;
}
/** Parse a base-16 hex value into a base-10 integer */
function parseIntFromHex(val) {
    return parseInt(val, 16);
}

// https://github.com/bahamas10/css-color-names/blob/master/css-color-names.json
/**
 * @hidden
 */
var names = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkgrey: '#a9a9a9',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkslategrey: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    goldenrod: '#daa520',
    gold: '#ffd700',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    grey: '#808080',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    lavenderblush: '#fff0f5',
    lavender: '#e6e6fa',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrodyellow: '#fafad2',
    lightgray: '#d3d3d3',
    lightgreen: '#90ee90',
    lightgrey: '#d3d3d3',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370db',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#db7093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    rebeccapurple: '#663399',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32',
};

/* eslint-disable @typescript-eslint/no-redundant-type-constituents */
/**
 * Given a string or object, convert that input to RGB
 *
 * Possible string inputs:
 * ```
 * "red"
 * "#f00" or "f00"
 * "#ff0000" or "ff0000"
 * "#ff000000" or "ff000000"
 * "rgb 255 0 0" or "rgb (255, 0, 0)"
 * "rgb 1.0 0 0" or "rgb (1, 0, 0)"
 * "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
 * "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
 * "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
 * "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
 * "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
 * ```
 */
function inputToRGB(color) {
    var rgb = { r: 0, g: 0, b: 0 };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color === 'string') {
        color = stringInputToObject(color);
    }
    if (typeof color === 'object') {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
            rgb = rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === '%' ? 'prgb' : 'rgb';
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
            s = convertToPercentage(color.s);
            v = convertToPercentage(color.v);
            rgb = hsvToRgb(color.h, s, v);
            ok = true;
            format = 'hsv';
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
            s = convertToPercentage(color.s);
            l = convertToPercentage(color.l);
            rgb = hslToRgb(color.h, s, l);
            ok = true;
            format = 'hsl';
        }
        if (Object.prototype.hasOwnProperty.call(color, 'a')) {
            a = color.a;
        }
    }
    a = boundAlpha(a);
    return {
        ok: ok,
        format: color.format || format,
        r: Math.min(255, Math.max(rgb.r, 0)),
        g: Math.min(255, Math.max(rgb.g, 0)),
        b: Math.min(255, Math.max(rgb.b, 0)),
        a: a,
    };
}
// <http://www.w3.org/TR/css3-values/#integers>
var CSS_INTEGER = '[-\\+]?\\d+%?';
// <http://www.w3.org/TR/css3-values/#number-value>
var CSS_NUMBER = '[-\\+]?\\d*\\.\\d+%?';
// Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
var CSS_UNIT = "(?:".concat(CSS_NUMBER, ")|(?:").concat(CSS_INTEGER, ")");
// Actual matching.
// Parentheses and commas are optional, but not required.
// Whitespace can take the place of commas or opening paren
var PERMISSIVE_MATCH3 = "[\\s|\\(]+(".concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")\\s*\\)?");
var PERMISSIVE_MATCH4 = "[\\s|\\(]+(".concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")\\s*\\)?");
var matchers = {
    CSS_UNIT: new RegExp(CSS_UNIT),
    rgb: new RegExp('rgb' + PERMISSIVE_MATCH3),
    rgba: new RegExp('rgba' + PERMISSIVE_MATCH4),
    hsl: new RegExp('hsl' + PERMISSIVE_MATCH3),
    hsla: new RegExp('hsla' + PERMISSIVE_MATCH4),
    hsv: new RegExp('hsv' + PERMISSIVE_MATCH3),
    hsva: new RegExp('hsva' + PERMISSIVE_MATCH4),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
};
/**
 * Permissive string parsing.  Take in a number of formats, and output an object
 * based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
 */
function stringInputToObject(color) {
    color = color.trim().toLowerCase();
    if (color.length === 0) {
        return false;
    }
    var named = false;
    if (names[color]) {
        color = names[color];
        named = true;
    }
    else if (color === 'transparent') {
        return { r: 0, g: 0, b: 0, a: 0, format: 'name' };
    }
    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match = matchers.rgb.exec(color);
    if (match) {
        return { r: match[1], g: match[2], b: match[3] };
    }
    match = matchers.rgba.exec(color);
    if (match) {
        return { r: match[1], g: match[2], b: match[3], a: match[4] };
    }
    match = matchers.hsl.exec(color);
    if (match) {
        return { h: match[1], s: match[2], l: match[3] };
    }
    match = matchers.hsla.exec(color);
    if (match) {
        return { h: match[1], s: match[2], l: match[3], a: match[4] };
    }
    match = matchers.hsv.exec(color);
    if (match) {
        return { h: match[1], s: match[2], v: match[3] };
    }
    match = matchers.hsva.exec(color);
    if (match) {
        return { h: match[1], s: match[2], v: match[3], a: match[4] };
    }
    match = matchers.hex8.exec(color);
    if (match) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? 'name' : 'hex8',
        };
    }
    match = matchers.hex6.exec(color);
    if (match) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? 'name' : 'hex',
        };
    }
    match = matchers.hex4.exec(color);
    if (match) {
        return {
            r: parseIntFromHex(match[1] + match[1]),
            g: parseIntFromHex(match[2] + match[2]),
            b: parseIntFromHex(match[3] + match[3]),
            a: convertHexToDecimal(match[4] + match[4]),
            format: named ? 'name' : 'hex8',
        };
    }
    match = matchers.hex3.exec(color);
    if (match) {
        return {
            r: parseIntFromHex(match[1] + match[1]),
            g: parseIntFromHex(match[2] + match[2]),
            b: parseIntFromHex(match[3] + match[3]),
            format: named ? 'name' : 'hex',
        };
    }
    return false;
}
/**
 * Check to see if it looks like a CSS unit
 * (see `matchers` above for definition).
 */
function isValidCSSUnit(color) {
    return Boolean(matchers.CSS_UNIT.exec(String(color)));
}

var hueStep = 2; // 色相阶梯

var saturationStep = 0.16; // 饱和度阶梯，浅色部分

var saturationStep2 = 0.05; // 饱和度阶梯，深色部分

var brightnessStep1 = 0.05; // 亮度阶梯，浅色部分

var brightnessStep2 = 0.15; // 亮度阶梯，深色部分

var lightColorCount = 5; // 浅色数量，主色上

var darkColorCount = 4; // 深色数量，主色下
// 暗色主题颜色映射关系表

var darkColorMap = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}];

// Wrapper function ported from TinyColor.prototype.toHsv
// Keep it here because of `hsv.h * 360`
function toHsv(_ref) {
  var r = _ref.r,
      g = _ref.g,
      b = _ref.b;
  var hsv = rgbToHsv(r, g, b);
  return {
    h: hsv.h * 360,
    s: hsv.s,
    v: hsv.v
  };
} // Wrapper function ported from TinyColor.prototype.toHexString
// Keep it here because of the prefix `#`


function toHex(_ref2) {
  var r = _ref2.r,
      g = _ref2.g,
      b = _ref2.b;
  return "#".concat(rgbToHex(r, g, b, false));
} // Wrapper function ported from TinyColor.prototype.mix, not treeshakable.
// Amount in range [0, 1]
// Assume color1 & color2 has no alpha, since the following src code did so.


function mix(rgb1, rgb2, amount) {
  var p = amount / 100;
  var rgb = {
    r: (rgb2.r - rgb1.r) * p + rgb1.r,
    g: (rgb2.g - rgb1.g) * p + rgb1.g,
    b: (rgb2.b - rgb1.b) * p + rgb1.b
  };
  return rgb;
}

function getHue(hsv, i, light) {
  var hue; // 根据色相不同，色相转向不同

  if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) {
    hue = light ? Math.round(hsv.h) - hueStep * i : Math.round(hsv.h) + hueStep * i;
  } else {
    hue = light ? Math.round(hsv.h) + hueStep * i : Math.round(hsv.h) - hueStep * i;
  }

  if (hue < 0) {
    hue += 360;
  } else if (hue >= 360) {
    hue -= 360;
  }

  return hue;
}

function getSaturation(hsv, i, light) {
  // grey color don't change saturation
  if (hsv.h === 0 && hsv.s === 0) {
    return hsv.s;
  }

  var saturation;

  if (light) {
    saturation = hsv.s - saturationStep * i;
  } else if (i === darkColorCount) {
    saturation = hsv.s + saturationStep;
  } else {
    saturation = hsv.s + saturationStep2 * i;
  } // 边界值修正


  if (saturation > 1) {
    saturation = 1;
  } // 第一格的 s 限制在 0.06-0.1 之间


  if (light && i === lightColorCount && saturation > 0.1) {
    saturation = 0.1;
  }

  if (saturation < 0.06) {
    saturation = 0.06;
  }

  return Number(saturation.toFixed(2));
}

function getValue(hsv, i, light) {
  var value;

  if (light) {
    value = hsv.v + brightnessStep1 * i;
  } else {
    value = hsv.v - brightnessStep2 * i;
  }

  if (value > 1) {
    value = 1;
  }

  return Number(value.toFixed(2));
}

function generate$1(color) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var patterns = [];
  var pColor = inputToRGB(color);

  for (var i = lightColorCount; i > 0; i -= 1) {
    var hsv = toHsv(pColor);
    var colorString = toHex(inputToRGB({
      h: getHue(hsv, i, true),
      s: getSaturation(hsv, i, true),
      v: getValue(hsv, i, true)
    }));
    patterns.push(colorString);
  }

  patterns.push(toHex(pColor));

  for (var _i = 1; _i <= darkColorCount; _i += 1) {
    var _hsv = toHsv(pColor);

    var _colorString = toHex(inputToRGB({
      h: getHue(_hsv, _i),
      s: getSaturation(_hsv, _i),
      v: getValue(_hsv, _i)
    }));

    patterns.push(_colorString);
  } // dark theme patterns


  if (opts.theme === 'dark') {
    return darkColorMap.map(function (_ref3) {
      var index = _ref3.index,
          opacity = _ref3.opacity;
      var darkColorString = toHex(mix(inputToRGB(opts.backgroundColor || '#141414'), inputToRGB(patterns[index]), opacity * 100));
      return darkColorString;
    });
  }

  return patterns;
}

var presetPrimaryColors = {
  red: '#F5222D',
  volcano: '#FA541C',
  orange: '#FA8C16',
  gold: '#FAAD14',
  yellow: '#FADB14',
  lime: '#A0D911',
  green: '#52C41A',
  cyan: '#13C2C2',
  blue: '#1677FF',
  geekblue: '#2F54EB',
  purple: '#722ED1',
  magenta: '#EB2F96',
  grey: '#666666'
};
var presetPalettes = {};
var presetDarkPalettes = {};
Object.keys(presetPrimaryColors).forEach(function (key) {
  presetPalettes[key] = generate$1(presetPrimaryColors[key]);
  presetPalettes[key].primary = presetPalettes[key][5]; // dark presetPalettes

  presetDarkPalettes[key] = generate$1(presetPrimaryColors[key], {
    theme: 'dark',
    backgroundColor: '#141414'
  });
  presetDarkPalettes[key].primary = presetDarkPalettes[key][5];
});
var blue = presetPalettes.blue;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

function canUseDom() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

function contains(root, n) {
  if (!root) {
    return false;
  }

  // Use native if support
  if (root.contains) {
    return root.contains(n);
  }

  // `document.contains` not support with IE11
  var node = n;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
}

var APPEND_ORDER = 'data-rc-order';
var APPEND_PRIORITY = 'data-rc-priority';
var MARK_KEY = "rc-util-key";
var containerCache = new Map();
function getMark() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    mark = _ref.mark;
  if (mark) {
    return mark.startsWith('data-') ? mark : "data-".concat(mark);
  }
  return MARK_KEY;
}
function getContainer(option) {
  if (option.attachTo) {
    return option.attachTo;
  }
  var head = document.querySelector('head');
  return head || document.body;
}
function getOrder(prepend) {
  if (prepend === 'queue') {
    return 'prependQueue';
  }
  return prepend ? 'prepend' : 'append';
}

/**
 * Find style which inject by rc-util
 */
function findStyles(container) {
  return Array.from((containerCache.get(container) || container).children).filter(function (node) {
    return node.tagName === 'STYLE';
  });
}
function injectCSS(css) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!canUseDom()) {
    return null;
  }
  var csp = option.csp,
    prepend = option.prepend,
    _option$priority = option.priority,
    priority = _option$priority === void 0 ? 0 : _option$priority;
  var mergedOrder = getOrder(prepend);
  var isPrependQueue = mergedOrder === 'prependQueue';
  var styleNode = document.createElement('style');
  styleNode.setAttribute(APPEND_ORDER, mergedOrder);
  if (isPrependQueue && priority) {
    styleNode.setAttribute(APPEND_PRIORITY, "".concat(priority));
  }
  if (csp !== null && csp !== void 0 && csp.nonce) {
    styleNode.nonce = csp === null || csp === void 0 ? void 0 : csp.nonce;
  }
  styleNode.innerHTML = css;
  var container = getContainer(option);
  var firstChild = container.firstChild;
  if (prepend) {
    // If is queue `prepend`, it will prepend first style and then append rest style
    if (isPrependQueue) {
      var existStyle = findStyles(container).filter(function (node) {
        // Ignore style which not injected by rc-util with prepend
        if (!['prepend', 'prependQueue'].includes(node.getAttribute(APPEND_ORDER))) {
          return false;
        }

        // Ignore style which priority less then new style
        var nodePriority = Number(node.getAttribute(APPEND_PRIORITY) || 0);
        return priority >= nodePriority;
      });
      if (existStyle.length) {
        container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
        return styleNode;
      }
    }

    // Use `insertBefore` as `prepend`
    container.insertBefore(styleNode, firstChild);
  } else {
    container.appendChild(styleNode);
  }
  return styleNode;
}
function findExistNode(key) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var container = getContainer(option);
  return findStyles(container).find(function (node) {
    return node.getAttribute(getMark(option)) === key;
  });
}

/**
 * qiankun will inject `appendChild` to insert into other
 */
function syncRealContainer(container, option) {
  var cachedRealContainer = containerCache.get(container);

  // Find real container when not cached or cached container removed
  if (!cachedRealContainer || !contains(document, cachedRealContainer)) {
    var placeholderStyle = injectCSS('', option);
    var parentNode = placeholderStyle.parentNode;
    containerCache.set(container, parentNode);
    container.removeChild(placeholderStyle);
  }
}
function updateCSS(css, key) {
  var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var container = getContainer(option);

  // Sync real parent
  syncRealContainer(container, option);
  var existNode = findExistNode(key, option);
  if (existNode) {
    var _option$csp, _option$csp2;
    if ((_option$csp = option.csp) !== null && _option$csp !== void 0 && _option$csp.nonce && existNode.nonce !== ((_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce)) {
      var _option$csp3;
      existNode.nonce = (_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce;
    }
    if (existNode.innerHTML !== css) {
      existNode.innerHTML = css;
    }
    return existNode;
  }
  var newNode = injectCSS(css, option);
  newNode.setAttribute(getMark(option), key);
  return newNode;
}

function getRoot(ele) {
  var _ele$getRootNode;
  return ele === null || ele === void 0 ? void 0 : (_ele$getRootNode = ele.getRootNode) === null || _ele$getRootNode === void 0 ? void 0 : _ele$getRootNode.call(ele);
}

/**
 * Check if is in shadowRoot
 */
function inShadow(ele) {
  return getRoot(ele) instanceof ShadowRoot;
}

/**
 * Return shadowRoot if possible
 */
function getShadowRoot(ele) {
  return inShadow(ele) ? getRoot(ele) : null;
}

/* eslint-disable no-console */
var warned = {};
var preWarningFns = [];

/**
 * Pre warning enable you to parse content before console.error.
 * Modify to null will prevent warning.
 */
var preMessage = function preMessage(fn) {
  preWarningFns.push(fn);
};
function warning$1(valid, message) {
  // Support uglify
  if (process$1.env.NODE_ENV !== 'production' && !valid && console !== undefined) {
    var finalMessage = preWarningFns.reduce(function (msg, preMessageFn) {
      return preMessageFn(msg !== null && msg !== void 0 ? msg : '', 'warning');
    }, message);
    if (finalMessage) {
      console.error("Warning: ".concat(finalMessage));
    }
  }
}
function note(valid, message) {
  // Support uglify
  if (process$1.env.NODE_ENV !== 'production' && !valid && console !== undefined) {
    var finalMessage = preWarningFns.reduce(function (msg, preMessageFn) {
      return preMessageFn(msg !== null && msg !== void 0 ? msg : '', 'note');
    }, message);
    if (finalMessage) {
      console.warn("Note: ".concat(finalMessage));
    }
  }
}
function resetWarned() {
  warned = {};
}
function call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}
function warningOnce(valid, message) {
  call(warning$1, valid, message);
}
function noteOnce(valid, message) {
  call(note, valid, message);
}
warningOnce.preMessage = preMessage;
warningOnce.resetWarned = resetWarned;
warningOnce.noteOnce = noteOnce;
/* eslint-enable */

function warning(valid, message) {
  warningOnce(valid, "[@ant-design/icons] ".concat(message));
}
function isIconDefinition(target) {
  return _typeof(target) === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && (_typeof(target.icon) === 'object' || typeof target.icon === 'function');
}
function normalizeAttrs() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(attrs).reduce(function (acc, key) {
    var val = attrs[key];
    switch (key) {
      case 'class':
        acc.className = val;
        delete acc.class;
        break;
      default:
        delete acc[key];
        acc[camelCase__default["default"](key)] = val;
    }
    return acc;
  }, {});
}
function generate(node, key, rootProps) {
  if (!rootProps) {
    return /*#__PURE__*/React__default["default"].createElement(node.tag, _objectSpread2({
      key: key
    }, normalizeAttrs(node.attrs)), (node.children || []).map(function (child, index) {
      return generate(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
  }
  return /*#__PURE__*/React__default["default"].createElement(node.tag, _objectSpread2(_objectSpread2({
    key: key
  }, normalizeAttrs(node.attrs)), rootProps), (node.children || []).map(function (child, index) {
    return generate(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
  }));
}
function getSecondaryColor(primaryColor) {
  // choose the second color
  return generate$1(primaryColor)[0];
}
function normalizeTwoToneColors(twoToneColor) {
  if (!twoToneColor) {
    return [];
  }
  return Array.isArray(twoToneColor) ? twoToneColor : [twoToneColor];
}

// These props make sure that the SVG behaviours like general text.
// Reference: https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
var svgBaseProps = {
  width: '1em',
  height: '1em',
  fill: 'currentColor',
  'aria-hidden': 'true',
  focusable: 'false'
};
var iconStyles = "\n.anticon {\n  display: inline-block;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
var useInsertStyles = function useInsertStyles(eleRef) {
  var _useContext = React.useContext(Context),
    csp = _useContext.csp,
    prefixCls = _useContext.prefixCls;
  var mergedStyleStr = iconStyles;
  if (prefixCls) {
    mergedStyleStr = mergedStyleStr.replace(/anticon/g, prefixCls);
  }
  React.useEffect(function () {
    var ele = eleRef.current;
    var shadowRoot = getShadowRoot(ele);
    updateCSS(mergedStyleStr, '@ant-design-icons', {
      prepend: true,
      csp: csp,
      attachTo: shadowRoot
    });
  }, []);
};

var _excluded$5 = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"];
var twoToneColorPalette = {
  primaryColor: '#333',
  secondaryColor: '#E6E6E6',
  calculated: false
};
function setTwoToneColors(_ref) {
  var primaryColor = _ref.primaryColor,
    secondaryColor = _ref.secondaryColor;
  twoToneColorPalette.primaryColor = primaryColor;
  twoToneColorPalette.secondaryColor = secondaryColor || getSecondaryColor(primaryColor);
  twoToneColorPalette.calculated = !!secondaryColor;
}
function getTwoToneColors() {
  return _objectSpread2({}, twoToneColorPalette);
}
var IconBase = function IconBase(props) {
  var icon = props.icon,
    className = props.className,
    onClick = props.onClick,
    style = props.style,
    primaryColor = props.primaryColor,
    secondaryColor = props.secondaryColor,
    restProps = _objectWithoutProperties(props, _excluded$5);
  var svgRef = React__namespace.useRef();
  var colors = twoToneColorPalette;
  if (primaryColor) {
    colors = {
      primaryColor: primaryColor,
      secondaryColor: secondaryColor || getSecondaryColor(primaryColor)
    };
  }
  useInsertStyles(svgRef);
  warning(isIconDefinition(icon), "icon should be icon definiton, but got ".concat(icon));
  if (!isIconDefinition(icon)) {
    return null;
  }
  var target = icon;
  if (target && typeof target.icon === 'function') {
    target = _objectSpread2(_objectSpread2({}, target), {}, {
      icon: target.icon(colors.primaryColor, colors.secondaryColor)
    });
  }
  return generate(target.icon, "svg-".concat(target.name), _objectSpread2(_objectSpread2({
    className: className,
    onClick: onClick,
    style: style,
    'data-icon': target.name,
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    'aria-hidden': 'true'
  }, restProps), {}, {
    ref: svgRef
  }));
};
IconBase.displayName = 'IconReact';
IconBase.getTwoToneColors = getTwoToneColors;
IconBase.setTwoToneColors = setTwoToneColors;
var ReactIcon = IconBase;

function setTwoToneColor(twoToneColor) {
  var _normalizeTwoToneColo = normalizeTwoToneColors(twoToneColor),
    _normalizeTwoToneColo2 = _slicedToArray(_normalizeTwoToneColo, 2),
    primaryColor = _normalizeTwoToneColo2[0],
    secondaryColor = _normalizeTwoToneColo2[1];
  return ReactIcon.setTwoToneColors({
    primaryColor: primaryColor,
    secondaryColor: secondaryColor
  });
}
function getTwoToneColor() {
  var colors = ReactIcon.getTwoToneColors();
  if (!colors.calculated) {
    return colors.primaryColor;
  }
  return [colors.primaryColor, colors.secondaryColor];
}

var _excluded$4 = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
// Initial setting
// should move it to antd main repo?
setTwoToneColor(blue.primary);

// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757#issuecomment-488848720

var Icon$2 = /*#__PURE__*/React__namespace.forwardRef(function (props, ref) {
  var _classNames;
  var className = props.className,
    icon = props.icon,
    spin = props.spin,
    rotate = props.rotate,
    tabIndex = props.tabIndex,
    onClick = props.onClick,
    twoToneColor = props.twoToneColor,
    restProps = _objectWithoutProperties(props, _excluded$4);
  var _React$useContext = React__namespace.useContext(Context),
    _React$useContext$pre = _React$useContext.prefixCls,
    prefixCls = _React$useContext$pre === void 0 ? 'anticon' : _React$useContext$pre,
    rootClassName = _React$useContext.rootClassName;
  var classString = classnames(rootClassName, prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(icon.name), !!icon.name), _defineProperty(_classNames, "".concat(prefixCls, "-spin"), !!spin || icon.name === 'loading'), _classNames), className);
  var iconTabIndex = tabIndex;
  if (iconTabIndex === undefined && onClick) {
    iconTabIndex = -1;
  }
  var svgStyle = rotate ? {
    msTransform: "rotate(".concat(rotate, "deg)"),
    transform: "rotate(".concat(rotate, "deg)")
  } : undefined;
  var _normalizeTwoToneColo = normalizeTwoToneColors(twoToneColor),
    _normalizeTwoToneColo2 = _slicedToArray(_normalizeTwoToneColo, 2),
    primaryColor = _normalizeTwoToneColo2[0],
    secondaryColor = _normalizeTwoToneColo2[1];
  return /*#__PURE__*/React__namespace.createElement("span", _extends({
    role: "img",
    "aria-label": icon.name
  }, restProps, {
    ref: ref,
    tabIndex: iconTabIndex,
    onClick: onClick,
    className: classString
  }), /*#__PURE__*/React__namespace.createElement(ReactIcon, {
    icon: icon,
    primaryColor: primaryColor,
    secondaryColor: secondaryColor,
    style: svgStyle
  }));
});
Icon$2.displayName = 'AntdIcon';
Icon$2.getTwoToneColor = getTwoToneColor;
Icon$2.setTwoToneColor = setTwoToneColor;
var AntdIcon = Icon$2;

var AccountBookFilled = function AccountBookFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AccountBookFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AccountBookFilled.displayName = 'AccountBookFilled';
}
var AccountBookFilled$1 = /*#__PURE__*/React__namespace.forwardRef(AccountBookFilled);

// This icon file is generated automatically.
var AccountBookOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584zM639.5 414h-45c-3 0-5.8 1.7-7.1 4.4L514 563.8h-2.8l-73.4-145.4a8 8 0 00-7.1-4.4h-46c-1.3 0-2.7.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9l89.3 164h-48.6c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1v33.7h-65.1c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1V752c0 4.4 3.6 8 8 8h41.3c4.4 0 8-3.6 8-8v-53.8h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-65.4v-33.7h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-49.1l89.3-164.1c.6-1.2 1-2.5 1-3.8.1-4.4-3.4-8-7.9-8z" } }] }, "name": "account-book", "theme": "outlined" };
var AccountBookOutlinedSvg = AccountBookOutlined$2;

var AccountBookOutlined = function AccountBookOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AccountBookOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AccountBookOutlined.displayName = 'AccountBookOutlined';
}
var AccountBookOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(AccountBookOutlined);

// This icon file is generated automatically.
var AccountBookTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v584h656V256H712v48zm-65.6 121.8l-89.3 164.1h49.1c4.4 0 8 3.6 8 8v21.3c0 4.4-3.6 8-8 8h-65.4v33.7h65.4c4.4 0 8 3.6 8 8v21.3c0 4.4-3.6 8-8 8h-65.4V752c0 4.4-3.6 8-8 8h-41.3c-4.4 0-8-3.6-8-8v-53.8h-65.1c-4.4 0-8-3.6-8-8v-21.3c0-4.4 3.6-8 8-8h65.1v-33.7h-65.1c-4.4 0-8-3.6-8-8v-21.3c0-4.4 3.6-8 8-8H467l-89.3-164c-2.1-3.9-.7-8.8 3.2-10.9 1.1-.7 2.5-1 3.8-1h46a8 8 0 017.1 4.4l73.4 145.4h2.8l73.4-145.4c1.3-2.7 4.1-4.4 7.1-4.4h45c4.5 0 8 3.6 7.9 8 0 1.3-.4 2.6-1 3.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M639.5 414h-45c-3 0-5.8 1.7-7.1 4.4L514 563.8h-2.8l-73.4-145.4a8 8 0 00-7.1-4.4h-46c-1.3 0-2.7.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9l89.3 164h-48.6c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1v33.7h-65.1c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1V752c0 4.4 3.6 8 8 8h41.3c4.4 0 8-3.6 8-8v-53.8h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-65.4v-33.7h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-49.1l89.3-164.1c.6-1.2 1-2.5 1-3.8.1-4.4-3.4-8-7.9-8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584z", "fill": primaryColor } }] }; }, "name": "account-book", "theme": "twotone" };
var AccountBookTwoToneSvg = AccountBookTwoTone$2;

var AccountBookTwoTone = function AccountBookTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AccountBookTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AccountBookTwoTone.displayName = 'AccountBookTwoTone';
}
var AccountBookTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(AccountBookTwoTone);

// This icon file is generated automatically.
var AimOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M952 474H829.8C812.5 327.6 696.4 211.5 550 194.2V72c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v122.2C327.6 211.5 211.5 327.6 194.2 474H72c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h122.2C211.5 696.4 327.6 812.5 474 829.8V952c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V829.8C696.4 812.5 812.5 696.4 829.8 550H952c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM512 756c-134.8 0-244-109.2-244-244s109.2-244 244-244 244 109.2 244 244-109.2 244-244 244z" } }, { "tag": "path", "attrs": { "d": "M512 392c-32.1 0-62.1 12.4-84.8 35.2-22.7 22.7-35.2 52.7-35.2 84.8s12.5 62.1 35.2 84.8C449.9 619.4 480 632 512 632s62.1-12.5 84.8-35.2C619.4 574.1 632 544 632 512s-12.5-62.1-35.2-84.8A118.57 118.57 0 00512 392z" } }] }, "name": "aim", "theme": "outlined" };
var AimOutlinedSvg = AimOutlined$2;

var AimOutlined = function AimOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AimOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AimOutlined.displayName = 'AimOutlined';
}
var AimOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(AimOutlined);

// This icon file is generated automatically.
var AlertFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 244c176.18 0 319 142.82 319 319v233a32 32 0 01-32 32H225a32 32 0 01-32-32V563c0-176.18 142.82-319 319-319zM484 68h56a8 8 0 018 8v96a8 8 0 01-8 8h-56a8 8 0 01-8-8V76a8 8 0 018-8zM177.25 191.66a8 8 0 0111.32 0l67.88 67.88a8 8 0 010 11.31l-39.6 39.6a8 8 0 01-11.31 0l-67.88-67.88a8 8 0 010-11.31l39.6-39.6zm669.6 0l39.6 39.6a8 8 0 010 11.3l-67.88 67.9a8 8 0 01-11.32 0l-39.6-39.6a8 8 0 010-11.32l67.89-67.88a8 8 0 0111.31 0zM192 892h640a32 32 0 0132 32v24a8 8 0 01-8 8H168a8 8 0 01-8-8v-24a32 32 0 0132-32zm148-317v253h64V575h-64z" } }] }, "name": "alert", "theme": "filled" };
var AlertFilledSvg = AlertFilled$2;

var AlertFilled = function AlertFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AlertFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AlertFilled.displayName = 'AlertFilled';
}
var AlertFilled$1 = /*#__PURE__*/React__namespace.forwardRef(AlertFilled);

// This icon file is generated automatically.
var AlertOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M193 796c0 17.7 14.3 32 32 32h574c17.7 0 32-14.3 32-32V563c0-176.2-142.8-319-319-319S193 386.8 193 563v233zm72-233c0-136.4 110.6-247 247-247s247 110.6 247 247v193H404V585c0-5.5-4.5-10-10-10h-44c-5.5 0-10 4.5-10 10v171h-75V563zm-48.1-252.5l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3l-67.9-67.9a8.03 8.03 0 00-11.3 0l-39.6 39.6a8.03 8.03 0 000 11.3l67.9 67.9c3.1 3.1 8.1 3.1 11.3 0zm669.6-79.2l-39.6-39.6a8.03 8.03 0 00-11.3 0l-67.9 67.9a8.03 8.03 0 000 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l67.9-67.9c3.1-3.2 3.1-8.2 0-11.3zM832 892H192c-17.7 0-32 14.3-32 32v24c0 4.4 3.6 8 8 8h688c4.4 0 8-3.6 8-8v-24c0-17.7-14.3-32-32-32zM484 180h56c4.4 0 8-3.6 8-8V76c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8z" } }] }, "name": "alert", "theme": "outlined" };
var AlertOutlinedSvg = AlertOutlined$2;

var AlertOutlined = function AlertOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AlertOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AlertOutlined.displayName = 'AlertOutlined';
}
var AlertOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(AlertOutlined);

// This icon file is generated automatically.
var AlertTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M340 585c0-5.5 4.5-10 10-10h44c5.5 0 10 4.5 10 10v171h355V563c0-136.4-110.6-247-247-247S265 426.6 265 563v193h75V585z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M216.9 310.5l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3l-67.9-67.9a8.03 8.03 0 00-11.3 0l-39.6 39.6a8.03 8.03 0 000 11.3l67.9 67.9c3.1 3.1 8.1 3.1 11.3 0zm669.6-79.2l-39.6-39.6a8.03 8.03 0 00-11.3 0l-67.9 67.9a8.03 8.03 0 000 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l67.9-67.9c3.1-3.2 3.1-8.2 0-11.3zM484 180h56c4.4 0 8-3.6 8-8V76c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8zm348 712H192c-17.7 0-32 14.3-32 32v24c0 4.4 3.6 8 8 8h688c4.4 0 8-3.6 8-8v-24c0-17.7-14.3-32-32-32zm-639-96c0 17.7 14.3 32 32 32h574c17.7 0 32-14.3 32-32V563c0-176.2-142.8-319-319-319S193 386.8 193 563v233zm72-233c0-136.4 110.6-247 247-247s247 110.6 247 247v193H404V585c0-5.5-4.5-10-10-10h-44c-5.5 0-10 4.5-10 10v171h-75V563z", "fill": primaryColor } }] }; }, "name": "alert", "theme": "twotone" };
var AlertTwoToneSvg = AlertTwoTone$2;

var AlertTwoTone = function AlertTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AlertTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AlertTwoTone.displayName = 'AlertTwoTone';
}
var AlertTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(AlertTwoTone);

// This icon file is generated automatically.
var AlibabaOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M602.9 669.8c-37.2 2.6-33.6-17.3-11.5-46.2 50.4-67.2 143.7-158.5 147.9-225.2 5.8-86.6-81.3-113.4-171-113.4-62.4 1.6-127 18.9-171 34.6-151.6 53.5-246.6 137.5-306.9 232-62.4 93.4-43 183.2 91.8 185.8 101.8-4.2 170.5-32.5 239.7-68.2.5 0-192.5 55.1-263.9 14.7-7.9-4.2-15.7-10-17.8-26.2 0-33.1 54.6-67.7 86.6-78.7v-56.7c64.5 22.6 140.6 16.3 205.7-32 2.1 5.8 4.2 13.1 3.7 21h11c2.6-22.6-12.6-44.6-37.8-46.2 7.3 5.8 12.6 10.5 15.2 14.7l-1 1-.5.5c-83.9 58.8-165.3 31.5-173.1 29.9l46.7-45.7-13.1-33.1c92.9-32.5 169.5-56.2 296.9-78.7l-28.5-23 14.7-8.9c75.5 21 126.4 36.7 123.8 76.6-1 6.8-3.7 14.7-7.9 23.1C660.1 466.1 594 538 567.2 569c-17.3 20.5-34.6 39.4-46.7 58.3-13.6 19.4-20.5 37.3-21 53.5 2.6 131.8 391.4-61.9 468-112.9-111.7 47.8-232.9 93.5-364.6 101.9zm85-302.9c2.8 5.2 4.1 11.6 4.1 19.1-.1-6.8-1.4-13.3-4.1-19.1z" } }] }, "name": "alibaba", "theme": "outlined" };
var AlibabaOutlinedSvg = AlibabaOutlined$2;

var AlibabaOutlined = function AlibabaOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AlibabaOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AlibabaOutlined.displayName = 'AlibabaOutlined';
}
var AlibabaOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(AlibabaOutlined);

// This icon file is generated automatically.
var AlignCenterOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M264 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm496 424c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496zm144 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "align-center", "theme": "outlined" };
var AlignCenterOutlinedSvg = AlignCenterOutlined$2;

var AlignCenterOutlined = function AlignCenterOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AlignCenterOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AlignCenterOutlined.displayName = 'AlignCenterOutlined';
}
var AlignCenterOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(AlignCenterOutlined);

// This icon file is generated automatically.
var AlignLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M120 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 424h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm784 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "align-left", "theme": "outlined" };
var AlignLeftOutlinedSvg = AlignLeftOutlined$2;

var AlignLeftOutlined = function AlignLeftOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AlignLeftOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AlignLeftOutlined.displayName = 'AlignLeftOutlined';
}
var AlignLeftOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(AlignLeftOutlined);

// This icon file is generated automatically.
var AlignRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 158H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 424H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 212H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "align-right", "theme": "outlined" };
var AlignRightOutlinedSvg = AlignRightOutlined$2;

var AlignRightOutlined = function AlignRightOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AlignRightOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AlignRightOutlined.displayName = 'AlignRightOutlined';
}
var AlignRightOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(AlignRightOutlined);

// This icon file is generated automatically.
var AlipayCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zm460.5 67c100.1 33.4 154.7 43 166.7 44.8A445.9 445.9 0 00960 512c0-247.4-200.6-448-448-448S64 264.6 64 512s200.6 448 448 448c155.9 0 293.2-79.7 373.5-200.5-75.6-29.8-213.6-85-286.8-120.1-69.9 85.7-160.1 137.8-253.7 137.8-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9z" } }] }, "name": "alipay-circle", "theme": "filled" };
var AlipayCircleFilledSvg = AlipayCircleFilled$2;

var AlipayCircleFilled = function AlipayCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AlipayCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AlipayCircleFilled.displayName = 'AlipayCircleFilled';
}
var AlipayCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(AlipayCircleFilled);

// This icon file is generated automatically.
var AlipayCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zm460.5 67c100.1 33.4 154.7 43 166.7 44.8A445.9 445.9 0 00960 512c0-247.4-200.6-448-448-448S64 264.6 64 512s200.6 448 448 448c155.9 0 293.2-79.7 373.5-200.5-75.6-29.8-213.6-85-286.8-120.1-69.9 85.7-160.1 137.8-253.7 137.8-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9z" } }] }, "name": "alipay-circle", "theme": "outlined" };
var AlipayCircleOutlinedSvg = AlipayCircleOutlined$2;

var AlipayCircleOutlined = function AlipayCircleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AlipayCircleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AlipayCircleOutlined.displayName = 'AlipayCircleOutlined';
}
var AlipayCircleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(AlipayCircleOutlined);

// This icon file is generated automatically.
var AlipayOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M789 610.3c-38.7-12.9-90.7-32.7-148.5-53.6 34.8-60.3 62.5-129 80.7-203.6H530.5v-68.6h233.6v-38.3H530.5V132h-95.4c-16.7 0-16.7 16.5-16.7 16.5v97.8H182.2v38.3h236.3v68.6H223.4v38.3h378.4a667.18 667.18 0 01-54.5 132.9c-122.8-40.4-253.8-73.2-336.1-53-52.6 13-86.5 36.1-106.5 60.3-91.4 111-25.9 279.6 167.2 279.6C386 811.2 496 747.6 581.2 643 708.3 704 960 808.7 960 808.7V659.4s-31.6-2.5-171-49.1zM253.9 746.6c-150.5 0-195-118.3-120.6-183.1 24.8-21.9 70.2-32.6 94.4-35 89.4-8.8 172.2 25.2 269.9 72.8-68.8 89.5-156.3 145.3-243.7 145.3z" } }] }, "name": "alipay", "theme": "outlined" };
var AlipayOutlinedSvg = AlipayOutlined$2;

var AlipayOutlined = function AlipayOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AlipayOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AlipayOutlined.displayName = 'AlipayOutlined';
}
var AlipayOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(AlipayOutlined);

// This icon file is generated automatically.
var AlipaySquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm29.4 663.2S703 689.4 598.7 639.5C528.8 725.2 438.6 777.3 345 777.3c-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9 114.3 38.2 140.2 40.2 140.2 40.2v122.3z" } }] }, "name": "alipay-square", "theme": "filled" };
var AlipaySquareFilledSvg = AlipaySquareFilled$2;

var AlipaySquareFilled = function AlipaySquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AlipaySquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AlipaySquareFilled.displayName = 'AlipaySquareFilled';
}
var AlipaySquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(AlipaySquareFilled);

// This icon file is generated automatically.
var AliwangwangFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M868.2 377.4c-18.9-45.1-46.3-85.6-81.2-120.6a377.26 377.26 0 00-120.5-81.2A375.65 375.65 0 00519 145.8c-41.9 0-82.9 6.7-121.9 20C306 123.3 200.8 120 170.6 120c-2.2 0-7.4 0-9.4.2-11.9.4-22.8 6.5-29.2 16.4-6.5 9.9-7.7 22.4-3.4 33.5l64.3 161.6a378.59 378.59 0 00-52.8 193.2c0 51.4 10 101 29.8 147.6 18.9 45 46.2 85.6 81.2 120.5 34.7 34.8 75.4 62.1 120.5 81.2C418.3 894 467.9 904 519 904c51.3 0 100.9-10 147.7-29.8 44.9-18.9 85.5-46.3 120.4-81.2 34.7-34.8 62.1-75.4 81.2-120.6a376.5 376.5 0 0029.8-147.6c-.2-51.2-10.1-100.8-29.9-147.4zm-325.2 79c0 20.4-16.6 37.1-37.1 37.1-20.4 0-37.1-16.7-37.1-37.1v-55.1c0-20.4 16.6-37.1 37.1-37.1 20.4 0 37.1 16.6 37.1 37.1v55.1zm175.2 0c0 20.4-16.6 37.1-37.1 37.1S644 476.8 644 456.4v-55.1c0-20.4 16.7-37.1 37.1-37.1 20.4 0 37.1 16.6 37.1 37.1v55.1z" } }] }, "name": "aliwangwang", "theme": "filled" };
var AliwangwangFilledSvg = AliwangwangFilled$2;

var AliwangwangFilled = function AliwangwangFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AliwangwangFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AliwangwangFilled.displayName = 'AliwangwangFilled';
}
var AliwangwangFilled$1 = /*#__PURE__*/React__namespace.forwardRef(AliwangwangFilled);

// This icon file is generated automatically.
var AliwangwangOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M868.2 377.4c-18.9-45.1-46.3-85.6-81.2-120.6a377.26 377.26 0 00-120.5-81.2A375.65 375.65 0 00519 145.8c-41.9 0-82.9 6.7-121.9 20C306 123.3 200.8 120 170.6 120c-2.2 0-7.4 0-9.4.2-11.9.4-22.8 6.5-29.2 16.4-6.5 9.9-7.7 22.4-3.4 33.5l64.3 161.6a378.59 378.59 0 00-52.8 193.2c0 51.4 10 101 29.8 147.6 18.9 45 46.2 85.6 81.2 120.5 34.7 34.8 75.4 62.1 120.5 81.2C418.3 894 467.9 904 519 904c51.3 0 100.9-10.1 147.7-29.8 44.9-18.9 85.5-46.3 120.4-81.2 34.7-34.8 62.1-75.4 81.2-120.6a376.5 376.5 0 0029.8-147.6c-.2-51.2-10.1-100.8-29.9-147.4zm-66.4 266.5a307.08 307.08 0 01-65.9 98c-28.4 28.5-61.3 50.7-97.7 65.9h-.1c-38 16-78.3 24.2-119.9 24.2a306.51 306.51 0 01-217.5-90.2c-28.4-28.5-50.6-61.4-65.8-97.8v-.1c-16-37.8-24.1-78.2-24.1-119.9 0-55.4 14.8-109.7 42.8-157l13.2-22.1-9.5-23.9L206 192c14.9.6 35.9 2.1 59.7 5.6 43.8 6.5 82.5 17.5 114.9 32.6l19 8.9 19.9-6.8c31.5-10.8 64.8-16.2 98.9-16.2a306.51 306.51 0 01217.5 90.2c28.4 28.5 50.6 61.4 65.8 97.8l.1.1.1.1c16 37.6 24.1 78 24.2 119.8-.1 41.7-8.3 82-24.3 119.8zM681.1 364.2c-20.4 0-37.1 16.7-37.1 37.1v55.1c0 20.4 16.6 37.1 37.1 37.1s37.1-16.7 37.1-37.1v-55.1c0-20.5-16.7-37.1-37.1-37.1zm-175.2 0c-20.5 0-37.1 16.7-37.1 37.1v55.1c0 20.4 16.7 37.1 37.1 37.1 20.5 0 37.1-16.7 37.1-37.1v-55.1c0-20.5-16.7-37.1-37.1-37.1z" } }] }, "name": "aliwangwang", "theme": "outlined" };
var AliwangwangOutlinedSvg = AliwangwangOutlined$2;

var AliwangwangOutlined = function AliwangwangOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AliwangwangOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AliwangwangOutlined.displayName = 'AliwangwangOutlined';
}
var AliwangwangOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(AliwangwangOutlined);

// This icon file is generated automatically.
var AliyunOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M959.2 383.9c-.3-82.1-66.9-148.6-149.1-148.6H575.9l21.6 85.2 201 43.7a42.58 42.58 0 0132.9 39.7c.1.5.1 216.1 0 216.6a42.58 42.58 0 01-32.9 39.7l-201 43.7-21.6 85.3h234.2c82.1 0 148.8-66.5 149.1-148.6V383.9zM225.5 660.4a42.58 42.58 0 01-32.9-39.7c-.1-.6-.1-216.1 0-216.6.8-19.4 14.6-35.5 32.9-39.7l201-43.7 21.6-85.2H213.8c-82.1 0-148.8 66.4-149.1 148.6V641c.3 82.1 67 148.6 149.1 148.6H448l-21.6-85.3-200.9-43.9zm200.9-158.8h171v21.3h-171z" } }] }, "name": "aliyun", "theme": "outlined" };
var AliyunOutlinedSvg = AliyunOutlined$2;

var AliyunOutlined = function AliyunOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AliyunOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AliyunOutlined.displayName = 'AliyunOutlined';
}
var AliyunOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(AliyunOutlined);

// This icon file is generated automatically.
var AmazonCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M485 467.5c-11.6 4.9-20.9 12.2-27.8 22-6.9 9.8-10.4 21.6-10.4 35.5 0 17.8 7.5 31.5 22.4 41.2 14.1 9.1 28.9 11.4 44.4 6.8 17.9-5.2 30-17.9 36.4-38.1 3-9.3 4.5-19.7 4.5-31.3v-50.2c-12.6.4-24.4 1.6-35.5 3.7-11.1 2.1-22.4 5.6-34 10.4zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm35.8 262.7c-7.2-10.9-20.1-16.4-38.7-16.4-1.3 0-3 .1-5.3.3-2.2.2-6.6 1.5-12.9 3.7a79.4 79.4 0 00-17.9 9.1c-5.5 3.8-11.5 10-18 18.4-6.4 8.5-11.5 18.4-15.3 29.8l-94-8.4c0-12.4 2.4-24.7 7-36.9 4.7-12.2 11.8-23.9 21.4-35 9.6-11.2 21.1-21 34.5-29.4 13.4-8.5 29.6-15.2 48.4-20.3 18.9-5.1 39.1-7.6 60.9-7.6 21.3 0 40.6 2.6 57.8 7.7 17.2 5.2 31.1 11.5 41.4 19.1a117 117 0 0125.9 25.7c6.9 9.6 11.7 18.5 14.4 26.7 2.7 8.2 4 15.7 4 22.8v182.5c0 6.4 1.4 13 4.3 19.8 2.9 6.8 6.3 12.8 10.2 18 3.9 5.2 7.9 9.9 12 14.3 4.1 4.3 7.6 7.7 10.6 9.9l4.1 3.4-72.5 69.4c-8.5-7.7-16.9-15.4-25.2-23.4-8.3-8-14.5-14-18.5-18.1l-6.1-6.2c-2.4-2.3-5-5.7-8-10.2-8.1 12.2-18.5 22.8-31.1 31.8-12.7 9-26.3 15.6-40.7 19.7-14.5 4.1-29.4 6.5-44.7 7.1-15.3.6-30-1.5-43.9-6.5-13.9-5-26.5-11.7-37.6-20.3-11.1-8.6-19.9-20.2-26.5-35-6.6-14.8-9.9-31.5-9.9-50.4 0-17.4 3-33.3 8.9-47.7 6-14.5 13.6-26.5 23-36.1 9.4-9.6 20.7-18.2 34-25.7s26.4-13.4 39.2-17.7c12.8-4.2 26.6-7.8 41.5-10.7 14.9-2.9 27.6-4.8 38.2-5.7 10.6-.9 21.2-1.6 31.8-2v-39.4c0-13.5-2.3-23.5-6.7-30.1zm180.5 379.6c-2.8 3.3-7.5 7.8-14.1 13.5s-16.8 12.7-30.5 21.1c-13.7 8.4-28.8 16-45 22.9-16.3 6.9-36.3 12.9-60.1 18-23.7 5.1-48.2 7.6-73.3 7.6-25.4 0-50.7-3.2-76.1-9.6-25.4-6.4-47.6-14.3-66.8-23.7-19.1-9.4-37.6-20.2-55.1-32.2-17.6-12.1-31.7-22.9-42.4-32.5-10.6-9.6-19.6-18.7-26.8-27.1-1.7-1.9-2.8-3.6-3.2-5.1-.4-1.5-.3-2.8.3-3.7.6-.9 1.5-1.6 2.6-2.2a7.42 7.42 0 017.4.8c40.9 24.2 72.9 41.3 95.9 51.4 82.9 36.4 168 45.7 255.3 27.9 40.5-8.3 82.1-22.2 124.9-41.8 3.2-1.2 6-1.5 8.3-.9 2.3.6 3.5 2.4 3.5 5.4 0 2.8-1.6 6.3-4.8 10.2zm59.9-29c-1.8 11.1-4.9 21.6-9.1 31.8-7.2 17.1-16.3 30-27.1 38.4-3.6 2.9-6.4 3.8-8.3 2.8-1.9-1-1.9-3.5 0-7.4 4.5-9.3 9.2-21.8 14.2-37.7 5-15.8 5.7-26 2.1-30.5-1.1-1.5-2.7-2.6-5-3.6-2.2-.9-5.1-1.5-8.6-1.9s-6.7-.6-9.4-.8c-2.8-.2-6.5-.2-11.2 0-4.7.2-8 .4-10.1.6a874.4 874.4 0 01-17.1 1.5c-1.3.2-2.7.4-4.1.5-1.5.1-2.7.2-3.5.3l-2.7.3c-1 .1-1.7.2-2.2.2h-3.2l-1-.2-.6-.5-.5-.9c-1.3-3.3 3.7-7.4 15-12.4s22.3-8.1 32.9-9.3c9.8-1.5 21.3-1.5 34.5-.3s21.3 3.7 24.3 7.4c2.3 3.5 2.5 10.7.7 21.7z" } }] }, "name": "amazon-circle", "theme": "filled" };
var AmazonCircleFilledSvg = AmazonCircleFilled$2;

var AmazonCircleFilled = function AmazonCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AmazonCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AmazonCircleFilled.displayName = 'AmazonCircleFilled';
}
var AmazonCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(AmazonCircleFilled);

// This icon file is generated automatically.
var AmazonOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M825 768.9c-3.3-.9-7.3-.4-11.9 1.3-61.6 28.2-121.5 48.3-179.7 60.2C507.7 856 385.2 842.6 266 790.3c-33.1-14.6-79.1-39.2-138-74a9.36 9.36 0 00-5.3-2c-2-.1-3.7.1-5.3.9-1.6.8-2.8 1.8-3.7 3.1-.9 1.3-1.1 3.1-.4 5.4.6 2.2 2.1 4.7 4.6 7.4 10.4 12.2 23.3 25.2 38.6 39s35.6 29.4 60.9 46.8c25.3 17.4 51.8 32.9 79.3 46.4 27.6 13.5 59.6 24.9 96.1 34.1s73 13.8 109.4 13.8c36.2 0 71.4-3.7 105.5-10.9 34.2-7.3 63-15.9 86.5-25.9 23.4-9.9 45-21 64.8-33 19.8-12 34.4-22.2 43.9-30.3 9.5-8.2 16.3-14.6 20.2-19.4 4.6-5.7 6.9-10.6 6.9-14.9.1-4.5-1.7-7.1-5-7.9zM527.4 348.1c-15.2 1.3-33.5 4.1-55 8.3-21.5 4.1-41.4 9.3-59.8 15.4s-37.2 14.6-56.3 25.4c-19.2 10.8-35.5 23.2-49 37s-24.5 31.1-33.1 52c-8.6 20.8-12.9 43.7-12.9 68.7 0 27.1 4.7 51.2 14.3 72.5 9.5 21.3 22.2 38 38.2 50.4 15.9 12.4 34 22.1 54 29.2 20 7.1 41.2 10.3 63.2 9.4 22-.9 43.5-4.3 64.4-10.3 20.8-5.9 40.4-15.4 58.6-28.3 18.2-12.9 33.1-28.2 44.8-45.7 4.3 6.6 8.1 11.5 11.5 14.7l8.7 8.9c5.8 5.9 14.7 14.6 26.7 26.1 11.9 11.5 24.1 22.7 36.3 33.7l104.4-99.9-6-4.9c-4.3-3.3-9.4-8-15.2-14.3-5.8-6.2-11.6-13.1-17.2-20.5-5.7-7.4-10.6-16.1-14.7-25.9-4.1-9.8-6.2-19.3-6.2-28.5V258.7c0-10.1-1.9-21-5.7-32.8-3.9-11.7-10.7-24.5-20.7-38.3-10-13.8-22.4-26.2-37.2-37-14.9-10.8-34.7-20-59.6-27.4-24.8-7.4-52.6-11.1-83.2-11.1-31.3 0-60.4 3.7-87.6 10.9-27.1 7.3-50.3 17-69.7 29.2-19.3 12.2-35.9 26.3-49.7 42.4-13.8 16.1-24.1 32.9-30.8 50.4-6.7 17.5-10.1 35.2-10.1 53.1L408 310c5.5-16.4 12.9-30.6 22-42.8 9.2-12.2 17.9-21 25.8-26.5 8-5.5 16.6-9.9 25.7-13.2 9.2-3.3 15.4-5 18.6-5.4 3.2-.3 5.7-.4 7.6-.4 26.7 0 45.2 7.9 55.6 23.6 6.5 9.5 9.7 23.9 9.7 43.3v56.6c-15.2.6-30.4 1.6-45.6 2.9zM573.1 500c0 16.6-2.2 31.7-6.5 45-9.2 29.1-26.7 47.4-52.4 54.8-22.4 6.6-43.7 3.3-63.9-9.8-21.5-14-32.2-33.8-32.2-59.3 0-19.9 5-36.9 15-51.1 10-14.1 23.3-24.7 40-31.7s33-12 49-14.9c15.9-3 33-4.8 51-5.4V500zm335.2 218.9c-4.3-5.4-15.9-8.9-34.9-10.7-19-1.8-35.5-1.7-49.7.4-15.3 1.8-31.1 6.2-47.3 13.4-16.3 7.1-23.4 13.1-21.6 17.8l.7 1.3.9.7 1.4.2h4.6c.8 0 1.8-.1 3.2-.2 1.4-.1 2.7-.3 3.9-.4 1.2-.1 2.9-.3 5.1-.4 2.1-.1 4.1-.4 6-.7.3 0 3.7-.3 10.3-.9 6.6-.6 11.4-1 14.3-1.3 2.9-.3 7.8-.6 14.5-.9 6.7-.3 12.1-.3 16.1 0 4 .3 8.5.7 13.6 1.1 5.1.4 9.2 1.3 12.4 2.7 3.2 1.3 5.6 3 7.1 5.1 5.2 6.6 4.2 21.2-3 43.9s-14 40.8-20.4 54.2c-2.8 5.7-2.8 9.2 0 10.7s6.7.1 11.9-4c15.6-12.2 28.6-30.6 39.1-55.3 6.1-14.6 10.5-29.8 13.1-45.7 2.4-15.9 2-26.2-1.3-31z" } }] }, "name": "amazon", "theme": "outlined" };
var AmazonOutlinedSvg = AmazonOutlined$2;

var AmazonOutlined = function AmazonOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AmazonOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AmazonOutlined.displayName = 'AmazonOutlined';
}
var AmazonOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(AmazonOutlined);

// This icon file is generated automatically.
var AmazonSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM547.8 326.7c-7.2-10.9-20.1-16.4-38.7-16.4-1.3 0-3 .1-5.3.3-2.2.2-6.6 1.5-12.9 3.7a79.4 79.4 0 00-17.9 9.1c-5.5 3.8-11.5 10-18 18.4-6.4 8.5-11.5 18.4-15.3 29.8l-94-8.4c0-12.4 2.4-24.7 7-36.9s11.8-23.9 21.4-35c9.6-11.2 21.1-21 34.5-29.4 13.4-8.5 29.6-15.2 48.4-20.3 18.9-5.1 39.1-7.6 60.9-7.6 21.3 0 40.6 2.6 57.8 7.7 17.2 5.2 31.1 11.5 41.4 19.1a117 117 0 0125.9 25.7c6.9 9.6 11.7 18.5 14.4 26.7 2.7 8.2 4 15.7 4 22.8v182.5c0 6.4 1.4 13 4.3 19.8 2.9 6.8 6.3 12.8 10.2 18 3.9 5.2 7.9 9.9 12 14.3 4.1 4.3 7.6 7.7 10.6 9.9l4.1 3.4-72.5 69.4c-8.5-7.7-16.9-15.4-25.2-23.4-8.3-8-14.5-14-18.5-18.1l-6.1-6.2c-2.4-2.3-5-5.7-8-10.2-8.1 12.2-18.5 22.8-31.1 31.8-12.7 9-26.3 15.6-40.7 19.7-14.5 4.1-29.4 6.5-44.7 7.1-15.3.6-30-1.5-43.9-6.5-13.9-5-26.5-11.7-37.6-20.3-11.1-8.6-19.9-20.2-26.5-35-6.6-14.8-9.9-31.5-9.9-50.4 0-17.4 3-33.3 8.9-47.7 6-14.5 13.6-26.5 23-36.1 9.4-9.6 20.7-18.2 34-25.7s26.4-13.4 39.2-17.7c12.8-4.2 26.6-7.8 41.5-10.7 14.9-2.9 27.6-4.8 38.2-5.7 10.6-.9 21.2-1.6 31.8-2v-39.4c0-13.5-2.3-23.5-6.7-30.1zm180.5 379.6c-2.8 3.3-7.5 7.8-14.1 13.5s-16.8 12.7-30.5 21.1c-13.7 8.4-28.8 16-45 22.9-16.3 6.9-36.3 12.9-60.1 18-23.7 5.1-48.2 7.6-73.3 7.6-25.4 0-50.7-3.2-76.1-9.6-25.4-6.4-47.6-14.3-66.8-23.7-19.1-9.4-37.6-20.2-55.1-32.2-17.6-12.1-31.7-22.9-42.4-32.5-10.6-9.6-19.6-18.7-26.8-27.1-1.7-1.9-2.8-3.6-3.2-5.1-.4-1.5-.3-2.8.3-3.7.6-.9 1.5-1.6 2.6-2.2a7.42 7.42 0 017.4.8c40.9 24.2 72.9 41.3 95.9 51.4 82.9 36.4 168 45.7 255.3 27.9 40.5-8.3 82.1-22.2 124.9-41.8 3.2-1.2 6-1.5 8.3-.9 2.3.6 3.5 2.4 3.5 5.4 0 2.8-1.6 6.3-4.8 10.2zm59.9-29c-1.8 11.1-4.9 21.6-9.1 31.8-7.2 17.1-16.3 30-27.1 38.4-3.6 2.9-6.4 3.8-8.3 2.8-1.9-1-1.9-3.5 0-7.4 4.5-9.3 9.2-21.8 14.2-37.7 5-15.8 5.7-26 2.1-30.5-1.1-1.5-2.7-2.6-5-3.6-2.2-.9-5.1-1.5-8.6-1.9s-6.7-.6-9.4-.8c-2.8-.2-6.5-.2-11.2 0-4.7.2-8 .4-10.1.6a874.4 874.4 0 01-17.1 1.5c-1.3.2-2.7.4-4.1.5-1.5.1-2.7.2-3.5.3l-2.7.3c-1 .1-1.7.2-2.2.2h-3.2l-1-.2-.6-.5-.5-.9c-1.3-3.3 3.7-7.4 15-12.4s22.3-8.1 32.9-9.3c9.8-1.5 21.3-1.5 34.5-.3s21.3 3.7 24.3 7.4c2.3 3.5 2.5 10.7.7 21.7zM485 467.5c-11.6 4.9-20.9 12.2-27.8 22-6.9 9.8-10.4 21.6-10.4 35.5 0 17.8 7.5 31.5 22.4 41.2 14.1 9.1 28.9 11.4 44.4 6.8 17.9-5.2 30-17.9 36.4-38.1 3-9.3 4.5-19.7 4.5-31.3v-50.2c-12.6.4-24.4 1.6-35.5 3.7-11.1 2.1-22.4 5.6-34 10.4z" } }] }, "name": "amazon-square", "theme": "filled" };
var AmazonSquareFilledSvg = AmazonSquareFilled$2;

var AmazonSquareFilled = function AmazonSquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AmazonSquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AmazonSquareFilled.displayName = 'AmazonSquareFilled';
}
var AmazonSquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(AmazonSquareFilled);

// This icon file is generated automatically.
var AndroidFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M270.1 741.7c0 23.4 19.1 42.5 42.6 42.5h48.7v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h85v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h48.7c23.5 0 42.6-19.1 42.6-42.5V346.4h-486v395.3zm357.1-600.1l44.9-65c2.6-3.8 2-8.9-1.5-11.4-3.5-2.4-8.5-1.2-11.1 2.6l-46.6 67.6c-30.7-12.1-64.9-18.8-100.8-18.8-35.9 0-70.1 6.7-100.8 18.8l-46.6-67.5c-2.6-3.8-7.6-5.1-11.1-2.6-3.5 2.4-4.1 7.4-1.5 11.4l44.9 65c-71.4 33.2-121.4 96.1-127.8 169.6h486c-6.6-73.6-56.7-136.5-128-169.7zM409.5 244.1a26.9 26.9 0 1126.9-26.9 26.97 26.97 0 01-26.9 26.9zm208.4 0a26.9 26.9 0 1126.9-26.9 26.97 26.97 0 01-26.9 26.9zm223.4 100.7c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c.1-30.6-24.3-55.3-54.6-55.3zm-658.6 0c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c0-30.6-24.5-55.3-54.6-55.3z" } }] }, "name": "android", "theme": "filled" };
var AndroidFilledSvg = AndroidFilled$2;

var AndroidFilled = function AndroidFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AndroidFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AndroidFilled.displayName = 'AndroidFilled';
}
var AndroidFilled$1 = /*#__PURE__*/React__namespace.forwardRef(AndroidFilled);

// This icon file is generated automatically.
var AndroidOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M448.3 225.2c-18.6 0-32 13.4-32 31.9s13.5 31.9 32 31.9c18.6 0 32-13.4 32-31.9.1-18.4-13.4-31.9-32-31.9zm393.9 96.4c-13.8-13.8-32.7-21.5-53.2-21.5-3.9 0-7.4.4-10.7 1v-1h-3.6c-5.5-30.6-18.6-60.5-38.1-87.4-18.7-25.7-43-47.9-70.8-64.9l25.1-35.8v-3.3c0-.8.4-2.3.7-3.8.6-2.4 1.4-5.5 1.4-8.9 0-18.5-13.5-31.9-32-31.9-9.8 0-19.5 5.7-25.9 15.4l-29.3 42.1c-30-9.8-62.4-15-93.8-15-31.3 0-63.7 5.2-93.8 15L389 79.4c-6.6-9.6-16.1-15.4-26-15.4-18.6 0-32 13.4-32 31.9 0 6.2 2.5 12.8 6.7 17.4l22.6 32.3c-28.7 17-53.5 39.4-72.2 65.1-19.4 26.9-32 56.8-36.7 87.4h-5.5v1c-3.2-.6-6.7-1-10.7-1-20.3 0-39.2 7.5-53.1 21.3-13.8 13.8-21.5 32.6-21.5 53v235c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 3.9 0 7.4-.4 10.7-1v93.5c0 29.2 23.9 53.1 53.2 53.1H331v58.3c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 20.3 0 39.2-7.5 53.1-21.3 13.8-13.8 21.5-32.6 21.5-53v-58.2H544v58.1c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 20.4 0 39.2-7.5 53.1-21.6 13.8-13.8 21.5-32.6 21.5-53v-58.2h31.9c29.3 0 53.2-23.8 53.2-53.1v-91.4c3.2.6 6.7 1 10.7 1 20.3 0 39.2-7.5 53.1-21.3 13.8-13.8 21.5-32.6 21.5-53v-235c-.1-20.3-7.6-39-21.4-52.9zM246 609.6c0 6.8-3.9 10.6-10.7 10.6-6.8 0-10.7-3.8-10.7-10.6V374.5c0-6.8 3.9-10.6 10.7-10.6 6.8 0 10.7 3.8 10.7 10.6v235.1zm131.1-396.8c37.5-27.3 85.3-42.3 135-42.3s97.5 15.1 135 42.5c32.4 23.7 54.2 54.2 62.7 87.5H314.4c8.5-33.4 30.5-64 62.7-87.7zm39.3 674.7c-.6 5.6-4.4 8.7-10.5 8.7-6.8 0-10.7-3.8-10.7-10.6v-58.2h21.2v60.1zm202.3 8.7c-6.8 0-10.7-3.8-10.7-10.6v-58.2h21.2v60.1c-.6 5.6-4.3 8.7-10.5 8.7zm95.8-132.6H309.9V364h404.6v399.6zm85.2-154c0 6.8-3.9 10.6-10.7 10.6-6.8 0-10.7-3.8-10.7-10.6V374.5c0-6.8 3.9-10.6 10.7-10.6 6.8 0 10.7 3.8 10.7 10.6v235.1zM576.1 225.2c-18.6 0-32 13.4-32 31.9s13.5 31.9 32 31.9c18.6 0 32.1-13.4 32.1-32-.1-18.6-13.4-31.8-32.1-31.8z" } }] }, "name": "android", "theme": "outlined" };
var AndroidOutlinedSvg = AndroidOutlined$2;

var AndroidOutlined = function AndroidOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AndroidOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AndroidOutlined.displayName = 'AndroidOutlined';
}
var AndroidOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(AndroidOutlined);

// This icon file is generated automatically.
var AntCloudOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M378.9 738c-3.1 0-6.1-.5-8.8-1.5l4.4 30.7h26.3l-15.5-29.9c-2.1.5-4.2.7-6.4.7zm421-291.2c-12.6 0-24.8 1.5-36.5 4.2-21.4-38.4-62.3-64.3-109.3-64.3-6.9 0-13.6.6-20.2 1.6-35.4-77.4-113.4-131.1-203.9-131.1-112.3 0-205.3 82.6-221.6 190.4C127.3 455.5 64 523.8 64 607c0 88.4 71.6 160.1 160 160.2h50l13.2-27.6c-26.2-8.3-43.3-29-39.1-48.8 4.6-21.6 32.8-33.9 63.1-27.5 22.9 4.9 40.4 19.1 45.5 35.1a26.1 26.1 0 0122.1-12.4h.2c-.8-3.2-1.2-6.5-1.2-9.9 0-20.1 14.8-36.7 34.1-39.6v-25.4c0-4.4 3.6-8 8-8s8 3.6 8 8v26.3c4.6 1.2 8.8 3.2 12.6 5.8l19.5-21.4c3-3.3 8-3.5 11.3-.5 3.3 3 3.5 8 .5 11.3l-20 22-.2.2a40 40 0 01-46.9 59.2c-.4 5.6-2.6 10.7-6 14.8l20 38.4H804v-.1c86.5-2.2 156-73 156-160.1 0-88.5-71.7-160.2-160.1-160.2zM338.2 737.2l-4.3 30h24.4l-5.9-41.5c-3.5 4.6-8.3 8.5-14.2 11.5zM797.5 305a48 48 0 1096 0 48 48 0 10-96 0zm-65.7 61.3a24 24 0 1048 0 24 24 0 10-48 0zM303.4 742.9l-11.6 24.3h26l3.5-24.7c-5.7.8-11.7 1-17.9.4z" } }] }, "name": "ant-cloud", "theme": "outlined" };
var AntCloudOutlinedSvg = AntCloudOutlined$2;

var AntCloudOutlined = function AntCloudOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AntCloudOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AntCloudOutlined.displayName = 'AntCloudOutlined';
}
var AntCloudOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(AntCloudOutlined);

// This icon file is generated automatically.
var AntDesignOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M716.3 313.8c19-18.9 19-49.7 0-68.6l-69.9-69.9.1.1c-18.5-18.5-50.3-50.3-95.3-95.2-21.2-20.7-55.5-20.5-76.5.5L80.9 474.2a53.84 53.84 0 000 76.4L474.6 944a54.14 54.14 0 0076.5 0l165.1-165c19-18.9 19-49.7 0-68.6a48.7 48.7 0 00-68.7 0l-125 125.2c-5.2 5.2-13.3 5.2-18.5 0L189.5 521.4c-5.2-5.2-5.2-13.3 0-18.5l314.4-314.2c.4-.4.9-.7 1.3-1.1 5.2-4.1 12.4-3.7 17.2 1.1l125.2 125.1c19 19 49.8 19 68.7 0zM408.6 514.4a106.3 106.2 0 10212.6 0 106.3 106.2 0 10-212.6 0zm536.2-38.6L821.9 353.5c-19-18.9-49.8-18.9-68.7.1a48.4 48.4 0 000 68.6l83 82.9c5.2 5.2 5.2 13.3 0 18.5l-81.8 81.7a48.4 48.4 0 000 68.6 48.7 48.7 0 0068.7 0l121.8-121.7a53.93 53.93 0 00-.1-76.4z" } }] }, "name": "ant-design", "theme": "outlined" };
var AntDesignOutlinedSvg = AntDesignOutlined$2;

var AntDesignOutlined = function AntDesignOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AntDesignOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AntDesignOutlined.displayName = 'AntDesignOutlined';
}
var AntDesignOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(AntDesignOutlined);

// This icon file is generated automatically.
var ApartmentOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M908 640H804V488c0-4.4-3.6-8-8-8H548v-96h108c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h108v96H228c-4.4 0-8 3.6-8 8v152H116c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16H292v-88h440v88H620c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16zm-564 76v168H176V716h168zm84-408V140h168v168H428zm420 576H680V716h168v168z" } }] }, "name": "apartment", "theme": "outlined" };
var ApartmentOutlinedSvg = ApartmentOutlined$2;

var ApartmentOutlined = function ApartmentOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ApartmentOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ApartmentOutlined.displayName = 'ApartmentOutlined';
}
var ApartmentOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ApartmentOutlined);

// This icon file is generated automatically.
var ApiFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 00-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 000 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM578.9 546.7a8.03 8.03 0 00-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 00-11.3 0L363 475.3l-43-43a7.85 7.85 0 00-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 68.9-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 000 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2z" } }] }, "name": "api", "theme": "filled" };
var ApiFilledSvg = ApiFilled$2;

var ApiFilled = function ApiFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ApiFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ApiFilled.displayName = 'ApiFilled';
}
var ApiFilled$1 = /*#__PURE__*/React__namespace.forwardRef(ApiFilled);

// This icon file is generated automatically.
var ApiOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 00-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 000 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4-186.8-186.8 59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7 35.3 0 68.4 13.7 93.4 38.7 24.9 24.9 38.7 58.1 38.7 93.4 0 35.3-13.8 68.4-38.7 93.4zm-190.2 105a8.03 8.03 0 00-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 00-11.3 0L363 475.3l-43-43a7.85 7.85 0 00-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 69-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 000 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 01-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7a131.32 131.32 0 01-38.7-93.4c0-35.3 13.7-68.4 38.7-93.4l59.4-59.4 186.8 186.8-59.4 59.4z" } }] }, "name": "api", "theme": "outlined" };
var ApiOutlinedSvg = ApiOutlined$2;

var ApiOutlined = function ApiOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ApiOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ApiOutlined.displayName = 'ApiOutlined';
}
var ApiOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ApiOutlined);

// This icon file is generated automatically.
var ApiTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M148.2 674.6zm106.7-92.3c-25 25-38.7 58.1-38.7 93.4s13.8 68.5 38.7 93.4c25 25 58.1 38.7 93.4 38.7 35.3 0 68.5-13.8 93.4-38.7l59.4-59.4-186.8-186.8-59.4 59.4zm420.8-366.1c-35.3 0-68.5 13.8-93.4 38.7l-59.4 59.4 186.8 186.8 59.4-59.4c24.9-25 38.7-58.1 38.7-93.4s-13.8-68.5-38.7-93.4c-25-25-58.1-38.7-93.4-38.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M578.9 546.7a8.03 8.03 0 00-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 00-11.3 0L363 475.3l-43-43a7.85 7.85 0 00-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2a199.45 199.45 0 00-58.6 140.4c-.2 39.5 11.2 79.1 34.3 113.1l-76.1 76.1a8.03 8.03 0 000 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 01-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7-24.9-24.9-38.7-58.1-38.7-93.4s13.7-68.4 38.7-93.4l59.4-59.4 186.8 186.8-59.4 59.4zm476-620.3l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 00-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 000 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4-186.8-186.8 59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7s68.4 13.7 93.4 38.7c24.9 24.9 38.7 58.1 38.7 93.4s-13.8 68.4-38.7 93.4z", "fill": primaryColor } }] }; }, "name": "api", "theme": "twotone" };
var ApiTwoToneSvg = ApiTwoTone$2;

var ApiTwoTone = function ApiTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ApiTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ApiTwoTone.displayName = 'ApiTwoTone';
}
var ApiTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(ApiTwoTone);

// This icon file is generated automatically.
var AppleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-105.1-305c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z" } }] }, "name": "apple", "theme": "filled" };
var AppleFilledSvg = AppleFilled$2;

var AppleFilled = function AppleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AppleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AppleFilled.displayName = 'AppleFilled';
}
var AppleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(AppleFilled);

// This icon file is generated automatically.
var AppleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-10.6 267c-14.3 19.9-28.7 35.6-41.9 45.7-10.5 8-18.6 11.4-24 11.6-9-.1-17.7-2.3-34.7-8.8-1.2-.5-2.5-1-4.2-1.6l-4.4-1.7c-17.4-6.7-27.8-10.3-41.1-13.8-18.6-4.8-37.1-7.4-56.9-7.4-20.2 0-39.2 2.5-58.1 7.2-13.9 3.5-25.6 7.4-42.7 13.8-.7.3-8.1 3.1-10.2 3.9-3.5 1.3-6.2 2.3-8.7 3.2-10.4 3.6-17 5.1-22.9 5.2-.7 0-1.3-.1-1.8-.2-1.1-.2-2.5-.6-4.1-1.3-4.5-1.8-9.9-5.1-16-9.8-14-10.9-29.4-28-45.1-49.9-27.5-38.6-53.5-89.8-66-125.7-15.4-44.8-23-87.7-23-128.6 0-60.2 17.8-106 48.4-137.1 26.3-26.6 61.7-41.5 97.8-42.3 5.9.1 14.5 1.5 25.4 4.5 8.6 2.3 18 5.4 30.7 9.9 3.8 1.4 16.9 6.1 18.5 6.7 7.7 2.8 13.5 4.8 19.2 6.6 18.2 5.8 32.3 9 47.6 9 15.5 0 28.8-3.3 47.7-9.8 7.1-2.4 32.9-12 37.5-13.6 25.6-9.1 44.5-14 60.8-15.2 4.8-.4 9.1-.4 13.2-.1 22.7 1.8 42.1 6.3 58.6 13.8-37.6 43.4-57 96.5-56.9 158.4-.3 14.7.9 31.7 5.1 51.8 6.4 30.5 18.6 60.7 37.9 89 14.7 21.5 32.9 40.9 54.7 57.8-11.5 23.7-25.6 48.2-40.4 68.8zm-94.5-572c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z" } }] }, "name": "apple", "theme": "outlined" };
var AppleOutlinedSvg = AppleOutlined$2;

var AppleOutlined = function AppleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AppleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AppleOutlined.displayName = 'AppleOutlined';
}
var AppleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(AppleOutlined);

// This icon file is generated automatically.
var AppstoreAddOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zm52 132H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200zM424 712H296V584c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v128H104c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h128v128c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V776h128c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }] }, "name": "appstore-add", "theme": "outlined" };
var AppstoreAddOutlinedSvg = AppstoreAddOutlined$2;

var AppstoreAddOutlined = function AppstoreAddOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AppstoreAddOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AppstoreAddOutlined.displayName = 'AppstoreAddOutlined';
}
var AppstoreAddOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(AppstoreAddOutlined);

// This icon file is generated automatically.
var AppstoreFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm0 400H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zM464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm0 400H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16z" } }] }, "name": "appstore", "theme": "filled" };
var AppstoreFilledSvg = AppstoreFilled$2;

var AppstoreFilled = function AppstoreFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AppstoreFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AppstoreFilled.displayName = 'AppstoreFilled';
}
var AppstoreFilled$1 = /*#__PURE__*/React__namespace.forwardRef(AppstoreFilled);

// This icon file is generated automatically.
var AppstoreOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z" } }] }, "name": "appstore", "theme": "outlined" };
var AppstoreOutlinedSvg = AppstoreOutlined$2;

var AppstoreOutlined = function AppstoreOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AppstoreOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AppstoreOutlined.displayName = 'AppstoreOutlined';
}
var AppstoreOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(AppstoreOutlined);

// This icon file is generated automatically.
var AppstoreTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm52-668H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452 132H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M212 212h200v200H212zm400 0h200v200H612zM212 612h200v200H212zm400 0h200v200H612z", "fill": secondaryColor } }] }; }, "name": "appstore", "theme": "twotone" };
var AppstoreTwoToneSvg = AppstoreTwoTone$2;

var AppstoreTwoTone = function AppstoreTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AppstoreTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AppstoreTwoTone.displayName = 'AppstoreTwoTone';
}
var AppstoreTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(AppstoreTwoTone);

// This icon file is generated automatically.
var AreaChartOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-616-64h536c4.4 0 8-3.6 8-8V284c0-7.2-8.7-10.7-13.7-5.7L592 488.6l-125.4-124a8.03 8.03 0 00-11.3 0l-189 189.6a7.87 7.87 0 00-2.3 5.6V720c0 4.4 3.6 8 8 8z" } }] }, "name": "area-chart", "theme": "outlined" };
var AreaChartOutlinedSvg = AreaChartOutlined$2;

var AreaChartOutlined = function AreaChartOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AreaChartOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AreaChartOutlined.displayName = 'AreaChartOutlined';
}
var AreaChartOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(AreaChartOutlined);

// This icon file is generated automatically.
var ArrowDownOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M862 465.3h-81c-4.6 0-9 2-12.1 5.5L550 723.1V160c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v563.1L255.1 470.8c-3-3.5-7.4-5.5-12.1-5.5h-81c-6.8 0-10.5 8.1-6 13.2L487.9 861a31.96 31.96 0 0048.3 0L868 478.5c4.5-5.2.8-13.2-6-13.2z" } }] }, "name": "arrow-down", "theme": "outlined" };
var ArrowDownOutlinedSvg = ArrowDownOutlined$2;

var ArrowDownOutlined = function ArrowDownOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ArrowDownOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ArrowDownOutlined.displayName = 'ArrowDownOutlined';
}
var ArrowDownOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ArrowDownOutlined);

// This icon file is generated automatically.
var ArrowLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 000 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] }, "name": "arrow-left", "theme": "outlined" };
var ArrowLeftOutlinedSvg = ArrowLeftOutlined$2;

var ArrowLeftOutlined = function ArrowLeftOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ArrowLeftOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ArrowLeftOutlined.displayName = 'ArrowLeftOutlined';
}
var ArrowLeftOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ArrowLeftOutlined);

// This icon file is generated automatically.
var ArrowRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 000-48.4z" } }] }, "name": "arrow-right", "theme": "outlined" };
var ArrowRightOutlinedSvg = ArrowRightOutlined$2;

var ArrowRightOutlined = function ArrowRightOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ArrowRightOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ArrowRightOutlined.displayName = 'ArrowRightOutlined';
}
var ArrowRightOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ArrowRightOutlined);

// This icon file is generated automatically.
var ArrowUpOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M868 545.5L536.1 163a31.96 31.96 0 00-48.3 0L156 545.5a7.97 7.97 0 006 13.2h81c4.6 0 9-2 12.1-5.5L474 300.9V864c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V300.9l218.9 252.3c3 3.5 7.4 5.5 12.1 5.5h81c6.8 0 10.5-8 6-13.2z" } }] }, "name": "arrow-up", "theme": "outlined" };
var ArrowUpOutlinedSvg = ArrowUpOutlined$2;

var ArrowUpOutlined = function ArrowUpOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ArrowUpOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ArrowUpOutlined.displayName = 'ArrowUpOutlined';
}
var ArrowUpOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ArrowUpOutlined);

// This icon file is generated automatically.
var ArrowsAltOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M855 160.1l-189.2 23.5c-6.6.8-9.3 8.8-4.7 13.5l54.7 54.7-153.5 153.5a8.03 8.03 0 000 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l153.6-153.6 54.7 54.7a7.94 7.94 0 0013.5-4.7L863.9 169a7.9 7.9 0 00-8.9-8.9zM416.6 562.3a8.03 8.03 0 00-11.3 0L251.8 715.9l-54.7-54.7a7.94 7.94 0 00-13.5 4.7L160.1 855c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 153.6-153.6c3.1-3.1 3.1-8.2 0-11.3l-45.2-45z" } }] }, "name": "arrows-alt", "theme": "outlined" };
var ArrowsAltOutlinedSvg = ArrowsAltOutlined$2;

var ArrowsAltOutlined = function ArrowsAltOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ArrowsAltOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ArrowsAltOutlined.displayName = 'ArrowsAltOutlined';
}
var ArrowsAltOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ArrowsAltOutlined);

// This icon file is generated automatically.
var AudioFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm330-170c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z" } }] }, "name": "audio", "theme": "filled" };
var AudioFilledSvg = AudioFilled$2;

var AudioFilled = function AudioFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AudioFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AudioFilled.displayName = 'AudioFilled';
}
var AudioFilled$1 = /*#__PURE__*/React__namespace.forwardRef(AudioFilled);

// This icon file is generated automatically.
var AudioMutedOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M682 455V311l-76 76v68c-.1 50.7-42 92.1-94 92a95.8 95.8 0 01-52-15l-54 55c29.1 22.4 65.9 36 106 36 93.8 0 170-75.1 170-168z" } }, { "tag": "path", "attrs": { "d": "M833 446h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254-63 0-120.7-23-165-61l-54 54a334.01 334.01 0 00179 81v102H326c-13.9 0-24.9 14.3-25 32v36c.1 4.4 2.9 8 6 8h408c3.2 0 6-3.6 6-8v-36c0-17.7-11-32-25-32H547V782c165.3-17.9 294-157.9 294-328 0-4.4-3.6-8-8-8zm13.1-377.7l-43.5-41.9a8 8 0 00-11.2.1l-129 129C634.3 101.2 577 64 511 64c-93.9 0-170 75.3-170 168v224c0 6.7.4 13.3 1.2 19.8l-68 68A252.33 252.33 0 01258 454c-.2-4.4-3.8-8-8-8h-60c-4.4 0-8 3.6-8 8 0 53 12.5 103 34.6 147.4l-137 137a8.03 8.03 0 000 11.3l42.7 42.7c3.1 3.1 8.2 3.1 11.3 0L846.2 79.8l.1-.1c3.1-3.2 3-8.3-.2-11.4zM417 401V232c0-50.6 41.9-92 94-92 46 0 84.1 32.3 92.3 74.7L417 401z" } }] }, "name": "audio-muted", "theme": "outlined" };
var AudioMutedOutlinedSvg = AudioMutedOutlined$2;

var AudioMutedOutlined = function AudioMutedOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AudioMutedOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AudioMutedOutlined.displayName = 'AudioMutedOutlined';
}
var AudioMutedOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(AudioMutedOutlined);

// This icon file is generated automatically.
var AudioOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M842 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1zM512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm-94-392c0-50.6 41.9-92 94-92s94 41.4 94 92v224c0 50.6-41.9 92-94 92s-94-41.4-94-92V232z" } }] }, "name": "audio", "theme": "outlined" };
var AudioOutlinedSvg = AudioOutlined$2;

var AudioOutlined = function AudioOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AudioOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AudioOutlined.displayName = 'AudioOutlined';
}
var AudioOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(AudioOutlined);

// This icon file is generated automatically.
var AudioTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 552c54.3 0 98-43.2 98-96V232c0-52.8-43.7-96-98-96s-98 43.2-98 96v224c0 52.8 43.7 96 98 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M842 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm-98-392c0-52.8 43.7-96 98-96s98 43.2 98 96v224c0 52.8-43.7 96-98 96s-98-43.2-98-96V232z", "fill": primaryColor } }] }; }, "name": "audio", "theme": "twotone" };
var AudioTwoToneSvg = AudioTwoTone$2;

var AudioTwoTone = function AudioTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AudioTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AudioTwoTone.displayName = 'AudioTwoTone';
}
var AudioTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(AudioTwoTone);

// This icon file is generated automatically.
var AuditOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M296 250c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm184 144H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 458H208V148h560v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm440-88H728v-36.6c46.3-13.8 80-56.6 80-107.4 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 50.7 33.7 93.6 80 107.4V764H520c-8.8 0-16 7.2-16 16v152c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16V780c0-8.8-7.2-16-16-16zM646 620c0-27.6 22.4-50 50-50s50 22.4 50 50-22.4 50-50 50-50-22.4-50-50zm180 266H566v-60h260v60z" } }] }, "name": "audit", "theme": "outlined" };
var AuditOutlinedSvg = AuditOutlined$2;

var AuditOutlined = function AuditOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AuditOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  AuditOutlined.displayName = 'AuditOutlined';
}
var AuditOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(AuditOutlined);

// This icon file is generated automatically.
var BackwardFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M485.6 249.9L198.2 498c-8.3 7.1-8.3 20.8 0 27.9l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9zm320 0L518.2 498a18.6 18.6 0 00-6.2 14c0 5.2 2.1 10.4 6.2 14l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9z" } }] }, "name": "backward", "theme": "filled" };
var BackwardFilledSvg = BackwardFilled$2;

var BackwardFilled = function BackwardFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BackwardFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BackwardFilled.displayName = 'BackwardFilled';
}
var BackwardFilled$1 = /*#__PURE__*/React__namespace.forwardRef(BackwardFilled);

// This icon file is generated automatically.
var BackwardOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M485.6 249.9L198.2 498c-8.3 7.1-8.3 20.8 0 27.9l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9zm320 0L518.2 498a18.6 18.6 0 00-6.2 14c0 5.2 2.1 10.4 6.2 14l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9z" } }] }, "name": "backward", "theme": "outlined" };
var BackwardOutlinedSvg = BackwardOutlined$2;

var BackwardOutlined = function BackwardOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BackwardOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BackwardOutlined.displayName = 'BackwardOutlined';
}
var BackwardOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(BackwardOutlined);

// This icon file is generated automatically.
var BankFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 00-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM381 836H264V462h117v374zm189 0H453V462h117v374zm190 0H642V462h118v374z" } }] }, "name": "bank", "theme": "filled" };
var BankFilledSvg = BankFilled$2;

var BankFilled = function BankFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BankFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BankFilled.displayName = 'BankFilled';
}
var BankFilled$1 = /*#__PURE__*/React__namespace.forwardRef(BankFilled);

// This icon file is generated automatically.
var BankOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 00-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM512 196.7l271.1 197.2H240.9L512 196.7zM264 462h117v374H264V462zm189 0h117v374H453V462zm307 374H642V462h118v374z" } }] }, "name": "bank", "theme": "outlined" };
var BankOutlinedSvg = BankOutlined$2;

var BankOutlined = function BankOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BankOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BankOutlined.displayName = 'BankOutlined';
}
var BankOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(BankOutlined);

// This icon file is generated automatically.
var BankTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M240.9 393.9h542.2L512 196.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 00-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM381 836H264V462h117v374zm189 0H453V462h117v374zm190 0H642V462h118v374zM240.9 393.9L512 196.7l271.1 197.2H240.9z", "fill": primaryColor } }] }; }, "name": "bank", "theme": "twotone" };
var BankTwoToneSvg = BankTwoTone$2;

var BankTwoTone = function BankTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BankTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BankTwoTone.displayName = 'BankTwoTone';
}
var BankTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(BankTwoTone);

// This icon file is generated automatically.
var BarChartOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-600-80h56c4.4 0 8-3.6 8-8V560c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V384c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v320c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V462c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v242c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v400c0 4.4 3.6 8 8 8z" } }] }, "name": "bar-chart", "theme": "outlined" };
var BarChartOutlinedSvg = BarChartOutlined$2;

var BarChartOutlined = function BarChartOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BarChartOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BarChartOutlined.displayName = 'BarChartOutlined';
}
var BarChartOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(BarChartOutlined);

// This icon file is generated automatically.
var BarcodeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M120 160H72c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm833 0h-48c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zM200 736h112c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm321 0h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm126 0h178c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H647c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm-255 0h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm-79 64H201c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm257 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm256 0H648c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h178c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-385 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }] }, "name": "barcode", "theme": "outlined" };
var BarcodeOutlinedSvg = BarcodeOutlined$2;

var BarcodeOutlined = function BarcodeOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BarcodeOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BarcodeOutlined.displayName = 'BarcodeOutlined';
}
var BarcodeOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(BarcodeOutlined);

// This icon file is generated automatically.
var BarsOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "bars", "theme": "outlined" };
var BarsOutlinedSvg = BarsOutlined$2;

var BarsOutlined = function BarsOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BarsOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BarsOutlined.displayName = 'BarsOutlined';
}
var BarsOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(BarsOutlined);

// This icon file is generated automatically.
var BehanceCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M420.3 470.3c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 00-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1a50.5 50.5 0 0017.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm86.5 286.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 01-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 01-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 01-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0138.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 00-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7z" } }] }, "name": "behance-circle", "theme": "filled" };
var BehanceCircleFilledSvg = BehanceCircleFilled$2;

var BehanceCircleFilled = function BehanceCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BehanceCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BehanceCircleFilled.displayName = 'BehanceCircleFilled';
}
var BehanceCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(BehanceCircleFilled);

// This icon file is generated automatically.
var BehanceOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M634 294.3h199.5v48.4H634zM434.1 485.8c44.1-21.1 67.2-53.2 67.2-102.8 0-98.1-73-121.9-157.3-121.9H112v492.4h238.5c89.4 0 173.3-43 173.3-143 0-61.8-29.2-107.5-89.7-124.7zM220.2 345.1h101.5c39.1 0 74.2 10.9 74.2 56.3 0 41.8-27.3 58.6-66 58.6H220.2V345.1zm115.5 324.8H220.1V534.3H338c47.6 0 77.7 19.9 77.7 70.3 0 49.6-35.9 65.3-80 65.3zm575.8-89.5c0-105.5-61.7-193.4-173.3-193.4-108.5 0-182.3 81.7-182.3 188.8 0 111 69.9 187.2 182.3 187.2 85.1 0 140.2-38.3 166.7-120h-86.3c-9.4 30.5-47.6 46.5-77.3 46.5-57.4 0-87.4-33.6-87.4-90.7h256.9c.3-5.9.7-12.1.7-18.4zM653.9 537c3.1-46.9 34.4-76.2 81.2-76.2 49.2 0 73.8 28.9 78.1 76.2H653.9z" } }] }, "name": "behance", "theme": "outlined" };
var BehanceOutlinedSvg = BehanceOutlined$2;

var BehanceOutlined = function BehanceOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BehanceOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BehanceOutlined.displayName = 'BehanceOutlined';
}
var BehanceOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(BehanceOutlined);

// This icon file is generated automatically.
var BehanceSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM598.5 350.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 01-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 01-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 01-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0138.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 00-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7zm-248.5-10.1c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 00-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1s12.7-3.8 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8z" } }] }, "name": "behance-square", "theme": "filled" };
var BehanceSquareFilledSvg = BehanceSquareFilled$2;

var BehanceSquareFilled = function BehanceSquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BehanceSquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BehanceSquareFilled.displayName = 'BehanceSquareFilled';
}
var BehanceSquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(BehanceSquareFilled);

// This icon file is generated automatically.
var BehanceSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM598.5 350.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 01-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 01-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 01-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0138.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 00-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7zm-248.5-10.1c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 00-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1s12.7-3.8 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8z" } }] }, "name": "behance-square", "theme": "outlined" };
var BehanceSquareOutlinedSvg = BehanceSquareOutlined$2;

var BehanceSquareOutlined = function BehanceSquareOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BehanceSquareOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BehanceSquareOutlined.displayName = 'BehanceSquareOutlined';
}
var BehanceSquareOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(BehanceSquareOutlined);

// This icon file is generated automatically.
var BellFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M816 768h-24V428c0-141.1-104.3-257.8-240-277.2V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.8C336.3 170.2 232 286.9 232 428v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48z" } }] }, "name": "bell", "theme": "filled" };
var BellFilledSvg = BellFilled$2;

var BellFilled = function BellFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BellFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BellFilled.displayName = 'BellFilled';
}
var BellFilled$1 = /*#__PURE__*/React__namespace.forwardRef(BellFilled);

// This icon file is generated automatically.
var BellOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M816 768h-24V428c0-141.1-104.3-257.7-240-277.1V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.9c-135.7 19.4-240 136-240 277.1v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zM304 768V428c0-55.6 21.6-107.8 60.9-147.1S456.4 220 512 220c55.6 0 107.8 21.6 147.1 60.9S720 372.4 720 428v340H304z" } }] }, "name": "bell", "theme": "outlined" };
var BellOutlinedSvg = BellOutlined$2;

var BellOutlined = function BellOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BellOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BellOutlined.displayName = 'BellOutlined';
}
var BellOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(BellOutlined);

// This icon file is generated automatically.
var BellTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 220c-55.6 0-107.8 21.6-147.1 60.9S304 372.4 304 428v340h416V428c0-55.6-21.6-107.8-60.9-147.1S567.6 220 512 220zm280 208c0-141.1-104.3-257.8-240-277.2v.1c135.7 19.4 240 136 240 277.1zM472 150.9v-.1C336.3 170.2 232 286.9 232 428c0-141.1 104.3-257.7 240-277.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M816 768h-24V428c0-141.1-104.3-257.7-240-277.1V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.9c-135.7 19.4-240 136-240 277.1v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zm208-120H304V428c0-55.6 21.6-107.8 60.9-147.1S456.4 220 512 220c55.6 0 107.8 21.6 147.1 60.9S720 372.4 720 428v340z", "fill": primaryColor } }] }; }, "name": "bell", "theme": "twotone" };
var BellTwoToneSvg = BellTwoTone$2;

var BellTwoTone = function BellTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BellTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BellTwoTone.displayName = 'BellTwoTone';
}
var BellTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(BellTwoTone);

// This icon file is generated automatically.
var BgColorsOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M766.4 744.3c43.7 0 79.4-36.2 79.4-80.5 0-53.5-79.4-140.8-79.4-140.8S687 610.3 687 663.8c0 44.3 35.7 80.5 79.4 80.5zm-377.1-44.1c7.1 7.1 18.6 7.1 25.6 0l256.1-256c7.1-7.1 7.1-18.6 0-25.6l-256-256c-.6-.6-1.3-1.2-2-1.7l-78.2-78.2a9.11 9.11 0 00-12.8 0l-48 48a9.11 9.11 0 000 12.8l67.2 67.2-207.8 207.9c-7.1 7.1-7.1 18.6 0 25.6l255.9 256zm12.9-448.6l178.9 178.9H223.4l178.8-178.9zM904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8z" } }] }, "name": "bg-colors", "theme": "outlined" };
var BgColorsOutlinedSvg = BgColorsOutlined$2;

var BgColorsOutlined = function BgColorsOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BgColorsOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BgColorsOutlined.displayName = 'BgColorsOutlined';
}
var BgColorsOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(BgColorsOutlined);

// This icon file is generated automatically.
var BlockOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M856 376H648V168c0-8.8-7.2-16-16-16H168c-8.8 0-16 7.2-16 16v464c0 8.8 7.2 16 16 16h208v208c0 8.8 7.2 16 16 16h464c8.8 0 16-7.2 16-16V392c0-8.8-7.2-16-16-16zm-480 16v188H220V220h360v156H392c-8.8 0-16 7.2-16 16zm204 52v136H444V444h136zm224 360H444V648h188c8.8 0 16-7.2 16-16V444h156v360z" } }] }, "name": "block", "theme": "outlined" };
var BlockOutlinedSvg = BlockOutlined$2;

var BlockOutlined = function BlockOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BlockOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BlockOutlined.displayName = 'BlockOutlined';
}
var BlockOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(BlockOutlined);

// This icon file is generated automatically.
var BoldOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M697.8 481.4c33.6-35 54.2-82.3 54.2-134.3v-10.2C752 229.3 663.9 142 555.3 142H259.4c-15.1 0-27.4 12.3-27.4 27.4v679.1c0 16.3 13.2 29.5 29.5 29.5h318.7c117 0 211.8-94.2 211.8-210.5v-11c0-73-37.4-137.3-94.2-175.1zM328 238h224.7c57.1 0 103.3 44.4 103.3 99.3v9.5c0 54.8-46.3 99.3-103.3 99.3H328V238zm366.6 429.4c0 62.9-51.7 113.9-115.5 113.9H328V542.7h251.1c63.8 0 115.5 51 115.5 113.9v10.8z" } }] }, "name": "bold", "theme": "outlined" };
var BoldOutlinedSvg = BoldOutlined$2;

var BoldOutlined = function BoldOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BoldOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BoldOutlined.displayName = 'BoldOutlined';
}
var BoldOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(BoldOutlined);

// This icon file is generated automatically.
var BookFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM668 345.9L621.5 312 572 347.4V124h96v221.9z" } }] }, "name": "book", "theme": "filled" };
var BookFilledSvg = BookFilled$2;

var BookFilled = function BookFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BookFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BookFilled.displayName = 'BookFilled';
}
var BookFilled$1 = /*#__PURE__*/React__namespace.forwardRef(BookFilled);

// This icon file is generated automatically.
var BookOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zm220 752H232V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0022.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752z" } }] }, "name": "book", "theme": "outlined" };
var BookOutlinedSvg = BookOutlined$2;

var BookOutlined = function BookOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BookOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BookOutlined.displayName = 'BookOutlined';
}
var BookOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(BookOutlined);

// This icon file is generated automatically.
var BookTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zM232 888V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0022.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752H232z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M668 345.9V136h-96v211.4l49.5-35.4z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M727.9 136v296.5c0 8.8-7.2 16-16 16-3.4 0-6.7-1.1-9.4-3.1L621.1 386l-83.8 59.9a15.9 15.9 0 01-22.3-3.7c-2-2.7-3-6-3-9.3V136H232v752h559.9V136h-64z", "fill": secondaryColor } }] }; }, "name": "book", "theme": "twotone" };
var BookTwoToneSvg = BookTwoTone$2;

var BookTwoTone = function BookTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BookTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BookTwoTone.displayName = 'BookTwoTone';
}
var BookTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(BookTwoTone);

// This icon file is generated automatically.
var BorderBottomOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 808H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-720-94h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-498h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-166h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm166 166h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm222-72h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388-404h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388 426h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388-404h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z" } }] }, "name": "border-bottom", "theme": "outlined" };
var BorderBottomOutlinedSvg = BorderBottomOutlined$2;

var BorderBottomOutlined = function BorderBottomOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BorderBottomOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BorderBottomOutlined.displayName = 'BorderBottomOutlined';
}
var BorderBottomOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(BorderBottomOutlined);

// This icon file is generated automatically.
var BorderHorizontalOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M540 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm664 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "border-horizontal", "theme": "outlined" };
var BorderHorizontalOutlinedSvg = BorderHorizontalOutlined$2;

var BorderHorizontalOutlined = function BorderHorizontalOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BorderHorizontalOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BorderHorizontalOutlined.displayName = 'BorderHorizontalOutlined';
}
var BorderHorizontalOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(BorderHorizontalOutlined);

// This icon file is generated automatically.
var BorderInnerOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 476H548V144h-72v332H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h324v332h72V548h324c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-664h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM650 216h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-592h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-166 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-426h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 260h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "border-inner", "theme": "outlined" };
var BorderInnerOutlinedSvg = BorderInnerOutlined$2;

var BorderInnerOutlined = function BorderInnerOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BorderInnerOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BorderInnerOutlined.displayName = 'BorderInnerOutlined';
}
var BorderInnerOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(BorderInnerOutlined);

// This icon file is generated automatically.
var BorderLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M208 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM540 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "border-left", "theme": "outlined" };
var BorderLeftOutlinedSvg = BorderLeftOutlined$2;

var BorderLeftOutlined = function BorderLeftOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BorderLeftOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BorderLeftOutlined.displayName = 'BorderLeftOutlined';
}
var BorderLeftOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(BorderLeftOutlined);

// This icon file is generated automatically.
var BorderOuterOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM484 366h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM302 548h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm364 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-182 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 182h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z" } }] }, "name": "border-outer", "theme": "outlined" };
var BorderOuterOutlinedSvg = BorderOuterOutlined$2;

var BorderOuterOutlined = function BorderOuterOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BorderOuterOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BorderOuterOutlined.displayName = 'BorderOuterOutlined';
}
var BorderOuterOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(BorderOuterOutlined);

// This icon file is generated automatically.
var BorderOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "border", "theme": "outlined" };
var BorderOutlinedSvg = BorderOutlined$2;

var BorderOutlined = function BorderOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BorderOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BorderOutlined.displayName = 'BorderOutlined';
}
var BorderOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(BorderOutlined);

// This icon file is generated automatically.
var BorderRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "border-right", "theme": "outlined" };
var BorderRightOutlinedSvg = BorderRightOutlined$2;

var BorderRightOutlined = function BorderRightOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BorderRightOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BorderRightOutlined.displayName = 'BorderRightOutlined';
}
var BorderRightOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(BorderRightOutlined);

// This icon file is generated automatically.
var BorderTopOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 144H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332-498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "border-top", "theme": "outlined" };
var BorderTopOutlinedSvg = BorderTopOutlined$2;

var BorderTopOutlined = function BorderTopOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BorderTopOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BorderTopOutlined.displayName = 'BorderTopOutlined';
}
var BorderTopOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(BorderTopOutlined);

// This icon file is generated automatically.
var BorderVerticleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 476H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-664h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM650 216h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-592h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-166 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM208 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM152 382h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM208 642h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "border-verticle", "theme": "outlined" };
var BorderVerticleOutlinedSvg = BorderVerticleOutlined$2;

var BorderVerticleOutlined = function BorderVerticleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BorderVerticleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BorderVerticleOutlined.displayName = 'BorderVerticleOutlined';
}
var BorderVerticleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(BorderVerticleOutlined);

// This icon file is generated automatically.
var BorderlessTableOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M117 368h231v64H117zm559 0h241v64H676zm-264 0h200v64H412zm0 224h200v64H412zm264 0h241v64H676zm-559 0h231v64H117zm295-160V179h-64v666h64V592zm264-64V179h-64v666h64V432z" } }] }, "name": "borderless-table", "theme": "outlined" };
var BorderlessTableOutlinedSvg = BorderlessTableOutlined$2;

var BorderlessTableOutlined = function BorderlessTableOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BorderlessTableOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BorderlessTableOutlined.displayName = 'BorderlessTableOutlined';
}
var BorderlessTableOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(BorderlessTableOutlined);

// This icon file is generated automatically.
var BoxPlotFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H448v432h344c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-728 80v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h152V296H232c-4.4 0-8 3.6-8 8z" } }] }, "name": "box-plot", "theme": "filled" };
var BoxPlotFilledSvg = BoxPlotFilled$2;

var BoxPlotFilled = function BoxPlotFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BoxPlotFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BoxPlotFilled.displayName = 'BoxPlotFilled';
}
var BoxPlotFilled$1 = /*#__PURE__*/React__namespace.forwardRef(BoxPlotFilled);

// This icon file is generated automatically.
var BoxPlotOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H232c-4.4 0-8 3.6-8 8v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zM296 368h88v288h-88V368zm432 288H448V368h280v288z" } }] }, "name": "box-plot", "theme": "outlined" };
var BoxPlotOutlinedSvg = BoxPlotOutlined$2;

var BoxPlotOutlined = function BoxPlotOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BoxPlotOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BoxPlotOutlined.displayName = 'BoxPlotOutlined';
}
var BoxPlotOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(BoxPlotOutlined);

// This icon file is generated automatically.
var BoxPlotTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M296 368h88v288h-88zm152 0h280v288H448z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H232c-4.4 0-8 3.6-8 8v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zM384 656h-88V368h88v288zm344 0H448V368h280v288z", "fill": primaryColor } }] }; }, "name": "box-plot", "theme": "twotone" };
var BoxPlotTwoToneSvg = BoxPlotTwoTone$2;

var BoxPlotTwoTone = function BoxPlotTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BoxPlotTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BoxPlotTwoTone.displayName = 'BoxPlotTwoTone';
}
var BoxPlotTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(BoxPlotTwoTone);

// This icon file is generated automatically.
var BranchesOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M740 161c-61.8 0-112 50.2-112 112 0 50.1 33.1 92.6 78.5 106.9v95.9L320 602.4V318.1c44.2-15 76-56.9 76-106.1 0-61.8-50.2-112-112-112s-112 50.2-112 112c0 49.2 31.8 91 76 106.1V706c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1v-27.8l423.5-138.7a50.52 50.52 0 0034.9-48.2V378.2c42.9-15.8 73.6-57 73.6-105.2 0-61.8-50.2-112-112-112zm-504 51a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm96 600a48.01 48.01 0 01-96 0 48.01 48.01 0 0196 0zm408-491a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "branches", "theme": "outlined" };
var BranchesOutlinedSvg = BranchesOutlined$2;

var BranchesOutlined = function BranchesOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BranchesOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BranchesOutlined.displayName = 'BranchesOutlined';
}
var BranchesOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(BranchesOutlined);

// This icon file is generated automatically.
var BugFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M304 280h416c4.4 0 8-3.6 8-8 0-40-8.8-76.7-25.9-108.1a184.31 184.31 0 00-74-74C596.7 72.8 560 64 520 64h-16c-40 0-76.7 8.8-108.1 25.9a184.31 184.31 0 00-74 74C304.8 195.3 296 232 296 272c0 4.4 3.6 8 8 8z" } }, { "tag": "path", "attrs": { "d": "M940 512H792V412c76.8 0 139-62.2 139-139 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8a63 63 0 01-63 63H232a63 63 0 01-63-63c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 76.8 62.2 139 139 139v100H84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h148v96c0 6.5.2 13 .7 19.3C164.1 728.6 116 796.7 116 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-44.2 23.9-82.9 59.6-103.7a273 273 0 0022.7 49c24.3 41.5 59 76.2 100.5 100.5 28.9 16.9 61 28.8 95.3 34.5 4.4 0 8-3.6 8-8V484c0-4.4 3.6-8 8-8h60c4.4 0 8 3.6 8 8v464.2c0 4.4 3.6 8 8 8 34.3-5.7 66.4-17.6 95.3-34.5a281.38 281.38 0 00123.2-149.5A120.4 120.4 0 01836 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-79.3-48.1-147.4-116.7-176.7.4-6.4.7-12.8.7-19.3v-96h148c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "bug", "theme": "filled" };
var BugFilledSvg = BugFilled$2;

var BugFilled = function BugFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BugFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BugFilled.displayName = 'BugFilled';
}
var BugFilled$1 = /*#__PURE__*/React__namespace.forwardRef(BugFilled);

// This icon file is generated automatically.
var BugOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M304 280h56c4.4 0 8-3.6 8-8 0-28.3 5.9-53.2 17.1-73.5 10.6-19.4 26-34.8 45.4-45.4C450.9 142 475.7 136 504 136h16c28.3 0 53.2 5.9 73.5 17.1 19.4 10.6 34.8 26 45.4 45.4C650 218.9 656 243.7 656 272c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-40-8.8-76.7-25.9-108.1a184.31 184.31 0 00-74-74C596.7 72.8 560 64 520 64h-16c-40 0-76.7 8.8-108.1 25.9a184.31 184.31 0 00-74 74C304.8 195.3 296 232 296 272c0 4.4 3.6 8 8 8z" } }, { "tag": "path", "attrs": { "d": "M940 512H792V412c76.8 0 139-62.2 139-139 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8a63 63 0 01-63 63H232a63 63 0 01-63-63c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 76.8 62.2 139 139 139v100H84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h148v96c0 6.5.2 13 .7 19.3C164.1 728.6 116 796.7 116 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-44.2 23.9-82.9 59.6-103.7a273 273 0 0022.7 49c24.3 41.5 59 76.2 100.5 100.5S460.5 960 512 960s99.8-13.9 141.3-38.2a281.38 281.38 0 00123.2-149.5A120 120 0 01836 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-79.3-48.1-147.4-116.7-176.7.4-6.4.7-12.8.7-19.3v-96h148c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM716 680c0 36.8-9.7 72-27.8 102.9-17.7 30.3-43 55.6-73.3 73.3C584 874.3 548.8 884 512 884s-72-9.7-102.9-27.8c-30.3-17.7-55.6-43-73.3-73.3A202.75 202.75 0 01308 680V412h408v268z" } }] }, "name": "bug", "theme": "outlined" };
var BugOutlinedSvg = BugOutlined$2;

var BugOutlined = function BugOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BugOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BugOutlined.displayName = 'BugOutlined';
}
var BugOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(BugOutlined);

// This icon file is generated automatically.
var BugTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M308 412v268c0 36.78 9.68 71.96 27.8 102.9a205.39 205.39 0 0073.3 73.3A202.68 202.68 0 00512 884c36.78 0 71.96-9.68 102.9-27.8a205.39 205.39 0 0073.3-73.3A202.68 202.68 0 00716 680V412H308zm484 172v96c0 6.5-.22 12.95-.66 19.35C859.94 728.64 908 796.7 908 876a8 8 0 01-8 8h-56a8 8 0 01-8-8c0-44.24-23.94-82.89-59.57-103.7a278.63 278.63 0 01-22.66 49.02 281.39 281.39 0 01-100.45 100.45C611.84 946.07 563.55 960 512 960s-99.84-13.93-141.32-38.23a281.39 281.39 0 01-100.45-100.45 278.63 278.63 0 01-22.66-49.02A119.95 119.95 0 00188 876a8 8 0 01-8 8h-56a8 8 0 01-8-8c0-79.3 48.07-147.36 116.66-176.65A284.12 284.12 0 01232 680v-96H84a8 8 0 01-8-8v-56a8 8 0 018-8h148V412c-76.77 0-139-62.23-139-139a8 8 0 018-8h60a8 8 0 018 8 63 63 0 0063 63h560a63 63 0 0063-63 8 8 0 018-8h60a8 8 0 018 8c0 76.77-62.23 139-139 139v100h148a8 8 0 018 8v56a8 8 0 01-8 8H792zM368 272a8 8 0 01-8 8h-56a8 8 0 01-8-8c0-40.04 8.78-76.75 25.9-108.07a184.57 184.57 0 0174.03-74.03C427.25 72.78 463.96 64 504 64h16c40.04 0 76.75 8.78 108.07 25.9a184.57 184.57 0 0174.03 74.03C719.22 195.25 728 231.96 728 272a8 8 0 01-8 8h-56a8 8 0 01-8-8c0-28.33-5.94-53.15-17.08-73.53a112.56 112.56 0 00-45.39-45.4C573.15 141.95 548.33 136 520 136h-16c-28.33 0-53.15 5.94-73.53 17.08a112.56 112.56 0 00-45.4 45.39C373.95 218.85 368 243.67 368 272z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M308 412v268c0 36.78 9.68 71.96 27.8 102.9a205.39 205.39 0 0073.3 73.3A202.68 202.68 0 00512 884c36.78 0 71.96-9.68 102.9-27.8a205.39 205.39 0 0073.3-73.3A202.68 202.68 0 00716 680V412H308z", "fill": secondaryColor } }] }; }, "name": "bug", "theme": "twotone" };
var BugTwoToneSvg = BugTwoTone$2;

var BugTwoTone = function BugTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BugTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BugTwoTone.displayName = 'BugTwoTone';
}
var BugTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(BugTwoTone);

// This icon file is generated automatically.
var BuildFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zM612 746H412V546h200v200zm268-268H680V278h200v200z" } }] }, "name": "build", "theme": "filled" };
var BuildFilledSvg = BuildFilled$2;

var BuildFilled = function BuildFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BuildFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BuildFilled.displayName = 'BuildFilled';
}
var BuildFilled$1 = /*#__PURE__*/React__namespace.forwardRef(BuildFilled);

// This icon file is generated automatically.
var BuildOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zm-504 68h200v200H412V278zm-68 468H144V546h200v200zm268 0H412V546h200v200zm268-268H680V278h200v200z" } }] }, "name": "build", "theme": "outlined" };
var BuildOutlinedSvg = BuildOutlined$2;

var BuildOutlined = function BuildOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BuildOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BuildOutlined.displayName = 'BuildOutlined';
}
var BuildOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(BuildOutlined);

// This icon file is generated automatically.
var BuildTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M144 546h200v200H144zm268-268h200v200H412z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zM344 746H144V546h200v200zm268 0H412V546h200v200zm0-268H412V278h200v200zm268 0H680V278h200v200z", "fill": primaryColor } }] }; }, "name": "build", "theme": "twotone" };
var BuildTwoToneSvg = BuildTwoTone$2;

var BuildTwoTone = function BuildTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BuildTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BuildTwoTone.displayName = 'BuildTwoTone';
}
var BuildTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(BuildTwoTone);

// This icon file is generated automatically.
var BulbFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M348 676.1C250 619.4 184 513.4 184 392c0-181.1 146.9-328 328-328s328 146.9 328 328c0 121.4-66 227.4-164 284.1V792c0 17.7-14.3 32-32 32H380c-17.7 0-32-14.3-32-32V676.1zM392 888h240c4.4 0 8 3.6 8 8v32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32v-32c0-4.4 3.6-8 8-8z" } }] }, "name": "bulb", "theme": "filled" };
var BulbFilledSvg = BulbFilled$2;

var BulbFilled = function BulbFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BulbFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BulbFilled.displayName = 'BulbFilled';
}
var BulbFilled$1 = /*#__PURE__*/React__namespace.forwardRef(BulbFilled);

// This icon file is generated automatically.
var BulbOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z" } }] }, "name": "bulb", "theme": "outlined" };
var BulbOutlinedSvg = BulbOutlined$2;

var BulbOutlined = function BulbOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BulbOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BulbOutlined.displayName = 'BulbOutlined';
}
var BulbOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(BulbOutlined);

// This icon file is generated automatically.
var BulbTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 136c-141.4 0-256 114.6-256 256 0 92.5 49.4 176.3 128.1 221.8l35.9 20.8V752h184V634.6l35.9-20.8C718.6 568.3 768 484.5 768 392c0-141.4-114.6-256-256-256z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z", "fill": primaryColor } }] }; }, "name": "bulb", "theme": "twotone" };
var BulbTwoToneSvg = BulbTwoTone$2;

var BulbTwoTone = function BulbTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BulbTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  BulbTwoTone.displayName = 'BulbTwoTone';
}
var BulbTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(BulbTwoTone);

// This icon file is generated automatically.
var CalculatorFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM440.2 765h-50.8c-2.2 0-4.5-1.1-5.9-2.9L348 718.6l-35.5 43.5a7.38 7.38 0 01-5.9 2.9h-50.8c-6.6 0-10.2-7.9-5.8-13.1l62.7-76.8-61.2-74.9c-4.3-5.2-.7-13.1 5.9-13.1h50.9c2.2 0 4.5 1.1 5.9 2.9l34 41.6 34-41.6c1.5-1.9 3.6-2.9 5.9-2.9h50.8c6.6 0 10.2 7.9 5.9 13.1L383.5 675l62.7 76.8c4.2 5.3.6 13.2-6 13.2zm7.8-382c0 2.2-1.4 4-3.2 4H376v68.7c0 1.9-1.8 3.3-4 3.3h-48c-2.2 0-4-1.4-4-3.2V387h-68.8c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4H320v-68.8c0-1.8 1.8-3.2 4-3.2h48c2.2 0 4 1.4 4 3.2V331h68.7c1.9 0 3.3 1.8 3.3 4v48zm328 369c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48zm0-104c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48zm0-265c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48z" } }] }, "name": "calculator", "theme": "filled" };
var CalculatorFilledSvg = CalculatorFilled$2;

var CalculatorFilled = function CalculatorFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CalculatorFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CalculatorFilled.displayName = 'CalculatorFilled';
}
var CalculatorFilled$1 = /*#__PURE__*/React__namespace.forwardRef(CalculatorFilled);

// This icon file is generated automatically.
var CalculatorOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M251.2 387H320v68.8c0 1.8 1.8 3.2 4 3.2h48c2.2 0 4-1.4 4-3.3V387h68.8c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H376v-68.8c0-1.8-1.8-3.2-4-3.2h-48c-2.2 0-4 1.4-4 3.2V331h-68.8c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm328 0h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0 265h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0 104h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm-195.7-81l61.2-74.9c4.3-5.2.7-13.1-5.9-13.1H388c-2.3 0-4.5 1-5.9 2.9l-34 41.6-34-41.6a7.85 7.85 0 00-5.9-2.9h-50.9c-6.6 0-10.2 7.9-5.9 13.1l61.2 74.9-62.7 76.8c-4.4 5.2-.8 13.1 5.8 13.1h50.8c2.3 0 4.5-1 5.9-2.9l35.5-43.5 35.5 43.5c1.5 1.8 3.7 2.9 5.9 2.9h50.8c6.6 0 10.2-7.9 5.9-13.1L383.5 675zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-36 732H180V180h664v664z" } }] }, "name": "calculator", "theme": "outlined" };
var CalculatorOutlinedSvg = CalculatorOutlined$2;

var CalculatorOutlined = function CalculatorOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CalculatorOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CalculatorOutlined.displayName = 'CalculatorOutlined';
}
var CalculatorOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CalculatorOutlined);

// This icon file is generated automatically.
var CalculatorTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm256.2-75h-50.8c-2.2 0-4.5-1.1-5.9-2.9L348 718.6l-35.5 43.5a7.38 7.38 0 01-5.9 2.9h-50.8c-6.6 0-10.2-7.9-5.8-13.1l62.7-76.8-61.2-74.9c-4.3-5.2-.7-13.1 5.9-13.1h50.9c2.2 0 4.5 1.1 5.9 2.9l34 41.6 34-41.6c1.5-1.9 3.6-2.9 5.9-2.9h50.8c6.6 0 10.2 7.9 5.9 13.1L383.5 675l62.7 76.8c4.2 5.3.6 13.2-6 13.2zM576 335c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zm0 265c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zm0 104c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zM248 335c0-2.2 1.4-4 3.2-4H320v-68.8c0-1.8 1.8-3.2 4-3.2h48c2.2 0 4 1.4 4 3.2V331h68.7c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H376v68.7c0 1.9-1.8 3.3-4 3.3h-48c-2.2 0-4-1.4-4-3.2V387h-68.8c-1.8 0-3.2-1.8-3.2-4v-48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M383.5 675l61.3-74.8c4.3-5.2.7-13.1-5.9-13.1h-50.8c-2.3 0-4.4 1-5.9 2.9l-34 41.6-34-41.6a7.69 7.69 0 00-5.9-2.9h-50.9c-6.6 0-10.2 7.9-5.9 13.1l61.2 74.9-62.7 76.8c-4.4 5.2-.8 13.1 5.8 13.1h50.8c2.3 0 4.4-1 5.9-2.9l35.5-43.5 35.5 43.5c1.4 1.8 3.7 2.9 5.9 2.9h50.8c6.6 0 10.2-7.9 6-13.2L383.5 675zM251.2 387H320v68.8c0 1.8 1.8 3.2 4 3.2h48c2.2 0 4-1.4 4-3.3V387h68.8c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H376v-68.8c0-1.8-1.8-3.2-4-3.2h-48c-2.2 0-4 1.4-4 3.2V331h-68.8c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm328 369h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0-104h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0-265h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4z", "fill": primaryColor } }] }; }, "name": "calculator", "theme": "twotone" };
var CalculatorTwoToneSvg = CalculatorTwoTone$2;

var CalculatorTwoTone = function CalculatorTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CalculatorTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CalculatorTwoTone.displayName = 'CalculatorTwoTone';
}
var CalculatorTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(CalculatorTwoTone);

// This icon file is generated automatically.
var CalendarFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M112 880c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V460H112v420zm768-696H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v176h800V216c0-17.7-14.3-32-32-32z" } }] }, "name": "calendar", "theme": "filled" };
var CalendarFilledSvg = CalendarFilled$2;

var CalendarFilled = function CalendarFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CalendarFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CalendarFilled.displayName = 'CalendarFilled';
}
var CalendarFilled$1 = /*#__PURE__*/React__namespace.forwardRef(CalendarFilled);

// This icon file is generated automatically.
var CalendarOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z" } }] }, "name": "calendar", "theme": "outlined" };
var CalendarOutlinedSvg = CalendarOutlined$2;

var CalendarOutlined = function CalendarOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CalendarOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CalendarOutlined.displayName = 'CalendarOutlined';
}
var CalendarOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CalendarOutlined);

// This icon file is generated automatically.
var CalendarTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v136h656V256H712v48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zm0-448H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136z", "fill": primaryColor } }] }; }, "name": "calendar", "theme": "twotone" };
var CalendarTwoToneSvg = CalendarTwoTone$2;

var CalendarTwoTone = function CalendarTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CalendarTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CalendarTwoTone.displayName = 'CalendarTwoTone';
}
var CalendarTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(CalendarTwoTone);

// This icon file is generated automatically.
var CameraFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 260H728l-32.4-90.8a32.07 32.07 0 00-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 260H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V340c0-44.2-35.8-80-80-80zM512 716c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160zm-96-160a96 96 0 10192 0 96 96 0 10-192 0z" } }] }, "name": "camera", "theme": "filled" };
var CameraFilledSvg = CameraFilled$2;

var CameraFilled = function CameraFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CameraFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CameraFilled.displayName = 'CameraFilled';
}
var CameraFilled$1 = /*#__PURE__*/React__namespace.forwardRef(CameraFilled);

// This icon file is generated automatically.
var CameraOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 248H728l-32.4-90.8a32.07 32.07 0 00-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80zm8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8v456zM512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z" } }] }, "name": "camera", "theme": "outlined" };
var CameraOutlinedSvg = CameraOutlined$2;

var CameraOutlined = function CameraOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CameraOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CameraOutlined.displayName = 'CameraOutlined';
}
var CameraOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CameraOutlined);

// This icon file is generated automatically.
var CameraTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 320H677.2l-17.1-47.8-22.9-64.2H386.7l-22.9 64.2-17.1 47.8H160c-4.4 0-8 3.6-8 8v456c0 4.4 3.6 8 8 8h704c4.4 0 8-3.6 8-8V328c0-4.4-3.6-8-8-8zM512 704c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M864 248H728l-32.4-90.8a32.07 32.07 0 00-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80zm8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8v456z", "fill": primaryColor } }] }; }, "name": "camera", "theme": "twotone" };
var CameraTwoToneSvg = CameraTwoTone$2;

var CameraTwoTone = function CameraTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CameraTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CameraTwoTone.displayName = 'CameraTwoTone';
}
var CameraTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(CameraTwoTone);

// This icon file is generated automatically.
var CarFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M959 413.4L935.3 372a8 8 0 00-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 00-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 00-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 003-10.8zM264 621c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm388 75c0 4.4-3.6 8-8 8H380c-4.4 0-8-3.6-8-8v-84c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v36h168v-36c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v84zm108-75c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM220 418l72.7-199.9.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220z" } }] }, "name": "car", "theme": "filled" };
var CarFilledSvg = CarFilled$2;

var CarFilled = function CarFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CarFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CarFilled.displayName = 'CarFilled';
}
var CarFilled$1 = /*#__PURE__*/React__namespace.forwardRef(CarFilled);

// This icon file is generated automatically.
var CarOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M380 704h264c4.4 0 8-3.6 8-8v-84c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v36H428v-36c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v84c0 4.4 3.6 8 8 8zm340-123a40 40 0 1080 0 40 40 0 10-80 0zm239-167.6L935.3 372a8 8 0 00-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 00-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 00-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 003-10.8zM840 517v237H184V517l15.6-43h624.8l15.6 43zM292.7 218.1l.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220l72.7-199.9zM224 581a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "car", "theme": "outlined" };
var CarOutlinedSvg = CarOutlined$2;

var CarOutlined = function CarOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CarOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CarOutlined.displayName = 'CarOutlined';
}
var CarOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CarOutlined);

// This icon file is generated automatically.
var CarTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M199.6 474L184 517v237h656V517l-15.6-43H199.6zM264 621c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm388 75c0 4.4-3.6 8-8 8H380c-4.4 0-8-3.6-8-8v-84c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v36h168v-36c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v84zm108-75c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M720 581a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M959 413.4L935.3 372a8 8 0 00-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 00-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 00-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 003-10.8zM292.7 218.1l.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220l72.7-199.9zM840 754H184V517l15.6-43h624.8l15.6 43v237z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M224 581a40 40 0 1080 0 40 40 0 10-80 0zm420 23h-40c-4.4 0-8 3.6-8 8v36H428v-36c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v84c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-84c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "car", "theme": "twotone" };
var CarTwoToneSvg = CarTwoTone$2;

var CarTwoTone = function CarTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CarTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CarTwoTone.displayName = 'CarTwoTone';
}
var CarTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(CarTwoTone);

// This icon file is generated automatically.
var CaretDownFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, "name": "caret-down", "theme": "filled" };
var CaretDownFilledSvg = CaretDownFilled$2;

var CaretDownFilled = function CaretDownFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CaretDownFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CaretDownFilled.displayName = 'CaretDownFilled';
}
var CaretDownFilled$1 = /*#__PURE__*/React__namespace.forwardRef(CaretDownFilled);

// This icon file is generated automatically.
var CaretDownOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, "name": "caret-down", "theme": "outlined" };
var CaretDownOutlinedSvg = CaretDownOutlined$2;

var CaretDownOutlined = function CaretDownOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CaretDownOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CaretDownOutlined.displayName = 'CaretDownOutlined';
}
var CaretDownOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CaretDownOutlined);

// This icon file is generated automatically.
var CaretLeftFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z" } }] }, "name": "caret-left", "theme": "filled" };
var CaretLeftFilledSvg = CaretLeftFilled$2;

var CaretLeftFilled = function CaretLeftFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CaretLeftFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CaretLeftFilled.displayName = 'CaretLeftFilled';
}
var CaretLeftFilled$1 = /*#__PURE__*/React__namespace.forwardRef(CaretLeftFilled);

// This icon file is generated automatically.
var CaretLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z" } }] }, "name": "caret-left", "theme": "outlined" };
var CaretLeftOutlinedSvg = CaretLeftOutlined$2;

var CaretLeftOutlined = function CaretLeftOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CaretLeftOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CaretLeftOutlined.displayName = 'CaretLeftOutlined';
}
var CaretLeftOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CaretLeftOutlined);

// This icon file is generated automatically.
var CaretRightFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z" } }] }, "name": "caret-right", "theme": "filled" };
var CaretRightFilledSvg = CaretRightFilled$2;

var CaretRightFilled = function CaretRightFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CaretRightFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CaretRightFilled.displayName = 'CaretRightFilled';
}
var CaretRightFilled$1 = /*#__PURE__*/React__namespace.forwardRef(CaretRightFilled);

// This icon file is generated automatically.
var CaretRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z" } }] }, "name": "caret-right", "theme": "outlined" };
var CaretRightOutlinedSvg = CaretRightOutlined$2;

var CaretRightOutlined = function CaretRightOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CaretRightOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CaretRightOutlined.displayName = 'CaretRightOutlined';
}
var CaretRightOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CaretRightOutlined);

// This icon file is generated automatically.
var CaretUpFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" } }] }, "name": "caret-up", "theme": "filled" };
var CaretUpFilledSvg = CaretUpFilled$2;

var CaretUpFilled = function CaretUpFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CaretUpFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CaretUpFilled.displayName = 'CaretUpFilled';
}
var CaretUpFilled$1 = /*#__PURE__*/React__namespace.forwardRef(CaretUpFilled);

// This icon file is generated automatically.
var CaretUpOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" } }] }, "name": "caret-up", "theme": "outlined" };
var CaretUpOutlinedSvg = CaretUpOutlined$2;

var CaretUpOutlined = function CaretUpOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CaretUpOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CaretUpOutlined.displayName = 'CaretUpOutlined';
}
var CaretUpOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CaretUpOutlined);

// This icon file is generated automatically.
var CarryOutFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zM694.5 432.7L481.9 725.4a16.1 16.1 0 01-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.1 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.8-6.6 13-6.6H688c6.5.1 10.3 7.5 6.5 12.8z" } }] }, "name": "carry-out", "theme": "filled" };
var CarryOutFilledSvg = CarryOutFilled$2;

var CarryOutFilled = function CarryOutFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CarryOutFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CarryOutFilled.displayName = 'CarryOutFilled';
}
var CarryOutFilled$1 = /*#__PURE__*/React__namespace.forwardRef(CarryOutFilled);

// This icon file is generated automatically.
var CarryOutOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584zM688 420h-55.2c-5.1 0-10 2.5-13 6.6L468.9 634.4l-64.7-89c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0026 0l212.6-292.7c3.8-5.4 0-12.8-6.5-12.8z" } }] }, "name": "carry-out", "theme": "outlined" };
var CarryOutOutlinedSvg = CarryOutOutlined$2;

var CarryOutOutlined = function CarryOutOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CarryOutOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CarryOutOutlined.displayName = 'CarryOutOutlined';
}
var CarryOutOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CarryOutOutlined);

// This icon file is generated automatically.
var CarryOutTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v584h656V256H712v48zm-17.5 128.8L481.9 725.5a16.1 16.1 0 01-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.2 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.9-6.6 13-6.6H688c6.5 0 10.3 7.4 6.5 12.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M688 420h-55.2c-5.1 0-10 2.5-13 6.6L468.9 634.4l-64.7-89c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0026 0l212.6-292.7c3.8-5.4 0-12.8-6.5-12.8z", "fill": primaryColor } }] }; }, "name": "carry-out", "theme": "twotone" };
var CarryOutTwoToneSvg = CarryOutTwoTone$2;

var CarryOutTwoTone = function CarryOutTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CarryOutTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CarryOutTwoTone.displayName = 'CarryOutTwoTone';
}
var CarryOutTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(CarryOutTwoTone);

// This icon file is generated automatically.
var CheckCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] }, "name": "check-circle", "theme": "filled" };
var CheckCircleFilledSvg = CheckCircleFilled$2;

var CheckCircleFilled = function CheckCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CheckCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CheckCircleFilled.displayName = 'CheckCircleFilled';
}
var CheckCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(CheckCircleFilled);

// This icon file is generated automatically.
var CheckCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "check-circle", "theme": "outlined" };
var CheckCircleOutlinedSvg = CheckCircleOutlined$2;

var CheckCircleOutlined = function CheckCircleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CheckCircleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CheckCircleOutlined.displayName = 'CheckCircleOutlined';
}
var CheckCircleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CheckCircleOutlined);

// This icon file is generated automatically.
var CheckCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm193.4 225.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.3 0 19.9 5 25.9 13.3l71.2 98.8 157.2-218c6-8.4 15.7-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.4 12.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z", "fill": primaryColor } }] }; }, "name": "check-circle", "theme": "twotone" };
var CheckCircleTwoToneSvg = CheckCircleTwoTone$2;

var CheckCircleTwoTone = function CheckCircleTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CheckCircleTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CheckCircleTwoTone.displayName = 'CheckCircleTwoTone';
}
var CheckCircleTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(CheckCircleTwoTone);

// This icon file is generated automatically.
var CheckOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, "name": "check", "theme": "outlined" };
var CheckOutlinedSvg = CheckOutlined$2;

var CheckOutlined = function CheckOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CheckOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CheckOutlined.displayName = 'CheckOutlined';
}
var CheckOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CheckOutlined);

// This icon file is generated automatically.
var CheckSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM695.5 365.7l-210.6 292a31.8 31.8 0 01-51.7 0L308.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H689c6.5 0 10.3 7.4 6.5 12.7z" } }] }, "name": "check-square", "theme": "filled" };
var CheckSquareFilledSvg = CheckSquareFilled$2;

var CheckSquareFilled = function CheckSquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CheckSquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CheckSquareFilled.displayName = 'CheckSquareFilled';
}
var CheckSquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(CheckSquareFilled);

// This icon file is generated automatically.
var CheckSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M433.1 657.7a31.8 31.8 0 0051.7 0l210.6-292c3.8-5.3 0-12.7-6.5-12.7H642c-10.2 0-19.9 4.9-25.9 13.3L459 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H315c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "check-square", "theme": "outlined" };
var CheckSquareOutlinedSvg = CheckSquareOutlined$2;

var CheckSquareOutlined = function CheckSquareOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CheckSquareOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CheckSquareOutlined.displayName = 'CheckSquareOutlined';
}
var CheckSquareOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CheckSquareOutlined);

// This icon file is generated automatically.
var CheckSquareTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm130-367.8h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H688c6.5 0 10.3 7.4 6.5 12.7l-210.6 292a31.8 31.8 0 01-51.7 0L307.5 484.9c-3.8-5.3 0-12.7 6.5-12.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M432.2 657.7a31.8 31.8 0 0051.7 0l210.6-292c3.8-5.3 0-12.7-6.5-12.7h-46.9c-10.3 0-19.9 5-25.9 13.3L458 584.3l-71.2-98.8c-6-8.4-15.7-13.3-25.9-13.3H314c-6.5 0-10.3 7.4-6.5 12.7l124.7 172.8z", "fill": primaryColor } }] }; }, "name": "check-square", "theme": "twotone" };
var CheckSquareTwoToneSvg = CheckSquareTwoTone$2;

var CheckSquareTwoTone = function CheckSquareTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CheckSquareTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CheckSquareTwoTone.displayName = 'CheckSquareTwoTone';
}
var CheckSquareTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(CheckSquareTwoTone);

// This icon file is generated automatically.
var ChromeFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M371.8 512c0 77.5 62.7 140.2 140.2 140.2S652.2 589.5 652.2 512 589.5 371.8 512 371.8 371.8 434.4 371.8 512zM900 362.4l-234.3 12.1c63.6 74.3 64.6 181.5 11.1 263.7l-188 289.2c78 4.2 158.4-12.9 231.2-55.2 180-104 253-322.1 180-509.8zM320.3 591.9L163.8 284.1A415.35 415.35 0 0096 512c0 208 152.3 380.3 351.4 410.8l106.9-209.4c-96.6 18.2-189.9-34.8-234-121.5zm218.5-285.5l344.4 18.1C848 254.7 792.6 194 719.8 151.7 653.9 113.6 581.5 95.5 510.5 96c-122.5.5-242.2 55.2-322.1 154.5l128.2 196.9c32-91.9 124.8-146.7 222.2-141z" } }] }, "name": "chrome", "theme": "filled" };
var ChromeFilledSvg = ChromeFilled$2;

var ChromeFilled = function ChromeFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ChromeFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ChromeFilled.displayName = 'ChromeFilled';
}
var ChromeFilled$1 = /*#__PURE__*/React__namespace.forwardRef(ChromeFilled);

// This icon file is generated automatically.
var ChromeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 512.3v-.3c0-229.8-186.2-416-416-416S96 282.2 96 512v.4c0 229.8 186.2 416 416 416s416-186.2 416-416v-.3.2zm-6.7-74.6l.6 3.3-.6-3.3zM676.7 638.2c53.5-82.2 52.5-189.4-11.1-263.7l162.4-8.4c20.5 44.4 32 93.8 32 145.9 0 185.2-144.6 336.6-327.1 347.4l143.8-221.2zM512 652.3c-77.5 0-140.2-62.7-140.2-140.2 0-77.7 62.7-140.2 140.2-140.2S652.2 434.5 652.2 512 589.5 652.3 512 652.3zm369.2-331.7l-3-5.7 3 5.7zM512 164c121.3 0 228.2 62.1 290.4 156.2l-263.6-13.9c-97.5-5.7-190.2 49.2-222.3 141.1L227.8 311c63.1-88.9 166.9-147 284.2-147zM102.5 585.8c26 145 127.1 264 261.6 315.1C229.6 850 128.5 731 102.5 585.8zM164 512c0-55.9 13.2-108.7 36.6-155.5l119.7 235.4c44.1 86.7 137.4 139.7 234 121.6l-74 145.1C302.9 842.5 164 693.5 164 512zm324.7 415.4c4 .2 8 .4 12 .5-4-.2-8-.3-12-.5z" } }] }, "name": "chrome", "theme": "outlined" };
var ChromeOutlinedSvg = ChromeOutlined$2;

var ChromeOutlined = function ChromeOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ChromeOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ChromeOutlined.displayName = 'ChromeOutlined';
}
var ChromeOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ChromeOutlined);

// This icon file is generated automatically.
var CiCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-63.6 656c-103 0-162.4-68.6-162.4-182.6v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-4-46.1-37.6-77.6-87-77.6-61.1 0-95.6 45.4-95.6 126.9v49.3c0 80.3 34.5 125.1 95.6 125.1 49.3 0 82.8-29.5 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z" } }] }, "name": "ci-circle", "theme": "filled" };
var CiCircleFilledSvg = CiCircleFilled$2;

var CiCircleFilled = function CiCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CiCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CiCircleFilled.displayName = 'CiCircleFilled';
}
var CiCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(CiCircleFilled);

// This icon file is generated automatically.
var CiCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm218-572.1h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z" } }] }, "name": "ci-circle", "theme": "outlined" };
var CiCircleOutlinedSvg = CiCircleOutlined$2;

var CiCircleOutlined = function CiCircleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CiCircleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CiCircleOutlined.displayName = 'CiCircleOutlined';
}
var CiCircleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CiCircleOutlined);

// This icon file is generated automatically.
var CiCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-63.5 522.8c49.3 0 82.8-29.4 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5C345.4 720 286 651.4 286 537.4v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-3.9-46.1-37.5-77.6-87-77.6-61.1 0-95.6 45.4-95.7 126.8v49.3c0 80.3 34.5 125.2 95.6 125.2zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M730 311.9h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z", "fill": primaryColor } }] }; }, "name": "ci-circle", "theme": "twotone" };
var CiCircleTwoToneSvg = CiCircleTwoTone$2;

var CiCircleTwoTone = function CiCircleTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CiCircleTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CiCircleTwoTone.displayName = 'CiCircleTwoTone';
}
var CiCircleTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(CiCircleTwoTone);

// This icon file is generated automatically.
var CiOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm218-572.1h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z" } }] }, "name": "ci", "theme": "outlined" };
var CiOutlinedSvg = CiOutlined$2;

var CiOutlined = function CiOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CiOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CiOutlined.displayName = 'CiOutlined';
}
var CiOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CiOutlined);

// This icon file is generated automatically.
var CiTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-63.5 522.8c49.3 0 82.8-29.4 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5C345.4 720 286 651.4 286 537.4v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-3.9-46.1-37.5-77.6-87-77.6-61.1 0-95.6 45.4-95.7 126.8v49.3c0 80.3 34.5 125.2 95.6 125.2zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M730 311.9h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z", "fill": primaryColor } }] }; }, "name": "ci", "theme": "twotone" };
var CiTwoToneSvg = CiTwoTone$2;

var CiTwoTone = function CiTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CiTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CiTwoTone.displayName = 'CiTwoTone';
}
var CiTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(CiTwoTone);

// This icon file is generated automatically.
var ClearOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M899.1 869.6l-53-305.6H864c14.4 0 26-11.6 26-26V346c0-14.4-11.6-26-26-26H618V138c0-14.4-11.6-26-26-26H432c-14.4 0-26 11.6-26 26v182H160c-14.4 0-26 11.6-26 26v192c0 14.4 11.6 26 26 26h17.9l-53 305.6a25.95 25.95 0 0025.6 30.4h723c1.5 0 3-.1 4.4-.4a25.88 25.88 0 0021.2-30zM204 390h272V182h72v208h272v104H204V390zm468 440V674c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v156H416V674c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v156H202.8l45.1-260H776l45.1 260H672z" } }] }, "name": "clear", "theme": "outlined" };
var ClearOutlinedSvg = ClearOutlined$2;

var ClearOutlined = function ClearOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ClearOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ClearOutlined.displayName = 'ClearOutlined';
}
var ClearOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ClearOutlined);

// This icon file is generated automatically.
var ClockCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm176.5 585.7l-28.6 39a7.99 7.99 0 01-11.2 1.7L483.3 569.8a7.92 7.92 0 01-3.3-6.5V288c0-4.4 3.6-8 8-8h48.1c4.4 0 8 3.6 8 8v247.5l142.6 103.1c3.6 2.5 4.4 7.5 1.8 11.1z" } }] }, "name": "clock-circle", "theme": "filled" };
var ClockCircleFilledSvg = ClockCircleFilled$2;

var ClockCircleFilled = function ClockCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ClockCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ClockCircleFilled.displayName = 'ClockCircleFilled';
}
var ClockCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(ClockCircleFilled);

// This icon file is generated automatically.
var ClockCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z" } }] }, "name": "clock-circle", "theme": "outlined" };
var ClockCircleOutlinedSvg = ClockCircleOutlined$2;

var ClockCircleOutlined = function ClockCircleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ClockCircleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ClockCircleOutlined.displayName = 'ClockCircleOutlined';
}
var ClockCircleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ClockCircleOutlined);

// This icon file is generated automatically.
var ClockCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm176.5 509.7l-28.6 39a7.99 7.99 0 01-11.2 1.7L483.3 569.8a7.92 7.92 0 01-3.3-6.5V288c0-4.4 3.6-8 8-8h48.1c4.4 0 8 3.6 8 8v247.5l142.6 103.1c3.6 2.5 4.4 7.5 1.8 11.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.3c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.9 11.2-1.7l28.6-39c2.6-3.6 1.8-8.6-1.8-11.1z", "fill": primaryColor } }] }; }, "name": "clock-circle", "theme": "twotone" };
var ClockCircleTwoToneSvg = ClockCircleTwoTone$2;

var ClockCircleTwoTone = function ClockCircleTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ClockCircleTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ClockCircleTwoTone.displayName = 'ClockCircleTwoTone';
}
var ClockCircleTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(ClockCircleTwoTone);

// This icon file is generated automatically.
var CloseCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "fill-rule": "evenodd", "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" } }] }, "name": "close-circle", "theme": "filled" };
var CloseCircleFilledSvg = CloseCircleFilled$2;

var CloseCircleFilled = function CloseCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CloseCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CloseCircleFilled.displayName = 'CloseCircleFilled';
}
var CloseCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(CloseCircleFilled);

// This icon file is generated automatically.
var CloseCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "fill-rule": "evenodd", "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm0 76c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm128.01 198.83c.03 0 .05.01.09.06l45.02 45.01a.2.2 0 01.05.09.12.12 0 010 .07c0 .02-.01.04-.05.08L557.25 512l127.87 127.86a.27.27 0 01.05.06v.02a.12.12 0 010 .07c0 .03-.01.05-.05.09l-45.02 45.02a.2.2 0 01-.09.05.12.12 0 01-.07 0c-.02 0-.04-.01-.08-.05L512 557.25 384.14 685.12c-.04.04-.06.05-.08.05a.12.12 0 01-.07 0c-.03 0-.05-.01-.09-.05l-45.02-45.02a.2.2 0 01-.05-.09.12.12 0 010-.07c0-.02.01-.04.06-.08L466.75 512 338.88 384.14a.27.27 0 01-.05-.06l-.01-.02a.12.12 0 010-.07c0-.03.01-.05.05-.09l45.02-45.02a.2.2 0 01.09-.05.12.12 0 01.07 0c.02 0 .04.01.08.06L512 466.75l127.86-127.86c.04-.05.06-.06.08-.06a.12.12 0 01.07 0z" } }] }, "name": "close-circle", "theme": "outlined" };
var CloseCircleOutlinedSvg = CloseCircleOutlined$2;

var CloseCircleOutlined = function CloseCircleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CloseCircleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CloseCircleOutlined.displayName = 'CloseCircleOutlined';
}
var CloseCircleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CloseCircleOutlined);

// This icon file is generated automatically.
var CloseCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm171.8 527.1c1.2 1.5 1.9 3.3 1.9 5.2 0 4.5-3.6 8-8 8l-66-.3-99.3-118.4-99.3 118.5-66.1.3c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2L471 512.3l-130.1-155a8.32 8.32 0 01-1.9-5.2c0-4.5 3.6-8 8-8l66.1.3 99.3 118.4 99.4-118.5 66-.3c4.4 0 8 3.6 8 8 0 1.9-.6 3.8-1.8 5.2l-130.1 155 129.9 154.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M685.8 352c0-4.4-3.6-8-8-8l-66 .3-99.4 118.5-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155-130.1 154.9a8.32 8.32 0 00-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3 99.3-118.5L611.7 680l66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.9 512.2l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z", "fill": primaryColor } }] }; }, "name": "close-circle", "theme": "twotone" };
var CloseCircleTwoToneSvg = CloseCircleTwoTone$2;

var CloseCircleTwoTone = function CloseCircleTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CloseCircleTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CloseCircleTwoTone.displayName = 'CloseCircleTwoTone';
}
var CloseCircleTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(CloseCircleTwoTone);

// This icon file is generated automatically.
var CloseOutlined$2 = { "icon": { "tag": "svg", "attrs": { "fill-rule": "evenodd", "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" } }] }, "name": "close", "theme": "outlined" };
var CloseOutlinedSvg = CloseOutlined$2;

var CloseOutlined = function CloseOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CloseOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CloseOutlined.displayName = 'CloseOutlined';
}
var CloseOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CloseOutlined);

// This icon file is generated automatically.
var CloseSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "fill-rule": "evenodd", "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112c17.7 0 32 14.3 32 32v736c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32zM639.98 338.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" } }] }, "name": "close-square", "theme": "filled" };
var CloseSquareFilledSvg = CloseSquareFilled$2;

var CloseSquareFilled = function CloseSquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CloseSquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CloseSquareFilled.displayName = 'CloseSquareFilled';
}
var CloseSquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(CloseSquareFilled);

// This icon file is generated automatically.
var CloseSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "fill-rule": "evenodd", "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112c17.7 0 32 14.3 32 32v736c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32zm-40 72H184v656h656V184zM640.01 338.83c.03 0 .05.01.09.06l45.02 45.01a.2.2 0 01.05.09.12.12 0 010 .07c0 .02-.01.04-.05.08L557.25 512l127.87 127.86a.27.27 0 01.05.06v.02a.12.12 0 010 .07c0 .03-.01.05-.05.09l-45.02 45.02a.2.2 0 01-.09.05.12.12 0 01-.07 0c-.02 0-.04-.01-.08-.05L512 557.25 384.14 685.12c-.04.04-.06.05-.08.05a.12.12 0 01-.07 0c-.03 0-.05-.01-.09-.05l-45.02-45.02a.2.2 0 01-.05-.09.12.12 0 010-.07c0-.02.01-.04.06-.08L466.75 512 338.88 384.14a.27.27 0 01-.05-.06l-.01-.02a.12.12 0 010-.07c0-.03.01-.05.05-.09l45.02-45.02a.2.2 0 01.09-.05.12.12 0 01.07 0c.02 0 .04.01.08.06L512 466.75l127.86-127.86c.04-.05.06-.06.08-.06a.12.12 0 01.07 0z" } }] }, "name": "close-square", "theme": "outlined" };
var CloseSquareOutlinedSvg = CloseSquareOutlined$2;

var CloseSquareOutlined = function CloseSquareOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CloseSquareOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CloseSquareOutlined.displayName = 'CloseSquareOutlined';
}
var CloseSquareOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CloseSquareOutlined);

// This icon file is generated automatically.
var CloseSquareTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm163.9-473.9A7.95 7.95 0 01354 353h58.9c4.7 0 9.2 2.1 12.3 5.7L512 462.2l86.8-103.5c3-3.6 7.5-5.7 12.3-5.7H670c6.8 0 10.5 7.9 6.1 13.1L553.8 512l122.3 145.9c4.4 5.2.7 13.1-6.1 13.1h-58.9c-4.7 0-9.2-2.1-12.3-5.7L512 561.8l-86.8 103.5c-3 3.6-7.5 5.7-12.3 5.7H354c-6.8 0-10.5-7.9-6.1-13.1L470.2 512 347.9 366.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M354 671h58.9c4.8 0 9.3-2.1 12.3-5.7L512 561.8l86.8 103.5c3.1 3.6 7.6 5.7 12.3 5.7H670c6.8 0 10.5-7.9 6.1-13.1L553.8 512l122.3-145.9c4.4-5.2.7-13.1-6.1-13.1h-58.9c-4.8 0-9.3 2.1-12.3 5.7L512 462.2l-86.8-103.5c-3.1-3.6-7.6-5.7-12.3-5.7H354c-6.8 0-10.5 7.9-6.1 13.1L470.2 512 347.9 657.9A7.95 7.95 0 00354 671z", "fill": primaryColor } }] }; }, "name": "close-square", "theme": "twotone" };
var CloseSquareTwoToneSvg = CloseSquareTwoTone$2;

var CloseSquareTwoTone = function CloseSquareTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CloseSquareTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CloseSquareTwoTone.displayName = 'CloseSquareTwoTone';
}
var CloseSquareTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(CloseSquareTwoTone);

// This icon file is generated automatically.
var CloudDownloadOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9z" } }, { "tag": "path", "attrs": { "d": "M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0152.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 01-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z" } }] }, "name": "cloud-download", "theme": "outlined" };
var CloudDownloadOutlinedSvg = CloudDownloadOutlined$2;

var CloudDownloadOutlined = function CloudDownloadOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CloudDownloadOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CloudDownloadOutlined.displayName = 'CloudDownloadOutlined';
}
var CloudDownloadOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CloudDownloadOutlined);

// This icon file is generated automatically.
var CloudFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3z" } }] }, "name": "cloud", "theme": "filled" };
var CloudFilledSvg = CloudFilled$2;

var CloudFilled = function CloudFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CloudFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CloudFilled.displayName = 'CloudFilled';
}
var CloudFilled$1 = /*#__PURE__*/React__namespace.forwardRef(CloudFilled);

// This icon file is generated automatically.
var CloudOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3zm36.3 281a123.07 123.07 0 01-87.6 36.3H263.9c-33.1 0-64.2-12.9-87.6-36.3A123.3 123.3 0 01140 612c0-28 9.1-54.3 26.2-76.3a125.7 125.7 0 0166.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0152.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-12.9 64.3-36.3 87.7z" } }] }, "name": "cloud", "theme": "outlined" };
var CloudOutlinedSvg = CloudOutlined$2;

var CloudOutlined = function CloudOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CloudOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CloudOutlined.displayName = 'CloudOutlined';
}
var CloudOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CloudOutlined);

// This icon file is generated automatically.
var CloudServerOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M704 446H320c-4.4 0-8 3.6-8 8v402c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8V454c0-4.4-3.6-8-8-8zm-328 64h272v117H376V510zm272 290H376V683h272v117z" } }, { "tag": "path", "attrs": { "d": "M424 748a32 32 0 1064 0 32 32 0 10-64 0zm0-178a32 32 0 1064 0 32 32 0 10-64 0z" } }, { "tag": "path", "attrs": { "d": "M811.4 368.9C765.6 248 648.9 162 512.2 162S258.8 247.9 213 368.8C126.9 391.5 63.5 470.2 64 563.6 64.6 668 145.6 752.9 247.6 762c4.7.4 8.7-3.3 8.7-8v-60.4c0-4-3-7.4-7-7.9-27-3.4-52.5-15.2-72.1-34.5-24-23.5-37.2-55.1-37.2-88.6 0-28 9.1-54.4 26.2-76.4 16.7-21.4 40.2-36.9 66.1-43.7l37.9-10 13.9-36.7c8.6-22.8 20.6-44.2 35.7-63.5 14.9-19.2 32.6-36 52.4-50 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.3c19.9 14 37.5 30.8 52.4 50 15.1 19.3 27.1 40.7 35.7 63.5l13.8 36.6 37.8 10c54.2 14.4 92.1 63.7 92.1 120 0 33.6-13.2 65.1-37.2 88.6-19.5 19.2-44.9 31.1-71.9 34.5-4 .5-6.9 3.9-6.9 7.9V754c0 4.7 4.1 8.4 8.8 8 101.7-9.2 182.5-94 183.2-198.2.6-93.4-62.7-172.1-148.6-194.9z" } }] }, "name": "cloud-server", "theme": "outlined" };
var CloudServerOutlinedSvg = CloudServerOutlined$2;

var CloudServerOutlined = function CloudServerOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CloudServerOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CloudServerOutlined.displayName = 'CloudServerOutlined';
}
var CloudServerOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CloudServerOutlined);

// This icon file is generated automatically.
var CloudSyncOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M811.4 368.9C765.6 248 648.9 162 512.2 162S258.8 247.9 213 368.8C126.9 391.5 63.5 470.2 64 563.6 64.6 668 145.6 752.9 247.6 762c4.7.4 8.7-3.3 8.7-8v-60.4c0-4-3-7.4-7-7.9-27-3.4-52.5-15.2-72.1-34.5-24-23.5-37.2-55.1-37.2-88.6 0-28 9.1-54.4 26.2-76.4 16.7-21.4 40.2-36.9 66.1-43.7l37.9-10 13.9-36.7c8.6-22.8 20.6-44.2 35.7-63.5 14.9-19.2 32.6-36 52.4-50 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.3c19.9 14 37.5 30.8 52.4 50 15.1 19.3 27.1 40.7 35.7 63.5l13.8 36.6 37.8 10c54.2 14.4 92.1 63.7 92.1 120 0 33.6-13.2 65.1-37.2 88.6-19.5 19.2-44.9 31.1-71.9 34.5-4 .5-6.9 3.9-6.9 7.9V754c0 4.7 4.1 8.4 8.8 8 101.7-9.2 182.5-94 183.2-198.2.6-93.4-62.7-172.1-148.6-194.9z" } }, { "tag": "path", "attrs": { "d": "M376.9 656.4c1.8-33.5 15.7-64.7 39.5-88.6 25.4-25.5 60-39.8 96-39.8 36.2 0 70.3 14.1 96 39.8 1.4 1.4 2.7 2.8 4.1 4.3l-25 19.6a8 8 0 003 14.1l98.2 24c5 1.2 9.9-2.6 9.9-7.7l.5-101.3c0-6.7-7.6-10.5-12.9-6.3L663 532.7c-36.6-42-90.4-68.6-150.5-68.6-107.4 0-195 85.1-199.4 191.7-.2 4.5 3.4 8.3 8 8.3H369c4.2-.1 7.7-3.4 7.9-7.7zM703 664h-47.9c-4.2 0-7.7 3.3-8 7.6-1.8 33.5-15.7 64.7-39.5 88.6-25.4 25.5-60 39.8-96 39.8-36.2 0-70.3-14.1-96-39.8-1.4-1.4-2.7-2.8-4.1-4.3l25-19.6a8 8 0 00-3-14.1l-98.2-24c-5-1.2-9.9 2.6-9.9 7.7l-.4 101.4c0 6.7 7.6 10.5 12.9 6.3l23.2-18.2c36.6 42 90.4 68.6 150.5 68.6 107.4 0 195-85.1 199.4-191.7.2-4.5-3.4-8.3-8-8.3z" } }] }, "name": "cloud-sync", "theme": "outlined" };
var CloudSyncOutlinedSvg = CloudSyncOutlined$2;

var CloudSyncOutlined = function CloudSyncOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CloudSyncOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CloudSyncOutlined.displayName = 'CloudSyncOutlined';
}
var CloudSyncOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CloudSyncOutlined);

// This icon file is generated automatically.
var CloudTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M791.9 492l-37.8-10-13.8-36.5c-8.6-22.7-20.6-44.1-35.7-63.4a245.73 245.73 0 00-52.4-49.9c-41.1-28.9-89.5-44.2-140-44.2s-98.9 15.3-140 44.2a245.6 245.6 0 00-52.4 49.9 240.47 240.47 0 00-35.7 63.4l-13.9 36.6-37.9 9.9a125.7 125.7 0 00-66.1 43.7A123.1 123.1 0 00140 612c0 33.1 12.9 64.3 36.3 87.7 23.4 23.4 54.5 36.3 87.6 36.3h496.2c33.1 0 64.2-12.9 87.6-36.3A123.3 123.3 0 00884 612c0-56.2-37.8-105.5-92.1-120z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3zm36.3 281a123.07 123.07 0 01-87.6 36.3H263.9c-33.1 0-64.2-12.9-87.6-36.3A123.3 123.3 0 01140 612c0-28 9.1-54.3 26.2-76.3a125.7 125.7 0 0166.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0152.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-12.9 64.3-36.3 87.7z", "fill": primaryColor } }] }; }, "name": "cloud", "theme": "twotone" };
var CloudTwoToneSvg = CloudTwoTone$2;

var CloudTwoTone = function CloudTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CloudTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CloudTwoTone.displayName = 'CloudTwoTone';
}
var CloudTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(CloudTwoTone);

// This icon file is generated automatically.
var CloudUploadOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M518.3 459a8 8 0 00-12.6 0l-112 141.7a7.98 7.98 0 006.3 12.9h73.9V856c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V613.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 459z" } }, { "tag": "path", "attrs": { "d": "M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0152.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 01-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z" } }] }, "name": "cloud-upload", "theme": "outlined" };
var CloudUploadOutlinedSvg = CloudUploadOutlined$2;

var CloudUploadOutlined = function CloudUploadOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CloudUploadOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CloudUploadOutlined.displayName = 'CloudUploadOutlined';
}
var CloudUploadOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CloudUploadOutlined);

// This icon file is generated automatically.
var ClusterOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888 680h-54V540H546v-92h238c8.8 0 16-7.2 16-16V168c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h238v92H190v140h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8h-54v-72h220v72h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8h-54v-72h220v72h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8zM256 805.3c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zm288 0c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zM288 384V216h448v168H288zm544 421.3c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zM360 300a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "cluster", "theme": "outlined" };
var ClusterOutlinedSvg = ClusterOutlined$2;

var ClusterOutlined = function ClusterOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ClusterOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ClusterOutlined.displayName = 'ClusterOutlined';
}
var ClusterOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ClusterOutlined);

// This icon file is generated automatically.
var CodeFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM513.1 518.1l-192 161c-5.2 4.4-13.1.7-13.1-6.1v-62.7c0-2.3 1.1-4.6 2.9-6.1L420.7 512l-109.8-92.2a7.63 7.63 0 01-2.9-6.1V351c0-6.8 7.9-10.5 13.1-6.1l192 160.9c3.9 3.2 3.9 9.1 0 12.3zM716 673c0 4.4-3.4 8-7.5 8h-185c-4.1 0-7.5-3.6-7.5-8v-48c0-4.4 3.4-8 7.5-8h185c4.1 0 7.5 3.6 7.5 8v48z" } }] }, "name": "code", "theme": "filled" };
var CodeFilledSvg = CodeFilled$2;

var CodeFilled = function CodeFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CodeFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CodeFilled.displayName = 'CodeFilled';
}
var CodeFilled$1 = /*#__PURE__*/React__namespace.forwardRef(CodeFilled);

// This icon file is generated automatically.
var CodeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48zm-194.9 6.1l192-161c3.8-3.2 3.8-9.1 0-12.3l-192-160.9A7.95 7.95 0 00308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 00-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "code", "theme": "outlined" };
var CodeOutlinedSvg = CodeOutlined$2;

var CodeOutlined = function CodeOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CodeOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CodeOutlined.displayName = 'CodeOutlined';
}
var CodeOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CodeOutlined);

// This icon file is generated automatically.
var CodeSandboxCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm243.7 589.2L512 794 268.3 653.2V371.8l110-63.6-.4-.2h.2L512 231l134 77h-.2l-.3.2 110.1 63.6v281.4zM307.9 536.7l87.6 49.9V681l96.7 55.9V524.8L307.9 418.4zm203.9-151.8L418 331l-91.1 52.6 185.2 107 185.2-106.9-91.4-52.8zm20 352l97.3-56.2v-94.1l87-49.5V418.5L531.8 525z" } }] }, "name": "code-sandbox-circle", "theme": "filled" };
var CodeSandboxCircleFilledSvg = CodeSandboxCircleFilled$2;

var CodeSandboxCircleFilled = function CodeSandboxCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CodeSandboxCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CodeSandboxCircleFilled.displayName = 'CodeSandboxCircleFilled';
}
var CodeSandboxCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(CodeSandboxCircleFilled);

// This icon file is generated automatically.
var CodeSandboxOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M709.6 210l.4-.2h.2L512 96 313.9 209.8h-.2l.7.3L151.5 304v416L512 928l360.5-208V304l-162.9-94zM482.7 843.6L339.6 761V621.4L210 547.8V372.9l272.7 157.3v313.4zM238.2 321.5l134.7-77.8 138.9 79.7 139.1-79.9 135.2 78-273.9 158-274-158zM814 548.3l-128.8 73.1v139.1l-143.9 83V530.4L814 373.1v175.2z" } }] }, "name": "code-sandbox", "theme": "outlined" };
var CodeSandboxOutlinedSvg = CodeSandboxOutlined$2;

var CodeSandboxOutlined = function CodeSandboxOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CodeSandboxOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CodeSandboxOutlined.displayName = 'CodeSandboxOutlined';
}
var CodeSandboxOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CodeSandboxOutlined);

// This icon file is generated automatically.
var CodeSandboxSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M307.9 536.7l87.6 49.9V681l96.7 55.9V524.8L307.9 418.4zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM755.7 653.2L512 794 268.3 653.2V371.8l110-63.6-.4-.2h.2L512 231l134 77h-.2l-.3.2 110.1 63.6v281.4zm-223.9 83.7l97.3-56.2v-94.1l87-49.5V418.5L531.8 525zm-20-352L418 331l-91.1 52.6 185.2 107 185.2-106.9-91.4-52.8z" } }] }, "name": "code-sandbox-square", "theme": "filled" };
var CodeSandboxSquareFilledSvg = CodeSandboxSquareFilled$2;

var CodeSandboxSquareFilled = function CodeSandboxSquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CodeSandboxSquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CodeSandboxSquareFilled.displayName = 'CodeSandboxSquareFilled';
}
var CodeSandboxSquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(CodeSandboxSquareFilled);

// This icon file is generated automatically.
var CodeTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm339.5-223h185c4.1 0 7.5 3.6 7.5 8v48c0 4.4-3.4 8-7.5 8h-185c-4.1 0-7.5-3.6-7.5-8v-48c0-4.4 3.4-8 7.5-8zM308 610.3c0-2.3 1.1-4.6 2.9-6.1L420.7 512l-109.8-92.2a7.63 7.63 0 01-2.9-6.1V351c0-6.8 7.9-10.5 13.1-6.1l192 160.9c3.9 3.2 3.9 9.1 0 12.3l-192 161c-5.2 4.4-13.1.7-13.1-6.1v-62.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M321.1 679.1l192-161c3.9-3.2 3.9-9.1 0-12.3l-192-160.9A7.95 7.95 0 00308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 00-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48z", "fill": primaryColor } }] }; }, "name": "code", "theme": "twotone" };
var CodeTwoToneSvg = CodeTwoTone$2;

var CodeTwoTone = function CodeTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CodeTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CodeTwoTone.displayName = 'CodeTwoTone';
}
var CodeTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(CodeTwoTone);

// This icon file is generated automatically.
var CodepenCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M488.1 414.7V303.4L300.9 428l83.6 55.8zm254.1 137.7v-79.8l-59.8 39.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm278 533c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 01-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 01-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 01.8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-254.1 13.3v111.3L723.1 597l-83.6-55.8zM281.8 472.6v79.8l59.8-39.9zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zM723.1 428L535.9 303.4v111.3l103.6 69.1zM384.5 541.2L300.9 597l187.2 124.6V610.3l-103.6-69.1z" } }] }, "name": "codepen-circle", "theme": "filled" };
var CodepenCircleFilledSvg = CodepenCircleFilled$2;

var CodepenCircleFilled = function CodepenCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CodepenCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CodepenCircleFilled.displayName = 'CodepenCircleFilled';
}
var CodepenCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(CodepenCircleFilled);

// This icon file is generated automatically.
var CodepenCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M488.1 414.7V303.4L300.9 428l83.6 55.8zm254.1 137.7v-79.8l-59.8 39.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm278 533c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 01-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 01-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 01.8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-254.1 13.3v111.3L723.1 597l-83.6-55.8zM281.8 472.6v79.8l59.8-39.9zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zM723.1 428L535.9 303.4v111.3l103.6 69.1zM384.5 541.2L300.9 597l187.2 124.6V610.3l-103.6-69.1z" } }] }, "name": "codepen-circle", "theme": "outlined" };
var CodepenCircleOutlinedSvg = CodepenCircleOutlined$2;

var CodepenCircleOutlined = function CodepenCircleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CodepenCircleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CodepenCircleOutlined.displayName = 'CodepenCircleOutlined';
}
var CodepenCircleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CodepenCircleOutlined);

// This icon file is generated automatically.
var CodepenOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M911.7 385.3l-.3-1.5c-.2-1-.3-1.9-.6-2.9-.2-.6-.4-1.1-.5-1.7-.3-.8-.5-1.7-.9-2.5-.2-.6-.5-1.1-.8-1.7-.4-.8-.8-1.5-1.2-2.3-.3-.5-.6-1.1-1-1.6-.8-1.2-1.7-2.4-2.6-3.6-.5-.6-1.1-1.3-1.7-1.9-.4-.5-.9-.9-1.4-1.3-.6-.6-1.3-1.1-1.9-1.6-.5-.4-1-.8-1.6-1.2-.2-.1-.4-.3-.6-.4L531.1 117.8a34.3 34.3 0 00-38.1 0L127.3 361.3c-.2.1-.4.3-.6.4-.5.4-1 .8-1.6 1.2-.7.5-1.3 1.1-1.9 1.6-.5.4-.9.9-1.4 1.3-.6.6-1.2 1.2-1.7 1.9-1 1.1-1.8 2.3-2.6 3.6-.3.5-.7 1-1 1.6-.4.7-.8 1.5-1.2 2.3-.3.5-.5 1.1-.8 1.7-.3.8-.6 1.7-.9 2.5-.2.6-.4 1.1-.5 1.7-.2.9-.4 1.9-.6 2.9l-.3 1.5c-.2 1.5-.3 3-.3 4.5v243.5c0 1.5.1 3 .3 4.5l.3 1.5.6 2.9c.2.6.3 1.1.5 1.7.3.9.6 1.7.9 2.5.2.6.5 1.1.8 1.7.4.8.7 1.5 1.2 2.3.3.5.6 1.1 1 1.6.5.7.9 1.4 1.5 2.1l1.2 1.5c.5.6 1.1 1.3 1.7 1.9.4.5.9.9 1.4 1.3.6.6 1.3 1.1 1.9 1.6.5.4 1 .8 1.6 1.2.2.1.4.3.6.4L493 905.7c5.6 3.8 12.3 5.8 19.1 5.8 6.6 0 13.3-1.9 19.1-5.8l365.6-243.5c.2-.1.4-.3.6-.4.5-.4 1-.8 1.6-1.2.7-.5 1.3-1.1 1.9-1.6.5-.4.9-.9 1.4-1.3.6-.6 1.2-1.2 1.7-1.9l1.2-1.5 1.5-2.1c.3-.5.7-1 1-1.6.4-.8.8-1.5 1.2-2.3.3-.5.5-1.1.8-1.7.3-.8.6-1.7.9-2.5.2-.5.4-1.1.5-1.7.3-.9.4-1.9.6-2.9l.3-1.5c.2-1.5.3-3 .3-4.5V389.8c-.3-1.5-.4-3-.6-4.5zM546.4 210.5l269.4 179.4-120.3 80.4-149-99.6V210.5zm-68.8 0v160.2l-149 99.6-120.3-80.4 269.3-179.4zM180.7 454.1l86 57.5-86 57.5v-115zm296.9 358.5L208.3 633.2l120.3-80.4 149 99.6v160.2zM512 592.8l-121.6-81.2L512 430.3l121.6 81.2L512 592.8zm34.4 219.8V652.4l149-99.6 120.3 80.4-269.3 179.4zM843.3 569l-86-57.5 86-57.5v115z" } }] }, "name": "codepen", "theme": "outlined" };
var CodepenOutlinedSvg = CodepenOutlined$2;

var CodepenOutlined = function CodepenOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CodepenOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CodepenOutlined.displayName = 'CodepenOutlined';
}
var CodepenOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CodepenOutlined);

// This icon file is generated automatically.
var CodepenSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M723.1 428L535.9 303.4v111.3l103.6 69.1zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zm23.9 154.2v111.3L723.1 597l-83.6-55.8zm-151.4-69.1L300.9 597l187.2 124.6V610.3l-103.6-69.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-90 485c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 01-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 01-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 01.8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-47.8-44.6v-79.8l-59.8 39.9zm-460.4-79.8v79.8l59.8-39.9zm206.3-57.9V303.4L300.9 428l83.6 55.8z" } }] }, "name": "codepen-square", "theme": "filled" };
var CodepenSquareFilledSvg = CodepenSquareFilled$2;

var CodepenSquareFilled = function CodepenSquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CodepenSquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CodepenSquareFilled.displayName = 'CodepenSquareFilled';
}
var CodepenSquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(CodepenSquareFilled);

// This icon file is generated automatically.
var CoffeeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M275 281c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36zm613 144H768c0-39.8-32.2-72-72-72H200c-39.8 0-72 32.2-72 72v248c0 3.4.2 6.7.7 9.9-.5 7-.7 14-.7 21.1 0 176.7 143.3 320 320 320 160.1 0 292.7-117.5 316.3-271H888c39.8 0 72-32.2 72-72V497c0-39.8-32.2-72-72-72zM696 681h-1.1c.7 7.6 1.1 15.2 1.1 23 0 137-111 248-248 248S200 841 200 704c0-7.8.4-15.4 1.1-23H200V425h496v256zm192-8H776V497h112v176zM613 281c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36zm-170 0c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36z" } }] }, "name": "coffee", "theme": "outlined" };
var CoffeeOutlinedSvg = CoffeeOutlined$2;

var CoffeeOutlined = function CoffeeOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CoffeeOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CoffeeOutlined.displayName = 'CoffeeOutlined';
}
var CoffeeOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CoffeeOutlined);

// This icon file is generated automatically.
var ColumnHeightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M840 836H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm0-724H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM610.8 378c6 0 9.4-7 5.7-11.7L515.7 238.7a7.14 7.14 0 00-11.3 0L403.6 366.3a7.23 7.23 0 005.7 11.7H476v268h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V378h62.8z" } }] }, "name": "column-height", "theme": "outlined" };
var ColumnHeightOutlinedSvg = ColumnHeightOutlined$2;

var ColumnHeightOutlined = function ColumnHeightOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ColumnHeightOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ColumnHeightOutlined.displayName = 'ColumnHeightOutlined';
}
var ColumnHeightOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ColumnHeightOutlined);

// This icon file is generated automatically.
var ColumnWidthOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M180 176h-60c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8zm724 0h-60c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8zM785.3 504.3L657.7 403.6a7.23 7.23 0 00-11.7 5.7V476H378v-62.8c0-6-7-9.4-11.7-5.7L238.7 508.3a7.14 7.14 0 000 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h268v62.8c0 6 7 9.4 11.7 5.7l127.5-100.8c3.8-2.9 3.8-8.5.2-11.4z" } }] }, "name": "column-width", "theme": "outlined" };
var ColumnWidthOutlinedSvg = ColumnWidthOutlined$2;

var ColumnWidthOutlined = function ColumnWidthOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ColumnWidthOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ColumnWidthOutlined.displayName = 'ColumnWidthOutlined';
}
var ColumnWidthOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ColumnWidthOutlined);

// This icon file is generated automatically.
var CommentOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M573 421c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40zm-280 0c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40z" } }, { "tag": "path", "attrs": { "d": "M894 345a343.92 343.92 0 00-189-130v.1c-17.1-19-36.4-36.5-58-52.1-163.7-119-393.5-82.7-513 81-96.3 133-92.2 311.9 6 439l.8 132.6c0 3.2.5 6.4 1.5 9.4a31.95 31.95 0 0040.1 20.9L309 806c33.5 11.9 68.1 18.7 102.5 20.6l-.5.4c89.1 64.9 205.9 84.4 313 49l127.1 41.4c3.2 1 6.5 1.6 9.9 1.6 17.7 0 32-14.3 32-32V753c88.1-119.6 90.4-284.9 1-408zM323 735l-12-5-99 31-1-104-8-9c-84.6-103.2-90.2-251.9-11-361 96.4-132.2 281.2-161.4 413-66 132.2 96.1 161.5 280.6 66 412-80.1 109.9-223.5 150.5-348 102zm505-17l-8 10 1 104-98-33-12 5c-56 20.8-115.7 22.5-171 7l-.2-.1A367.31 367.31 0 00729 676c76.4-105.3 88.8-237.6 44.4-350.4l.6.4c23 16.5 44.1 37.1 62 62 72.6 99.6 68.5 235.2-8 330z" } }, { "tag": "path", "attrs": { "d": "M433 421c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40z" } }] }, "name": "comment", "theme": "outlined" };
var CommentOutlinedSvg = CommentOutlined$2;

var CommentOutlined = function CommentOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CommentOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CommentOutlined.displayName = 'CommentOutlined';
}
var CommentOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CommentOutlined);

// This icon file is generated automatically.
var CompassFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM327.3 702.4c-2 .9-4.4 0-5.3-2.1-.4-1-.4-2.2 0-3.2l98.7-225.5 132.1 132.1-225.5 98.7zm375.1-375.1l-98.7 225.5-132.1-132.1L697.1 322c2-.9 4.4 0 5.3 2.1.4 1 .4 2.1 0 3.2z" } }] }, "name": "compass", "theme": "filled" };
var CompassFilledSvg = CompassFilled$2;

var CompassFilled = function CompassFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CompassFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CompassFilled.displayName = 'CompassFilled';
}
var CompassFilled$1 = /*#__PURE__*/React__namespace.forwardRef(CompassFilled);

// This icon file is generated automatically.
var CompassOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm198.4-588.1a32 32 0 00-24.5.5L414.9 415 296.4 686c-3.6 8.2-3.6 17.5 0 25.7 3.4 7.8 9.7 13.9 17.7 17 3.8 1.5 7.7 2.2 11.7 2.2 4.4 0 8.7-.9 12.8-2.7l271-118.6 118.5-271a32.06 32.06 0 00-17.7-42.7zM576.8 534.4l26.2 26.2-42.4 42.4-26.2-26.2L380 644.4 447.5 490 422 464.4l42.4-42.4 25.5 25.5L644.4 380l-67.6 154.4zM464.4 422L422 464.4l25.5 25.6 86.9 86.8 26.2 26.2 42.4-42.4-26.2-26.2-86.8-86.9z" } }] }, "name": "compass", "theme": "outlined" };
var CompassOutlinedSvg = CompassOutlined$2;

var CompassOutlined = function CompassOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CompassOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CompassOutlined.displayName = 'CompassOutlined';
}
var CompassOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CompassOutlined);

// This icon file is generated automatically.
var CompassTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM327.6 701.7c-2 .9-4.4 0-5.3-2.1-.4-1-.4-2.2 0-3.2L421 470.9 553.1 603l-225.5 98.7zm375.1-375.1L604 552.1 471.9 420l225.5-98.7c2-.9 4.4 0 5.3 2.1.4 1 .4 2.1 0 3.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M322.3 696.4c-.4 1-.4 2.2 0 3.2.9 2.1 3.3 3 5.3 2.1L553.1 603 421 470.9l-98.7 225.5zm375.1-375.1L471.9 420 604 552.1l98.7-225.5c.4-1.1.4-2.2 0-3.2-.9-2.1-3.3-3-5.3-2.1z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }] }; }, "name": "compass", "theme": "twotone" };
var CompassTwoToneSvg = CompassTwoTone$2;

var CompassTwoTone = function CompassTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CompassTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CompassTwoTone.displayName = 'CompassTwoTone';
}
var CompassTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(CompassTwoTone);

// This icon file is generated automatically.
var CompressOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M326 664H104c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h174v176c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V696c0-17.7-14.3-32-32-32zm16-576h-48c-8.8 0-16 7.2-16 16v176H104c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h222c17.7 0 32-14.3 32-32V104c0-8.8-7.2-16-16-16zm578 576H698c-17.7 0-32 14.3-32 32v224c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V744h174c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16zm0-384H746V104c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16v224c0 17.7 14.3 32 32 32h222c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16z" } }] }, "name": "compress", "theme": "outlined" };
var CompressOutlinedSvg = CompressOutlined$2;

var CompressOutlined = function CompressOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CompressOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CompressOutlined.displayName = 'CompressOutlined';
}
var CompressOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CompressOutlined);

// This icon file is generated automatically.
var ConsoleSqlOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M301.3 496.7c-23.8 0-40.2-10.5-41.6-26.9H205c.9 43.4 36.9 70.3 93.9 70.3 59.1 0 95-28.4 95-75.5 0-35.8-20-55.9-64.5-64.5l-29.1-5.6c-23.8-4.7-33.8-11.9-33.8-24.2 0-15 13.3-24.5 33.4-24.5 20.1 0 35.3 11.1 36.6 27h53c-.9-41.7-37.5-70.3-90.3-70.3-54.4 0-89.7 28.9-89.7 73 0 35.5 21.2 58 62.5 65.8l29.7 5.9c25.8 5.2 35.6 11.9 35.6 24.4.1 14.7-14.5 25.1-36 25.1z" } }, { "tag": "path", "attrs": { "d": "M928 140H96c-17.7 0-32 14.3-32 32v496c0 17.7 14.3 32 32 32h380v112H304c-8.8 0-16 7.2-16 16v48c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-48c0-8.8-7.2-16-16-16H548V700h380c17.7 0 32-14.3 32-32V172c0-17.7-14.3-32-32-32zm-40 488H136V212h752v416z" } }, { "tag": "path", "attrs": { "d": "M828.5 486.7h-95.8V308.5h-57.4V534h153.2zm-298.6 53.4c14.1 0 27.2-2 39.1-5.8l13.3 20.3h53.3L607.9 511c21.1-20 33-51.1 33-89.8 0-73.3-43.3-118.8-110.9-118.8s-111.2 45.3-111.2 118.8c-.1 73.7 43 118.9 111.1 118.9zm0-190c31.6 0 52.7 27.7 52.7 71.1 0 16.7-3.6 30.6-10 40.5l-5.2-6.9h-48.8L542 491c-3.9.9-8 1.4-12.2 1.4-31.7 0-52.8-27.5-52.8-71.2.1-43.6 21.2-71.1 52.9-71.1z" } }] }, "name": "console-sql", "theme": "outlined" };
var ConsoleSqlOutlinedSvg = ConsoleSqlOutlined$2;

var ConsoleSqlOutlined = function ConsoleSqlOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ConsoleSqlOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ConsoleSqlOutlined.displayName = 'ConsoleSqlOutlined';
}
var ConsoleSqlOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ConsoleSqlOutlined);

// This icon file is generated automatically.
var ContactsFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zM661 736h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.6-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H363a8 8 0 01-8-8.4c2.8-53.3 32-99.7 74.6-126.1a111.8 111.8 0 01-29.1-75.5c0-61.9 49.9-112 111.4-112 61.5 0 111.4 50.1 111.4 112 0 29.1-11 55.5-29.1 75.5 42.7 26.5 71.8 72.8 74.6 126.1.4 4.6-3.2 8.4-7.8 8.4zM512 474c-28.5 0-51.7 23.3-51.7 52s23.2 52 51.7 52c28.5 0 51.7-23.3 51.7-52s-23.2-52-51.7-52z" } }] }, "name": "contacts", "theme": "filled" };
var ContactsFilledSvg = ContactsFilled$2;

var ContactsFilled = function ContactsFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ContactsFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ContactsFilled.displayName = 'ContactsFilled';
}
var ContactsFilled$1 = /*#__PURE__*/React__namespace.forwardRef(ContactsFilled);

// This icon file is generated automatically.
var ContactsOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M594.3 601.5a111.8 111.8 0 0029.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 00-74.6 126.1 8 8 0 008 8.4H407c4.2 0 7.6-3.3 7.9-7.5 3.8-50.6 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H661a8 8 0 008-8.4c-2.8-53.3-32-99.7-74.7-126.1zM512 578c-28.5 0-51.7-23.3-51.7-52s23.2-52 51.7-52 51.7 23.3 51.7 52-23.2 52-51.7 52zm416-354H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z" } }] }, "name": "contacts", "theme": "outlined" };
var ContactsOutlinedSvg = ContactsOutlined$2;

var ContactsOutlined = function ContactsOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ContactsOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ContactsOutlined.displayName = 'ContactsOutlined';
}
var ContactsOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ContactsOutlined);

// This icon file is generated automatically.
var ContactsTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M460.3 526a51.7 52 0 10103.4 0 51.7 52 0 10-103.4 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M768 352c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H548v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H328v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H136v496h752V296H768v56zM661 736h-43.8c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 39.9-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5h-43.9a8 8 0 01-8-8.4c2.8-53.3 31.9-99.6 74.6-126.1-18.1-20-29.1-46.4-29.1-75.5 0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.6-29.1 75.5 42.7 26.4 71.9 72.8 74.7 126.1a8 8 0 01-8 8.4z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M594.3 601.5a111.8 111.8 0 0029.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 00-74.6 126.1 8 8 0 008 8.4H407c4.2 0 7.6-3.3 7.9-7.5 3.8-50.6 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H661a8 8 0 008-8.4c-2.8-53.3-32-99.7-74.7-126.1zM512 578c-28.5 0-51.7-23.3-51.7-52s23.2-52 51.7-52 51.7 23.3 51.7 52-23.2 52-51.7 52z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z", "fill": primaryColor } }] }; }, "name": "contacts", "theme": "twotone" };
var ContactsTwoToneSvg = ContactsTwoTone$2;

var ContactsTwoTone = function ContactsTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ContactsTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ContactsTwoTone.displayName = 'ContactsTwoTone';
}
var ContactsTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(ContactsTwoTone);

// This icon file is generated automatically.
var ContainerFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v529c0-.6.4-1 1-1h219.3l5.2 24.7C397.6 708.5 450.8 752 512 752s114.4-43.5 126.4-103.3l5.2-24.7H863c.6 0 1 .4 1 1V96c0-17.7-14.3-32-32-32zM712 493c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8v48zm0-160c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8v48zm151 354H694.1c-11.6 32.8-32 62.3-59.1 84.7-34.5 28.6-78.2 44.3-123 44.3s-88.5-15.8-123-44.3a194.02 194.02 0 01-59.1-84.7H161c-.6 0-1-.4-1-1v242c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V686c0 .6-.4 1-1 1z" } }] }, "name": "container", "theme": "filled" };
var ContainerFilledSvg = ContainerFilled$2;

var ContainerFilled = function ContainerFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ContainerFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ContainerFilled.displayName = 'ContainerFilled';
}
var ContainerFilled$1 = /*#__PURE__*/React__namespace.forwardRef(ContainerFilled);

// This icon file is generated automatically.
var ContainerOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V687h97.9c11.6 32.8 32 62.3 59.1 84.7 34.5 28.5 78.2 44.3 123 44.3s88.5-15.7 123-44.3c27.1-22.4 47.5-51.9 59.1-84.7H792v-63H643.6l-5.2 24.7C626.4 708.5 573.2 752 512 752s-114.4-43.5-126.5-103.3l-5.2-24.7H232V136h560v752zM320 341h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 160h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }] }, "name": "container", "theme": "outlined" };
var ContainerOutlinedSvg = ContainerOutlined$2;

var ContainerOutlined = function ContainerOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ContainerOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ContainerOutlined.displayName = 'ContainerOutlined';
}
var ContainerOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ContainerOutlined);

// This icon file is generated automatically.
var ContainerTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M635 771.7c-34.5 28.6-78.2 44.3-123 44.3s-88.5-15.8-123-44.3a194.02 194.02 0 01-59.1-84.7H232v201h560V687h-97.9c-11.6 32.8-32 62.3-59.1 84.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M320 501h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V687h97.9c11.6 32.8 32 62.3 59.1 84.7 34.5 28.5 78.2 44.3 123 44.3s88.5-15.7 123-44.3c27.1-22.4 47.5-51.9 59.1-84.7H792v201zm0-264H643.6l-5.2 24.7C626.4 708.5 573.2 752 512 752s-114.4-43.5-126.5-103.3l-5.2-24.7H232V136h560v488z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M320 341h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z", "fill": primaryColor } }] }; }, "name": "container", "theme": "twotone" };
var ContainerTwoToneSvg = ContainerTwoTone$2;

var ContainerTwoTone = function ContainerTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ContainerTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ContainerTwoTone.displayName = 'ContainerTwoTone';
}
var ContainerTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(ContainerTwoTone);

// This icon file is generated automatically.
var ControlFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM404 683v77c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-77c-41.7-13.6-72-52.8-72-99s30.3-85.5 72-99V264c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v221c41.7 13.6 72 52.8 72 99s-30.3 85.5-72 99zm279.6-143.9c.2 0 .3-.1.4-.1v221c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V539c.2 0 .3.1.4.1-42-13.4-72.4-52.7-72.4-99.1 0-46.4 30.4-85.7 72.4-99.1-.2 0-.3.1-.4.1v-77c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v77c-.2 0-.3-.1-.4-.1 42 13.4 72.4 52.7 72.4 99.1 0 46.4-30.4 85.7-72.4 99.1zM616 440a36 36 0 1072 0 36 36 0 10-72 0zM403.4 566.5l-1.5-2.4c0-.1-.1-.1-.1-.2l-.9-1.2c-.1-.1-.2-.2-.2-.3-1-1.3-2-2.5-3.2-3.6l-.2-.2c-.4-.4-.8-.8-1.2-1.1-.8-.8-1.7-1.5-2.6-2.1h-.1l-1.2-.9c-.1-.1-.3-.2-.4-.3-1.2-.8-2.5-1.6-3.9-2.2-.2-.1-.5-.2-.7-.4-.4-.2-.7-.3-1.1-.5-.3-.1-.7-.3-1-.4-.5-.2-1-.4-1.5-.5-.4-.1-.9-.3-1.3-.4l-.9-.3-1.4-.3c-.2-.1-.5-.1-.7-.2-.7-.1-1.4-.3-2.1-.4-.2 0-.4 0-.6-.1-.6-.1-1.1-.1-1.7-.2-.2 0-.4 0-.7-.1-.8 0-1.5-.1-2.3-.1s-1.5 0-2.3.1c-.2 0-.4 0-.7.1-.6 0-1.2.1-1.7.2-.2 0-.4 0-.6.1-.7.1-1.4.2-2.1.4-.2.1-.5.1-.7.2l-1.4.3-.9.3c-.4.1-.9.3-1.3.4-.5.2-1 .4-1.5.5-.3.1-.7.3-1 .4-.4.2-.7.3-1.1.5-.2.1-.5.2-.7.4-1.3.7-2.6 1.4-3.9 2.2-.1.1-.3.2-.4.3l-1.2.9h-.1c-.9.7-1.8 1.4-2.6 2.1-.4.4-.8.7-1.2 1.1l-.2.2a54.8 54.8 0 00-3.2 3.6c-.1.1-.2.2-.2.3l-.9 1.2c0 .1-.1.1-.1.2l-1.5 2.4c-.1.2-.2.3-.3.5-2.7 5.1-4.3 10.9-4.3 17s1.6 12 4.3 17c.1.2.2.3.3.5l1.5 2.4c0 .1.1.1.1.2l.9 1.2c.1.1.2.2.2.3 1 1.3 2 2.5 3.2 3.6l.2.2c.4.4.8.8 1.2 1.1.8.8 1.7 1.5 2.6 2.1h.1l1.2.9c.1.1.3.2.4.3 1.2.8 2.5 1.6 3.9 2.2.2.1.5.2.7.4.4.2.7.3 1.1.5.3.1.7.3 1 .4.5.2 1 .4 1.5.5.4.1.9.3 1.3.4l.9.3 1.4.3c.2.1.5.1.7.2.7.1 1.4.3 2.1.4.2 0 .4 0 .6.1.6.1 1.1.1 1.7.2.2 0 .4 0 .7.1.8 0 1.5.1 2.3.1s1.5 0 2.3-.1c.2 0 .4 0 .7-.1.6 0 1.2-.1 1.7-.2.2 0 .4 0 .6-.1.7-.1 1.4-.2 2.1-.4.2-.1.5-.1.7-.2l1.4-.3.9-.3c.4-.1.9-.3 1.3-.4.5-.2 1-.4 1.5-.5.3-.1.7-.3 1-.4.4-.2.7-.3 1.1-.5.2-.1.5-.2.7-.4 1.3-.7 2.6-1.4 3.9-2.2.1-.1.3-.2.4-.3l1.2-.9h.1c.9-.7 1.8-1.4 2.6-2.1.4-.4.8-.7 1.2-1.1l.2-.2c1.1-1.1 2.2-2.4 3.2-3.6.1-.1.2-.2.2-.3l.9-1.2c0-.1.1-.1.1-.2l1.5-2.4c.1-.2.2-.3.3-.5 2.7-5.1 4.3-10.9 4.3-17s-1.6-12-4.3-17c-.1-.2-.2-.4-.3-.5z" } }] }, "name": "control", "theme": "filled" };
var ControlFilledSvg = ControlFilled$2;

var ControlFilled = function ControlFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ControlFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ControlFilled.displayName = 'ControlFilled';
}
var ControlFilled$1 = /*#__PURE__*/React__namespace.forwardRef(ControlFilled);

// This icon file is generated automatically.
var ControlOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM340 683v77c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-77c-10.1 3.3-20.8 5-32 5s-21.9-1.8-32-5zm64-198V264c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v221c10.1-3.3 20.8-5 32-5s21.9 1.8 32 5zm-64 198c10.1 3.3 20.8 5 32 5s21.9-1.8 32-5c41.8-13.5 72-52.7 72-99s-30.2-85.5-72-99c-10.1-3.3-20.8-5-32-5s-21.9 1.8-32 5c-41.8 13.5-72 52.7-72 99s30.2 85.5 72 99zm.1-115.7c.3-.6.7-1.2 1-1.8v-.1l1.2-1.8c.1-.2.2-.3.3-.5.3-.5.7-.9 1-1.4.1-.1.2-.3.3-.4.5-.6.9-1.1 1.4-1.6l.3-.3 1.2-1.2.4-.4c.5-.5 1-.9 1.6-1.4.6-.5 1.1-.9 1.7-1.3.2-.1.3-.2.5-.3.5-.3.9-.7 1.4-1 .1-.1.3-.2.4-.3.6-.4 1.2-.7 1.9-1.1.1-.1.3-.1.4-.2.5-.3 1-.5 1.6-.8l.6-.3c.7-.3 1.3-.6 2-.8.7-.3 1.4-.5 2.1-.7.2-.1.4-.1.6-.2.6-.2 1.1-.3 1.7-.4.2 0 .3-.1.5-.1.7-.2 1.5-.3 2.2-.4.2 0 .3 0 .5-.1.6-.1 1.2-.1 1.8-.2h.6c.8 0 1.5-.1 2.3-.1s1.5 0 2.3.1h.6c.6 0 1.2.1 1.8.2.2 0 .3 0 .5.1.7.1 1.5.2 2.2.4.2 0 .3.1.5.1.6.1 1.2.3 1.7.4.2.1.4.1.6.2.7.2 1.4.4 2.1.7.7.2 1.3.5 2 .8l.6.3c.5.2 1.1.5 1.6.8.1.1.3.1.4.2.6.3 1.3.7 1.9 1.1.1.1.3.2.4.3.5.3 1 .6 1.4 1 .2.1.3.2.5.3.6.4 1.2.9 1.7 1.3s1.1.9 1.6 1.4l.4.4 1.2 1.2.3.3c.5.5 1 1.1 1.4 1.6.1.1.2.3.3.4.4.4.7.9 1 1.4.1.2.2.3.3.5l1.2 1.8s0 .1.1.1a36.18 36.18 0 015.1 18.5c0 6-1.5 11.7-4.1 16.7-.3.6-.7 1.2-1 1.8 0 0 0 .1-.1.1l-1.2 1.8c-.1.2-.2.3-.3.5-.3.5-.7.9-1 1.4-.1.1-.2.3-.3.4-.5.6-.9 1.1-1.4 1.6l-.3.3-1.2 1.2-.4.4c-.5.5-1 .9-1.6 1.4-.6.5-1.1.9-1.7 1.3-.2.1-.3.2-.5.3-.5.3-.9.7-1.4 1-.1.1-.3.2-.4.3-.6.4-1.2.7-1.9 1.1-.1.1-.3.1-.4.2-.5.3-1 .5-1.6.8l-.6.3c-.7.3-1.3.6-2 .8-.7.3-1.4.5-2.1.7-.2.1-.4.1-.6.2-.6.2-1.1.3-1.7.4-.2 0-.3.1-.5.1-.7.2-1.5.3-2.2.4-.2 0-.3 0-.5.1-.6.1-1.2.1-1.8.2h-.6c-.8 0-1.5.1-2.3.1s-1.5 0-2.3-.1h-.6c-.6 0-1.2-.1-1.8-.2-.2 0-.3 0-.5-.1-.7-.1-1.5-.2-2.2-.4-.2 0-.3-.1-.5-.1-.6-.1-1.2-.3-1.7-.4-.2-.1-.4-.1-.6-.2-.7-.2-1.4-.4-2.1-.7-.7-.2-1.3-.5-2-.8l-.6-.3c-.5-.2-1.1-.5-1.6-.8-.1-.1-.3-.1-.4-.2-.6-.3-1.3-.7-1.9-1.1-.1-.1-.3-.2-.4-.3-.5-.3-1-.6-1.4-1-.2-.1-.3-.2-.5-.3-.6-.4-1.2-.9-1.7-1.3s-1.1-.9-1.6-1.4l-.4-.4-1.2-1.2-.3-.3c-.5-.5-1-1.1-1.4-1.6-.1-.1-.2-.3-.3-.4-.4-.4-.7-.9-1-1.4-.1-.2-.2-.3-.3-.5l-1.2-1.8v-.1c-.4-.6-.7-1.2-1-1.8-2.6-5-4.1-10.7-4.1-16.7s1.5-11.7 4.1-16.7zM620 539v221c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V539c-10.1 3.3-20.8 5-32 5s-21.9-1.8-32-5zm64-198v-77c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v77c10.1-3.3 20.8-5 32-5s21.9 1.8 32 5zm-64 198c10.1 3.3 20.8 5 32 5s21.9-1.8 32-5c41.8-13.5 72-52.7 72-99s-30.2-85.5-72-99c-10.1-3.3-20.8-5-32-5s-21.9 1.8-32 5c-41.8 13.5-72 52.7-72 99s30.2 85.5 72 99zm.1-115.7c.3-.6.7-1.2 1-1.8v-.1l1.2-1.8c.1-.2.2-.3.3-.5.3-.5.7-.9 1-1.4.1-.1.2-.3.3-.4.5-.6.9-1.1 1.4-1.6l.3-.3 1.2-1.2.4-.4c.5-.5 1-.9 1.6-1.4.6-.5 1.1-.9 1.7-1.3.2-.1.3-.2.5-.3.5-.3.9-.7 1.4-1 .1-.1.3-.2.4-.3.6-.4 1.2-.7 1.9-1.1.1-.1.3-.1.4-.2.5-.3 1-.5 1.6-.8l.6-.3c.7-.3 1.3-.6 2-.8.7-.3 1.4-.5 2.1-.7.2-.1.4-.1.6-.2.6-.2 1.1-.3 1.7-.4.2 0 .3-.1.5-.1.7-.2 1.5-.3 2.2-.4.2 0 .3 0 .5-.1.6-.1 1.2-.1 1.8-.2h.6c.8 0 1.5-.1 2.3-.1s1.5 0 2.3.1h.6c.6 0 1.2.1 1.8.2.2 0 .3 0 .5.1.7.1 1.5.2 2.2.4.2 0 .3.1.5.1.6.1 1.2.3 1.7.4.2.1.4.1.6.2.7.2 1.4.4 2.1.7.7.2 1.3.5 2 .8l.6.3c.5.2 1.1.5 1.6.8.1.1.3.1.4.2.6.3 1.3.7 1.9 1.1.1.1.3.2.4.3.5.3 1 .6 1.4 1 .2.1.3.2.5.3.6.4 1.2.9 1.7 1.3s1.1.9 1.6 1.4l.4.4 1.2 1.2.3.3c.5.5 1 1.1 1.4 1.6.1.1.2.3.3.4.4.4.7.9 1 1.4.1.2.2.3.3.5l1.2 1.8v.1a36.18 36.18 0 015.1 18.5c0 6-1.5 11.7-4.1 16.7-.3.6-.7 1.2-1 1.8v.1l-1.2 1.8c-.1.2-.2.3-.3.5-.3.5-.7.9-1 1.4-.1.1-.2.3-.3.4-.5.6-.9 1.1-1.4 1.6l-.3.3-1.2 1.2-.4.4c-.5.5-1 .9-1.6 1.4-.6.5-1.1.9-1.7 1.3-.2.1-.3.2-.5.3-.5.3-.9.7-1.4 1-.1.1-.3.2-.4.3-.6.4-1.2.7-1.9 1.1-.1.1-.3.1-.4.2-.5.3-1 .5-1.6.8l-.6.3c-.7.3-1.3.6-2 .8-.7.3-1.4.5-2.1.7-.2.1-.4.1-.6.2-.6.2-1.1.3-1.7.4-.2 0-.3.1-.5.1-.7.2-1.5.3-2.2.4-.2 0-.3 0-.5.1-.6.1-1.2.1-1.8.2h-.6c-.8 0-1.5.1-2.3.1s-1.5 0-2.3-.1h-.6c-.6 0-1.2-.1-1.8-.2-.2 0-.3 0-.5-.1-.7-.1-1.5-.2-2.2-.4-.2 0-.3-.1-.5-.1-.6-.1-1.2-.3-1.7-.4-.2-.1-.4-.1-.6-.2-.7-.2-1.4-.4-2.1-.7-.7-.2-1.3-.5-2-.8l-.6-.3c-.5-.2-1.1-.5-1.6-.8-.1-.1-.3-.1-.4-.2-.6-.3-1.3-.7-1.9-1.1-.1-.1-.3-.2-.4-.3-.5-.3-1-.6-1.4-1-.2-.1-.3-.2-.5-.3-.6-.4-1.2-.9-1.7-1.3s-1.1-.9-1.6-1.4l-.4-.4-1.2-1.2-.3-.3c-.5-.5-1-1.1-1.4-1.6-.1-.1-.2-.3-.3-.4-.4-.4-.7-.9-1-1.4-.1-.2-.2-.3-.3-.5l-1.2-1.8v-.1c-.4-.6-.7-1.2-1-1.8-2.6-5-4.1-10.7-4.1-16.7s1.5-11.7 4.1-16.7z" } }] }, "name": "control", "theme": "outlined" };
var ControlOutlinedSvg = ControlOutlined$2;

var ControlOutlined = function ControlOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ControlOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ControlOutlined.displayName = 'ControlOutlined';
}
var ControlOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ControlOutlined);

// This icon file is generated automatically.
var ControlTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M616 440a36 36 0 1072 0 36 36 0 10-72 0zM340.4 601.5l1.5 2.4c0 .1.1.1.1.2l.9 1.2c.1.1.2.2.2.3 1 1.3 2 2.5 3.2 3.6l.2.2c.4.4.8.8 1.2 1.1.8.8 1.7 1.5 2.6 2.1h.1l1.2.9c.1.1.3.2.4.3 1.2.8 2.5 1.6 3.9 2.2.2.1.5.2.7.4.4.2.7.3 1.1.5.3.1.7.3 1 .4.5.2 1 .4 1.5.5.4.1.9.3 1.3.4l.9.3 1.4.3c.2.1.5.1.7.2.7.1 1.4.3 2.1.4.2 0 .4 0 .6.1.6.1 1.1.1 1.7.2.2 0 .4 0 .7.1.8 0 1.5.1 2.3.1s1.5 0 2.3-.1c.2 0 .4 0 .7-.1.6 0 1.2-.1 1.7-.2.2 0 .4 0 .6-.1.7-.1 1.4-.2 2.1-.4.2-.1.5-.1.7-.2l1.4-.3.9-.3c.4-.1.9-.3 1.3-.4.5-.2 1-.4 1.5-.5.3-.1.7-.3 1-.4.4-.2.7-.3 1.1-.5.2-.1.5-.2.7-.4 1.3-.7 2.6-1.4 3.9-2.2.1-.1.3-.2.4-.3l1.2-.9h.1c.9-.7 1.8-1.4 2.6-2.1.4-.4.8-.7 1.2-1.1l.2-.2c1.1-1.1 2.2-2.4 3.2-3.6.1-.1.2-.2.2-.3l.9-1.2c0-.1.1-.1.1-.2l1.5-2.4c.1-.2.2-.3.3-.5 2.7-5.1 4.3-10.9 4.3-17s-1.6-12-4.3-17c-.1-.2-.2-.4-.3-.5l-1.5-2.4c0-.1-.1-.1-.1-.2l-.9-1.2c-.1-.1-.2-.2-.2-.3-1-1.3-2-2.5-3.2-3.6l-.2-.2c-.4-.4-.8-.8-1.2-1.1-.8-.8-1.7-1.5-2.6-2.1h-.1l-1.2-.9c-.1-.1-.3-.2-.4-.3-1.2-.8-2.5-1.6-3.9-2.2-.2-.1-.5-.2-.7-.4-.4-.2-.7-.3-1.1-.5-.3-.1-.7-.3-1-.4-.5-.2-1-.4-1.5-.5-.4-.1-.9-.3-1.3-.4l-.9-.3-1.4-.3c-.2-.1-.5-.1-.7-.2-.7-.1-1.4-.3-2.1-.4-.2 0-.4 0-.6-.1-.6-.1-1.1-.1-1.7-.2-.2 0-.4 0-.7-.1-.8 0-1.5-.1-2.3-.1s-1.5 0-2.3.1c-.2 0-.4 0-.7.1-.6 0-1.2.1-1.7.2-.2 0-.4 0-.6.1-.7.1-1.4.2-2.1.4-.2.1-.5.1-.7.2l-1.4.3-.9.3c-.4.1-.9.3-1.3.4-.5.2-1 .4-1.5.5-.3.1-.7.3-1 .4-.4.2-.7.3-1.1.5-.2.1-.5.2-.7.4-1.3.7-2.6 1.4-3.9 2.2-.1.1-.3.2-.4.3l-1.2.9h-.1c-.9.7-1.8 1.4-2.6 2.1-.4.4-.8.7-1.2 1.1l-.2.2a54.8 54.8 0 00-3.2 3.6c-.1.1-.2.2-.2.3l-.9 1.2c0 .1-.1.1-.1.2l-1.5 2.4c-.1.2-.2.3-.3.5-2.7 5.1-4.3 10.9-4.3 17s1.6 12 4.3 17c.1.2.2.3.3.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm436.4-499.1c-.2 0-.3.1-.4.1v-77c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v77c-.2 0-.3-.1-.4-.1 42 13.4 72.4 52.7 72.4 99.1 0 46.4-30.4 85.7-72.4 99.1.2 0 .3-.1.4-.1v221c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V539c.2 0 .3.1.4.1-42-13.4-72.4-52.7-72.4-99.1 0-46.4 30.4-85.7 72.4-99.1zM340 485V264c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v221c41.7 13.6 72 52.8 72 99s-30.3 85.5-72 99v77c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-77c-41.7-13.6-72-52.8-72-99s30.3-85.5 72-99z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M340 683v77c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-77c41.7-13.5 72-52.8 72-99s-30.3-85.4-72-99V264c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v221c-41.7 13.5-72 52.8-72 99s30.3 85.4 72 99zm.1-116c.1-.2.2-.3.3-.5l1.5-2.4c0-.1.1-.1.1-.2l.9-1.2c0-.1.1-.2.2-.3 1-1.2 2.1-2.5 3.2-3.6l.2-.2c.4-.4.8-.7 1.2-1.1.8-.7 1.7-1.4 2.6-2.1h.1l1.2-.9c.1-.1.3-.2.4-.3 1.3-.8 2.6-1.5 3.9-2.2.2-.2.5-.3.7-.4.4-.2.7-.3 1.1-.5.3-.1.7-.3 1-.4.5-.1 1-.3 1.5-.5.4-.1.9-.3 1.3-.4l.9-.3 1.4-.3c.2-.1.5-.1.7-.2.7-.2 1.4-.3 2.1-.4.2-.1.4-.1.6-.1.5-.1 1.1-.2 1.7-.2.3-.1.5-.1.7-.1.8-.1 1.5-.1 2.3-.1s1.5.1 2.3.1c.3.1.5.1.7.1.6.1 1.1.1 1.7.2.2.1.4.1.6.1.7.1 1.4.3 2.1.4.2.1.5.1.7.2l1.4.3.9.3c.4.1.9.3 1.3.4.5.1 1 .3 1.5.5.3.1.7.3 1 .4.4.2.7.3 1.1.5.2.2.5.3.7.4 1.4.6 2.7 1.4 3.9 2.2.1.1.3.2.4.3l1.2.9h.1c.9.6 1.8 1.3 2.6 2.1.4.3.8.7 1.2 1.1l.2.2c1.2 1.1 2.2 2.3 3.2 3.6 0 .1.1.2.2.3l.9 1.2c0 .1.1.1.1.2l1.5 2.4A36.03 36.03 0 01408 584c0 6.1-1.6 11.9-4.3 17-.1.2-.2.3-.3.5l-1.5 2.4c0 .1-.1.1-.1.2l-.9 1.2c0 .1-.1.2-.2.3-1 1.2-2.1 2.5-3.2 3.6l-.2.2c-.4.4-.8.7-1.2 1.1-.8.7-1.7 1.4-2.6 2.1h-.1l-1.2.9c-.1.1-.3.2-.4.3-1.3.8-2.6 1.5-3.9 2.2-.2.2-.5.3-.7.4-.4.2-.7.3-1.1.5-.3.1-.7.3-1 .4-.5.1-1 .3-1.5.5-.4.1-.9.3-1.3.4l-.9.3-1.4.3c-.2.1-.5.1-.7.2-.7.2-1.4.3-2.1.4-.2.1-.4.1-.6.1-.5.1-1.1.2-1.7.2-.3.1-.5.1-.7.1-.8.1-1.5.1-2.3.1s-1.5-.1-2.3-.1c-.3-.1-.5-.1-.7-.1-.6-.1-1.1-.1-1.7-.2-.2-.1-.4-.1-.6-.1-.7-.1-1.4-.3-2.1-.4-.2-.1-.5-.1-.7-.2l-1.4-.3-.9-.3c-.4-.1-.9-.3-1.3-.4-.5-.1-1-.3-1.5-.5-.3-.1-.7-.3-1-.4-.4-.2-.7-.3-1.1-.5-.2-.2-.5-.3-.7-.4-1.4-.6-2.7-1.4-3.9-2.2-.1-.1-.3-.2-.4-.3l-1.2-.9h-.1c-.9-.6-1.8-1.3-2.6-2.1-.4-.3-.8-.7-1.2-1.1l-.2-.2c-1.2-1.1-2.2-2.3-3.2-3.6 0-.1-.1-.2-.2-.3l-.9-1.2c0-.1-.1-.1-.1-.2l-1.5-2.4c-.1-.2-.2-.3-.3-.5-2.7-5-4.3-10.9-4.3-17s1.6-11.9 4.3-17zm280.3-27.9c-.1 0-.2-.1-.4-.1v221c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V539c-.1 0-.2.1-.4.1 42-13.4 72.4-52.7 72.4-99.1 0-46.4-30.4-85.7-72.4-99.1.1 0 .2.1.4.1v-77c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v77c.1 0 .2-.1.4-.1-42 13.4-72.4 52.7-72.4 99.1 0 46.4 30.4 85.7 72.4 99.1zM652 404c19.9 0 36 16.1 36 36s-16.1 36-36 36-36-16.1-36-36 16.1-36 36-36z", "fill": primaryColor } }] }; }, "name": "control", "theme": "twotone" };
var ControlTwoToneSvg = ControlTwoTone$2;

var ControlTwoTone = function ControlTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ControlTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ControlTwoTone.displayName = 'ControlTwoTone';
}
var ControlTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(ControlTwoTone);

// This icon file is generated automatically.
var CopyFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM382 896h-.2L232 746.2v-.2h150v150z" } }] }, "name": "copy", "theme": "filled" };
var CopyFilledSvg = CopyFilled$2;

var CopyFilled = function CopyFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CopyFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CopyFilled.displayName = 'CopyFilled';
}
var CopyFilled$1 = /*#__PURE__*/React__namespace.forwardRef(CopyFilled);

// This icon file is generated automatically.
var CopyOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z" } }] }, "name": "copy", "theme": "outlined" };
var CopyOutlinedSvg = CopyOutlined$2;

var CopyOutlined = function CopyOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CopyOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CopyOutlined.displayName = 'CopyOutlined';
}
var CopyOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CopyOutlined);

// This icon file is generated automatically.
var CopyTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M232 706h142c22.1 0 40 17.9 40 40v142h250V264H232v442z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z", "fill": primaryColor } }] }; }, "name": "copy", "theme": "twotone" };
var CopyTwoToneSvg = CopyTwoTone$2;

var CopyTwoTone = function CopyTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CopyTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CopyTwoTone.displayName = 'CopyTwoTone';
}
var CopyTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(CopyTwoTone);

// This icon file is generated automatically.
var CopyrightCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm5.4 670c-110 0-173.4-73.2-173.4-194.9v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.6-3.2-8-7.4-4-49.5-40-83.4-93-83.4-65.3 0-102.1 48.5-102.1 135.5v52.6c0 85.7 36.9 133.6 102.1 133.6 52.8 0 88.7-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4z" } }] }, "name": "copyright-circle", "theme": "filled" };
var CopyrightCircleFilledSvg = CopyrightCircleFilled$2;

var CopyrightCircleFilled = function CopyrightCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CopyrightCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CopyrightCircleFilled.displayName = 'CopyrightCircleFilled';
}
var CopyrightCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(CopyrightCircleFilled);

// This icon file is generated automatically.
var CopyrightCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm5.6-532.7c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z" } }] }, "name": "copyright-circle", "theme": "outlined" };
var CopyrightCircleOutlinedSvg = CopyrightCircleOutlined$2;

var CopyrightCircleOutlined = function CopyrightCircleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CopyrightCircleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CopyrightCircleOutlined.displayName = 'CopyrightCircleOutlined';
}
var CopyrightCircleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CopyrightCircleOutlined);

// This icon file is generated automatically.
var CopyrightCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm5.5 533c52.9 0 88.8-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4C407.4 734 344 660.8 344 539.1v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.7-3.2-8-7.4-4-49.6-40-83.4-93-83.4-65.2 0-102.1 48.5-102.2 135.5v52.6c0 85.7 36.8 133.6 102.1 133.6z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M517.6 351.3c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z", "fill": primaryColor } }] }; }, "name": "copyright-circle", "theme": "twotone" };
var CopyrightCircleTwoToneSvg = CopyrightCircleTwoTone$2;

var CopyrightCircleTwoTone = function CopyrightCircleTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CopyrightCircleTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CopyrightCircleTwoTone.displayName = 'CopyrightCircleTwoTone';
}
var CopyrightCircleTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(CopyrightCircleTwoTone);

// This icon file is generated automatically.
var CopyrightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm5.6-532.7c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z" } }] }, "name": "copyright", "theme": "outlined" };
var CopyrightOutlinedSvg = CopyrightOutlined$2;

var CopyrightOutlined = function CopyrightOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CopyrightOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CopyrightOutlined.displayName = 'CopyrightOutlined';
}
var CopyrightOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CopyrightOutlined);

// This icon file is generated automatically.
var CopyrightTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm5.5 533c52.9 0 88.8-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4C407.4 734 344 660.8 344 539.1v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.7-3.2-8-7.4-4-49.6-40-83.4-93-83.4-65.2 0-102.1 48.5-102.2 135.5v52.6c0 85.7 36.8 133.6 102.1 133.6z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M517.6 351.3c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z", "fill": primaryColor } }] }; }, "name": "copyright", "theme": "twotone" };
var CopyrightTwoToneSvg = CopyrightTwoTone$2;

var CopyrightTwoTone = function CopyrightTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CopyrightTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CopyrightTwoTone.displayName = 'CopyrightTwoTone';
}
var CopyrightTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(CopyrightTwoTone);

// This icon file is generated automatically.
var CreditCardFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v160h896V192c0-17.7-14.3-32-32-32zM64 832c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V440H64v392zm579-184c0-4.4 3.6-8 8-8h165c4.4 0 8 3.6 8 8v72c0 4.4-3.6 8-8 8H651c-4.4 0-8-3.6-8-8v-72z" } }] }, "name": "credit-card", "theme": "filled" };
var CreditCardFilledSvg = CreditCardFilled$2;

var CreditCardFilled = function CreditCardFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CreditCardFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CreditCardFilled.displayName = 'CreditCardFilled';
}
var CreditCardFilled$1 = /*#__PURE__*/React__namespace.forwardRef(CreditCardFilled);

// This icon file is generated automatically.
var CreditCardOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-792 72h752v120H136V232zm752 560H136V440h752v352zm-237-64h165c4.4 0 8-3.6 8-8v-72c0-4.4-3.6-8-8-8H651c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8z" } }] }, "name": "credit-card", "theme": "outlined" };
var CreditCardOutlinedSvg = CreditCardOutlined$2;

var CreditCardOutlined = function CreditCardOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CreditCardOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CreditCardOutlined.displayName = 'CreditCardOutlined';
}
var CreditCardOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CreditCardOutlined);

// This icon file is generated automatically.
var CreditCardTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M136 792h752V440H136v352zm507-144c0-4.4 3.6-8 8-8h165c4.4 0 8 3.6 8 8v72c0 4.4-3.6 8-8 8H651c-4.4 0-8-3.6-8-8v-72zM136 232h752v120H136z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M651 728h165c4.4 0 8-3.6 8-8v-72c0-4.4-3.6-8-8-8H651c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V440h752v352zm0-440H136V232h752v120z", "fill": primaryColor } }] }; }, "name": "credit-card", "theme": "twotone" };
var CreditCardTwoToneSvg = CreditCardTwoTone$2;

var CreditCardTwoTone = function CreditCardTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CreditCardTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CreditCardTwoTone.displayName = 'CreditCardTwoTone';
}
var CreditCardTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(CreditCardTwoTone);

// This icon file is generated automatically.
var CrownFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M899.6 276.5L705 396.4 518.4 147.5a8.06 8.06 0 00-12.9 0L319 396.4 124.3 276.5c-5.7-3.5-13.1 1.2-12.2 7.9L188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.8-6.7-6.5-11.4-12.3-7.9zM512 734.2c-62.1 0-112.6-50.5-112.6-112.6S449.9 509 512 509s112.6 50.5 112.6 112.6S574.1 734.2 512 734.2zm0-160.9c-26.6 0-48.2 21.6-48.2 48.3 0 26.6 21.6 48.3 48.2 48.3s48.2-21.6 48.2-48.3c0-26.6-21.6-48.3-48.2-48.3z" } }] }, "name": "crown", "theme": "filled" };
var CrownFilledSvg = CrownFilled$2;

var CrownFilled = function CrownFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CrownFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CrownFilled.displayName = 'CrownFilled';
}
var CrownFilled$1 = /*#__PURE__*/React__namespace.forwardRef(CrownFilled);

// This icon file is generated automatically.
var CrownOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M899.6 276.5L705 396.4 518.4 147.5a8.06 8.06 0 00-12.9 0L319 396.4 124.3 276.5c-5.7-3.5-13.1 1.2-12.2 7.9L188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.8-6.7-6.5-11.4-12.3-7.9zm-126 534.1H250.3l-53.8-409.4 139.8 86.1L512 252.9l175.7 234.4 139.8-86.1-53.9 409.4zM512 509c-62.1 0-112.6 50.5-112.6 112.6S449.9 734.2 512 734.2s112.6-50.5 112.6-112.6S574.1 509 512 509zm0 160.9c-26.6 0-48.2-21.6-48.2-48.3 0-26.6 21.6-48.3 48.2-48.3s48.2 21.6 48.2 48.3c0 26.6-21.6 48.3-48.2 48.3z" } }] }, "name": "crown", "theme": "outlined" };
var CrownOutlinedSvg = CrownOutlined$2;

var CrownOutlined = function CrownOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CrownOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CrownOutlined.displayName = 'CrownOutlined';
}
var CrownOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CrownOutlined);

// This icon file is generated automatically.
var CrownTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M911.9 283.9v.5L835.5 865c-1 8-7.9 14-15.9 14H204.5c-8.1 0-14.9-6.1-16-14l-76.4-580.6v-.6 1.6L188.5 866c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.1-.5.1-1 0-1.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M773.6 810.6l53.9-409.4-139.8 86.1L512 252.9 336.3 487.3l-139.8-86.1 53.8 409.4h523.3zm-374.2-189c0-62.1 50.5-112.6 112.6-112.6s112.6 50.5 112.6 112.6v1c0 62.1-50.5 112.6-112.6 112.6s-112.6-50.5-112.6-112.6v-1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 734.2c61.9 0 112.3-50.2 112.6-112.1v-.5c0-62.1-50.5-112.6-112.6-112.6s-112.6 50.5-112.6 112.6v.5c.3 61.9 50.7 112.1 112.6 112.1zm0-160.9c26.6 0 48.2 21.6 48.2 48.3 0 26.6-21.6 48.3-48.2 48.3s-48.2-21.6-48.2-48.3c0-26.6 21.6-48.3 48.2-48.3z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6v-.5c.3-6.4-6.7-10.8-12.3-7.4L705 396.4 518.4 147.5a8.06 8.06 0 00-12.9 0L319 396.4 124.3 276.5c-5.5-3.4-12.6.9-12.2 7.3v.6L188.5 865zm147.8-377.7L512 252.9l175.7 234.4 139.8-86.1-53.9 409.4H250.3l-53.8-409.4 139.8 86.1z", "fill": primaryColor } }] }; }, "name": "crown", "theme": "twotone" };
var CrownTwoToneSvg = CrownTwoTone$2;

var CrownTwoTone = function CrownTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CrownTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CrownTwoTone.displayName = 'CrownTwoTone';
}
var CrownTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(CrownTwoTone);

// This icon file is generated automatically.
var CustomerServiceFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384z" } }] }, "name": "customer-service", "theme": "filled" };
var CustomerServiceFilledSvg = CustomerServiceFilled$2;

var CustomerServiceFilled = function CustomerServiceFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CustomerServiceFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CustomerServiceFilled.displayName = 'CustomerServiceFilled';
}
var CustomerServiceFilled$1 = /*#__PURE__*/React__namespace.forwardRef(CustomerServiceFilled);

// This icon file is generated automatically.
var CustomerServiceOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384zM328 632v192H200V632h128zm496 192H696V632h128v192z" } }] }, "name": "customer-service", "theme": "outlined" };
var CustomerServiceOutlinedSvg = CustomerServiceOutlined$2;

var CustomerServiceOutlined = function CustomerServiceOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CustomerServiceOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CustomerServiceOutlined.displayName = 'CustomerServiceOutlined';
}
var CustomerServiceOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(CustomerServiceOutlined);

// This icon file is generated automatically.
var CustomerServiceTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M696 632h128v192H696zm-496 0h128v192H200z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384zM328 632v192H200V632h128zm496 192H696V632h128v192z", "fill": primaryColor } }] }; }, "name": "customer-service", "theme": "twotone" };
var CustomerServiceTwoToneSvg = CustomerServiceTwoTone$2;

var CustomerServiceTwoTone = function CustomerServiceTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CustomerServiceTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  CustomerServiceTwoTone.displayName = 'CustomerServiceTwoTone';
}
var CustomerServiceTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(CustomerServiceTwoTone);

// This icon file is generated automatically.
var DashOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M112 476h160v72H112zm320 0h160v72H432zm320 0h160v72H752z" } }] }, "name": "dash", "theme": "outlined" };
var DashOutlinedSvg = DashOutlined$2;

var DashOutlined = function DashOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DashOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DashOutlined.displayName = 'DashOutlined';
}
var DashOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(DashOutlined);

// This icon file is generated automatically.
var DashboardFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M924.8 385.6a446.7 446.7 0 00-96-142.4 446.7 446.7 0 00-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 00-142.4 96 446.7 446.7 0 00-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM482 232c0-4.4 3.6-8 8-8h44c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-44c-4.4 0-8-3.6-8-8v-80zM270 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44zm90.7-204.5l-31.1 31.1a8.03 8.03 0 01-11.3 0L261.7 352a8.03 8.03 0 010-11.3l31.1-31.1c3.1-3.1 8.2-3.1 11.3 0l56.6 56.6c3.1 3.1 3.1 8.2 0 11.3zm291.1 83.6l-84.5 84.5c5 18.7.2 39.4-14.5 54.1a55.95 55.95 0 01-79.2 0 55.95 55.95 0 010-79.2 55.87 55.87 0 0154.1-14.5l84.5-84.5c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3c3.1 3.1 3.1 8.1 0 11.3zm43-52.4l-31.1-31.1a8.03 8.03 0 010-11.3l56.6-56.6c3.1-3.1 8.2-3.1 11.3 0l31.1 31.1c3.1 3.1 3.1 8.2 0 11.3l-56.6 56.6a8.03 8.03 0 01-11.3 0zM846 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44z" } }] }, "name": "dashboard", "theme": "filled" };
var DashboardFilledSvg = DashboardFilled$2;

var DashboardFilled = function DashboardFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DashboardFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DashboardFilled.displayName = 'DashboardFilled';
}
var DashboardFilled$1 = /*#__PURE__*/React__namespace.forwardRef(DashboardFilled);

// This icon file is generated automatically.
var DashboardOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M924.8 385.6a446.7 446.7 0 00-96-142.4 446.7 446.7 0 00-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 00-142.4 96 446.7 446.7 0 00-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM761.4 836H262.6A371.12 371.12 0 01140 560c0-99.4 38.7-192.8 109-263 70.3-70.3 163.7-109 263-109 99.4 0 192.8 38.7 263 109 70.3 70.3 109 163.7 109 263 0 105.6-44.5 205.5-122.6 276zM623.5 421.5a8.03 8.03 0 00-11.3 0L527.7 506c-18.7-5-39.4-.2-54.1 14.5a55.95 55.95 0 000 79.2 55.95 55.95 0 0079.2 0 55.87 55.87 0 0014.5-54.1l84.5-84.5c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3zM490 320h44c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-44c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8zm260 218v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zm12.7-197.2l-31.1-31.1a8.03 8.03 0 00-11.3 0l-56.6 56.6a8.03 8.03 0 000 11.3l31.1 31.1c3.1 3.1 8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3zm-458.6-31.1a8.03 8.03 0 00-11.3 0l-31.1 31.1a8.03 8.03 0 000 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0l31.1-31.1c3.1-3.1 3.1-8.2 0-11.3l-56.6-56.6zM262 530h-80c-4.4 0-8 3.6-8 8v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8z" } }] }, "name": "dashboard", "theme": "outlined" };
var DashboardOutlinedSvg = DashboardOutlined$2;

var DashboardOutlined = function DashboardOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DashboardOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DashboardOutlined.displayName = 'DashboardOutlined';
}
var DashboardOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(DashboardOutlined);

// This icon file is generated automatically.
var DashboardTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 188c-99.3 0-192.7 38.7-263 109-70.3 70.2-109 163.6-109 263 0 105.6 44.5 205.5 122.6 276h498.8A371.12 371.12 0 00884 560c0-99.3-38.7-192.7-109-263-70.2-70.3-163.6-109-263-109zm-30 44c0-4.4 3.6-8 8-8h44c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-44c-4.4 0-8-3.6-8-8v-80zM270 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44zm90.7-204.4l-31.1 31.1a8.03 8.03 0 01-11.3 0l-56.6-56.6a8.03 8.03 0 010-11.3l31.1-31.1c3.1-3.1 8.2-3.1 11.3 0l56.6 56.6c3.1 3.1 3.1 8.2 0 11.3zm291.1 83.5l-84.5 84.5c5 18.7.2 39.4-14.5 54.1a55.95 55.95 0 01-79.2 0 55.95 55.95 0 010-79.2 55.87 55.87 0 0154.1-14.5l84.5-84.5c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3c3.1 3.1 3.1 8.2 0 11.3zm43-52.4l-31.1-31.1a8.03 8.03 0 010-11.3l56.6-56.6c3.1-3.1 8.2-3.1 11.3 0l31.1 31.1c3.1 3.1 3.1 8.2 0 11.3l-56.6 56.6a8.03 8.03 0 01-11.3 0zM846 538v44c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M623.5 421.5a8.03 8.03 0 00-11.3 0L527.7 506c-18.7-5-39.4-.2-54.1 14.5a55.95 55.95 0 000 79.2 55.95 55.95 0 0079.2 0 55.87 55.87 0 0014.5-54.1l84.5-84.5c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3zM490 320h44c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-44c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M924.8 385.6a446.7 446.7 0 00-96-142.4 446.7 446.7 0 00-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 00-142.4 96 446.7 446.7 0 00-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM761.4 836H262.6A371.12 371.12 0 01140 560c0-99.4 38.7-192.8 109-263 70.3-70.3 163.7-109 263-109 99.4 0 192.8 38.7 263 109 70.3 70.3 109 163.7 109 263 0 105.6-44.5 205.5-122.6 276z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M762.7 340.8l-31.1-31.1a8.03 8.03 0 00-11.3 0l-56.6 56.6a8.03 8.03 0 000 11.3l31.1 31.1c3.1 3.1 8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3zM750 538v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zM304.1 309.7a8.03 8.03 0 00-11.3 0l-31.1 31.1a8.03 8.03 0 000 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0l31.1-31.1c3.1-3.1 3.1-8.2 0-11.3l-56.6-56.6zM262 530h-80c-4.4 0-8 3.6-8 8v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "dashboard", "theme": "twotone" };
var DashboardTwoToneSvg = DashboardTwoTone$2;

var DashboardTwoTone = function DashboardTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DashboardTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DashboardTwoTone.displayName = 'DashboardTwoTone';
}
var DashboardTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(DashboardTwoTone);

// This icon file is generated automatically.
var DatabaseFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v224h704V96c0-17.7-14.3-32-32-32zM288 232c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM160 928c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V704H160v224zm128-136c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM160 640h704V384H160v256zm128-168c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z" } }] }, "name": "database", "theme": "filled" };
var DatabaseFilledSvg = DatabaseFilled$2;

var DatabaseFilled = function DatabaseFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DatabaseFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DatabaseFilled.displayName = 'DatabaseFilled';
}
var DatabaseFilled$1 = /*#__PURE__*/React__namespace.forwardRef(DatabaseFilled);

// This icon file is generated automatically.
var DatabaseOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-600 72h560v208H232V136zm560 480H232V408h560v208zm0 272H232V680h560v208zM304 240a40 40 0 1080 0 40 40 0 10-80 0zm0 272a40 40 0 1080 0 40 40 0 10-80 0zm0 272a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "database", "theme": "outlined" };
var DatabaseOutlinedSvg = DatabaseOutlined$2;

var DatabaseOutlined = function DatabaseOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DatabaseOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DatabaseOutlined.displayName = 'DatabaseOutlined';
}
var DatabaseOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(DatabaseOutlined);

// This icon file is generated automatically.
var DatabaseTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M232 616h560V408H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 888h560V680H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 344h560V136H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M304 512a40 40 0 1080 0 40 40 0 10-80 0zm0 272a40 40 0 1080 0 40 40 0 10-80 0zm0-544a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V680h560v208zm0-272H232V408h560v208zm0-272H232V136h560v208z", "fill": primaryColor } }] }; }, "name": "database", "theme": "twotone" };
var DatabaseTwoToneSvg = DatabaseTwoTone$2;

var DatabaseTwoTone = function DatabaseTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DatabaseTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DatabaseTwoTone.displayName = 'DatabaseTwoTone';
}
var DatabaseTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(DatabaseTwoTone);

// This icon file is generated automatically.
var DeleteColumnOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M651.1 641.9a7.84 7.84 0 00-5.1-1.9h-54.7c-2.4 0-4.6 1.1-6.1 2.9L512 730.7l-73.1-87.8a8.1 8.1 0 00-6.1-2.9H378c-1.9 0-3.7.7-5.1 1.9a7.97 7.97 0 00-1 11.3L474.2 776 371.8 898.9a8.06 8.06 0 006.1 13.2h54.7c2.4 0 4.6-1.1 6.1-2.9l73.1-87.8 73.1 87.8a8.1 8.1 0 006.1 2.9h55c1.9 0 3.7-.7 5.1-1.9 3.4-2.8 3.9-7.9 1-11.3L549.8 776l102.4-122.9c2.8-3.4 2.3-8.4-1.1-11.2zM472 544h80c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8zM350 386H184V136c0-3.3-2.7-6-6-6h-60c-3.3 0-6 2.7-6 6v292c0 16.6 13.4 30 30 30h208c3.3 0 6-2.7 6-6v-60c0-3.3-2.7-6-6-6zm556-256h-60c-3.3 0-6 2.7-6 6v250H674c-3.3 0-6 2.7-6 6v60c0 3.3 2.7 6 6 6h208c16.6 0 30-13.4 30-30V136c0-3.3-2.7-6-6-6z" } }] }, "name": "delete-column", "theme": "outlined" };
var DeleteColumnOutlinedSvg = DeleteColumnOutlined$2;

var DeleteColumnOutlined = function DeleteColumnOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DeleteColumnOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DeleteColumnOutlined.displayName = 'DeleteColumnOutlined';
}
var DeleteColumnOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(DeleteColumnOutlined);

// This icon file is generated automatically.
var DeleteFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 256H736v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zm-200 0H360v-72h304v72z" } }] }, "name": "delete", "theme": "filled" };
var DeleteFilledSvg = DeleteFilled$2;

var DeleteFilled = function DeleteFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DeleteFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DeleteFilled.displayName = 'DeleteFilled';
}
var DeleteFilled$1 = /*#__PURE__*/React__namespace.forwardRef(DeleteFilled);

// This icon file is generated automatically.
var DeleteOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z" } }] }, "name": "delete", "theme": "outlined" };
var DeleteOutlinedSvg = DeleteOutlined$2;

var DeleteOutlined = function DeleteOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DeleteOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DeleteOutlined.displayName = 'DeleteOutlined';
}
var DeleteOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(DeleteOutlined);

// This icon file is generated automatically.
var DeleteRowOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M819.8 512l102.4-122.9a8.06 8.06 0 00-6.1-13.2h-54.7c-2.4 0-4.6 1.1-6.1 2.9L782 466.7l-73.1-87.8a8.1 8.1 0 00-6.1-2.9H648c-1.9 0-3.7.7-5.1 1.9a7.97 7.97 0 00-1 11.3L744.2 512 641.8 634.9a8.06 8.06 0 006.1 13.2h54.7c2.4 0 4.6-1.1 6.1-2.9l73.1-87.8 73.1 87.8a8.1 8.1 0 006.1 2.9h55c1.9 0 3.7-.7 5.1-1.9 3.4-2.8 3.9-7.9 1-11.3L819.8 512zM536 464H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h416c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8zm-84 204h-60c-3.3 0-6 2.7-6 6v166H136c-3.3 0-6 2.7-6 6v60c0 3.3 2.7 6 6 6h292c16.6 0 30-13.4 30-30V674c0-3.3-2.7-6-6-6zM136 184h250v166c0 3.3 2.7 6 6 6h60c3.3 0 6-2.7 6-6V142c0-16.6-13.4-30-30-30H136c-3.3 0-6 2.7-6 6v60c0 3.3 2.7 6 6 6z" } }] }, "name": "delete-row", "theme": "outlined" };
var DeleteRowOutlinedSvg = DeleteRowOutlined$2;

var DeleteRowOutlined = function DeleteRowOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DeleteRowOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DeleteRowOutlined.displayName = 'DeleteRowOutlined';
}
var DeleteRowOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(DeleteRowOutlined);

// This icon file is generated automatically.
var DeleteTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M292.7 840h438.6l24.2-512h-487z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M864 256H736v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zm-504-72h304v72H360v-72zm371.3 656H292.7l-24.2-512h487l-24.2 512z", "fill": primaryColor } }] }; }, "name": "delete", "theme": "twotone" };
var DeleteTwoToneSvg = DeleteTwoTone$2;

var DeleteTwoTone = function DeleteTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DeleteTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DeleteTwoTone.displayName = 'DeleteTwoTone';
}
var DeleteTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(DeleteTwoTone);

// This icon file is generated automatically.
var DeliveredProcedureOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M632 698.3l141.9-112a8 8 0 000-12.6L632 461.7c-5.3-4.2-13-.4-13 6.3v76H295c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h324v76c0 6.7 7.8 10.4 13 6.3zm261.3-405L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v278c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V422c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-83.5c0-17-6.7-33.2-18.7-45.2zM640 288H384V184h256v104zm264 436h-56c-4.4 0-8 3.6-8 8v108H184V732c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v148c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V732c0-4.4-3.6-8-8-8z" } }] }, "name": "delivered-procedure", "theme": "outlined" };
var DeliveredProcedureOutlinedSvg = DeliveredProcedureOutlined$2;

var DeliveredProcedureOutlined = function DeliveredProcedureOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DeliveredProcedureOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DeliveredProcedureOutlined.displayName = 'DeliveredProcedureOutlined';
}
var DeliveredProcedureOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(DeliveredProcedureOutlined);

// This icon file is generated automatically.
var DeploymentUnitOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888.3 693.2c-42.5-24.6-94.3-18-129.2 12.8l-53-30.7V523.6c0-15.7-8.4-30.3-22-38.1l-136-78.3v-67.1c44.2-15 76-56.8 76-106.1 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 49.3 31.8 91.1 76 106.1v67.1l-136 78.3c-13.6 7.8-22 22.4-22 38.1v151.6l-53 30.7c-34.9-30.8-86.8-37.4-129.2-12.8-53.5 31-71.7 99.4-41 152.9 30.8 53.5 98.9 71.9 152.2 41 42.5-24.6 62.7-73 53.6-118.8l48.7-28.3 140.6 81c6.8 3.9 14.4 5.9 22 5.9s15.2-2 22-5.9L674.5 740l48.7 28.3c-9.1 45.7 11.2 94.2 53.6 118.8 53.3 30.9 121.5 12.6 152.2-41 30.8-53.6 12.6-122-40.7-152.9zm-673 138.4a47.6 47.6 0 01-65.2-17.6c-13.2-22.9-5.4-52.3 17.5-65.5a47.6 47.6 0 0165.2 17.6c13.2 22.9 5.4 52.3-17.5 65.5zM522 463.8zM464 234a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm170 446.2l-122 70.3-122-70.3V539.8l122-70.3 122 70.3v140.4zm239.9 133.9c-13.2 22.9-42.4 30.8-65.2 17.6-22.8-13.2-30.7-42.6-17.5-65.5s42.4-30.8 65.2-17.6c22.9 13.2 30.7 42.5 17.5 65.5z" } }] }, "name": "deployment-unit", "theme": "outlined" };
var DeploymentUnitOutlinedSvg = DeploymentUnitOutlined$2;

var DeploymentUnitOutlined = function DeploymentUnitOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DeploymentUnitOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DeploymentUnitOutlined.displayName = 'DeploymentUnitOutlined';
}
var DeploymentUnitOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(DeploymentUnitOutlined);

// This icon file is generated automatically.
var DesktopOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 140H96c-17.7 0-32 14.3-32 32v496c0 17.7 14.3 32 32 32h380v112H304c-8.8 0-16 7.2-16 16v48c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-48c0-8.8-7.2-16-16-16H548V700h380c17.7 0 32-14.3 32-32V172c0-17.7-14.3-32-32-32zm-40 488H136V212h752v416z" } }] }, "name": "desktop", "theme": "outlined" };
var DesktopOutlinedSvg = DesktopOutlined$2;

var DesktopOutlined = function DesktopOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DesktopOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DesktopOutlined.displayName = 'DesktopOutlined';
}
var DesktopOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(DesktopOutlined);

// This icon file is generated automatically.
var DiffFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.2 306.6L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23zM553.4 201.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM568 753c0 3.8-3.4 7-7.5 7h-225c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7h225c4.1 0 7.5 3.2 7.5 7v42zm0-220c0 3.8-3.4 7-7.5 7H476v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V540h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H420v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1V484h84.5c4.1 0 7.5 3.1 7.5 7v42z" } }] }, "name": "diff", "theme": "filled" };
var DiffFilledSvg = DiffFilled$2;

var DiffFilled = function DiffFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DiffFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DiffFilled.displayName = 'DiffFilled';
}
var DiffFilled$1 = /*#__PURE__*/React__namespace.forwardRef(DiffFilled);

// This icon file is generated automatically.
var DiffOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M476 399.1c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1V484h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H420v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V540h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H476v-84.9zM560.5 704h-225c-4.1 0-7.5 3.2-7.5 7v42c0 3.8 3.4 7 7.5 7h225c4.1 0 7.5-3.2 7.5-7v-42c0-3.8-3.4-7-7.5-7zm-7.1-502.6c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM664 888H232V264h282.2L664 413.8V888zm190.2-581.4L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23z" } }] }, "name": "diff", "theme": "outlined" };
var DiffOutlinedSvg = DiffOutlined$2;

var DiffOutlined = function DiffOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DiffOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DiffOutlined.displayName = 'DiffOutlined';
}
var DiffOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(DiffOutlined);

// This icon file is generated automatically.
var DiffTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M232 264v624h432V413.8L514.2 264H232zm336 489c0 3.8-3.4 7-7.5 7h-225c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7h225c4.1 0 7.5 3.2 7.5 7v42zm0-262v42c0 3.8-3.4 7-7.5 7H476v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V540h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H420v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1V484h84.5c4.1 0 7.5 3.1 7.5 7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.2 306.6L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M553.4 201.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM664 888H232V264h282.2L664 413.8V888z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M476 399.1c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1V484h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H420v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V540h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H476v-84.9zM560.5 704h-225c-4.1 0-7.5 3.2-7.5 7v42c0 3.8 3.4 7 7.5 7h225c4.1 0 7.5-3.2 7.5-7v-42c0-3.8-3.4-7-7.5-7z", "fill": primaryColor } }] }; }, "name": "diff", "theme": "twotone" };
var DiffTwoToneSvg = DiffTwoTone$2;

var DiffTwoTone = function DiffTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DiffTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DiffTwoTone.displayName = 'DiffTwoTone';
}
var DiffTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(DiffTwoTone);

// This icon file is generated automatically.
var DingdingOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M573.7 252.5C422.5 197.4 201.3 96.7 201.3 96.7c-15.7-4.1-17.9 11.1-17.9 11.1-5 61.1 33.6 160.5 53.6 182.8 19.9 22.3 319.1 113.7 319.1 113.7S326 357.9 270.5 341.9c-55.6-16-37.9 17.8-37.9 17.8 11.4 61.7 64.9 131.8 107.2 138.4 42.2 6.6 220.1 4 220.1 4s-35.5 4.1-93.2 11.9c-42.7 5.8-97 12.5-111.1 17.8-33.1 12.5 24 62.6 24 62.6 84.7 76.8 129.7 50.5 129.7 50.5 33.3-10.7 61.4-18.5 85.2-24.2L565 743.1h84.6L603 928l205.3-271.9H700.8l22.3-38.7c.3.5.4.8.4.8S799.8 496.1 829 433.8l.6-1h-.1c5-10.8 8.6-19.7 10-25.8 17-71.3-114.5-99.4-265.8-154.5z" } }] }, "name": "dingding", "theme": "outlined" };
var DingdingOutlinedSvg = DingdingOutlined$2;

var DingdingOutlined = function DingdingOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DingdingOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DingdingOutlined.displayName = 'DingdingOutlined';
}
var DingdingOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(DingdingOutlined);

// This icon file is generated automatically.
var DingtalkCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm227 385.3c-1 4.2-3.5 10.4-7 17.8h.1l-.4.7c-20.3 43.1-73.1 127.7-73.1 127.7s-.1-.2-.3-.5l-15.5 26.8h74.5L575.1 810l32.3-128h-58.6l20.4-84.7c-16.5 3.9-35.9 9.4-59 16.8 0 0-31.2 18.2-89.9-35 0 0-39.6-34.7-16.6-43.4 9.8-3.7 47.4-8.4 77-12.3 40-5.4 64.6-8.2 64.6-8.2S422 517 392.7 512.5c-29.3-4.6-66.4-53.1-74.3-95.8 0 0-12.2-23.4 26.3-12.3 38.5 11.1 197.9 43.2 197.9 43.2s-207.4-63.3-221.2-78.7c-13.8-15.4-40.6-84.2-37.1-126.5 0 0 1.5-10.5 12.4-7.7 0 0 153.3 69.7 258.1 107.9 104.8 37.9 195.9 57.3 184.2 106.7z" } }] }, "name": "dingtalk-circle", "theme": "filled" };
var DingtalkCircleFilledSvg = DingtalkCircleFilled$2;

var DingtalkCircleFilled = function DingtalkCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DingtalkCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DingtalkCircleFilled.displayName = 'DingtalkCircleFilled';
}
var DingtalkCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(DingtalkCircleFilled);

// This icon file is generated automatically.
var DingtalkOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M573.7 252.5C422.5 197.4 201.3 96.7 201.3 96.7c-15.7-4.1-17.9 11.1-17.9 11.1-5 61.1 33.6 160.5 53.6 182.8 19.9 22.3 319.1 113.7 319.1 113.7S326 357.9 270.5 341.9c-55.6-16-37.9 17.8-37.9 17.8 11.4 61.7 64.9 131.8 107.2 138.4 42.2 6.6 220.1 4 220.1 4s-35.5 4.1-93.2 11.9c-42.7 5.8-97 12.5-111.1 17.8-33.1 12.5 24 62.6 24 62.6 84.7 76.8 129.7 50.5 129.7 50.5 33.3-10.7 61.4-18.5 85.2-24.2L565 743.1h84.6L603 928l205.3-271.9H700.8l22.3-38.7c.3.5.4.8.4.8S799.8 496.1 829 433.8l.6-1h-.1c5-10.8 8.6-19.7 10-25.8 17-71.3-114.5-99.4-265.8-154.5z" } }] }, "name": "dingtalk", "theme": "outlined" };
var DingtalkOutlinedSvg = DingtalkOutlined$2;

var DingtalkOutlined = function DingtalkOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DingtalkOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DingtalkOutlined.displayName = 'DingtalkOutlined';
}
var DingtalkOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(DingtalkOutlined);

// This icon file is generated automatically.
var DingtalkSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM739 449.3c-1 4.2-3.5 10.4-7 17.8h.1l-.4.7c-20.3 43.1-73.1 127.7-73.1 127.7s-.1-.2-.3-.5l-15.5 26.8h74.5L575.1 810l32.3-128h-58.6l20.4-84.7c-16.5 3.9-35.9 9.4-59 16.8 0 0-31.2 18.2-89.9-35 0 0-39.6-34.7-16.6-43.4 9.8-3.7 47.4-8.4 77-12.3 40-5.4 64.6-8.2 64.6-8.2S422 517 392.7 512.5c-29.3-4.6-66.4-53.1-74.3-95.8 0 0-12.2-23.4 26.3-12.3 38.5 11.1 197.9 43.2 197.9 43.2s-207.4-63.3-221.2-78.7c-13.8-15.4-40.6-84.2-37.1-126.5 0 0 1.5-10.5 12.4-7.7 0 0 153.3 69.7 258.1 107.9 104.8 37.9 195.9 57.3 184.2 106.7z" } }] }, "name": "dingtalk-square", "theme": "filled" };
var DingtalkSquareFilledSvg = DingtalkSquareFilled$2;

var DingtalkSquareFilled = function DingtalkSquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DingtalkSquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DingtalkSquareFilled.displayName = 'DingtalkSquareFilled';
}
var DingtalkSquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(DingtalkSquareFilled);

// This icon file is generated automatically.
var DisconnectOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832.6 191.4c-84.6-84.6-221.5-84.6-306 0l-96.9 96.9 51 51 96.9-96.9c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204l-96.9 96.9 51.1 51.1 96.9-96.9c84.4-84.6 84.4-221.5-.1-306.1zM446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l96.9-96.9-51.1-51.1-96.9 96.9c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l96.9-96.9-51-51-96.8 97zM260.3 209.4a8.03 8.03 0 00-11.3 0L209.4 249a8.03 8.03 0 000 11.3l554.4 554.4c3.1 3.1 8.2 3.1 11.3 0l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3L260.3 209.4z" } }] }, "name": "disconnect", "theme": "outlined" };
var DisconnectOutlinedSvg = DisconnectOutlined$2;

var DisconnectOutlined = function DisconnectOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DisconnectOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DisconnectOutlined.displayName = 'DisconnectOutlined';
}
var DisconnectOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(DisconnectOutlined);

// This icon file is generated automatically.
var DislikeFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 00-26.5-5.4H273v428h.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32z" } }] }, "name": "dislike", "theme": "filled" };
var DislikeFilledSvg = DislikeFilled$2;

var DislikeFilled = function DislikeFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DislikeFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DislikeFilled.displayName = 'DislikeFilled';
}
var DislikeFilled$1 = /*#__PURE__*/React__namespace.forwardRef(DislikeFilled);

// This icon file is generated automatically.
var DislikeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 00-26.5-5.4H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h129.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM184 456V172h81v284h-81zm627.2 160.4H496.8l9.6 198.4c.6 11.9-4.7 23.1-14.6 30.5-6.1 4.5-13.6 6.8-21.1 6.7a44.28 44.28 0 01-42.2-32.3L329 459.2V172h415.4a56.85 56.85 0 0133.6 51.8c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0119.6 43c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0119.6 43c0 9.7-2.3 18.9-6.9 27.3l-14 25.5 21.9 19a56.76 56.76 0 0119.6 43c0 19.1-11 37.5-28.8 48.4z" } }] }, "name": "dislike", "theme": "outlined" };
var DislikeOutlinedSvg = DislikeOutlined$2;

var DislikeOutlined = function DislikeOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DislikeOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DislikeOutlined.displayName = 'DislikeOutlined';
}
var DislikeOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(DislikeOutlined);

// This icon file is generated automatically.
var DislikeTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M273 100.1v428h.3l-.3-428zM820.4 525l-21.9-19 14-25.5a56.2 56.2 0 006.9-27.3c0-16.5-7.1-32.2-19.6-43l-21.9-19 13.9-25.4a56.2 56.2 0 006.9-27.3c0-16.5-7.1-32.2-19.6-43l-21.9-19 13.9-25.4a56.2 56.2 0 006.9-27.3c0-22.4-13.2-42.6-33.6-51.8H345v345.2c18.6 67.2 46.4 168 83.5 302.5a44.28 44.28 0 0042.2 32.3c7.5.1 15-2.2 21.1-6.7 9.9-7.4 15.2-18.6 14.6-30.5l-9.6-198.4h314.4C829 605.5 840 587.1 840 568c0-16.5-7.1-32.2-19.6-43z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32zm773.9 358.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 00-26.5-5.4H273l.3 428 85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zm-74.7 126.1H496.8l9.6 198.4c.6 11.9-4.7 23.1-14.6 30.5-6.1 4.5-13.6 6.8-21.1 6.7a44.28 44.28 0 01-42.2-32.3c-37.1-134.4-64.9-235.2-83.5-302.5V172h399.4a56.85 56.85 0 0133.6 51.8c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0119.6 43c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0119.6 43c0 9.7-2.3 18.9-6.9 27.3l-14 25.5 21.9 19a56.76 56.76 0 0119.6 43c0 19.1-11 37.5-28.8 48.4z", "fill": primaryColor } }] }; }, "name": "dislike", "theme": "twotone" };
var DislikeTwoToneSvg = DislikeTwoTone$2;

var DislikeTwoTone = function DislikeTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DislikeTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DislikeTwoTone.displayName = 'DislikeTwoTone';
}
var DislikeTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(DislikeTwoTone);

// This icon file is generated automatically.
var DollarCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm22.3 665.2l.2 31.7c0 4.4-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4C401.3 723 359.5 672.4 355 617.4c-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.7 29.8 55.4 74.1 61.3V533.9l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-72.9 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.9 46.9 125.9 109.2.5 4.7-3.2 8.8-8 8.8h-44.9c-4 0-7.4-3-7.9-6.9-4-29.2-27.4-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 108.9 116.4 0 75.3-56 117.3-134.3 124.1zM426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-36.9 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.8-.6-5.6-1.3-8.8-2.2V677c42.6-3.8 72-27.2 72-66.4 0-30.7-15.9-50.7-63.2-65.1z" } }] }, "name": "dollar-circle", "theme": "filled" };
var DollarCircleFilledSvg = DollarCircleFilled$2;

var DollarCircleFilled = function DollarCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DollarCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DollarCircleFilled.displayName = 'DollarCircleFilled';
}
var DollarCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(DollarCircleFilled);

// This icon file is generated automatically.
var DollarCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm47.7-395.2l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z" } }] }, "name": "dollar-circle", "theme": "outlined" };
var DollarCircleOutlinedSvg = DollarCircleOutlined$2;

var DollarCircleOutlined = function DollarCircleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DollarCircleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DollarCircleOutlined.displayName = 'DollarCircleOutlined';
}
var DollarCircleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(DollarCircleOutlined);

// This icon file is generated automatically.
var DollarCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-37 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.9-.6-5.7-1.3-8.8-2.2V677c42.6-3.8 72-27.3 72-66.4 0-30.7-15.9-50.7-63.2-65.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm22.4 589.2l.2 31.7c0 4.5-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4c-89-6.5-130.7-57.1-135.2-112.1-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.8 29.9 55.4 74.1 61.3V534l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-73 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.8 46.9 125.9 109.2a8.1 8.1 0 01-8 8.8h-44.9c-4 0-7.4-2.9-7.9-6.9-4-29.2-27.5-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 109 116.4 0 75.2-56 117.1-134.3 124z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M559.7 488.8l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z", "fill": primaryColor } }] }; }, "name": "dollar-circle", "theme": "twotone" };
var DollarCircleTwoToneSvg = DollarCircleTwoTone$2;

var DollarCircleTwoTone = function DollarCircleTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DollarCircleTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DollarCircleTwoTone.displayName = 'DollarCircleTwoTone';
}
var DollarCircleTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(DollarCircleTwoTone);

// This icon file is generated automatically.
var DollarOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm47.7-395.2l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z" } }] }, "name": "dollar", "theme": "outlined" };
var DollarOutlinedSvg = DollarOutlined$2;

var DollarOutlined = function DollarOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DollarOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DollarOutlined.displayName = 'DollarOutlined';
}
var DollarOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(DollarOutlined);

// This icon file is generated automatically.
var DollarTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-37 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.9-.6-5.7-1.3-8.8-2.2V677c42.6-3.8 72-27.3 72-66.4 0-30.7-15.9-50.7-63.2-65.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm22.4 589.2l.2 31.7c0 4.5-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4c-89-6.5-130.7-57.1-135.2-112.1-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.8 29.9 55.4 74.1 61.3V534l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-73 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.8 46.9 125.9 109.2a8.1 8.1 0 01-8 8.8h-44.9c-4 0-7.4-2.9-7.9-6.9-4-29.2-27.5-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 109 116.4 0 75.2-56 117.1-134.3 124z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M559.7 488.8l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z", "fill": primaryColor } }] }; }, "name": "dollar", "theme": "twotone" };
var DollarTwoToneSvg = DollarTwoTone$2;

var DollarTwoTone = function DollarTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DollarTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DollarTwoTone.displayName = 'DollarTwoTone';
}
var DollarTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(DollarTwoTone);

// This icon file is generated automatically.
var DotChartOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM288 604a64 64 0 10128 0 64 64 0 10-128 0zm118-224a48 48 0 1096 0 48 48 0 10-96 0zm158 228a96 96 0 10192 0 96 96 0 10-192 0zm148-314a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "dot-chart", "theme": "outlined" };
var DotChartOutlinedSvg = DotChartOutlined$2;

var DotChartOutlined = function DotChartOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DotChartOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DotChartOutlined.displayName = 'DotChartOutlined';
}
var DotChartOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(DotChartOutlined);

// This icon file is generated automatically.
var DoubleLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z" } }] }, "name": "double-left", "theme": "outlined" };
var DoubleLeftOutlinedSvg = DoubleLeftOutlined$2;

var DoubleLeftOutlined = function DoubleLeftOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DoubleLeftOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DoubleLeftOutlined.displayName = 'DoubleLeftOutlined';
}
var DoubleLeftOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(DoubleLeftOutlined);

// This icon file is generated automatically.
var DoubleRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z" } }] }, "name": "double-right", "theme": "outlined" };
var DoubleRightOutlinedSvg = DoubleRightOutlined$2;

var DoubleRightOutlined = function DoubleRightOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DoubleRightOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DoubleRightOutlined.displayName = 'DoubleRightOutlined';
}
var DoubleRightOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(DoubleRightOutlined);

// This icon file is generated automatically.
var DownCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm184.5 353.7l-178 246a7.95 7.95 0 01-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7H381c10.2 0 19.9 4.9 25.9 13.2L512 563.6l105.2-145.4c6-8.3 15.6-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.5 12.7z" } }] }, "name": "down-circle", "theme": "filled" };
var DownCircleFilledSvg = DownCircleFilled$2;

var DownCircleFilled = function DownCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DownCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DownCircleFilled.displayName = 'DownCircleFilled';
}
var DownCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(DownCircleFilled);

// This icon file is generated automatically.
var DownCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M690 405h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 563.6 406.8 418.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "down-circle", "theme": "outlined" };
var DownCircleOutlinedSvg = DownCircleOutlined$2;

var DownCircleOutlined = function DownCircleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DownCircleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DownCircleOutlined.displayName = 'DownCircleOutlined';
}
var DownCircleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(DownCircleOutlined);

// This icon file is generated automatically.
var DownCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm184.4 277.7l-178 246a7.95 7.95 0 01-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.3 0 19.9 4.9 25.9 13.2L512 563.6l105.2-145.4c6-8.3 15.7-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.4 12.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M690 405h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 563.6 406.8 418.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7z", "fill": primaryColor } }] }; }, "name": "down-circle", "theme": "twotone" };
var DownCircleTwoToneSvg = DownCircleTwoTone$2;

var DownCircleTwoTone = function DownCircleTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DownCircleTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DownCircleTwoTone.displayName = 'DownCircleTwoTone';
}
var DownCircleTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(DownCircleTwoTone);

// This icon file is generated automatically.
var DownOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] }, "name": "down", "theme": "outlined" };
var DownOutlinedSvg = DownOutlined$2;

var DownOutlined = function DownOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DownOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DownOutlined.displayName = 'DownOutlined';
}
var DownOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(DownOutlined);

// This icon file is generated automatically.
var DownSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM696.5 412.7l-178 246a7.95 7.95 0 01-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7H381c10.2 0 19.9 4.9 25.9 13.2L512 558.6l105.2-145.4c6-8.3 15.6-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.5 12.7z" } }] }, "name": "down-square", "theme": "filled" };
var DownSquareFilledSvg = DownSquareFilled$2;

var DownSquareFilled = function DownSquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DownSquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DownSquareFilled.displayName = 'DownSquareFilled';
}
var DownSquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(DownSquareFilled);

// This icon file is generated automatically.
var DownSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M505.5 658.7c3.2 4.4 9.7 4.4 12.9 0l178-246c3.8-5.3 0-12.7-6.5-12.7H643c-10.2 0-19.9 4.9-25.9 13.2L512 558.6 406.8 413.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "down-square", "theme": "outlined" };
var DownSquareOutlinedSvg = DownSquareOutlined$2;

var DownSquareOutlined = function DownSquareOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DownSquareOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DownSquareOutlined.displayName = 'DownSquareOutlined';
}
var DownSquareOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(DownSquareOutlined);

// This icon file is generated automatically.
var DownSquareTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm150-440h46.9c10.3 0 19.9 4.9 25.9 13.2L512 558.6l105.2-145.4c6-8.3 15.7-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.4 12.7l-178 246a7.95 7.95 0 01-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M505.5 658.7c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 558.6 406.8 413.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246z", "fill": primaryColor } }] }; }, "name": "down-square", "theme": "twotone" };
var DownSquareTwoToneSvg = DownSquareTwoTone$2;

var DownSquareTwoTone = function DownSquareTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DownSquareTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DownSquareTwoTone.displayName = 'DownSquareTwoTone';
}
var DownSquareTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(DownSquareTwoTone);

// This icon file is generated automatically.
var DownloadOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" } }] }, "name": "download", "theme": "outlined" };
var DownloadOutlinedSvg = DownloadOutlined$2;

var DownloadOutlined = function DownloadOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DownloadOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DownloadOutlined.displayName = 'DownloadOutlined';
}
var DownloadOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(DownloadOutlined);

// This icon file is generated automatically.
var DragOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M909.3 506.3L781.7 405.6a7.23 7.23 0 00-11.7 5.7V476H548V254h64.8c6 0 9.4-7 5.7-11.7L517.7 114.7a7.14 7.14 0 00-11.3 0L405.6 242.3a7.23 7.23 0 005.7 11.7H476v222H254v-64.8c0-6-7-9.4-11.7-5.7L114.7 506.3a7.14 7.14 0 000 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h222v222h-64.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V548h222v64.8c0 6 7 9.4 11.7 5.7l127.5-100.8a7.3 7.3 0 00.1-11.4z" } }] }, "name": "drag", "theme": "outlined" };
var DragOutlinedSvg = DragOutlined$2;

var DragOutlined = function DragOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DragOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DragOutlined.displayName = 'DragOutlined';
}
var DragOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(DragOutlined);

// This icon file is generated automatically.
var DribbbleCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M675.1 328.3a245.2 245.2 0 00-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6zm47.7-11.9c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 736c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm53.1-346.2c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm30.6 82.5c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4z" } }] }, "name": "dribbble-circle", "theme": "filled" };
var DribbbleCircleFilledSvg = DribbbleCircleFilled$2;

var DribbbleCircleFilled = function DribbbleCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DribbbleCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DribbbleCircleFilled.displayName = 'DribbbleCircleFilled';
}
var DribbbleCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(DribbbleCircleFilled);

// This icon file is generated automatically.
var DribbbleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 96C282.6 96 96 282.6 96 512s186.6 416 416 416 416-186.6 416-416S741.4 96 512 96zm275.1 191.8c49.5 60.5 79.5 137.5 80.2 221.4-11.7-2.5-129.2-26.3-247.4-11.4-2.5-6.1-5-12.2-7.6-18.3-7.4-17.3-15.3-34.6-23.6-51.5C720 374.3 779.6 298 787.1 287.8zM512 157.2c90.3 0 172.8 33.9 235.5 89.5-6.4 9.1-59.9 81-186.2 128.4-58.2-107-122.7-194.8-132.6-208 27.3-6.6 55.2-9.9 83.3-9.9zM360.9 191c9.4 12.8 72.9 100.9 131.7 205.5C326.4 440.6 180 440 164.1 439.8c23.1-110.3 97.4-201.9 196.8-248.8zM156.7 512.5c0-3.6.1-7.3.2-10.9 15.5.3 187.7 2.5 365.2-50.6 10.2 19.9 19.9 40.1 28.8 60.3-4.7 1.3-9.4 2.7-14 4.2C353.6 574.9 256.1 736.4 248 750.1c-56.7-63-91.3-146.3-91.3-237.6zM512 867.8c-82.2 0-157.9-28-218.1-75 6.4-13.1 78.3-152 278.7-221.9l2.3-.8c49.9 129.6 70.5 238.3 75.8 269.5A350.46 350.46 0 01512 867.8zm198.5-60.7c-3.6-21.6-22.5-125.6-69-253.3C752.9 536 850.7 565.2 862.8 569c-15.8 98.8-72.5 184.2-152.3 238.1z" } }] }, "name": "dribbble", "theme": "outlined" };
var DribbbleOutlinedSvg = DribbbleOutlined$2;

var DribbbleOutlined = function DribbbleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DribbbleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DribbbleOutlined.displayName = 'DribbbleOutlined';
}
var DribbbleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(DribbbleOutlined);

// This icon file is generated automatically.
var DribbbleSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm66.5 21.8c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM512 800c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm89.7-259.1c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zm-72.5-26.4c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4zm145.9-186.2a245.2 245.2 0 00-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6z" } }] }, "name": "dribbble-square", "theme": "filled" };
var DribbbleSquareFilledSvg = DribbbleSquareFilled$2;

var DribbbleSquareFilled = function DribbbleSquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DribbbleSquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DribbbleSquareFilled.displayName = 'DribbbleSquareFilled';
}
var DribbbleSquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(DribbbleSquareFilled);

// This icon file is generated automatically.
var DribbbleSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm66.5 21.8c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM512 800c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm89.7-259.1c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zm-72.5-26.4c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4zm145.9-186.2a245.2 245.2 0 00-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6z" } }] }, "name": "dribbble-square", "theme": "outlined" };
var DribbbleSquareOutlinedSvg = DribbbleSquareOutlined$2;

var DribbbleSquareOutlined = function DribbbleSquareOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DribbbleSquareOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DribbbleSquareOutlined.displayName = 'DribbbleSquareOutlined';
}
var DribbbleSquareOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(DribbbleSquareOutlined);

// This icon file is generated automatically.
var DropboxCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M663.8 455.5zm-151.5-93.8l-151.8 93.8 151.8 93.9 151.5-93.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm151.2 595.5L512.6 750l-151-90.5v-33.1l45.4 29.4 105.6-87.7 105.6 87.7 45.1-29.4v33.1zm-45.6-22.4l-105.3-87.7L407 637.1l-151-99.2 104.5-82.4L256 371.2 407 274l105.3 87.7L617.6 274 768 372.1l-104.2 83.5L768 539l-150.4 98.1z" } }] }, "name": "dropbox-circle", "theme": "filled" };
var DropboxCircleFilledSvg = DropboxCircleFilled$2;

var DropboxCircleFilled = function DropboxCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DropboxCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DropboxCircleFilled.displayName = 'DropboxCircleFilled';
}
var DropboxCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(DropboxCircleFilled);

// This icon file is generated automatically.
var DropboxOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M64 556.9l264.2 173.5L512.5 577 246.8 412.7zm896-290.3zm0 0L696.8 95 512.5 248.5l265.2 164.2L512.5 577l184.3 153.4L960 558.8 777.7 412.7zM513 609.8L328.2 763.3l-79.4-51.5v57.8L513 928l263.7-158.4v-57.8l-78.9 51.5zM328.2 95L64 265.1l182.8 147.6 265.7-164.2zM64 556.9z" } }] }, "name": "dropbox", "theme": "outlined" };
var DropboxOutlinedSvg = DropboxOutlined$2;

var DropboxOutlined = function DropboxOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DropboxOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DropboxOutlined.displayName = 'DropboxOutlined';
}
var DropboxOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(DropboxOutlined);

// This icon file is generated automatically.
var DropboxSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM663.2 659.5L512.6 750l-151-90.5v-33.1l45.4 29.4 105.6-87.7 105.6 87.7 45.1-29.4v33.1zm-45.6-22.4l-105.3-87.7L407 637.1l-151-99.2 104.5-82.4L256 371.2 407 274l105.3 87.7L617.6 274 768 372.1l-104.2 83.5L768 539l-150.4 98.1zM512.3 361.7l-151.8 93.8 151.8 93.9 151.5-93.9zm151.5 93.8z" } }] }, "name": "dropbox-square", "theme": "filled" };
var DropboxSquareFilledSvg = DropboxSquareFilled$2;

var DropboxSquareFilled = function DropboxSquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DropboxSquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  DropboxSquareFilled.displayName = 'DropboxSquareFilled';
}
var DropboxSquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(DropboxSquareFilled);

// This icon file is generated automatically.
var EditFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9z" } }] }, "name": "edit", "theme": "filled" };
var EditFilledSvg = EditFilled$2;

var EditFilled = function EditFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EditFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  EditFilled.displayName = 'EditFilled';
}
var EditFilled$1 = /*#__PURE__*/React__namespace.forwardRef(EditFilled);

// This icon file is generated automatically.
var EditOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z" } }] }, "name": "edit", "theme": "outlined" };
var EditOutlinedSvg = EditOutlined$2;

var EditOutlined = function EditOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EditOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  EditOutlined.displayName = 'EditOutlined';
}
var EditOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(EditOutlined);

// This icon file is generated automatically.
var EditTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M761.1 288.3L687.8 215 325.1 577.6l-15.6 89 88.9-15.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89z", "fill": primaryColor } }] }; }, "name": "edit", "theme": "twotone" };
var EditTwoToneSvg = EditTwoTone$2;

var EditTwoTone = function EditTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EditTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  EditTwoTone.displayName = 'EditTwoTone';
}
var EditTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(EditTwoTone);

// This icon file is generated automatically.
var EllipsisOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "ellipsis", "theme": "outlined" };
var EllipsisOutlinedSvg = EllipsisOutlined$2;

var EllipsisOutlined = function EllipsisOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EllipsisOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  EllipsisOutlined.displayName = 'EllipsisOutlined';
}
var EllipsisOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(EllipsisOutlined);

// This icon file is generated automatically.
var EnterOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z" } }] }, "name": "enter", "theme": "outlined" };
var EnterOutlinedSvg = EnterOutlined$2;

var EnterOutlined = function EnterOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EnterOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  EnterOutlined.displayName = 'EnterOutlined';
}
var EnterOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(EnterOutlined);

// This icon file is generated automatically.
var EnvironmentFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 327c-29.9 0-58 11.6-79.2 32.8A111.6 111.6 0 00400 439c0 29.9 11.7 58 32.8 79.2A111.6 111.6 0 00512 551c29.9 0 58-11.7 79.2-32.8C612.4 497 624 468.9 624 439c0-29.9-11.6-58-32.8-79.2S541.9 327 512 327zm342.6-37.9a362.49 362.49 0 00-79.9-115.7 370.83 370.83 0 00-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 00169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0022.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 615c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z" } }] }, "name": "environment", "theme": "filled" };
var EnvironmentFilledSvg = EnvironmentFilled$2;

var EnvironmentFilled = function EnvironmentFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EnvironmentFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  EnvironmentFilled.displayName = 'EnvironmentFilled';
}
var EnvironmentFilled$1 = /*#__PURE__*/React__namespace.forwardRef(EnvironmentFilled);

// This icon file is generated automatically.
var EnvironmentOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 289.1a362.49 362.49 0 00-79.9-115.7 370.83 370.83 0 00-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 00169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0022.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1zm0-617.2c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8C612.4 381 624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z" } }] }, "name": "environment", "theme": "outlined" };
var EnvironmentOutlinedSvg = EnvironmentOutlined$2;

var EnvironmentOutlined = function EnvironmentOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EnvironmentOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  EnvironmentOutlined.displayName = 'EnvironmentOutlined';
}
var EnvironmentOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(EnvironmentOutlined);

// This icon file is generated automatically.
var EnvironmentTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M724.4 224.9C667.7 169.5 592.3 139 512 139s-155.7 30.5-212.4 85.8C243.1 280 212 353.2 212 431.1c0 241.3 234.1 407.2 300 449.1 65.9-41.9 300-207.8 300-449.1 0-77.9-31.1-151.1-87.6-206.2zM512 615c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 263c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8S624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 289.1a362.49 362.49 0 00-79.9-115.7 370.83 370.83 0 00-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 00169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0022.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1z", "fill": primaryColor } }] }; }, "name": "environment", "theme": "twotone" };
var EnvironmentTwoToneSvg = EnvironmentTwoTone$2;

var EnvironmentTwoTone = function EnvironmentTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EnvironmentTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  EnvironmentTwoTone.displayName = 'EnvironmentTwoTone';
}
var EnvironmentTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(EnvironmentTwoTone);

// This icon file is generated automatically.
var EuroCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm63.5 375.8c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8h-136c-.3 4.4-.3 9.1-.3 13.8v36h136.2c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H444.9c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.2 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.3 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H344c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.8.3-12.8H344c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.7c19.7-94.2 92-149.9 198.6-149.9 20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346h.1c0 5.1-4.6 8.8-9.6 7.8-14.7-2.9-31.8-4.4-51.7-4.4-65.4 0-110.4 33.5-127.6 90.4h128.4z" } }] }, "name": "euro-circle", "theme": "filled" };
var EuroCircleFilledSvg = EuroCircleFilled$2;

var EuroCircleFilled = function EuroCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EuroCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  EuroCircleFilled.displayName = 'EuroCircleFilled';
}
var EuroCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(EuroCircleFilled);

// This icon file is generated automatically.
var EuroCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm117.7-588.6c-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H344c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H344c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H439.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H447.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 009.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8z" } }] }, "name": "euro-circle", "theme": "outlined" };
var EuroCircleOutlinedSvg = EuroCircleOutlined$2;

var EuroCircleOutlined = function EuroCircleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EuroCircleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  EuroCircleOutlined.displayName = 'EuroCircleOutlined';
}
var EuroCircleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(EuroCircleOutlined);

// This icon file is generated automatically.
var EuroCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm117.1 581.1c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.4 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.7.3-12.8H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.8C388.5 345.7 460.7 290 567.4 290c20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346a8 8 0 01-9.6 7.8c-14.6-2.9-31.8-4.4-51.7-4.4-65.3 0-110.4 33.5-127.6 90.4h128.3c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8H432.5c-.3 4.4-.3 9.1-.3 13.8v36h136.4c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H438c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.3 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M619.6 670.5c-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H432.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H440.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 009.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H337c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H337c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8z", "fill": primaryColor } }] }; }, "name": "euro-circle", "theme": "twotone" };
var EuroCircleTwoToneSvg = EuroCircleTwoTone$2;

var EuroCircleTwoTone = function EuroCircleTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EuroCircleTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  EuroCircleTwoTone.displayName = 'EuroCircleTwoTone';
}
var EuroCircleTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(EuroCircleTwoTone);

// This icon file is generated automatically.
var EuroOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm117.7-588.6c-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H344c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H344c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H439.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H447.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 009.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8z" } }] }, "name": "euro", "theme": "outlined" };
var EuroOutlinedSvg = EuroOutlined$2;

var EuroOutlined = function EuroOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EuroOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  EuroOutlined.displayName = 'EuroOutlined';
}
var EuroOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(EuroOutlined);

// This icon file is generated automatically.
var EuroTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm117.1 581.1c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.4 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.7.3-12.8H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.8C388.5 345.7 460.7 290 567.4 290c20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346a8 8 0 01-9.6 7.8c-14.6-2.9-31.8-4.4-51.7-4.4-65.3 0-110.4 33.5-127.6 90.4h128.3c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8H432.5c-.3 4.4-.3 9.1-.3 13.8v36h136.4c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H438c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.3 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M619.6 670.5c-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H432.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H440.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 009.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H337c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H337c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8z", "fill": primaryColor } }] }; }, "name": "euro", "theme": "twotone" };
var EuroTwoToneSvg = EuroTwoTone$2;

var EuroTwoTone = function EuroTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EuroTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  EuroTwoTone.displayName = 'EuroTwoTone';
}
var EuroTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(EuroTwoTone);

// This icon file is generated automatically.
var ExceptionOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm376 116c-119.3 0-216 96.7-216 216s96.7 216 216 216 216-96.7 216-216-96.7-216-216-216zm107.5 323.5C750.8 868.2 712.6 884 672 884s-78.8-15.8-107.5-44.5C535.8 810.8 520 772.6 520 732s15.8-78.8 44.5-107.5C593.2 595.8 631.4 580 672 580s78.8 15.8 107.5 44.5C808.2 653.2 824 691.4 824 732s-15.8 78.8-44.5 107.5zM640 812a32 32 0 1064 0 32 32 0 10-64 0zm12-64h40c4.4 0 8-3.6 8-8V628c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8zM440 852H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "exception", "theme": "outlined" };
var ExceptionOutlinedSvg = ExceptionOutlined$2;

var ExceptionOutlined = function ExceptionOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ExceptionOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ExceptionOutlined.displayName = 'ExceptionOutlined';
}
var ExceptionOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ExceptionOutlined);

// This icon file is generated automatically.
var ExclamationCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "exclamation-circle", "theme": "filled" };
var ExclamationCircleFilledSvg = ExclamationCircleFilled$2;

var ExclamationCircleFilled = function ExclamationCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ExclamationCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ExclamationCircleFilled.displayName = 'ExclamationCircleFilled';
}
var ExclamationCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(ExclamationCircleFilled);

// This icon file is generated automatically.
var ExclamationCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z" } }] }, "name": "exclamation-circle", "theme": "outlined" };
var ExclamationCircleOutlinedSvg = ExclamationCircleOutlined$2;

var ExclamationCircleOutlined = function ExclamationCircleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ExclamationCircleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ExclamationCircleOutlined.displayName = 'ExclamationCircleOutlined';
}
var ExclamationCircleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ExclamationCircleOutlined);

// This icon file is generated automatically.
var ExclamationCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-32 156c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M488 576h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8zm-24 112a48 48 0 1096 0 48 48 0 10-96 0z", "fill": primaryColor } }] }; }, "name": "exclamation-circle", "theme": "twotone" };
var ExclamationCircleTwoToneSvg = ExclamationCircleTwoTone$2;

var ExclamationCircleTwoTone = function ExclamationCircleTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ExclamationCircleTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ExclamationCircleTwoTone.displayName = 'ExclamationCircleTwoTone';
}
var ExclamationCircleTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(ExclamationCircleTwoTone);

// This icon file is generated automatically.
var ExclamationOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M448 804a64 64 0 10128 0 64 64 0 10-128 0zm32-168h64c4.4 0 8-3.6 8-8V164c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z" } }] }, "name": "exclamation", "theme": "outlined" };
var ExclamationOutlinedSvg = ExclamationOutlined$2;

var ExclamationOutlined = function ExclamationOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ExclamationOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ExclamationOutlined.displayName = 'ExclamationOutlined';
}
var ExclamationOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ExclamationOutlined);

// This icon file is generated automatically.
var ExpandAltOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M855 160.1l-189.2 23.5c-6.6.8-9.3 8.8-4.7 13.5l54.7 54.7-153.5 153.5a8.03 8.03 0 000 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l153.6-153.6 54.7 54.7a7.94 7.94 0 0013.5-4.7L863.9 169a7.9 7.9 0 00-8.9-8.9zM416.6 562.3a8.03 8.03 0 00-11.3 0L251.8 715.9l-54.7-54.7a7.94 7.94 0 00-13.5 4.7L160.1 855c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 153.6-153.6c3.1-3.1 3.1-8.2 0-11.3l-45.2-45z" } }] }, "name": "expand-alt", "theme": "outlined" };
var ExpandAltOutlinedSvg = ExpandAltOutlined$2;

var ExpandAltOutlined = function ExpandAltOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ExpandAltOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ExpandAltOutlined.displayName = 'ExpandAltOutlined';
}
var ExpandAltOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ExpandAltOutlined);

// This icon file is generated automatically.
var ExpandOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M342 88H120c-17.7 0-32 14.3-32 32v224c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V168h174c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16zm578 576h-48c-8.8 0-16 7.2-16 16v176H682c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h222c17.7 0 32-14.3 32-32V680c0-8.8-7.2-16-16-16zM342 856H168V680c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16v224c0 17.7 14.3 32 32 32h222c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16zM904 88H682c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h174v176c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V120c0-17.7-14.3-32-32-32z" } }] }, "name": "expand", "theme": "outlined" };
var ExpandOutlinedSvg = ExpandOutlined$2;

var ExpandOutlined = function ExpandOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ExpandOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ExpandOutlined.displayName = 'ExpandOutlined';
}
var ExpandOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ExpandOutlined);

// This icon file is generated automatically.
var ExperimentFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M218.9 636.3l42.6 26.6c.1.1.3.2.4.3l12.7 8 .3.3a186.9 186.9 0 0094.1 25.1c44.9 0 87.2-15.7 121-43.8a256.27 256.27 0 01164.9-59.9c52.3 0 102.2 15.7 144.6 44.5l7.9 5-111.6-289V179.8h63.5c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8H264.7c-4.4 0-8 3.6-8 8v51.9c0 4.4 3.6 8 8 8h63.5v173.6L218.9 636.3zm333-203.1c22 0 39.9 17.9 39.9 39.9S573.9 513 551.9 513 512 495.1 512 473.1s17.9-39.9 39.9-39.9zM878 825.1l-29.9-77.4-85.7-53.5-.1.1c-.7-.5-1.5-1-2.2-1.5l-8.1-5-.3-.3c-29-17.5-62.3-26.8-97-26.8-44.9 0-87.2 15.7-121 43.8a256.27 256.27 0 01-164.9 59.9c-53 0-103.5-16.1-146.2-45.6l-28.9-18.1L146 825.1c-2.8 7.4-4.3 15.2-4.3 23 0 35.2 28.6 63.8 63.8 63.8h612.9c7.9 0 15.7-1.5 23-4.3a63.6 63.6 0 0036.6-82.5z" } }] }, "name": "experiment", "theme": "filled" };
var ExperimentFilledSvg = ExperimentFilled$2;

var ExperimentFilled = function ExperimentFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ExperimentFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ExperimentFilled.displayName = 'ExperimentFilled';
}
var ExperimentFilled$1 = /*#__PURE__*/React__namespace.forwardRef(ExperimentFilled);

// This icon file is generated automatically.
var ExperimentOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 472a40 40 0 1080 0 40 40 0 10-80 0zm367 352.9L696.3 352V178H768v-68H256v68h71.7v174L145 824.9c-2.8 7.4-4.3 15.2-4.3 23.1 0 35.3 28.7 64 64 64h614.6c7.9 0 15.7-1.5 23.1-4.3 33-12.7 49.4-49.8 36.6-82.8zM395.7 364.7V180h232.6v184.7L719.2 600c-20.7-5.3-42.1-8-63.9-8-61.2 0-119.2 21.5-165.3 60a188.78 188.78 0 01-121.3 43.9c-32.7 0-64.1-8.3-91.8-23.7l118.8-307.5zM210.5 844l41.7-107.8c35.7 18.1 75.4 27.8 116.6 27.8 61.2 0 119.2-21.5 165.3-60 33.9-28.2 76.3-43.9 121.3-43.9 35 0 68.4 9.5 97.6 27.1L813.5 844h-603z" } }] }, "name": "experiment", "theme": "outlined" };
var ExperimentOutlinedSvg = ExperimentOutlined$2;

var ExperimentOutlined = function ExperimentOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ExperimentOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ExperimentOutlined.displayName = 'ExperimentOutlined';
}
var ExperimentOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ExperimentOutlined);

// This icon file is generated automatically.
var ExperimentTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M551.9 513c19.6 0 35.9-14.2 39.3-32.8A40.02 40.02 0 01552 512a40 40 0 01-40-39.4v.5c0 22 17.9 39.9 39.9 39.9zM752 687.8l-.3-.3c-29-17.5-62.3-26.8-97-26.8-44.9 0-87.2 15.7-121 43.8a256.27 256.27 0 01-164.9 59.9c-41.2 0-81-9.8-116.7-28L210.5 844h603l-59.9-155.2-1.6-1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M879 824.9L696.3 352V178H768v-68H256v68h71.7v174L145 824.9c-2.8 7.4-4.3 15.2-4.3 23.1 0 35.3 28.7 64 64 64h614.6c7.9 0 15.7-1.5 23.1-4.3 33-12.7 49.4-49.8 36.6-82.8zM395.7 364.7V180h232.6v184.7L719.2 600c-20.7-5.3-42.1-8-63.9-8-61.2 0-119.2 21.5-165.3 60a188.78 188.78 0 01-121.3 43.9c-32.7 0-64.1-8.3-91.8-23.7l118.8-307.5zM210.5 844l41.6-107.6.1-.2c35.7 18.1 75.4 27.8 116.6 27.8 61.2 0 119.2-21.5 165.3-60 33.9-28.2 76.3-43.9 121.3-43.9 35 0 68.4 9.5 97.6 27.1l.6 1.6L813.5 844h-603z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M552 512c19.3 0 35.4-13.6 39.2-31.8.6-2.7.8-5.4.8-8.2 0-22.1-17.9-40-40-40s-40 17.9-40 40v.6a40 40 0 0040 39.4z", "fill": primaryColor } }] }; }, "name": "experiment", "theme": "twotone" };
var ExperimentTwoToneSvg = ExperimentTwoTone$2;

var ExperimentTwoTone = function ExperimentTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ExperimentTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ExperimentTwoTone.displayName = 'ExperimentTwoTone';
}
var ExperimentTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(ExperimentTwoTone);

// This icon file is generated automatically.
var ExportOutlined$2 = { "icon": { "tag": "svg", "attrs": { "fill-rule": "evenodd", "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 912H144c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32h360c4.4 0 8 3.6 8 8v56c0 4.4-3.6 8-8 8H184v656h656V520c0-4.4 3.6-8 8-8h56c4.4 0 8 3.6 8 8v360c0 17.7-14.3 32-32 32zM770.87 199.13l-52.2-52.2a8.01 8.01 0 014.7-13.6l179.4-21c5.1-.6 9.5 3.7 8.9 8.9l-21 179.4c-.8 6.6-8.9 9.4-13.6 4.7l-52.4-52.4-256.2 256.2a8.03 8.03 0 01-11.3 0l-42.4-42.4a8.03 8.03 0 010-11.3l256.1-256.3z" } }] }, "name": "export", "theme": "outlined" };
var ExportOutlinedSvg = ExportOutlined$2;

var ExportOutlined = function ExportOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ExportOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ExportOutlined.displayName = 'ExportOutlined';
}
var ExportOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ExportOutlined);

// This icon file is generated automatically.
var EyeFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M396 512a112 112 0 10224 0 112 112 0 10-224 0zm546.2-25.8C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM508 688c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z" } }] }, "name": "eye", "theme": "filled" };
var EyeFilledSvg = EyeFilled$2;

var EyeFilled = function EyeFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EyeFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  EyeFilled.displayName = 'EyeFilled';
}
var EyeFilled$1 = /*#__PURE__*/React__namespace.forwardRef(EyeFilled);

// This icon file is generated automatically.
var EyeInvisibleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M508 624a112 112 0 00112-112c0-3.28-.15-6.53-.43-9.74L498.26 623.57c3.21.28 6.45.43 9.74.43zm370.72-458.44L836 122.88a8 8 0 00-11.31 0L715.37 232.23Q624.91 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.7 119.43 136.55 191.45L112.56 835a8 8 0 000 11.31L155.25 889a8 8 0 0011.31 0l712.16-712.12a8 8 0 000-11.32zM332 512a176 176 0 01258.88-155.28l-48.62 48.62a112.08 112.08 0 00-140.92 140.92l-48.62 48.62A175.09 175.09 0 01332 512z" } }, { "tag": "path", "attrs": { "d": "M942.2 486.2Q889.4 375 816.51 304.85L672.37 449A176.08 176.08 0 01445 676.37L322.74 798.63Q407.82 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5z" } }] }, "name": "eye-invisible", "theme": "filled" };
var EyeInvisibleFilledSvg = EyeInvisibleFilled$2;

var EyeInvisibleFilled = function EyeInvisibleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EyeInvisibleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  EyeInvisibleFilled.displayName = 'EyeInvisibleFilled';
}
var EyeInvisibleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(EyeInvisibleFilled);

// This icon file is generated automatically.
var EyeInvisibleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z" } }, { "tag": "path", "attrs": { "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z" } }] }, "name": "eye-invisible", "theme": "outlined" };
var EyeInvisibleOutlinedSvg = EyeInvisibleOutlined$2;

var EyeInvisibleOutlined = function EyeInvisibleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EyeInvisibleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  EyeInvisibleOutlined.displayName = 'EyeInvisibleOutlined';
}
var EyeInvisibleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(EyeInvisibleOutlined);

// This icon file is generated automatically.
var EyeInvisibleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M254.89 758.85l125.57-125.57a176 176 0 01248.82-248.82L757 256.72Q651.69 186.07 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q69.27 145.91 173.09 221.05zM942.2 486.2Q889.46 375.11 816.7 305L672.48 449.27a176.09 176.09 0 01-227.22 227.21L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zM878.63 165.56L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z", "fill": primaryColor } }] }; }, "name": "eye-invisible", "theme": "twotone" };
var EyeInvisibleTwoToneSvg = EyeInvisibleTwoTone$2;

var EyeInvisibleTwoTone = function EyeInvisibleTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EyeInvisibleTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  EyeInvisibleTwoTone.displayName = 'EyeInvisibleTwoTone';
}
var EyeInvisibleTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(EyeInvisibleTwoTone);

// This icon file is generated automatically.
var EyeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, "name": "eye", "theme": "outlined" };
var EyeOutlinedSvg = EyeOutlined$2;

var EyeOutlined = function EyeOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EyeOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  EyeOutlined.displayName = 'EyeOutlined';
}
var EyeOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(EyeOutlined);

// This icon file is generated automatically.
var EyeTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M81.8 537.8a60.3 60.3 0 010-51.5C176.6 286.5 319.8 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c-192.1 0-335.4-100.5-430.2-300.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 258c-161.3 0-279.4 81.8-362.7 254C232.6 684.2 350.7 766 512 766c161.4 0 279.5-81.8 362.7-254C791.4 339.8 673.3 258 512 258zm-4 430c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258s279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M508 336c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z", "fill": primaryColor } }] }; }, "name": "eye", "theme": "twotone" };
var EyeTwoToneSvg = EyeTwoTone$2;

var EyeTwoTone = function EyeTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EyeTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  EyeTwoTone.displayName = 'EyeTwoTone';
}
var EyeTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(EyeTwoTone);

// This icon file is generated automatically.
var FacebookFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-92.4 233.5h-63.9c-50.1 0-59.8 23.8-59.8 58.8v77.1h119.6l-15.6 120.7h-104V912H539.2V602.2H434.9V481.4h104.3v-89c0-103.3 63.1-159.6 155.3-159.6 44.2 0 82.1 3.3 93.2 4.8v107.9z" } }] }, "name": "facebook", "theme": "filled" };
var FacebookFilledSvg = FacebookFilled$2;

var FacebookFilled = function FacebookFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FacebookFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FacebookFilled.displayName = 'FacebookFilled';
}
var FacebookFilled$1 = /*#__PURE__*/React__namespace.forwardRef(FacebookFilled);

// This icon file is generated automatically.
var FacebookOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-32 736H663.9V602.2h104l15.6-120.7H663.9v-77.1c0-35 9.7-58.8 59.8-58.8h63.9v-108c-11.1-1.5-49-4.8-93.2-4.8-92.2 0-155.3 56.3-155.3 159.6v89H434.9v120.7h104.3V848H176V176h672v672z" } }] }, "name": "facebook", "theme": "outlined" };
var FacebookOutlinedSvg = FacebookOutlined$2;

var FacebookOutlined = function FacebookOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FacebookOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FacebookOutlined.displayName = 'FacebookOutlined';
}
var FacebookOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FacebookOutlined);

// This icon file is generated automatically.
var FallOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M925.9 804l-24-199.2c-.8-6.6-8.9-9.4-13.6-4.7L829 659.5 557.7 388.3c-6.3-6.2-16.4-6.2-22.6 0L433.3 490 156.6 213.3a8.03 8.03 0 00-11.3 0l-45 45.2a8.03 8.03 0 000 11.3L422 591.7c6.2 6.3 16.4 6.3 22.6 0L546.4 490l226.1 226-59.3 59.3a8.01 8.01 0 004.7 13.6l199.2 24c5.1.7 9.5-3.7 8.8-8.9z" } }] }, "name": "fall", "theme": "outlined" };
var FallOutlinedSvg = FallOutlined$2;

var FallOutlined = function FallOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FallOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FallOutlined.displayName = 'FallOutlined';
}
var FallOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FallOutlined);

// This icon file is generated automatically.
var FastBackwardFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M517.6 273.5L230.2 499.3a16.14 16.14 0 000 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm320 0L550.2 499.3a16.14 16.14 0 000 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm-620-25.5h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z" } }] }, "name": "fast-backward", "theme": "filled" };
var FastBackwardFilledSvg = FastBackwardFilled$2;

var FastBackwardFilled = function FastBackwardFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FastBackwardFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FastBackwardFilled.displayName = 'FastBackwardFilled';
}
var FastBackwardFilled$1 = /*#__PURE__*/React__namespace.forwardRef(FastBackwardFilled);

// This icon file is generated automatically.
var FastBackwardOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M517.6 273.5L230.2 499.3a16.14 16.14 0 000 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm320 0L550.2 499.3a16.14 16.14 0 000 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm-620-25.5h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z" } }] }, "name": "fast-backward", "theme": "outlined" };
var FastBackwardOutlinedSvg = FastBackwardOutlined$2;

var FastBackwardOutlined = function FastBackwardOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FastBackwardOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FastBackwardOutlined.displayName = 'FastBackwardOutlined';
}
var FastBackwardOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FastBackwardOutlined);

// This icon file is generated automatically.
var FastForwardFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M793.8 499.3L506.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.6c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8a16.14 16.14 0 000-25.4zm-320 0L186.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.5c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8c4.1-3.2 6.2-8 6.2-12.7 0-4.6-2.1-9.4-6.2-12.6zM857.6 248h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z" } }] }, "name": "fast-forward", "theme": "filled" };
var FastForwardFilledSvg = FastForwardFilled$2;

var FastForwardFilled = function FastForwardFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FastForwardFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FastForwardFilled.displayName = 'FastForwardFilled';
}
var FastForwardFilled$1 = /*#__PURE__*/React__namespace.forwardRef(FastForwardFilled);

// This icon file is generated automatically.
var FastForwardOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M793.8 499.3L506.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.6c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8a16.14 16.14 0 000-25.4zm-320 0L186.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.5c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8c4.1-3.2 6.2-8 6.2-12.7 0-4.6-2.1-9.4-6.2-12.6zM857.6 248h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z" } }] }, "name": "fast-forward", "theme": "outlined" };
var FastForwardOutlinedSvg = FastForwardOutlined$2;

var FastForwardOutlined = function FastForwardOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FastForwardOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FastForwardOutlined.displayName = 'FastForwardOutlined';
}
var FastForwardOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FastForwardOutlined);

// This icon file is generated automatically.
var FieldBinaryOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M600 395.4h91V649h79V267c0-4.4-3.6-8-8-8h-48.2c-3.7 0-7 2.6-7.7 6.3-2.6 12.1-6.9 22.3-12.9 30.9a86.14 86.14 0 01-26.3 24.4c-10.3 6.2-22 10.5-35 12.9-10.4 1.9-21 3-32 3.1a8 8 0 00-7.9 8v42.8c0 4.4 3.6 8 8 8zM871 702H567c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM443.9 312.7c-16.1-19-34.4-32.4-55.2-40.4-21.3-8.2-44.1-12.3-68.4-12.3-23.9 0-46.4 4.1-67.7 12.3-20.8 8-39 21.4-54.8 40.3-15.9 19.1-28.7 44.7-38.3 77-9.6 32.5-14.5 73-14.5 121.5 0 49.9 4.9 91.4 14.5 124.4 9.6 32.8 22.4 58.7 38.3 77.7 15.8 18.9 34 32.3 54.8 40.3 21.3 8.2 43.8 12.3 67.7 12.3 24.4 0 47.2-4.1 68.4-12.3 20.8-8 39.2-21.4 55.2-40.4 16.1-19 29-44.9 38.6-77.7 9.6-33 14.5-74.5 14.5-124.4 0-48.4-4.9-88.9-14.5-121.5-9.5-32.1-22.4-57.7-38.6-76.8zm-29.5 251.7c-1 21.4-4.2 42-9.5 61.9-5.5 20.7-14.5 38.5-27 53.4-13.6 16.3-33.2 24.3-57.6 24.3-24 0-43.2-8.1-56.7-24.4-12.2-14.8-21.1-32.6-26.6-53.3-5.3-19.9-8.5-40.6-9.5-61.9-1-20.8-1.5-38.5-1.5-53.2 0-8.8.1-19.4.4-31.8.2-12.7 1.1-25.8 2.6-39.2 1.5-13.6 4-27.1 7.6-40.5 3.7-13.8 8.8-26.3 15.4-37.4 6.9-11.6 15.8-21.1 26.7-28.3 11.4-7.6 25.3-11.3 41.5-11.3 16.1 0 30.1 3.7 41.7 11.2a87.94 87.94 0 0127.4 28.2c6.9 11.2 12.1 23.8 15.6 37.7 3.3 13.2 5.8 26.6 7.5 40.1 1.8 13.5 2.8 26.6 3 39.4.2 12.4.4 23 .4 31.8.1 14.8-.4 32.5-1.4 53.3z" } }] }, "name": "field-binary", "theme": "outlined" };
var FieldBinaryOutlinedSvg = FieldBinaryOutlined$2;

var FieldBinaryOutlined = function FieldBinaryOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FieldBinaryOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FieldBinaryOutlined.displayName = 'FieldBinaryOutlined';
}
var FieldBinaryOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FieldBinaryOutlined);

// This icon file is generated automatically.
var FieldNumberOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M508 280h-63.3c-3.3 0-6 2.7-6 6v340.2H433L197.4 282.6c-1.1-1.6-3-2.6-4.9-2.6H126c-3.3 0-6 2.7-6 6v464c0 3.3 2.7 6 6 6h62.7c3.3 0 6-2.7 6-6V405.1h5.7l238.2 348.3c1.1 1.6 3 2.6 5 2.6H508c3.3 0 6-2.7 6-6V286c0-3.3-2.7-6-6-6zm378 413H582c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-152.2-63c52.9 0 95.2-17.2 126.2-51.7 29.4-32.9 44-75.8 44-128.8 0-53.1-14.6-96.5-44-129.3-30.9-34.8-73.2-52.2-126.2-52.2-53.7 0-95.9 17.5-126.3 52.8-29.2 33.1-43.4 75.9-43.4 128.7 0 52.4 14.3 95.2 43.5 128.3 30.6 34.7 73 52.2 126.2 52.2zm-71.5-263.7c16.9-20.6 40.3-30.9 71.4-30.9 31.5 0 54.8 9.6 71 29.1 16.4 20.3 24.9 48.6 24.9 84.9 0 36.3-8.4 64.1-24.8 83.9-16.5 19.4-40 29.2-71.1 29.2-31.2 0-55-10.3-71.4-30.4-16.3-20.1-24.5-47.3-24.5-82.6.1-35.8 8.2-63 24.5-83.2z" } }] }, "name": "field-number", "theme": "outlined" };
var FieldNumberOutlinedSvg = FieldNumberOutlined$2;

var FieldNumberOutlined = function FieldNumberOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FieldNumberOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FieldNumberOutlined.displayName = 'FieldNumberOutlined';
}
var FieldNumberOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FieldNumberOutlined);

// This icon file is generated automatically.
var FieldStringOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M875.6 515.9c2.1.8 4.4-.3 5.2-2.4.2-.4.2-.9.2-1.4v-58.3c0-1.8-1.1-3.3-2.8-3.8-6-1.8-17.2-3-27.2-3-32.9 0-61.7 16.7-73.5 41.2v-28.6c0-4.4-3.6-8-8-8H717c-4.4 0-8 3.6-8 8V729c0 4.4 3.6 8 8 8h54.8c4.4 0 8-3.6 8-8V572.7c0-36.2 26.1-60.2 65.1-60.2 10.4.1 26.6 1.8 30.7 3.4zm-537-40.5l-54.7-12.6c-61.2-14.2-87.7-34.8-87.7-70.7 0-44.6 39.1-73.5 96.9-73.5 52.8 0 91.4 26.5 99.9 68.9h70C455.9 311.6 387.6 259 293.4 259c-103.3 0-171 55.5-171 139 0 68.6 38.6 109.5 122.2 128.5l61.6 14.3c63.6 14.9 91.6 37.1 91.6 75.1 0 44.1-43.5 75.2-102.5 75.2-60.6 0-104.5-27.2-112.8-70.5H111c7.2 79.9 75.6 130.4 179.1 130.4C402.3 751 471 695.2 471 605.3c0-70.2-38.6-108.5-132.4-129.9zM841 729a36 36 0 1072 0 36 36 0 10-72 0zM653 457.8h-51.4V396c0-4.4-3.6-8-8-8h-54.7c-4.4 0-8 3.6-8 8v61.8H495c-4.4 0-8 3.6-8 8v42.3c0 4.4 3.6 8 8 8h35.9v147.5c0 56.2 27.4 79.4 93.1 79.4 11.7 0 23.6-1.2 33.8-3.1 1.9-.3 3.2-2 3.2-3.9v-49.3c0-2.2-1.8-4-4-4h-.4c-4.9.5-6.2.6-8.3.8-4.1.3-7.8.5-12.6.5-24.1 0-34.1-10.3-34.1-35.6V516.1H653c4.4 0 8-3.6 8-8v-42.3c0-4.4-3.6-8-8-8z" } }] }, "name": "field-string", "theme": "outlined" };
var FieldStringOutlinedSvg = FieldStringOutlined$2;

var FieldStringOutlined = function FieldStringOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FieldStringOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FieldStringOutlined.displayName = 'FieldStringOutlined';
}
var FieldStringOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FieldStringOutlined);

// This icon file is generated automatically.
var FieldTimeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M945 412H689c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h256c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM811 548H689c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h122c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM477.3 322.5H434c-6.2 0-11.2 5-11.2 11.2v248c0 3.6 1.7 6.9 4.6 9l148.9 108.6c5 3.6 12 2.6 15.6-2.4l25.7-35.1v-.1c3.6-5 2.5-12-2.5-15.6l-126.7-91.6V333.7c.1-6.2-5-11.2-11.1-11.2z" } }, { "tag": "path", "attrs": { "d": "M804.8 673.9H747c-5.6 0-10.9 2.9-13.9 7.7a321 321 0 01-44.5 55.7 317.17 317.17 0 01-101.3 68.3c-39.3 16.6-81 25-124 25-43.1 0-84.8-8.4-124-25-37.9-16-72-39-101.3-68.3s-52.3-63.4-68.3-101.3c-16.6-39.2-25-80.9-25-124 0-43.1 8.4-84.7 25-124 16-37.9 39-72 68.3-101.3 29.3-29.3 63.4-52.3 101.3-68.3 39.2-16.6 81-25 124-25 43.1 0 84.8 8.4 124 25 37.9 16 72 39 101.3 68.3a321 321 0 0144.5 55.7c3 4.8 8.3 7.7 13.9 7.7h57.8c6.9 0 11.3-7.2 8.2-13.3-65.2-129.7-197.4-214-345-215.7-216.1-2.7-395.6 174.2-396 390.1C71.6 727.5 246.9 903 463.2 903c149.5 0 283.9-84.6 349.8-215.8a9.18 9.18 0 00-8.2-13.3z" } }] }, "name": "field-time", "theme": "outlined" };
var FieldTimeOutlinedSvg = FieldTimeOutlined$2;

var FieldTimeOutlined = function FieldTimeOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FieldTimeOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FieldTimeOutlined.displayName = 'FieldTimeOutlined';
}
var FieldTimeOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FieldTimeOutlined);

// This icon file is generated automatically.
var FileAddFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M480 580H372a8 8 0 00-8 8v48a8 8 0 008 8h108v108a8 8 0 008 8h48a8 8 0 008-8V644h108a8 8 0 008-8v-48a8 8 0 00-8-8H544V472a8 8 0 00-8-8h-48a8 8 0 00-8 8v108zm374.6-291.3c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z" } }] }, "name": "file-add", "theme": "filled" };
var FileAddFilledSvg = FileAddFilled$2;

var FileAddFilled = function FileAddFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileAddFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileAddFilled.displayName = 'FileAddFilled';
}
var FileAddFilled$1 = /*#__PURE__*/React__namespace.forwardRef(FileAddFilled);

// This icon file is generated automatically.
var FileAddOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z" } }] }, "name": "file-add", "theme": "outlined" };
var FileAddOutlinedSvg = FileAddOutlined$2;

var FileAddOutlined = function FileAddOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileAddOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileAddOutlined.displayName = 'FileAddOutlined';
}
var FileAddOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FileAddOutlined);

// This icon file is generated automatically.
var FileAddTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm126 236v48c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V644H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V472c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z", "fill": primaryColor } }] }; }, "name": "file-add", "theme": "twotone" };
var FileAddTwoToneSvg = FileAddTwoTone$2;

var FileAddTwoTone = function FileAddTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileAddTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileAddTwoTone.displayName = 'FileAddTwoTone';
}
var FileAddTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(FileAddTwoTone);

// This icon file is generated automatically.
var FileDoneOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm376 116c-119.3 0-216 96.7-216 216s96.7 216 216 216 216-96.7 216-216-96.7-216-216-216zm107.5 323.5C750.8 868.2 712.6 884 672 884s-78.8-15.8-107.5-44.5C535.8 810.8 520 772.6 520 732s15.8-78.8 44.5-107.5C593.2 595.8 631.4 580 672 580s78.8 15.8 107.5 44.5C808.2 653.2 824 691.4 824 732s-15.8 78.8-44.5 107.5zM761 656h-44.3c-2.6 0-5 1.2-6.5 3.3l-63.5 87.8-23.1-31.9a7.92 7.92 0 00-6.5-3.3H573c-6.5 0-10.3 7.4-6.5 12.7l73.8 102.1c3.2 4.4 9.7 4.4 12.9 0l114.2-158c3.9-5.3.1-12.7-6.4-12.7zM440 852H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "file-done", "theme": "outlined" };
var FileDoneOutlinedSvg = FileDoneOutlined$2;

var FileDoneOutlined = function FileDoneOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileDoneOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileDoneOutlined.displayName = 'FileDoneOutlined';
}
var FileDoneOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FileDoneOutlined);

// This icon file is generated automatically.
var FileExcelFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM575.34 477.84l-61.22 102.3L452.3 477.8a12 12 0 00-10.27-5.79h-38.44a12 12 0 00-6.4 1.85 12 12 0 00-3.75 16.56l82.34 130.42-83.45 132.78a12 12 0 00-1.84 6.39 12 12 0 0012 12h34.46a12 12 0 0010.21-5.7l62.7-101.47 62.3 101.45a12 12 0 0010.23 5.72h37.48a12 12 0 006.48-1.9 12 12 0 003.62-16.58l-83.83-130.55 85.3-132.47a12 12 0 001.9-6.5 12 12 0 00-12-12h-35.7a12 12 0 00-10.29 5.84z" } }] }, "name": "file-excel", "theme": "filled" };
var FileExcelFilledSvg = FileExcelFilled$2;

var FileExcelFilled = function FileExcelFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileExcelFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileExcelFilled.displayName = 'FileExcelFilled';
}
var FileExcelFilled$1 = /*#__PURE__*/React__namespace.forwardRef(FileExcelFilled);

// This icon file is generated automatically.
var FileExcelOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0010.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 00-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z" } }] }, "name": "file-excel", "theme": "outlined" };
var FileExcelOutlinedSvg = FileExcelOutlined$2;

var FileExcelOutlined = function FileExcelOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileExcelOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileExcelOutlined.displayName = 'FileExcelOutlined';
}
var FileExcelOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FileExcelOutlined);

// This icon file is generated automatically.
var FileExcelTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm51.6 120h35.7a12.04 12.04 0 0110.1 18.5L546.1 623l84 130.4c3.6 5.6 2 13-3.6 16.6-2 1.2-4.2 1.9-6.5 1.9h-37.5c-4.1 0-8-2.1-10.2-5.7L510 664.8l-62.7 101.5c-2.2 3.5-6 5.7-10.2 5.7h-34.5a12.04 12.04 0 01-10.2-18.4l83.4-132.8-82.3-130.4c-3.6-5.7-1.9-13.1 3.7-16.6 1.9-1.3 4.1-1.9 6.4-1.9H442c4.2 0 8.1 2.2 10.3 5.8l61.8 102.4 61.2-102.3c2.2-3.6 6.1-5.8 10.3-5.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0010.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 00-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z", "fill": primaryColor } }] }; }, "name": "file-excel", "theme": "twotone" };
var FileExcelTwoToneSvg = FileExcelTwoTone$2;

var FileExcelTwoTone = function FileExcelTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileExcelTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileExcelTwoTone.displayName = 'FileExcelTwoTone';
}
var FileExcelTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(FileExcelTwoTone);

// This icon file is generated automatically.
var FileExclamationFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 784a40 40 0 100-80 40 40 0 000 80zm32-152V448a8 8 0 00-8-8h-48a8 8 0 00-8 8v184a8 8 0 008 8h48a8 8 0 008-8z" } }] }, "name": "file-exclamation", "theme": "filled" };
var FileExclamationFilledSvg = FileExclamationFilled$2;

var FileExclamationFilled = function FileExclamationFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileExclamationFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileExclamationFilled.displayName = 'FileExclamationFilled';
}
var FileExclamationFilled$1 = /*#__PURE__*/React__namespace.forwardRef(FileExclamationFilled);

// This icon file is generated automatically.
var FileExclamationOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM472 744a40 40 0 1080 0 40 40 0 10-80 0zm16-104h48c4.4 0 8-3.6 8-8V448c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8z" } }] }, "name": "file-exclamation", "theme": "outlined" };
var FileExclamationOutlinedSvg = FileExclamationOutlined$2;

var FileExclamationOutlined = function FileExclamationOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileExclamationOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileExclamationOutlined.displayName = 'FileExclamationOutlined';
}
var FileExclamationOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FileExclamationOutlined);

// This icon file is generated automatically.
var FileExclamationTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm-54 96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V448zm32 336c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M488 640h48c4.4 0 8-3.6 8-8V448c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm-16 104a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }] }; }, "name": "file-exclamation", "theme": "twotone" };
var FileExclamationTwoToneSvg = FileExclamationTwoTone$2;

var FileExclamationTwoTone = function FileExclamationTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileExclamationTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileExclamationTwoTone.displayName = 'FileExclamationTwoTone';
}
var FileExclamationTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(FileExclamationTwoTone);

// This icon file is generated automatically.
var FileFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z" } }] }, "name": "file", "theme": "filled" };
var FileFilledSvg = FileFilled$2;

var FileFilled = function FileFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileFilled.displayName = 'FileFilled';
}
var FileFilled$1 = /*#__PURE__*/React__namespace.forwardRef(FileFilled);

// This icon file is generated automatically.
var FileGifOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M551.5 490.5H521c-4.6 0-8.4 3.7-8.4 8.4V720c0 4.6 3.7 8.4 8.4 8.4h30.5c4.6 0 8.4-3.7 8.4-8.4V498.9c-.1-4.6-3.8-8.4-8.4-8.4zM477.3 600h-88.1c-4.6 0-8.4 3.7-8.4 8.4v23.8c0 4.6 3.7 8.4 8.4 8.4h47.6v.7c-.6 29.9-23 49.8-56.5 49.8-39.2 0-63.6-30.7-63.6-81.4 0-50.1 23.9-80.6 62.3-80.6 28.1 0 47.5 13.5 55.4 38.3l.9 2.8h49.2l-.7-4.6C475.9 515.9 434.7 484 379 484c-68.8 0-113 49.4-113 125.9 0 77.5 43.7 126.1 113.6 126.1 64.4 0 106-40.3 106-102.9v-24.8c0-4.6-3.7-8.3-8.3-8.3z" } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z" } }, { "tag": "path", "attrs": { "d": "M608.2 727.8h32.3c4.6 0 8.4-3.7 8.4-8.4v-84.8h87.8c4.6 0 8.4-3.7 8.4-8.4v-25.5c0-4.6-3.7-8.4-8.4-8.4h-87.8v-58.9h96.8c4.6 0 8.4-3.7 8.4-8.4v-26.8c0-4.6-3.7-8.4-8.4-8.4H608.2c-4.6 0-8.4 3.7-8.4 8.4v221.1c0 4.8 3.8 8.5 8.4 8.5z" } }] }, "name": "file-gif", "theme": "outlined" };
var FileGifOutlinedSvg = FileGifOutlined$2;

var FileGifOutlined = function FileGifOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileGifOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileGifOutlined.displayName = 'FileGifOutlined';
}
var FileGifOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FileGifOutlined);

// This icon file is generated automatically.
var FileImageFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM400 402c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm296 294H328c-6.7 0-10.4-7.7-6.3-12.9l99.8-127.2a8 8 0 0112.6 0l41.1 52.4 77.8-99.2a8 8 0 0112.6 0l136.5 174c4.3 5.2.5 12.9-6.1 12.9zm-94-370V137.8L790.2 326H602z" } }] }, "name": "file-image", "theme": "filled" };
var FileImageFilledSvg = FileImageFilled$2;

var FileImageFilled = function FileImageFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileImageFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileImageFilled.displayName = 'FileImageFilled';
}
var FileImageFilled$1 = /*#__PURE__*/React__namespace.forwardRef(FileImageFilled);

// This icon file is generated automatically.
var FileImageOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M553.1 509.1l-77.8 99.2-41.1-52.4a8 8 0 00-12.6 0l-99.8 127.2a7.98 7.98 0 006.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174a8.1 8.1 0 00-12.7 0zM360 442a40 40 0 1080 0 40 40 0 10-80 0zm494.6-153.4L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] }, "name": "file-image", "theme": "outlined" };
var FileImageOutlinedSvg = FileImageOutlined$2;

var FileImageOutlined = function FileImageOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileImageOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileImageOutlined.displayName = 'FileImageOutlined';
}
var FileImageOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FileImageOutlined);

// This icon file is generated automatically.
var FileImageTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm-134 50c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm296 294H328.1c-6.7 0-10.4-7.7-6.3-12.9l99.8-127.2a8 8 0 0112.6 0l41.1 52.4 77.8-99.2a8.1 8.1 0 0112.7 0l136.5 174c4.1 5.2.4 12.9-6.3 12.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M553.1 509.1l-77.8 99.2-41.1-52.4a8 8 0 00-12.6 0l-99.8 127.2a7.98 7.98 0 006.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174a8.1 8.1 0 00-12.7 0zM360 442a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }] }; }, "name": "file-image", "theme": "twotone" };
var FileImageTwoToneSvg = FileImageTwoTone$2;

var FileImageTwoTone = function FileImageTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileImageTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileImageTwoTone.displayName = 'FileImageTwoTone';
}
var FileImageTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(FileImageTwoTone);

// This icon file is generated automatically.
var FileJpgOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M874.6 301.8L596.8 21.3c-4.5-4.5-9.4-8.3-14.7-11.5-1.4-.8-2.8-1.6-4.3-2.3-.9-.5-1.9-.9-2.8-1.3-9-4-18.9-6.2-29-6.2H201c-39.8 0-73 32.2-73 72v880c0 39.8 33.2 72 73 72h623c39.8 0 71-32.2 71-72V352.5c0-19-7-37.2-20.4-50.7zM583 110.4L783.8 312H583V110.4zM823 952H200V72h311v240c0 39.8 33.2 72 73 72h239v568zM350 696.5c0 24.2-7.5 31.4-21.9 31.4-9 0-18.4-5.8-24.8-18.5L272.9 732c13.4 22.9 32.3 34.2 61.3 34.2 41.6 0 60.8-29.9 60.8-66.2V577h-45v119.5zM501.3 577H437v186h44v-62h21.6c39.1 0 73.1-19.6 73.1-63.6 0-45.8-33.5-60.4-74.4-60.4zm-.8 89H481v-53h18.2c21.5 0 33.4 6.2 33.4 24.9 0 18.1-10.5 28.1-32.1 28.1zm182.5-9v36h30v30.1c-4 2.9-11 4.7-17.7 4.7-34.3 0-50.7-21.4-50.7-58.2 0-36.1 19.7-57.4 47.1-57.4 15.3 0 25 6.2 34 14.4l23.7-28.3c-12.7-12.8-32.1-24.2-59.2-24.2-49.6 0-91.1 35.3-91.1 97 0 62.7 40 95.1 91.5 95.1 25.9 0 49.2-10.2 61.5-22.6V657H683z" } }] }, "name": "file-jpg", "theme": "outlined" };
var FileJpgOutlinedSvg = FileJpgOutlined$2;

var FileJpgOutlined = function FileJpgOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileJpgOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileJpgOutlined.displayName = 'FileJpgOutlined';
}
var FileJpgOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FileJpgOutlined);

// This icon file is generated automatically.
var FileMarkdownFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM426.13 600.93l59.11 132.97a16 16 0 0014.62 9.5h24.06a16 16 0 0014.63-9.51l59.1-133.35V758a16 16 0 0016.01 16H641a16 16 0 0016-16V486a16 16 0 00-16-16h-34.75a16 16 0 00-14.67 9.62L512.1 662.2l-79.48-182.59a16 16 0 00-14.67-9.61H383a16 16 0 00-16 16v272a16 16 0 0016 16h27.13a16 16 0 0016-16V600.93z" } }] }, "name": "file-markdown", "theme": "filled" };
var FileMarkdownFilledSvg = FileMarkdownFilled$2;

var FileMarkdownFilled = function FileMarkdownFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileMarkdownFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileMarkdownFilled.displayName = 'FileMarkdownFilled';
}
var FileMarkdownFilled$1 = /*#__PURE__*/React__namespace.forwardRef(FileMarkdownFilled);

// This icon file is generated automatically.
var FileMarkdownOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM429 481.2c-1.9-4.4-6.2-7.2-11-7.2h-35c-6.6 0-12 5.4-12 12v272c0 6.6 5.4 12 12 12h27.1c6.6 0 12-5.4 12-12V582.1l66.8 150.2a12 12 0 0011 7.1H524c4.7 0 9-2.8 11-7.1l66.8-150.6V758c0 6.6 5.4 12 12 12H641c6.6 0 12-5.4 12-12V486c0-6.6-5.4-12-12-12h-34.7c-4.8 0-9.1 2.8-11 7.2l-83.1 191-83.2-191z" } }] }, "name": "file-markdown", "theme": "outlined" };
var FileMarkdownOutlinedSvg = FileMarkdownOutlined$2;

var FileMarkdownOutlined = function FileMarkdownOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileMarkdownOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileMarkdownOutlined.displayName = 'FileMarkdownOutlined';
}
var FileMarkdownOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FileMarkdownOutlined);

// This icon file is generated automatically.
var FileMarkdownTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm72.3 122H641c6.6 0 12 5.4 12 12v272c0 6.6-5.4 12-12 12h-27.2c-6.6 0-12-5.4-12-12V581.7L535 732.3c-2 4.3-6.3 7.1-11 7.1h-24.1a12 12 0 01-11-7.1l-66.8-150.2V758c0 6.6-5.4 12-12 12H383c-6.6 0-12-5.4-12-12V486c0-6.6 5.4-12 12-12h35c4.8 0 9.1 2.8 11 7.2l83.2 191 83.1-191c1.9-4.4 6.2-7.2 11-7.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M429 481.2c-1.9-4.4-6.2-7.2-11-7.2h-35c-6.6 0-12 5.4-12 12v272c0 6.6 5.4 12 12 12h27.1c6.6 0 12-5.4 12-12V582.1l66.8 150.2a12 12 0 0011 7.1H524c4.7 0 9-2.8 11-7.1l66.8-150.6V758c0 6.6 5.4 12 12 12H641c6.6 0 12-5.4 12-12V486c0-6.6-5.4-12-12-12h-34.7c-4.8 0-9.1 2.8-11 7.2l-83.1 191-83.2-191z", "fill": primaryColor } }] }; }, "name": "file-markdown", "theme": "twotone" };
var FileMarkdownTwoToneSvg = FileMarkdownTwoTone$2;

var FileMarkdownTwoTone = function FileMarkdownTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileMarkdownTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileMarkdownTwoTone.displayName = 'FileMarkdownTwoTone';
}
var FileMarkdownTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(FileMarkdownTwoTone);

// This icon file is generated automatically.
var FileOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] }, "name": "file", "theme": "outlined" };
var FileOutlinedSvg = FileOutlined$2;

var FileOutlined = function FileOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileOutlined.displayName = 'FileOutlined';
}
var FileOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FileOutlined);

// This icon file is generated automatically.
var FilePdfFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM633.22 637.26c-15.18-.5-31.32.67-49.65 2.96-24.3-14.99-40.66-35.58-52.28-65.83l1.07-4.38 1.24-5.18c4.3-18.13 6.61-31.36 7.3-44.7.52-10.07-.04-19.36-1.83-27.97-3.3-18.59-16.45-29.46-33.02-30.13-15.45-.63-29.65 8-33.28 21.37-5.91 21.62-2.45 50.07 10.08 98.59-15.96 38.05-37.05 82.66-51.2 107.54-18.89 9.74-33.6 18.6-45.96 28.42-16.3 12.97-26.48 26.3-29.28 40.3-1.36 6.49.69 14.97 5.36 21.92 5.3 7.88 13.28 13 22.85 13.74 24.15 1.87 53.83-23.03 86.6-79.26 3.29-1.1 6.77-2.26 11.02-3.7l11.9-4.02c7.53-2.54 12.99-4.36 18.39-6.11 23.4-7.62 41.1-12.43 57.2-15.17 27.98 14.98 60.32 24.8 82.1 24.8 17.98 0 30.13-9.32 34.52-23.99 3.85-12.88.8-27.82-7.48-36.08-8.56-8.41-24.3-12.43-45.65-13.12zM385.23 765.68v-.36l.13-.34a54.86 54.86 0 015.6-10.76c4.28-6.58 10.17-13.5 17.47-20.87 3.92-3.95 8-7.8 12.79-12.12 1.07-.96 7.91-7.05 9.19-8.25l11.17-10.4-8.12 12.93c-12.32 19.64-23.46 33.78-33 43-3.51 3.4-6.6 5.9-9.1 7.51a16.43 16.43 0 01-2.61 1.42c-.41.17-.77.27-1.13.3a2.2 2.2 0 01-1.12-.15 2.07 2.07 0 01-1.27-1.91zM511.17 547.4l-2.26 4-1.4-4.38c-3.1-9.83-5.38-24.64-6.01-38-.72-15.2.49-24.32 5.29-24.32 6.74 0 9.83 10.8 10.07 27.05.22 14.28-2.03 29.14-5.7 35.65zm-5.81 58.46l1.53-4.05 2.09 3.8c11.69 21.24 26.86 38.96 43.54 51.31l3.6 2.66-4.39.9c-16.33 3.38-31.54 8.46-52.34 16.85 2.17-.88-21.62 8.86-27.64 11.17l-5.25 2.01 2.8-4.88c12.35-21.5 23.76-47.32 36.05-79.77zm157.62 76.26c-7.86 3.1-24.78.33-54.57-12.39l-7.56-3.22 8.2-.6c23.3-1.73 39.8-.45 49.42 3.07 4.1 1.5 6.83 3.39 8.04 5.55a4.64 4.64 0 01-1.36 6.31 6.7 6.7 0 01-2.17 1.28z" } }] }, "name": "file-pdf", "theme": "filled" };
var FilePdfFilledSvg = FilePdfFilled$2;

var FilePdfFilled = function FilePdfFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FilePdfFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FilePdfFilled.displayName = 'FilePdfFilled';
}
var FilePdfFilled$1 = /*#__PURE__*/React__namespace.forwardRef(FilePdfFilled);

// This icon file is generated automatically.
var FilePdfOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M531.3 574.4l.3-1.4c5.8-23.9 13.1-53.7 7.4-80.7-3.8-21.3-19.5-29.6-32.9-30.2-15.8-.7-29.9 8.3-33.4 21.4-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.5-51.2 107.5-29.6 15.3-69.3 38.9-75.2 68.7-1.2 5.5.2 12.5 3.5 18.8 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-13.2-13-45.3-16.4-95.3-10.2-24.6-15-40.7-35.4-52.4-65.8zM421.6 726.3c-13.9 20.2-24.4 30.3-30.1 34.7 6.7-12.3 19.8-25.3 30.1-34.7zm87.6-235.5c5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4.8.1 1.5.7 2.2 2zm-1.6 120.5c10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4zm155.6 65.5c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4zm191.4-388.2L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] }, "name": "file-pdf", "theme": "outlined" };
var FilePdfOutlinedSvg = FilePdfOutlined$2;

var FilePdfOutlined = function FilePdfOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FilePdfOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FilePdfOutlined.displayName = 'FilePdfOutlined';
}
var FilePdfOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FilePdfOutlined);

// This icon file is generated automatically.
var FilePdfTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M509.2 490.8c-.7-1.3-1.4-1.9-2.2-2-2.9 3.3-2.2 31.5 2.7 51.4 4-13.6 4.7-40.5-.5-49.4zm-1.6 120.5c-7.7 20-18.8 47.3-32.1 71.4 4-1.6 8.1-3.3 12.3-5 17.6-7.2 37.3-15.3 58.9-20.2-14.9-11.8-28.4-27.7-39.1-46.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm55 287.6c16.1-1.9 30.6-2.8 44.3-2.3 12.8.4 23.6 2 32 5.1.2.1.3.1.5.2.4.2.8.3 1.2.5.5.2 1.1.4 1.6.7.1.1.3.1.4.2 4.1 1.8 7.5 4 10.1 6.6 9.1 9.1 11.8 26.1 6.2 39.6-3.2 7.7-11.7 20.5-33.3 20.5-21.8 0-53.9-9.7-82.1-24.8-25.5 4.3-53.7 13.9-80.9 23.1-5.8 2-11.8 4-17.6 5.9-38 65.2-66.5 79.4-84.1 79.4-4.2 0-7.8-.9-10.8-2-6.9-2.6-12.8-8-16.5-15-.9-1.7-1.6-3.4-2.2-5.2-1.6-4.8-2.1-9.6-1.3-13.6l.6-2.7c.1-.2.1-.4.2-.6.2-.7.4-1.4.7-2.1 0-.1.1-.2.1-.3 4.1-11.9 13.6-23.4 27.7-34.6 12.3-9.8 27.1-18.7 45.9-28.4 15.9-28 37.6-75.1 51.2-107.4-10.8-41.8-16.7-74.6-10.1-98.6.9-3.3 2.5-6.4 4.6-9.1.2-.2.3-.4.5-.6.1-.1.1-.2.2-.2 6.3-7.5 16.9-11.9 28.1-11.5 16.6.7 29.7 11.5 33 30.1 1.7 8 2.2 16.5 1.9 25.7v.7c0 .5 0 1-.1 1.5-.7 13.3-3 26.6-7.3 44.7-.4 1.6-.8 3.2-1.2 5.2l-1 4.1-.1.3c.1.2.1.3.2.5l1.8 4.5c.1.3.3.7.4 1 .7 1.6 1.4 3.3 2.1 4.8v.1c8.7 18.8 19.7 33.4 33.9 45.1 4.3 3.5 8.9 6.7 13.9 9.8 1.8-.5 3.5-.7 5.3-.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M391.5 761c5.7-4.4 16.2-14.5 30.1-34.7-10.3 9.4-23.4 22.4-30.1 34.7zm270.9-83l.2-.3h.2c.6-.4.5-.7.4-.9-.1-.1-4.5-9.3-45.1-7.4 35.3 13.9 43.5 9.1 44.3 8.6z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M535.9 585.3c-.8-1.7-1.5-3.3-2.2-4.9-.1-.3-.3-.7-.4-1l-1.8-4.5c-.1-.2-.1-.3-.2-.5l.1-.3.2-1.1c4-16.3 8.6-35.3 9.4-54.4v-.7c.3-8.6-.2-17.2-2-25.6-3.8-21.3-19.5-29.6-32.9-30.2-11.3-.5-21.8 4-28.1 11.4-.1.1-.1.2-.2.2-.2.2-.4.4-.5.6-2.1 2.7-3.7 5.8-4.6 9.1-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.4-51.2 107.4v.1c-27.7 14.3-64.1 35.8-73.6 62.9 0 .1-.1.2-.1.3-.2.7-.5 1.4-.7 2.1-.1.2-.1.4-.2.6-.2.9-.5 1.8-.6 2.7-.9 4-.4 8.8 1.3 13.6.6 1.8 1.3 3.5 2.2 5.2 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-2.6-2.6-6-4.8-10.1-6.6-.1-.1-.3-.1-.4-.2-.5-.2-1.1-.4-1.6-.7-.4-.2-.8-.3-1.2-.5-.2-.1-.3-.1-.5-.2-16.2-5.8-41.7-6.7-76.3-2.8l-5.3.6c-5-3-9.6-6.3-13.9-9.8-14.2-11.3-25.1-25.8-33.8-44.7zM391.5 761c6.7-12.3 19.8-25.3 30.1-34.7-13.9 20.2-24.4 30.3-30.1 34.7zM507 488.8c.8.1 1.5.7 2.2 2 5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4zm-19.2 188.9c-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4 10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2zm175.4-.9c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4z", "fill": primaryColor } }] }; }, "name": "file-pdf", "theme": "twotone" };
var FilePdfTwoToneSvg = FilePdfTwoTone$2;

var FilePdfTwoTone = function FilePdfTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FilePdfTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FilePdfTwoTone.displayName = 'FilePdfTwoTone';
}
var FilePdfTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(FilePdfTwoTone);

// This icon file is generated automatically.
var FilePptFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM468.53 760v-91.54h59.27c60.57 0 100.2-39.65 100.2-98.12 0-58.22-39.58-98.34-99.98-98.34H424a12 12 0 00-12 12v276a12 12 0 0012 12h32.53a12 12 0 0012-12zm0-139.33h34.9c47.82 0 67.19-12.93 67.19-50.33 0-32.05-18.12-50.12-49.87-50.12h-52.22v100.45z" } }] }, "name": "file-ppt", "theme": "filled" };
var FilePptFilledSvg = FilePptFilled$2;

var FilePptFilled = function FilePptFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FilePptFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FilePptFilled.displayName = 'FilePptFilled';
}
var FilePptFilled$1 = /*#__PURE__*/React__namespace.forwardRef(FilePptFilled);

// This icon file is generated automatically.
var FilePptOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M424 476c-4.4 0-8 3.6-8 8v276c0 4.4 3.6 8 8 8h32.5c4.4 0 8-3.6 8-8v-95.5h63.3c59.4 0 96.2-38.9 96.2-94.1 0-54.5-36.3-94.3-96-94.3H424zm150.6 94.3c0 43.4-26.5 54.3-71.2 54.3h-38.9V516.2h56.2c33.8 0 53.9 19.7 53.9 54.1zm280-281.7L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] }, "name": "file-ppt", "theme": "outlined" };
var FilePptOutlinedSvg = FilePptOutlined$2;

var FilePptOutlined = function FilePptOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FilePptOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FilePptOutlined.displayName = 'FilePptOutlined';
}
var FilePptOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FilePptOutlined);

// This icon file is generated automatically.
var FilePptTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M464.5 516.2v108.4h38.9c44.7 0 71.2-10.9 71.2-54.3 0-34.4-20.1-54.1-53.9-54.1h-56.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm90 218.4c0 55.2-36.8 94.1-96.2 94.1h-63.3V760c0 4.4-3.6 8-8 8H424c-4.4 0-8-3.6-8-8V484c0-4.4 3.6-8 8-8v.1h104c59.7 0 96 39.8 96 94.3z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M424 476.1c-4.4-.1-8 3.5-8 7.9v276c0 4.4 3.6 8 8 8h32.5c4.4 0 8-3.6 8-8v-95.5h63.3c59.4 0 96.2-38.9 96.2-94.1 0-54.5-36.3-94.3-96-94.3H424zm150.6 94.2c0 43.4-26.5 54.3-71.2 54.3h-38.9V516.2h56.2c33.8 0 53.9 19.7 53.9 54.1z", "fill": primaryColor } }] }; }, "name": "file-ppt", "theme": "twotone" };
var FilePptTwoToneSvg = FilePptTwoTone$2;

var FilePptTwoTone = function FilePptTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FilePptTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FilePptTwoTone.displayName = 'FilePptTwoTone';
}
var FilePptTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(FilePptTwoTone);

// This icon file is generated automatically.
var FileProtectOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M644.7 669.2a7.92 7.92 0 00-6.5-3.3H594c-6.5 0-10.3 7.4-6.5 12.7l73.8 102.1c3.2 4.4 9.7 4.4 12.9 0l114.2-158c3.8-5.3 0-12.7-6.5-12.7h-44.3c-2.6 0-5 1.2-6.5 3.3l-63.5 87.8-22.9-31.9zM688 306v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm184 458H208V148h560v296c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h312c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm402.6-320.8l-192-66.7c-.9-.3-1.7-.4-2.6-.4s-1.8.1-2.6.4l-192 66.7a7.96 7.96 0 00-5.4 7.5v251.1c0 2.5 1.1 4.8 3.1 6.3l192 150.2c1.4 1.1 3.2 1.7 4.9 1.7s3.5-.6 4.9-1.7l192-150.2c1.9-1.5 3.1-3.8 3.1-6.3V538.7c0-3.4-2.2-6.4-5.4-7.5zM826 763.7L688 871.6 550 763.7V577l138-48 138 48v186.7z" } }] }, "name": "file-protect", "theme": "outlined" };
var FileProtectOutlinedSvg = FileProtectOutlined$2;

var FileProtectOutlined = function FileProtectOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileProtectOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileProtectOutlined.displayName = 'FileProtectOutlined';
}
var FileProtectOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FileProtectOutlined);

// This icon file is generated automatically.
var FileSearchOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm144 452H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm445.7 51.5l-93.3-93.3C814.7 780.7 828 743.9 828 704c0-97.2-78.8-176-176-176s-176 78.8-176 176 78.8 176 176 176c35.8 0 69-10.7 96.8-29l94.7 94.7c1.6 1.6 3.6 2.3 5.6 2.3s4.1-.8 5.6-2.3l31-31a7.9 7.9 0 000-11.2zM652 816c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, "name": "file-search", "theme": "outlined" };
var FileSearchOutlinedSvg = FileSearchOutlined$2;

var FileSearchOutlined = function FileSearchOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileSearchOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileSearchOutlined.displayName = 'FileSearchOutlined';
}
var FileSearchOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FileSearchOutlined);

// This icon file is generated automatically.
var FileSyncOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M296 256c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm192 200v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8zm-48 396H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm104.1-115.6c1.8-34.5 16.2-66.8 40.8-91.4 26.2-26.2 62-41 99.1-41 37.4 0 72.6 14.6 99.1 41 3.2 3.2 6.3 6.6 9.2 10.1L769.2 673a8 8 0 003 14.1l93.3 22.5c5 1.2 9.8-2.6 9.9-7.7l.6-95.4a8 8 0 00-12.9-6.4l-20.3 15.8C805.4 569.6 748.1 540 684 540c-109.9 0-199.6 86.9-204 195.7-.2 4.5 3.5 8.3 8 8.3h48.1c4.3 0 7.8-3.3 8-7.6zM880 744h-48.1c-4.3 0-7.8 3.3-8 7.6-1.8 34.5-16.2 66.8-40.8 91.4-26.2 26.2-62 41-99.1 41-37.4 0-72.6-14.6-99.1-41-3.2-3.2-6.3-6.6-9.2-10.1l23.1-17.9a8 8 0 00-3-14.1l-93.3-22.5c-5-1.2-9.8 2.6-9.9 7.7l-.6 95.4a8 8 0 0012.9 6.4l20.3-15.8C562.6 918.4 619.9 948 684 948c109.9 0 199.6-86.9 204-195.7.2-4.5-3.5-8.3-8-8.3z" } }] }, "name": "file-sync", "theme": "outlined" };
var FileSyncOutlinedSvg = FileSyncOutlined$2;

var FileSyncOutlined = function FileSyncOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileSyncOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileSyncOutlined.displayName = 'FileSyncOutlined';
}
var FileSyncOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FileSyncOutlined);

// This icon file is generated automatically.
var FileTextFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM320 482a8 8 0 00-8 8v48a8 8 0 008 8h384a8 8 0 008-8v-48a8 8 0 00-8-8H320zm0 136a8 8 0 00-8 8v48a8 8 0 008 8h184a8 8 0 008-8v-48a8 8 0 00-8-8H320z" } }] }, "name": "file-text", "theme": "filled" };
var FileTextFilledSvg = FileTextFilled$2;

var FileTextFilled = function FileTextFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileTextFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileTextFilled.displayName = 'FileTextFilled';
}
var FileTextFilled$1 = /*#__PURE__*/React__namespace.forwardRef(FileTextFilled);

// This icon file is generated automatically.
var FileTextOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM504 618H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8z" } }] }, "name": "file-text", "theme": "outlined" };
var FileTextOutlinedSvg = FileTextOutlined$2;

var FileTextOutlined = function FileTextOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileTextOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileTextOutlined.displayName = 'FileTextOutlined';
}
var FileTextOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FileTextOutlined);

// This icon file is generated automatically.
var FileTextTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm-22 322c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm200-184v48c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8zm192 128H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "file-text", "theme": "twotone" };
var FileTextTwoToneSvg = FileTextTwoTone$2;

var FileTextTwoTone = function FileTextTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileTextTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileTextTwoTone.displayName = 'FileTextTwoTone';
}
var FileTextTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(FileTextTwoTone);

// This icon file is generated automatically.
var FileTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }] }; }, "name": "file", "theme": "twotone" };
var FileTwoToneSvg = FileTwoTone$2;

var FileTwoTone = function FileTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileTwoTone.displayName = 'FileTwoTone';
}
var FileTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(FileTwoTone);

// This icon file is generated automatically.
var FileUnknownFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM402 549c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103zm110 227a32 32 0 100-64 32 32 0 000 64z" } }] }, "name": "file-unknown", "theme": "filled" };
var FileUnknownFilledSvg = FileUnknownFilled$2;

var FileUnknownFilled = function FileUnknownFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileUnknownFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileUnknownFilled.displayName = 'FileUnknownFilled';
}
var FileUnknownFilled$1 = /*#__PURE__*/React__namespace.forwardRef(FileUnknownFilled);

// This icon file is generated automatically.
var FileUnknownOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM402 549c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103zm78 195a32 32 0 1064 0 32 32 0 10-64 0z" } }] }, "name": "file-unknown", "theme": "outlined" };
var FileUnknownOutlinedSvg = FileUnknownOutlined$2;

var FileUnknownOutlined = function FileUnknownOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileUnknownOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileUnknownOutlined.displayName = 'FileUnknownOutlined';
}
var FileUnknownOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FileUnknownOutlined);

// This icon file is generated automatically.
var FileUnknownTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm-22 424c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm110-228.4c.7 44.9-29.7 84.5-74.3 98.9-5.7 1.8-9.7 7.3-9.7 13.3V672c0 5.5-4.5 10-10 10h-32c-5.5 0-10-4.5-10-10v-32c.2-19.8 15.4-37.3 34.7-40.1C549 596.2 570 574.3 570 549c0-28.1-25.8-51.5-58-51.5s-58 23.4-58 51.6c0 5.2-4.4 9.4-9.8 9.4h-32.4c-5.4 0-9.8-4.1-9.8-9.5 0-57.4 50.1-103.7 111.5-103 59.3.8 107.7 46.1 108.5 101.6z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M480 744a32 32 0 1064 0 32 32 0 10-64 0zm-78-195c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103z", "fill": primaryColor } }] }; }, "name": "file-unknown", "theme": "twotone" };
var FileUnknownTwoToneSvg = FileUnknownTwoTone$2;

var FileUnknownTwoTone = function FileUnknownTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileUnknownTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileUnknownTwoTone.displayName = 'FileUnknownTwoTone';
}
var FileUnknownTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(FileUnknownTwoTone);

// This icon file is generated automatically.
var FileWordFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 566.1l52.81 197a12 12 0 0011.6 8.9h31.77a12 12 0 0011.6-8.88l74.37-276a12 12 0 00.4-3.12 12 12 0 00-12-12h-35.57a12 12 0 00-11.7 9.31l-45.78 199.1-49.76-199.32A12 12 0 00528.1 472h-32.2a12 12 0 00-11.64 9.1L434.6 680.01 388.5 481.3a12 12 0 00-11.68-9.29h-35.39a12 12 0 00-3.11.41 12 12 0 00-8.47 14.7l74.17 276A12 12 0 00415.6 772h31.99a12 12 0 0011.59-8.9l52.81-197z" } }] }, "name": "file-word", "theme": "filled" };
var FileWordFilledSvg = FileWordFilled$2;

var FileWordFilled = function FileWordFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileWordFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileWordFilled.displayName = 'FileWordFilled';
}
var FileWordFilled$1 = /*#__PURE__*/React__namespace.forwardRef(FileWordFilled);

// This icon file is generated automatically.
var FileWordOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM528.1 472h-32.2c-5.5 0-10.3 3.7-11.6 9.1L434.6 680l-46.1-198.7c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4a12.02 12.02 0 00-11.6 15.1l74.2 276c1.4 5.2 6.2 8.9 11.6 8.9h32c5.4 0 10.2-3.6 11.6-8.9l52.8-197 52.8 197c1.4 5.2 6.2 8.9 11.6 8.9h31.8c5.4 0 10.2-3.6 11.6-8.9l74.4-276a12.04 12.04 0 00-11.6-15.1H647c-5.6 0-10.4 3.9-11.7 9.3l-45.8 199.1-49.8-199.3c-1.3-5.4-6.1-9.1-11.6-9.1z" } }] }, "name": "file-word", "theme": "outlined" };
var FileWordOutlinedSvg = FileWordOutlined$2;

var FileWordOutlined = function FileWordOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileWordOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileWordOutlined.displayName = 'FileWordOutlined';
}
var FileWordOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FileWordOutlined);

// This icon file is generated automatically.
var FileWordTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm101.3 129.3c1.3-5.4 6.1-9.3 11.7-9.3h35.6a12.04 12.04 0 0111.6 15.1l-74.4 276c-1.4 5.3-6.2 8.9-11.6 8.9h-31.8c-5.4 0-10.2-3.7-11.6-8.9l-52.8-197-52.8 197c-1.4 5.3-6.2 8.9-11.6 8.9h-32c-5.4 0-10.2-3.7-11.6-8.9l-74.2-276a12.02 12.02 0 0111.6-15.1h35.4c5.6 0 10.4 3.9 11.7 9.3L434.6 680l49.7-198.9c1.3-5.4 6.1-9.1 11.6-9.1h32.2c5.5 0 10.3 3.7 11.6 9.1l49.8 199.3 45.8-199.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M528.1 472h-32.2c-5.5 0-10.3 3.7-11.6 9.1L434.6 680l-46.1-198.7c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4a12.02 12.02 0 00-11.6 15.1l74.2 276c1.4 5.2 6.2 8.9 11.6 8.9h32c5.4 0 10.2-3.6 11.6-8.9l52.8-197 52.8 197c1.4 5.2 6.2 8.9 11.6 8.9h31.8c5.4 0 10.2-3.6 11.6-8.9l74.4-276a12.04 12.04 0 00-11.6-15.1H647c-5.6 0-10.4 3.9-11.7 9.3l-45.8 199.1-49.8-199.3c-1.3-5.4-6.1-9.1-11.6-9.1z", "fill": primaryColor } }] }; }, "name": "file-word", "theme": "twotone" };
var FileWordTwoToneSvg = FileWordTwoTone$2;

var FileWordTwoTone = function FileWordTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileWordTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileWordTwoTone.displayName = 'FileWordTwoTone';
}
var FileWordTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(FileWordTwoTone);

// This icon file is generated automatically.
var FileZipFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM296 136v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm0 64v160h128V584H296zm48 48h32v64h-32v-64z" } }] }, "name": "file-zip", "theme": "filled" };
var FileZipFilledSvg = FileZipFilled$2;

var FileZipFilled = function FileZipFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileZipFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileZipFilled.displayName = 'FileZipFilled';
}
var FileZipFilled$1 = /*#__PURE__*/React__namespace.forwardRef(FileZipFilled);

// This icon file is generated automatically.
var FileZipOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M296 392h64v64h-64zm0 190v160h128V582h-64v-62h-64v62zm80 48v64h-32v-64h32zm-16-302h64v64h-64zm-64-64h64v64h-64zm64 192h64v64h-64zm0-256h64v64h-64zm494.6 88.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h64v64h64v-64h174v216a42 42 0 0042 42h216v494z" } }] }, "name": "file-zip", "theme": "outlined" };
var FileZipOutlinedSvg = FileZipOutlined$2;

var FileZipOutlined = function FileZipOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileZipOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileZipOutlined.displayName = 'FileZipOutlined';
}
var FileZipOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FileZipOutlined);

// This icon file is generated automatically.
var FileZipTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M344 630h32v2h-32z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M534 352V136H360v64h64v64h-64v64h64v64h-64v64h64v64h-64v62h64v160H296V520h64v-64h-64v-64h64v-64h-64v-64h64v-64h-64v-64h-64v752h560V394H576a42 42 0 01-42-42z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h64v64h64v-64h174v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M296 392h64v64h-64zm0-128h64v64h-64zm0 318v160h128V582h-64v-62h-64v62zm48 50v-2h32v64h-32v-62zm16-432h64v64h-64zm0 256h64v64h-64zm0-128h64v64h-64z", "fill": primaryColor } }] }; }, "name": "file-zip", "theme": "twotone" };
var FileZipTwoToneSvg = FileZipTwoTone$2;

var FileZipTwoTone = function FileZipTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileZipTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FileZipTwoTone.displayName = 'FileZipTwoTone';
}
var FileZipTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(FileZipTwoTone);

// This icon file is generated automatically.
var FilterFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z" } }] }, "name": "filter", "theme": "filled" };
var FilterFilledSvg = FilterFilled$2;

var FilterFilled = function FilterFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FilterFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FilterFilled.displayName = 'FilterFilled';
}
var FilterFilled$1 = /*#__PURE__*/React__namespace.forwardRef(FilterFilled);

// This icon file is generated automatically.
var FilterOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V642h182.9v156zm9.6-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z" } }] }, "name": "filter", "theme": "outlined" };
var FilterOutlinedSvg = FilterOutlined$2;

var FilterOutlined = function FilterOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FilterOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FilterOutlined.displayName = 'FilterOutlined';
}
var FilterOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FilterOutlined);

// This icon file is generated automatically.
var FilterTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M420.6 798h182.9V642H420.6zM411 561.4l9.5 16.6h183l9.5-16.6L811.3 226H212.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.5 798H420.6V642h182.9v156zm9.5-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z", "fill": primaryColor } }] }; }, "name": "filter", "theme": "twotone" };
var FilterTwoToneSvg = FilterTwoTone$2;

var FilterTwoTone = function FilterTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FilterTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FilterTwoTone.displayName = 'FilterTwoTone';
}
var FilterTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(FilterTwoTone);

// This icon file is generated automatically.
var FireFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M834.1 469.2A347.49 347.49 0 00751.2 354l-29.1-26.7a8.09 8.09 0 00-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 01-47.5 46.1 352.6 352.6 0 00-100.3 121.5A347.75 347.75 0 00160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0075.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 00760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0027.7-136c0-48.8-10-96.2-29.9-140.9z" } }] }, "name": "fire", "theme": "filled" };
var FireFilledSvg = FireFilled$2;

var FireFilled = function FireFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FireFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FireFilled.displayName = 'FireFilled';
}
var FireFilled$1 = /*#__PURE__*/React__namespace.forwardRef(FireFilled);

// This icon file is generated automatically.
var FireOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M834.1 469.2A347.49 347.49 0 00751.2 354l-29.1-26.7a8.09 8.09 0 00-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 01-47.5 46.1 352.6 352.6 0 00-100.3 121.5A347.75 347.75 0 00160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0075.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 00760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0027.7-136c0-48.8-10-96.2-29.9-140.9zM713 808.5c-53.7 53.2-125 82.4-201 82.4s-147.3-29.2-201-82.4c-53.5-53.1-83-123.5-83-198.4 0-43.5 9.8-85.2 29.1-124 18.8-37.9 46.8-71.8 80.8-97.9a349.6 349.6 0 0058.6-56.8c25-30.5 44.6-64.5 58.2-101a240 240 0 0012.1-46.5c24.1 22.2 44.3 49 61.2 80.4 33.4 62.6 48.8 118.3 45.8 165.7a74.01 74.01 0 0024.4 59.8 73.36 73.36 0 0053.4 18.8c19.7-1 37.8-9.7 51-24.4 13.3-14.9 24.8-30.1 34.4-45.6 14 17.9 25.7 37.4 35 58.4 15.9 35.8 24 73.9 24 113.1 0 74.9-29.5 145.4-83 198.4z" } }] }, "name": "fire", "theme": "outlined" };
var FireOutlinedSvg = FireOutlined$2;

var FireOutlined = function FireOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FireOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FireOutlined.displayName = 'FireOutlined';
}
var FireOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FireOutlined);

// This icon file is generated automatically.
var FireTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M737 438.6c-9.6 15.5-21.1 30.7-34.4 45.6a73.1 73.1 0 01-51 24.4 73.36 73.36 0 01-53.4-18.8 74.01 74.01 0 01-24.4-59.8c3-47.4-12.4-103.1-45.8-165.7-16.9-31.4-37.1-58.2-61.2-80.4a240 240 0 01-12.1 46.5 354.26 354.26 0 01-58.2 101 349.6 349.6 0 01-58.6 56.8c-34 26.1-62 60-80.8 97.9a275.96 275.96 0 00-29.1 124c0 74.9 29.5 145.3 83 198.4 53.7 53.2 125 82.4 201 82.4s147.3-29.2 201-82.4c53.5-53 83-123.5 83-198.4 0-39.2-8.1-77.3-24-113.1-9.3-21-21-40.5-35-58.4z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M834.1 469.2A347.49 347.49 0 00751.2 354l-29.1-26.7a8.09 8.09 0 00-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 01-47.5 46.1 352.6 352.6 0 00-100.3 121.5A347.75 347.75 0 00160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0075.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 00760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0027.7-136c0-48.8-10-96.2-29.9-140.9zM713 808.5c-53.7 53.2-125 82.4-201 82.4s-147.3-29.2-201-82.4c-53.5-53.1-83-123.5-83-198.4 0-43.5 9.8-85.2 29.1-124 18.8-37.9 46.8-71.8 80.8-97.9a349.6 349.6 0 0058.6-56.8c25-30.5 44.6-64.5 58.2-101a240 240 0 0012.1-46.5c24.1 22.2 44.3 49 61.2 80.4 33.4 62.6 48.8 118.3 45.8 165.7a74.01 74.01 0 0024.4 59.8 73.36 73.36 0 0053.4 18.8c19.7-1 37.8-9.7 51-24.4 13.3-14.9 24.8-30.1 34.4-45.6 14 17.9 25.7 37.4 35 58.4 15.9 35.8 24 73.9 24 113.1 0 74.9-29.5 145.4-83 198.4z", "fill": primaryColor } }] }; }, "name": "fire", "theme": "twotone" };
var FireTwoToneSvg = FireTwoTone$2;

var FireTwoTone = function FireTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FireTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FireTwoTone.displayName = 'FireTwoTone';
}
var FireTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(FireTwoTone);

// This icon file is generated automatically.
var FlagFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32z" } }] }, "name": "flag", "theme": "filled" };
var FlagFilledSvg = FlagFilled$2;

var FlagFilled = function FlagFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FlagFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FlagFilled.displayName = 'FlagFilled';
}
var FlagFilled$1 = /*#__PURE__*/React__namespace.forwardRef(FlagFilled);

// This icon file is generated automatically.
var FlagOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z" } }] }, "name": "flag", "theme": "outlined" };
var FlagOutlinedSvg = FlagOutlined$2;

var FlagOutlined = function FlagOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FlagOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FlagOutlined.displayName = 'FlagOutlined';
}
var FlagOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FlagOutlined);

// This icon file is generated automatically.
var FlagTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M184 232h368v336H184z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M624 632c0 4.4-3.6 8-8 8H504v73h336V377H624v255z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z", "fill": primaryColor } }] }; }, "name": "flag", "theme": "twotone" };
var FlagTwoToneSvg = FlagTwoTone$2;

var FlagTwoTone = function FlagTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FlagTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FlagTwoTone.displayName = 'FlagTwoTone';
}
var FlagTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(FlagTwoTone);

// This icon file is generated automatically.
var FolderAddFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM632 577c0 3.8-3.4 7-7.5 7H540v84.9c0 3.9-3.2 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V584h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7H484v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.8 0 7 3.2 7 7.1V528h84.5c4.1 0 7.5 3.2 7.5 7v42z" } }] }, "name": "folder-add", "theme": "filled" };
var FolderAddFilledSvg = FolderAddFilled$2;

var FolderAddFilled = function FolderAddFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FolderAddFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FolderAddFilled.displayName = 'FolderAddFilled';
}
var FolderAddFilled$1 = /*#__PURE__*/React__namespace.forwardRef(FolderAddFilled);

// This icon file is generated automatically.
var FolderAddOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M484 443.1V528h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H484v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V584h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H540v-84.9c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1zm396-144.7H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z" } }] }, "name": "folder-add", "theme": "outlined" };
var FolderAddOutlinedSvg = FolderAddOutlined$2;

var FolderAddOutlined = function FolderAddOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FolderAddOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FolderAddOutlined.displayName = 'FolderAddOutlined';
}
var FolderAddOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FolderAddOutlined);

// This icon file is generated automatically.
var FolderAddTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M372.5 256H184v512h656V370.4H492.1L372.5 256zM540 443.1V528h84.5c4.1 0 7.5 3.1 7.5 7v42c0 3.8-3.4 7-7.5 7H540v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V584h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H484v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M484 443.1V528h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H484v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V584h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H540v-84.9c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1z", "fill": primaryColor } }] }; }, "name": "folder-add", "theme": "twotone" };
var FolderAddTwoToneSvg = FolderAddTwoTone$2;

var FolderAddTwoTone = function FolderAddTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FolderAddTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FolderAddTwoTone.displayName = 'FolderAddTwoTone';
}
var FolderAddTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(FolderAddTwoTone);

// This icon file is generated automatically.
var FolderFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32z" } }] }, "name": "folder", "theme": "filled" };
var FolderFilledSvg = FolderFilled$2;

var FolderFilled = function FolderFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FolderFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FolderFilled.displayName = 'FolderFilled';
}
var FolderFilled$1 = /*#__PURE__*/React__namespace.forwardRef(FolderFilled);

// This icon file is generated automatically.
var FolderOpenFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zm-180 0H238c-13 0-24.8 7.9-29.7 20L136 643.2V256h188.5l119.6 114.4H748V444z" } }] }, "name": "folder-open", "theme": "filled" };
var FolderOpenFilledSvg = FolderOpenFilled$2;

var FolderOpenFilled = function FolderOpenFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FolderOpenFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FolderOpenFilled.displayName = 'FolderOpenFilled';
}
var FolderOpenFilled$1 = /*#__PURE__*/React__namespace.forwardRef(FolderOpenFilled);

// This icon file is generated automatically.
var FolderOpenOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z" } }] }, "name": "folder-open", "theme": "outlined" };
var FolderOpenOutlinedSvg = FolderOpenOutlined$2;

var FolderOpenOutlined = function FolderOpenOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FolderOpenOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FolderOpenOutlined.displayName = 'FolderOpenOutlined';
}
var FolderOpenOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FolderOpenOutlined);

// This icon file is generated automatically.
var FolderOpenTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M159 768h612.3l103.4-256H262.3z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z", "fill": primaryColor } }] }; }, "name": "folder-open", "theme": "twotone" };
var FolderOpenTwoToneSvg = FolderOpenTwoTone$2;

var FolderOpenTwoTone = function FolderOpenTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FolderOpenTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FolderOpenTwoTone.displayName = 'FolderOpenTwoTone';
}
var FolderOpenTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(FolderOpenTwoTone);

// This icon file is generated automatically.
var FolderOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z" } }] }, "name": "folder", "theme": "outlined" };
var FolderOutlinedSvg = FolderOutlined$2;

var FolderOutlined = function FolderOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FolderOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FolderOutlined.displayName = 'FolderOutlined';
}
var FolderOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FolderOutlined);

// This icon file is generated automatically.
var FolderTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M372.5 256H184v512h656V370.4H492.1z", "fill": secondaryColor } }] }; }, "name": "folder", "theme": "twotone" };
var FolderTwoToneSvg = FolderTwoTone$2;

var FolderTwoTone = function FolderTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FolderTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FolderTwoTone.displayName = 'FolderTwoTone';
}
var FolderTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(FolderTwoTone);

// This icon file is generated automatically.
var FolderViewOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M309.1 554.3a42.92 42.92 0 000 36.4C353.3 684 421.6 732 512.5 732s159.2-48.1 203.4-141.3c5.4-11.5 5.4-24.8.1-36.3l-.1-.1-.1-.1C671.7 461 603.4 413 512.5 413s-159.2 48.1-203.4 141.3zM512.5 477c62.1 0 107.4 30 141.1 95.5C620 638 574.6 668 512.5 668s-107.4-30-141.1-95.5c33.7-65.5 79-95.5 141.1-95.5z" } }, { "tag": "path", "attrs": { "d": "M457 573a56 56 0 10112 0 56 56 0 10-112 0z" } }, { "tag": "path", "attrs": { "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z" } }] }, "name": "folder-view", "theme": "outlined" };
var FolderViewOutlinedSvg = FolderViewOutlined$2;

var FolderViewOutlined = function FolderViewOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FolderViewOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FolderViewOutlined.displayName = 'FolderViewOutlined';
}
var FolderViewOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FolderViewOutlined);

// This icon file is generated automatically.
var FontColorsOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8zm-650.3-80h85c4.2 0 8-2.7 9.3-6.8l53.7-166h219.2l53.2 166c1.3 4 5 6.8 9.3 6.8h89.1c1.1 0 2.2-.2 3.2-.5a9.7 9.7 0 006-12.4L573.6 118.6a9.9 9.9 0 00-9.2-6.6H462.1c-4.2 0-7.9 2.6-9.2 6.6L244.5 723.1c-.4 1-.5 2.1-.5 3.2-.1 5.3 4.3 9.7 9.7 9.7zm255.9-516.1h4.1l83.8 263.8H424.9l84.7-263.8z" } }] }, "name": "font-colors", "theme": "outlined" };
var FontColorsOutlinedSvg = FontColorsOutlined$2;

var FontColorsOutlined = function FontColorsOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FontColorsOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FontColorsOutlined.displayName = 'FontColorsOutlined';
}
var FontColorsOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FontColorsOutlined);

// This icon file is generated automatically.
var FontSizeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M920 416H616c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h60v320h-46c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h164c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-46V480h60v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V424c0-4.4-3.6-8-8-8zM656 296V168c0-4.4-3.6-8-8-8H104c-4.4 0-8 3.6-8 8v128c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-64h168v560h-92c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-92V232h168v64c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8z" } }] }, "name": "font-size", "theme": "outlined" };
var FontSizeOutlinedSvg = FontSizeOutlined$2;

var FontSizeOutlined = function FontSizeOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FontSizeOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FontSizeOutlined.displayName = 'FontSizeOutlined';
}
var FontSizeOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FontSizeOutlined);

// This icon file is generated automatically.
var ForkOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M752 100c-61.8 0-112 50.2-112 112 0 47.7 29.9 88.5 72 104.6v27.6L512 601.4 312 344.2v-27.6c42.1-16.1 72-56.9 72-104.6 0-61.8-50.2-112-112-112s-112 50.2-112 112c0 50.6 33.8 93.5 80 107.3v34.4c0 9.7 3.3 19.3 9.3 27L476 672.3v33.6c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1v-33.6l226.7-291.6c6-7.7 9.3-17.3 9.3-27v-34.4c46.2-13.8 80-56.7 80-107.3 0-61.8-50.2-112-112-112zM224 212a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm336 600a48.01 48.01 0 01-96 0 48.01 48.01 0 0196 0zm192-552a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "fork", "theme": "outlined" };
var ForkOutlinedSvg = ForkOutlined$2;

var ForkOutlined = function ForkOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ForkOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ForkOutlined.displayName = 'ForkOutlined';
}
var ForkOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ForkOutlined);

// This icon file is generated automatically.
var FormOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 512h-56c-4.4 0-8 3.6-8 8v320H184V184h320c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V520c0-4.4-3.6-8-8-8z" } }, { "tag": "path", "attrs": { "d": "M355.9 534.9L354 653.8c-.1 8.9 7.1 16.2 16 16.2h.4l118-2.9c2-.1 4-.9 5.4-2.3l415.9-415c3.1-3.1 3.1-8.2 0-11.3L785.4 114.3c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-415.8 415a8.3 8.3 0 00-2.3 5.6zm63.5 23.6L779.7 199l45.2 45.1-360.5 359.7-45.7 1.1.7-46.4z" } }] }, "name": "form", "theme": "outlined" };
var FormOutlinedSvg = FormOutlined$2;

var FormOutlined = function FormOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FormOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FormOutlined.displayName = 'FormOutlined';
}
var FormOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FormOutlined);

// This icon file is generated automatically.
var FormatPainterFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M840 192h-56v-72c0-13.3-10.7-24-24-24H168c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h592c13.3 0 24-10.7 24-24V256h32v200H465c-22.1 0-40 17.9-40 40v136h-44c-4.4 0-8 3.6-8 8v228c0 1.1.2 2.2.6 3.1-.4 1.6-.6 3.2-.6 4.9 0 46.4 37.6 84 84 84s84-37.6 84-84c0-1.7-.2-3.3-.6-4.9.4-1 .6-2 .6-3.1V640c0-4.4-3.6-8-8-8h-44V520h351c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40z" } }] }, "name": "format-painter", "theme": "filled" };
var FormatPainterFilledSvg = FormatPainterFilled$2;

var FormatPainterFilled = function FormatPainterFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FormatPainterFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FormatPainterFilled.displayName = 'FormatPainterFilled';
}
var FormatPainterFilled$1 = /*#__PURE__*/React__namespace.forwardRef(FormatPainterFilled);

// This icon file is generated automatically.
var FormatPainterOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M840 192h-56v-72c0-13.3-10.7-24-24-24H168c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h592c13.3 0 24-10.7 24-24V256h32v200H465c-22.1 0-40 17.9-40 40v136h-44c-4.4 0-8 3.6-8 8v228c0 .6.1 1.3.2 1.9A83.99 83.99 0 00457 960c46.4 0 84-37.6 84-84 0-2.1-.1-4.1-.2-6.1.1-.6.2-1.2.2-1.9V640c0-4.4-3.6-8-8-8h-44V520h351c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40zM720 352H208V160h512v192zM477 876c0 11-9 20-20 20s-20-9-20-20V696h40v180z" } }] }, "name": "format-painter", "theme": "outlined" };
var FormatPainterOutlinedSvg = FormatPainterOutlined$2;

var FormatPainterOutlined = function FormatPainterOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FormatPainterOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FormatPainterOutlined.displayName = 'FormatPainterOutlined';
}
var FormatPainterOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FormatPainterOutlined);

// This icon file is generated automatically.
var ForwardFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M825.8 498L538.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L825.8 526c8.3-7.2 8.3-20.8 0-28zm-320 0L218.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L505.8 526c4.1-3.6 6.2-8.8 6.2-14 0-5.2-2.1-10.4-6.2-14z" } }] }, "name": "forward", "theme": "filled" };
var ForwardFilledSvg = ForwardFilled$2;

var ForwardFilled = function ForwardFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ForwardFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ForwardFilled.displayName = 'ForwardFilled';
}
var ForwardFilled$1 = /*#__PURE__*/React__namespace.forwardRef(ForwardFilled);

// This icon file is generated automatically.
var ForwardOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M825.8 498L538.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L825.8 526c8.3-7.2 8.3-20.8 0-28zm-320 0L218.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L505.8 526c4.1-3.6 6.2-8.8 6.2-14 0-5.2-2.1-10.4-6.2-14z" } }] }, "name": "forward", "theme": "outlined" };
var ForwardOutlinedSvg = ForwardOutlined$2;

var ForwardOutlined = function ForwardOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ForwardOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ForwardOutlined.displayName = 'ForwardOutlined';
}
var ForwardOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ForwardOutlined);

// This icon file is generated automatically.
var FrownFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm376 272h-48.1c-4.2 0-7.8-3.2-8.1-7.4C604 636.1 562.5 597 512 597s-92.1 39.1-95.8 88.6c-.3 4.2-3.9 7.4-8.1 7.4H360a8 8 0 01-8-8.4c4.4-84.3 74.5-151.6 160-151.6s155.6 67.3 160 151.6a8 8 0 01-8 8.4zm24-224a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "frown", "theme": "filled" };
var FrownFilledSvg = FrownFilled$2;

var FrownFilled = function FrownFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FrownFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FrownFilled.displayName = 'FrownFilled';
}
var FrownFilled$1 = /*#__PURE__*/React__namespace.forwardRef(FrownFilled);

// This icon file is generated automatically.
var FrownOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M288 421a48 48 0 1096 0 48 48 0 10-96 0zm352 0a48 48 0 1096 0 48 48 0 10-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 01248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 01249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 01775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 01775 775zM512 533c-85.5 0-155.6 67.3-160 151.6a8 8 0 008 8.4h48.1c4.2 0 7.8-3.2 8.1-7.4C420 636.1 461.5 597 512 597s92.1 39.1 95.8 88.6c.3 4.2 3.9 7.4 8.1 7.4H664a8 8 0 008-8.4C667.6 600.3 597.5 533 512 533z" } }] }, "name": "frown", "theme": "outlined" };
var FrownOutlinedSvg = FrownOutlined$2;

var FrownOutlined = function FrownOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FrownOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FrownOutlined.displayName = 'FrownOutlined';
}
var FrownOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FrownOutlined);

// This icon file is generated automatically.
var FrownTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm376 272h-48.1c-4.2 0-7.8-3.2-8.1-7.4C604 636.1 562.5 597 512 597s-92.1 39.1-95.8 88.6c-.3 4.2-3.9 7.4-8.1 7.4H360a8 8 0 01-8-8.4c4.4-84.3 74.5-151.6 160-151.6s155.6 67.3 160 151.6a8 8 0 01-8 8.4zm24-224a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M288 421a48 48 0 1096 0 48 48 0 10-96 0zm224 112c-85.5 0-155.6 67.3-160 151.6a8 8 0 008 8.4h48.1c4.2 0 7.8-3.2 8.1-7.4 3.7-49.5 45.3-88.6 95.8-88.6s92 39.1 95.8 88.6c.3 4.2 3.9 7.4 8.1 7.4H664a8 8 0 008-8.4C667.6 600.3 597.5 533 512 533zm128-112a48 48 0 1096 0 48 48 0 10-96 0z", "fill": primaryColor } }] }; }, "name": "frown", "theme": "twotone" };
var FrownTwoToneSvg = FrownTwoTone$2;

var FrownTwoTone = function FrownTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FrownTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FrownTwoTone.displayName = 'FrownTwoTone';
}
var FrownTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(FrownTwoTone);

// This icon file is generated automatically.
var FullscreenExitOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M391 240.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L200 146.3a8.03 8.03 0 00-11.3 0l-42.4 42.3a8.03 8.03 0 000 11.3L280 333.6l-43.9 43.9a8.01 8.01 0 004.7 13.6L401 410c5.1.6 9.5-3.7 8.9-8.9L391 240.9zm10.1 373.2L240.8 633c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L146.3 824a8.03 8.03 0 000 11.3l42.4 42.3c3.1 3.1 8.2 3.1 11.3 0L333.7 744l43.7 43.7A8.01 8.01 0 00391 783l18.9-160.1c.6-5.1-3.7-9.4-8.8-8.8zm221.8-204.2L783.2 391c6.6-.8 9.4-8.9 4.7-13.6L744 333.6 877.7 200c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.3a8.03 8.03 0 00-11.3 0L690.3 279.9l-43.7-43.7a8.01 8.01 0 00-13.6 4.7L614.1 401c-.6 5.2 3.7 9.5 8.8 8.9zM744 690.4l43.9-43.9a8.01 8.01 0 00-4.7-13.6L623 614c-5.1-.6-9.5 3.7-8.9 8.9L633 783.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L824 877.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L744 690.4z" } }] }, "name": "fullscreen-exit", "theme": "outlined" };
var FullscreenExitOutlinedSvg = FullscreenExitOutlined$2;

var FullscreenExitOutlined = function FullscreenExitOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FullscreenExitOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FullscreenExitOutlined.displayName = 'FullscreenExitOutlined';
}
var FullscreenExitOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FullscreenExitOutlined);

// This icon file is generated automatically.
var FullscreenOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M290 236.4l43.9-43.9a8.01 8.01 0 00-4.7-13.6L169 160c-5.1-.6-9.5 3.7-8.9 8.9L179 329.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L370 423.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L290 236.4zm352.7 187.3c3.1 3.1 8.2 3.1 11.3 0l133.7-133.6 43.7 43.7a8.01 8.01 0 0013.6-4.7L863.9 169c.6-5.1-3.7-9.5-8.9-8.9L694.8 179c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L600.3 370a8.03 8.03 0 000 11.3l42.4 42.4zM845 694.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L654 600.3a8.03 8.03 0 00-11.3 0l-42.4 42.3a8.03 8.03 0 000 11.3L734 787.6l-43.9 43.9a8.01 8.01 0 004.7 13.6L855 864c5.1.6 9.5-3.7 8.9-8.9L845 694.9zm-463.7-94.6a8.03 8.03 0 00-11.3 0L236.3 733.9l-43.7-43.7a8.01 8.01 0 00-13.6 4.7L160.1 855c-.6 5.1 3.7 9.5 8.9 8.9L329.2 845c6.6-.8 9.4-8.9 4.7-13.6L290 787.6 423.7 654c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.4z" } }] }, "name": "fullscreen", "theme": "outlined" };
var FullscreenOutlinedSvg = FullscreenOutlined$2;

var FullscreenOutlined = function FullscreenOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FullscreenOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FullscreenOutlined.displayName = 'FullscreenOutlined';
}
var FullscreenOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FullscreenOutlined);

// This icon file is generated automatically.
var FunctionOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M841 370c3-3.3 2.7-8.3-.6-11.3a8.24 8.24 0 00-5.3-2.1h-72.6c-2.4 0-4.6 1-6.1 2.8L633.5 504.6a7.96 7.96 0 01-13.4-1.9l-63.5-141.3a7.9 7.9 0 00-7.3-4.7H380.7l.9-4.7 8-42.3c10.5-55.4 38-81.4 85.8-81.4 18.6 0 35.5 1.7 48.8 4.7l14.1-66.8c-22.6-4.7-35.2-6.1-54.9-6.1-103.3 0-156.4 44.3-175.9 147.3l-9.4 49.4h-97.6c-3.8 0-7.1 2.7-7.8 6.4L181.9 415a8.07 8.07 0 007.8 9.7H284l-89 429.9a8.07 8.07 0 007.8 9.7H269c3.8 0 7.1-2.7 7.8-6.4l89.7-433.1h135.8l68.2 139.1c1.4 2.9 1 6.4-1.2 8.8l-180.6 203c-2.9 3.3-2.6 8.4.7 11.3 1.5 1.3 3.4 2 5.3 2h72.7c2.4 0 4.6-1 6.1-2.8l123.7-146.7c2.8-3.4 7.9-3.8 11.3-1 .9.8 1.6 1.7 2.1 2.8L676.4 784c1.3 2.8 4.1 4.7 7.3 4.7h64.6a8.02 8.02 0 007.2-11.5l-95.2-198.9c-1.4-2.9-.9-6.4 1.3-8.8L841 370z" } }] }, "name": "function", "theme": "outlined" };
var FunctionOutlinedSvg = FunctionOutlined$2;

var FunctionOutlined = function FunctionOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FunctionOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FunctionOutlined.displayName = 'FunctionOutlined';
}
var FunctionOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FunctionOutlined);

// This icon file is generated automatically.
var FundFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M926 164H94c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V196c0-17.7-14.3-32-32-32zm-92.3 194.4l-297 297.2a8.03 8.03 0 01-11.3 0L410.9 541.1 238.4 713.7a8.03 8.03 0 01-11.3 0l-36.8-36.8a8.03 8.03 0 010-11.3l214.9-215c3.1-3.1 8.2-3.1 11.3 0L531 565l254.5-254.6c3.1-3.1 8.2-3.1 11.3 0l36.8 36.8c3.2 3 3.2 8.1.1 11.2z" } }] }, "name": "fund", "theme": "filled" };
var FundFilledSvg = FundFilled$2;

var FundFilled = function FundFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FundFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FundFilled.displayName = 'FundFilled';
}
var FundFilled$1 = /*#__PURE__*/React__namespace.forwardRef(FundFilled);

// This icon file is generated automatically.
var FundOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M926 164H94c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V196c0-17.7-14.3-32-32-32zm-40 632H134V236h752v560zm-658.9-82.3c3.1 3.1 8.2 3.1 11.3 0l172.5-172.5 114.4 114.5c3.1 3.1 8.2 3.1 11.3 0l297-297.2c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 00-11.3 0L531 565 416.6 450.5a8.03 8.03 0 00-11.3 0l-214.9 215a8.03 8.03 0 000 11.3l36.7 36.9z" } }] }, "name": "fund", "theme": "outlined" };
var FundOutlinedSvg = FundOutlined$2;

var FundOutlined = function FundOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FundOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FundOutlined.displayName = 'FundOutlined';
}
var FundOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FundOutlined);

// This icon file is generated automatically.
var FundProjectionScreenOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M312.1 591.5c3.1 3.1 8.2 3.1 11.3 0l101.8-101.8 86.1 86.2c3.1 3.1 8.2 3.1 11.3 0l226.3-226.5c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 00-11.3 0L517 485.3l-86.1-86.2a8.03 8.03 0 00-11.3 0L275.3 543.4a8.03 8.03 0 000 11.3l36.8 36.8z" } }, { "tag": "path", "attrs": { "d": "M904 160H548V96c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H120c-17.7 0-32 14.3-32 32v520c0 17.7 14.3 32 32 32h356.4v32L311.6 884.1a7.92 7.92 0 00-2.3 11l30.3 47.2v.1c2.4 3.7 7.4 4.7 11.1 2.3L512 838.9l161.3 105.8c3.7 2.4 8.7 1.4 11.1-2.3v-.1l30.3-47.2a8 8 0 00-2.3-11L548 776.3V744h356c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 512H160V232h704v440z" } }] }, "name": "fund-projection-screen", "theme": "outlined" };
var FundProjectionScreenOutlinedSvg = FundProjectionScreenOutlined$2;

var FundProjectionScreenOutlined = function FundProjectionScreenOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FundProjectionScreenOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FundProjectionScreenOutlined.displayName = 'FundProjectionScreenOutlined';
}
var FundProjectionScreenOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FundProjectionScreenOutlined);

// This icon file is generated automatically.
var FundTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M136 792h752V232H136v560zm56.4-130.5l214.9-215c3.1-3.1 8.2-3.1 11.3 0L533 561l254.5-254.6c3.1-3.1 8.2-3.1 11.3 0l36.8 36.8c3.1 3.1 3.1 8.2 0 11.3l-297 297.2a8.03 8.03 0 01-11.3 0L412.9 537.2 240.4 709.7a8.03 8.03 0 01-11.3 0l-36.7-36.9a8.03 8.03 0 010-11.3z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M229.1 709.7c3.1 3.1 8.2 3.1 11.3 0l172.5-172.5 114.4 114.5c3.1 3.1 8.2 3.1 11.3 0l297-297.2c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 00-11.3 0L533 561 418.6 446.5a8.03 8.03 0 00-11.3 0l-214.9 215a8.03 8.03 0 000 11.3l36.7 36.9z", "fill": primaryColor } }] }; }, "name": "fund", "theme": "twotone" };
var FundTwoToneSvg = FundTwoTone$2;

var FundTwoTone = function FundTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FundTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FundTwoTone.displayName = 'FundTwoTone';
}
var FundTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(FundTwoTone);

// This icon file is generated automatically.
var FundViewOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M956 686.5l-.1-.1-.1-.1C911.7 593 843.4 545 752.5 545s-159.2 48.1-203.4 141.3v.1a42.92 42.92 0 000 36.4C593.3 816 661.6 864 752.5 864s159.2-48.1 203.4-141.3c5.4-11.5 5.4-24.8.1-36.2zM752.5 800c-62.1 0-107.4-30-141.1-95.5C645 639 690.4 609 752.5 609c62.1 0 107.4 30 141.1 95.5C860 770 814.6 800 752.5 800z" } }, { "tag": "path", "attrs": { "d": "M697 705a56 56 0 10112 0 56 56 0 10-112 0zM136 232h704v253h72V192c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v520c0 17.7 14.3 32 32 32h352v-72H136V232z" } }, { "tag": "path", "attrs": { "d": "M724.9 338.1l-36.8-36.8a8.03 8.03 0 00-11.3 0L493 485.3l-86.1-86.2a8.03 8.03 0 00-11.3 0L251.3 543.4a8.03 8.03 0 000 11.3l36.8 36.8c3.1 3.1 8.2 3.1 11.3 0l101.8-101.8 86.1 86.2c3.1 3.1 8.2 3.1 11.3 0l226.3-226.5c3.2-3.1 3.2-8.2 0-11.3z" } }] }, "name": "fund-view", "theme": "outlined" };
var FundViewOutlinedSvg = FundViewOutlined$2;

var FundViewOutlined = function FundViewOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FundViewOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FundViewOutlined.displayName = 'FundViewOutlined';
}
var FundViewOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FundViewOutlined);

// This icon file is generated automatically.
var FunnelPlotFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M336.7 586h350.6l84.9-148H251.8zm543.4-432H143.9c-24.5 0-39.8 26.7-27.5 48L215 374h594l98.7-172c12.2-21.3-3.1-48-27.6-48zM349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V650H349v188z" } }] }, "name": "funnel-plot", "theme": "filled" };
var FunnelPlotFilledSvg = FunnelPlotFilled$2;

var FunnelPlotFilled = function FunnelPlotFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FunnelPlotFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FunnelPlotFilled.displayName = 'FunnelPlotFilled';
}
var FunnelPlotFilled$1 = /*#__PURE__*/React__namespace.forwardRef(FunnelPlotFilled);

// This icon file is generated automatically.
var FunnelPlotOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 607.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V607.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V650h182.9v148zm9.6-226.6l-8.4 14.6H419.3l-8.4-14.6L334.4 438h355.2L613 571.4zM726.3 374H297.7l-85-148h598.6l-85 148z" } }] }, "name": "funnel-plot", "theme": "outlined" };
var FunnelPlotOutlinedSvg = FunnelPlotOutlined$2;

var FunnelPlotOutlined = function FunnelPlotOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FunnelPlotOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FunnelPlotOutlined.displayName = 'FunnelPlotOutlined';
}
var FunnelPlotOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(FunnelPlotOutlined);

// This icon file is generated automatically.
var FunnelPlotTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M420.6 798h182.9V650H420.6zM297.7 374h428.6l85-148H212.7zm113.2 197.4l8.4 14.6h185.3l8.4-14.6L689.6 438H334.4z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 607.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V607.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.5 798H420.6V650h182.9v148zm9.5-226.6l-8.4 14.6H419.3l-8.4-14.6L334.4 438h355.2L613 571.4zM726.3 374H297.7l-85-148h598.6l-85 148z", "fill": primaryColor } }] }; }, "name": "funnel-plot", "theme": "twotone" };
var FunnelPlotTwoToneSvg = FunnelPlotTwoTone$2;

var FunnelPlotTwoTone = function FunnelPlotTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FunnelPlotTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  FunnelPlotTwoTone.displayName = 'FunnelPlotTwoTone';
}
var FunnelPlotTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(FunnelPlotTwoTone);

// This icon file is generated automatically.
var GatewayOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 392c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H744c-8.8 0-16 7.2-16 16v56H296v-56c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v184c0 8.8 7.2 16 16 16h56v240H96c-8.8 0-16 7.2-16 16v184c0 8.8 7.2 16 16 16h184c8.8 0 16-7.2 16-16v-56h432v56c0 8.8 7.2 16 16 16h184c8.8 0 16-7.2 16-16V648c0-8.8-7.2-16-16-16h-56V392h56zM792 240h88v88h-88v-88zm-648 88v-88h88v88h-88zm88 456h-88v-88h88v88zm648-88v88h-88v-88h88zm-80-64h-56c-8.8 0-16 7.2-16 16v56H296v-56c0-8.8-7.2-16-16-16h-56V392h56c8.8 0 16-7.2 16-16v-56h432v56c0 8.8 7.2 16 16 16h56v240z" } }] }, "name": "gateway", "theme": "outlined" };
var GatewayOutlinedSvg = GatewayOutlined$2;

var GatewayOutlined = function GatewayOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GatewayOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  GatewayOutlined.displayName = 'GatewayOutlined';
}
var GatewayOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(GatewayOutlined);

// This icon file is generated automatically.
var GifOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M944 299H692c-4.4 0-8 3.6-8 8v406c0 4.4 3.6 8 8 8h59.2c4.4 0 8-3.6 8-8V549.9h168.2c4.4 0 8-3.6 8-8V495c0-4.4-3.6-8-8-8H759.2V364.2H944c4.4 0 8-3.6 8-8V307c0-4.4-3.6-8-8-8zm-356 1h-56c-4.4 0-8 3.6-8 8v406c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V308c0-4.4-3.6-8-8-8zM452 500.9H290.5c-4.4 0-8 3.6-8 8v43.7c0 4.4 3.6 8 8 8h94.9l-.3 8.9c-1.2 58.8-45.6 98.5-110.9 98.5-76.2 0-123.9-59.7-123.9-156.7 0-95.8 46.8-155.2 121.5-155.2 54.8 0 93.1 26.9 108.5 75.4h76.2c-13.6-87.2-86-143.4-184.7-143.4C150 288 72 375.2 72 511.9 72 650.2 149.1 736 273 736c114.1 0 187-70.7 187-181.6v-45.5c0-4.4-3.6-8-8-8z" } }] }, "name": "gif", "theme": "outlined" };
var GifOutlinedSvg = GifOutlined$2;

var GifOutlined = function GifOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GifOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  GifOutlined.displayName = 'GifOutlined';
}
var GifOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(GifOutlined);

// This icon file is generated automatically.
var GiftFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M160 894c0 17.7 14.3 32 32 32h286V550H160v344zm386 32h286c17.7 0 32-14.3 32-32V550H546v376zm334-616H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v140h366V310h68v172h366V342c0-17.7-14.3-32-32-32zm-402-4h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm138 0h-70v-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70z" } }] }, "name": "gift", "theme": "filled" };
var GiftFilledSvg = GiftFilled$2;

var GiftFilled = function GiftFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GiftFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  GiftFilled.displayName = 'GiftFilled';
}
var GiftFilled$1 = /*#__PURE__*/React__namespace.forwardRef(GiftFilled);

// This icon file is generated automatically.
var GiftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 310H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v200c0 4.4 3.6 8 8 8h40v344c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V550h40c4.4 0 8-3.6 8-8V342c0-17.7-14.3-32-32-32zm-334-74c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70h-70v-70zm-138-70c38.6 0 70 31.4 70 70v70h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70zM180 482V378h298v104H180zm48 68h250v308H228V550zm568 308H546V550h250v308zm48-376H546V378h298v104z" } }] }, "name": "gift", "theme": "outlined" };
var GiftOutlinedSvg = GiftOutlined$2;

var GiftOutlined = function GiftOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GiftOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  GiftOutlined.displayName = 'GiftOutlined';
}
var GiftOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(GiftOutlined);

// This icon file is generated automatically.
var GiftTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M546 378h298v104H546zM228 550h250v308H228zm-48-172h298v104H180zm366 172h250v308H546z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 310H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v200c0 4.4 3.6 8 8 8h40v344c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V550h40c4.4 0 8-3.6 8-8V342c0-17.7-14.3-32-32-32zM478 858H228V550h250v308zm0-376H180V378h298v104zm0-176h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm68-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70h-70v-70zm250 622H546V550h250v308zm48-376H546V378h298v104z", "fill": primaryColor } }] }; }, "name": "gift", "theme": "twotone" };
var GiftTwoToneSvg = GiftTwoTone$2;

var GiftTwoTone = function GiftTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GiftTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  GiftTwoTone.displayName = 'GiftTwoTone';
}
var GiftTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(GiftTwoTone);

// This icon file is generated automatically.
var GithubFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0138.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z" } }] }, "name": "github", "theme": "filled" };
var GithubFilledSvg = GithubFilled$2;

var GithubFilled = function GithubFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GithubFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  GithubFilled.displayName = 'GithubFilled';
}
var GithubFilled$1 = /*#__PURE__*/React__namespace.forwardRef(GithubFilled);

// This icon file is generated automatically.
var GithubOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0138.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z" } }] }, "name": "github", "theme": "outlined" };
var GithubOutlinedSvg = GithubOutlined$2;

var GithubOutlined = function GithubOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GithubOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  GithubOutlined.displayName = 'GithubOutlined';
}
var GithubOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(GithubOutlined);

// This icon file is generated automatically.
var GitlabFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M910.5 553.2l-109-370.8c-6.8-20.4-23.1-34.1-44.9-34.1s-39.5 12.3-46.3 32.7l-72.2 215.4H386.2L314 181.1c-6.8-20.4-24.5-32.7-46.3-32.7s-39.5 13.6-44.9 34.1L113.9 553.2c-4.1 13.6 1.4 28.6 12.3 36.8l385.4 289 386.7-289c10.8-8.1 16.3-23.1 12.2-36.8z" } }] }, "name": "gitlab", "theme": "filled" };
var GitlabFilledSvg = GitlabFilled$2;

var GitlabFilled = function GitlabFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GitlabFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  GitlabFilled.displayName = 'GitlabFilled';
}
var GitlabFilled$1 = /*#__PURE__*/React__namespace.forwardRef(GitlabFilled);

// This icon file is generated automatically.
var GitlabOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M913.9 552.2L805 181.4v-.1c-7.6-22.9-25.7-36.5-48.3-36.5-23.4 0-42.5 13.5-49.7 35.2l-71.4 213H388.8l-71.4-213c-7.2-21.7-26.3-35.2-49.7-35.2-23.1 0-42.5 14.8-48.4 36.6L110.5 552.2c-4.4 14.7 1.2 31.4 13.5 40.7l368.5 276.4c2.6 3.6 6.2 6.3 10.4 7.8l8.6 6.4 8.5-6.4c4.9-1.7 9-4.7 11.9-8.9l368.4-275.4c12.4-9.2 18-25.9 13.6-40.6zM751.7 193.4c1-1.8 2.9-1.9 3.5-1.9 1.1 0 2.5.3 3.4 3L818 394.3H684.5l67.2-200.9zm-487.4 1c.9-2.6 2.3-2.9 3.4-2.9 2.7 0 2.9.1 3.4 1.7l67.3 201.2H206.5l57.8-200zM158.8 558.7l28.2-97.3 202.4 270.2-230.6-172.9zm73.9-116.4h122.1l90.8 284.3-212.9-284.3zM512.9 776L405.7 442.3H620L512.9 776zm157.9-333.7h119.5L580 723.1l90.8-280.8zm-40.7 293.9l207.3-276.7 29.5 99.2-236.8 177.5z" } }] }, "name": "gitlab", "theme": "outlined" };
var GitlabOutlinedSvg = GitlabOutlined$2;

var GitlabOutlined = function GitlabOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GitlabOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  GitlabOutlined.displayName = 'GitlabOutlined';
}
var GitlabOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(GitlabOutlined);

// This icon file is generated automatically.
var GlobalOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8-1.1-1.3-2.1-2.5-3.2-3.7-.4-.5-.8-.9-1.2-1.4l-4.1-4.7-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1-4.8-4.8-.3-.3c-1.5-1.5-3-2.9-4.5-4.3-.5-.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1-1 .9-2 1.9-3 2.9-.5.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-.3.3-4.8 4.8-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7-.4.5-.8.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2 1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0010-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5 0-.1.1-.1.1-.2 1.4-1.5 2.8-3.1 4.1-4.7.4-.5.8-.9 1.2-1.4a99 99 0 003.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 00-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 01887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 01-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 01115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 01540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 00540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 01-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 00-81.5 55.9A373.86 373.86 0 01137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8a373.81 373.81 0 01-107.6 69.2z" } }] }, "name": "global", "theme": "outlined" };
var GlobalOutlinedSvg = GlobalOutlined$2;

var GlobalOutlined = function GlobalOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GlobalOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  GlobalOutlined.displayName = 'GlobalOutlined';
}
var GlobalOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(GlobalOutlined);

// This icon file is generated automatically.
var GoldFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M905.9 806.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zm-470.2-248c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8z" } }] }, "name": "gold", "theme": "filled" };
var GoldFilledSvg = GoldFilled$2;

var GoldFilled = function GoldFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GoldFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  GoldFilled.displayName = 'GoldFilled';
}
var GoldFilled$1 = /*#__PURE__*/React__namespace.forwardRef(GoldFilled);

// This icon file is generated automatically.
var GoldOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8zm91.2-196h159.5l20.7 128h-201l20.8-128zm2.5 282.7c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM196.5 748l20.7-128h159.5l20.7 128H196.5zm709.4 58.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zM626.5 748l20.7-128h159.5l20.7 128H626.5z" } }] }, "name": "gold", "theme": "outlined" };
var GoldOutlinedSvg = GoldOutlined$2;

var GoldOutlined = function GoldOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GoldOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  GoldOutlined.displayName = 'GoldOutlined';
}
var GoldOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(GoldOutlined);

// This icon file is generated automatically.
var GoldTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M435.7 558.7c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM196.5 748l20.7-128h159.5l20.7 128H196.5zm709.4 58.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zM626.5 748l20.7-128h159.5l20.7 128H626.5zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8zm91.2-196h159.5l20.7 128h-201l20.8-128z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M592.7 276H433.2l-20.8 128h201zM217.2 620l-20.7 128h200.9l-20.7-128zm430 0l-20.7 128h200.9l-20.7-128z", "fill": secondaryColor } }] }; }, "name": "gold", "theme": "twotone" };
var GoldTwoToneSvg = GoldTwoTone$2;

var GoldTwoTone = function GoldTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GoldTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  GoldTwoTone.displayName = 'GoldTwoTone';
}
var GoldTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(GoldTwoTone);

// This icon file is generated automatically.
var GoldenFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M905.9 806.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zm-470.2-248c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8z" } }] }, "name": "golden", "theme": "filled" };
var GoldenFilledSvg = GoldenFilled$2;

var GoldenFilled = function GoldenFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GoldenFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  GoldenFilled.displayName = 'GoldenFilled';
}
var GoldenFilled$1 = /*#__PURE__*/React__namespace.forwardRef(GoldenFilled);

// This icon file is generated automatically.
var GoogleCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm167 633.6C638.4 735 583 757 516.9 757c-95.7 0-178.5-54.9-218.8-134.9C281.5 589 272 551.6 272 512s9.5-77 26.1-110.1c40.3-80.1 123.1-135 218.8-135 66 0 121.4 24.3 163.9 63.8L610.6 401c-25.4-24.3-57.7-36.6-93.6-36.6-63.8 0-117.8 43.1-137.1 101-4.9 14.7-7.7 30.4-7.7 46.6s2.8 31.9 7.7 46.6c19.3 57.9 73.3 101 137 101 33 0 61-8.7 82.9-23.4 26-17.4 43.2-43.3 48.9-74H516.9v-94.8h230.7c2.9 16.1 4.4 32.8 4.4 50.1 0 74.7-26.7 137.4-73 180.1z" } }] }, "name": "google-circle", "theme": "filled" };
var GoogleCircleFilledSvg = GoogleCircleFilled$2;

var GoogleCircleFilled = function GoogleCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GoogleCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  GoogleCircleFilled.displayName = 'GoogleCircleFilled';
}
var GoogleCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(GoogleCircleFilled);

// This icon file is generated automatically.
var GoogleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M881 442.4H519.7v148.5h206.4c-8.9 48-35.9 88.6-76.6 115.8-34.4 23-78.3 36.6-129.9 36.6-99.9 0-184.4-67.5-214.6-158.2-7.6-23-12-47.6-12-72.9s4.4-49.9 12-72.9c30.3-90.6 114.8-158.1 214.7-158.1 56.3 0 106.8 19.4 146.6 57.4l110-110.1c-66.5-62-153.2-100-256.6-100-149.9 0-279.6 86-342.7 211.4-26 51.8-40.8 110.4-40.8 172.4S151 632.8 177 684.6C240.1 810 369.8 896 519.7 896c103.6 0 190.4-34.4 253.8-93 72.5-66.8 114.4-165.2 114.4-282.1 0-27.2-2.4-53.3-6.9-78.5z" } }] }, "name": "google", "theme": "outlined" };
var GoogleOutlinedSvg = GoogleOutlined$2;

var GoogleOutlined = function GoogleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GoogleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  GoogleOutlined.displayName = 'GoogleOutlined';
}
var GoogleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(GoogleOutlined);

// This icon file is generated automatically.
var GooglePlusCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm36.5 558.8c-43.9 61.8-132.1 79.8-200.9 53.3-69-26.3-118-99.2-112.1-173.5 1.5-90.9 85.2-170.6 176.1-167.5 43.6-2 84.6 16.9 118 43.6-14.3 16.2-29 31.8-44.8 46.3-40.1-27.7-97.2-35.6-137.3-3.6-57.4 39.7-60 133.4-4.8 176.1 53.7 48.7 155.2 24.5 170.1-50.1-33.6-.5-67.4 0-101-1.1-.1-20.1-.2-40.1-.1-60.2 56.2-.2 112.5-.3 168.8.2 3.3 47.3-3 97.5-32 136.5zM791 536.5c-16.8.2-33.6.3-50.4.4-.2 16.8-.3 33.6-.3 50.4H690c-.2-16.8-.2-33.5-.3-50.3-16.8-.2-33.6-.3-50.4-.5v-50.1c16.8-.2 33.6-.3 50.4-.3.1-16.8.3-33.6.4-50.4h50.2l.3 50.4c16.8.2 33.6.2 50.4.3v50.1z" } }] }, "name": "google-plus-circle", "theme": "filled" };
var GooglePlusCircleFilledSvg = GooglePlusCircleFilled$2;

var GooglePlusCircleFilled = function GooglePlusCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GooglePlusCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  GooglePlusCircleFilled.displayName = 'GooglePlusCircleFilled';
}
var GooglePlusCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(GooglePlusCircleFilled);

// This icon file is generated automatically.
var GooglePlusOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M879.5 470.4c-.3-27-.4-54.2-.5-81.3h-80.8c-.3 27-.5 54.1-.7 81.3-27.2.1-54.2.3-81.2.6v80.9c27 .3 54.2.5 81.2.8.3 27 .3 54.1.5 81.1h80.9c.1-27 .3-54.1.5-81.3 27.2-.3 54.2-.4 81.2-.7v-80.9c-26.9-.2-54.1-.2-81.1-.5zm-530 .4c-.1 32.3 0 64.7.1 97 54.2 1.8 108.5 1 162.7 1.8-23.9 120.3-187.4 159.3-273.9 80.7-89-68.9-84.8-220 7.7-284 64.7-51.6 156.6-38.9 221.3 5.8 25.4-23.5 49.2-48.7 72.1-74.7-53.8-42.9-119.8-73.5-190-70.3-146.6-4.9-281.3 123.5-283.7 270.2-9.4 119.9 69.4 237.4 180.6 279.8 110.8 42.7 252.9 13.6 323.7-86 46.7-62.9 56.8-143.9 51.3-220-90.7-.7-181.3-.6-271.9-.3z" } }] }, "name": "google-plus", "theme": "outlined" };
var GooglePlusOutlinedSvg = GooglePlusOutlined$2;

var GooglePlusOutlined = function GooglePlusOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GooglePlusOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  GooglePlusOutlined.displayName = 'GooglePlusOutlined';
}
var GooglePlusOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(GooglePlusOutlined);

// This icon file is generated automatically.
var GooglePlusSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM548.5 622.8c-43.9 61.8-132.1 79.8-200.9 53.3-69-26.3-118-99.2-112.1-173.5 1.5-90.9 85.2-170.6 176.1-167.5 43.6-2 84.6 16.9 118 43.6-14.3 16.2-29 31.8-44.8 46.3-40.1-27.7-97.2-35.6-137.3-3.6-57.4 39.7-60 133.4-4.8 176.1 53.7 48.7 155.2 24.5 170.1-50.1-33.6-.5-67.4 0-101-1.1-.1-20.1-.2-40.1-.1-60.2 56.2-.2 112.5-.3 168.8.2 3.3 47.3-3 97.5-32 136.5zM791 536.5c-16.8.2-33.6.3-50.4.4-.2 16.8-.3 33.6-.3 50.4H690c-.2-16.8-.2-33.5-.3-50.3-16.8-.2-33.6-.3-50.4-.5v-50.1c16.8-.2 33.6-.3 50.4-.3.1-16.8.3-33.6.4-50.4h50.2l.3 50.4c16.8.2 33.6.2 50.4.3v50.1z" } }] }, "name": "google-plus-square", "theme": "filled" };
var GooglePlusSquareFilledSvg = GooglePlusSquareFilled$2;

var GooglePlusSquareFilled = function GooglePlusSquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GooglePlusSquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  GooglePlusSquareFilled.displayName = 'GooglePlusSquareFilled';
}
var GooglePlusSquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(GooglePlusSquareFilled);

// This icon file is generated automatically.
var GoogleSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM679 697.6C638.4 735 583 757 516.9 757c-95.7 0-178.5-54.9-218.8-134.9A245.02 245.02 0 01272 512c0-39.6 9.5-77 26.1-110.1 40.3-80.1 123.1-135 218.8-135 66 0 121.4 24.3 163.9 63.8L610.6 401c-25.4-24.3-57.7-36.6-93.6-36.6-63.8 0-117.8 43.1-137.1 101-4.9 14.7-7.7 30.4-7.7 46.6s2.8 31.9 7.7 46.6c19.3 57.9 73.3 101 137 101 33 0 61-8.7 82.9-23.4 26-17.4 43.2-43.3 48.9-74H516.9v-94.8h230.7c2.9 16.1 4.4 32.8 4.4 50.1 0 74.7-26.7 137.4-73 180.1z" } }] }, "name": "google-square", "theme": "filled" };
var GoogleSquareFilledSvg = GoogleSquareFilled$2;

var GoogleSquareFilled = function GoogleSquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GoogleSquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  GoogleSquareFilled.displayName = 'GoogleSquareFilled';
}
var GoogleSquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(GoogleSquareFilled);

// This icon file is generated automatically.
var GroupOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M912 820.1V203.9c28-9.9 48-36.6 48-67.9 0-39.8-32.2-72-72-72-31.3 0-58 20-67.9 48H203.9C194 84 167.3 64 136 64c-39.8 0-72 32.2-72 72 0 31.3 20 58 48 67.9v616.2C84 830 64 856.7 64 888c0 39.8 32.2 72 72 72 31.3 0 58-20 67.9-48h616.2c9.9 28 36.6 48 67.9 48 39.8 0 72-32.2 72-72 0-31.3-20-58-48-67.9zM888 112c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zM136 912c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-752c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm704 680H184V184h656v656zm48 72c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z" } }, { "tag": "path", "attrs": { "d": "M288 474h448c8.8 0 16-7.2 16-16V282c0-8.8-7.2-16-16-16H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16zm56-136h336v64H344v-64zm-56 420h448c8.8 0 16-7.2 16-16V566c0-8.8-7.2-16-16-16H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16zm56-136h336v64H344v-64z" } }] }, "name": "group", "theme": "outlined" };
var GroupOutlinedSvg = GroupOutlined$2;

var GroupOutlined = function GroupOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GroupOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  GroupOutlined.displayName = 'GroupOutlined';
}
var GroupOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(GroupOutlined);

// This icon file is generated automatically.
var HddFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v224h704V96c0-17.7-14.3-32-32-32zM456 216c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zM160 928c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V704H160v224zm576-136c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM160 640h704V384H160v256zm96-152c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8v-48z" } }] }, "name": "hdd", "theme": "filled" };
var HddFilledSvg = HddFilled$2;

var HddFilled = function HddFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: HddFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  HddFilled.displayName = 'HddFilled';
}
var HddFilled$1 = /*#__PURE__*/React__namespace.forwardRef(HddFilled);

// This icon file is generated automatically.
var HddOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-600 72h560v208H232V136zm560 480H232V408h560v208zm0 272H232V680h560v208zM496 208H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 544h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm328 244a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "hdd", "theme": "outlined" };
var HddOutlinedSvg = HddOutlined$2;

var HddOutlined = function HddOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: HddOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  HddOutlined.displayName = 'HddOutlined';
}
var HddOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(HddOutlined);

// This icon file is generated automatically.
var HddTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M232 888h560V680H232v208zm448-140c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 616h560V408H232v208zm72-128c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8v-48zm-72-144h560V136H232v208zm72-128c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8v-48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V680h560v208zm0-272H232V408h560v208zm0-272H232V136h560v208z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M312 544h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-272h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm328 516a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }] }; }, "name": "hdd", "theme": "twotone" };
var HddTwoToneSvg = HddTwoTone$2;

var HddTwoTone = function HddTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: HddTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  HddTwoTone.displayName = 'HddTwoTone';
}
var HddTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(HddTwoTone);

// This icon file is generated automatically.
var HeartFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M923 283.6a260.04 260.04 0 00-56.9-82.8 264.4 264.4 0 00-84-55.5A265.34 265.34 0 00679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 00-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9z" } }] }, "name": "heart", "theme": "filled" };
var HeartFilledSvg = HeartFilled$2;

var HeartFilled = function HeartFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: HeartFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  HeartFilled.displayName = 'HeartFilled';
}
var HeartFilled$1 = /*#__PURE__*/React__namespace.forwardRef(HeartFilled);

// This icon file is generated automatically.
var HeartOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M923 283.6a260.04 260.04 0 00-56.9-82.8 264.4 264.4 0 00-84-55.5A265.34 265.34 0 00679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 00-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z" } }] }, "name": "heart", "theme": "outlined" };
var HeartOutlinedSvg = HeartOutlined$2;

var HeartOutlined = function HeartOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: HeartOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  HeartOutlined.displayName = 'HeartOutlined';
}
var HeartOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(HeartOutlined);

// This icon file is generated automatically.
var HeartTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M923 283.6a260.04 260.04 0 00-56.9-82.8 264.4 264.4 0 00-84-55.5A265.34 265.34 0 00679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 00-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M679.7 201c-73.1 0-136.5 40.8-167.7 100.4C480.8 241.8 417.4 201 344.3 201c-104 0-188.3 82.6-188.3 184.5 0 201.2 356 429.3 356 429.3s356-228.1 356-429.3C868 283.6 783.7 201 679.7 201z", "fill": secondaryColor } }] }; }, "name": "heart", "theme": "twotone" };
var HeartTwoToneSvg = HeartTwoTone$2;

var HeartTwoTone = function HeartTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: HeartTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  HeartTwoTone.displayName = 'HeartTwoTone';
}
var HeartTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(HeartTwoTone);

// This icon file is generated automatically.
var HeatMapOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-790.4-23.9L512 231.9 858.7 832H165.3zm319-474.1l-228 394c-12.3 21.3 3.1 48 27.7 48h455.8c24.7 0 40.1-26.7 27.7-48L539.7 358c-6.2-10.7-17-16-27.7-16-10.8 0-21.6 5.3-27.7 16zm214 386H325.7L512 422l186.3 322zm-214-194.1l-57 98.4C415 669.5 430.4 696 455 696h114c24.6 0 39.9-26.5 27.7-47.7l-57-98.4c-6.1-10.6-16.9-15.9-27.7-15.9s-21.5 5.3-27.7 15.9zm57.1 98.4h-58.7l29.4-50.7 29.3 50.7z" } }] }, "name": "heat-map", "theme": "outlined" };
var HeatMapOutlinedSvg = HeatMapOutlined$2;

var HeatMapOutlined = function HeatMapOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: HeatMapOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  HeatMapOutlined.displayName = 'HeatMapOutlined';
}
var HeatMapOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(HeatMapOutlined);

// This icon file is generated automatically.
var HighlightFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M957.6 507.4L603.2 158.2a7.9 7.9 0 00-11.2 0L353.3 393.4a8.03 8.03 0 00-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 00-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8V860c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6 40.4 39.8a7.9 7.9 0 0011.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0011.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2z" } }] }, "name": "highlight", "theme": "filled" };
var HighlightFilledSvg = HighlightFilled$2;

var HighlightFilled = function HighlightFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: HighlightFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  HighlightFilled.displayName = 'HighlightFilled';
}
var HighlightFilled$1 = /*#__PURE__*/React__namespace.forwardRef(HighlightFilled);

// This icon file is generated automatically.
var HighlightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M957.6 507.4L603.2 158.2a7.9 7.9 0 00-11.2 0L353.3 393.4a8.03 8.03 0 00-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 00-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8V860c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6 40.4 39.8a7.9 7.9 0 0011.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0011.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2zM389.8 796.2H229.6l134.4-133 80.1 78.9-54.3 54.1zm154.8-62.1L373.2 565.2l68.6-67.6 171.4 168.9-68.6 67.6zM713.1 658L450.3 399.1 597.6 254l262.8 259-147.3 145z" } }] }, "name": "highlight", "theme": "outlined" };
var HighlightOutlinedSvg = HighlightOutlined$2;

var HighlightOutlined = function HighlightOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: HighlightOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  HighlightOutlined.displayName = 'HighlightOutlined';
}
var HighlightOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(HighlightOutlined);

// This icon file is generated automatically.
var HighlightTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M229.6 796.3h160.2l54.3-54.1-80.1-78.9zm220.7-397.1l262.8 258.9 147.3-145-262.8-259zm-77.1 166.1l171.4 168.9 68.6-67.6-171.4-168.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M957.6 507.5L603.2 158.3a7.9 7.9 0 00-11.2 0L353.3 393.5a8.03 8.03 0 00-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 00-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8v55.2c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6L539 830a7.9 7.9 0 0011.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0011.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2zM389.8 796.3H229.6l134.4-133 80.1 78.9-54.3 54.1zm154.8-62.1L373.2 565.3l68.6-67.6 171.4 168.9-68.6 67.6zm168.5-76.1L450.3 399.2l147.3-145.1 262.8 259-147.3 145z", "fill": primaryColor } }] }; }, "name": "highlight", "theme": "twotone" };
var HighlightTwoToneSvg = HighlightTwoTone$2;

var HighlightTwoTone = function HighlightTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: HighlightTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  HighlightTwoTone.displayName = 'HighlightTwoTone';
}
var HighlightTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(HighlightTwoTone);

// This icon file is generated automatically.
var HistoryOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M536.1 273H488c-4.4 0-8 3.6-8 8v275.3c0 2.6 1.2 5 3.3 6.5l165.3 120.7c3.6 2.6 8.6 1.9 11.2-1.7l28.6-39c2.7-3.7 1.9-8.7-1.7-11.2L544.1 528.5V281c0-4.4-3.6-8-8-8zm219.8 75.2l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3L752.9 334.1a8 8 0 003 14.1zm167.7 301.1l-56.7-19.5a8 8 0 00-10.1 4.8c-1.9 5.1-3.9 10.1-6 15.1-17.8 42.1-43.3 80-75.9 112.5a353 353 0 01-112.5 75.9 352.18 352.18 0 01-137.7 27.8c-47.8 0-94.1-9.3-137.7-27.8a353 353 0 01-112.5-75.9c-32.5-32.5-58-70.4-75.9-112.5A353.44 353.44 0 01171 512c0-47.8 9.3-94.2 27.8-137.8 17.8-42.1 43.3-80 75.9-112.5a353 353 0 01112.5-75.9C430.6 167.3 477 158 524.8 158s94.1 9.3 137.7 27.8A353 353 0 01775 261.7c10.2 10.3 19.8 21 28.6 32.3l59.8-46.8C784.7 146.6 662.2 81.9 524.6 82 285 82.1 92.6 276.7 95 516.4 97.4 751.9 288.9 942 524.8 942c185.5 0 343.5-117.6 403.7-282.3 1.5-4.2-.7-8.9-4.9-10.4z" } }] }, "name": "history", "theme": "outlined" };
var HistoryOutlinedSvg = HistoryOutlined$2;

var HistoryOutlined = function HistoryOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: HistoryOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  HistoryOutlined.displayName = 'HistoryOutlined';
}
var HistoryOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(HistoryOutlined);

// This icon file is generated automatically.
var HolderOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z" } }] }, "name": "holder", "theme": "outlined" };
var HolderOutlinedSvg = HolderOutlined$2;

var HolderOutlined = function HolderOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: HolderOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  HolderOutlined.displayName = 'HolderOutlined';
}
var HolderOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(HolderOutlined);

// This icon file is generated automatically.
var HomeFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M946.5 505L534.6 93.4a31.93 31.93 0 00-45.2 0L77.5 505c-12 12-18.8 28.3-18.8 45.3 0 35.3 28.7 64 64 64h43.4V908c0 17.7 14.3 32 32 32H448V716h112v224h265.9c17.7 0 32-14.3 32-32V614.3h43.4c17 0 33.3-6.7 45.3-18.8 24.9-25 24.9-65.5-.1-90.5z" } }] }, "name": "home", "theme": "filled" };
var HomeFilledSvg = HomeFilled$2;

var HomeFilled = function HomeFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: HomeFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  HomeFilled.displayName = 'HomeFilled';
}
var HomeFilled$1 = /*#__PURE__*/React__namespace.forwardRef(HomeFilled);

// This icon file is generated automatically.
var HomeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M946.5 505L560.1 118.8l-25.9-25.9a31.5 31.5 0 00-44.4 0L77.5 505a63.9 63.9 0 00-18.8 46c.4 35.2 29.7 63.3 64.9 63.3h42.5V940h691.8V614.3h43.4c17.1 0 33.2-6.7 45.3-18.8a63.6 63.6 0 0018.7-45.3c0-17-6.7-33.1-18.8-45.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z" } }] }, "name": "home", "theme": "outlined" };
var HomeOutlinedSvg = HomeOutlined$2;

var HomeOutlined = function HomeOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: HomeOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  HomeOutlined.displayName = 'HomeOutlined';
}
var HomeOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(HomeOutlined);

// This icon file is generated automatically.
var HomeTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512.1 172.6l-370 369.7h96V868H392V640c0-22.1 17.9-40 40-40h160c22.1 0 40 17.9 40 40v228h153.9V542.3H882L535.2 195.7l-23.1-23.1zm434.5 422.9c-6 6-13.1 10.8-20.8 13.9 7.7-3.2 14.8-7.9 20.8-13.9zm-887-34.7c5 30.3 31.4 53.5 63.1 53.5h.9c-31.9 0-58.9-23-64-53.5zm-.9-10.5v-1.9 1.9zm.1-2.6c.1-3.1.5-6.1 1-9.1-.6 2.9-.9 6-1 9.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M951 510c0-.1-.1-.1-.1-.2l-1.8-2.1c-.1-.1-.2-.3-.4-.4-.7-.8-1.5-1.6-2.2-2.4L560.1 118.8l-25.9-25.9a31.5 31.5 0 00-44.4 0L77.5 505a63.6 63.6 0 00-16 26.6l-.6 2.1-.3 1.1-.3 1.2c-.2.7-.3 1.4-.4 2.1 0 .1 0 .3-.1.4-.6 3-.9 6-1 9.1v3.3c0 .5 0 1 .1 1.5 0 .5 0 .9.1 1.4 0 .5.1 1 .1 1.5 0 .6.1 1.2.2 1.8 0 .3.1.6.1.9l.3 2.5v.1c5.1 30.5 32.2 53.5 64 53.5h42.5V940h691.7V614.3h43.4c8.6 0 16.9-1.7 24.5-4.9s14.7-7.9 20.8-13.9a63.6 63.6 0 0018.7-45.3c0-14.7-5-28.8-14.3-40.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z", "fill": primaryColor } }] }; }, "name": "home", "theme": "twotone" };
var HomeTwoToneSvg = HomeTwoTone$2;

var HomeTwoTone = function HomeTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: HomeTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  HomeTwoTone.displayName = 'HomeTwoTone';
}
var HomeTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(HomeTwoTone);

// This icon file is generated automatically.
var HourglassFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194z" } }] }, "name": "hourglass", "theme": "filled" };
var HourglassFilledSvg = HourglassFilled$2;

var HourglassFilled = function HourglassFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: HourglassFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  HourglassFilled.displayName = 'HourglassFilled';
}
var HourglassFilled$1 = /*#__PURE__*/React__namespace.forwardRef(HourglassFilled);

// This icon file is generated automatically.
var HourglassOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194zm-72 388v134H354V706c0-42.2 16.4-81.9 46.3-111.7C430.1 564.4 469.8 548 512 548s81.9 16.4 111.7 46.3C653.6 624.1 670 663.8 670 706zm0-388c0 42.2-16.4 81.9-46.3 111.7C593.9 459.6 554.2 476 512 476s-81.9-16.4-111.7-46.3A156.63 156.63 0 01354 318V184h316v134z" } }] }, "name": "hourglass", "theme": "outlined" };
var HourglassOutlinedSvg = HourglassOutlined$2;

var HourglassOutlined = function HourglassOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: HourglassOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  HourglassOutlined.displayName = 'HourglassOutlined';
}
var HourglassOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(HourglassOutlined);

// This icon file is generated automatically.
var HourglassTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 548c-42.2 0-81.9 16.4-111.7 46.3A156.63 156.63 0 00354 706v134h316V706c0-42.2-16.4-81.9-46.3-111.7A156.63 156.63 0 00512 548zM354 318c0 42.2 16.4 81.9 46.3 111.7C430.1 459.6 469.8 476 512 476s81.9-16.4 111.7-46.3C653.6 399.9 670 360.2 670 318V184H354v134z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194zm-72 388v134H354V706c0-42.2 16.4-81.9 46.3-111.7C430.1 564.4 469.8 548 512 548s81.9 16.4 111.7 46.3C653.6 624.1 670 663.8 670 706zm0-388c0 42.2-16.4 81.9-46.3 111.7C593.9 459.6 554.2 476 512 476s-81.9-16.4-111.7-46.3A156.63 156.63 0 01354 318V184h316v134z", "fill": primaryColor } }] }; }, "name": "hourglass", "theme": "twotone" };
var HourglassTwoToneSvg = HourglassTwoTone$2;

var HourglassTwoTone = function HourglassTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: HourglassTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  HourglassTwoTone.displayName = 'HourglassTwoTone';
}
var HourglassTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(HourglassTwoTone);

// This icon file is generated automatically.
var Html5Filled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M145.2 96l66 746.6L512 928l299.6-85.4L878.9 96H145.2zm595 177.1l-4.8 47.2-1.7 19.5H382.3l8.2 94.2h335.1l-3.3 24.3-21.2 242.2-1.7 16.2-187 51.6v.3h-1.2l-.3.1v-.1h-.1l-188.6-52L310.8 572h91.1l6.5 73.2 102.4 27.7h.4l102-27.6 11.4-118.6H510.9v-.1H306l-22.8-253.5-1.7-24.3h460.3l-1.6 24.3z" } }] }, "name": "html5", "theme": "filled" };
var Html5FilledSvg = Html5Filled$2;

var Html5Filled = function Html5Filled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: Html5FilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  Html5Filled.displayName = 'Html5Filled';
}
var Html5Filled$1 = /*#__PURE__*/React__namespace.forwardRef(Html5Filled);

// This icon file is generated automatically.
var Html5Outlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M145 96l66 746.6L511.8 928l299.6-85.4L878.7 96H145zm610.9 700.6l-244.1 69.6-245.2-69.6-56.7-641.2h603.8l-57.8 641.2zM281 249l1.7 24.3 22.7 253.5h206.5v-.1h112.9l-11.4 118.5L511 672.9v.2h-.8l-102.4-27.7-6.5-73.2h-91l11.3 144.7 188.6 52h1.7v-.4l187.7-51.7 1.7-16.3 21.2-242.2 3.2-24.3H511v.2H389.9l-8.2-94.2h352.1l1.7-19.5 4.8-47.2L742 249H511z" } }] }, "name": "html5", "theme": "outlined" };
var Html5OutlinedSvg = Html5Outlined$2;

var Html5Outlined = function Html5Outlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: Html5OutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  Html5Outlined.displayName = 'Html5Outlined';
}
var Html5Outlined$1 = /*#__PURE__*/React__namespace.forwardRef(Html5Outlined);

// This icon file is generated automatically.
var Html5TwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M145 96l66 746.6L511.8 928l299.6-85.4L878.7 96H145zm610.9 700.6l-244.1 69.6-245.2-69.6-56.7-641.2h603.8l-57.8 641.2z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M209.9 155.4l56.7 641.2 245.2 69.6 244.1-69.6 57.8-641.2H209.9zm530.4 117.9l-4.8 47.2-1.7 19.5H381.7l8.2 94.2H511v-.2h214.7l-3.2 24.3-21.2 242.2-1.7 16.3-187.7 51.7v.4h-1.7l-188.6-52-11.3-144.7h91l6.5 73.2 102.4 27.7h.8v-.2l102.4-27.7 11.4-118.5H511.9v.1H305.4l-22.7-253.5L281 249h461l-1.7 24.3z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M281 249l1.7 24.3 22.7 253.5h206.5v-.1h112.9l-11.4 118.5L511 672.9v.2h-.8l-102.4-27.7-6.5-73.2h-91l11.3 144.7 188.6 52h1.7v-.4l187.7-51.7 1.7-16.3 21.2-242.2 3.2-24.3H511v.2H389.9l-8.2-94.2h352.1l1.7-19.5 4.8-47.2L742 249H511z", "fill": primaryColor } }] }; }, "name": "html5", "theme": "twotone" };
var Html5TwoToneSvg = Html5TwoTone$2;

var Html5TwoTone = function Html5TwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: Html5TwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  Html5TwoTone.displayName = 'Html5TwoTone';
}
var Html5TwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(Html5TwoTone);

// This icon file is generated automatically.
var IdcardFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M373 411c-28.5 0-51.7 23.3-51.7 52s23.2 52 51.7 52 51.7-23.3 51.7-52-23.2-52-51.7-52zm555-251H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zM608 420c0-4.4 1-8 2.3-8h123.4c1.3 0 2.3 3.6 2.3 8v48c0 4.4-1 8-2.3 8H610.3c-1.3 0-2.3-3.6-2.3-8v-48zm-86 253h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H224a8 8 0 01-8-8.4c2.8-53.3 32-99.7 74.6-126.1a111.8 111.8 0 01-29.1-75.5c0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.5-29.1 75.5 42.7 26.5 71.8 72.8 74.6 126.1.4 4.6-3.2 8.4-7.8 8.4zm278.9-53H615.1c-3.9 0-7.1-3.6-7.1-8v-48c0-4.4 3.2-8 7.1-8h185.7c3.9 0 7.1 3.6 7.1 8v48h.1c0 4.4-3.2 8-7.1 8z" } }] }, "name": "idcard", "theme": "filled" };
var IdcardFilledSvg = IdcardFilled$2;

var IdcardFilled = function IdcardFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: IdcardFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  IdcardFilled.displayName = 'IdcardFilled';
}
var IdcardFilled$1 = /*#__PURE__*/React__namespace.forwardRef(IdcardFilled);

// This icon file is generated automatically.
var IdcardOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560zM610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 008-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0029.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 00-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z" } }] }, "name": "idcard", "theme": "outlined" };
var IdcardOutlinedSvg = IdcardOutlined$2;

var IdcardOutlined = function IdcardOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: IdcardOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  IdcardOutlined.displayName = 'IdcardOutlined';
}
var IdcardOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(IdcardOutlined);

// This icon file is generated automatically.
var IdcardTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M136 792h752V232H136v560zm472-372c0-4.4 1-8 2.3-8h123.4c1.3 0 2.3 3.6 2.3 8v48c0 4.4-1 8-2.3 8H610.3c-1.3 0-2.3-3.6-2.3-8v-48zm0 144c0-4.4 3.2-8 7.1-8h185.7c3.9 0 7.1 3.6 7.1 8v48c0 4.4-3.2 8-7.1 8H615.1c-3.9 0-7.1-3.6-7.1-8v-48zM216.2 664.6c2.8-53.3 31.9-99.6 74.6-126.1-18.1-20-29.1-46.4-29.1-75.5 0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.6-29.1 75.5 42.6 26.4 71.8 72.8 74.6 126.1a8 8 0 01-8 8.4h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H224c-4.6 0-8.2-3.8-7.8-8.4z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M321.3 463a51.7 52 0 10103.4 0 51.7 52 0 10-103.4 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 008-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0029.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 00-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z", "fill": primaryColor } }] }; }, "name": "idcard", "theme": "twotone" };
var IdcardTwoToneSvg = IdcardTwoTone$2;

var IdcardTwoTone = function IdcardTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: IdcardTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  IdcardTwoTone.displayName = 'IdcardTwoTone';
}
var IdcardTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(IdcardTwoTone);

// This icon file is generated automatically.
var IeCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M693.6 284.4c-24 0-51.1 11.7-72.6 22 46.3 18 86 57.3 112.3 99.6 7.1-18.9 14.6-47.9 14.6-67.9 0-32-22.8-53.7-54.3-53.7zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm253.9 492.9H437.1c0 100.4 144.3 136 196.8 47.4h120.8c-32.6 91.7-119.7 146-216.8 146-35.1 0-70.3-.1-101.7-15.6-87.4 44.5-180.3 56.6-180.3-42 0-45.8 23.2-107.1 44-145C335 484 381.3 422.8 435.6 374.5c-43.7 18.9-91.1 66.3-122 101.2 25.9-112.8 129.5-193.6 237.1-186.5 130-59.8 209.7-34.1 209.7 38.6 0 27.4-10.6 63.3-21.4 87.9 25.2 45.5 33.3 97.6 26.9 141.2zM540.5 399.1c-53.7 0-102 39.7-104 94.9h208c-2-55.1-50.6-94.9-104-94.9zM320.6 602.9c-73 152.4 11.5 172.2 100.3 123.3-46.6-27.5-82.6-72.2-100.3-123.3z" } }] }, "name": "ie-circle", "theme": "filled" };
var IeCircleFilledSvg = IeCircleFilled$2;

var IeCircleFilled = function IeCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: IeCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  IeCircleFilled.displayName = 'IeCircleFilled';
}
var IeCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(IeCircleFilled);

// This icon file is generated automatically.
var IeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M852.6 367.6c16.3-36.9 32.1-90.7 32.1-131.8 0-109.1-119.5-147.6-314.5-57.9-161.4-10.8-316.8 110.5-355.6 279.7 46.3-52.3 117.4-123.4 183-151.7C316.1 378.3 246.7 470 194 565.6c-31.1 56.9-66 148.8-66 217.5 0 147.9 139.3 129.8 270.4 63 47.1 23.1 99.8 23.4 152.5 23.4 145.7 0 276.4-81.4 325.2-219H694.9c-78.8 132.9-295.2 79.5-295.2-71.2h493.2c9.6-65.4-2.5-143.6-40.3-211.7zM224.8 648.3c26.6 76.7 80.6 143.8 150.4 185-133.1 73.4-259.9 43.6-150.4-185zm174-163.3c3-82.7 75.4-142.3 156-142.3 80.1 0 153 59.6 156 142.3h-312zm276.8-281.4c32.1-15.4 72.8-33 108.8-33 47.1 0 81.4 32.6 81.4 80.6 0 30-11.1 73.5-21.9 101.8-39.3-63.5-98.9-122.4-168.3-149.4z" } }] }, "name": "ie", "theme": "outlined" };
var IeOutlinedSvg = IeOutlined$2;

var IeOutlined = function IeOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: IeOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  IeOutlined.displayName = 'IeOutlined';
}
var IeOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(IeOutlined);

// This icon file is generated automatically.
var IeSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM765.9 556.9H437.1c0 100.4 144.3 136 196.8 47.4h120.8c-32.6 91.7-119.7 146-216.8 146-35.1 0-70.3-.1-101.7-15.6-87.4 44.5-180.3 56.6-180.3-42 0-45.8 23.2-107.1 44-145C335 484 381.3 422.8 435.6 374.5c-43.7 18.9-91.1 66.3-122 101.2 25.9-112.8 129.5-193.6 237.1-186.5 130-59.8 209.7-34.1 209.7 38.6 0 27.4-10.6 63.3-21.4 87.9 25.2 45.5 33.3 97.6 26.9 141.2zm-72.3-272.5c-24 0-51.1 11.7-72.6 22 46.3 18 86 57.3 112.3 99.6 7.1-18.9 14.6-47.9 14.6-67.9 0-32-22.8-53.7-54.3-53.7zM540.5 399.1c-53.7 0-102 39.7-104 94.9h208c-2-55.1-50.6-94.9-104-94.9zM320.6 602.9c-73 152.4 11.5 172.2 100.3 123.3-46.6-27.5-82.6-72.2-100.3-123.3z" } }] }, "name": "ie-square", "theme": "filled" };
var IeSquareFilledSvg = IeSquareFilled$2;

var IeSquareFilled = function IeSquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: IeSquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  IeSquareFilled.displayName = 'IeSquareFilled';
}
var IeSquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(IeSquareFilled);

// This icon file is generated automatically.
var ImportOutlined$2 = { "icon": { "tag": "svg", "attrs": { "fill-rule": "evenodd", "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 912H144c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32h360c4.4 0 8 3.6 8 8v56c0 4.4-3.6 8-8 8H184v656h656V520c0-4.4 3.6-8 8-8h56c4.4 0 8 3.6 8 8v360c0 17.7-14.3 32-32 32zM653.3 424.6l52.2 52.2a8.01 8.01 0 01-4.7 13.6l-179.4 21c-5.1.6-9.5-3.7-8.9-8.9l21-179.4c.8-6.6 8.9-9.4 13.6-4.7l52.4 52.4 256.2-256.2c3.1-3.1 8.2-3.1 11.3 0l42.4 42.4c3.1 3.1 3.1 8.2 0 11.3L653.3 424.6z" } }] }, "name": "import", "theme": "outlined" };
var ImportOutlinedSvg = ImportOutlined$2;

var ImportOutlined = function ImportOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ImportOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ImportOutlined.displayName = 'ImportOutlined';
}
var ImportOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ImportOutlined);

// This icon file is generated automatically.
var InboxOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M885.2 446.3l-.2-.8-112.2-285.1c-5-16.1-19.9-27.2-36.8-27.2H281.2c-17 0-32.1 11.3-36.9 27.6L139.4 443l-.3.7-.2.8c-1.3 4.9-1.7 9.9-1 14.8-.1 1.6-.2 3.2-.2 4.8V830a60.9 60.9 0 0060.8 60.8h627.2c33.5 0 60.8-27.3 60.9-60.8V464.1c0-1.3 0-2.6-.1-3.7.4-4.9 0-9.6-1.3-14.1zm-295.8-43l-.3 15.7c-.8 44.9-31.8 75.1-77.1 75.1-22.1 0-41.1-7.1-54.8-20.6S436 441.2 435.6 419l-.3-15.7H229.5L309 210h399.2l81.7 193.3H589.4zm-375 76.8h157.3c24.3 57.1 76 90.8 140.4 90.8 33.7 0 65-9.4 90.3-27.2 22.2-15.6 39.5-37.4 50.7-63.6h156.5V814H214.4V480.1z" } }] }, "name": "inbox", "theme": "outlined" };
var InboxOutlinedSvg = InboxOutlined$2;

var InboxOutlined = function InboxOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: InboxOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  InboxOutlined.displayName = 'InboxOutlined';
}
var InboxOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(InboxOutlined);

// This icon file is generated automatically.
var InfoCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "info-circle", "theme": "filled" };
var InfoCircleFilledSvg = InfoCircleFilled$2;

var InfoCircleFilled = function InfoCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: InfoCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  InfoCircleFilled.displayName = 'InfoCircleFilled';
}
var InfoCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(InfoCircleFilled);

// This icon file is generated automatically.
var InfoCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z" } }] }, "name": "info-circle", "theme": "outlined" };
var InfoCircleOutlinedSvg = InfoCircleOutlined$2;

var InfoCircleOutlined = function InfoCircleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: InfoCircleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  InfoCircleOutlined.displayName = 'InfoCircleOutlined';
}
var InfoCircleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(InfoCircleOutlined);

// This icon file is generated automatically.
var InfoCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm32 588c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "info-circle", "theme": "twotone" };
var InfoCircleTwoToneSvg = InfoCircleTwoTone$2;

var InfoCircleTwoTone = function InfoCircleTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: InfoCircleTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  InfoCircleTwoTone.displayName = 'InfoCircleTwoTone';
}
var InfoCircleTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(InfoCircleTwoTone);

// This icon file is generated automatically.
var InfoOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M448 224a64 64 0 10128 0 64 64 0 10-128 0zm96 168h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V400c0-4.4-3.6-8-8-8z" } }] }, "name": "info", "theme": "outlined" };
var InfoOutlinedSvg = InfoOutlined$2;

var InfoOutlined = function InfoOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: InfoOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  InfoOutlined.displayName = 'InfoOutlined';
}
var InfoOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(InfoOutlined);

// This icon file is generated automatically.
var InsertRowAboveOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M878.7 336H145.3c-18.4 0-33.3 14.3-33.3 32v464c0 17.7 14.9 32 33.3 32h733.3c18.4 0 33.3-14.3 33.3-32V368c.1-17.7-14.8-32-33.2-32zM360 792H184V632h176v160zm0-224H184V408h176v160zm240 224H424V632h176v160zm0-224H424V408h176v160zm240 224H664V632h176v160zm0-224H664V408h176v160zm64-408H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8z" } }] }, "name": "insert-row-above", "theme": "outlined" };
var InsertRowAboveOutlinedSvg = InsertRowAboveOutlined$2;

var InsertRowAboveOutlined = function InsertRowAboveOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: InsertRowAboveOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  InsertRowAboveOutlined.displayName = 'InsertRowAboveOutlined';
}
var InsertRowAboveOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(InsertRowAboveOutlined);

// This icon file is generated automatically.
var InsertRowBelowOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M904 768H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8zm-25.3-608H145.3c-18.4 0-33.3 14.3-33.3 32v464c0 17.7 14.9 32 33.3 32h733.3c18.4 0 33.3-14.3 33.3-32V192c.1-17.7-14.8-32-33.2-32zM360 616H184V456h176v160zm0-224H184V232h176v160zm240 224H424V456h176v160zm0-224H424V232h176v160zm240 224H664V456h176v160zm0-224H664V232h176v160z" } }] }, "name": "insert-row-below", "theme": "outlined" };
var InsertRowBelowOutlinedSvg = InsertRowBelowOutlined$2;

var InsertRowBelowOutlined = function InsertRowBelowOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: InsertRowBelowOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  InsertRowBelowOutlined.displayName = 'InsertRowBelowOutlined';
}
var InsertRowBelowOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(InsertRowBelowOutlined);

// This icon file is generated automatically.
var InsertRowLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M248 112h-80c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8zm584 0H368c-17.7 0-32 14.9-32 33.3v733.3c0 18.4 14.3 33.3 32 33.3h464c17.7 0 32-14.9 32-33.3V145.3c0-18.4-14.3-33.3-32-33.3zM568 840H408V664h160v176zm0-240H408V424h160v176zm0-240H408V184h160v176zm224 480H632V664h160v176zm0-240H632V424h160v176zm0-240H632V184h160v176z" } }] }, "name": "insert-row-left", "theme": "outlined" };
var InsertRowLeftOutlinedSvg = InsertRowLeftOutlined$2;

var InsertRowLeftOutlined = function InsertRowLeftOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: InsertRowLeftOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  InsertRowLeftOutlined.displayName = 'InsertRowLeftOutlined';
}
var InsertRowLeftOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(InsertRowLeftOutlined);

// This icon file is generated automatically.
var InsertRowRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M856 112h-80c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8zm-200 0H192c-17.7 0-32 14.9-32 33.3v733.3c0 18.4 14.3 33.3 32 33.3h464c17.7 0 32-14.9 32-33.3V145.3c0-18.4-14.3-33.3-32-33.3zM392 840H232V664h160v176zm0-240H232V424h160v176zm0-240H232V184h160v176zm224 480H456V664h160v176zm0-240H456V424h160v176zm0-240H456V184h160v176z" } }] }, "name": "insert-row-right", "theme": "outlined" };
var InsertRowRightOutlinedSvg = InsertRowRightOutlined$2;

var InsertRowRightOutlined = function InsertRowRightOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: InsertRowRightOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  InsertRowRightOutlined.displayName = 'InsertRowRightOutlined';
}
var InsertRowRightOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(InsertRowRightOutlined);

// This icon file is generated automatically.
var InstagramFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 378.7c-73.4 0-133.3 59.9-133.3 133.3S438.6 645.3 512 645.3 645.3 585.4 645.3 512 585.4 378.7 512 378.7zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zM512 717.1c-113.5 0-205.1-91.6-205.1-205.1S398.5 306.9 512 306.9 717.1 398.5 717.1 512 625.5 717.1 512 717.1zm213.5-370.7c-26.5 0-47.9-21.4-47.9-47.9s21.4-47.9 47.9-47.9 47.9 21.4 47.9 47.9a47.84 47.84 0 01-47.9 47.9z" } }] }, "name": "instagram", "theme": "filled" };
var InstagramFilledSvg = InstagramFilled$2;

var InstagramFilled = function InstagramFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: InstagramFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  InstagramFilled.displayName = 'InstagramFilled';
}
var InstagramFilled$1 = /*#__PURE__*/React__namespace.forwardRef(InstagramFilled);

// This icon file is generated automatically.
var InstagramOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 306.9c-113.5 0-205.1 91.6-205.1 205.1S398.5 717.1 512 717.1 717.1 625.5 717.1 512 625.5 306.9 512 306.9zm0 338.4c-73.4 0-133.3-59.9-133.3-133.3S438.6 378.7 512 378.7 645.3 438.6 645.3 512 585.4 645.3 512 645.3zm213.5-394.6c-26.5 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9 47.9-21.3 47.9-47.9a47.84 47.84 0 00-47.9-47.9zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zm-88 235.8c-7.3 18.2-16.1 31.8-30.2 45.8-14.1 14.1-27.6 22.9-45.8 30.2C695.2 844.7 570.3 840 512 840c-58.3 0-183.3 4.7-235.9-16.1-18.2-7.3-31.8-16.1-45.8-30.2-14.1-14.1-22.9-27.6-30.2-45.8C179.3 695.2 184 570.3 184 512c0-58.3-4.7-183.3 16.1-235.9 7.3-18.2 16.1-31.8 30.2-45.8s27.6-22.9 45.8-30.2C328.7 179.3 453.7 184 512 184s183.3-4.7 235.9 16.1c18.2 7.3 31.8 16.1 45.8 30.2 14.1 14.1 22.9 27.6 30.2 45.8C844.7 328.7 840 453.7 840 512c0 58.3 4.7 183.2-16.2 235.8z" } }] }, "name": "instagram", "theme": "outlined" };
var InstagramOutlinedSvg = InstagramOutlined$2;

var InstagramOutlined = function InstagramOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: InstagramOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  InstagramOutlined.displayName = 'InstagramOutlined';
}
var InstagramOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(InstagramOutlined);

// This icon file is generated automatically.
var InsuranceFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M519.9 358.8h97.9v41.6h-97.9zm347-188.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM411.3 656h-.2c0 4.4-3.6 8-8 8h-37.3c-4.4 0-8-3.6-8-8V471.4c-7.7 9.2-15.4 17.9-23.1 26a6.04 6.04 0 01-10.2-2.4l-13.2-43.5c-.6-2-.2-4.1 1.2-5.6 37-43.4 64.7-95.1 82.2-153.6 1.1-3.5 5-5.3 8.4-3.7l38.6 18.3c2.7 1.3 4.1 4.4 3.2 7.2a429.2 429.2 0 01-33.6 79V656zm296.5-49.2l-26.3 35.3a5.92 5.92 0 01-8.9.7c-30.6-29.3-56.8-65.2-78.1-106.9V656c0 4.4-3.6 8-8 8h-36.2c-4.4 0-8-3.6-8-8V536c-22 44.7-49 80.8-80.6 107.6a5.9 5.9 0 01-8.9-1.4L430 605.7a6 6 0 011.6-8.1c28.6-20.3 51.9-45.2 71-76h-55.1c-4.4 0-8-3.6-8-8V478c0-4.4 3.6-8 8-8h94.9v-18.6h-65.9c-4.4 0-8-3.6-8-8V316c0-4.4 3.6-8 8-8h184.7c4.4 0 8 3.6 8 8v127.2c0 4.4-3.6 8-8 8h-66.7v18.6h98.8c4.4 0 8 3.6 8 8v35.6c0 4.4-3.6 8-8 8h-59c18.1 29.1 41.8 54.3 72.3 76.9 2.6 2.1 3.2 5.9 1.2 8.5z" } }] }, "name": "insurance", "theme": "filled" };
var InsuranceFilledSvg = InsuranceFilled$2;

var InsuranceFilled = function InsuranceFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: InsuranceFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  InsuranceFilled.displayName = 'InsuranceFilled';
}
var InsuranceFilled$1 = /*#__PURE__*/React__namespace.forwardRef(InsuranceFilled);

// This icon file is generated automatically.
var InsuranceOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M441.6 306.8L403 288.6a6.1 6.1 0 00-8.4 3.7c-17.5 58.5-45.2 110.1-82.2 153.6a6.05 6.05 0 00-1.2 5.6l13.2 43.5c1.3 4.4 7 5.7 10.2 2.4 7.7-8.1 15.4-16.9 23.1-26V656c0 4.4 3.6 8 8 8H403c4.4 0 8-3.6 8-8V393.1a429.2 429.2 0 0033.6-79c1-2.9-.3-6-3-7.3zm26.8 9.2v127.2c0 4.4 3.6 8 8 8h65.9v18.6h-94.9c-4.4 0-8 3.6-8 8v35.6c0 4.4 3.6 8 8 8h55.1c-19.1 30.8-42.4 55.7-71 76a6 6 0 00-1.6 8.1l22.8 36.5c1.9 3.1 6.2 3.8 8.9 1.4 31.6-26.8 58.7-62.9 80.6-107.6v120c0 4.4 3.6 8 8 8h36.2c4.4 0 8-3.6 8-8V536c21.3 41.7 47.5 77.5 78.1 106.9 2.6 2.5 6.8 2.1 8.9-.7l26.3-35.3c2-2.7 1.4-6.5-1.2-8.4-30.5-22.6-54.2-47.8-72.3-76.9h59c4.4 0 8-3.6 8-8V478c0-4.4-3.6-8-8-8h-98.8v-18.6h66.7c4.4 0 8-3.6 8-8V316c0-4.4-3.6-8-8-8H476.4c-4.4 0-8 3.6-8 8zm51.5 42.8h97.9v41.6h-97.9v-41.6zm347-188.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z" } }] }, "name": "insurance", "theme": "outlined" };
var InsuranceOutlinedSvg = InsuranceOutlined$2;

var InsuranceOutlined = function InsuranceOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: InsuranceOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  InsuranceOutlined.displayName = 'InsuranceOutlined';
}
var InsuranceOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(InsuranceOutlined);

// This icon file is generated automatically.
var InsuranceTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M521.9 358.8h97.9v41.6h-97.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM413.3 656h-.2c0 4.4-3.6 8-8 8h-37.3c-4.4 0-8-3.6-8-8V471.4c-7.7 9.2-15.4 17.9-23.1 26a6.04 6.04 0 01-10.2-2.4l-13.2-43.5c-.6-2-.2-4.1 1.2-5.6 37-43.4 64.7-95.1 82.2-153.6 1.1-3.5 5-5.3 8.4-3.7l38.6 18.3c2.7 1.3 4.1 4.4 3.2 7.2a429.2 429.2 0 01-33.6 79V656zm257.9-340v127.2c0 4.4-3.6 8-8 8h-66.7v18.6h98.8c4.4 0 8 3.6 8 8v35.6c0 4.4-3.6 8-8 8h-59c18.1 29.1 41.8 54.3 72.3 76.9 2.6 2.1 3.2 5.9 1.2 8.5l-26.3 35.3a5.92 5.92 0 01-8.9.7c-30.6-29.3-56.8-65.2-78.1-106.9V656c0 4.4-3.6 8-8 8h-36.2c-4.4 0-8-3.6-8-8V536c-22 44.7-49 80.8-80.6 107.6a6.38 6.38 0 01-4.8 1.4c-1.7-.3-3.2-1.3-4.1-2.8L432 605.7a6 6 0 011.6-8.1c28.6-20.3 51.9-45.2 71-76h-55.1c-4.4 0-8-3.6-8-8V478c0-4.4 3.6-8 8-8h94.9v-18.6h-65.9c-4.4 0-8-3.6-8-8V316c0-4.4 3.6-8 8-8h184.7c4.4 0 8 3.6 8 8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M443.7 306.9l-38.6-18.3c-3.4-1.6-7.3.2-8.4 3.7-17.5 58.5-45.2 110.2-82.2 153.6a5.7 5.7 0 00-1.2 5.6l13.2 43.5c1.4 4.5 7 5.8 10.2 2.4 7.7-8.1 15.4-16.8 23.1-26V656c0 4.4 3.6 8 8 8h37.3c4.4 0 8-3.6 8-8h.2V393.1a429.2 429.2 0 0033.6-79c.9-2.8-.5-5.9-3.2-7.2zm26.8 9.1v127.4c0 4.4 3.6 8 8 8h65.9V470h-94.9c-4.4 0-8 3.6-8 8v35.6c0 4.4 3.6 8 8 8h55.1c-19.1 30.8-42.4 55.7-71 76a6 6 0 00-1.6 8.1l22.8 36.5c.9 1.5 2.4 2.5 4.1 2.8 1.7.3 3.5-.2 4.8-1.4 31.6-26.8 58.6-62.9 80.6-107.6v120c0 4.4 3.6 8 8 8h36.2c4.4 0 8-3.6 8-8V535.9c21.3 41.7 47.5 77.6 78.1 106.9 2.6 2.5 6.7 2.2 8.9-.7l26.3-35.3c2-2.6 1.4-6.4-1.2-8.5-30.5-22.6-54.2-47.8-72.3-76.9h59c4.4 0 8-3.6 8-8v-35.6c0-4.4-3.6-8-8-8h-98.8v-18.6h66.7c4.4 0 8-3.6 8-8V316c0-4.4-3.6-8-8-8H478.5c-4.4 0-8 3.6-8 8zm51.4 42.8h97.9v41.6h-97.9v-41.6z", "fill": primaryColor } }] }; }, "name": "insurance", "theme": "twotone" };
var InsuranceTwoToneSvg = InsuranceTwoTone$2;

var InsuranceTwoTone = function InsuranceTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: InsuranceTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  InsuranceTwoTone.displayName = 'InsuranceTwoTone';
}
var InsuranceTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(InsuranceTwoTone);

// This icon file is generated automatically.
var InteractionFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM726 585.7c0 55.3-44.7 100.1-99.7 100.1H420.6v53.4c0 5.7-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.7l109.1-85.7c4.4-3.5 10.9-.3 10.9 5.3v53.4h205.7c19.6 0 35.5-16 35.5-35.6v-78.9c0-3.7 3-6.8 6.8-6.8h50.7c3.7 0 6.8 3 6.8 6.8v79.1zm-2.6-209.9l-109.1 85.7c-4.4 3.5-10.9.3-10.9-5.3v-53.4H397.7c-19.6 0-35.5 16-35.5 35.6v78.9c0 3.7-3 6.8-6.8 6.8h-50.7c-3.7 0-6.8-3-6.8-6.8v-78.9c0-55.3 44.7-100.1 99.7-100.1h205.7v-53.4c0-5.7 6.5-8.8 10.9-5.3l109.1 85.7c3.6 2.5 3.6 7.8.1 10.5z" } }] }, "name": "interaction", "theme": "filled" };
var InteractionFilledSvg = InteractionFilled$2;

var InteractionFilled = function InteractionFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: InteractionFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  InteractionFilled.displayName = 'InteractionFilled';
}
var InteractionFilled$1 = /*#__PURE__*/React__namespace.forwardRef(InteractionFilled);

// This icon file is generated automatically.
var InteractionOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z" } }] }, "name": "interaction", "theme": "outlined" };
var InteractionOutlinedSvg = InteractionOutlined$2;

var InteractionOutlined = function InteractionOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: InteractionOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  InteractionOutlined.displayName = 'InteractionOutlined';
}
var InteractionOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(InteractionOutlined);

// This icon file is generated automatically.
var InteractionTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm114-401.9c0-55.3 44.6-100.1 99.7-100.1h205.8v-53.4c0-5.6 6.5-8.8 10.9-5.3L723.5 365c3.5 2.7 3.5 8 0 10.7l-109.1 85.7c-4.4 3.5-10.9.4-10.9-5.3v-53.4H397.8c-19.6 0-35.5 15.9-35.5 35.6v78.9c0 3.8-3.1 6.8-6.8 6.8h-50.7c-3.8 0-6.8-3-6.8-7v-78.9zm2.6 210.3l109.1-85.7c4.4-3.5 10.9-.4 10.9 5.3v53.4h205.6c19.6 0 35.5-15.9 35.5-35.6v-78.9c0-3.8 3.1-6.8 6.8-6.8h50.7c3.8 0 6.8 3.1 6.8 6.8v78.9c0 55.3-44.6 100.1-99.7 100.1H420.6v53.4c0 5.6-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z", "fill": primaryColor } }] }; }, "name": "interaction", "theme": "twotone" };
var InteractionTwoToneSvg = InteractionTwoTone$2;

var InteractionTwoTone = function InteractionTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: InteractionTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  InteractionTwoTone.displayName = 'InteractionTwoTone';
}
var InteractionTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(InteractionTwoTone);

// This icon file is generated automatically.
var IssuesCloseOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M464 688a48 48 0 1096 0 48 48 0 10-96 0zm72-112c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48zm400-188h-59.3c-2.6 0-5 1.2-6.5 3.3L763.7 538.1l-49.9-68.8a7.92 7.92 0 00-6.5-3.3H648c-6.5 0-10.3 7.4-6.5 12.7l109.2 150.7a16.1 16.1 0 0026 0l165.8-228.7c3.8-5.3 0-12.7-6.5-12.7zm-44 306h-64.2c-5.5 0-10.6 2.9-13.6 7.5a352.2 352.2 0 01-49.8 62.2A355.92 355.92 0 01651.1 840a355 355 0 01-138.7 27.9c-48.1 0-94.8-9.4-138.7-27.9a355.92 355.92 0 01-113.3-76.3A353.06 353.06 0 01184 650.5c-18.6-43.8-28-90.5-28-138.5s9.4-94.7 28-138.5c17.9-42.4 43.6-80.5 76.4-113.2 32.8-32.7 70.9-58.4 113.3-76.3a355 355 0 01138.7-27.9c48.1 0 94.8 9.4 138.7 27.9 42.4 17.9 80.5 43.6 113.3 76.3 19 19 35.6 39.8 49.8 62.2 2.9 4.7 8.1 7.5 13.6 7.5H892c6 0 9.8-6.3 7.2-11.6C828.8 178.5 684.7 82 517.7 80 278.9 77.2 80.5 272.5 80 511.2 79.5 750.1 273.3 944 512.4 944c169.2 0 315.6-97 386.7-238.4A8 8 0 00892 694z" } }] }, "name": "issues-close", "theme": "outlined" };
var IssuesCloseOutlinedSvg = IssuesCloseOutlined$2;

var IssuesCloseOutlined = function IssuesCloseOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: IssuesCloseOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  IssuesCloseOutlined.displayName = 'IssuesCloseOutlined';
}
var IssuesCloseOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(IssuesCloseOutlined);

// This icon file is generated automatically.
var ItalicOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M798 160H366c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h181.2l-156 544H229c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8H474.4l156-544H798c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z" } }] }, "name": "italic", "theme": "outlined" };
var ItalicOutlinedSvg = ItalicOutlined$2;

var ItalicOutlined = function ItalicOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ItalicOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ItalicOutlined.displayName = 'ItalicOutlined';
}
var ItalicOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ItalicOutlined);

// This icon file is generated automatically.
var KeyOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M608 112c-167.9 0-304 136.1-304 304 0 70.3 23.9 135 63.9 186.5l-41.1 41.1-62.3-62.3a8.15 8.15 0 00-11.4 0l-39.8 39.8a8.15 8.15 0 000 11.4l62.3 62.3-44.9 44.9-62.3-62.3a8.15 8.15 0 00-11.4 0l-39.8 39.8a8.15 8.15 0 000 11.4l62.3 62.3-65.3 65.3a8.03 8.03 0 000 11.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0l253.6-253.6A304.06 304.06 0 00608 720c167.9 0 304-136.1 304-304S775.9 112 608 112zm161.2 465.2C726.2 620.3 668.9 644 608 644c-60.9 0-118.2-23.7-161.2-66.8-43.1-43-66.8-100.3-66.8-161.2 0-60.9 23.7-118.2 66.8-161.2 43-43.1 100.3-66.8 161.2-66.8 60.9 0 118.2 23.7 161.2 66.8 43.1 43 66.8 100.3 66.8 161.2 0 60.9-23.7 118.2-66.8 161.2z" } }] }, "name": "key", "theme": "outlined" };
var KeyOutlinedSvg = KeyOutlined$2;

var KeyOutlined = function KeyOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: KeyOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  KeyOutlined.displayName = 'KeyOutlined';
}
var KeyOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(KeyOutlined);

// This icon file is generated automatically.
var LaptopOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M956.9 845.1L896.4 632V168c0-17.7-14.3-32-32-32h-704c-17.7 0-32 14.3-32 32v464L67.9 845.1C60.4 866 75.8 888 98 888h828.8c22.2 0 37.6-22 30.1-42.9zM200.4 208h624v395h-624V208zm228.3 608l8.1-37h150.3l8.1 37H428.7zm224 0l-19.1-86.7c-.8-3.7-4.1-6.3-7.8-6.3H398.2c-3.8 0-7 2.6-7.8 6.3L371.3 816H151l42.3-149h638.2l42.3 149H652.7z" } }] }, "name": "laptop", "theme": "outlined" };
var LaptopOutlinedSvg = LaptopOutlined$2;

var LaptopOutlined = function LaptopOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LaptopOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  LaptopOutlined.displayName = 'LaptopOutlined';
}
var LaptopOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(LaptopOutlined);

// This icon file is generated automatically.
var LayoutFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M384 912h496c17.7 0 32-14.3 32-32V340H384v572zm496-800H384v164h528V144c0-17.7-14.3-32-32-32zm-768 32v736c0 17.7 14.3 32 32 32h176V112H144c-17.7 0-32 14.3-32 32z" } }] }, "name": "layout", "theme": "filled" };
var LayoutFilledSvg = LayoutFilled$2;

var LayoutFilled = function LayoutFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LayoutFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  LayoutFilled.displayName = 'LayoutFilled';
}
var LayoutFilled$1 = /*#__PURE__*/React__namespace.forwardRef(LayoutFilled);

// This icon file is generated automatically.
var LayoutOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-696 72h136v656H184V184zm656 656H384V384h456v456zM384 320V184h456v136H384z" } }] }, "name": "layout", "theme": "outlined" };
var LayoutOutlinedSvg = LayoutOutlined$2;

var LayoutOutlined = function LayoutOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LayoutOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  LayoutOutlined.displayName = 'LayoutOutlined';
}
var LayoutOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(LayoutOutlined);

// This icon file is generated automatically.
var LayoutTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M384 185h456v136H384zm-200 0h136v656H184zm696-73H144c-17.7 0-32 14.3-32 32v1c0-17.7 14.3-32 32-32h736c17.7 0 32 14.3 32 32v-1c0-17.7-14.3-32-32-32zM384 385h456v456H384z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 113H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V145c0-17.7-14.3-32-32-32zM320 841H184V185h136v656zm520 0H384V385h456v456zm0-520H384V185h456v136z", "fill": primaryColor } }] }; }, "name": "layout", "theme": "twotone" };
var LayoutTwoToneSvg = LayoutTwoTone$2;

var LayoutTwoTone = function LayoutTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LayoutTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  LayoutTwoTone.displayName = 'LayoutTwoTone';
}
var LayoutTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(LayoutTwoTone);

// This icon file is generated automatically.
var LeftCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm104 316.9c0 10.2-4.9 19.9-13.2 25.9L457.4 512l145.4 105.2c8.3 6 13.2 15.6 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 010-12.9l246-178a8 8 0 0112.7 6.5v46.8z" } }] }, "name": "left-circle", "theme": "filled" };
var LeftCircleFilledSvg = LeftCircleFilled$2;

var LeftCircleFilled = function LeftCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LeftCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  LeftCircleFilled.displayName = 'LeftCircleFilled';
}
var LeftCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(LeftCircleFilled);

// This icon file is generated automatically.
var LeftCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M603.3 327.5l-246 178a7.95 7.95 0 000 12.9l246 178c5.3 3.8 12.7 0 12.7-6.5V643c0-10.2-4.9-19.9-13.2-25.9L457.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "left-circle", "theme": "outlined" };
var LeftCircleOutlinedSvg = LeftCircleOutlined$2;

var LeftCircleOutlined = function LeftCircleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LeftCircleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  LeftCircleOutlined.displayName = 'LeftCircleOutlined';
}
var LeftCircleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(LeftCircleOutlined);

// This icon file is generated automatically.
var LeftCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm104 240.9c0 10.3-4.9 19.9-13.2 25.9L457.4 512l145.4 105.1c8.3 6 13.2 15.7 13.2 25.9v46.9c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 010-12.9l246-178c5.3-3.8 12.7 0 12.7 6.5v46.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M603.3 327.5l-246 178a7.95 7.95 0 000 12.9l246 178c5.3 3.8 12.7 0 12.7-6.5V643c0-10.2-4.9-19.9-13.2-25.9L457.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5z", "fill": primaryColor } }] }; }, "name": "left-circle", "theme": "twotone" };
var LeftCircleTwoToneSvg = LeftCircleTwoTone$2;

var LeftCircleTwoTone = function LeftCircleTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LeftCircleTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  LeftCircleTwoTone.displayName = 'LeftCircleTwoTone';
}
var LeftCircleTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(LeftCircleTwoTone);

// This icon file is generated automatically.
var LeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" } }] }, "name": "left", "theme": "outlined" };
var LeftOutlinedSvg = LeftOutlined$2;

var LeftOutlined = function LeftOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LeftOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  LeftOutlined.displayName = 'LeftOutlined';
}
var LeftOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(LeftOutlined);

// This icon file is generated automatically.
var LeftSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM624 380.9c0 10.2-4.9 19.9-13.2 25.9L465.4 512l145.4 105.2c8.3 6 13.2 15.6 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 010-12.9l246-178c5.3-3.8 12.7 0 12.7 6.5v46.8z" } }] }, "name": "left-square", "theme": "filled" };
var LeftSquareFilledSvg = LeftSquareFilled$2;

var LeftSquareFilled = function LeftSquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LeftSquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  LeftSquareFilled.displayName = 'LeftSquareFilled';
}
var LeftSquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(LeftSquareFilled);

// This icon file is generated automatically.
var LeftSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M365.3 518.5l246 178c5.3 3.8 12.7 0 12.7-6.5v-46.9c0-10.2-4.9-19.9-13.2-25.9L465.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5l-246 178a8.05 8.05 0 000 13z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "left-square", "theme": "outlined" };
var LeftSquareOutlinedSvg = LeftSquareOutlined$2;

var LeftSquareOutlined = function LeftSquareOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LeftSquareOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  LeftSquareOutlined.displayName = 'LeftSquareOutlined';
}
var LeftSquareOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(LeftSquareOutlined);

// This icon file is generated automatically.
var LeftSquareTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm181.3-334.5l246-178c5.3-3.8 12.7 0 12.7 6.5v46.9c0 10.3-4.9 19.9-13.2 25.9L465.4 512l145.4 105.2c8.3 6 13.2 15.7 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.4l-246-178a7.95 7.95 0 010-12.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M365.3 518.4l246 178c5.3 3.9 12.7.1 12.7-6.4v-46.9c0-10.2-4.9-19.9-13.2-25.9L465.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5l-246 178a7.95 7.95 0 000 12.9z", "fill": primaryColor } }] }; }, "name": "left-square", "theme": "twotone" };
var LeftSquareTwoToneSvg = LeftSquareTwoTone$2;

var LeftSquareTwoTone = function LeftSquareTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LeftSquareTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  LeftSquareTwoTone.displayName = 'LeftSquareTwoTone';
}
var LeftSquareTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(LeftSquareTwoTone);

// This icon file is generated automatically.
var LikeFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 00-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 00471 99.9c-52 0-98 35-111.8 85.1l-85.9 311h-.3v428h472.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32z" } }] }, "name": "like", "theme": "filled" };
var LikeFilledSvg = LikeFilled$2;

var LikeFilled = function LikeFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LikeFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  LikeFilled.displayName = 'LikeFilled';
}
var LikeFilled$1 = /*#__PURE__*/React__namespace.forwardRef(LikeFilled);

// This icon file is generated automatically.
var LikeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 00-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 00471 99.9c-52 0-98 35-111.8 85.1l-85.9 311H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h601.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM184 852V568h81v284h-81zm636.4-353l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 22.4-13.2 42.6-33.6 51.8H329V564.8l99.5-360.5a44.1 44.1 0 0142.2-32.3c7.6 0 15.1 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.2 32.1-19.6 43z" } }] }, "name": "like", "theme": "outlined" };
var LikeOutlinedSvg = LikeOutlined$2;

var LikeOutlined = function LikeOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LikeOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  LikeOutlined.displayName = 'LikeOutlined';
}
var LikeOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(LikeOutlined);

// This icon file is generated automatically.
var LikeTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M273 495.9v428l.3-428zm538.2-88.3H496.8l9.6-198.4c.6-11.9-4.7-23.1-14.6-30.5-6.1-4.5-13.6-6.8-21.1-6.7-19.6.1-36.9 13.4-42.2 32.3-37.1 134.4-64.9 235.2-83.5 302.5V852h399.4a56.85 56.85 0 0033.6-51.8c0-9.7-2.3-18.9-6.9-27.3l-13.9-25.4 21.9-19a56.76 56.76 0 0019.6-43c0-9.7-2.3-18.9-6.9-27.3l-13.9-25.4 21.9-19a56.76 56.76 0 0019.6-43c0-9.7-2.3-18.9-6.9-27.3l-14-25.5 21.9-19a56.76 56.76 0 0019.6-43c0-19.1-11-37.5-28.8-48.4z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32zm773.9 5.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.5-65.5-111a67.67 67.67 0 00-34.3-9.3H572.3l6-122.9c1.5-29.7-9-57.9-29.5-79.4a106.4 106.4 0 00-77.9-33.4c-52 0-98 35-111.8 85.1l-85.8 310.8-.3 428h472.1c9.3 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37zM820.4 499l-21.9 19 14 25.5a56.2 56.2 0 016.9 27.3c0 16.5-7.1 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 16.5-7.1 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 22.4-13.2 42.6-33.6 51.8H345V506.8c18.6-67.2 46.4-168 83.5-302.5a44.28 44.28 0 0142.2-32.3c7.5-.1 15 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.1 32.2-19.6 43z", "fill": primaryColor } }] }; }, "name": "like", "theme": "twotone" };
var LikeTwoToneSvg = LikeTwoTone$2;

var LikeTwoTone = function LikeTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LikeTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  LikeTwoTone.displayName = 'LikeTwoTone';
}
var LikeTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(LikeTwoTone);

// This icon file is generated automatically.
var LineChartOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM305.8 637.7c3.1 3.1 8.1 3.1 11.3 0l138.3-137.6L583 628.5c3.1 3.1 8.2 3.1 11.3 0l275.4-275.3c3.1-3.1 3.1-8.2 0-11.3l-39.6-39.6a8.03 8.03 0 00-11.3 0l-230 229.9L461.4 404a8.03 8.03 0 00-11.3 0L266.3 586.7a8.03 8.03 0 000 11.3l39.5 39.7z" } }] }, "name": "line-chart", "theme": "outlined" };
var LineChartOutlinedSvg = LineChartOutlined$2;

var LineChartOutlined = function LineChartOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LineChartOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  LineChartOutlined.displayName = 'LineChartOutlined';
}
var LineChartOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(LineChartOutlined);

// This icon file is generated automatically.
var LineHeightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M648 160H104c-4.4 0-8 3.6-8 8v128c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-64h168v560h-92c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-92V232h168v64c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm272.8 546H856V318h64.8c6 0 9.4-7 5.7-11.7L825.7 178.7a7.14 7.14 0 00-11.3 0L713.6 306.3a7.23 7.23 0 005.7 11.7H784v388h-64.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5a7.2 7.2 0 00-5.6-11.7z" } }] }, "name": "line-height", "theme": "outlined" };
var LineHeightOutlinedSvg = LineHeightOutlined$2;

var LineHeightOutlined = function LineHeightOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LineHeightOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  LineHeightOutlined.displayName = 'LineHeightOutlined';
}
var LineHeightOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(LineHeightOutlined);

// This icon file is generated automatically.
var LineOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 476H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "line", "theme": "outlined" };
var LineOutlinedSvg = LineOutlined$2;

var LineOutlined = function LineOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LineOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  LineOutlined.displayName = 'LineOutlined';
}
var LineOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(LineOutlined);

// This icon file is generated automatically.
var LinkOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M574 665.4a8.03 8.03 0 00-11.3 0L446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3l-39.8-39.8a8.03 8.03 0 00-11.3 0L191.4 526.5c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3L574 665.4zm258.6-474c-84.6-84.6-221.5-84.6-306 0L410.3 307.6a8.03 8.03 0 000 11.3l39.7 39.7c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204L665.3 562.6a8.03 8.03 0 000 11.3l39.8 39.8c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c84.5-84.6 84.5-221.5 0-306.1zM610.1 372.3a8.03 8.03 0 00-11.3 0L372.3 598.7a8.03 8.03 0 000 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l226.4-226.4c3.1-3.1 3.1-8.2 0-11.3l-39.5-39.6z" } }] }, "name": "link", "theme": "outlined" };
var LinkOutlinedSvg = LinkOutlined$2;

var LinkOutlined = function LinkOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LinkOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  LinkOutlined.displayName = 'LinkOutlined';
}
var LinkOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(LinkOutlined);

// This icon file is generated automatically.
var LinkedinFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM349.3 793.7H230.6V411.9h118.7v381.8zm-59.3-434a68.8 68.8 0 1168.8-68.8c-.1 38-30.9 68.8-68.8 68.8zm503.7 434H675.1V608c0-44.3-.8-101.2-61.7-101.2-61.7 0-71.2 48.2-71.2 98v188.9H423.7V411.9h113.8v52.2h1.6c15.8-30 54.5-61.7 112.3-61.7 120.2 0 142.3 79.1 142.3 181.9v209.4z" } }] }, "name": "linkedin", "theme": "filled" };
var LinkedinFilledSvg = LinkedinFilled$2;

var LinkedinFilled = function LinkedinFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LinkedinFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  LinkedinFilled.displayName = 'LinkedinFilled';
}
var LinkedinFilled$1 = /*#__PURE__*/React__namespace.forwardRef(LinkedinFilled);

// This icon file is generated automatically.
var LinkedinOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M847.7 112H176.3c-35.5 0-64.3 28.8-64.3 64.3v671.4c0 35.5 28.8 64.3 64.3 64.3h671.4c35.5 0 64.3-28.8 64.3-64.3V176.3c0-35.5-28.8-64.3-64.3-64.3zm0 736c-447.8-.1-671.7-.2-671.7-.3.1-447.8.2-671.7.3-671.7 447.8.1 671.7.2 671.7.3-.1 447.8-.2 671.7-.3 671.7zM230.6 411.9h118.7v381.8H230.6zm59.4-52.2c37.9 0 68.8-30.8 68.8-68.8a68.8 68.8 0 10-137.6 0c-.1 38 30.7 68.8 68.8 68.8zm252.3 245.1c0-49.8 9.5-98 71.2-98 60.8 0 61.7 56.9 61.7 101.2v185.7h118.6V584.3c0-102.8-22.2-181.9-142.3-181.9-57.7 0-96.4 31.7-112.3 61.7h-1.6v-52.2H423.7v381.8h118.6V604.8z" } }] }, "name": "linkedin", "theme": "outlined" };
var LinkedinOutlinedSvg = LinkedinOutlined$2;

var LinkedinOutlined = function LinkedinOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LinkedinOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  LinkedinOutlined.displayName = 'LinkedinOutlined';
}
var LinkedinOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(LinkedinOutlined);

// This icon file is generated automatically.
var Loading3QuartersOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 1024c-69.1 0-136.2-13.5-199.3-40.2C251.7 958 197 921 150 874c-47-47-84-101.7-109.8-162.7C13.5 648.2 0 581.1 0 512c0-19.9 16.1-36 36-36s36 16.1 36 36c0 59.4 11.6 117 34.6 171.3 22.2 52.4 53.9 99.5 94.3 139.9 40.4 40.4 87.5 72.2 139.9 94.3C395 940.4 452.6 952 512 952c59.4 0 117-11.6 171.3-34.6 52.4-22.2 99.5-53.9 139.9-94.3 40.4-40.4 72.2-87.5 94.3-139.9C940.4 629 952 571.4 952 512c0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.2C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3s-13.5 136.2-40.2 199.3C958 772.3 921 827 874 874c-47 47-101.8 83.9-162.7 109.7-63.1 26.8-130.2 40.3-199.3 40.3z" } }] }, "name": "loading-3-quarters", "theme": "outlined" };
var Loading3QuartersOutlinedSvg = Loading3QuartersOutlined$2;

var Loading3QuartersOutlined = function Loading3QuartersOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: Loading3QuartersOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  Loading3QuartersOutlined.displayName = 'Loading3QuartersOutlined';
}
var Loading3QuartersOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(Loading3QuartersOutlined);

// This icon file is generated automatically.
var LoadingOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, "name": "loading", "theme": "outlined" };
var LoadingOutlinedSvg = LoadingOutlined$2;

var LoadingOutlined = function LoadingOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LoadingOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  LoadingOutlined.displayName = 'LoadingOutlined';
}
var LoadingOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(LoadingOutlined);

// This icon file is generated automatically.
var LockFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1156 0zm152-237H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224z" } }] }, "name": "lock", "theme": "filled" };
var LockFilledSvg = LockFilled$2;

var LockFilled = function LockFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LockFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  LockFilled.displayName = 'LockFilled';
}
var LockFilled$1 = /*#__PURE__*/React__namespace.forwardRef(LockFilled);

// This icon file is generated automatically.
var LockOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z" } }] }, "name": "lock", "theme": "outlined" };
var LockOutlinedSvg = LockOutlined$2;

var LockOutlined = function LockOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LockOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  LockOutlined.displayName = 'LockOutlined';
}
var LockOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(LockOutlined);

// This icon file is generated automatically.
var LockTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M232 840h560V536H232v304zm280-226a48.01 48.01 0 0128 87v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 0128-87z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z", "fill": primaryColor } }] }; }, "name": "lock", "theme": "twotone" };
var LockTwoToneSvg = LockTwoTone$2;

var LockTwoTone = function LockTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LockTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  LockTwoTone.displayName = 'LockTwoTone';
}
var LockTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(LockTwoTone);

// This icon file is generated automatically.
var LoginOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M521.7 82c-152.5-.4-286.7 78.5-363.4 197.7-3.4 5.3.4 12.3 6.7 12.3h70.3c4.8 0 9.3-2.1 12.3-5.8 7-8.5 14.5-16.7 22.4-24.5 32.6-32.5 70.5-58.1 112.7-75.9 43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 32.6 32.5 58.1 70.4 76 112.5C865.7 417.8 875 464.1 875 512c0 47.9-9.4 94.2-27.8 137.8-17.8 42.1-43.4 80-76 112.5s-70.5 58.1-112.7 75.9A352.8 352.8 0 01520.6 866c-47.9 0-94.3-9.4-137.9-27.8A353.84 353.84 0 01270 762.3c-7.9-7.9-15.3-16.1-22.4-24.5-3-3.7-7.6-5.8-12.3-5.8H165c-6.3 0-10.2 7-6.7 12.3C234.9 863.2 368.5 942 520.6 942c236.2 0 428-190.1 430.4-425.6C953.4 277.1 761.3 82.6 521.7 82zM395.02 624v-76h-314c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h314v-76c0-6.7 7.8-10.5 13-6.3l141.9 112a8 8 0 010 12.6l-141.9 112c-5.2 4.1-13 .4-13-6.3z" } }] }, "name": "login", "theme": "outlined" };
var LoginOutlinedSvg = LoginOutlined$2;

var LoginOutlined = function LoginOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LoginOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  LoginOutlined.displayName = 'LoginOutlined';
}
var LoginOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(LoginOutlined);

// This icon file is generated automatically.
var LogoutOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M868 732h-70.3c-4.8 0-9.3 2.1-12.3 5.8-7 8.5-14.5 16.7-22.4 24.5a353.84 353.84 0 01-112.7 75.9A352.8 352.8 0 01512.4 866c-47.9 0-94.3-9.4-137.9-27.8a353.84 353.84 0 01-112.7-75.9 353.28 353.28 0 01-76-112.5C167.3 606.2 158 559.9 158 512s9.4-94.2 27.8-137.8c17.8-42.1 43.4-80 76-112.5s70.5-58.1 112.7-75.9c43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 7.9 7.9 15.3 16.1 22.4 24.5 3 3.7 7.6 5.8 12.3 5.8H868c6.3 0 10.2-7 6.7-12.3C798 160.5 663.8 81.6 511.3 82 271.7 82.6 79.6 277.1 82 516.4 84.4 751.9 276.2 942 512.4 942c152.1 0 285.7-78.8 362.3-197.7 3.4-5.3-.4-12.3-6.7-12.3zm88.9-226.3L815 393.7c-5.3-4.2-13-.4-13 6.3v76H488c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 000-12.6z" } }] }, "name": "logout", "theme": "outlined" };
var LogoutOutlinedSvg = LogoutOutlined$2;

var LogoutOutlined = function LogoutOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LogoutOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  LogoutOutlined.displayName = 'LogoutOutlined';
}
var LogoutOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(LogoutOutlined);

// This icon file is generated automatically.
var MacCommandFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M624 672a48.01 48.01 0 0096 0c0-26.5-21.5-48-48-48h-48v48zm96-320a48.01 48.01 0 00-96 0v48h48c26.5 0 48-21.5 48-48z" } }, { "tag": "path", "attrs": { "d": "M928 64H96c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM672 560c61.9 0 112 50.1 112 112s-50.1 112-112 112-112-50.1-112-112v-48h-96v48c0 61.9-50.1 112-112 112s-112-50.1-112-112 50.1-112 112-112h48v-96h-48c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112v48h96v-48c0-61.9 50.1-112 112-112s112 50.1 112 112-50.1 112-112 112h-48v96h48z" } }, { "tag": "path", "attrs": { "d": "M464 464h96v96h-96zM352 304a48.01 48.01 0 000 96h48v-48c0-26.5-21.5-48-48-48zm-48 368a48.01 48.01 0 0096 0v-48h-48c-26.5 0-48 21.5-48 48z" } }] }, "name": "mac-command", "theme": "filled" };
var MacCommandFilledSvg = MacCommandFilled$2;

var MacCommandFilled = function MacCommandFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MacCommandFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MacCommandFilled.displayName = 'MacCommandFilled';
}
var MacCommandFilled$1 = /*#__PURE__*/React__namespace.forwardRef(MacCommandFilled);

// This icon file is generated automatically.
var MacCommandOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }, { "tag": "path", "attrs": { "d": "M370.8 554.4c-54.6 0-98.8 44.2-98.8 98.8s44.2 98.8 98.8 98.8 98.8-44.2 98.8-98.8v-42.4h84.7v42.4c0 54.6 44.2 98.8 98.8 98.8s98.8-44.2 98.8-98.8-44.2-98.8-98.8-98.8h-42.4v-84.7h42.4c54.6 0 98.8-44.2 98.8-98.8 0-54.6-44.2-98.8-98.8-98.8s-98.8 44.2-98.8 98.8v42.4h-84.7v-42.4c0-54.6-44.2-98.8-98.8-98.8S272 316.2 272 370.8s44.2 98.8 98.8 98.8h42.4v84.7h-42.4zm42.4 98.8c0 23.4-19 42.4-42.4 42.4s-42.4-19-42.4-42.4 19-42.4 42.4-42.4h42.4v42.4zm197.6-282.4c0-23.4 19-42.4 42.4-42.4s42.4 19 42.4 42.4-19 42.4-42.4 42.4h-42.4v-42.4zm0 240h42.4c23.4 0 42.4 19 42.4 42.4s-19 42.4-42.4 42.4-42.4-19-42.4-42.4v-42.4zM469.6 469.6h84.7v84.7h-84.7v-84.7zm-98.8-56.4c-23.4 0-42.4-19-42.4-42.4s19-42.4 42.4-42.4 42.4 19 42.4 42.4v42.4h-42.4z" } }] }, "name": "mac-command", "theme": "outlined" };
var MacCommandOutlinedSvg = MacCommandOutlined$2;

var MacCommandOutlined = function MacCommandOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MacCommandOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MacCommandOutlined.displayName = 'MacCommandOutlined';
}
var MacCommandOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(MacCommandOutlined);

// This icon file is generated automatically.
var MailFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-80.8 108.9L531.7 514.4c-7.8 6.1-18.7 6.1-26.5 0L189.6 268.9A7.2 7.2 0 01194 256h648.8a7.2 7.2 0 014.4 12.9z" } }] }, "name": "mail", "theme": "filled" };
var MailFilledSvg = MailFilled$2;

var MailFilled = function MailFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MailFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MailFilled.displayName = 'MailFilled';
}
var MailFilled$1 = /*#__PURE__*/React__namespace.forwardRef(MailFilled);

// This icon file is generated automatically.
var MailOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 110.8V792H136V270.8l-27.6-21.5 39.3-50.5 42.8 33.3h643.1l42.8-33.3 39.3 50.5-27.7 21.5zM833.6 232L512 482 190.4 232l-42.8-33.3-39.3 50.5 27.6 21.5 341.6 265.6a55.99 55.99 0 0068.7 0L888 270.8l27.6-21.5-39.3-50.5-42.7 33.2z" } }] }, "name": "mail", "theme": "outlined" };
var MailOutlinedSvg = MailOutlined$2;

var MailOutlined = function MailOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MailOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MailOutlined.displayName = 'MailOutlined';
}
var MailOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(MailOutlined);

// This icon file is generated automatically.
var MailTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M477.5 536.3L135.9 270.7l-27.5-21.4 27.6 21.5V792h752V270.8L546.2 536.3a55.99 55.99 0 01-68.7 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M876.3 198.8l39.3 50.5-27.6 21.5 27.7-21.5-39.3-50.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-94.5 72.1L512 482 190.5 232.1h643zm54.5 38.7V792H136V270.8l-27.6-21.5 27.5 21.4 341.6 265.6a55.99 55.99 0 0068.7 0L888 270.8l27.6-21.5-39.3-50.5h.1l39.3 50.5-27.7 21.5z", "fill": primaryColor } }] }; }, "name": "mail", "theme": "twotone" };
var MailTwoToneSvg = MailTwoTone$2;

var MailTwoTone = function MailTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MailTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MailTwoTone.displayName = 'MailTwoTone';
}
var MailTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(MailTwoTone);

// This icon file is generated automatically.
var ManOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M874 120H622c-3.3 0-6 2.7-6 6v56c0 3.3 2.7 6 6 6h160.4L583.1 387.3c-50-38.5-111-59.3-175.1-59.3-76.9 0-149.3 30-203.6 84.4S120 539.1 120 616s30 149.3 84.4 203.6C258.7 874 331.1 904 408 904s149.3-30 203.6-84.4C666 765.3 696 692.9 696 616c0-64.1-20.8-124.9-59.2-174.9L836 241.9V402c0 3.3 2.7 6 6 6h56c3.3 0 6-2.7 6-6V150c0-16.5-13.5-30-30-30zM408 828c-116.9 0-212-95.1-212-212s95.1-212 212-212 212 95.1 212 212-95.1 212-212 212z" } }] }, "name": "man", "theme": "outlined" };
var ManOutlinedSvg = ManOutlined$2;

var ManOutlined = function ManOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ManOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ManOutlined.displayName = 'ManOutlined';
}
var ManOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ManOutlined);

// This icon file is generated automatically.
var MedicineBoxFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M839.2 278.1a32 32 0 00-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 00-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM660 628c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V636H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V464c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8v48zm4-372H360v-72h304v72z" } }] }, "name": "medicine-box", "theme": "filled" };
var MedicineBoxFilledSvg = MedicineBoxFilled$2;

var MedicineBoxFilled = function MedicineBoxFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MedicineBoxFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MedicineBoxFilled.displayName = 'MedicineBoxFilled';
}
var MedicineBoxFilled$1 = /*#__PURE__*/React__namespace.forwardRef(MedicineBoxFilled);

// This icon file is generated automatically.
var MedicineBoxOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M839.2 278.1a32 32 0 00-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 00-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM360 184h304v72H360v-72zm480 656H184V513.4L244.3 328h535.4L840 513.4V840zM652 572H544V464c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V636h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }] }, "name": "medicine-box", "theme": "outlined" };
var MedicineBoxOutlinedSvg = MedicineBoxOutlined$2;

var MedicineBoxOutlined = function MedicineBoxOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MedicineBoxOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MedicineBoxOutlined.displayName = 'MedicineBoxOutlined';
}
var MedicineBoxOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(MedicineBoxOutlined);

// This icon file is generated automatically.
var MedicineBoxTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M244.3 328L184 513.4V840h656V513.4L779.7 328H244.3zM660 628c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V636H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V464c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8v48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M652 572H544V464c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V636h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M839.2 278.1a32 32 0 00-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 00-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM360 184h304v72H360v-72zm480 656H184V513.4L244.3 328h535.4L840 513.4V840z", "fill": primaryColor } }] }; }, "name": "medicine-box", "theme": "twotone" };
var MedicineBoxTwoToneSvg = MedicineBoxTwoTone$2;

var MedicineBoxTwoTone = function MedicineBoxTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MedicineBoxTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MedicineBoxTwoTone.displayName = 'MedicineBoxTwoTone';
}
var MedicineBoxTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(MedicineBoxTwoTone);

// This icon file is generated automatically.
var MediumCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm256 253.7l-40.8 39.1c-3.6 2.7-5.3 7.1-4.6 11.4v287.7c-.7 4.4 1 8.8 4.6 11.4l40 39.1v8.7H566.4v-8.3l41.3-40.1c4.1-4.1 4.1-5.3 4.1-11.4V422.5l-115 291.6h-15.5L347.5 422.5V618c-1.2 8.2 1.7 16.5 7.5 22.4l53.8 65.1v8.7H256v-8.7l53.8-65.1a26.1 26.1 0 007-22.4V392c.7-6.3-1.7-12.4-6.5-16.7l-47.8-57.6V309H411l114.6 251.5 100.9-251.3H768v8.5z" } }] }, "name": "medium-circle", "theme": "filled" };
var MediumCircleFilledSvg = MediumCircleFilled$2;

var MediumCircleFilled = function MediumCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MediumCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MediumCircleFilled.displayName = 'MediumCircleFilled';
}
var MediumCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(MediumCircleFilled);

// This icon file is generated automatically.
var MediumOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M834.7 279.8l61.3-58.9V208H683.7L532.4 586.4 360.3 208H137.7v12.9l71.6 86.6c7 6.4 10.6 15.8 9.7 25.2V673c2.2 12.3-1.7 24.8-10.3 33.7L128 805v12.7h228.6v-12.9l-80.6-98a39.99 39.99 0 01-11.1-33.7V378.7l200.7 439.2h23.3l172.6-439.2v349.9c0 9.2 0 11.1-6 17.2l-62.1 60.3V819h301.2v-12.9l-59.9-58.9c-5.2-4-7.9-10.7-6.8-17.2V297a18.1 18.1 0 016.8-17.2z" } }] }, "name": "medium", "theme": "outlined" };
var MediumOutlinedSvg = MediumOutlined$2;

var MediumOutlined = function MediumOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MediumOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MediumOutlined.displayName = 'MediumOutlined';
}
var MediumOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(MediumOutlined);

// This icon file is generated automatically.
var MediumSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM768 317.7l-40.8 39.1c-3.6 2.7-5.3 7.1-4.6 11.4v287.7c-.7 4.4 1 8.8 4.6 11.4l40 39.1v8.7H566.4v-8.3l41.3-40.1c4.1-4.1 4.1-5.3 4.1-11.4V422.5l-115 291.6h-15.5L347.5 422.5V618c-1.2 8.2 1.7 16.5 7.5 22.4l53.8 65.1v8.7H256v-8.7l53.8-65.1a26.1 26.1 0 007-22.4V392c.7-6.3-1.7-12.4-6.5-16.7l-47.8-57.6V309H411l114.6 251.5 100.9-251.3H768v8.5z" } }] }, "name": "medium-square", "theme": "filled" };
var MediumSquareFilledSvg = MediumSquareFilled$2;

var MediumSquareFilled = function MediumSquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MediumSquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MediumSquareFilled.displayName = 'MediumSquareFilled';
}
var MediumSquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(MediumSquareFilled);

// This icon file is generated automatically.
var MediumWorkmarkOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M517.2 590.55c0 3.55 0 4.36 2.4 6.55l13.43 13.25v.57h-59.57v-25.47a41.44 41.44 0 01-39.5 27.65c-30.61 0-52.84-24.25-52.84-68.87 0-41.8 23.99-69.69 57.65-69.69a35.15 35.15 0 0134.61 21.67v-56.19a6.99 6.99 0 00-2.71-6.79l-12.8-12.45v-.56l59.33-7.04v177.37zm-43.74-8.09v-83.83a22.2 22.2 0 00-17.74-8.4c-14.48 0-28.47 13.25-28.47 52.62 0 36.86 12.07 49.88 27.1 49.88a23.91 23.91 0 0019.11-10.27zm83.23 28.46V497.74a7.65 7.65 0 00-2.4-6.79l-13.19-13.74v-.57h59.56v114.8c0 3.55 0 4.36 2.4 6.54l13.12 12.45v.57l-59.49-.08zm-2.16-175.67c0-13.4 10.74-24.25 23.99-24.25 13.25 0 23.98 10.86 23.98 24.25 0 13.4-10.73 24.25-23.98 24.25s-23.99-10.85-23.99-24.25zm206.83 155.06c0 3.55 0 4.6 2.4 6.79l13.43 13.25v.57h-59.88V581.9a43.4 43.4 0 01-41.01 31.2c-26.55 0-40.78-19.56-40.78-56.59 0-17.86 0-37.43.56-59.41a6.91 6.91 0 00-2.4-6.55L620.5 477.2v-.57h59.09v73.81c0 24.25 3.51 40.42 18.54 40.42a23.96 23.96 0 0019.35-12.2v-80.85a7.65 7.65 0 00-2.4-6.79l-13.27-13.82v-.57h59.56V590.3zm202.76 20.6c0-4.36.8-59.97.8-72.75 0-24.25-3.76-40.98-20.63-40.98a26.7 26.7 0 00-21.19 11.64 99.68 99.68 0 012.4 23.04c0 16.81-.56 38.23-.8 59.66a6.91 6.91 0 002.4 6.55l13.43 12.45v.56h-60.12c0-4.04.8-59.98.8-72.76 0-24.65-3.76-40.98-20.39-40.98-8.2.3-15.68 4.8-19.83 11.96v82.46c0 3.56 0 4.37 2.4 6.55l13.11 12.45v.56h-59.48V498.15a7.65 7.65 0 00-2.4-6.8l-13.19-14.14v-.57H841v28.78c5.53-19 23.13-31.76 42.7-30.96 19.82 0 33.26 11.16 38.93 32.34a46.41 46.41 0 0144.77-32.34c26.55 0 41.58 19.8 41.58 57.23 0 17.87-.56 38.24-.8 59.66a6.5 6.5 0 002.72 6.55l13.11 12.45v.57h-59.88zM215.87 593.3l17.66 17.05v.57h-89.62v-.57l17.99-17.05a6.91 6.91 0 002.4-6.55V477.69c0-4.6 0-10.83.8-16.16L104.66 613.1h-.72l-62.6-139.45c-1.37-3.47-1.77-3.72-2.65-6.06v91.43a32.08 32.08 0 002.96 17.87l25.19 33.46v.57H0v-.57l25.18-33.55a32.16 32.16 0 002.96-17.78V457.97A19.71 19.71 0 0024 444.15L6.16 420.78v-.56h63.96l53.56 118.1 47.17-118.1h62.6v.56l-17.58 19.8a6.99 6.99 0 00-2.72 6.8v139.37a6.5 6.5 0 002.72 6.55zm70.11-54.65v.56c0 34.6 17.67 48.5 38.38 48.5a43.5 43.5 0 0040.77-24.97h.56c-7.2 34.2-28.14 50.36-59.48 50.36-33.82 0-65.72-20.61-65.72-68.39 0-50.2 31.98-70.25 67.32-70.25 28.46 0 58.76 13.58 58.76 57.24v6.95h-80.59zm0-6.95h39.42v-7.04c0-35.57-7.28-45.03-18.23-45.03-13.27 0-21.35 14.15-21.35 52.07h.16z" } }] }, "name": "medium-workmark", "theme": "outlined" };
var MediumWorkmarkOutlinedSvg = MediumWorkmarkOutlined$2;

var MediumWorkmarkOutlined = function MediumWorkmarkOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MediumWorkmarkOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MediumWorkmarkOutlined.displayName = 'MediumWorkmarkOutlined';
}
var MediumWorkmarkOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(MediumWorkmarkOutlined);

// This icon file is generated automatically.
var MehFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm384 200c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v48zm16-152a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "meh", "theme": "filled" };
var MehFilledSvg = MehFilled$2;

var MehFilled = function MehFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MehFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MehFilled.displayName = 'MehFilled';
}
var MehFilled$1 = /*#__PURE__*/React__namespace.forwardRef(MehFilled);

// This icon file is generated automatically.
var MehOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M288 421a48 48 0 1096 0 48 48 0 10-96 0zm352 0a48 48 0 1096 0 48 48 0 10-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 01248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 01249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 01775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 01775 775zM664 565H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }] }, "name": "meh", "theme": "outlined" };
var MehOutlinedSvg = MehOutlined$2;

var MehOutlined = function MehOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MehOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MehOutlined.displayName = 'MehOutlined';
}
var MehOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(MehOutlined);

// This icon file is generated automatically.
var MehTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm384 200c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v48zm16-152a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M288 421a48 48 0 1096 0 48 48 0 10-96 0zm376 144H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-24-144a48 48 0 1096 0 48 48 0 10-96 0z", "fill": primaryColor } }] }; }, "name": "meh", "theme": "twotone" };
var MehTwoToneSvg = MehTwoTone$2;

var MehTwoTone = function MehTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MehTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MehTwoTone.displayName = 'MehTwoTone';
}
var MehTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(MehTwoTone);

// This icon file is generated automatically.
var MenuFoldOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM115.4 518.9L271.7 642c5.8 4.6 14.4.5 14.4-6.9V388.9c0-7.4-8.5-11.5-14.4-6.9L115.4 505.1a8.74 8.74 0 000 13.8z" } }] }, "name": "menu-fold", "theme": "outlined" };
var MenuFoldOutlinedSvg = MenuFoldOutlined$2;

var MenuFoldOutlined = function MenuFoldOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MenuFoldOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MenuFoldOutlined.displayName = 'MenuFoldOutlined';
}
var MenuFoldOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(MenuFoldOutlined);

// This icon file is generated automatically.
var MenuOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z" } }] }, "name": "menu", "theme": "outlined" };
var MenuOutlinedSvg = MenuOutlined$2;

var MenuOutlined = function MenuOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MenuOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MenuOutlined.displayName = 'MenuOutlined';
}
var MenuOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(MenuOutlined);

// This icon file is generated automatically.
var MenuUnfoldOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 000-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0014.4 7z" } }] }, "name": "menu-unfold", "theme": "outlined" };
var MenuUnfoldOutlinedSvg = MenuUnfoldOutlined$2;

var MenuUnfoldOutlined = function MenuUnfoldOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MenuUnfoldOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MenuUnfoldOutlined.displayName = 'MenuUnfoldOutlined';
}
var MenuUnfoldOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(MenuUnfoldOutlined);

// This icon file is generated automatically.
var MergeCellsOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M482.2 508.4L331.3 389c-3-2.4-7.3-.2-7.3 3.6V478H184V184h204v128c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V144c0-15.5-12.5-28-28-28H144c-15.5 0-28 12.5-28 28v736c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v128H184V546h140v85.4c0 3.8 4.4 6 7.3 3.6l150.9-119.4a4.5 4.5 0 000-7.2zM880 116H596c-15.5 0-28 12.5-28 28v168c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V184h204v294H700v-85.4c0-3.8-4.3-6-7.3-3.6l-151 119.4a4.52 4.52 0 000 7.1l151 119.5c2.9 2.3 7.3.2 7.3-3.6V546h140v294H636V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v168c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V144c0-15.5-12.5-28-28-28z" } }] }, "name": "merge-cells", "theme": "outlined" };
var MergeCellsOutlinedSvg = MergeCellsOutlined$2;

var MergeCellsOutlined = function MergeCellsOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MergeCellsOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MergeCellsOutlined.displayName = 'MergeCellsOutlined';
}
var MergeCellsOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(MergeCellsOutlined);

// This icon file is generated automatically.
var MessageFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M924.3 338.4a447.57 447.57 0 00-96.1-143.3 443.09 443.09 0 00-143-96.3A443.91 443.91 0 00512 64h-2c-60.5.3-119 12.3-174.1 35.9a444.08 444.08 0 00-141.7 96.5 445 445 0 00-95 142.8A449.89 449.89 0 0065 514.1c.3 69.4 16.9 138.3 47.9 199.9v152c0 25.4 20.6 46 45.9 46h151.8a447.72 447.72 0 00199.5 48h2.1c59.8 0 117.7-11.6 172.3-34.3A443.2 443.2 0 00827 830.5c41.2-40.9 73.6-88.7 96.3-142 23.5-55.2 35.5-113.9 35.8-174.5.2-60.9-11.6-120-34.8-175.6zM312.4 560c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.4 48-47.9 48zm199.6 0c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.5 48-47.9 48zm199.6 0c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.5 48-47.9 48z" } }] }, "name": "message", "theme": "filled" };
var MessageFilledSvg = MessageFilled$2;

var MessageFilled = function MessageFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MessageFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MessageFilled.displayName = 'MessageFilled';
}
var MessageFilled$1 = /*#__PURE__*/React__namespace.forwardRef(MessageFilled);

// This icon file is generated automatically.
var MessageOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M464 512a48 48 0 1096 0 48 48 0 10-96 0zm200 0a48 48 0 1096 0 48 48 0 10-96 0zm-400 0a48 48 0 1096 0 48 48 0 10-96 0zm661.2-173.6c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 00-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 00-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 00112 714v152a46 46 0 0046 46h152.1A449.4 449.4 0 00510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 00142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z" } }] }, "name": "message", "theme": "outlined" };
var MessageOutlinedSvg = MessageOutlined$2;

var MessageOutlined = function MessageOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MessageOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MessageOutlined.displayName = 'MessageOutlined';
}
var MessageOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(MessageOutlined);

// This icon file is generated automatically.
var MessageTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M775.3 248.9a369.62 369.62 0 00-119-80A370.2 370.2 0 00512.1 140h-1.7c-99.7.4-193 39.4-262.8 109.9-69.9 70.5-108 164.1-107.6 263.8.3 60.3 15.3 120.2 43.5 173.1l4.5 8.4V836h140.8l8.4 4.5c52.9 28.2 112.8 43.2 173.1 43.5h1.7c99 0 192-38.2 262.1-107.6 70.4-69.8 109.5-163.1 110.1-262.7.2-50.6-9.5-99.6-28.9-145.8a370.15 370.15 0 00-80-119zM312 560a48.01 48.01 0 010-96 48.01 48.01 0 010 96zm200 0a48.01 48.01 0 010-96 48.01 48.01 0 010 96zm200 0a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M664 512a48 48 0 1096 0 48 48 0 10-96 0zm-400 0a48 48 0 1096 0 48 48 0 10-96 0z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M925.2 338.4c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 00-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 00-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 00112 714v152a46 46 0 0046 46h152.1A449.4 449.4 0 00510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 00142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M464 512a48 48 0 1096 0 48 48 0 10-96 0z", "fill": primaryColor } }] }; }, "name": "message", "theme": "twotone" };
var MessageTwoToneSvg = MessageTwoTone$2;

var MessageTwoTone = function MessageTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MessageTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MessageTwoTone.displayName = 'MessageTwoTone';
}
var MessageTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(MessageTwoTone);

// This icon file is generated automatically.
var MinusCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z" } }] }, "name": "minus-circle", "theme": "filled" };
var MinusCircleFilledSvg = MinusCircleFilled$2;

var MinusCircleFilled = function MinusCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MinusCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MinusCircleFilled.displayName = 'MinusCircleFilled';
}
var MinusCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(MinusCircleFilled);

// This icon file is generated automatically.
var MinusCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "minus-circle", "theme": "outlined" };
var MinusCircleOutlinedSvg = MinusCircleOutlined$2;

var MinusCircleOutlined = function MinusCircleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MinusCircleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MinusCircleOutlined.displayName = 'MinusCircleOutlined';
}
var MinusCircleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(MinusCircleOutlined);

// This icon file is generated automatically.
var MinusCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm192 396c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "minus-circle", "theme": "twotone" };
var MinusCircleTwoToneSvg = MinusCircleTwoTone$2;

var MinusCircleTwoTone = function MinusCircleTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MinusCircleTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MinusCircleTwoTone.displayName = 'MinusCircleTwoTone';
}
var MinusCircleTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(MinusCircleTwoTone);

// This icon file is generated automatically.
var MinusOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] }, "name": "minus", "theme": "outlined" };
var MinusOutlinedSvg = MinusOutlined$2;

var MinusOutlined = function MinusOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MinusOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MinusOutlined.displayName = 'MinusOutlined';
}
var MinusOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(MinusOutlined);

// This icon file is generated automatically.
var MinusSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM704 536c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z" } }] }, "name": "minus-square", "theme": "filled" };
var MinusSquareFilledSvg = MinusSquareFilled$2;

var MinusSquareFilled = function MinusSquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MinusSquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MinusSquareFilled.displayName = 'MinusSquareFilled';
}
var MinusSquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(MinusSquareFilled);

// This icon file is generated automatically.
var MinusSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "minus-square", "theme": "outlined" };
var MinusSquareOutlinedSvg = MinusSquareOutlined$2;

var MinusSquareOutlined = function MinusSquareOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MinusSquareOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MinusSquareOutlined.displayName = 'MinusSquareOutlined';
}
var MinusSquareOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(MinusSquareOutlined);

// This icon file is generated automatically.
var MinusSquareTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm136-352c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z", "fill": primaryColor } }] }; }, "name": "minus-square", "theme": "twotone" };
var MinusSquareTwoToneSvg = MinusSquareTwoTone$2;

var MinusSquareTwoTone = function MinusSquareTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MinusSquareTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MinusSquareTwoTone.displayName = 'MinusSquareTwoTone';
}
var MinusSquareTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(MinusSquareTwoTone);

// This icon file is generated automatically.
var MobileFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zM512 824c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z" } }] }, "name": "mobile", "theme": "filled" };
var MobileFilledSvg = MobileFilled$2;

var MobileFilled = function MobileFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MobileFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MobileFilled.displayName = 'MobileFilled';
}
var MobileFilled$1 = /*#__PURE__*/React__namespace.forwardRef(MobileFilled);

// This icon file is generated automatically.
var MobileOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zm-8 824H288V134h448v752zM472 784a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "mobile", "theme": "outlined" };
var MobileOutlinedSvg = MobileOutlined$2;

var MobileOutlined = function MobileOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MobileOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MobileOutlined.displayName = 'MobileOutlined';
}
var MobileOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(MobileOutlined);

// This icon file is generated automatically.
var MobileTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M744 64H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H288V136h448v752z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M288 888h448V136H288v752zm224-142c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M472 786a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }] }; }, "name": "mobile", "theme": "twotone" };
var MobileTwoToneSvg = MobileTwoTone$2;

var MobileTwoTone = function MobileTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MobileTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MobileTwoTone.displayName = 'MobileTwoTone';
}
var MobileTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(MobileTwoTone);

// This icon file is generated automatically.
var MoneyCollectFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M911.5 699.7a8 8 0 00-10.3-4.8L840 717.2V179c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V762c0 3.3 2.1 6.3 5.3 7.5L501 909.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zm-243.8-377L564 514.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V703c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 322.8c-2.1-3.8-.7-8.7 3.2-10.8 1.2-.7 2.5-1 3.8-1h55.7a8 8 0 017.1 4.4L511 484.2h3.3L599 315.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-.4 2.6-1 3.8z" } }] }, "name": "money-collect", "theme": "filled" };
var MoneyCollectFilledSvg = MoneyCollectFilled$2;

var MoneyCollectFilled = function MoneyCollectFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MoneyCollectFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MoneyCollectFilled.displayName = 'MoneyCollectFilled';
}
var MoneyCollectFilled$1 = /*#__PURE__*/React__namespace.forwardRef(MoneyCollectFilled);

// This icon file is generated automatically.
var MoneyCollectOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M911.5 700.7a8 8 0 00-10.3-4.8L840 718.2V180c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V763c0 3.3 2.1 6.3 5.3 7.5L501 910.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zM512 837.5l-256-93.1V184h512v560.4l-256 93.1zM660.6 312h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 00-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.6-1.2 1-2.5 1-3.8-.1-4.3-3.7-7.9-8.1-7.9z" } }] }, "name": "money-collect", "theme": "outlined" };
var MoneyCollectOutlinedSvg = MoneyCollectOutlined$2;

var MoneyCollectOutlined = function MoneyCollectOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MoneyCollectOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MoneyCollectOutlined.displayName = 'MoneyCollectOutlined';
}
var MoneyCollectOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(MoneyCollectOutlined);

// This icon file is generated automatically.
var MoneyCollectTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M256 744.4l256 93.1 256-93.1V184H256v560.4zM359.7 313c1.2-.7 2.5-1 3.8-1h55.7a8 8 0 017.1 4.4L511 485.2h3.3L599 316.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-.4 2.6-1 3.8L564 515.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V704c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 323.8c-2.1-3.8-.7-8.7 3.2-10.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M911.5 700.7a8 8 0 00-10.3-4.8L840 718.2V180c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V763c0 3.3 2.1 6.3 5.3 7.5L501 910.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zM768 744.4l-256 93.1-256-93.1V184h512v560.4z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M460.4 515.4h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.6-1.2 1-2.5 1-3.8-.1-4.3-3.7-7.9-8.1-7.9h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 00-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6z", "fill": primaryColor } }] }; }, "name": "money-collect", "theme": "twotone" };
var MoneyCollectTwoToneSvg = MoneyCollectTwoTone$2;

var MoneyCollectTwoTone = function MoneyCollectTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MoneyCollectTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MoneyCollectTwoTone.displayName = 'MoneyCollectTwoTone';
}
var MoneyCollectTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(MoneyCollectTwoTone);

// This icon file is generated automatically.
var MonitorOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M692.8 412.7l.2-.2-34.6-44.3a7.97 7.97 0 00-11.2-1.4l-50.4 39.3-70.5-90.1a7.97 7.97 0 00-11.2-1.4l-37.9 29.7a7.97 7.97 0 00-1.4 11.2l70.5 90.2-.2.1 34.6 44.3c2.7 3.5 7.7 4.1 11.2 1.4l50.4-39.3 64.1 82c2.7 3.5 7.7 4.1 11.2 1.4l37.9-29.6c3.5-2.7 4.1-7.7 1.4-11.2l-64.1-82.1zM608 112c-167.9 0-304 136.1-304 304 0 70.3 23.9 135 63.9 186.5L114.3 856.1a8.03 8.03 0 000 11.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0l253.6-253.6C473 696.1 537.7 720 608 720c167.9 0 304-136.1 304-304S775.9 112 608 112zm161.2 465.2C726.2 620.3 668.9 644 608 644s-118.2-23.7-161.2-66.8C403.7 534.2 380 476.9 380 416s23.7-118.2 66.8-161.2c43-43.1 100.3-66.8 161.2-66.8s118.2 23.7 161.2 66.8c43.1 43 66.8 100.3 66.8 161.2s-23.7 118.2-66.8 161.2z" } }] }, "name": "monitor", "theme": "outlined" };
var MonitorOutlinedSvg = MonitorOutlined$2;

var MonitorOutlined = function MonitorOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MonitorOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MonitorOutlined.displayName = 'MonitorOutlined';
}
var MonitorOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(MonitorOutlined);

// This icon file is generated automatically.
var MoreOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M456 231a56 56 0 10112 0 56 56 0 10-112 0zm0 280a56 56 0 10112 0 56 56 0 10-112 0zm0 280a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "more", "theme": "outlined" };
var MoreOutlinedSvg = MoreOutlined$2;

var MoreOutlined = function MoreOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MoreOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  MoreOutlined.displayName = 'MoreOutlined';
}
var MoreOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(MoreOutlined);

// This icon file is generated automatically.
var NodeCollapseOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M952 612c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H298a95.92 95.92 0 00-89-60c-53 0-96 43-96 96s43 96 96 96c40.3 0 74.8-24.8 89-60h150.3v152c0 55.2 44.8 100 100 100H952c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H548.3c-15.5 0-28-12.5-28-28V612H952zM451.7 313.7l172.5 136.2c6.3 5.1 15.8.5 15.8-7.7V344h264c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H640v-98.2c0-8.1-9.4-12.8-15.8-7.7L451.7 298.3a9.9 9.9 0 000 15.4z" } }] }, "name": "node-collapse", "theme": "outlined" };
var NodeCollapseOutlinedSvg = NodeCollapseOutlined$2;

var NodeCollapseOutlined = function NodeCollapseOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: NodeCollapseOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  NodeCollapseOutlined.displayName = 'NodeCollapseOutlined';
}
var NodeCollapseOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(NodeCollapseOutlined);

// This icon file is generated automatically.
var NodeExpandOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M952 612c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H298a95.92 95.92 0 00-89-60c-53 0-96 43-96 96s43 96 96 96c40.3 0 74.8-24.8 89-60h150.3v152c0 55.2 44.8 100 100 100H952c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H548.3c-15.5 0-28-12.5-28-28V612H952zM456 344h264v98.2c0 8.1 9.5 12.8 15.8 7.7l172.5-136.2c5-3.9 5-11.4 0-15.3L735.8 162.1c-6.4-5.1-15.8-.5-15.8 7.7V268H456c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8z" } }] }, "name": "node-expand", "theme": "outlined" };
var NodeExpandOutlinedSvg = NodeExpandOutlined$2;

var NodeExpandOutlined = function NodeExpandOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: NodeExpandOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  NodeExpandOutlined.displayName = 'NodeExpandOutlined';
}
var NodeExpandOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(NodeExpandOutlined);

// This icon file is generated automatically.
var NodeIndexOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M843.5 737.4c-12.4-75.2-79.2-129.1-155.3-125.4S550.9 676 546 752c-153.5-4.8-208-40.7-199.1-113.7 3.3-27.3 19.8-41.9 50.1-49 18.4-4.3 38.8-4.9 57.3-3.2 1.7.2 3.5.3 5.2.5 11.3 2.7 22.8 5 34.3 6.8 34.1 5.6 68.8 8.4 101.8 6.6 92.8-5 156-45.9 159.2-132.7 3.1-84.1-54.7-143.7-147.9-183.6-29.9-12.8-61.6-22.7-93.3-30.2-14.3-3.4-26.3-5.7-35.2-7.2-7.9-75.9-71.5-133.8-147.8-134.4-76.3-.6-140.9 56.1-150.1 131.9s40 146.3 114.2 163.9c74.2 17.6 149.9-23.3 175.7-95.1 9.4 1.7 18.7 3.6 28 5.8 28.2 6.6 56.4 15.4 82.4 26.6 70.7 30.2 109.3 70.1 107.5 119.9-1.6 44.6-33.6 65.2-96.2 68.6-27.5 1.5-57.6-.9-87.3-5.8-8.3-1.4-15.9-2.8-22.6-4.3-3.9-.8-6.6-1.5-7.8-1.8l-3.1-.6c-2.2-.3-5.9-.8-10.7-1.3-25-2.3-52.1-1.5-78.5 4.6-55.2 12.9-93.9 47.2-101.1 105.8-15.7 126.2 78.6 184.7 276 188.9 29.1 70.4 106.4 107.9 179.6 87 73.3-20.9 119.3-93.4 106.9-168.6zM329.1 345.2a83.3 83.3 0 11.01-166.61 83.3 83.3 0 01-.01 166.61zM695.6 845a83.3 83.3 0 11.01-166.61A83.3 83.3 0 01695.6 845z" } }] }, "name": "node-index", "theme": "outlined" };
var NodeIndexOutlinedSvg = NodeIndexOutlined$2;

var NodeIndexOutlined = function NodeIndexOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: NodeIndexOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  NodeIndexOutlined.displayName = 'NodeIndexOutlined';
}
var NodeIndexOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(NodeIndexOutlined);

// This icon file is generated automatically.
var NotificationFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.6c-3.7 11.6-5.6 23.9-5.6 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1z" } }] }, "name": "notification", "theme": "filled" };
var NotificationFilledSvg = NotificationFilled$2;

var NotificationFilled = function NotificationFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: NotificationFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  NotificationFilled.displayName = 'NotificationFilled';
}
var NotificationFilled$1 = /*#__PURE__*/React__namespace.forwardRef(NotificationFilled);

// This icon file is generated automatically.
var NotificationOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.7c-3.7 11.6-5.7 23.9-5.7 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1zm496 58.4L318.8 611.3l-12.9-5.2H184V417.9h121.9l12.9-5.2L840 203.3v617.4z" } }] }, "name": "notification", "theme": "outlined" };
var NotificationOutlinedSvg = NotificationOutlined$2;

var NotificationOutlined = function NotificationOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: NotificationOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  NotificationOutlined.displayName = 'NotificationOutlined';
}
var NotificationOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(NotificationOutlined);

// This icon file is generated automatically.
var NotificationTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M229.6 678.1c-3.7 11.6-5.6 23.9-5.6 36.4 0-12.5 2-24.8 5.7-36.4h-.1zm76.3-260.2H184v188.2h121.9l12.9 5.2L840 820.7V203.3L318.8 412.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.7c-3.7 11.6-5.7 23.9-5.7 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1zm496 58.4L318.8 611.3l-12.9-5.2H184V417.9h121.9l12.9-5.2L840 203.3v617.4z", "fill": primaryColor } }] }; }, "name": "notification", "theme": "twotone" };
var NotificationTwoToneSvg = NotificationTwoTone$2;

var NotificationTwoTone = function NotificationTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: NotificationTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  NotificationTwoTone.displayName = 'NotificationTwoTone';
}
var NotificationTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(NotificationTwoTone);

// This icon file is generated automatically.
var NumberOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 394c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H400V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v236H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h228v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h164c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V394h164zM628 630H400V394h228v236z" } }] }, "name": "number", "theme": "outlined" };
var NumberOutlinedSvg = NumberOutlined$2;

var NumberOutlined = function NumberOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: NumberOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  NumberOutlined.displayName = 'NumberOutlined';
}
var NumberOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(NumberOutlined);

// This icon file is generated automatically.
var OneToOneOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M316 672h60c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8zm196-50c22.1 0 40-17.9 40-39 0-23.1-17.9-41-40-41s-40 17.9-40 41c0 21.1 17.9 39 40 39zm0-140c22.1 0 40-17.9 40-39 0-23.1-17.9-41-40-41s-40 17.9-40 41c0 21.1 17.9 39 40 39z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }, { "tag": "path", "attrs": { "d": "M648 672h60c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8z" } }] }, "name": "one-to-one", "theme": "outlined" };
var OneToOneOutlinedSvg = OneToOneOutlined$2;

var OneToOneOutlined = function OneToOneOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: OneToOneOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  OneToOneOutlined.displayName = 'OneToOneOutlined';
}
var OneToOneOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(OneToOneOutlined);

// This icon file is generated automatically.
var OrderedListOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M920 760H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-568H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM216 712H100c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h72.4v20.5h-35.7c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h35.7V838H100c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h116c2.2 0 4-1.8 4-4V716c0-2.2-1.8-4-4-4zM100 188h38v120c0 2.2 1.8 4 4 4h40c2.2 0 4-1.8 4-4V152c0-4.4-3.6-8-8-8h-78c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4zm116 240H100c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4h68.4l-70.3 77.7a8.3 8.3 0 00-2.1 5.4V592c0 2.2 1.8 4 4 4h116c2.2 0 4-1.8 4-4v-36c0-2.2-1.8-4-4-4h-68.4l70.3-77.7a8.3 8.3 0 002.1-5.4V432c0-2.2-1.8-4-4-4z" } }] }, "name": "ordered-list", "theme": "outlined" };
var OrderedListOutlinedSvg = OrderedListOutlined$2;

var OrderedListOutlined = function OrderedListOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: OrderedListOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  OrderedListOutlined.displayName = 'OrderedListOutlined';
}
var OrderedListOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(OrderedListOutlined);

// This icon file is generated automatically.
var PaperClipOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z" } }] }, "name": "paper-clip", "theme": "outlined" };
var PaperClipOutlinedSvg = PaperClipOutlined$2;

var PaperClipOutlined = function PaperClipOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PaperClipOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PaperClipOutlined.displayName = 'PaperClipOutlined';
}
var PaperClipOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(PaperClipOutlined);

// This icon file is generated automatically.
var PartitionOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M640.6 429.8h257.1c7.9 0 14.3-6.4 14.3-14.3V158.3c0-7.9-6.4-14.3-14.3-14.3H640.6c-7.9 0-14.3 6.4-14.3 14.3v92.9H490.6c-3.9 0-7.1 3.2-7.1 7.1v221.5h-85.7v-96.5c0-7.9-6.4-14.3-14.3-14.3H126.3c-7.9 0-14.3 6.4-14.3 14.3v257.2c0 7.9 6.4 14.3 14.3 14.3h257.1c7.9 0 14.3-6.4 14.3-14.3V544h85.7v221.5c0 3.9 3.2 7.1 7.1 7.1h135.7v92.9c0 7.9 6.4 14.3 14.3 14.3h257.1c7.9 0 14.3-6.4 14.3-14.3v-257c0-7.9-6.4-14.3-14.3-14.3h-257c-7.9 0-14.3 6.4-14.3 14.3v100h-78.6v-393h78.6v100c0 7.9 6.4 14.3 14.3 14.3zm53.5-217.9h150V362h-150V211.9zM329.9 587h-150V437h150v150zm364.2 75.1h150v150.1h-150V662.1z" } }] }, "name": "partition", "theme": "outlined" };
var PartitionOutlinedSvg = PartitionOutlined$2;

var PartitionOutlined = function PartitionOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PartitionOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PartitionOutlined.displayName = 'PartitionOutlined';
}
var PartitionOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(PartitionOutlined);

// This icon file is generated automatically.
var PauseCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-80 600c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304zm224 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z" } }] }, "name": "pause-circle", "theme": "filled" };
var PauseCircleFilledSvg = PauseCircleFilled$2;

var PauseCircleFilled = function PauseCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PauseCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PauseCircleFilled.displayName = 'PauseCircleFilled';
}
var PauseCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(PauseCircleFilled);

// This icon file is generated automatically.
var PauseCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm-88-532h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zm224 0h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z" } }] }, "name": "pause-circle", "theme": "outlined" };
var PauseCircleOutlinedSvg = PauseCircleOutlined$2;

var PauseCircleOutlined = function PauseCircleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PauseCircleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PauseCircleOutlined.displayName = 'PauseCircleOutlined';
}
var PauseCircleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(PauseCircleOutlined);

// This icon file is generated automatically.
var PauseCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-80 524c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304zm224 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M424 352h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zm224 0h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "pause-circle", "theme": "twotone" };
var PauseCircleTwoToneSvg = PauseCircleTwoTone$2;

var PauseCircleTwoTone = function PauseCircleTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PauseCircleTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PauseCircleTwoTone.displayName = 'PauseCircleTwoTone';
}
var PauseCircleTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(PauseCircleTwoTone);

// This icon file is generated automatically.
var PauseOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M304 176h80v672h-80zm408 0h-64c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8z" } }] }, "name": "pause", "theme": "outlined" };
var PauseOutlinedSvg = PauseOutlined$2;

var PauseOutlined = function PauseOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PauseOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PauseOutlined.displayName = 'PauseOutlined';
}
var PauseOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(PauseOutlined);

// This icon file is generated automatically.
var PayCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm166.6 246.8L567.5 515.6h62c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V603h82c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V717c0 4.4-3.6 8-8 8h-54.3c-4.4 0-8-3.6-8-8v-68.1h-81.7c-4.4 0-8-3.6-8-8V611c0-4.4 3.6-8 8-8h81.7v-41.5h-81.7c-4.4 0-8-3.6-8-8v-29.9c0-4.4 3.6-8 8-8h61.4L345.4 310.8a8.07 8.07 0 017-11.9h60.7c3 0 5.8 1.7 7.1 4.4l90.6 180h3.4l90.6-180a8 8 0 017.1-4.4h59.5c4.4 0 8 3.6 8 8 .2 1.4-.2 2.7-.8 3.9z" } }] }, "name": "pay-circle", "theme": "filled" };
var PayCircleFilledSvg = PayCircleFilled$2;

var PayCircleFilled = function PayCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PayCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PayCircleFilled.displayName = 'PayCircleFilled';
}
var PayCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(PayCircleFilled);

// This icon file is generated automatically.
var PayCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm159.6-585h-59.5c-3 0-5.8 1.7-7.1 4.4l-90.6 180H511l-90.6-180a8 8 0 00-7.1-4.4h-60.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9L457 515.7h-61.4c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7V603h-81.7c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7V717c0 4.4 3.6 8 8 8h54.3c4.4 0 8-3.6 8-8v-68.1h82c4.4 0 8-3.6 8-8V611c0-4.4-3.6-8-8-8h-82v-41.5h82c4.4 0 8-3.6 8-8v-29.9c0-4.4-3.6-8-8-8h-62l111.1-204.8c.6-1.2 1-2.5 1-3.8-.1-4.4-3.7-8-8.1-8z" } }] }, "name": "pay-circle", "theme": "outlined" };
var PayCircleOutlinedSvg = PayCircleOutlined$2;

var PayCircleOutlined = function PayCircleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PayCircleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PayCircleOutlined.displayName = 'PayCircleOutlined';
}
var PayCircleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(PayCircleOutlined);

// This icon file is generated automatically.
var PercentageOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M855.7 210.8l-42.4-42.4a8.03 8.03 0 00-11.3 0L168.3 801.9a8.03 8.03 0 000 11.3l42.4 42.4c3.1 3.1 8.2 3.1 11.3 0L855.6 222c3.2-3 3.2-8.1.1-11.2zM304 448c79.4 0 144-64.6 144-144s-64.6-144-144-144-144 64.6-144 144 64.6 144 144 144zm0-216c39.7 0 72 32.3 72 72s-32.3 72-72 72-72-32.3-72-72 32.3-72 72-72zm416 344c-79.4 0-144 64.6-144 144s64.6 144 144 144 144-64.6 144-144-64.6-144-144-144zm0 216c-39.7 0-72-32.3-72-72s32.3-72 72-72 72 32.3 72 72-32.3 72-72 72z" } }] }, "name": "percentage", "theme": "outlined" };
var PercentageOutlinedSvg = PercentageOutlined$2;

var PercentageOutlined = function PercentageOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PercentageOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PercentageOutlined.displayName = 'PercentageOutlined';
}
var PercentageOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(PercentageOutlined);

// This icon file is generated automatically.
var PhoneFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M885.6 230.2L779.1 123.8a80.83 80.83 0 00-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L549.8 238.4a80.83 80.83 0 00-23.8 57.3c0 21.7 8.5 42.1 23.8 57.4l83.8 83.8A393.82 393.82 0 01553.1 553 395.34 395.34 0 01437 633.8L353.2 550a80.83 80.83 0 00-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L123.8 664.5a80.89 80.89 0 00-23.8 57.4c0 21.7 8.5 42.1 23.8 57.4l106.3 106.3c24.4 24.5 58.1 38.4 92.7 38.4 7.3 0 14.3-.6 21.2-1.8 134.8-22.2 268.5-93.9 376.4-201.7C828.2 612.8 899.8 479.2 922.3 344c6.8-41.3-6.9-83.8-36.7-113.8z" } }] }, "name": "phone", "theme": "filled" };
var PhoneFilledSvg = PhoneFilled$2;

var PhoneFilled = function PhoneFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PhoneFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PhoneFilled.displayName = 'PhoneFilled';
}
var PhoneFilled$1 = /*#__PURE__*/React__namespace.forwardRef(PhoneFilled);

// This icon file is generated automatically.
var PhoneOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 01-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 00-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 00285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z" } }] }, "name": "phone", "theme": "outlined" };
var PhoneOutlinedSvg = PhoneOutlined$2;

var PhoneOutlined = function PhoneOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PhoneOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PhoneOutlined.displayName = 'PhoneOutlined';
}
var PhoneOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(PhoneOutlined);

// This icon file is generated automatically.
var PhoneTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M721.7 184.9L610.9 295.8l120.8 120.7-8 21.6A481.29 481.29 0 01438 723.9l-21.6 8-.9-.9-119.8-120-110.8 110.9 104.5 104.5c10.8 10.7 26 15.7 40.8 13.2 117.9-19.5 235.4-82.9 330.9-178.4s158.9-213.1 178.4-331c2.5-14.8-2.5-30-13.3-40.8L721.7 184.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 01-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 00-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 00285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z", "fill": primaryColor } }] }; }, "name": "phone", "theme": "twotone" };
var PhoneTwoToneSvg = PhoneTwoTone$2;

var PhoneTwoTone = function PhoneTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PhoneTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PhoneTwoTone.displayName = 'PhoneTwoTone';
}
var PhoneTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(PhoneTwoTone);

// This icon file is generated automatically.
var PicCenterOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM848 660c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h672zM232 436h560v152H232V436z" } }] }, "name": "pic-center", "theme": "outlined" };
var PicCenterOutlinedSvg = PicCenterOutlined$2;

var PicCenterOutlined = function PicCenterOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PicCenterOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PicCenterOutlined.displayName = 'PicCenterOutlined';
}
var PicCenterOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(PicCenterOutlined);

// This icon file is generated automatically.
var PicLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM608 660c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h512zM152 436h400v152H152V436zm552 210c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H712c-4.4 0-8 3.6-8 8v56zm8-204h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H712c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z" } }] }, "name": "pic-left", "theme": "outlined" };
var PicLeftOutlinedSvg = PicLeftOutlined$2;

var PicLeftOutlined = function PicLeftOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PicLeftOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PicLeftOutlined.displayName = 'PicLeftOutlined';
}
var PicLeftOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(PicLeftOutlined);

// This icon file is generated automatically.
var PicRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-24 500c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H416c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h512zM472 436h400v152H472V436zM80 646c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v56zm8-204h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z" } }] }, "name": "pic-right", "theme": "outlined" };
var PicRightOutlinedSvg = PicRightOutlined$2;

var PicRightOutlined = function PicRightOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PicRightOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PicRightOutlined.displayName = 'PicRightOutlined';
}
var PicRightOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(PicRightOutlined);

// This icon file is generated automatically.
var PictureFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zM338 304c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm513.9 437.1a8.11 8.11 0 01-5.2 1.9H177.2c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2l170.3-202c2.8-3.4 7.9-3.8 11.3-1 .3.3.7.6 1 1l99.4 118 158.1-187.5c2.8-3.4 7.9-3.8 11.3-1 .3.3.7.6 1 1l229.6 271.6c2.6 3.3 2.2 8.4-1.2 11.2z" } }] }, "name": "picture", "theme": "filled" };
var PictureFilledSvg = PictureFilled$2;

var PictureFilled = function PictureFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PictureFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PictureFilled.displayName = 'PictureFilled';
}
var PictureFilled$1 = /*#__PURE__*/React__namespace.forwardRef(PictureFilled);

// This icon file is generated automatically.
var PictureOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2zM304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z" } }] }, "name": "picture", "theme": "outlined" };
var PictureOutlinedSvg = PictureOutlined$2;

var PictureOutlined = function PictureOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PictureOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PictureOutlined.displayName = 'PictureOutlined';
}
var PictureOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(PictureOutlined);

// This icon file is generated automatically.
var PictureTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M424.6 765.8l-150.1-178L136 752.1V792h752v-30.4L658.1 489z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M136 652.7l132.4-157c3.2-3.8 9-3.8 12.2 0l144 170.7L652 396.8c3.2-3.8 9-3.8 12.2 0L888 662.2V232H136v420.7zM304 280a88 88 0 110 176 88 88 0 010-176z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M276 368a28 28 0 1056 0 28 28 0 10-56 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z", "fill": primaryColor } }] }; }, "name": "picture", "theme": "twotone" };
var PictureTwoToneSvg = PictureTwoTone$2;

var PictureTwoTone = function PictureTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PictureTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PictureTwoTone.displayName = 'PictureTwoTone';
}
var PictureTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(PictureTwoTone);

// This icon file is generated automatically.
var PieChartFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M863.1 518.5H505.5V160.9c0-4.4-3.6-8-8-8h-26a398.57 398.57 0 00-282.5 117 397.47 397.47 0 00-85.6 127C82.6 446.2 72 498.5 72 552.5S82.6 658.7 103.4 708c20.1 47.5 48.9 90.3 85.6 127 36.7 36.7 79.4 65.5 127 85.6a396.64 396.64 0 00155.6 31.5 398.57 398.57 0 00282.5-117c36.7-36.7 65.5-79.4 85.6-127a396.64 396.64 0 0031.5-155.6v-26c-.1-4.4-3.7-8-8.1-8zM951 463l-2.6-28.2c-8.5-92-49.3-178.8-115.1-244.3A398.5 398.5 0 00588.4 75.6L560.1 73c-4.7-.4-8.7 3.2-8.7 7.9v383.7c0 4.4 3.6 8 8 8l383.6-1c4.7-.1 8.4-4 8-8.6z" } }] }, "name": "pie-chart", "theme": "filled" };
var PieChartFilledSvg = PieChartFilled$2;

var PieChartFilled = function PieChartFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PieChartFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PieChartFilled.displayName = 'PieChartFilled';
}
var PieChartFilled$1 = /*#__PURE__*/React__namespace.forwardRef(PieChartFilled);

// This icon file is generated automatically.
var PieChartOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 518H506V160c0-4.4-3.6-8-8-8h-26a398.46 398.46 0 00-282.8 117.1 398.19 398.19 0 00-85.7 127.1A397.61 397.61 0 0072 552a398.46 398.46 0 00117.1 282.8c36.7 36.7 79.5 65.6 127.1 85.7A397.61 397.61 0 00472 952a398.46 398.46 0 00282.8-117.1c36.7-36.7 65.6-79.5 85.7-127.1A397.61 397.61 0 00872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8A331.59 331.59 0 01470.4 884c-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552c0-88.7 34.5-172.1 97.2-234.8 54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8zM952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6A399.4 399.4 0 00589 74.6L560.7 72c-4.7-.4-8.7 3.2-8.7 7.9V464c0 4.4 3.6 8 8 8l384-1c4.7 0 8.4-4 8-8.6zm-332.2-58.2V147.6a332.24 332.24 0 01166.4 89.8c45.7 45.6 77 103.6 90 166.1l-256.4.7z" } }] }, "name": "pie-chart", "theme": "outlined" };
var PieChartOutlinedSvg = PieChartOutlined$2;

var PieChartOutlined = function PieChartOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PieChartOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PieChartOutlined.displayName = 'PieChartOutlined';
}
var PieChartOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(PieChartOutlined);

// This icon file is generated automatically.
var PieChartTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M316.2 920.5c-47.6-20.1-90.4-49-127.1-85.7a398.19 398.19 0 01-85.7-127.1A397.12 397.12 0 0172 552.2v.2a398.57 398.57 0 00117 282.5c36.7 36.7 79.4 65.5 127 85.6A396.64 396.64 0 00471.6 952c27 0 53.6-2.7 79.7-7.9-25.9 5.2-52.4 7.8-79.3 7.8-54 .1-106.4-10.5-155.8-31.4zM560 472c-4.4 0-8-3.6-8-8V79.9c0-1.3.3-2.5.9-3.6-.9 1.3-1.5 2.9-1.5 4.6v383.7c0 4.4 3.6 8 8 8l383.6-1c1.6 0 3.1-.5 4.4-1.3-1 .5-2.2.7-3.4.7l-384 1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M619.8 147.6v256.6l256.4-.7c-13-62.5-44.3-120.5-90-166.1a332.24 332.24 0 00-166.4-89.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M438 221.7c-75.9 7.6-146.2 40.9-200.8 95.5C174.5 379.9 140 463.3 140 552s34.5 172.1 97.2 234.8c62.3 62.3 145.1 96.8 233.2 97.2 88.2.4 172.7-34.1 235.3-96.2C761 733 794.6 662.3 802.3 586H438V221.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M864 518H506V160c0-4.4-3.6-8-8-8h-26a398.46 398.46 0 00-282.8 117.1 398.19 398.19 0 00-85.7 127.1A397.61 397.61 0 0072 552v.2c0 53.9 10.6 106.2 31.4 155.5 20.1 47.6 49 90.4 85.7 127.1 36.7 36.7 79.5 65.6 127.1 85.7A397.61 397.61 0 00472 952c26.9 0 53.4-2.6 79.3-7.8 26.1-5.3 51.7-13.1 76.4-23.6 47.6-20.1 90.4-49 127.1-85.7 36.7-36.7 65.6-79.5 85.7-127.1A397.61 397.61 0 00872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8A331.59 331.59 0 01470.4 884c-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552s34.5-172.1 97.2-234.8c54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6A399.4 399.4 0 00589 74.6L560.7 72c-3.4-.3-6.4 1.5-7.8 4.3a8.7 8.7 0 00-.9 3.6V464c0 4.4 3.6 8 8 8l384-1c1.2 0 2.3-.3 3.4-.7a8.1 8.1 0 004.6-7.9zm-332.2-58.2V147.6a332.24 332.24 0 01166.4 89.8c45.7 45.6 77 103.6 90 166.1l-256.4.7z", "fill": primaryColor } }] }; }, "name": "pie-chart", "theme": "twotone" };
var PieChartTwoToneSvg = PieChartTwoTone$2;

var PieChartTwoTone = function PieChartTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PieChartTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PieChartTwoTone.displayName = 'PieChartTwoTone';
}
var PieChartTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(PieChartTwoTone);

// This icon file is generated automatically.
var PlayCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm144.1 454.9L437.7 677.8a8.02 8.02 0 01-12.7-6.5V353.7a8 8 0 0112.7-6.5L656.1 506a7.9 7.9 0 010 12.9z" } }] }, "name": "play-circle", "theme": "filled" };
var PlayCircleFilledSvg = PlayCircleFilled$2;

var PlayCircleFilled = function PlayCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PlayCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PlayCircleFilled.displayName = 'PlayCircleFilled';
}
var PlayCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(PlayCircleFilled);

// This icon file is generated automatically.
var PlayCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M719.4 499.1l-296.1-215A15.9 15.9 0 00398 297v430c0 13.1 14.8 20.5 25.3 12.9l296.1-215a15.9 15.9 0 000-25.8zm-257.6 134V390.9L628.5 512 461.8 633.1z" } }] }, "name": "play-circle", "theme": "outlined" };
var PlayCircleOutlinedSvg = PlayCircleOutlined$2;

var PlayCircleOutlined = function PlayCircleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PlayCircleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PlayCircleOutlined.displayName = 'PlayCircleOutlined';
}
var PlayCircleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(PlayCircleOutlined);

// This icon file is generated automatically.
var PlayCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm164.1 378.2L457.7 677.1a8.02 8.02 0 01-12.7-6.5V353a8 8 0 0112.7-6.5l218.4 158.8a7.9 7.9 0 010 12.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M676.1 505.3L457.7 346.5A8 8 0 00445 353v317.6a8.02 8.02 0 0012.7 6.5l218.4-158.9a7.9 7.9 0 000-12.9z", "fill": primaryColor } }] }; }, "name": "play-circle", "theme": "twotone" };
var PlayCircleTwoToneSvg = PlayCircleTwoTone$2;

var PlayCircleTwoTone = function PlayCircleTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PlayCircleTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PlayCircleTwoTone.displayName = 'PlayCircleTwoTone';
}
var PlayCircleTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(PlayCircleTwoTone);

// This icon file is generated automatically.
var PlaySquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM641.7 520.8L442.3 677.6c-7.4 5.8-18.3.6-18.3-8.8V355.3c0-9.4 10.9-14.7 18.3-8.8l199.4 156.7a11.2 11.2 0 010 17.6z" } }] }, "name": "play-square", "theme": "filled" };
var PlaySquareFilledSvg = PlaySquareFilled$2;

var PlaySquareFilled = function PlaySquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PlaySquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PlaySquareFilled.displayName = 'PlaySquareFilled';
}
var PlaySquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(PlaySquareFilled);

// This icon file is generated automatically.
var PlaySquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M442.3 677.6l199.4-156.7a11.3 11.3 0 000-17.7L442.3 346.4c-7.4-5.8-18.3-.6-18.3 8.8v313.5c0 9.4 10.9 14.7 18.3 8.9z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "play-square", "theme": "outlined" };
var PlaySquareOutlinedSvg = PlaySquareOutlined$2;

var PlaySquareOutlined = function PlaySquareOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PlaySquareOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PlaySquareOutlined.displayName = 'PlaySquareOutlined';
}
var PlaySquareOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(PlaySquareOutlined);

// This icon file is generated automatically.
var PlaySquareTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm240-484.7c0-9.4 10.9-14.7 18.3-8.8l199.4 156.7a11.2 11.2 0 010 17.6L442.3 677.6c-7.4 5.8-18.3.6-18.3-8.8V355.3z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M442.3 677.6l199.4-156.8a11.2 11.2 0 000-17.6L442.3 346.5c-7.4-5.9-18.3-.6-18.3 8.8v313.5c0 9.4 10.9 14.6 18.3 8.8z", "fill": primaryColor } }] }; }, "name": "play-square", "theme": "twotone" };
var PlaySquareTwoToneSvg = PlaySquareTwoTone$2;

var PlaySquareTwoTone = function PlaySquareTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PlaySquareTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PlaySquareTwoTone.displayName = 'PlaySquareTwoTone';
}
var PlaySquareTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(PlaySquareTwoTone);

// This icon file is generated automatically.
var PlusCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" } }] }, "name": "plus-circle", "theme": "filled" };
var PlusCircleFilledSvg = PlusCircleFilled$2;

var PlusCircleFilled = function PlusCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PlusCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PlusCircleFilled.displayName = 'PlusCircleFilled';
}
var PlusCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(PlusCircleFilled);

// This icon file is generated automatically.
var PlusCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "plus-circle", "theme": "outlined" };
var PlusCircleOutlinedSvg = PlusCircleOutlined$2;

var PlusCircleOutlined = function PlusCircleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PlusCircleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PlusCircleOutlined.displayName = 'PlusCircleOutlined';
}
var PlusCircleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(PlusCircleOutlined);

// This icon file is generated automatically.
var PlusCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm192 396c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "plus-circle", "theme": "twotone" };
var PlusCircleTwoToneSvg = PlusCircleTwoTone$2;

var PlusCircleTwoTone = function PlusCircleTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PlusCircleTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PlusCircleTwoTone.displayName = 'PlusCircleTwoTone';
}
var PlusCircleTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(PlusCircleTwoTone);

// This icon file is generated automatically.
var PlusOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z" } }, { "tag": "path", "attrs": { "d": "M176 474h672q8 0 8 8v60q0 8-8 8H176q-8 0-8-8v-60q0-8 8-8z" } }] }, "name": "plus", "theme": "outlined" };
var PlusOutlinedSvg = PlusOutlined$2;

var PlusOutlined = function PlusOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PlusOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PlusOutlined.displayName = 'PlusOutlined';
}
var PlusOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(PlusOutlined);

// This icon file is generated automatically.
var PlusSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM704 536c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" } }] }, "name": "plus-square", "theme": "filled" };
var PlusSquareFilledSvg = PlusSquareFilled$2;

var PlusSquareFilled = function PlusSquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PlusSquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PlusSquareFilled.displayName = 'PlusSquareFilled';
}
var PlusSquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(PlusSquareFilled);

// This icon file is generated automatically.
var PlusSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "plus-square", "theme": "outlined" };
var PlusSquareOutlinedSvg = PlusSquareOutlined$2;

var PlusSquareOutlined = function PlusSquareOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PlusSquareOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PlusSquareOutlined.displayName = 'PlusSquareOutlined';
}
var PlusSquareOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(PlusSquareOutlined);

// This icon file is generated automatically.
var PlusSquareTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm136-352c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z", "fill": primaryColor } }] }; }, "name": "plus-square", "theme": "twotone" };
var PlusSquareTwoToneSvg = PlusSquareTwoTone$2;

var PlusSquareTwoTone = function PlusSquareTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PlusSquareTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PlusSquareTwoTone.displayName = 'PlusSquareTwoTone';
}
var PlusSquareTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(PlusSquareTwoTone);

// This icon file is generated automatically.
var PoundCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm146 658c0 4.4-3.6 8-8 8H376.2c-4.4 0-8-3.6-8-8v-38.5c0-3.7 2.5-6.9 6.1-7.8 44-10.9 72.8-49 72.8-94.2 0-14.7-2.5-29.4-5.9-44.2H374c-4.4 0-8-3.6-8-8v-30c0-4.4 3.6-8 8-8h53.7c-7.8-25.1-14.6-50.7-14.6-77.1 0-75.8 58.6-120.3 151.5-120.3 26.5 0 51.4 5.5 70.3 12.7 3.1 1.2 5.2 4.2 5.2 7.5v39.5a8 8 0 01-10.6 7.6c-17.9-6.4-39-10.5-60.4-10.5-53.3 0-87.3 26.6-87.3 70.2 0 24.7 6.2 47.9 13.4 70.5h112c4.4 0 8 3.6 8 8v30c0 4.4-3.6 8-8 8h-98.6c3.1 13.2 5.3 26.9 5.3 41 0 40.7-16.5 73.9-43.9 91.1v4.7h180c4.4 0 8 3.6 8 8V722z" } }] }, "name": "pound-circle", "theme": "filled" };
var PoundCircleFilledSvg = PoundCircleFilled$2;

var PoundCircleFilled = function PoundCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PoundCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PoundCircleFilled.displayName = 'PoundCircleFilled';
}
var PoundCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(PoundCircleFilled);

// This icon file is generated automatically.
var PoundCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm138-209.8H469.8v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.9-5.3-41H607c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8H495c-7.2-22.6-13.4-45.7-13.4-70.5 0-43.5 34-70.2 87.3-70.2 21.5 0 42.5 4.1 60.4 10.5 5.2 1.9 10.6-2 10.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.8-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.3 6.9 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.1c3.4 14.7 5.9 29.4 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8V722c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z" } }] }, "name": "pound-circle", "theme": "outlined" };
var PoundCircleOutlinedSvg = PoundCircleOutlined$2;

var PoundCircleOutlined = function PoundCircleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PoundCircleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PoundCircleOutlined.displayName = 'PoundCircleOutlined';
}
var PoundCircleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(PoundCircleOutlined);

// This icon file is generated automatically.
var PoundCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm146 582.1c0 4.4-3.6 8-8 8H376.2c-4.4 0-8-3.6-8-8v-38.5c0-3.7 2.5-6.9 6.1-7.8 44-10.9 72.8-49 72.8-94.2 0-14.7-2.5-29.4-5.9-44.2H374c-4.4 0-8-3.6-8-8v-30c0-4.4 3.6-8 8-8h53.7c-7.8-25.1-14.6-50.7-14.6-77.1 0-75.8 58.6-120.3 151.5-120.3 26.5 0 51.4 5.5 70.3 12.7 3.1 1.2 5.2 4.2 5.2 7.5v39.5a8 8 0 01-10.6 7.6c-17.9-6.4-39-10.5-60.4-10.5-53.3 0-87.3 26.6-87.3 70.2 0 24.7 6.2 47.9 13.4 70.5h112c4.4 0 8 3.6 8 8v30c0 4.4-3.6 8-8 8h-98.6c3.1 13.2 5.3 26.9 5.3 41 0 40.7-16.5 73.9-43.9 91.1v4.7h180c4.4 0 8 3.6 8 8v39.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M650 674.3H470v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.8-5.3-41h98.6c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8h-112c-7.2-22.6-13.4-45.8-13.4-70.5 0-43.6 34-70.2 87.3-70.2 21.4 0 42.5 4.1 60.4 10.5a8 8 0 0010.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.9-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.4 6.8 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.2c3.4 14.8 5.9 29.5 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8v38.5c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "pound-circle", "theme": "twotone" };
var PoundCircleTwoToneSvg = PoundCircleTwoTone$2;

var PoundCircleTwoTone = function PoundCircleTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PoundCircleTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PoundCircleTwoTone.displayName = 'PoundCircleTwoTone';
}
var PoundCircleTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(PoundCircleTwoTone);

// This icon file is generated automatically.
var PoundOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm138-209.8H469.8v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.9-5.3-41H607c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8H495c-7.2-22.6-13.4-45.7-13.4-70.5 0-43.5 34-70.2 87.3-70.2 21.5 0 42.5 4.1 60.4 10.5 5.2 1.9 10.6-2 10.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.8-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.3 6.9 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.1c3.4 14.7 5.9 29.4 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8V722c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z" } }] }, "name": "pound", "theme": "outlined" };
var PoundOutlinedSvg = PoundOutlined$2;

var PoundOutlined = function PoundOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PoundOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PoundOutlined.displayName = 'PoundOutlined';
}
var PoundOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(PoundOutlined);

// This icon file is generated automatically.
var PoweroffOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M705.6 124.9a8 8 0 00-11.6 7.2v64.2c0 5.5 2.9 10.6 7.5 13.6a352.2 352.2 0 0162.2 49.8c32.7 32.8 58.4 70.9 76.3 113.3a355 355 0 0127.9 138.7c0 48.1-9.4 94.8-27.9 138.7a355.92 355.92 0 01-76.3 113.3 353.06 353.06 0 01-113.2 76.4c-43.8 18.6-90.5 28-138.5 28s-94.7-9.4-138.5-28a353.06 353.06 0 01-113.2-76.4A355.92 355.92 0 01184 650.4a355 355 0 01-27.9-138.7c0-48.1 9.4-94.8 27.9-138.7 17.9-42.4 43.6-80.5 76.3-113.3 19-19 39.8-35.6 62.2-49.8 4.7-2.9 7.5-8.1 7.5-13.6V132c0-6-6.3-9.8-11.6-7.2C178.5 195.2 82 339.3 80 506.3 77.2 745.1 272.5 943.5 511.2 944c239 .5 432.8-193.3 432.8-432.4 0-169.2-97-315.7-238.4-386.7zM480 560h64c4.4 0 8-3.6 8-8V88c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z" } }] }, "name": "poweroff", "theme": "outlined" };
var PoweroffOutlinedSvg = PoweroffOutlined$2;

var PoweroffOutlined = function PoweroffOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PoweroffOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PoweroffOutlined.displayName = 'PoweroffOutlined';
}
var PoweroffOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(PoweroffOutlined);

// This icon file is generated automatically.
var PrinterFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M732 120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v148h440V120zm120 212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM664 844H360V568h304v276zm164-360c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v40z" } }] }, "name": "printer", "theme": "filled" };
var PrinterFilledSvg = PrinterFilled$2;

var PrinterFilled = function PrinterFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PrinterFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PrinterFilled.displayName = 'PrinterFilled';
}
var PrinterFilled$1 = /*#__PURE__*/React__namespace.forwardRef(PrinterFilled);

// This icon file is generated automatically.
var PrinterOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8zm32-104H732V120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM360 180h304v152H360V180zm304 664H360V568h304v276zm200-140H732V500H292v204H160V412c0-6.6 5.4-12 12-12h680c6.6 0 12 5.4 12 12v292z" } }] }, "name": "printer", "theme": "outlined" };
var PrinterOutlinedSvg = PrinterOutlined$2;

var PrinterOutlined = function PrinterOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PrinterOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PrinterOutlined.displayName = 'PrinterOutlined';
}
var PrinterOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(PrinterOutlined);

// This icon file is generated automatically.
var PrinterTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M360 180h304v152H360zm492 220H172c-6.6 0-12 5.4-12 12v292h132V500h440v204h132V412c0-6.6-5.4-12-12-12zm-24 84c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M852 332H732V120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM360 180h304v152H360V180zm304 664H360V568h304v276zm200-140H732V500H292v204H160V412c0-6.6 5.4-12 12-12h680c6.6 0 12 5.4 12 12v292z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "printer", "theme": "twotone" };
var PrinterTwoToneSvg = PrinterTwoTone$2;

var PrinterTwoTone = function PrinterTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PrinterTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PrinterTwoTone.displayName = 'PrinterTwoTone';
}
var PrinterTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(PrinterTwoTone);

// This icon file is generated automatically.
var ProfileFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM380 696c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0-144c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0-144c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm304 272c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-144c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-144c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48z" } }] }, "name": "profile", "theme": "filled" };
var ProfileFilledSvg = ProfileFilled$2;

var ProfileFilled = function ProfileFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ProfileFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ProfileFilled.displayName = 'ProfileFilled';
}
var ProfileFilled$1 = /*#__PURE__*/React__namespace.forwardRef(ProfileFilled);

// This icon file is generated automatically.
var ProfileOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM492 400h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zM340 368a40 40 0 1080 0 40 40 0 10-80 0zm0 144a40 40 0 1080 0 40 40 0 10-80 0zm0 144a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "profile", "theme": "outlined" };
var ProfileOutlinedSvg = ProfileOutlined$2;

var ProfileOutlined = function ProfileOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ProfileOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ProfileOutlined.displayName = 'ProfileOutlined';
}
var ProfileOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ProfileOutlined);

// This icon file is generated automatically.
var ProfileTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm300-496c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zm0 144c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zm0 144c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zM380 328c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M340 656a40 40 0 1080 0 40 40 0 10-80 0zm0-144a40 40 0 1080 0 40 40 0 10-80 0zm0-144a40 40 0 1080 0 40 40 0 10-80 0zm152 320h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z", "fill": primaryColor } }] }; }, "name": "profile", "theme": "twotone" };
var ProfileTwoToneSvg = ProfileTwoTone$2;

var ProfileTwoTone = function ProfileTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ProfileTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ProfileTwoTone.displayName = 'ProfileTwoTone';
}
var ProfileTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(ProfileTwoTone);

// This icon file is generated automatically.
var ProjectFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM368 744c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v464zm192-280c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v184zm192 72c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v256z" } }] }, "name": "project", "theme": "filled" };
var ProjectFilledSvg = ProjectFilled$2;

var ProjectFilled = function ProjectFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ProjectFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ProjectFilled.displayName = 'ProjectFilled';
}
var ProjectFilled$1 = /*#__PURE__*/React__namespace.forwardRef(ProjectFilled);

// This icon file is generated automatically.
var ProjectOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M280 752h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8zm192-280h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm192 72h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v256c0 4.4 3.6 8 8 8zm216-432H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "project", "theme": "outlined" };
var ProjectOutlinedSvg = ProjectOutlined$2;

var ProjectOutlined = function ProjectOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ProjectOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ProjectOutlined.displayName = 'ProjectOutlined';
}
var ProjectOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ProjectOutlined);

// This icon file is generated automatically.
var ProjectTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm472-560c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v256c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280zm-192 0c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280zm-192 0c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v464c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M280 752h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8zm192-280h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm192 72h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v256c0 4.4 3.6 8 8 8z", "fill": primaryColor } }] }; }, "name": "project", "theme": "twotone" };
var ProjectTwoToneSvg = ProjectTwoTone$2;

var ProjectTwoTone = function ProjectTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ProjectTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ProjectTwoTone.displayName = 'ProjectTwoTone';
}
var ProjectTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(ProjectTwoTone);

// This icon file is generated automatically.
var PropertySafetyFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM648.3 332.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V658c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3 73.2-144.3a10 10 0 018.9-5.5h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8z" } }] }, "name": "property-safety", "theme": "filled" };
var PropertySafetyFilledSvg = PropertySafetyFilled$2;

var PropertySafetyFilled = function PropertySafetyFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PropertySafetyFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PropertySafetyFilled.displayName = 'PropertySafetyFilled';
}
var PropertySafetyFilled$1 = /*#__PURE__*/React__namespace.forwardRef(PropertySafetyFilled);

// This icon file is generated automatically.
var PropertySafetyOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zM430.5 318h-46c-1.7 0-3.3.4-4.8 1.2a10.1 10.1 0 00-4 13.6l88 161.1h-45.2c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1v29.7h-63.1c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1V658c0 5.5 4.5 10 10 10h41.3c5.5 0 10-4.5 10-10v-51.8h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-63.4v-29.7h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-45.7l87.7-161.1a10.05 10.05 0 00-8.8-14.8h-45c-3.8 0-7.2 2.1-8.9 5.5l-73.2 144.3-72.9-144.3c-1.7-3.4-5.2-5.5-9-5.5z" } }] }, "name": "property-safety", "theme": "outlined" };
var PropertySafetyOutlinedSvg = PropertySafetyOutlined$2;

var PropertySafetyOutlined = function PropertySafetyOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PropertySafetyOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PropertySafetyOutlined.displayName = 'PropertySafetyOutlined';
}
var PropertySafetyOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(PropertySafetyOutlined);

// This icon file is generated automatically.
var PropertySafetyTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM593.9 318h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V658c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8H418c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7H418c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3L585 323.5a10 10 0 018.9-5.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M438.9 323.5a9.88 9.88 0 00-8.9-5.5h-46c-1.7 0-3.3.4-4.8 1.2-4.9 2.7-6.6 8.8-4 13.6l88 161.1H418c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1v29.7H418c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1V658c0 5.5 4.5 10 10 10h41.3c5.5 0 10-4.5 10-10v-51.8h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-63.4v-29.7h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-45.7l87.7-161.1c.8-1.5 1.2-3.1 1.1-4.8 0-5.5-4.5-10-10-10h-45a10 10 0 00-8.9 5.5l-73.2 144.3-72.9-144.3z", "fill": primaryColor } }] }; }, "name": "property-safety", "theme": "twotone" };
var PropertySafetyTwoToneSvg = PropertySafetyTwoTone$2;

var PropertySafetyTwoTone = function PropertySafetyTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PropertySafetyTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PropertySafetyTwoTone.displayName = 'PropertySafetyTwoTone';
}
var PropertySafetyTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(PropertySafetyTwoTone);

// This icon file is generated automatically.
var PullRequestOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M788 705.9V192c0-8.8-7.2-16-16-16H602v-68.8c0-6-7-9.4-11.7-5.7L462.7 202.3a7.14 7.14 0 000 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V240h114v465.9c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c.1-49.2-31.7-91-75.9-106.1zM752 860a48.01 48.01 0 010-96 48.01 48.01 0 010 96zM384 212c0-61.8-50.2-112-112-112s-112 50.2-112 112c0 49.2 31.8 91 76 106.1V706c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1V318.1c44.2-15.1 76-56.9 76-106.1zm-160 0a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm96 600a48.01 48.01 0 01-96 0 48.01 48.01 0 0196 0z" } }] }, "name": "pull-request", "theme": "outlined" };
var PullRequestOutlinedSvg = PullRequestOutlined$2;

var PullRequestOutlined = function PullRequestOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PullRequestOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PullRequestOutlined.displayName = 'PullRequestOutlined';
}
var PullRequestOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(PullRequestOutlined);

// This icon file is generated automatically.
var PushpinFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3-15.4 12.3-16.6 35.4-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 00-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8z" } }] }, "name": "pushpin", "theme": "filled" };
var PushpinFilledSvg = PushpinFilled$2;

var PushpinFilled = function PushpinFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PushpinFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PushpinFilled.displayName = 'PushpinFilled';
}
var PushpinFilled$1 = /*#__PURE__*/React__namespace.forwardRef(PushpinFilled);

// This icon file is generated automatically.
var PushpinOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3a33.23 33.23 0 00-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 00-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8zM666.2 549.3l-24.5 24.5 3.8 34.4a259.92 259.92 0 01-30.4 153.9L262 408.8c12.9-7.1 26.3-13.1 40.3-17.9 27.2-9.4 55.7-14.1 84.7-14.1 9.6 0 19.3.5 28.9 1.6l34.4 3.8 24.5-24.5L608.5 224 800 415.5 666.2 549.3z" } }] }, "name": "pushpin", "theme": "outlined" };
var PushpinOutlinedSvg = PushpinOutlined$2;

var PushpinOutlined = function PushpinOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PushpinOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PushpinOutlined.displayName = 'PushpinOutlined';
}
var PushpinOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(PushpinOutlined);

// This icon file is generated automatically.
var PushpinTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M474.8 357.7l-24.5 24.5-34.4-3.8c-9.6-1.1-19.3-1.6-28.9-1.6-29 0-57.5 4.7-84.7 14.1-14 4.8-27.4 10.8-40.3 17.9l353.1 353.3a259.92 259.92 0 0030.4-153.9l-3.8-34.4 24.5-24.5L800 415.5 608.5 224 474.8 357.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3a33.23 33.23 0 00-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 00-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8zM666.2 549.3l-24.5 24.5 3.8 34.4a259.92 259.92 0 01-30.4 153.9L262 408.8c12.9-7.1 26.3-13.1 40.3-17.9 27.2-9.4 55.7-14.1 84.7-14.1 9.6 0 19.3.5 28.9 1.6l34.4 3.8 24.5-24.5L608.5 224 800 415.5 666.2 549.3z", "fill": primaryColor } }] }; }, "name": "pushpin", "theme": "twotone" };
var PushpinTwoToneSvg = PushpinTwoTone$2;

var PushpinTwoTone = function PushpinTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PushpinTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  PushpinTwoTone.displayName = 'PushpinTwoTone';
}
var PushpinTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(PushpinTwoTone);

// This icon file is generated automatically.
var QqCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm210.5 612.4c-11.5 1.4-44.9-52.7-44.9-52.7 0 31.3-16.2 72.2-51.1 101.8 16.9 5.2 54.9 19.2 45.9 34.4-7.3 12.3-125.6 7.9-159.8 4-34.2 3.8-152.5 8.3-159.8-4-9.1-15.2 28.9-29.2 45.8-34.4-35-29.5-51.1-70.4-51.1-101.8 0 0-33.4 54.1-44.9 52.7-5.4-.7-12.4-29.6 9.4-99.7 10.3-33 22-60.5 40.2-105.8-3.1-116.9 45.3-215 160.4-215 113.9 0 163.3 96.1 160.4 215 18.1 45.2 29.9 72.8 40.2 105.8 21.7 70.1 14.6 99.1 9.3 99.7z" } }] }, "name": "qq-circle", "theme": "filled" };
var QqCircleFilledSvg = QqCircleFilled$2;

var QqCircleFilled = function QqCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: QqCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  QqCircleFilled.displayName = 'QqCircleFilled';
}
var QqCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(QqCircleFilled);

// This icon file is generated automatically.
var QqOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M824.8 613.2c-16-51.4-34.4-94.6-62.7-165.3C766.5 262.2 689.3 112 511.5 112 331.7 112 256.2 265.2 261 447.9c-28.4 70.8-46.7 113.7-62.7 165.3-34 109.5-23 154.8-14.6 155.8 18 2.2 70.1-82.4 70.1-82.4 0 49 25.2 112.9 79.8 159-26.4 8.1-85.7 29.9-71.6 53.8 11.4 19.3 196.2 12.3 249.5 6.3 53.3 6 238.1 13 249.5-6.3 14.1-23.8-45.3-45.7-71.6-53.8 54.6-46.2 79.8-110.1 79.8-159 0 0 52.1 84.6 70.1 82.4 8.5-1.1 19.5-46.4-14.5-155.8z" } }] }, "name": "qq", "theme": "outlined" };
var QqOutlinedSvg = QqOutlined$2;

var QqOutlined = function QqOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: QqOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  QqOutlined.displayName = 'QqOutlined';
}
var QqOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(QqOutlined);

// This icon file is generated automatically.
var QqSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM722.5 676.4c-11.5 1.4-44.9-52.7-44.9-52.7 0 31.3-16.2 72.2-51.1 101.8 16.9 5.2 54.9 19.2 45.9 34.4-7.3 12.3-125.6 7.9-159.8 4-34.2 3.8-152.5 8.3-159.8-4-9.1-15.2 28.9-29.2 45.8-34.4-35-29.5-51.1-70.4-51.1-101.8 0 0-33.4 54.1-44.9 52.7-5.4-.7-12.4-29.6 9.4-99.7 10.3-33 22-60.5 40.2-105.8-3.1-116.9 45.3-215 160.4-215 113.9 0 163.3 96.1 160.4 215 18.1 45.2 29.9 72.8 40.2 105.8 21.7 70.1 14.6 99.1 9.3 99.7z" } }] }, "name": "qq-square", "theme": "filled" };
var QqSquareFilledSvg = QqSquareFilled$2;

var QqSquareFilled = function QqSquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: QqSquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  QqSquareFilled.displayName = 'QqSquareFilled';
}
var QqSquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(QqSquareFilled);

// This icon file is generated automatically.
var QrcodeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M468 128H160c-17.7 0-32 14.3-32 32v308c0 4.4 3.6 8 8 8h332c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8zm-56 284H192V192h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm194 210H136c-4.4 0-8 3.6-8 8v308c0 17.7 14.3 32 32 32h308c4.4 0 8-3.6 8-8V556c0-4.4-3.6-8-8-8zm-56 284H192V612h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm590-630H556c-4.4 0-8 3.6-8 8v332c0 4.4 3.6 8 8 8h332c4.4 0 8-3.6 8-8V160c0-17.7-14.3-32-32-32zm-32 284H612V192h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm194 210h-48c-4.4 0-8 3.6-8 8v134h-78V556c0-4.4-3.6-8-8-8H556c-4.4 0-8 3.6-8 8v332c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h78v102c0 4.4 3.6 8 8 8h190c4.4 0 8-3.6 8-8V556c0-4.4-3.6-8-8-8zM746 832h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm142 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }] }, "name": "qrcode", "theme": "outlined" };
var QrcodeOutlinedSvg = QrcodeOutlined$2;

var QrcodeOutlined = function QrcodeOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: QrcodeOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  QrcodeOutlined.displayName = 'QrcodeOutlined';
}
var QrcodeOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(QrcodeOutlined);

// This icon file is generated automatically.
var QuestionCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 708c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5a48.3 48.3 0 00-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z" } }] }, "name": "question-circle", "theme": "filled" };
var QuestionCircleFilledSvg = QuestionCircleFilled$2;

var QuestionCircleFilled = function QuestionCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: QuestionCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  QuestionCircleFilled.displayName = 'QuestionCircleFilled';
}
var QuestionCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(QuestionCircleFilled);

// This icon file is generated automatically.
var QuestionCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "question-circle", "theme": "outlined" };
var QuestionCircleOutlinedSvg = QuestionCircleOutlined$2;

var QuestionCircleOutlined = function QuestionCircleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: QuestionCircleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  QuestionCircleOutlined.displayName = 'QuestionCircleOutlined';
}
var QuestionCircleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(QuestionCircleOutlined);

// This icon file is generated automatically.
var QuestionCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm0 632c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5a48.3 48.3 0 00-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M472 732a40 40 0 1080 0 40 40 0 10-80 0zm151.6-415.3C593.6 290.5 554 276 512 276s-81.6 14.4-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.2 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5 0-39.3-17.2-76-48.4-103.3z", "fill": primaryColor } }] }; }, "name": "question-circle", "theme": "twotone" };
var QuestionCircleTwoToneSvg = QuestionCircleTwoTone$2;

var QuestionCircleTwoTone = function QuestionCircleTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: QuestionCircleTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  QuestionCircleTwoTone.displayName = 'QuestionCircleTwoTone';
}
var QuestionCircleTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(QuestionCircleTwoTone);

// This icon file is generated automatically.
var QuestionOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M764 280.9c-14-30.6-33.9-58.1-59.3-81.6C653.1 151.4 584.6 125 512 125s-141.1 26.4-192.7 74.2c-25.4 23.6-45.3 51-59.3 81.7-14.6 32-22 65.9-22 100.9v27c0 6.2 5 11.2 11.2 11.2h54c6.2 0 11.2-5 11.2-11.2v-27c0-99.5 88.6-180.4 197.6-180.4s197.6 80.9 197.6 180.4c0 40.8-14.5 79.2-42 111.2-27.2 31.7-65.6 54.4-108.1 64-24.3 5.5-46.2 19.2-61.7 38.8a110.85 110.85 0 00-23.9 68.6v31.4c0 6.2 5 11.2 11.2 11.2h54c6.2 0 11.2-5 11.2-11.2v-31.4c0-15.7 10.9-29.5 26-32.9 58.4-13.2 111.4-44.7 149.3-88.7 19.1-22.3 34-47.1 44.3-74 10.7-27.9 16.1-57.2 16.1-87 0-35-7.4-69-22-100.9zM512 787c-30.9 0-56 25.1-56 56s25.1 56 56 56 56-25.1 56-56-25.1-56-56-56z" } }] }, "name": "question", "theme": "outlined" };
var QuestionOutlinedSvg = QuestionOutlined$2;

var QuestionOutlined = function QuestionOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: QuestionOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  QuestionOutlined.displayName = 'QuestionOutlined';
}
var QuestionOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(QuestionOutlined);

// This icon file is generated automatically.
var RadarChartOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M926.8 397.1l-396-288a31.81 31.81 0 00-37.6 0l-396 288a31.99 31.99 0 00-11.6 35.8l151.3 466a32 32 0 0030.4 22.1h489.5c13.9 0 26.1-8.9 30.4-22.1l151.3-466c4.2-13.2-.5-27.6-11.7-35.8zM838.6 417l-98.5 32-200-144.7V199.9L838.6 417zM466 567.2l-89.1 122.3-55.2-169.2L466 567.2zm-116.3-96.8L484 373.3v140.8l-134.3-43.7zM512 599.2l93.9 128.9H418.1L512 599.2zm28.1-225.9l134.2 97.1L540.1 514V373.3zM558 567.2l144.3-46.9-55.2 169.2L558 567.2zm-74-367.3v104.4L283.9 449l-98.5-32L484 199.9zM169.3 470.8l86.5 28.1 80.4 246.4-53.8 73.9-113.1-348.4zM327.1 853l50.3-69h269.3l50.3 69H327.1zm414.5-33.8l-53.8-73.9 80.4-246.4 86.5-28.1-113.1 348.4z" } }] }, "name": "radar-chart", "theme": "outlined" };
var RadarChartOutlinedSvg = RadarChartOutlined$2;

var RadarChartOutlined = function RadarChartOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RadarChartOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RadarChartOutlined.displayName = 'RadarChartOutlined';
}
var RadarChartOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(RadarChartOutlined);

// This icon file is generated automatically.
var RadiusBottomleftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M712 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm2-696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM136 374h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-174h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm752 624h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-230 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm230 624H358c-87.3 0-158-70.7-158-158V484c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v182c0 127 103 230 230 230h182c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "radius-bottomleft", "theme": "outlined" };
var RadiusBottomleftOutlinedSvg = RadiusBottomleftOutlined$2;

var RadiusBottomleftOutlined = function RadiusBottomleftOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RadiusBottomleftOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RadiusBottomleftOutlined.displayName = 'RadiusBottomleftOutlined';
}
var RadiusBottomleftOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(RadiusBottomleftOutlined);

// This icon file is generated automatically.
var RadiusBottomrightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M368 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-58-624h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm578 102h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm292 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm174 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm230 276h-56c-4.4 0-8 3.6-8 8v182c0 87.3-70.7 158-158 158H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h182c127 0 230-103 230-230V484c0-4.4-3.6-8-8-8z" } }] }, "name": "radius-bottomright", "theme": "outlined" };
var RadiusBottomrightOutlinedSvg = RadiusBottomrightOutlined$2;

var RadiusBottomrightOutlined = function RadiusBottomrightOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RadiusBottomrightOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RadiusBottomrightOutlined.displayName = 'RadiusBottomrightOutlined';
}
var RadiusBottomrightOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(RadiusBottomrightOutlined);

// This icon file is generated automatically.
var RadiusSettingOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M396 140h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-44 684h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm524-204h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 344h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm320 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm160 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm140-284c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V370c0-127-103-230-230-230H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h170c87.3 0 158 70.7 158 158v170zM236 96H92c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8V104c0-4.4-3.6-8-8-8zm-48 101.6c0 1.3-1.1 2.4-2.4 2.4h-43.2c-1.3 0-2.4-1.1-2.4-2.4v-43.2c0-1.3 1.1-2.4 2.4-2.4h43.2c1.3 0 2.4 1.1 2.4 2.4v43.2zM920 780H776c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8V788c0-4.4-3.6-8-8-8zm-48 101.6c0 1.3-1.1 2.4-2.4 2.4h-43.2c-1.3 0-2.4-1.1-2.4-2.4v-43.2c0-1.3 1.1-2.4 2.4-2.4h43.2c1.3 0 2.4 1.1 2.4 2.4v43.2z" } }] }, "name": "radius-setting", "theme": "outlined" };
var RadiusSettingOutlinedSvg = RadiusSettingOutlined$2;

var RadiusSettingOutlined = function RadiusSettingOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RadiusSettingOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RadiusSettingOutlined.displayName = 'RadiusSettingOutlined';
}
var RadiusSettingOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(RadiusSettingOutlined);

// This icon file is generated automatically.
var RadiusUpleftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M656 200h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm58 624h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 650h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm696-696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-174 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm174-696H358c-127 0-230 103-230 230v182c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V358c0-87.3 70.7-158 158-158h182c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "radius-upleft", "theme": "outlined" };
var RadiusUpleftOutlinedSvg = RadiusUpleftOutlined$2;

var RadiusUpleftOutlined = function RadiusUpleftOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RadiusUpleftOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RadiusUpleftOutlined.displayName = 'RadiusUpleftOutlined';
}
var RadiusUpleftOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(RadiusUpleftOutlined);

// This icon file is generated automatically.
var RadiusUprightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M368 128h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-2 696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm522-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 128h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm174 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-48-696H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h182c87.3 0 158 70.7 158 158v182c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V358c0-127-103-230-230-230z" } }] }, "name": "radius-upright", "theme": "outlined" };
var RadiusUprightOutlinedSvg = RadiusUprightOutlined$2;

var RadiusUprightOutlined = function RadiusUprightOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RadiusUprightOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RadiusUprightOutlined.displayName = 'RadiusUprightOutlined';
}
var RadiusUprightOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(RadiusUprightOutlined);

// This icon file is generated automatically.
var ReadFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 161H699.2c-49.1 0-97.1 14.1-138.4 40.7L512 233l-48.8-31.3A255.2 255.2 0 00324.8 161H96c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h228.8c49.1 0 97.1 14.1 138.4 40.7l44.4 28.6c1.3.8 2.8 1.3 4.3 1.3s3-.4 4.3-1.3l44.4-28.6C602 807.1 650.1 793 699.2 793H928c17.7 0 32-14.3 32-32V193c0-17.7-14.3-32-32-32zM404 553.5c0 4.1-3.2 7.5-7.1 7.5H211.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm0-140c0 4.1-3.2 7.5-7.1 7.5H211.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm416 140c0 4.1-3.2 7.5-7.1 7.5H627.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm0-140c0 4.1-3.2 7.5-7.1 7.5H627.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45z" } }] }, "name": "read", "theme": "filled" };
var ReadFilledSvg = ReadFilled$2;

var ReadFilled = function ReadFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ReadFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ReadFilled.displayName = 'ReadFilled';
}
var ReadFilled$1 = /*#__PURE__*/React__namespace.forwardRef(ReadFilled);

// This icon file is generated automatically.
var ReadOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 161H699.2c-49.1 0-97.1 14.1-138.4 40.7L512 233l-48.8-31.3A255.2 255.2 0 00324.8 161H96c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h228.8c49.1 0 97.1 14.1 138.4 40.7l44.4 28.6c1.3.8 2.8 1.3 4.3 1.3s3-.4 4.3-1.3l44.4-28.6C602 807.1 650.1 793 699.2 793H928c17.7 0 32-14.3 32-32V193c0-17.7-14.3-32-32-32zM324.8 721H136V233h188.8c35.4 0 69.8 10.1 99.5 29.2l48.8 31.3 6.9 4.5v462c-47.6-25.6-100.8-39-155.2-39zm563.2 0H699.2c-54.4 0-107.6 13.4-155.2 39V298l6.9-4.5 48.8-31.3c29.7-19.1 64.1-29.2 99.5-29.2H888v488zM396.9 361H211.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5zm223.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c0-4.1-3.2-7.5-7.1-7.5H627.1c-3.9 0-7.1 3.4-7.1 7.5zM396.9 501H211.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5zm416 0H627.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5z" } }] }, "name": "read", "theme": "outlined" };
var ReadOutlinedSvg = ReadOutlined$2;

var ReadOutlined = function ReadOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ReadOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ReadOutlined.displayName = 'ReadOutlined';
}
var ReadOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ReadOutlined);

// This icon file is generated automatically.
var ReconciliationFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M676 623c-18.8 0-34 15.2-34 34s15.2 34 34 34 34-15.2 34-34-15.2-34-34-34zm204-455H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zM448 848H176V616h272v232zm0-296H176v-88h272v88zm20-272v-48h72v-56h64v56h72v48H468zm180 168v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8zm28 301c-50.8 0-92-41.2-92-92s41.2-92 92-92 92 41.2 92 92-41.2 92-92 92zm92-245c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v96zm-92 61c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34z" } }] }, "name": "reconciliation", "theme": "filled" };
var ReconciliationFilledSvg = ReconciliationFilled$2;

var ReconciliationFilled = function ReconciliationFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ReconciliationFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ReconciliationFilled.displayName = 'ReconciliationFilled';
}
var ReconciliationFilled$1 = /*#__PURE__*/React__namespace.forwardRef(ReconciliationFilled);

// This icon file is generated automatically.
var ReconciliationOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M676 565c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34zm204-523H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zm-412 64h72v-56h64v56h72v48H468v-48zm-20 616H176V616h272v232zm0-296H176v-88h272v88zm392 240H512V432c0-17.7-14.3-32-32-32H304V240h100v104h336V240h100v552zM704 408v96c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-96c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zM592 512h48c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z" } }] }, "name": "reconciliation", "theme": "outlined" };
var ReconciliationOutlinedSvg = ReconciliationOutlined$2;

var ReconciliationOutlined = function ReconciliationOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ReconciliationOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ReconciliationOutlined.displayName = 'ReconciliationOutlined';
}
var ReconciliationOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ReconciliationOutlined);

// This icon file is generated automatically.
var ReconciliationTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M740 344H404V240H304v160h176c17.7 0 32 14.3 32 32v360h328V240H740v104zM584 448c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56zm92 301c-50.8 0-92-41.2-92-92s41.2-92 92-92 92 41.2 92 92-41.2 92-92 92zm92-341v96c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M642 657a34 34 0 1068 0 34 34 0 10-68 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M592 512h48c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm112-104v96c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-96c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M880 168H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zm-412 64h72v-56h64v56h72v48H468v-48zm-20 616H176V616h272v232zm0-296H176v-88h272v88zm392 240H512V432c0-17.7-14.3-32-32-32H304V240h100v104h336V240h100v552z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M676 565c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34z", "fill": primaryColor } }] }; }, "name": "reconciliation", "theme": "twotone" };
var ReconciliationTwoToneSvg = ReconciliationTwoTone$2;

var ReconciliationTwoTone = function ReconciliationTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ReconciliationTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ReconciliationTwoTone.displayName = 'ReconciliationTwoTone';
}
var ReconciliationTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(ReconciliationTwoTone);

// This icon file is generated automatically.
var RedEnvelopeFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM647 470.4l-87.2 161h45.9c4.6 0 8.4 3.8 8.4 8.4v25.1c0 4.6-3.8 8.4-8.4 8.4h-63.3v28.6h63.3c4.6 0 8.4 3.8 8.4 8.4v25c.2 4.6-3.6 8.5-8.2 8.5h-63.3v49.9c0 4.6-3.8 8.4-8.4 8.4h-43.7c-4.6 0-8.4-3.8-8.4-8.4v-49.9h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h63v-28.6h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h45.4l-87.5-161c-2.2-4.1-.7-9.1 3.4-11.4 1.3-.6 2.6-1 3.9-1h48.8c3.2 0 6.1 1.8 7.5 4.6l71.9 141.8 71.9-141.9a8.5 8.5 0 017.5-4.6h47.8c4.6 0 8.4 3.8 8.4 8.4-.1 1.5-.5 2.9-1.1 4.1zM512.6 323L289 148h446L512.6 323z" } }] }, "name": "red-envelope", "theme": "filled" };
var RedEnvelopeFilledSvg = RedEnvelopeFilled$2;

var RedEnvelopeFilled = function RedEnvelopeFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RedEnvelopeFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RedEnvelopeFilled.displayName = 'RedEnvelopeFilled';
}
var RedEnvelopeFilled$1 = /*#__PURE__*/React__namespace.forwardRef(RedEnvelopeFilled);

// This icon file is generated automatically.
var RedEnvelopeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M440.6 462.6a8.38 8.38 0 00-7.5-4.6h-48.8c-1.3 0-2.6.4-3.9 1a8.4 8.4 0 00-3.4 11.4l87.4 161.1H419c-4.6 0-8.4 3.8-8.4 8.4V665c0 4.6 3.8 8.4 8.4 8.4h63V702h-63c-4.6 0-8.4 3.8-8.4 8.4v25.1c0 4.6 3.8 8.4 8.4 8.4h63v49.9c0 4.6 3.8 8.4 8.4 8.4h43.7c4.6 0 8.4-3.8 8.4-8.4v-49.9h63.3c4.7 0 8.4-3.8 8.2-8.5v-25c0-4.6-3.8-8.4-8.4-8.4h-63.3v-28.6h63.3c4.6 0 8.4-3.8 8.4-8.4v-25.1c0-4.6-3.8-8.4-8.4-8.4h-45.9l87.2-161a8.45 8.45 0 00-7.4-12.4h-47.8c-3.1 0-6 1.8-7.5 4.6l-71.9 141.9-71.7-142zM832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V193.1l260.3 204.1c11.6 9.1 27.9 9.1 39.5 0L792 193.1V888zm0-751.3h-31.7L512 331.3 263.7 136.7H232v-.7h560v.7z" } }] }, "name": "red-envelope", "theme": "outlined" };
var RedEnvelopeOutlinedSvg = RedEnvelopeOutlined$2;

var RedEnvelopeOutlined = function RedEnvelopeOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RedEnvelopeOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RedEnvelopeOutlined.displayName = 'RedEnvelopeOutlined';
}
var RedEnvelopeOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(RedEnvelopeOutlined);

// This icon file is generated automatically.
var RedEnvelopeTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V193.1l260.3 204.1c11.6 9.1 27.9 9.1 39.5 0L792 193.1V888zm0-751.3h-31.7L512 331.3 263.7 136.7H232v-.7h560v.7z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M492.3 397.2L232 193.1V888h560V193.1L531.8 397.2a31.99 31.99 0 01-39.5 0zm99.4 60.9h47.8a8.45 8.45 0 017.4 12.4l-87.2 161h45.9c4.6 0 8.4 3.8 8.4 8.4V665c0 4.6-3.8 8.4-8.4 8.4h-63.3V702h63.3c4.6 0 8.4 3.8 8.4 8.4v25c.2 4.7-3.5 8.5-8.2 8.5h-63.3v49.9c0 4.6-3.8 8.4-8.4 8.4h-43.7c-4.6 0-8.4-3.8-8.4-8.4v-49.9h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h63v-28.6h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h45.4L377 470.4a8.4 8.4 0 013.4-11.4c1.3-.6 2.6-1 3.9-1h48.8c3.2 0 6.1 1.8 7.5 4.6l71.7 142 71.9-141.9a8.6 8.6 0 017.5-4.6z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M232 136.7h31.7L512 331.3l248.3-194.6H792v-.7H232z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M440.6 462.6a8.38 8.38 0 00-7.5-4.6h-48.8c-1.3 0-2.6.4-3.9 1a8.4 8.4 0 00-3.4 11.4l87.4 161.1H419c-4.6 0-8.4 3.8-8.4 8.4V665c0 4.6 3.8 8.4 8.4 8.4h63V702h-63c-4.6 0-8.4 3.8-8.4 8.4v25.1c0 4.6 3.8 8.4 8.4 8.4h63v49.9c0 4.6 3.8 8.4 8.4 8.4h43.7c4.6 0 8.4-3.8 8.4-8.4v-49.9h63.3c4.7 0 8.4-3.8 8.2-8.5v-25c0-4.6-3.8-8.4-8.4-8.4h-63.3v-28.6h63.3c4.6 0 8.4-3.8 8.4-8.4v-25.1c0-4.6-3.8-8.4-8.4-8.4h-45.9l87.2-161a8.45 8.45 0 00-7.4-12.4h-47.8c-3.1 0-6 1.8-7.5 4.6l-71.9 141.9-71.7-142z", "fill": primaryColor } }] }; }, "name": "red-envelope", "theme": "twotone" };
var RedEnvelopeTwoToneSvg = RedEnvelopeTwoTone$2;

var RedEnvelopeTwoTone = function RedEnvelopeTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RedEnvelopeTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RedEnvelopeTwoTone.displayName = 'RedEnvelopeTwoTone';
}
var RedEnvelopeTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(RedEnvelopeTwoTone);

// This icon file is generated automatically.
var RedditCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M584 548a36 36 0 1072 0 36 36 0 10-72 0zm144-108a35.9 35.9 0 00-32.5 20.6c18.8 14.3 34.4 30.7 45.9 48.8A35.98 35.98 0 00728 440zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm245 477.9c4.6 13.5 7 27.6 7 42.1 0 99.4-112.8 180-252 180s-252-80.6-252-180c0-14.5 2.4-28.6 7-42.1A72.01 72.01 0 01296 404c27.1 0 50.6 14.9 62.9 37 36.2-19.8 80.2-32.8 128.1-36.1l58.4-131.1c4.3-9.8 15.2-14.8 25.5-11.8l91.6 26.5a54.03 54.03 0 01101.6 25.6c0 29.8-24.2 54-54 54-23.5 0-43.5-15.1-50.9-36.1L577 308.3l-43 96.5c49.1 3 94.2 16.1 131.2 36.3 12.3-22.1 35.8-37 62.9-37 39.8 0 72 32.2 72 72-.1 29.3-17.8 54.6-43.1 65.8zm-171.3 83c-14.9 11.7-44.3 24.3-73.7 24.3s-58.9-12.6-73.7-24.3c-9.3-7.3-22.7-5.7-30 3.6-7.3 9.3-5.7 22.7 3.6 30 25.7 20.4 65 33.5 100.1 33.5 35.1 0 74.4-13.1 100.2-33.5 9.3-7.3 10.9-20.8 3.6-30a21.46 21.46 0 00-30.1-3.6zM296 440a35.98 35.98 0 00-13.4 69.4c11.5-18.1 27.1-34.5 45.9-48.8A35.9 35.9 0 00296 440zm72 108a36 36 0 1072 0 36 36 0 10-72 0z" } }] }, "name": "reddit-circle", "theme": "filled" };
var RedditCircleFilledSvg = RedditCircleFilled$2;

var RedditCircleFilled = function RedditCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RedditCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RedditCircleFilled.displayName = 'RedditCircleFilled';
}
var RedditCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(RedditCircleFilled);

// This icon file is generated automatically.
var RedditOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M288 568a56 56 0 10112 0 56 56 0 10-112 0zm338.7 119.7c-23.1 18.2-68.9 37.8-114.7 37.8s-91.6-19.6-114.7-37.8c-14.4-11.3-35.3-8.9-46.7 5.5s-8.9 35.3 5.5 46.7C396.3 771.6 457.5 792 512 792s115.7-20.4 155.9-52.1a33.25 33.25 0 10-41.2-52.2zM960 456c0-61.9-50.1-112-112-112-42.1 0-78.7 23.2-97.9 57.6-57.6-31.5-127.7-51.8-204.1-56.5L612.9 195l127.9 36.9c11.5 32.6 42.6 56.1 79.2 56.1 46.4 0 84-37.6 84-84s-37.6-84-84-84c-32 0-59.8 17.9-74 44.2L603.5 123a33.2 33.2 0 00-39.6 18.4l-90.8 203.9c-74.5 5.2-142.9 25.4-199.2 56.2A111.94 111.94 0 00176 344c-61.9 0-112 50.1-112 112 0 45.8 27.5 85.1 66.8 102.5-7.1 21-10.8 43-10.8 65.5 0 154.6 175.5 280 392 280s392-125.4 392-280c0-22.6-3.8-44.5-10.8-65.5C932.5 541.1 960 501.8 960 456zM820 172.5a31.5 31.5 0 110 63 31.5 31.5 0 010-63zM120 456c0-30.9 25.1-56 56-56a56 56 0 0150.6 32.1c-29.3 22.2-53.5 47.8-71.5 75.9a56.23 56.23 0 01-35.1-52zm392 381.5c-179.8 0-325.5-95.6-325.5-213.5S332.2 410.5 512 410.5 837.5 506.1 837.5 624 691.8 837.5 512 837.5zM868.8 508c-17.9-28.1-42.2-53.7-71.5-75.9 9-18.9 28.3-32.1 50.6-32.1 30.9 0 56 25.1 56 56 .1 23.5-14.5 43.7-35.1 52zM624 568a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "reddit", "theme": "outlined" };
var RedditOutlinedSvg = RedditOutlined$2;

var RedditOutlined = function RedditOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RedditOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RedditOutlined.displayName = 'RedditOutlined';
}
var RedditOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(RedditOutlined);

// This icon file is generated automatically.
var RedditSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M296 440a35.98 35.98 0 00-13.4 69.4c11.5-18.1 27.1-34.5 45.9-48.8A35.9 35.9 0 00296 440zm289.7 184.9c-14.9 11.7-44.3 24.3-73.7 24.3s-58.9-12.6-73.7-24.3c-9.3-7.3-22.7-5.7-30 3.6-7.3 9.3-5.7 22.7 3.6 30 25.7 20.4 65 33.5 100.1 33.5 35.1 0 74.4-13.1 100.2-33.5 9.3-7.3 10.9-20.8 3.6-30a21.46 21.46 0 00-30.1-3.6zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM757 541.9c4.6 13.5 7 27.6 7 42.1 0 99.4-112.8 180-252 180s-252-80.6-252-180c0-14.5 2.4-28.6 7-42.1A72.01 72.01 0 01296 404c27.1 0 50.6 14.9 62.9 37 36.2-19.8 80.2-32.8 128.1-36.1l58.4-131.1c4.3-9.8 15.2-14.8 25.5-11.8l91.6 26.5a54.03 54.03 0 01101.6 25.6c0 29.8-24.2 54-54 54-23.5 0-43.5-15.1-50.9-36.1L577 308.3l-43 96.5c49.1 3 94.2 16.1 131.2 36.3 12.3-22.1 35.8-37 62.9-37 39.8 0 72 32.2 72 72-.1 29.3-17.8 54.6-43.1 65.8zM584 548a36 36 0 1072 0 36 36 0 10-72 0zm144-108a35.9 35.9 0 00-32.5 20.6c18.8 14.3 34.4 30.7 45.9 48.8A35.98 35.98 0 00728 440zM368 548a36 36 0 1072 0 36 36 0 10-72 0z" } }] }, "name": "reddit-square", "theme": "filled" };
var RedditSquareFilledSvg = RedditSquareFilled$2;

var RedditSquareFilled = function RedditSquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RedditSquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RedditSquareFilled.displayName = 'RedditSquareFilled';
}
var RedditSquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(RedditSquareFilled);

// This icon file is generated automatically.
var RedoOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M758.2 839.1C851.8 765.9 912 651.9 912 523.9 912 303 733.5 124.3 512.6 124 291.4 123.7 112 302.8 112 523.9c0 125.2 57.5 236.9 147.6 310.2 3.5 2.8 8.6 2.2 11.4-1.3l39.4-50.5c2.7-3.4 2.1-8.3-1.2-11.1-8.1-6.6-15.9-13.7-23.4-21.2a318.64 318.64 0 01-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 01-68.6 101.7c-9.3 9.3-19.1 18-29.3 26L668.2 724a8 8 0 00-14.1 3l-39.6 162.2c-1.2 5 2.6 9.9 7.7 9.9l167 .8c6.7 0 10.5-7.7 6.3-12.9l-37.3-47.9z" } }] }, "name": "redo", "theme": "outlined" };
var RedoOutlinedSvg = RedoOutlined$2;

var RedoOutlined = function RedoOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RedoOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RedoOutlined.displayName = 'RedoOutlined';
}
var RedoOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(RedoOutlined);

// This icon file is generated automatically.
var ReloadOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M909.1 209.3l-56.4 44.1C775.8 155.1 656.2 92 521.9 92 290 92 102.3 279.5 102 511.5 101.7 743.7 289.8 932 521.9 932c181.3 0 335.8-115 394.6-276.1 1.5-4.2-.7-8.9-4.9-10.3l-56.7-19.5a8 8 0 00-10.1 4.8c-1.8 5-3.8 10-5.9 14.9-17.3 41-42.1 77.8-73.7 109.4A344.77 344.77 0 01655.9 829c-42.3 17.9-87.4 27-133.8 27-46.5 0-91.5-9.1-133.8-27A341.5 341.5 0 01279 755.2a342.16 342.16 0 01-73.7-109.4c-17.9-42.4-27-87.4-27-133.9s9.1-91.5 27-133.9c17.3-41 42.1-77.8 73.7-109.4 31.6-31.6 68.4-56.4 109.3-73.8 42.3-17.9 87.4-27 133.8-27 46.5 0 91.5 9.1 133.8 27a341.5 341.5 0 01109.3 73.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 003 14.1l175.6 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c-.1-6.6-7.8-10.3-13-6.2z" } }] }, "name": "reload", "theme": "outlined" };
var ReloadOutlinedSvg = ReloadOutlined$2;

var ReloadOutlined = function ReloadOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ReloadOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ReloadOutlined.displayName = 'ReloadOutlined';
}
var ReloadOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ReloadOutlined);

// This icon file is generated automatically.
var RestFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0031.9 29.3h429.2a32 32 0 0031.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zM508 704c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144zM291 256l22.4-76h397.2l22.4 76H291zm137 304a80 80 0 10160 0 80 80 0 10-160 0z" } }] }, "name": "rest", "theme": "filled" };
var RestFilledSvg = RestFilled$2;

var RestFilled = function RestFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RestFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RestFilled.displayName = 'RestFilled';
}
var RestFilled$1 = /*#__PURE__*/React__namespace.forwardRef(RestFilled);

// This icon file is generated automatically.
var RestOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M508 704c79.5 0 144-64.5 144-144s-64.5-144-144-144-144 64.5-144 144 64.5 144 144 144zm0-224c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z" } }, { "tag": "path", "attrs": { "d": "M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0031.9 29.3h429.2a32 32 0 0031.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zm-518.6-76h397.2l22.4 76H291l22.4-76zm376.2 664H326.4L282 324h451.9l-44.3 520z" } }] }, "name": "rest", "theme": "outlined" };
var RestOutlinedSvg = RestOutlined$2;

var RestOutlined = function RestOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RestOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RestOutlined.displayName = 'RestOutlined';
}
var RestOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(RestOutlined);

// This icon file is generated automatically.
var RestTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M326.4 844h363.2l44.3-520H282l44.4 520zM508 416c79.5 0 144 64.5 144 144s-64.5 144-144 144-144-64.5-144-144 64.5-144 144-144z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M508 704c79.5 0 144-64.5 144-144s-64.5-144-144-144-144 64.5-144 144 64.5 144 144 144zm0-224c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0031.9 29.3h429.2a32 32 0 0031.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zm-518.6-76h397.2l22.4 76H291l22.4-76zm376.2 664H326.4L282 324h451.9l-44.3 520z", "fill": primaryColor } }] }; }, "name": "rest", "theme": "twotone" };
var RestTwoToneSvg = RestTwoTone$2;

var RestTwoTone = function RestTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RestTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RestTwoTone.displayName = 'RestTwoTone';
}
var RestTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(RestTwoTone);

// This icon file is generated automatically.
var RetweetOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M136 552h63.6c4.4 0 8-3.6 8-8V288.7h528.6v72.6c0 1.9.6 3.7 1.8 5.2a8.3 8.3 0 0011.7 1.4L893 255.4c4.3-5 3.6-10.3 0-13.2L749.7 129.8a8.22 8.22 0 00-5.2-1.8c-4.6 0-8.4 3.8-8.4 8.4V209H199.7c-39.5 0-71.7 32.2-71.7 71.8V544c0 4.4 3.6 8 8 8zm752-80h-63.6c-4.4 0-8 3.6-8 8v255.3H287.8v-72.6c0-1.9-.6-3.7-1.8-5.2a8.3 8.3 0 00-11.7-1.4L131 768.6c-4.3 5-3.6 10.3 0 13.2l143.3 112.4c1.5 1.2 3.3 1.8 5.2 1.8 4.6 0 8.4-3.8 8.4-8.4V815h536.6c39.5 0 71.7-32.2 71.7-71.8V480c-.2-4.4-3.8-8-8.2-8z" } }] }, "name": "retweet", "theme": "outlined" };
var RetweetOutlinedSvg = RetweetOutlined$2;

var RetweetOutlined = function RetweetOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RetweetOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RetweetOutlined.displayName = 'RetweetOutlined';
}
var RetweetOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(RetweetOutlined);

// This icon file is generated automatically.
var RightCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm154.7 454.5l-246 178c-5.3 3.8-12.7 0-12.7-6.5v-46.9c0-10.2 4.9-19.9 13.2-25.9L566.6 512 421.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.8 0 13z" } }] }, "name": "right-circle", "theme": "filled" };
var RightCircleFilledSvg = RightCircleFilled$2;

var RightCircleFilled = function RightCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RightCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RightCircleFilled.displayName = 'RightCircleFilled';
}
var RightCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(RightCircleFilled);

// This icon file is generated automatically.
var RightCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M666.7 505.5l-246-178A8 8 0 00408 334v46.9c0 10.2 4.9 19.9 13.2 25.9L566.6 512 421.2 617.2c-8.3 6-13.2 15.6-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.5l246-178c4.4-3.2 4.4-9.8 0-13z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "right-circle", "theme": "outlined" };
var RightCircleOutlinedSvg = RightCircleOutlined$2;

var RightCircleOutlined = function RightCircleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RightCircleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RightCircleOutlined.displayName = 'RightCircleOutlined';
}
var RightCircleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(RightCircleOutlined);

// This icon file is generated automatically.
var RightCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm154.7 378.4l-246 178c-5.3 3.8-12.7 0-12.7-6.5V643c0-10.2 4.9-19.9 13.2-25.9L566.6 512 421.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.7 0 12.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M666.7 505.5l-246-178c-5.3-3.8-12.7 0-12.7 6.5v46.9c0 10.3 4.9 19.9 13.2 25.9L566.6 512 421.2 617.1c-8.3 6-13.2 15.7-13.2 25.9v46.9c0 6.5 7.4 10.3 12.7 6.5l246-178c4.4-3.2 4.4-9.7 0-12.9z", "fill": primaryColor } }] }; }, "name": "right-circle", "theme": "twotone" };
var RightCircleTwoToneSvg = RightCircleTwoTone$2;

var RightCircleTwoTone = function RightCircleTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RightCircleTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RightCircleTwoTone.displayName = 'RightCircleTwoTone';
}
var RightCircleTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(RightCircleTwoTone);

// This icon file is generated automatically.
var RightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, "name": "right", "theme": "outlined" };
var RightOutlinedSvg = RightOutlined$2;

var RightOutlined = function RightOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RightOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RightOutlined.displayName = 'RightOutlined';
}
var RightOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(RightOutlined);

// This icon file is generated automatically.
var RightSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM658.7 518.5l-246 178c-5.3 3.8-12.7 0-12.7-6.5v-46.9c0-10.2 4.9-19.9 13.2-25.9L558.6 512 413.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.8 0 13z" } }] }, "name": "right-square", "theme": "filled" };
var RightSquareFilledSvg = RightSquareFilled$2;

var RightSquareFilled = function RightSquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RightSquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RightSquareFilled.displayName = 'RightSquareFilled';
}
var RightSquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(RightSquareFilled);

// This icon file is generated automatically.
var RightSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M412.7 696.5l246-178c4.4-3.2 4.4-9.7 0-12.9l-246-178c-5.3-3.8-12.7 0-12.7 6.5V381c0 10.2 4.9 19.9 13.2 25.9L558.6 512 413.2 617.2c-8.3 6-13.2 15.6-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.5z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "right-square", "theme": "outlined" };
var RightSquareOutlinedSvg = RightSquareOutlined$2;

var RightSquareOutlined = function RightSquareOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RightSquareOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RightSquareOutlined.displayName = 'RightSquareOutlined';
}
var RightSquareOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(RightSquareOutlined);

// This icon file is generated automatically.
var RightSquareTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm216-196.9c0-10.2 4.9-19.9 13.2-25.9L558.6 512 413.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.7 0 12.9l-246 178c-5.3 3.9-12.7.1-12.7-6.4v-46.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M412.7 696.4l246-178c4.4-3.2 4.4-9.7 0-12.9l-246-178c-5.3-3.8-12.7 0-12.7 6.5v46.9c0 10.3 4.9 19.9 13.2 25.9L558.6 512 413.2 617.2c-8.3 6-13.2 15.7-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.4z", "fill": primaryColor } }] }; }, "name": "right-square", "theme": "twotone" };
var RightSquareTwoToneSvg = RightSquareTwoTone$2;

var RightSquareTwoTone = function RightSquareTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RightSquareTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RightSquareTwoTone.displayName = 'RightSquareTwoTone';
}
var RightSquareTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(RightSquareTwoTone);

// This icon file is generated automatically.
var RiseOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M917 211.1l-199.2 24c-6.6.8-9.4 8.9-4.7 13.6l59.3 59.3-226 226-101.8-101.7c-6.3-6.3-16.4-6.2-22.6 0L100.3 754.1a8.03 8.03 0 000 11.3l45 45.2c3.1 3.1 8.2 3.1 11.3 0L433.3 534 535 635.7c6.3 6.2 16.4 6.2 22.6 0L829 364.5l59.3 59.3a8.01 8.01 0 0013.6-4.7l24-199.2c.7-5.1-3.7-9.5-8.9-8.8z" } }] }, "name": "rise", "theme": "outlined" };
var RiseOutlinedSvg = RiseOutlined$2;

var RiseOutlined = function RiseOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RiseOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RiseOutlined.displayName = 'RiseOutlined';
}
var RiseOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(RiseOutlined);

// This icon file is generated automatically.
var RobotFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M852 64H172c-17.7 0-32 14.3-32 32v660c0 17.7 14.3 32 32 32h680c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM300 328c0-33.1 26.9-60 60-60s60 26.9 60 60-26.9 60-60 60-60-26.9-60-60zm372 248c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-60c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v60zm-8-188c-33.1 0-60-26.9-60-60s26.9-60 60-60 60 26.9 60 60-26.9 60-60 60zm135 476H225c-13.8 0-25 14.3-25 32v56c0 4.4 2.8 8 6.2 8h611.5c3.4 0 6.2-3.6 6.2-8v-56c.1-17.7-11.1-32-24.9-32z" } }] }, "name": "robot", "theme": "filled" };
var RobotFilledSvg = RobotFilled$2;

var RobotFilled = function RobotFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RobotFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RobotFilled.displayName = 'RobotFilled';
}
var RobotFilled$1 = /*#__PURE__*/React__namespace.forwardRef(RobotFilled);

// This icon file is generated automatically.
var RobotOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M300 328a60 60 0 10120 0 60 60 0 10-120 0zM852 64H172c-17.7 0-32 14.3-32 32v660c0 17.7 14.3 32 32 32h680c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-32 660H204V128h616v596zM604 328a60 60 0 10120 0 60 60 0 10-120 0zm250.2 556H169.8c-16.5 0-29.8 14.3-29.8 32v36c0 4.4 3.3 8 7.4 8h729.1c4.1 0 7.4-3.6 7.4-8v-36c.1-17.7-13.2-32-29.7-32zM664 508H360c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] }, "name": "robot", "theme": "outlined" };
var RobotOutlinedSvg = RobotOutlined$2;

var RobotOutlined = function RobotOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RobotOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RobotOutlined.displayName = 'RobotOutlined';
}
var RobotOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(RobotOutlined);

// This icon file is generated automatically.
var RocketFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 00-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0043.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0043.1-30.5 97.52 97.52 0 0021.4-60.8c0-8.4-1.1-16.4-3.1-23.8L864 736zM512 352a48.01 48.01 0 010 96 48.01 48.01 0 010-96zm116.1 432.2c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5s-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 01-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5z" } }] }, "name": "rocket", "theme": "filled" };
var RocketFilledSvg = RocketFilled$2;

var RocketFilled = function RocketFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RocketFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RocketFilled.displayName = 'RocketFilled';
}
var RocketFilled$1 = /*#__PURE__*/React__namespace.forwardRef(RocketFilled);

// This icon file is generated automatically.
var RocketOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 00-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0043.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0043.1-30.5 97.52 97.52 0 0021.4-60.8c0-8.4-1.1-16.4-3.1-23.8H864zM762.3 621.4c9.4 14.6 17 30.3 22.5 46.6H700V558.7a211.6 211.6 0 0162.3 62.7zM388 483.1V318.8l124-147 124 147V668H388V483.1zM239.2 668c5.5-16.3 13.1-32 22.5-46.6 16.3-25.2 37.5-46.5 62.3-62.7V668h-84.8zm388.9 116.2c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5-38.3 0-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 01-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5zM464 400a48 48 0 1096 0 48 48 0 10-96 0z" } }] }, "name": "rocket", "theme": "outlined" };
var RocketOutlinedSvg = RocketOutlined$2;

var RocketOutlined = function RocketOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RocketOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RocketOutlined.displayName = 'RocketOutlined';
}
var RocketOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(RocketOutlined);

// This icon file is generated automatically.
var RocketTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M261.7 621.4c-9.4 14.6-17 30.3-22.5 46.6H324V558.7c-24.8 16.2-46 37.5-62.3 62.7zM700 558.7V668h84.8c-5.5-16.3-13.1-32-22.5-46.6a211.6 211.6 0 00-62.3-62.7zm-64-239.9l-124-147-124 147V668h248V318.8zM512 448a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 00-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0043.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0043.1-30.5 97.52 97.52 0 0021.4-60.8c0-8.4-1.1-16.4-3.1-23.8L864 736zm-540-68h-84.8c5.5-16.3 13.1-32 22.5-46.6 16.3-25.2 37.5-46.5 62.3-62.7V668zm64-184.9V318.8l124-147 124 147V668H388V483.1zm240.1 301.1c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5s-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 01-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5zM700 668V558.7a211.6 211.6 0 0162.3 62.7c9.4 14.6 17 30.3 22.5 46.6H700z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M464 400a48 48 0 1096 0 48 48 0 10-96 0z", "fill": primaryColor } }] }; }, "name": "rocket", "theme": "twotone" };
var RocketTwoToneSvg = RocketTwoTone$2;

var RocketTwoTone = function RocketTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RocketTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RocketTwoTone.displayName = 'RocketTwoTone';
}
var RocketTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(RocketTwoTone);

// This icon file is generated automatically.
var RollbackOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M793 242H366v-74c0-6.7-7.7-10.4-12.9-6.3l-142 112a8 8 0 000 12.6l142 112c5.2 4.1 12.9.4 12.9-6.3v-74h415v470H175c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h618c35.3 0 64-28.7 64-64V306c0-35.3-28.7-64-64-64z" } }] }, "name": "rollback", "theme": "outlined" };
var RollbackOutlinedSvg = RollbackOutlined$2;

var RollbackOutlined = function RollbackOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RollbackOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RollbackOutlined.displayName = 'RollbackOutlined';
}
var RollbackOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(RollbackOutlined);

// This icon file is generated automatically.
var RotateLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M672 418H144c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H188V494h440v326z" } }, { "tag": "path", "attrs": { "d": "M819.3 328.5c-78.8-100.7-196-153.6-314.6-154.2l-.2-64c0-6.5-7.6-10.1-12.6-6.1l-128 101c-4 3.1-3.9 9.1 0 12.3L492 318.6c5.1 4 12.7.4 12.6-6.1v-63.9c12.9.1 25.9.9 38.8 2.5 42.1 5.2 82.1 18.2 119 38.7 38.1 21.2 71.2 49.7 98.4 84.3 27.1 34.7 46.7 73.7 58.1 115.8a325.95 325.95 0 016.5 140.9h74.9c14.8-103.6-11.3-213-81-302.3z" } }] }, "name": "rotate-left", "theme": "outlined" };
var RotateLeftOutlinedSvg = RotateLeftOutlined$2;

var RotateLeftOutlined = function RotateLeftOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RotateLeftOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RotateLeftOutlined.displayName = 'RotateLeftOutlined';
}
var RotateLeftOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(RotateLeftOutlined);

// This icon file is generated automatically.
var RotateRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-.4-12.6 6.1l-.2 64c-118.6.5-235.8 53.4-314.6 154.2A399.75 399.75 0 00123.5 631h74.9c-.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8z" } }, { "tag": "path", "attrs": { "d": "M880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H396V494h440v326z" } }] }, "name": "rotate-right", "theme": "outlined" };
var RotateRightOutlinedSvg = RotateRightOutlined$2;

var RotateRightOutlined = function RotateRightOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RotateRightOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  RotateRightOutlined.displayName = 'RotateRightOutlined';
}
var RotateRightOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(RotateRightOutlined);

// This icon file is generated automatically.
var SafetyCertificateFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM694.5 340.7L481.9 633.4a16.1 16.1 0 01-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.1 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.8-6.6 13-6.6H688c6.5.1 10.3 7.5 6.5 12.8z" } }] }, "name": "safety-certificate", "theme": "filled" };
var SafetyCertificateFilledSvg = SafetyCertificateFilled$2;

var SafetyCertificateFilled = function SafetyCertificateFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SafetyCertificateFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SafetyCertificateFilled.displayName = 'SafetyCertificateFilled';
}
var SafetyCertificateFilled$1 = /*#__PURE__*/React__namespace.forwardRef(SafetyCertificateFilled);

// This icon file is generated automatically.
var SafetyCertificateOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zm-405.8-201c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0026 0l212.6-292.7c3.8-5.3 0-12.7-6.5-12.7h-55.2c-5.1 0-10 2.5-13 6.6L468.9 542.4l-64.7-89.1z" } }] }, "name": "safety-certificate", "theme": "outlined" };
var SafetyCertificateOutlinedSvg = SafetyCertificateOutlined$2;

var SafetyCertificateOutlined = function SafetyCertificateOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SafetyCertificateOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SafetyCertificateOutlined.displayName = 'SafetyCertificateOutlined';
}
var SafetyCertificateOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SafetyCertificateOutlined);

// This icon file is generated automatically.
var SafetyCertificateTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM632.8 328H688c6.5 0 10.3 7.4 6.5 12.7L481.9 633.4a16.1 16.1 0 01-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.2 0 10 2.5 13 6.6l64.7 89.1 150.9-207.8c3-4.1 7.9-6.6 13-6.6z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M404.2 453.3c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0026 0l212.6-292.7c3.8-5.3 0-12.7-6.5-12.7h-55.2c-5.1 0-10 2.5-13 6.6L468.9 542.4l-64.7-89.1z", "fill": primaryColor } }] }; }, "name": "safety-certificate", "theme": "twotone" };
var SafetyCertificateTwoToneSvg = SafetyCertificateTwoTone$2;

var SafetyCertificateTwoTone = function SafetyCertificateTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SafetyCertificateTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SafetyCertificateTwoTone.displayName = 'SafetyCertificateTwoTone';
}
var SafetyCertificateTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(SafetyCertificateTwoTone);

// This icon file is generated automatically.
var SafetyOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64L128 192v384c0 212.1 171.9 384 384 384s384-171.9 384-384V192L512 64zm312 512c0 172.3-139.7 312-312 312S200 748.3 200 576V246l312-110 312 110v330z" } }, { "tag": "path", "attrs": { "d": "M378.4 475.1a35.91 35.91 0 00-50.9 0 35.91 35.91 0 000 50.9l129.4 129.4 2.1 2.1a33.98 33.98 0 0048.1 0L730.6 434a33.98 33.98 0 000-48.1l-2.8-2.8a33.98 33.98 0 00-48.1 0L483 579.7 378.4 475.1z" } }] }, "name": "safety", "theme": "outlined" };
var SafetyOutlinedSvg = SafetyOutlined$2;

var SafetyOutlined = function SafetyOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SafetyOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SafetyOutlined.displayName = 'SafetyOutlined';
}
var SafetyOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SafetyOutlined);

// This icon file is generated automatically.
var SaveFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M893.3 293.3L730.7 130.7c-12-12-28.3-18.7-45.3-18.7H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 176h256v112H384V176zm128 554c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144zm0-224c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80z" } }] }, "name": "save", "theme": "filled" };
var SaveFilledSvg = SaveFilled$2;

var SaveFilled = function SaveFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SaveFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SaveFilled.displayName = 'SaveFilled';
}
var SaveFilled$1 = /*#__PURE__*/React__namespace.forwardRef(SaveFilled);

// This icon file is generated automatically.
var SaveOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840zM512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z" } }] }, "name": "save", "theme": "outlined" };
var SaveOutlinedSvg = SaveOutlined$2;

var SaveOutlined = function SaveOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SaveOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SaveOutlined.displayName = 'SaveOutlined';
}
var SaveOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SaveOutlined);

// This icon file is generated automatically.
var SaveTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M704 320c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V184H184v656h656V341.8l-136-136V320zM512 730c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M893.3 293.3L730.7 130.7c-.7-.7-1.4-1.3-2.1-2-.1-.1-.3-.2-.4-.3-.7-.7-1.5-1.3-2.2-1.9a64 64 0 00-22-11.7V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840z", "fill": primaryColor } }] }; }, "name": "save", "theme": "twotone" };
var SaveTwoToneSvg = SaveTwoTone$2;

var SaveTwoTone = function SaveTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SaveTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SaveTwoTone.displayName = 'SaveTwoTone';
}
var SaveTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(SaveTwoTone);

// This icon file is generated automatically.
var ScanOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M136 384h56c4.4 0 8-3.6 8-8V200h176c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-37.6 0-68 30.4-68 68v180c0 4.4 3.6 8 8 8zm512-184h176v176c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V196c0-37.6-30.4-68-68-68H648c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM376 824H200V648c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v180c0 37.6 30.4 68 68 68h180c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm512-184h-56c-4.4 0-8 3.6-8 8v176H648c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h180c37.6 0 68-30.4 68-68V648c0-4.4-3.6-8-8-8zm16-164H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "scan", "theme": "outlined" };
var ScanOutlinedSvg = ScanOutlined$2;

var ScanOutlined = function ScanOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ScanOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ScanOutlined.displayName = 'ScanOutlined';
}
var ScanOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ScanOutlined);

// This icon file is generated automatically.
var ScheduleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zM424 688c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-136c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm374.5-91.3l-165 228.7a15.9 15.9 0 01-25.8 0L493.5 531.2c-3.8-5.3 0-12.7 6.5-12.7h54.9c5.1 0 9.9 2.5 12.9 6.6l52.8 73.1 103.7-143.7c3-4.2 7.8-6.6 12.9-6.6H792c6.5.1 10.3 7.5 6.5 12.8z" } }] }, "name": "schedule", "theme": "filled" };
var ScheduleFilledSvg = ScheduleFilled$2;

var ScheduleFilled = function ScheduleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ScheduleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ScheduleFilled.displayName = 'ScheduleFilled';
}
var ScheduleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(ScheduleFilled);

// This icon file is generated automatically.
var ScheduleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496zM416 496H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 136H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm308.2-177.4L620.6 598.3l-52.8-73.1c-3-4.2-7.8-6.6-12.9-6.6H500c-6.5 0-10.3 7.4-6.5 12.7l114.1 158.2a15.9 15.9 0 0025.8 0l165-228.7c3.8-5.3 0-12.7-6.5-12.7H737c-5-.1-9.8 2.4-12.8 6.5z" } }] }, "name": "schedule", "theme": "outlined" };
var ScheduleOutlinedSvg = ScheduleOutlined$2;

var ScheduleOutlined = function ScheduleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ScheduleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ScheduleOutlined.displayName = 'ScheduleOutlined';
}
var ScheduleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ScheduleOutlined);

// This icon file is generated automatically.
var ScheduleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M768 352c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H548v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H328v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H136v496h752V296H768v56zM424 688c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-136c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm374.4-91.2l-165 228.7a15.9 15.9 0 01-25.8 0L493.5 531.3c-3.8-5.3 0-12.7 6.5-12.7h54.9c5.1 0 9.9 2.4 12.9 6.6l52.8 73.1 103.6-143.7c3-4.1 7.8-6.6 12.8-6.5h54.9c6.5 0 10.3 7.4 6.5 12.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M724.2 454.6L620.6 598.3l-52.8-73.1c-3-4.2-7.8-6.6-12.9-6.6H500c-6.5 0-10.3 7.4-6.5 12.7l114.1 158.2a15.9 15.9 0 0025.8 0l165-228.7c3.8-5.3 0-12.7-6.5-12.7H737c-5-.1-9.8 2.4-12.8 6.5zM416 496H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M416 632H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "schedule", "theme": "twotone" };
var ScheduleTwoToneSvg = ScheduleTwoTone$2;

var ScheduleTwoTone = function ScheduleTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ScheduleTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ScheduleTwoTone.displayName = 'ScheduleTwoTone';
}
var ScheduleTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(ScheduleTwoTone);

// This icon file is generated automatically.
var ScissorOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M567.1 512l318.5-319.3c5-5 1.5-13.7-5.6-13.7h-90.5c-2.1 0-4.2.8-5.6 2.3l-273.3 274-90.2-90.5c12.5-22.1 19.7-47.6 19.7-74.8 0-83.9-68.1-152-152-152s-152 68.1-152 152 68.1 152 152 152c27.7 0 53.6-7.4 75.9-20.3l90 90.3-90.1 90.3A151.04 151.04 0 00288 582c-83.9 0-152 68.1-152 152s68.1 152 152 152 152-68.1 152-152c0-27.2-7.2-52.7-19.7-74.8l90.2-90.5 273.3 274c1.5 1.5 3.5 2.3 5.6 2.3H880c7.1 0 10.7-8.6 5.6-13.7L567.1 512zM288 370c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm0 444c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z" } }] }, "name": "scissor", "theme": "outlined" };
var ScissorOutlinedSvg = ScissorOutlined$2;

var ScissorOutlined = function ScissorOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ScissorOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ScissorOutlined.displayName = 'ScissorOutlined';
}
var ScissorOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ScissorOutlined);

// This icon file is generated automatically.
var SearchOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" } }] }, "name": "search", "theme": "outlined" };
var SearchOutlinedSvg = SearchOutlined$2;

var SearchOutlined = function SearchOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SearchOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SearchOutlined.displayName = 'SearchOutlined';
}
var SearchOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SearchOutlined);

// This icon file is generated automatically.
var SecurityScanFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM626.8 554c-48.5 48.5-123 55.2-178.6 20.1l-77.5 77.5a8.03 8.03 0 01-11.3 0l-34-34a8.03 8.03 0 010-11.3l77.5-77.5c-35.1-55.7-28.4-130.1 20.1-178.6 56.3-56.3 147.5-56.3 203.8 0 56.3 56.3 56.3 147.5 0 203.8zm-158.54-45.27a80.1 80.1 0 10113.27-113.28 80.1 80.1 0 10-113.27 113.28z" } }] }, "name": "security-scan", "theme": "filled" };
var SecurityScanFilledSvg = SecurityScanFilled$2;

var SecurityScanFilled = function SecurityScanFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SecurityScanFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SecurityScanFilled.displayName = 'SecurityScanFilled';
}
var SecurityScanFilled$1 = /*#__PURE__*/React__namespace.forwardRef(SecurityScanFilled);

// This icon file is generated automatically.
var SecurityScanOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zM402.9 528.8l-77.5 77.5a8.03 8.03 0 000 11.3l34 34c3.1 3.1 8.2 3.1 11.3 0l77.5-77.5c55.7 35.1 130.1 28.4 178.6-20.1 56.3-56.3 56.3-147.5 0-203.8-56.3-56.3-147.5-56.3-203.8 0-48.5 48.5-55.2 123-20.1 178.6zm65.4-133.3c31.3-31.3 82-31.3 113.2 0 31.3 31.3 31.3 82 0 113.2-31.3 31.3-82 31.3-113.2 0s-31.3-81.9 0-113.2z" } }] }, "name": "security-scan", "theme": "outlined" };
var SecurityScanOutlinedSvg = SecurityScanOutlined$2;

var SecurityScanOutlined = function SecurityScanOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SecurityScanOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SecurityScanOutlined.displayName = 'SecurityScanOutlined';
}
var SecurityScanOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SecurityScanOutlined);

// This icon file is generated automatically.
var SecurityScanTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M460.7 451.1a80.1 80.1 0 10160.2 0 80.1 80.1 0 10-160.2 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zm428.7 122.5c56.3 56.3 56.3 147.5 0 203.8-48.5 48.5-123 55.2-178.6 20.1l-77.5 77.5a8.03 8.03 0 01-11.3 0l-34-34a8.03 8.03 0 010-11.3l77.5-77.5c-35.1-55.7-28.4-130.1 20.1-178.6 56.3-56.3 147.5-56.3 203.8 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M418.8 527.8l-77.5 77.5a8.03 8.03 0 000 11.3l34 34c3.1 3.1 8.2 3.1 11.3 0l77.5-77.5c55.6 35.1 130.1 28.4 178.6-20.1 56.3-56.3 56.3-147.5 0-203.8-56.3-56.3-147.5-56.3-203.8 0-48.5 48.5-55.2 122.9-20.1 178.6zm65.4-133.3a80.1 80.1 0 01113.3 0 80.1 80.1 0 010 113.3c-31.3 31.3-82 31.3-113.3 0s-31.3-82 0-113.3z", "fill": primaryColor } }] }; }, "name": "security-scan", "theme": "twotone" };
var SecurityScanTwoToneSvg = SecurityScanTwoTone$2;

var SecurityScanTwoTone = function SecurityScanTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SecurityScanTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SecurityScanTwoTone.displayName = 'SecurityScanTwoTone';
}
var SecurityScanTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(SecurityScanTwoTone);

// This icon file is generated automatically.
var SelectOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h360c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H184V184h656v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32zM653.3 599.4l52.2-52.2a8.01 8.01 0 00-4.7-13.6l-179.4-21c-5.1-.6-9.5 3.7-8.9 8.9l21 179.4c.8 6.6 8.9 9.4 13.6 4.7l52.4-52.4 256.2 256.2c3.1 3.1 8.2 3.1 11.3 0l42.4-42.4c3.1-3.1 3.1-8.2 0-11.3L653.3 599.4z" } }] }, "name": "select", "theme": "outlined" };
var SelectOutlinedSvg = SelectOutlined$2;

var SelectOutlined = function SelectOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SelectOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SelectOutlined.displayName = 'SelectOutlined';
}
var SelectOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SelectOutlined);

// This icon file is generated automatically.
var SendOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M931.4 498.9L94.9 79.5c-3.4-1.7-7.3-2.1-11-1.2a15.99 15.99 0 00-11.7 19.3l86.2 352.2c1.3 5.3 5.2 9.6 10.4 11.3l147.7 50.7-147.6 50.7c-5.2 1.8-9.1 6-10.3 11.3L72.2 926.5c-.9 3.7-.5 7.6 1.2 10.9 3.9 7.9 13.5 11.1 21.5 7.2l836.5-417c3.1-1.5 5.6-4.1 7.2-7.1 3.9-8 .7-17.6-7.2-21.6zM170.8 826.3l50.3-205.6 295.2-101.3c2.3-.8 4.2-2.6 5-5 1.4-4.2-.8-8.7-5-10.2L221.1 403 171 198.2l628 314.9-628.2 313.2z" } }] }, "name": "send", "theme": "outlined" };
var SendOutlinedSvg = SendOutlined$2;

var SendOutlined = function SendOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SendOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SendOutlined.displayName = 'SendOutlined';
}
var SendOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SendOutlined);

// This icon file is generated automatically.
var SettingFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512.5 390.6c-29.9 0-57.9 11.6-79.1 32.8-21.1 21.2-32.8 49.2-32.8 79.1 0 29.9 11.7 57.9 32.8 79.1 21.2 21.1 49.2 32.8 79.1 32.8 29.9 0 57.9-11.7 79.1-32.8 21.1-21.2 32.8-49.2 32.8-79.1 0-29.9-11.7-57.9-32.8-79.1a110.96 110.96 0 00-79.1-32.8zm412.3 235.5l-65.4-55.9c3.1-19 4.7-38.4 4.7-57.7s-1.6-38.8-4.7-57.7l65.4-55.9a32.03 32.03 0 009.3-35.2l-.9-2.6a442.5 442.5 0 00-79.6-137.7l-1.8-2.1a32.12 32.12 0 00-35.1-9.5l-81.2 28.9c-30-24.6-63.4-44-99.6-57.5l-15.7-84.9a32.05 32.05 0 00-25.8-25.7l-2.7-.5c-52-9.4-106.8-9.4-158.8 0l-2.7.5a32.05 32.05 0 00-25.8 25.7l-15.8 85.3a353.44 353.44 0 00-98.9 57.3l-81.8-29.1a32 32 0 00-35.1 9.5l-1.8 2.1a445.93 445.93 0 00-79.6 137.7l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.2 56.5c-3.1 18.8-4.6 38-4.6 57 0 19.2 1.5 38.4 4.6 57l-66 56.5a32.03 32.03 0 00-9.3 35.2l.9 2.6c18.1 50.3 44.8 96.8 79.6 137.7l1.8 2.1a32.12 32.12 0 0035.1 9.5l81.8-29.1c29.8 24.5 63 43.9 98.9 57.3l15.8 85.3a32.05 32.05 0 0025.8 25.7l2.7.5a448.27 448.27 0 00158.8 0l2.7-.5a32.05 32.05 0 0025.8-25.7l15.7-84.9c36.2-13.6 69.6-32.9 99.6-57.5l81.2 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.5-87.4 79.6-137.7l.9-2.6c4.3-12.4.6-26.3-9.5-35zm-412.3 52.2c-97.1 0-175.8-78.7-175.8-175.8s78.7-175.8 175.8-175.8 175.8 78.7 175.8 175.8-78.7 175.8-175.8 175.8z" } }] }, "name": "setting", "theme": "filled" };
var SettingFilledSvg = SettingFilled$2;

var SettingFilled = function SettingFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SettingFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SettingFilled.displayName = 'SettingFilled';
}
var SettingFilled$1 = /*#__PURE__*/React__namespace.forwardRef(SettingFilled);

// This icon file is generated automatically.
var SettingOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M924.8 625.7l-65.5-56c3.1-19 4.7-38.4 4.7-57.8s-1.6-38.8-4.7-57.8l65.5-56a32.03 32.03 0 009.3-35.2l-.9-2.6a443.74 443.74 0 00-79.7-137.9l-1.8-2.1a32.12 32.12 0 00-35.1-9.5l-81.3 28.9c-30-24.6-63.5-44-99.7-57.6l-15.7-85a32.05 32.05 0 00-25.8-25.7l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 00-25.8 25.7l-15.8 85.4a351.86 351.86 0 00-99 57.4l-81.9-29.1a32 32 0 00-35.1 9.5l-1.8 2.1a446.02 446.02 0 00-79.7 137.9l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.3 56.6c-3.1 18.8-4.6 38-4.6 57.1 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 00-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1a32.12 32.12 0 0035.1 9.5l81.9-29.1c29.8 24.5 63.1 43.9 99 57.4l15.8 85.4a32.05 32.05 0 0025.8 25.7l2.7.5a449.4 449.4 0 00159 0l2.7-.5a32.05 32.05 0 0025.8-25.7l15.7-85a350 350 0 0099.7-57.6l81.3 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c4.5-12.3.8-26.3-9.3-35zM788.3 465.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 01-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97a377.5 377.5 0 01-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9zM512 326c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 502c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 01624 502c0 29.9-11.7 58-32.8 79.2z" } }] }, "name": "setting", "theme": "outlined" };
var SettingOutlinedSvg = SettingOutlined$2;

var SettingOutlined = function SettingOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SettingOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SettingOutlined.displayName = 'SettingOutlined';
}
var SettingOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SettingOutlined);

// This icon file is generated automatically.
var SettingTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M859.3 569.7l.2.1c3.1-18.9 4.6-38.2 4.6-57.3 0-17.1-1.3-34.3-3.7-51.1 2.4 16.7 3.6 33.6 3.6 50.5 0 19.4-1.6 38.8-4.7 57.8zM99 398.1c-.5-.4-.9-.8-1.4-1.3.7.7 1.4 1.4 2.2 2.1l65.5 55.9v-.1L99 398.1zm536.6-216h.1l-15.5-83.8c-.2-1-.4-1.9-.7-2.8.1.5.3 1.1.4 1.6l15.7 85zm54 546.5l31.4-25.8 92.8 32.9c17-22.9 31.3-47.5 42.6-73.6l-74.7-63.9 6.6-40.1c2.5-15.1 3.8-30.6 3.8-46.1s-1.3-31-3.8-46.1l-6.5-39.9 74.7-63.9c-11.4-26-25.6-50.7-42.6-73.6l-92.8 32.9-31.4-25.8c-23.9-19.6-50.6-35-79.3-45.8l-38.1-14.3-17.9-97a377.5 377.5 0 00-85 0l-17.9 97.2-37.9 14.3c-28.5 10.8-55 26.2-78.7 45.7l-31.4 25.9-93.4-33.2c-17 22.9-31.3 47.5-42.6 73.6l75.5 64.5-6.5 40c-2.5 14.9-3.7 30.2-3.7 45.5 0 15.2 1.3 30.6 3.7 45.5l6.5 40-75.5 64.5c11.4 26 25.6 50.7 42.6 73.6l93.4-33.2 31.4 25.9c23.7 19.5 50.2 34.9 78.7 45.7l37.8 14.5 17.9 97.2c28.2 3.2 56.9 3.2 85 0l17.9-97 38.1-14.3c28.8-10.8 55.4-26.2 79.3-45.8zm-177.1-50.3c-30.5 0-59.2-7.8-84.3-21.5C373.3 627 336 568.9 336 502c0-97.2 78.8-176 176-176 66.9 0 125 37.3 154.8 92.2 13.7 25 21.5 53.7 21.5 84.3 0 97.1-78.7 175.8-175.8 175.8zM207.2 812.8c-5.5 1.9-11.2 2.3-16.6 1.2 5.7 1.2 11.7 1 17.5-1l81.4-29c-.1-.1-.3-.2-.4-.3l-81.9 29.1zm717.6-414.7l-65.5 56c0 .2.1.5.1.7l65.4-55.9c7.1-6.1 11.1-14.9 11.2-24-.3 8.8-4.3 17.3-11.2 23.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M935.8 646.6c.5 4.7 0 9.5-1.7 14.1l-.9 2.6a446.02 446.02 0 01-79.7 137.9l-1.8 2.1a32 32 0 01-35.1 9.5l-81.3-28.9a350 350 0 01-99.7 57.6l-15.7 85a32.05 32.05 0 01-25.8 25.7l-2.7.5a445.2 445.2 0 01-79.2 7.1h.3c26.7 0 53.4-2.4 79.4-7.1l2.7-.5a32.05 32.05 0 0025.8-25.7l15.7-84.9c36.2-13.6 69.6-32.9 99.6-57.5l81.2 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.5-87.4 79.6-137.7l.9-2.6c1.6-4.7 2.1-9.7 1.5-14.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M688 502c0-30.3-7.7-58.9-21.2-83.8C637 363.3 578.9 326 512 326c-97.2 0-176 78.8-176 176 0 66.9 37.3 125 92.2 154.8 24.9 13.5 53.4 21.2 83.8 21.2 97.2 0 176-78.8 176-176zm-288 0c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 01624 502c0 29.9-11.7 58-32.8 79.2A111.6 111.6 0 01512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 502z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M594.1 952.2a32.05 32.05 0 0025.8-25.7l15.7-85a350 350 0 0099.7-57.6l81.3 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c1.7-4.6 2.2-9.4 1.7-14.1-.9-7.9-4.7-15.4-11-20.9l-65.3-55.9-.2-.1c3.1-19 4.7-38.4 4.7-57.8 0-16.9-1.2-33.9-3.6-50.5-.3-2.2-.7-4.4-1-6.6 0-.2-.1-.5-.1-.7l65.5-56c6.9-5.9 10.9-14.4 11.2-23.2.1-4-.5-8.1-1.9-12l-.9-2.6a443.74 443.74 0 00-79.7-137.9l-1.8-2.1a32.12 32.12 0 00-35.1-9.5l-81.3 28.9c-30-24.6-63.4-44-99.6-57.6h-.1l-15.7-85c-.1-.5-.2-1.1-.4-1.6a32.08 32.08 0 00-25.4-24.1l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 00-25.8 25.7l-15.8 85.4a351.86 351.86 0 00-99 57.4l-81.9-29.1a32 32 0 00-35.1 9.5l-1.8 2.1a446.02 446.02 0 00-79.7 137.9l-.9 2.6a32.09 32.09 0 007.9 33.9c.5.4.9.9 1.4 1.3l66.3 56.6v.1c-3.1 18.8-4.6 37.9-4.6 57 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 00-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1c4.9 5.7 11.4 9.4 18.5 10.7 5.4 1 11.1.7 16.6-1.2l81.9-29.1c.1.1.3.2.4.3 29.7 24.3 62.8 43.6 98.6 57.1l15.8 85.4a32.05 32.05 0 0025.8 25.7l2.7.5c26.1 4.7 52.8 7.1 79.5 7.1h.3c26.6 0 53.3-2.4 79.2-7.1l2.7-.5zm-39.8-66.5a377.5 377.5 0 01-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 01-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97z", "fill": primaryColor } }] }; }, "name": "setting", "theme": "twotone" };
var SettingTwoToneSvg = SettingTwoTone$2;

var SettingTwoTone = function SettingTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SettingTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SettingTwoTone.displayName = 'SettingTwoTone';
}
var SettingTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(SettingTwoTone);

// This icon file is generated automatically.
var ShakeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M324 666a48 48 0 1096 0 48 48 0 10-96 0zm616.7-309.6L667.6 83.2C655.2 70.9 638.7 64 621.1 64s-34.1 6.8-46.5 19.2L83.3 574.5a65.85 65.85 0 000 93.1l273.2 273.2c12.3 12.3 28.9 19.2 46.5 19.2s34.1-6.8 46.5-19.2l491.3-491.3c25.6-25.7 25.6-67.5-.1-93.1zM403 880.1L143.9 621l477.2-477.2 259 259.2L403 880.1zM152.8 373.7a7.9 7.9 0 0011.2 0L373.7 164a7.9 7.9 0 000-11.2l-38.4-38.4a7.9 7.9 0 00-11.2 0L114.3 323.9a7.9 7.9 0 000 11.2l38.5 38.6zm718.6 276.6a7.9 7.9 0 00-11.2 0L650.3 860.1a7.9 7.9 0 000 11.2l38.4 38.4a7.9 7.9 0 0011.2 0L909.7 700a7.9 7.9 0 000-11.2l-38.3-38.5z" } }] }, "name": "shake", "theme": "outlined" };
var ShakeOutlinedSvg = ShakeOutlined$2;

var ShakeOutlined = function ShakeOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ShakeOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ShakeOutlined.displayName = 'ShakeOutlined';
}
var ShakeOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ShakeOutlined);

// This icon file is generated automatically.
var ShareAltOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M752 664c-28.5 0-54.8 10-75.4 26.7L469.4 540.8a160.68 160.68 0 000-57.6l207.2-149.9C697.2 350 723.5 360 752 360c66.2 0 120-53.8 120-120s-53.8-120-120-120-120 53.8-120 120c0 11.6 1.6 22.7 4.7 33.3L439.9 415.8C410.7 377.1 364.3 352 312 352c-88.4 0-160 71.6-160 160s71.6 160 160 160c52.3 0 98.7-25.1 127.9-63.8l196.8 142.5c-3.1 10.6-4.7 21.8-4.7 33.3 0 66.2 53.8 120 120 120s120-53.8 120-120-53.8-120-120-120zm0-476c28.7 0 52 23.3 52 52s-23.3 52-52 52-52-23.3-52-52 23.3-52 52-52zM312 600c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88zm440 236c-28.7 0-52-23.3-52-52s23.3-52 52-52 52 23.3 52 52-23.3 52-52 52z" } }] }, "name": "share-alt", "theme": "outlined" };
var ShareAltOutlinedSvg = ShareAltOutlined$2;

var ShareAltOutlined = function ShareAltOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ShareAltOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ShareAltOutlined.displayName = 'ShareAltOutlined';
}
var ShareAltOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ShareAltOutlined);

// This icon file is generated automatically.
var ShopFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0014.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h274V736h128v176h274c17.7 0 32-14.3 32-32V535a175 175 0 0015.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zm-72 568H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm0-568.1H214v-88h596v88z" } }] }, "name": "shop", "theme": "filled" };
var ShopFilledSvg = ShopFilled$2;

var ShopFilled = function ShopFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ShopFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ShopFilled.displayName = 'ShopFilled';
}
var ShopFilled$1 = /*#__PURE__*/React__namespace.forwardRef(ShopFilled);

// This icon file is generated automatically.
var ShopOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0014.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535a175 175 0 0015.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88zm362 656.1H448V736h128v104.1zm234 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm30-404.4c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-.6c-5.7 0-11 3.1-13.9 8.1A109.24 109.24 0 01512 544c-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3a109.63 109.63 0 01-95.1 54.7C233 544 184 495.5 184 435.7v-91.2c0-.3.2-.5.5-.5h655c.3 0 .5.2.5.5v91.2z" } }] }, "name": "shop", "theme": "outlined" };
var ShopOutlinedSvg = ShopOutlined$2;

var ShopOutlined = function ShopOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ShopOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ShopOutlined.displayName = 'ShopOutlined';
}
var ShopOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ShopOutlined);

// This icon file is generated automatically.
var ShopTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M839.5 344h-655c-.3 0-.5.2-.5.5v91.2c0 59.8 49 108.3 109.3 108.3 40.7 0 76.2-22 95.1-54.7 2.9-5.1 8.4-8.3 14.3-8.3s11.3 3.2 14.3 8.3c18.8 32.7 54.3 54.7 95 54.7 40.8 0 76.4-22.1 95.1-54.9 2.9-5 8.2-8.1 13.9-8.1h.6c5.8 0 11 3.1 13.9 8.1 18.8 32.8 54.4 54.9 95.2 54.9C791 544 840 495.5 840 435.7v-91.2c0-.3-.2-.5-.5-.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0014.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535a175 175 0 0015.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88zm362 656.1H448V736h128v104.1zm234.4 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c3-1.3 6-2.6 9-4v242.2zM840 435.7c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-.6c-5.7 0-11 3.1-13.9 8.1A109.24 109.24 0 01512 544c-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3a109.63 109.63 0 01-95.1 54.7C233 544 184 495.5 184 435.7v-91.2c0-.3.2-.5.5-.5h655c.3 0 .5.2.5.5v91.2z", "fill": primaryColor } }] }; }, "name": "shop", "theme": "twotone" };
var ShopTwoToneSvg = ShopTwoTone$2;

var ShopTwoTone = function ShopTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ShopTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ShopTwoTone.displayName = 'ShopTwoTone';
}
var ShopTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(ShopTwoTone);

// This icon file is generated automatically.
var ShoppingCartOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M922.9 701.9H327.4l29.9-60.9 496.8-.9c16.8 0 31.2-12 34.2-28.6l68.8-385.1c1.8-10.1-.9-20.5-7.5-28.4a34.99 34.99 0 00-26.6-12.5l-632-2.1-5.4-25.4c-3.4-16.2-18-28-34.6-28H96.5a35.3 35.3 0 100 70.6h125.9L246 312.8l58.1 281.3-74.8 122.1a34.96 34.96 0 00-3 36.8c6 11.9 18.1 19.4 31.5 19.4h62.8a102.43 102.43 0 00-20.6 61.7c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7h161.1a102.43 102.43 0 00-20.6 61.7c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7H923c19.4 0 35.3-15.8 35.3-35.3a35.42 35.42 0 00-35.4-35.2zM305.7 253l575.8 1.9-56.4 315.8-452.3.8L305.7 253zm96.9 612.7c-17.4 0-31.6-14.2-31.6-31.6 0-17.4 14.2-31.6 31.6-31.6s31.6 14.2 31.6 31.6a31.6 31.6 0 01-31.6 31.6zm325.1 0c-17.4 0-31.6-14.2-31.6-31.6 0-17.4 14.2-31.6 31.6-31.6s31.6 14.2 31.6 31.6a31.6 31.6 0 01-31.6 31.6z" } }] }, "name": "shopping-cart", "theme": "outlined" };
var ShoppingCartOutlinedSvg = ShoppingCartOutlined$2;

var ShoppingCartOutlined = function ShoppingCartOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ShoppingCartOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ShoppingCartOutlined.displayName = 'ShoppingCartOutlined';
}
var ShoppingCartOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ShoppingCartOutlined);

// This icon file is generated automatically.
var ShoppingFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-208 0H400v-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16z" } }] }, "name": "shopping", "theme": "filled" };
var ShoppingFilledSvg = ShoppingFilled$2;

var ShoppingFilled = function ShoppingFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ShoppingFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ShoppingFilled.displayName = 'ShoppingFilled';
}
var ShoppingFilled$1 = /*#__PURE__*/React__namespace.forwardRef(ShoppingFilled);

// This icon file is generated automatically.
var ShoppingOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-432-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16H400v-16zm392 544H232V384h96v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h224v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h96v456z" } }] }, "name": "shopping", "theme": "outlined" };
var ShoppingOutlinedSvg = ShoppingOutlined$2;

var ShoppingOutlined = function ShoppingOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ShoppingOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ShoppingOutlined.displayName = 'ShoppingOutlined';
}
var ShoppingOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ShoppingOutlined);

// This icon file is generated automatically.
var ShoppingTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M696 472c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-88H400v88c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-88h-96v456h560V384h-96v88z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-432-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16H400v-16zm392 544H232V384h96v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h224v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h96v456z", "fill": primaryColor } }] }; }, "name": "shopping", "theme": "twotone" };
var ShoppingTwoToneSvg = ShoppingTwoTone$2;

var ShoppingTwoTone = function ShoppingTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ShoppingTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ShoppingTwoTone.displayName = 'ShoppingTwoTone';
}
var ShoppingTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(ShoppingTwoTone);

// This icon file is generated automatically.
var ShrinkOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M881.7 187.4l-45.1-45.1a8.03 8.03 0 00-11.3 0L667.8 299.9l-54.7-54.7a7.94 7.94 0 00-13.5 4.7L576.1 439c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 157.6-157.6c3-3 3-8.1-.1-11.2zM439 576.1l-189.2 23.5c-6.6.8-9.3 8.9-4.7 13.5l54.7 54.7-157.5 157.5a8.03 8.03 0 000 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l157.6-157.6 54.7 54.7a7.94 7.94 0 0013.5-4.7L447.9 585a7.9 7.9 0 00-8.9-8.9z" } }] }, "name": "shrink", "theme": "outlined" };
var ShrinkOutlinedSvg = ShrinkOutlined$2;

var ShrinkOutlined = function ShrinkOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ShrinkOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ShrinkOutlined.displayName = 'ShrinkOutlined';
}
var ShrinkOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ShrinkOutlined);

// This icon file is generated automatically.
var SignalFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M584 352H440c-17.7 0-32 14.3-32 32v544c0 17.7 14.3 32 32 32h144c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32zM892 64H748c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h144c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM276 640H132c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h144c17.7 0 32-14.3 32-32V672c0-17.7-14.3-32-32-32z" } }] }, "name": "signal", "theme": "filled" };
var SignalFilledSvg = SignalFilled$2;

var SignalFilled = function SignalFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SignalFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SignalFilled.displayName = 'SignalFilled';
}
var SignalFilled$1 = /*#__PURE__*/React__namespace.forwardRef(SignalFilled);

// This icon file is generated automatically.
var SisternodeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M672 432c-120.3 0-219.9 88.5-237.3 204H320c-15.5 0-28-12.5-28-28V244h291c14.2 35.2 48.7 60 89 60 53 0 96-43 96-96s-43-96-96-96c-40.3 0-74.8 24.8-89 60H112v72h108v364c0 55.2 44.8 100 100 100h114.7c17.4 115.5 117 204 237.3 204 132.5 0 240-107.5 240-240S804.5 432 672 432zm128 266c0 4.4-3.6 8-8 8h-86v86c0 4.4-3.6 8-8 8h-52c-4.4 0-8-3.6-8-8v-86h-86c-4.4 0-8-3.6-8-8v-52c0-4.4 3.6-8 8-8h86v-86c0-4.4 3.6-8 8-8h52c4.4 0 8 3.6 8 8v86h86c4.4 0 8 3.6 8 8v52z" } }] }, "name": "sisternode", "theme": "outlined" };
var SisternodeOutlinedSvg = SisternodeOutlined$2;

var SisternodeOutlined = function SisternodeOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SisternodeOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SisternodeOutlined.displayName = 'SisternodeOutlined';
}
var SisternodeOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SisternodeOutlined);

// This icon file is generated automatically.
var SketchCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M582.3 625.6l147.9-166.3h-63.4zm90-202.3h62.5l-92.1-115.1zm-274.7 36L512 684.5l114.4-225.2zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm286.7 380.2L515.8 762.3c-1 1.1-2.4 1.7-3.8 1.7s-2.8-.6-3.8-1.7L225.3 444.2a5.14 5.14 0 01-.2-6.6L365.6 262c1-1.2 2.4-1.9 4-1.9h284.6c1.6 0 3 .7 4 1.9l140.5 175.6a4.9 4.9 0 010 6.6zm-190.5-20.9L512 326.1l-96.2 97.2zM420.3 301.1l-23.1 89.8 88.8-89.8zm183.4 0H538l88.8 89.8zm-222.4 7.1l-92.1 115.1h62.5zm-87.5 151.1l147.9 166.3-84.5-166.3z" } }] }, "name": "sketch-circle", "theme": "filled" };
var SketchCircleFilledSvg = SketchCircleFilled$2;

var SketchCircleFilled = function SketchCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SketchCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SketchCircleFilled.displayName = 'SketchCircleFilled';
}
var SketchCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(SketchCircleFilled);

// This icon file is generated automatically.
var SketchOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M925.6 405.1l-203-253.7a6.5 6.5 0 00-5-2.4H306.4c-1.9 0-3.8.9-5 2.4l-203 253.7a6.5 6.5 0 00.2 8.3l408.6 459.5c1.2 1.4 3 2.1 4.8 2.1 1.8 0 3.5-.8 4.8-2.1l408.6-459.5a6.5 6.5 0 00.2-8.3zM645.2 206.4l34.4 133.9-132.5-133.9h98.1zm8.2 178.5H370.6L512 242l141.4 142.9zM378.8 206.4h98.1L344.3 340.3l34.5-133.9zm-53.4 7l-44.1 171.5h-93.1l137.2-171.5zM194.6 434.9H289l125.8 247.7-220.2-247.7zM512 763.4L345.1 434.9h333.7L512 763.4zm97.1-80.8L735 434.9h94.4L609.1 682.6zm133.6-297.7l-44.1-171.5 137.2 171.5h-93.1z" } }] }, "name": "sketch", "theme": "outlined" };
var SketchOutlinedSvg = SketchOutlined$2;

var SketchOutlined = function SketchOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SketchOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SketchOutlined.displayName = 'SketchOutlined';
}
var SketchOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SketchOutlined);

// This icon file is generated automatically.
var SketchSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M608.2 423.3L512 326.1l-96.2 97.2zm-25.9 202.3l147.9-166.3h-63.4zm90-202.3h62.5l-92.1-115.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-81.3 332.2L515.8 762.3c-1 1.1-2.4 1.7-3.8 1.7s-2.8-.6-3.8-1.7L225.3 444.2a5.14 5.14 0 01-.2-6.6L365.6 262c1-1.2 2.4-1.9 4-1.9h284.6c1.6 0 3 .7 4 1.9l140.5 175.6a4.9 4.9 0 010 6.6zm-401.1 15.1L512 684.5l114.4-225.2zm-16.3-151.1l-92.1 115.1h62.5zm-87.5 151.1l147.9 166.3-84.5-166.3zm126.5-158.2l-23.1 89.8 88.8-89.8zm183.4 0H538l88.8 89.8z" } }] }, "name": "sketch-square", "theme": "filled" };
var SketchSquareFilledSvg = SketchSquareFilled$2;

var SketchSquareFilled = function SketchSquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SketchSquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SketchSquareFilled.displayName = 'SketchSquareFilled';
}
var SketchSquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(SketchSquareFilled);

// This icon file is generated automatically.
var SkinFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 00-37-29.3H154a44 44 0 00-44 44v252a44 44 0 0044 44h75v388a44 44 0 0044 44h478a44 44 0 0044-44V466h75a44 44 0 0044-44V170a44 44 0 00-44-44z" } }] }, "name": "skin", "theme": "filled" };
var SkinFilledSvg = SkinFilled$2;

var SkinFilled = function SkinFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SkinFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SkinFilled.displayName = 'SkinFilled';
}
var SkinFilled$1 = /*#__PURE__*/React__namespace.forwardRef(SkinFilled);

// This icon file is generated automatically.
var SkinOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 00-37-29.3H154a44 44 0 00-44 44v252a44 44 0 0044 44h75v388a44 44 0 0044 44h478a44 44 0 0044-44V466h75a44 44 0 0044-44V170a44 44 0 00-44-44zm-28 268H723v432H301V394H182V198h153.3c28.2 71.2 97.5 120 176.7 120s148.5-48.8 176.7-120H842v196z" } }] }, "name": "skin", "theme": "outlined" };
var SkinOutlinedSvg = SkinOutlined$2;

var SkinOutlined = function SkinOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SkinOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SkinOutlined.displayName = 'SkinOutlined';
}
var SkinOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SkinOutlined);

// This icon file is generated automatically.
var SkinTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 318c-79.2 0-148.5-48.8-176.7-120H182v196h119v432h422V394h119V198H688.7c-28.2 71.2-97.5 120-176.7 120z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 00-37-29.3H154a44 44 0 00-44 44v252a44 44 0 0044 44h75v388a44 44 0 0044 44h478a44 44 0 0044-44V466h75a44 44 0 0044-44V170a44 44 0 00-44-44zm-28 268H723v432H301V394H182V198h153.3c28.2 71.2 97.5 120 176.7 120s148.5-48.8 176.7-120H842v196z", "fill": primaryColor } }] }; }, "name": "skin", "theme": "twotone" };
var SkinTwoToneSvg = SkinTwoTone$2;

var SkinTwoTone = function SkinTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SkinTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SkinTwoTone.displayName = 'SkinTwoTone';
}
var SkinTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(SkinTwoTone);

// This icon file is generated automatically.
var SkypeFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M883.7 578.6c4.1-22.5 6.3-45.5 6.3-68.5 0-51-10-100.5-29.7-147-19-45-46.3-85.4-81-120.1a375.79 375.79 0 00-120.1-80.9c-46.6-19.7-96-29.7-147-29.7-24 0-48.1 2.3-71.5 6.8A225.1 225.1 0 00335.6 113c-59.7 0-115.9 23.3-158.1 65.5A222.25 222.25 0 00112 336.6c0 38 9.8 75.4 28.1 108.4-3.7 21.4-5.7 43.3-5.7 65.1 0 51 10 100.5 29.7 147 19 45 46.2 85.4 80.9 120.1 34.7 34.7 75.1 61.9 120.1 80.9 46.6 19.7 96 29.7 147 29.7 22.2 0 44.4-2 66.2-5.9 33.5 18.9 71.3 29 110 29 59.7 0 115.9-23.2 158.1-65.5 42.3-42.2 65.5-98.4 65.5-158.1.1-38-9.7-75.5-28.2-108.7zm-370 162.9c-134.2 0-194.2-66-194.2-115.4 0-25.4 18.7-43.1 44.5-43.1 57.4 0 42.6 82.5 149.7 82.5 54.9 0 85.2-29.8 85.2-60.3 0-18.3-9-38.7-45.2-47.6l-119.4-29.8c-96.1-24.1-113.6-76.1-113.6-124.9 0-101.4 95.5-139.5 185.2-139.5 82.6 0 180 45.7 180 106.5 0 26.1-22.6 41.2-48.4 41.2-49 0-40-67.8-138.7-67.8-49 0-76.1 22.2-76.1 53.9s38.7 41.8 72.3 49.5l88.4 19.6c96.8 21.6 121.3 78.1 121.3 131.3 0 82.3-63.3 143.9-191 143.9z" } }] }, "name": "skype", "theme": "filled" };
var SkypeFilledSvg = SkypeFilled$2;

var SkypeFilled = function SkypeFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SkypeFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SkypeFilled.displayName = 'SkypeFilled';
}
var SkypeFilled$1 = /*#__PURE__*/React__namespace.forwardRef(SkypeFilled);

// This icon file is generated automatically.
var SkypeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M883.7 578.6c4.1-22.5 6.3-45.5 6.3-68.5 0-51-10-100.5-29.7-147-19-45-46.3-85.4-81-120.1a375.79 375.79 0 00-120.1-80.9c-46.6-19.7-96-29.7-147-29.7-24 0-48.1 2.3-71.5 6.8A225.1 225.1 0 00335.6 113c-59.7 0-115.9 23.3-158.1 65.5A222.25 222.25 0 00112 336.6c0 38 9.8 75.4 28.1 108.4-3.7 21.4-5.7 43.3-5.7 65.1 0 51 10 100.5 29.7 147 19 45 46.2 85.4 80.9 120.1 34.7 34.7 75.1 61.9 120.1 80.9 46.6 19.7 96 29.7 147 29.7 22.2 0 44.4-2 66.2-5.9 33.5 18.9 71.3 29 110 29 59.7 0 115.9-23.2 158.1-65.5 42.3-42.2 65.5-98.4 65.5-158.1.1-38-9.7-75.5-28.2-108.7zm-88.1 216C766.9 823.4 729 839 688.4 839c-26.1 0-51.8-6.8-74.6-19.7l-22.5-12.7-25.5 4.5c-17.8 3.2-35.8 4.8-53.6 4.8-41.4 0-81.3-8.1-119.1-24.1-36.3-15.3-69-37.3-97.2-65.5a304.29 304.29 0 01-65.5-97.1c-16-37.7-24-77.6-24-119 0-17.4 1.6-35.2 4.6-52.8l4.4-25.1L203 410a151.02 151.02 0 01-19.1-73.4c0-40.6 15.7-78.5 44.4-107.2C257.1 200.7 295 185 335.6 185a153 153 0 0171.4 17.9l22.4 11.8 24.8-4.8c18.9-3.6 38.4-5.5 58-5.5 41.4 0 81.3 8.1 119 24 36.5 15.4 69.1 37.4 97.2 65.5 28.2 28.1 50.2 60.8 65.6 97.2 16 37.7 24 77.6 24 119 0 18.4-1.7 37-5.1 55.5l-4.7 25.5 12.6 22.6c12.6 22.5 19.2 48 19.2 73.7 0 40.7-15.7 78.5-44.4 107.2zM583.4 466.2L495 446.6c-33.6-7.7-72.3-17.8-72.3-49.5s27.1-53.9 76.1-53.9c98.7 0 89.7 67.8 138.7 67.8 25.8 0 48.4-15.2 48.4-41.2 0-60.8-97.4-106.5-180-106.5-89.7 0-185.2 38.1-185.2 139.5 0 48.8 17.4 100.8 113.6 124.9l119.4 29.8c36.1 8.9 45.2 29.2 45.2 47.6 0 30.5-30.3 60.3-85.2 60.3-107.2 0-92.3-82.5-149.7-82.5-25.8 0-44.5 17.8-44.5 43.1 0 49.4 60 115.4 194.2 115.4 127.7 0 191-61.5 191-144 0-53.1-24.5-109.6-121.3-131.2z" } }] }, "name": "skype", "theme": "outlined" };
var SkypeOutlinedSvg = SkypeOutlined$2;

var SkypeOutlined = function SkypeOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SkypeOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SkypeOutlined.displayName = 'SkypeOutlined';
}
var SkypeOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SkypeOutlined);

// This icon file is generated automatically.
var SlackCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 01-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0150.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm83.7-50.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM579.3 765c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134c-13.3 0-26.1-5.3-35.6-14.8S529 593.6 529 580.2c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z" } }] }, "name": "slack-circle", "theme": "filled" };
var SlackCircleFilledSvg = SlackCircleFilled$2;

var SlackCircleFilled = function SlackCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SlackCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SlackCircleFilled.displayName = 'SlackCircleFilled';
}
var SlackCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(SlackCircleFilled);

// This icon file is generated automatically.
var SlackOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M409.4 128c-42.4 0-76.7 34.4-76.7 76.8 0 20.3 8.1 39.9 22.4 54.3a76.74 76.74 0 0054.3 22.5h76.7v-76.8c0-42.3-34.3-76.7-76.7-76.8zm0 204.8H204.7c-42.4 0-76.7 34.4-76.7 76.8s34.4 76.8 76.7 76.8h204.6c42.4 0 76.7-34.4 76.7-76.8.1-42.4-34.3-76.8-76.6-76.8zM614 486.4c42.4 0 76.8-34.4 76.7-76.8V204.8c0-42.4-34.3-76.8-76.7-76.8-42.4 0-76.7 34.4-76.7 76.8v204.8c0 42.5 34.3 76.8 76.7 76.8zm281.4-76.8c0-42.4-34.4-76.8-76.7-76.8S742 367.2 742 409.6v76.8h76.7c42.3 0 76.7-34.4 76.7-76.8zm-76.8 128H614c-42.4 0-76.7 34.4-76.7 76.8 0 20.3 8.1 39.9 22.4 54.3a76.74 76.74 0 0054.3 22.5h204.6c42.4 0 76.7-34.4 76.7-76.8.1-42.4-34.3-76.7-76.7-76.8zM614 742.4h-76.7v76.8c0 42.4 34.4 76.8 76.7 76.8 42.4 0 76.8-34.4 76.7-76.8.1-42.4-34.3-76.7-76.7-76.8zM409.4 537.6c-42.4 0-76.7 34.4-76.7 76.8v204.8c0 42.4 34.4 76.8 76.7 76.8 42.4 0 76.8-34.4 76.7-76.8V614.4c0-20.3-8.1-39.9-22.4-54.3a76.92 76.92 0 00-54.3-22.5zM128 614.4c0 20.3 8.1 39.9 22.4 54.3a76.74 76.74 0 0054.3 22.5c42.4 0 76.8-34.4 76.7-76.8v-76.8h-76.7c-42.3 0-76.7 34.4-76.7 76.8z" } }] }, "name": "slack", "theme": "outlined" };
var SlackOutlinedSvg = SlackOutlined$2;

var SlackOutlined = function SlackOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SlackOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SlackOutlined.displayName = 'SlackOutlined';
}
var SlackOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SlackOutlined);

// This icon file is generated automatically.
var SlackSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM529 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 01-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0150.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm134 403.2c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134a50.35 50.35 0 01-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z" } }] }, "name": "slack-square", "theme": "filled" };
var SlackSquareFilledSvg = SlackSquareFilled$2;

var SlackSquareFilled = function SlackSquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SlackSquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SlackSquareFilled.displayName = 'SlackSquareFilled';
}
var SlackSquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(SlackSquareFilled);

// This icon file is generated automatically.
var SlackSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM529 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 01-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0150.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm134 403.2c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134a50.35 50.35 0 01-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z" } }] }, "name": "slack-square", "theme": "outlined" };
var SlackSquareOutlinedSvg = SlackSquareOutlined$2;

var SlackSquareOutlined = function SlackSquareOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SlackSquareOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SlackSquareOutlined.displayName = 'SlackSquareOutlined';
}
var SlackSquareOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SlackSquareOutlined);

// This icon file is generated automatically.
var SlidersFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 296h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-584-72h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm292 180h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8z" } }] }, "name": "sliders", "theme": "filled" };
var SlidersFilledSvg = SlidersFilled$2;

var SlidersFilled = function SlidersFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SlidersFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SlidersFilled.displayName = 'SlidersFilled';
}
var SlidersFilled$1 = /*#__PURE__*/React__namespace.forwardRef(SlidersFilled);

// This icon file is generated automatically.
var SlidersOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M320 224h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-60 508h-80V292h80v440zm644-436h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-60 364h-80V364h80v296zM612 404h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8zm-60 145a3 3 0 01-3 3h-74a3 3 0 01-3-3v-74a3 3 0 013-3h74a3 3 0 013 3v74z" } }] }, "name": "sliders", "theme": "outlined" };
var SlidersOutlinedSvg = SlidersOutlined$2;

var SlidersOutlined = function SlidersOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SlidersOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SlidersOutlined.displayName = 'SlidersOutlined';
}
var SlidersOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SlidersOutlined);

// This icon file is generated automatically.
var SlidersTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M180 292h80v440h-80zm369 180h-74a3 3 0 00-3 3v74a3 3 0 003 3h74a3 3 0 003-3v-74a3 3 0 00-3-3zm215-108h80v296h-80z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M904 296h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-60 364h-80V364h80v296zM612 404h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8zm-60 145a3 3 0 01-3 3h-74a3 3 0 01-3-3v-74a3 3 0 013-3h74a3 3 0 013 3v74zM320 224h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-60 508h-80V292h80v440z", "fill": primaryColor } }] }; }, "name": "sliders", "theme": "twotone" };
var SlidersTwoToneSvg = SlidersTwoTone$2;

var SlidersTwoTone = function SlidersTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SlidersTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SlidersTwoTone.displayName = 'SlidersTwoTone';
}
var SlidersTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(SlidersTwoTone);

// This icon file is generated automatically.
var SmallDashOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M112 476h72v72h-72zm182 0h72v72h-72zm364 0h72v72h-72zm182 0h72v72h-72zm-364 0h72v72h-72z" } }] }, "name": "small-dash", "theme": "outlined" };
var SmallDashOutlinedSvg = SmallDashOutlined$2;

var SmallDashOutlined = function SmallDashOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SmallDashOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SmallDashOutlined.displayName = 'SmallDashOutlined';
}
var SmallDashOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SmallDashOutlined);

// This icon file is generated automatically.
var SmileFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm224 272c-85.5 0-155.6-67.3-160-151.6a8 8 0 018-8.4h48.1c4.2 0 7.8 3.2 8.1 7.4C420 589.9 461.5 629 512 629s92.1-39.1 95.8-88.6c.3-4.2 3.9-7.4 8.1-7.4H664a8 8 0 018 8.4C667.6 625.7 597.5 693 512 693zm176-224a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "smile", "theme": "filled" };
var SmileFilledSvg = SmileFilled$2;

var SmileFilled = function SmileFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SmileFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SmileFilled.displayName = 'SmileFilled';
}
var SmileFilled$1 = /*#__PURE__*/React__namespace.forwardRef(SmileFilled);

// This icon file is generated automatically.
var SmileOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M288 421a48 48 0 1096 0 48 48 0 10-96 0zm352 0a48 48 0 1096 0 48 48 0 10-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 01248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 01249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 01775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 01775 775zM664 533h-48.1c-4.2 0-7.8 3.2-8.1 7.4C604 589.9 562.5 629 512 629s-92.1-39.1-95.8-88.6c-.3-4.2-3.9-7.4-8.1-7.4H360a8 8 0 00-8 8.4c4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6a8 8 0 00-8-8.4z" } }] }, "name": "smile", "theme": "outlined" };
var SmileOutlinedSvg = SmileOutlined$2;

var SmileOutlined = function SmileOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SmileOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SmileOutlined.displayName = 'SmileOutlined';
}
var SmileOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SmileOutlined);

// This icon file is generated automatically.
var SmileTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm224 272c-85.5 0-155.6-67.3-160-151.6a8 8 0 018-8.4h48.1c4.2 0 7.8 3.2 8.1 7.4C420 589.9 461.5 629 512 629s92.1-39.1 95.8-88.6c.3-4.2 3.9-7.4 8.1-7.4H664a8 8 0 018 8.4C667.6 625.7 597.5 693 512 693zm176-224a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M288 421a48 48 0 1096 0 48 48 0 10-96 0zm376 112h-48.1c-4.2 0-7.8 3.2-8.1 7.4-3.7 49.5-45.3 88.6-95.8 88.6s-92-39.1-95.8-88.6c-.3-4.2-3.9-7.4-8.1-7.4H360a8 8 0 00-8 8.4c4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6a8 8 0 00-8-8.4zm-24-112a48 48 0 1096 0 48 48 0 10-96 0z", "fill": primaryColor } }] }; }, "name": "smile", "theme": "twotone" };
var SmileTwoToneSvg = SmileTwoTone$2;

var SmileTwoTone = function SmileTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SmileTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SmileTwoTone.displayName = 'SmileTwoTone';
}
var SmileTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(SmileTwoTone);

// This icon file is generated automatically.
var SnippetsFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 486H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z" } }] }, "name": "snippets", "theme": "filled" };
var SnippetsFilledSvg = SnippetsFilled$2;

var SnippetsFilled = function SnippetsFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SnippetsFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SnippetsFilled.displayName = 'SnippetsFilled';
}
var SnippetsFilled$1 = /*#__PURE__*/React__namespace.forwardRef(SnippetsFilled);

// This icon file is generated automatically.
var SnippetsOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 888H232V336h218v174c0 22.1 17.9 40 40 40h174v338zm0-402H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z" } }] }, "name": "snippets", "theme": "outlined" };
var SnippetsOutlinedSvg = SnippetsOutlined$2;

var SnippetsOutlined = function SnippetsOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SnippetsOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SnippetsOutlined.displayName = 'SnippetsOutlined';
}
var SnippetsOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SnippetsOutlined);

// This icon file is generated automatically.
var SnippetsTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M450 510V336H232v552h432V550H490c-22.1 0-40-17.9-40-40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 888H232V336h218v174c0 22.1 17.9 40 40 40h174v338zm0-402H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z", "fill": primaryColor } }] }; }, "name": "snippets", "theme": "twotone" };
var SnippetsTwoToneSvg = SnippetsTwoTone$2;

var SnippetsTwoTone = function SnippetsTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SnippetsTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SnippetsTwoTone.displayName = 'SnippetsTwoTone';
}
var SnippetsTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(SnippetsTwoTone);

// This icon file is generated automatically.
var SolutionOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M688 264c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48zm-8 136H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM480 544H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 308H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm356.8-74.4c29-26.3 47.2-64.3 47.2-106.6 0-79.5-64.5-144-144-144s-144 64.5-144 144c0 42.3 18.2 80.3 47.2 106.6-57 32.5-96.2 92.7-99.2 162.1-.2 4.5 3.5 8.3 8 8.3h48.1c4.2 0 7.7-3.3 8-7.6C564 871.2 621.7 816 692 816s128 55.2 131.9 124.4c.2 4.2 3.7 7.6 8 7.6H880c4.6 0 8.2-3.8 8-8.3-2.9-69.5-42.2-129.6-99.2-162.1zM692 591c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z" } }] }, "name": "solution", "theme": "outlined" };
var SolutionOutlinedSvg = SolutionOutlined$2;

var SolutionOutlined = function SolutionOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SolutionOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SolutionOutlined.displayName = 'SolutionOutlined';
}
var SolutionOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SolutionOutlined);

// This icon file is generated automatically.
var SortAscendingOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M839.6 433.8L749 150.5a9.24 9.24 0 00-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-.3.9-.5 1.9-.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-.1 2.8-.4 2.4-.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2zm143.5 492.9H677.2v-.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v.4L587.7 828.9a9.35 9.35 0 00-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43a9.2 9.2 0 00-9.2-9.3zM416 702h-76V172c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v530h-76c-6.7 0-10.5 7.8-6.3 13l112 141.9a8 8 0 0012.6 0l112-141.9c4.1-5.2.4-13-6.3-13z" } }] }, "name": "sort-ascending", "theme": "outlined" };
var SortAscendingOutlinedSvg = SortAscendingOutlined$2;

var SortAscendingOutlined = function SortAscendingOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SortAscendingOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SortAscendingOutlined.displayName = 'SortAscendingOutlined';
}
var SortAscendingOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SortAscendingOutlined);

// This icon file is generated automatically.
var SortDescendingOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M839.6 433.8L749 150.5a9.24 9.24 0 00-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-.3.9-.5 1.9-.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-.1 2.8-.4 2.4-.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2zm143.5 492.9H677.2v-.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v.4L587.7 828.9a9.35 9.35 0 00-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43a9.2 9.2 0 00-9.2-9.3zM310.3 167.1a8 8 0 00-12.6 0L185.7 309c-4.2 5.3-.4 13 6.3 13h76v530c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V322h76c6.7 0 10.5-7.8 6.3-13l-112-141.9z" } }] }, "name": "sort-descending", "theme": "outlined" };
var SortDescendingOutlinedSvg = SortDescendingOutlined$2;

var SortDescendingOutlined = function SortDescendingOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SortDescendingOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SortDescendingOutlined.displayName = 'SortDescendingOutlined';
}
var SortDescendingOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SortDescendingOutlined);

// This icon file is generated automatically.
var SoundFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M892.1 737.8l-110.3-63.7a15.9 15.9 0 00-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0021.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM760 344a15.9 15.9 0 0021.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 00-21.7-5.9L746 287.8a15.99 15.99 0 00-5.8 21.8L760 344zm174 132H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zM625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1z" } }] }, "name": "sound", "theme": "filled" };
var SoundFilledSvg = SoundFilled$2;

var SoundFilled = function SoundFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SoundFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SoundFilled.displayName = 'SoundFilled';
}
var SoundFilled$1 = /*#__PURE__*/React__namespace.forwardRef(SoundFilled);

// This icon file is generated automatically.
var SoundOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1zM586 803L293.4 611.7l-18-11.7H146V424h129.4l17.9-11.7L586 221v582zm348-327H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm-41.9 261.8l-110.3-63.7a15.9 15.9 0 00-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0021.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM760 344a15.9 15.9 0 0021.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 00-21.7-5.9L746 287.8a15.99 15.99 0 00-5.8 21.8L760 344z" } }] }, "name": "sound", "theme": "outlined" };
var SoundOutlinedSvg = SoundOutlined$2;

var SoundOutlined = function SoundOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SoundOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SoundOutlined.displayName = 'SoundOutlined';
}
var SoundOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SoundOutlined);

// This icon file is generated automatically.
var SoundTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M275.4 424H146v176h129.4l18 11.7L586 803V221L293.3 412.3z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M892.1 737.8l-110.3-63.7a15.9 15.9 0 00-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0021.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM934 476H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zM760 344a15.9 15.9 0 0021.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 00-21.7-5.9L746 287.8a15.99 15.99 0 00-5.8 21.8L760 344zM625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1zM586 803L293.4 611.7l-18-11.7H146V424h129.4l17.9-11.7L586 221v582z", "fill": primaryColor } }] }; }, "name": "sound", "theme": "twotone" };
var SoundTwoToneSvg = SoundTwoTone$2;

var SoundTwoTone = function SoundTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SoundTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SoundTwoTone.displayName = 'SoundTwoTone';
}
var SoundTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(SoundTwoTone);

// This icon file is generated automatically.
var SplitCellsOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M938.2 508.4L787.3 389c-3-2.4-7.3-.2-7.3 3.6V478H636V184h204v128c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V144c0-15.5-12.5-28-28-28H596c-15.5 0-28 12.5-28 28v736c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v128H636V546h144v85.4c0 3.8 4.4 6 7.3 3.6l150.9-119.4a4.5 4.5 0 000-7.2zM428 116H144c-15.5 0-28 12.5-28 28v168c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V184h204v294H244v-85.4c0-3.8-4.3-6-7.3-3.6l-151 119.4a4.52 4.52 0 000 7.1l151 119.5c2.9 2.3 7.3.2 7.3-3.6V546h144v294H184V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v168c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V144c0-15.5-12.5-28-28-28z" } }] }, "name": "split-cells", "theme": "outlined" };
var SplitCellsOutlinedSvg = SplitCellsOutlined$2;

var SplitCellsOutlined = function SplitCellsOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SplitCellsOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SplitCellsOutlined.displayName = 'SplitCellsOutlined';
}
var SplitCellsOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SplitCellsOutlined);

// This icon file is generated automatically.
var StarFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0046.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z" } }] }, "name": "star", "theme": "filled" };
var StarFilledSvg = StarFilled$2;

var StarFilled = function StarFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: StarFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  StarFilled.displayName = 'StarFilled';
}
var StarFilled$1 = /*#__PURE__*/React__namespace.forwardRef(StarFilled);

// This icon file is generated automatically.
var StarOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0046.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7-152.8 148.9z" } }] }, "name": "star", "theme": "outlined" };
var StarOutlinedSvg = StarOutlined$2;

var StarOutlined = function StarOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: StarOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  StarOutlined.displayName = 'StarOutlined';
}
var StarOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(StarOutlined);

// This icon file is generated automatically.
var StarTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512.5 190.4l-94.4 191.3-211.2 30.7 152.8 149-36.1 210.3 188.9-99.3 188.9 99.2-36.1-210.3 152.8-148.9-211.2-30.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M908.6 352.8l-253.9-36.9L541.2 85.8c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L370.3 315.9l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1L239 839.4a31.95 31.95 0 0046.4 33.7l227.1-119.4 227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM665.3 561.3l36.1 210.3-188.9-99.2-188.9 99.3 36.1-210.3-152.8-149 211.2-30.7 94.4-191.3 94.4 191.3 211.2 30.7-152.8 148.9z", "fill": primaryColor } }] }; }, "name": "star", "theme": "twotone" };
var StarTwoToneSvg = StarTwoTone$2;

var StarTwoTone = function StarTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: StarTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  StarTwoTone.displayName = 'StarTwoTone';
}
var StarTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(StarTwoTone);

// This icon file is generated automatically.
var StepBackwardFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M347.6 528.95l383.2 301.02c14.25 11.2 35.2 1.1 35.2-16.95V210.97c0-18.05-20.95-28.14-35.2-16.94L347.6 495.05a21.53 21.53 0 000 33.9M330 864h-64a8 8 0 01-8-8V168a8 8 0 018-8h64a8 8 0 018 8v688a8 8 0 01-8 8" } }] }, "name": "step-backward", "theme": "filled" };
var StepBackwardFilledSvg = StepBackwardFilled$2;

var StepBackwardFilled = function StepBackwardFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: StepBackwardFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  StepBackwardFilled.displayName = 'StepBackwardFilled';
}
var StepBackwardFilled$1 = /*#__PURE__*/React__namespace.forwardRef(StepBackwardFilled);

// This icon file is generated automatically.
var StepBackwardOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M347.6 528.95l383.2 301.02c14.25 11.2 35.2 1.1 35.2-16.95V210.97c0-18.05-20.95-28.14-35.2-16.94L347.6 495.05a21.53 21.53 0 000 33.9M330 864h-64a8 8 0 01-8-8V168a8 8 0 018-8h64a8 8 0 018 8v688a8 8 0 01-8 8" } }] }, "name": "step-backward", "theme": "outlined" };
var StepBackwardOutlinedSvg = StepBackwardOutlined$2;

var StepBackwardOutlined = function StepBackwardOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: StepBackwardOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  StepBackwardOutlined.displayName = 'StepBackwardOutlined';
}
var StepBackwardOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(StepBackwardOutlined);

// This icon file is generated automatically.
var StepForwardFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M676.4 528.95L293.2 829.97c-14.25 11.2-35.2 1.1-35.2-16.95V210.97c0-18.05 20.95-28.14 35.2-16.94l383.2 301.02a21.53 21.53 0 010 33.9M694 864h64a8 8 0 008-8V168a8 8 0 00-8-8h-64a8 8 0 00-8 8v688a8 8 0 008 8" } }] }, "name": "step-forward", "theme": "filled" };
var StepForwardFilledSvg = StepForwardFilled$2;

var StepForwardFilled = function StepForwardFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: StepForwardFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  StepForwardFilled.displayName = 'StepForwardFilled';
}
var StepForwardFilled$1 = /*#__PURE__*/React__namespace.forwardRef(StepForwardFilled);

// This icon file is generated automatically.
var StepForwardOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M676.4 528.95L293.2 829.97c-14.25 11.2-35.2 1.1-35.2-16.95V210.97c0-18.05 20.95-28.14 35.2-16.94l383.2 301.02a21.53 21.53 0 010 33.9M694 864h64a8 8 0 008-8V168a8 8 0 00-8-8h-64a8 8 0 00-8 8v688a8 8 0 008 8" } }] }, "name": "step-forward", "theme": "outlined" };
var StepForwardOutlinedSvg = StepForwardOutlined$2;

var StepForwardOutlined = function StepForwardOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: StepForwardOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  StepForwardOutlined.displayName = 'StepForwardOutlined';
}
var StepForwardOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(StepForwardOutlined);

// This icon file is generated automatically.
var StockOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 747H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM165.7 621.8l39.7 39.5c3.1 3.1 8.2 3.1 11.3 0l234.7-233.9 97.6 97.3a32.11 32.11 0 0045.2 0l264.2-263.2c3.1-3.1 3.1-8.2 0-11.3l-39.7-39.6a8.03 8.03 0 00-11.3 0l-235.7 235-97.7-97.3a32.11 32.11 0 00-45.2 0L165.7 610.5a7.94 7.94 0 000 11.3z" } }] }, "name": "stock", "theme": "outlined" };
var StockOutlinedSvg = StockOutlined$2;

var StockOutlined = function StockOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: StockOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  StockOutlined.displayName = 'StockOutlined';
}
var StockOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(StockOutlined);

// This icon file is generated automatically.
var StopFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm234.8 736.5L223.5 277.2c16-19.7 34-37.7 53.7-53.7l523.3 523.3c-16 19.6-34 37.7-53.7 53.7z" } }] }, "name": "stop", "theme": "filled" };
var StopFilledSvg = StopFilled$2;

var StopFilled = function StopFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: StopFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  StopFilled.displayName = 'StopFilled';
}
var StopFilled$1 = /*#__PURE__*/React__namespace.forwardRef(StopFilled);

// This icon file is generated automatically.
var StopOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372 0-89 31.3-170.8 83.5-234.8l523.3 523.3C682.8 852.7 601 884 512 884zm288.5-137.2L277.2 223.5C341.2 171.3 423 140 512 140c205.4 0 372 166.6 372 372 0 89-31.3 170.8-83.5 234.8z" } }] }, "name": "stop", "theme": "outlined" };
var StopOutlinedSvg = StopOutlined$2;

var StopOutlined = function StopOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: StopOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  StopOutlined.displayName = 'StopOutlined';
}
var StopOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(StopOutlined);

// This icon file is generated automatically.
var StopTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm288.5 682.8L277.7 224C258 240 240 258 224 277.7l522.8 522.8C682.8 852.7 601 884 512 884c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372c0 89-31.3 170.8-83.5 234.8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372c89 0 170.8-31.3 234.8-83.5L224 277.7c16-19.7 34-37.7 53.7-53.7l522.8 522.8C852.7 682.8 884 601 884 512c0-205.4-166.6-372-372-372z", "fill": secondaryColor } }] }; }, "name": "stop", "theme": "twotone" };
var StopTwoToneSvg = StopTwoTone$2;

var StopTwoTone = function StopTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: StopTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  StopTwoTone.displayName = 'StopTwoTone';
}
var StopTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(StopTwoTone);

// This icon file is generated automatically.
var StrikethroughOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M952 474H569.9c-10-2-20.5-4-31.6-6-15.9-2.9-22.2-4.1-30.8-5.8-51.3-10-82.2-20-106.8-34.2-35.1-20.5-52.2-48.3-52.2-85.1 0-37 15.2-67.7 44-89 28.4-21 68.8-32.1 116.8-32.1 54.8 0 97.1 14.4 125.8 42.8 14.6 14.4 25.3 32.1 31.8 52.6 1.3 4.1 2.8 10 4.3 17.8.9 4.8 5.2 8.2 9.9 8.2h72.8c5.6 0 10.1-4.6 10.1-10.1v-1c-.7-6.8-1.3-12.1-2-16-7.3-43.5-28-81.7-59.7-110.3-44.4-40.5-109.7-61.8-188.7-61.8-72.3 0-137.4 18.1-183.3 50.9-25.6 18.4-45.4 41.2-58.6 67.7-13.5 27.1-20.3 58.4-20.3 92.9 0 29.5 5.7 54.5 17.3 76.5 8.3 15.7 19.6 29.5 34.1 42H72c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h433.2c2.1.4 3.9.8 5.9 1.2 30.9 6.2 49.5 10.4 66.6 15.2 23 6.5 40.6 13.3 55.2 21.5 35.8 20.2 53.3 49.2 53.3 89 0 35.3-15.5 66.8-43.6 88.8-30.5 23.9-75.6 36.4-130.5 36.4-43.7 0-80.7-8.5-110.2-25-29.1-16.3-49.1-39.8-59.7-69.5-.8-2.2-1.7-5.2-2.7-9-1.2-4.4-5.3-7.5-9.7-7.5h-79.7c-5.6 0-10.1 4.6-10.1 10.1v1c.2 2.3.4 4.2.6 5.7 6.5 48.8 30.3 88.8 70.7 118.8 47.1 34.8 113.4 53.2 191.8 53.2 84.2 0 154.8-19.8 204.2-57.3 25-18.9 44.2-42.2 57.1-69 13-27.1 19.7-57.9 19.7-91.5 0-31.8-5.8-58.4-17.8-81.4-5.8-11.2-13.1-21.5-21.8-30.8H952c4.4 0 8-3.6 8-8v-60a8 8 0 00-8-7.9z" } }] }, "name": "strikethrough", "theme": "outlined" };
var StrikethroughOutlinedSvg = StrikethroughOutlined$2;

var StrikethroughOutlined = function StrikethroughOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: StrikethroughOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  StrikethroughOutlined.displayName = 'StrikethroughOutlined';
}
var StrikethroughOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(StrikethroughOutlined);

// This icon file is generated automatically.
var SubnodeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M688 240c-138 0-252 102.8-269.6 236H249a95.92 95.92 0 00-89-60c-53 0-96 43-96 96s43 96 96 96c40.3 0 74.8-24.8 89-60h169.3C436 681.2 550 784 688 784c150.2 0 272-121.8 272-272S838.2 240 688 240zm128 298c0 4.4-3.6 8-8 8h-86v86c0 4.4-3.6 8-8 8h-52c-4.4 0-8-3.6-8-8v-86h-86c-4.4 0-8-3.6-8-8v-52c0-4.4 3.6-8 8-8h86v-86c0-4.4 3.6-8 8-8h52c4.4 0 8 3.6 8 8v86h86c4.4 0 8 3.6 8 8v52z" } }] }, "name": "subnode", "theme": "outlined" };
var SubnodeOutlinedSvg = SubnodeOutlined$2;

var SubnodeOutlined = function SubnodeOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SubnodeOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SubnodeOutlined.displayName = 'SubnodeOutlined';
}
var SubnodeOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SubnodeOutlined);

// This icon file is generated automatically.
var SwapLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 572H266.8l144.3-183c4.1-5.2.4-13-6.3-13H340c-9.8 0-19.1 4.5-25.1 12.2l-164 208c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] }, "name": "swap-left", "theme": "outlined" };
var SwapLeftOutlinedSvg = SwapLeftOutlined$2;

var SwapLeftOutlined = function SwapLeftOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SwapLeftOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SwapLeftOutlined.displayName = 'SwapLeftOutlined';
}
var SwapLeftOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SwapLeftOutlined);

// This icon file is generated automatically.
var SwapOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] }, "name": "swap", "theme": "outlined" };
var SwapOutlinedSvg = SwapOutlined$2;

var SwapOutlined = function SwapOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SwapOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SwapOutlined.displayName = 'SwapOutlined';
}
var SwapOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SwapOutlined);

// This icon file is generated automatically.
var SwapRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M873.1 596.2l-164-208A32 32 0 00684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z" } }] }, "name": "swap-right", "theme": "outlined" };
var SwapRightOutlinedSvg = SwapRightOutlined$2;

var SwapRightOutlined = function SwapRightOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SwapRightOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SwapRightOutlined.displayName = 'SwapRightOutlined';
}
var SwapRightOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SwapRightOutlined);

// This icon file is generated automatically.
var SwitcherFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zM596 606c0 4.4-3.6 8-8 8H308c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h280c4.4 0 8 3.6 8 8v48zm284-494H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32z" } }] }, "name": "switcher", "theme": "filled" };
var SwitcherFilledSvg = SwitcherFilled$2;

var SwitcherFilled = function SwitcherFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SwitcherFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SwitcherFilled.displayName = 'SwitcherFilled';
}
var SwitcherFilled$1 = /*#__PURE__*/React__namespace.forwardRef(SwitcherFilled);

// This icon file is generated automatically.
var SwitcherOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zm-40 600H184V312h528v528zm168-728H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32zM300 550h296v64H300z" } }] }, "name": "switcher", "theme": "outlined" };
var SwitcherOutlinedSvg = SwitcherOutlined$2;

var SwitcherOutlined = function SwitcherOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SwitcherOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SwitcherOutlined.displayName = 'SwitcherOutlined';
}
var SwitcherOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SwitcherOutlined);

// This icon file is generated automatically.
var SwitcherTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M184 840h528V312H184v528zm116-290h296v64H300v-64z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 112H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zm-40 600H184V312h528v528z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M300 550h296v64H300z", "fill": primaryColor } }] }; }, "name": "switcher", "theme": "twotone" };
var SwitcherTwoToneSvg = SwitcherTwoTone$2;

var SwitcherTwoTone = function SwitcherTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SwitcherTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SwitcherTwoTone.displayName = 'SwitcherTwoTone';
}
var SwitcherTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(SwitcherTwoTone);

// This icon file is generated automatically.
var SyncOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M168 504.2c1-43.7 10-86.1 26.9-126 17.3-41 42.1-77.7 73.7-109.4S337 212.3 378 195c42.4-17.9 87.4-27 133.9-27s91.5 9.1 133.8 27A341.5 341.5 0 01755 268.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 003 14.1l175.7 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c0-6.7-7.7-10.5-12.9-6.3l-56.4 44.1C765.8 155.1 646.2 92 511.8 92 282.7 92 96.3 275.6 92 503.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8zm756 7.8h-60c-4.4 0-7.9 3.5-8 7.8-1 43.7-10 86.1-26.9 126-17.3 41-42.1 77.8-73.7 109.4A342.45 342.45 0 01512.1 856a342.24 342.24 0 01-243.2-100.8c-9.9-9.9-19.2-20.4-27.8-31.4l60.2-47a8 8 0 00-3-14.1l-175.7-43c-5-1.2-9.9 2.6-9.9 7.7l-.7 181c0 6.7 7.7 10.5 12.9 6.3l56.4-44.1C258.2 868.9 377.8 932 512.2 932c229.2 0 415.5-183.7 419.8-411.8a8 8 0 00-8-8.2z" } }] }, "name": "sync", "theme": "outlined" };
var SyncOutlinedSvg = SyncOutlined$2;

var SyncOutlined = function SyncOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SyncOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  SyncOutlined.displayName = 'SyncOutlined';
}
var SyncOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(SyncOutlined);

// This icon file is generated automatically.
var TableOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 208H676V232h212v136zm0 224H676V432h212v160zM412 432h200v160H412V432zm200-64H412V232h200v136zm-476 64h212v160H136V432zm0-200h212v136H136V232zm0 424h212v136H136V656zm276 0h200v136H412V656zm476 136H676V656h212v136z" } }] }, "name": "table", "theme": "outlined" };
var TableOutlinedSvg = TableOutlined$2;

var TableOutlined = function TableOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TableOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  TableOutlined.displayName = 'TableOutlined';
}
var TableOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(TableOutlined);

// This icon file is generated automatically.
var TabletFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM512 824c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z" } }] }, "name": "tablet", "theme": "filled" };
var TabletFilledSvg = TabletFilled$2;

var TabletFilled = function TabletFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TabletFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  TabletFilled.displayName = 'TabletFilled';
}
var TabletFilled$1 = /*#__PURE__*/React__namespace.forwardRef(TabletFilled);

// This icon file is generated automatically.
var TabletOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H232V136h560v752zM472 784a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "tablet", "theme": "outlined" };
var TabletOutlinedSvg = TabletOutlined$2;

var TabletOutlined = function TabletOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TabletOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  TabletOutlined.displayName = 'TabletOutlined';
}
var TabletOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(TabletOutlined);

// This icon file is generated automatically.
var TabletTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H232V136h560v752z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M232 888h560V136H232v752zm280-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M472 784a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }] }; }, "name": "tablet", "theme": "twotone" };
var TabletTwoToneSvg = TabletTwoTone$2;

var TabletTwoTone = function TabletTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TabletTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  TabletTwoTone.displayName = 'TabletTwoTone';
}
var TabletTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(TabletTwoTone);

// This icon file is generated automatically.
var TagFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 000 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM699 387c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z" } }] }, "name": "tag", "theme": "filled" };
var TagFilledSvg = TagFilled$2;

var TagFilled = function TagFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TagFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  TagFilled.displayName = 'TagFilled';
}
var TagFilled$1 = /*#__PURE__*/React__namespace.forwardRef(TagFilled);

// This icon file is generated automatically.
var TagOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 000 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7zM680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z" } }] }, "name": "tag", "theme": "outlined" };
var TagOutlinedSvg = TagOutlined$2;

var TagOutlined = function TagOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TagOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  TagOutlined.displayName = 'TagOutlined';
}
var TagOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(TagOutlined);

// This icon file is generated automatically.
var TagTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M589 164.6L189.3 564.3l270.4 270.4L859.4 435 836 188l-247-23.4zM680 432c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 000 14.1l363.8 363.8a9.9 9.9 0 007.1 2.9c2.7 0 5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7z", "fill": primaryColor } }] }; }, "name": "tag", "theme": "twotone" };
var TagTwoToneSvg = TagTwoTone$2;

var TagTwoTone = function TagTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TagTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  TagTwoTone.displayName = 'TagTwoTone';
}
var TagTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(TagTwoTone);

// This icon file is generated automatically.
var TagsFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M483.2 790.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3c-2.3-.2-4.7.6-6.3 2.3L137.7 444.8a8.03 8.03 0 000 11.3l334.2 334.2c3.1 3.2 8.2 3.2 11.3 0zm122.7-533.4c18.7-18.7 49.1-18.7 67.9 0 18.7 18.7 18.7 49.1 0 67.9-18.7 18.7-49.1 18.7-67.9 0-18.7-18.7-18.7-49.1 0-67.9zm283.8 282.9l-39.6-39.5a8.03 8.03 0 00-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 00-11.3 0l-39.6 39.5a8.03 8.03 0 000 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3z" } }] }, "name": "tags", "theme": "filled" };
var TagsFilledSvg = TagsFilled$2;

var TagsFilled = function TagsFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TagsFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  TagsFilled.displayName = 'TagsFilled';
}
var TagsFilled$1 = /*#__PURE__*/React__namespace.forwardRef(TagsFilled);

// This icon file is generated automatically.
var TagsOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M483.2 790.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3c-2.3-.2-4.7.6-6.3 2.3L137.7 444.8a8.03 8.03 0 000 11.3l334.2 334.2c3.1 3.2 8.2 3.2 11.3 0zm62.6-651.7l224.6 19 19 224.6L477.5 694 233.9 450.5l311.9-311.9zm60.16 186.23a48 48 0 1067.88-67.89 48 48 0 10-67.88 67.89zM889.7 539.8l-39.6-39.5a8.03 8.03 0 00-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 00-11.3 0l-39.6 39.5a8.03 8.03 0 000 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3z" } }] }, "name": "tags", "theme": "outlined" };
var TagsOutlinedSvg = TagsOutlined$2;

var TagsOutlined = function TagsOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TagsOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  TagsOutlined.displayName = 'TagsOutlined';
}
var TagsOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(TagsOutlined);

// This icon file is generated automatically.
var TagsTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M477.5 694l311.9-311.8-19-224.6-224.6-19-311.9 311.9L477.5 694zm116-415.5a47.81 47.81 0 0133.9-33.9c16.6-4.4 34.2.3 46.4 12.4a47.93 47.93 0 0112.4 46.4 47.81 47.81 0 01-33.9 33.9c-16.6 4.4-34.2-.3-46.4-12.4a48.3 48.3 0 01-12.4-46.4z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M476.6 792.6c-1.7-.2-3.4-1-4.7-2.3L137.7 456.1a8.03 8.03 0 010-11.3L515.9 66.6c1.2-1.3 2.9-2.1 4.7-2.3h-.4c-2.3-.2-4.7.6-6.3 2.3L135.7 444.8a8.03 8.03 0 000 11.3l334.2 334.2c1.8 1.9 4.3 2.6 6.7 2.3z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M889.7 539.8l-39.6-39.5a8.03 8.03 0 00-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 00-11.3 0l-39.6 39.5a8.03 8.03 0 000 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3zM652.3 337.3a47.81 47.81 0 0033.9-33.9c4.4-16.6-.3-34.2-12.4-46.4a47.93 47.93 0 00-46.4-12.4 47.81 47.81 0 00-33.9 33.9c-4.4 16.6.3 34.2 12.4 46.4a48.3 48.3 0 0046.4 12.4z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M137.7 444.8a8.03 8.03 0 000 11.3l334.2 334.2c1.3 1.3 2.9 2.1 4.7 2.3 2.4.3 4.8-.5 6.6-2.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3h-1.6c-1.8.2-3.4 1-4.7 2.3L137.7 444.8zm408.1-306.2l224.6 19 19 224.6L477.5 694 233.9 450.5l311.9-311.9z", "fill": primaryColor } }] }; }, "name": "tags", "theme": "twotone" };
var TagsTwoToneSvg = TagsTwoTone$2;

var TagsTwoTone = function TagsTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TagsTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  TagsTwoTone.displayName = 'TagsTwoTone';
}
var TagsTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(TagsTwoTone);

// This icon file is generated automatically.
var TaobaoCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 110-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z" } }] }, "name": "taobao-circle", "theme": "filled" };
var TaobaoCircleFilledSvg = TaobaoCircleFilled$2;

var TaobaoCircleFilled = function TaobaoCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TaobaoCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  TaobaoCircleFilled.displayName = 'TaobaoCircleFilled';
}
var TaobaoCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(TaobaoCircleFilled);

// This icon file is generated automatically.
var TaobaoCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 110-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z" } }] }, "name": "taobao-circle", "theme": "outlined" };
var TaobaoCircleOutlinedSvg = TaobaoCircleOutlined$2;

var TaobaoCircleOutlined = function TaobaoCircleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TaobaoCircleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  TaobaoCircleOutlined.displayName = 'TaobaoCircleOutlined';
}
var TaobaoCircleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(TaobaoCircleOutlined);

// This icon file is generated automatically.
var TaobaoOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M168.5 273.7a68.7 68.7 0 10137.4 0 68.7 68.7 0 10-137.4 0zm730 79.2s-23.7-184.4-426.9-70.1c17.3-30 25.6-49.5 25.6-49.5L396.4 205s-40.6 132.6-113 194.4c0 0 70.1 40.6 69.4 39.4 20.1-20.1 38.2-40.6 53.7-60.4 16.1-7 31.5-13.6 46.7-19.8-18.6 33.5-48.7 83.8-78.8 115.6l42.4 37s28.8-27.7 60.4-61.2h36v61.8H372.9v49.5h140.3v118.5c-1.7 0-3.6 0-5.4-.2-15.4-.7-39.5-3.3-49-18.2-11.5-18.1-3-51.5-2.4-71.9h-97l-3.4 1.8s-35.5 159.1 102.3 155.5c129.1 3.6 203-36 238.6-63.1l14.2 52.6 79.6-33.2-53.9-131.9-64.6 20.1 12.1 45.2c-16.6 12.4-35.6 21.7-56.2 28.4V561.3h137.1v-49.5H628.1V450h137.6v-49.5H521.3c17.6-21.4 31.5-41.1 35-53.6l-42.5-11.6c182.8-65.5 284.5-54.2 283.6 53.2v282.8s10.8 97.1-100.4 90.1l-60.2-12.9-14.2 57.1S882.5 880 903.7 680.2c21.3-200-5.2-327.3-5.2-327.3zm-707.4 18.3l-45.4 69.7 83.6 52.1s56 28.5 29.4 81.9C233.8 625.5 112 736.3 112 736.3l109 68.1c75.4-163.7 70.5-142 89.5-200.7 19.5-60.1 23.7-105.9-9.4-139.1-42.4-42.6-47-46.6-110-93.4z" } }] }, "name": "taobao", "theme": "outlined" };
var TaobaoOutlinedSvg = TaobaoOutlined$2;

var TaobaoOutlined = function TaobaoOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TaobaoOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  TaobaoOutlined.displayName = 'TaobaoOutlined';
}
var TaobaoOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(TaobaoOutlined);

// This icon file is generated automatically.
var TaobaoSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 110-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z" } }] }, "name": "taobao-square", "theme": "filled" };
var TaobaoSquareFilledSvg = TaobaoSquareFilled$2;

var TaobaoSquareFilled = function TaobaoSquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TaobaoSquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  TaobaoSquareFilled.displayName = 'TaobaoSquareFilled';
}
var TaobaoSquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(TaobaoSquareFilled);

// This icon file is generated automatically.
var TeamOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M824.2 699.9a301.55 301.55 0 00-86.4-60.4C783.1 602.8 812 546.8 812 484c0-110.8-92.4-201.7-203.2-200-109.1 1.7-197 90.6-197 200 0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 00-86.4 60.4C345 754.6 314 826.8 312 903.8a8 8 0 008 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5A226.62 226.62 0 01612 684c60.9 0 118.2 23.7 161.3 66.8C814.5 792 838 846.3 840 904.3c.1 4.3 3.7 7.7 8 7.7h56a8 8 0 008-8.2c-2-77-33-149.2-87.8-203.9zM612 612c-34.2 0-66.4-13.3-90.5-37.5a126.86 126.86 0 01-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4 0 34.2-13.3 66.3-37.5 90.5A127.3 127.3 0 01612 612zM361.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 01-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 008 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7z" } }] }, "name": "team", "theme": "outlined" };
var TeamOutlinedSvg = TeamOutlined$2;

var TeamOutlined = function TeamOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TeamOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  TeamOutlined.displayName = 'TeamOutlined';
}
var TeamOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(TeamOutlined);

// This icon file is generated automatically.
var ThunderboltFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7z" } }] }, "name": "thunderbolt", "theme": "filled" };
var ThunderboltFilledSvg = ThunderboltFilled$2;

var ThunderboltFilled = function ThunderboltFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ThunderboltFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ThunderboltFilled.displayName = 'ThunderboltFilled';
}
var ThunderboltFilled$1 = /*#__PURE__*/React__namespace.forwardRef(ThunderboltFilled);

// This icon file is generated automatically.
var ThunderboltOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7zM378.2 732.5l60.3-241H281.1l189.6-327.4h224.6L487 427.4h211L378.2 732.5z" } }] }, "name": "thunderbolt", "theme": "outlined" };
var ThunderboltOutlinedSvg = ThunderboltOutlined$2;

var ThunderboltOutlined = function ThunderboltOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ThunderboltOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ThunderboltOutlined.displayName = 'ThunderboltOutlined';
}
var ThunderboltOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ThunderboltOutlined);

// This icon file is generated automatically.
var ThunderboltTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M695.4 164.1H470.8L281.2 491.5h157.4l-60.3 241 319.8-305.1h-211z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M848.1 359.3H627.8L825.9 109c4.1-5.3.4-13-6.3-13H436.1c-2.8 0-5.5 1.5-6.9 4L170.1 547.5c-3.1 5.3.7 12 6.9 12h174.4L262 917.1c-1.9 7.8 7.5 13.3 13.3 7.7L853.6 373c5.2-4.9 1.7-13.7-5.5-13.7zM378.3 732.5l60.3-241H281.2l189.6-327.4h224.6L487.1 427.4h211L378.3 732.5z", "fill": primaryColor } }] }; }, "name": "thunderbolt", "theme": "twotone" };
var ThunderboltTwoToneSvg = ThunderboltTwoTone$2;

var ThunderboltTwoTone = function ThunderboltTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ThunderboltTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ThunderboltTwoTone.displayName = 'ThunderboltTwoTone';
}
var ThunderboltTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(ThunderboltTwoTone);

// This icon file is generated automatically.
var ToTopOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M885 780H165c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM400 325.7h73.9V664c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V325.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 171a8 8 0 00-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13z" } }] }, "name": "to-top", "theme": "outlined" };
var ToTopOutlinedSvg = ToTopOutlined$2;

var ToTopOutlined = function ToTopOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ToTopOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ToTopOutlined.displayName = 'ToTopOutlined';
}
var ToTopOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ToTopOutlined);

// This icon file is generated automatically.
var ToolFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M865.3 244.7c-.3-.3-61.1 59.8-182.1 180.6l-84.9-84.9 180.9-180.9c-95.2-57.3-217.5-42.6-296.8 36.7A244.42 244.42 0 00419 432l1.8 6.7-283.5 283.4c-6.2 6.2-6.2 16.4 0 22.6l141.4 141.4c6.2 6.2 16.4 6.2 22.6 0l283.3-283.3 6.7 1.8c83.7 22.3 173.6-.9 236-63.3 79.4-79.3 94.1-201.6 38-296.6z" } }] }, "name": "tool", "theme": "filled" };
var ToolFilledSvg = ToolFilled$2;

var ToolFilled = function ToolFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ToolFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ToolFilled.displayName = 'ToolFilled';
}
var ToolFilled$1 = /*#__PURE__*/React__namespace.forwardRef(ToolFilled);

// This icon file is generated automatically.
var ToolOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M876.6 239.5c-.5-.9-1.2-1.8-2-2.5-5-5-13.1-5-18.1 0L684.2 409.3l-67.9-67.9L788.7 169c.8-.8 1.4-1.6 2-2.5 3.6-6.1 1.6-13.9-4.5-17.5-98.2-58-226.8-44.7-311.3 39.7-67 67-89.2 162-66.5 247.4l-293 293c-3 3-2.8 7.9.3 11l169.7 169.7c3.1 3.1 8.1 3.3 11 .3l292.9-292.9c85.5 22.8 180.5.7 247.6-66.4 84.4-84.5 97.7-213.1 39.7-311.3zM786 499.8c-58.1 58.1-145.3 69.3-214.6 33.6l-8.8 8.8-.1-.1-274 274.1-79.2-79.2 230.1-230.1s0 .1.1.1l52.8-52.8c-35.7-69.3-24.5-156.5 33.6-214.6a184.2 184.2 0 01144-53.5L537 318.9a32.05 32.05 0 000 45.3l124.5 124.5a32.05 32.05 0 0045.3 0l132.8-132.8c3.7 51.8-14.4 104.8-53.6 143.9z" } }] }, "name": "tool", "theme": "outlined" };
var ToolOutlinedSvg = ToolOutlined$2;

var ToolOutlined = function ToolOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ToolOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ToolOutlined.displayName = 'ToolOutlined';
}
var ToolOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ToolOutlined);

// This icon file is generated automatically.
var ToolTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M706.8 488.7a32.05 32.05 0 01-45.3 0L537 364.2a32.05 32.05 0 010-45.3l132.9-132.8a184.2 184.2 0 00-144 53.5c-58.1 58.1-69.3 145.3-33.6 214.6L439.5 507c-.1 0-.1-.1-.1-.1L209.3 737l79.2 79.2 274-274.1.1.1 8.8-8.8c69.3 35.7 156.5 24.5 214.6-33.6 39.2-39.1 57.3-92.1 53.6-143.9L706.8 488.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M876.6 239.5c-.5-.9-1.2-1.8-2-2.5-5-5-13.1-5-18.1 0L684.2 409.3l-67.9-67.9L788.7 169c.8-.8 1.4-1.6 2-2.5 3.6-6.1 1.6-13.9-4.5-17.5-98.2-58-226.8-44.7-311.3 39.7-67 67-89.2 162-66.5 247.4l-293 293c-3 3-2.8 7.9.3 11l169.7 169.7c3.1 3.1 8.1 3.3 11 .3l292.9-292.9c85.5 22.8 180.5.7 247.6-66.4 84.4-84.5 97.7-213.1 39.7-311.3zM786 499.8c-58.1 58.1-145.3 69.3-214.6 33.6l-8.8 8.8-.1-.1-274 274.1-79.2-79.2 230.1-230.1s0 .1.1.1l52.8-52.8c-35.7-69.3-24.5-156.5 33.6-214.6a184.2 184.2 0 01144-53.5L537 318.9a32.05 32.05 0 000 45.3l124.5 124.5a32.05 32.05 0 0045.3 0l132.8-132.8c3.7 51.8-14.4 104.8-53.6 143.9z", "fill": primaryColor } }] }; }, "name": "tool", "theme": "twotone" };
var ToolTwoToneSvg = ToolTwoTone$2;

var ToolTwoTone = function ToolTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ToolTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ToolTwoTone.displayName = 'ToolTwoTone';
}
var ToolTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(ToolTwoTone);

// This icon file is generated automatically.
var TrademarkCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm164.7 660.2c-1.1.5-2.3.8-3.5.8h-62c-3.1 0-5.9-1.8-7.2-4.6l-74.6-159.2h-88.7V717c0 4.4-3.6 8-8 8H378c-4.4 0-8-3.6-8-8V307c0-4.4 3.6-8 8-8h155.6c98.8 0 144.2 59.9 144.2 131.1 0 70.2-43.6 106.4-78.4 119.2l80.8 164.2c2.1 3.9.4 8.7-3.5 10.7zM523.9 357h-83.4v148H522c53 0 82.8-25.6 82.8-72.4 0-50.3-32.9-75.6-80.9-75.6z" } }] }, "name": "trademark-circle", "theme": "filled" };
var TrademarkCircleFilledSvg = TrademarkCircleFilled$2;

var TrademarkCircleFilled = function TrademarkCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TrademarkCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  TrademarkCircleFilled.displayName = 'TrademarkCircleFilled';
}
var TrademarkCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(TrademarkCircleFilled);

// This icon file is generated automatically.
var TrademarkCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm87.5-334.7c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.5-131.1-144.2-131.1H378c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.5c4.4 0 8-3.6 8-8V561.2h88.7l74.6 159.2c1.3 2.8 4.1 4.6 7.2 4.6h62a7.9 7.9 0 007.1-11.5l-80.6-164.2zM522 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.5 0 46.9-29.8 72.5-82.8 72.5z" } }] }, "name": "trademark-circle", "theme": "outlined" };
var TrademarkCircleOutlinedSvg = TrademarkCircleOutlined$2;

var TrademarkCircleOutlined = function TrademarkCircleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TrademarkCircleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  TrademarkCircleOutlined.displayName = 'TrademarkCircleOutlined';
}
var TrademarkCircleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(TrademarkCircleOutlined);

// This icon file is generated automatically.
var TrademarkCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm170.7 584.2c-1.1.5-2.3.8-3.5.8h-62c-3.1 0-5.9-1.8-7.2-4.6l-74.6-159.2h-88.7V717c0 4.4-3.6 8-8 8H384c-4.4 0-8-3.6-8-8V307c0-4.4 3.6-8 8-8h155.6c98.8 0 144.2 59.9 144.2 131.1 0 70.2-43.6 106.4-78.4 119.2l80.8 164.2c2.1 3.9.4 8.7-3.5 10.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M529.9 357h-83.4v148H528c53 0 82.8-25.6 82.8-72.4 0-50.3-32.9-75.6-80.9-75.6z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M605.4 549.3c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.4-131.1-144.2-131.1H384c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.7c4.4 0 8-3.6 8-8V561.2h88.7L610 720.4c1.3 2.8 4.1 4.6 7.2 4.6h62c1.2 0 2.4-.3 3.5-.8 3.9-2 5.6-6.8 3.5-10.7l-80.8-164.2zM528 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.6 0 46.8-29.8 72.4-82.8 72.4z", "fill": primaryColor } }] }; }, "name": "trademark-circle", "theme": "twotone" };
var TrademarkCircleTwoToneSvg = TrademarkCircleTwoTone$2;

var TrademarkCircleTwoTone = function TrademarkCircleTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TrademarkCircleTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  TrademarkCircleTwoTone.displayName = 'TrademarkCircleTwoTone';
}
var TrademarkCircleTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(TrademarkCircleTwoTone);

// This icon file is generated automatically.
var TrademarkOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm87.5-334.7c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.5-131.1-144.2-131.1H378c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.5c4.4 0 8-3.6 8-8V561.2h88.7l74.6 159.2c1.3 2.8 4.1 4.6 7.2 4.6h62a7.9 7.9 0 007.1-11.5l-80.6-164.2zM522 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.5 0 46.9-29.8 72.5-82.8 72.5z" } }] }, "name": "trademark", "theme": "outlined" };
var TrademarkOutlinedSvg = TrademarkOutlined$2;

var TrademarkOutlined = function TrademarkOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TrademarkOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  TrademarkOutlined.displayName = 'TrademarkOutlined';
}
var TrademarkOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(TrademarkOutlined);

// This icon file is generated automatically.
var TransactionOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M668.6 320c0-4.4-3.6-8-8-8h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 00-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.5-1.1.9-2.4.9-3.7zM157.9 504.2a352.7 352.7 0 01103.5-242.4c32.5-32.5 70.3-58.1 112.4-75.9 43.6-18.4 89.9-27.8 137.6-27.8 47.8 0 94.1 9.3 137.6 27.8 42.1 17.8 79.9 43.4 112.4 75.9 10 10 19.3 20.5 27.9 31.4l-50 39.1a8 8 0 003 14.1l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3l-47.8 37.4C770.7 146.3 648.6 82 511.5 82 277 82 86.3 270.1 82 503.8a8 8 0 008 8.2h60c4.3 0 7.8-3.5 7.9-7.8zM934 512h-60c-4.3 0-7.9 3.5-8 7.8a352.7 352.7 0 01-103.5 242.4 352.57 352.57 0 01-112.4 75.9c-43.6 18.4-89.9 27.8-137.6 27.8s-94.1-9.3-137.6-27.8a352.57 352.57 0 01-112.4-75.9c-10-10-19.3-20.5-27.9-31.4l49.9-39.1a8 8 0 00-3-14.1l-156.8-38.3c-5-1.2-9.9 2.6-9.9 7.7l-.8 161.7c0 6.7 7.7 10.5 12.9 6.3l47.8-37.4C253.3 877.7 375.4 942 512.5 942 747 942 937.7 753.9 942 520.2a8 8 0 00-8-8.2z" } }] }, "name": "transaction", "theme": "outlined" };
var TransactionOutlinedSvg = TransactionOutlined$2;

var TransactionOutlined = function TransactionOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TransactionOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  TransactionOutlined.displayName = 'TransactionOutlined';
}
var TransactionOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(TransactionOutlined);

// This icon file is generated automatically.
var TranslationOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M140 188h584v164h76V144c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h544v-76H140V188z" } }, { "tag": "path", "attrs": { "d": "M414.3 256h-60.6c-3.4 0-6.4 2.2-7.6 5.4L219 629.4c-.3.8-.4 1.7-.4 2.6 0 4.4 3.6 8 8 8h55.1c3.4 0 6.4-2.2 7.6-5.4L322 540h196.2L422 261.4a8.42 8.42 0 00-7.7-5.4zm12.4 228h-85.5L384 360.2 426.7 484zM936 528H800v-93c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v93H592c-13.3 0-24 10.7-24 24v176c0 13.3 10.7 24 24 24h136v152c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V752h136c13.3 0 24-10.7 24-24V552c0-13.3-10.7-24-24-24zM728 680h-88v-80h88v80zm160 0h-88v-80h88v80z" } }] }, "name": "translation", "theme": "outlined" };
var TranslationOutlinedSvg = TranslationOutlined$2;

var TranslationOutlined = function TranslationOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TranslationOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  TranslationOutlined.displayName = 'TranslationOutlined';
}
var TranslationOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(TranslationOutlined);

// This icon file is generated automatically.
var TrophyFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 00-44 44v148c0 81.7 60 149.6 138.2 162C265.6 630.2 359 721.8 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.8 758.4 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 00-44-44zM248 439.6c-37.1-11.9-64-46.7-64-87.6V232h64v207.6zM840 352c0 41-26.9 75.8-64 87.6V232h64v120z" } }] }, "name": "trophy", "theme": "filled" };
var TrophyFilledSvg = TrophyFilled$2;

var TrophyFilled = function TrophyFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TrophyFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  TrophyFilled.displayName = 'TrophyFilled';
}
var TrophyFilled$1 = /*#__PURE__*/React__namespace.forwardRef(TrophyFilled);

// This icon file is generated automatically.
var TrophyOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 00-44 44v148c0 81.7 60 149.6 138.2 162C265.7 630.2 359 721.7 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.7 758.3 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 00-44-44zM184 352V232h64v207.6a91.99 91.99 0 01-64-87.6zm520 128c0 49.1-19.1 95.4-53.9 130.1-34.8 34.8-81 53.9-130.1 53.9h-16c-49.1 0-95.4-19.1-130.1-53.9-34.8-34.8-53.9-81-53.9-130.1V184h384v296zm136-128c0 41-26.9 75.8-64 87.6V232h64v120z" } }] }, "name": "trophy", "theme": "outlined" };
var TrophyOutlinedSvg = TrophyOutlined$2;

var TrophyOutlined = function TrophyOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TrophyOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  TrophyOutlined.displayName = 'TrophyOutlined';
}
var TrophyOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(TrophyOutlined);

// This icon file is generated automatically.
var TrophyTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M320 480c0 49.1 19.1 95.3 53.9 130.1 34.7 34.8 81 53.9 130.1 53.9h16c49.1 0 95.3-19.1 130.1-53.9 34.8-34.7 53.9-81 53.9-130.1V184H320v296zM184 352c0 41 26.9 75.8 64 87.6-37.1-11.9-64-46.7-64-87.6zm364 382.5C665 721.8 758.4 630.2 773.8 514 758.3 630.2 665 721.7 548 734.5zM250.2 514C265.6 630.2 359 721.8 476 734.5 359 721.7 265.7 630.2 250.2 514z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 00-44 44v148c0 81.7 60 149.6 138.2 162C265.7 630.2 359 721.7 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.7 758.3 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 00-44-44zM248 439.6a91.99 91.99 0 01-64-87.6V232h64v207.6zM704 480c0 49.1-19.1 95.4-53.9 130.1-34.8 34.8-81 53.9-130.1 53.9h-16c-49.1 0-95.4-19.1-130.1-53.9-34.8-34.8-53.9-81-53.9-130.1V184h384v296zm136-128c0 41-26.9 75.8-64 87.6V232h64v120z", "fill": primaryColor } }] }; }, "name": "trophy", "theme": "twotone" };
var TrophyTwoToneSvg = TrophyTwoTone$2;

var TrophyTwoTone = function TrophyTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TrophyTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  TrophyTwoTone.displayName = 'TrophyTwoTone';
}
var TrophyTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(TrophyTwoTone);

// This icon file is generated automatically.
var TwitterCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm215.3 337.7c.3 4.7.3 9.6.3 14.4 0 146.8-111.8 315.9-316.1 315.9-63 0-121.4-18.3-170.6-49.8 9 1 17.6 1.4 26.8 1.4 52 0 99.8-17.6 137.9-47.4-48.8-1-89.8-33-103.8-77 17.1 2.5 32.5 2.5 50.1-2a111 111 0 01-88.9-109v-1.4c14.7 8.3 32 13.4 50.1 14.1a111.13 111.13 0 01-49.5-92.4c0-20.7 5.4-39.6 15.1-56a315.28 315.28 0 00229 116.1C492 353.1 548.4 292 616.2 292c32 0 60.8 13.4 81.1 35 25.1-4.7 49.1-14.1 70.5-26.7-8.3 25.7-25.7 47.4-48.8 61.1 22.4-2.4 44-8.6 64-17.3-15.1 22.2-34 41.9-55.7 57.6z" } }] }, "name": "twitter-circle", "theme": "filled" };
var TwitterCircleFilledSvg = TwitterCircleFilled$2;

var TwitterCircleFilled = function TwitterCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TwitterCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  TwitterCircleFilled.displayName = 'TwitterCircleFilled';
}
var TwitterCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(TwitterCircleFilled);

// This icon file is generated automatically.
var TwitterOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 254.3c-30.6 13.2-63.9 22.7-98.2 26.4a170.1 170.1 0 0075-94 336.64 336.64 0 01-108.2 41.2A170.1 170.1 0 00672 174c-94.5 0-170.5 76.6-170.5 170.6 0 13.2 1.6 26.4 4.2 39.1-141.5-7.4-267.7-75-351.6-178.5a169.32 169.32 0 00-23.2 86.1c0 59.2 30.1 111.4 76 142.1a172 172 0 01-77.1-21.7v2.1c0 82.9 58.6 151.6 136.7 167.4a180.6 180.6 0 01-44.9 5.8c-11.1 0-21.6-1.1-32.2-2.6C211 652 273.9 701.1 348.8 702.7c-58.6 45.9-132 72.9-211.7 72.9-14.3 0-27.5-.5-41.2-2.1C171.5 822 261.2 850 357.8 850 671.4 850 843 590.2 843 364.7c0-7.4 0-14.8-.5-22.2 33.2-24.3 62.3-54.4 85.5-88.2z" } }] }, "name": "twitter", "theme": "outlined" };
var TwitterOutlinedSvg = TwitterOutlined$2;

var TwitterOutlined = function TwitterOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TwitterOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  TwitterOutlined.displayName = 'TwitterOutlined';
}
var TwitterOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(TwitterOutlined);

// This icon file is generated automatically.
var TwitterSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM727.3 401.7c.3 4.7.3 9.6.3 14.4 0 146.8-111.8 315.9-316.1 315.9-63 0-121.4-18.3-170.6-49.8 9 1 17.6 1.4 26.8 1.4 52 0 99.8-17.6 137.9-47.4-48.8-1-89.8-33-103.8-77 17.1 2.5 32.5 2.5 50.1-2a111 111 0 01-88.9-109v-1.4c14.7 8.3 32 13.4 50.1 14.1a111.13 111.13 0 01-49.5-92.4c0-20.7 5.4-39.6 15.1-56a315.28 315.28 0 00229 116.1C492 353.1 548.4 292 616.2 292c32 0 60.8 13.4 81.1 35 25.1-4.7 49.1-14.1 70.5-26.7-8.3 25.7-25.7 47.4-48.8 61.1 22.4-2.4 44-8.6 64-17.3-15.1 22.2-34 41.9-55.7 57.6z" } }] }, "name": "twitter-square", "theme": "filled" };
var TwitterSquareFilledSvg = TwitterSquareFilled$2;

var TwitterSquareFilled = function TwitterSquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TwitterSquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  TwitterSquareFilled.displayName = 'TwitterSquareFilled';
}
var TwitterSquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(TwitterSquareFilled);

// This icon file is generated automatically.
var UnderlineOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M824 804H200c-4.4 0-8 3.4-8 7.6v60.8c0 4.2 3.6 7.6 8 7.6h624c4.4 0 8-3.4 8-7.6v-60.8c0-4.2-3.6-7.6-8-7.6zm-312-76c69.4 0 134.6-27.1 183.8-76.2C745 602.7 772 537.4 772 468V156c0-6.6-5.4-12-12-12h-60c-6.6 0-12 5.4-12 12v312c0 97-79 176-176 176s-176-79-176-176V156c0-6.6-5.4-12-12-12h-60c-6.6 0-12 5.4-12 12v312c0 69.4 27.1 134.6 76.2 183.8C377.3 701 442.6 728 512 728z" } }] }, "name": "underline", "theme": "outlined" };
var UnderlineOutlinedSvg = UnderlineOutlined$2;

var UnderlineOutlined = function UnderlineOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UnderlineOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  UnderlineOutlined.displayName = 'UnderlineOutlined';
}
var UnderlineOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(UnderlineOutlined);

// This icon file is generated automatically.
var UndoOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M511.4 124C290.5 124.3 112 303 112 523.9c0 128 60.2 242 153.8 315.2l-37.5 48c-4.1 5.3-.3 13 6.3 12.9l167-.8c5.2 0 9-4.9 7.7-9.9L369.8 727a8 8 0 00-14.1-3L315 776.1c-10.2-8-20-16.7-29.3-26a318.64 318.64 0 01-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 01-68.6 101.7c-7.5 7.5-15.3 14.5-23.4 21.2a7.93 7.93 0 00-1.2 11.1l39.4 50.5c2.8 3.5 7.9 4.1 11.4 1.3C854.5 760.8 912 649.1 912 523.9c0-221.1-179.4-400.2-400.6-399.9z" } }] }, "name": "undo", "theme": "outlined" };
var UndoOutlinedSvg = UndoOutlined$2;

var UndoOutlined = function UndoOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UndoOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  UndoOutlined.displayName = 'UndoOutlined';
}
var UndoOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(UndoOutlined);

// This icon file is generated automatically.
var UngroupOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M736 550H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V566c0-8.8-7.2-16-16-16zm-56 136H344v-64h336v64zm208 130c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zM736 266H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V282c0-8.8-7.2-16-16-16zm-56 136H344v-64h336v64zm208-194c39.8 0 72-32.2 72-72s-32.2-72-72-72-72 32.2-72 72 32.2 72 72 72zm0-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zM136 64c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0 656c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z" } }] }, "name": "ungroup", "theme": "outlined" };
var UngroupOutlinedSvg = UngroupOutlined$2;

var UngroupOutlined = function UngroupOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UngroupOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  UngroupOutlined.displayName = 'UngroupOutlined';
}
var UngroupOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(UngroupOutlined);

// This icon file is generated automatically.
var UnlockFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1156 0z" } }] }, "name": "unlock", "theme": "filled" };
var UnlockFilledSvg = UnlockFilled$2;

var UnlockFilled = function UnlockFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UnlockFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  UnlockFilled.displayName = 'UnlockFilled';
}
var UnlockFilled$1 = /*#__PURE__*/React__namespace.forwardRef(UnlockFilled);

// This icon file is generated automatically.
var UnlockOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zm-40 376H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z" } }] }, "name": "unlock", "theme": "outlined" };
var UnlockOutlinedSvg = UnlockOutlined$2;

var UnlockOutlined = function UnlockOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UnlockOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  UnlockOutlined.displayName = 'UnlockOutlined';
}
var UnlockOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(UnlockOutlined);

// This icon file is generated automatically.
var UnlockTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M232 840h560V536H232v304zm280-226a48.01 48.01 0 0128 87v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 0128-87z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zm-40 376H232V536h560v304z", "fill": primaryColor } }] }; }, "name": "unlock", "theme": "twotone" };
var UnlockTwoToneSvg = UnlockTwoTone$2;

var UnlockTwoTone = function UnlockTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UnlockTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  UnlockTwoTone.displayName = 'UnlockTwoTone';
}
var UnlockTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(UnlockTwoTone);

// This icon file is generated automatically.
var UnorderedListOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "unordered-list", "theme": "outlined" };
var UnorderedListOutlinedSvg = UnorderedListOutlined$2;

var UnorderedListOutlined = function UnorderedListOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UnorderedListOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  UnorderedListOutlined.displayName = 'UnorderedListOutlined';
}
var UnorderedListOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(UnorderedListOutlined);

// This icon file is generated automatically.
var UpCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm178 555h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 460.4 406.8 605.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z" } }] }, "name": "up-circle", "theme": "filled" };
var UpCircleFilledSvg = UpCircleFilled$2;

var UpCircleFilled = function UpCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UpCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  UpCircleFilled.displayName = 'UpCircleFilled';
}
var UpCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(UpCircleFilled);

// This icon file is generated automatically.
var UpCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M518.5 360.3a7.95 7.95 0 00-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7H381c10.2 0 19.9-4.9 25.9-13.2L512 460.4l105.2 145.4c6 8.3 15.6 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.5-12.7l-178-246z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "up-circle", "theme": "outlined" };
var UpCircleOutlinedSvg = UpCircleOutlined$2;

var UpCircleOutlined = function UpCircleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UpCircleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  UpCircleOutlined.displayName = 'UpCircleOutlined';
}
var UpCircleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(UpCircleOutlined);

// This icon file is generated automatically.
var UpCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm178 479h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 460.4 406.8 605.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M518.4 360.3a7.95 7.95 0 00-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7h46.9c10.3 0 19.9-4.9 25.9-13.2L512 460.4l105.2 145.4c6 8.3 15.7 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.4-12.7l-178-246z", "fill": primaryColor } }] }; }, "name": "up-circle", "theme": "twotone" };
var UpCircleTwoToneSvg = UpCircleTwoTone$2;

var UpCircleTwoTone = function UpCircleTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UpCircleTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  UpCircleTwoTone.displayName = 'UpCircleTwoTone';
}
var UpCircleTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(UpCircleTwoTone);

// This icon file is generated automatically.
var UpOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z" } }] }, "name": "up", "theme": "outlined" };
var UpOutlinedSvg = UpOutlined$2;

var UpOutlined = function UpOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UpOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  UpOutlined.displayName = 'UpOutlined';
}
var UpOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(UpOutlined);

// This icon file is generated automatically.
var UpSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM690 624h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 465.4 406.8 610.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z" } }] }, "name": "up-square", "theme": "filled" };
var UpSquareFilledSvg = UpSquareFilled$2;

var UpSquareFilled = function UpSquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UpSquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  UpSquareFilled.displayName = 'UpSquareFilled';
}
var UpSquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(UpSquareFilled);

// This icon file is generated automatically.
var UpSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M334 624h46.9c10.2 0 19.9-4.9 25.9-13.2L512 465.4l105.2 145.4c6 8.3 15.6 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.5-12.7l-178-246a7.95 7.95 0 00-12.9 0l-178 246A7.96 7.96 0 00334 624z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "up-square", "theme": "outlined" };
var UpSquareOutlinedSvg = UpSquareOutlined$2;

var UpSquareOutlined = function UpSquareOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UpSquareOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  UpSquareOutlined.displayName = 'UpSquareOutlined';
}
var UpSquareOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(UpSquareOutlined);

// This icon file is generated automatically.
var UpSquareTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm143.5-228.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 465.4 406.8 610.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M334 624h46.9c10.3 0 19.9-4.9 25.9-13.2L512 465.4l105.2 145.4c6 8.3 15.7 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.4-12.7l-178-246a7.95 7.95 0 00-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7z", "fill": primaryColor } }] }; }, "name": "up-square", "theme": "twotone" };
var UpSquareTwoToneSvg = UpSquareTwoTone$2;

var UpSquareTwoTone = function UpSquareTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UpSquareTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  UpSquareTwoTone.displayName = 'UpSquareTwoTone';
}
var UpSquareTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(UpSquareTwoTone);

// This icon file is generated automatically.
var UploadOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 00-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" } }] }, "name": "upload", "theme": "outlined" };
var UploadOutlinedSvg = UploadOutlined$2;

var UploadOutlined = function UploadOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UploadOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  UploadOutlined.displayName = 'UploadOutlined';
}
var UploadOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(UploadOutlined);

// This icon file is generated automatically.
var UsbFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M408 312h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm352 120V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zm-72 0H336V184h352v248zM568 312h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }] }, "name": "usb", "theme": "filled" };
var UsbFilledSvg = UsbFilled$2;

var UsbFilled = function UsbFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UsbFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  UsbFilled.displayName = 'UsbFilled';
}
var UsbFilled$1 = /*#__PURE__*/React__namespace.forwardRef(UsbFilled);

// This icon file is generated automatically.
var UsbOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M760 432V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V548c0-24.3 21.6-44 48.1-44h495.8c26.5 0 48.1 19.7 48.1 44v356c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zm-424 0V184h352v248H336zm120-184h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm160 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }] }, "name": "usb", "theme": "outlined" };
var UsbOutlinedSvg = UsbOutlined$2;

var UsbOutlined = function UsbOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UsbOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  UsbOutlined.displayName = 'UsbOutlined';
}
var UsbOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(UsbOutlined);

// This icon file is generated automatically.
var UsbTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M759.9 504H264.1c-26.5 0-48.1 19.7-48.1 44v292h592V548c0-24.3-21.6-44-48.1-44z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M456 248h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm160 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M760 432V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zM336 184h352v248H336V184zm472 656H216V548c0-24.3 21.6-44 48.1-44h495.8c26.5 0 48.1 19.7 48.1 44v292z", "fill": primaryColor } }] }; }, "name": "usb", "theme": "twotone" };
var UsbTwoToneSvg = UsbTwoTone$2;

var UsbTwoTone = function UsbTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UsbTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  UsbTwoTone.displayName = 'UsbTwoTone';
}
var UsbTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(UsbTwoTone);

// This icon file is generated automatically.
var UserAddOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M678.3 642.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 00-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 505 759.6 431.7 759.6 349c0-137-110.8-248-247.5-248S264.7 212 264.7 349c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 00-80.4 119.5A373.6 373.6 0 00137 888.8a8 8 0 008 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 628.2 432.2 597 512.2 597c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 008.1.3zM512.2 521c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 01340.5 349c0-45.9 17.9-89.1 50.3-121.6S466.3 177 512.2 177s88.9 17.9 121.4 50.4A171.2 171.2 0 01683.9 349c0 45.9-17.9 89.1-50.3 121.6C601.1 503.1 558 521 512.2 521zM880 759h-84v-84c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v84h-84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h84v84c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-84h84c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "user-add", "theme": "outlined" };
var UserAddOutlinedSvg = UserAddOutlined$2;

var UserAddOutlined = function UserAddOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UserAddOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  UserAddOutlined.displayName = 'UserAddOutlined';
}
var UserAddOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(UserAddOutlined);

// This icon file is generated automatically.
var UserDeleteOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M678.3 655.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 00-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 518 759.6 444.7 759.6 362c0-137-110.8-248-247.5-248S264.7 225 264.7 362c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 00-80.4 119.5A373.6 373.6 0 00137 901.8a8 8 0 008 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 641.2 432.2 610 512.2 610c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 008.1.3zM512.2 534c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 01340.5 362c0-45.9 17.9-89.1 50.3-121.6S466.3 190 512.2 190s88.9 17.9 121.4 50.4A171.2 171.2 0 01683.9 362c0 45.9-17.9 89.1-50.3 121.6C601.1 516.1 558 534 512.2 534zM880 772H640c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "user-delete", "theme": "outlined" };
var UserDeleteOutlinedSvg = UserDeleteOutlined$2;

var UserDeleteOutlined = function UserDeleteOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UserDeleteOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  UserDeleteOutlined.displayName = 'UserDeleteOutlined';
}
var UserDeleteOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(UserDeleteOutlined);

// This icon file is generated automatically.
var UserOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M858.5 763.6a374 374 0 00-80.6-119.5 375.63 375.63 0 00-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 00-80.6 119.5A371.7 371.7 0 00136 901.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 008-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z" } }] }, "name": "user", "theme": "outlined" };
var UserOutlinedSvg = UserOutlined$2;

var UserOutlined = function UserOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UserOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  UserOutlined.displayName = 'UserOutlined';
}
var UserOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(UserOutlined);

// This icon file is generated automatically.
var UserSwitchOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M759 335c0-137-111-248-248-248S263 198 263 335c0 82.8 40.6 156.2 103 201.2-.4.2-.7.3-.9.4-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 00-80.4 119.5A373.6 373.6 0 00136 874.8a8 8 0 008 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C356 614.2 431 583 511 583c137 0 248-111 248-248zM511 507c-95 0-172-77-172-172s77-172 172-172 172 77 172 172-77 172-172 172zm105 221h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H703.5l47.2-60.1a8.1 8.1 0 001.7-4.9c0-4.4-3.6-8-8-8h-72.6c-4.9 0-9.5 2.3-12.6 6.1l-68.5 87.1c-4.4 5.6-6.8 12.6-6.8 19.8.1 17.7 14.4 32 32.1 32zm240 64H592c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h176.5l-47.2 60.1a8.1 8.1 0 00-1.7 4.9c0 4.4 3.6 8 8 8h72.6c4.9 0 9.5-2.3 12.6-6.1l68.5-87.1c4.4-5.6 6.8-12.6 6.8-19.8-.1-17.7-14.4-32-32.1-32z" } }] }, "name": "user-switch", "theme": "outlined" };
var UserSwitchOutlinedSvg = UserSwitchOutlined$2;

var UserSwitchOutlined = function UserSwitchOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UserSwitchOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  UserSwitchOutlined.displayName = 'UserSwitchOutlined';
}
var UserSwitchOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(UserSwitchOutlined);

// This icon file is generated automatically.
var UsergroupAddOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M892 772h-80v-80c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v80h-80c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h80v80c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-80h80c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM373.5 498.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 01-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.8-1.7-203.2 89.2-203.2 200 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 008 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.8-1.1 6.4-4.8 5.9-8.8zM824 472c0-109.4-87.9-198.3-196.9-200C516.3 270.3 424 361.2 424 472c0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 00-86.4 60.4C357 742.6 326 814.8 324 891.8a8 8 0 008 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5C505.8 695.7 563 672 624 672c110.4 0 200-89.5 200-200zm-109.5 90.5C690.3 586.7 658.2 600 624 600s-66.3-13.3-90.5-37.5a127.26 127.26 0 01-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4-.1 34.2-13.4 66.3-37.6 90.5z" } }] }, "name": "usergroup-add", "theme": "outlined" };
var UsergroupAddOutlinedSvg = UsergroupAddOutlined$2;

var UsergroupAddOutlined = function UsergroupAddOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UsergroupAddOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  UsergroupAddOutlined.displayName = 'UsergroupAddOutlined';
}
var UsergroupAddOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(UsergroupAddOutlined);

// This icon file is generated automatically.
var UsergroupDeleteOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888 784H664c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM373.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 01-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 008 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7zM824 484c0-109.4-87.9-198.3-196.9-200C516.3 282.3 424 373.2 424 484c0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 00-86.4 60.4C357 754.6 326 826.8 324 903.8a8 8 0 008 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5C505.8 707.7 563 684 624 684c110.4 0 200-89.5 200-200zm-109.5 90.5C690.3 598.7 658.2 612 624 612s-66.3-13.3-90.5-37.5a127.26 127.26 0 01-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4-.1 34.2-13.4 66.3-37.6 90.5z" } }] }, "name": "usergroup-delete", "theme": "outlined" };
var UsergroupDeleteOutlinedSvg = UsergroupDeleteOutlined$2;

var UsergroupDeleteOutlined = function UsergroupDeleteOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UsergroupDeleteOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  UsergroupDeleteOutlined.displayName = 'UsergroupDeleteOutlined';
}
var UsergroupDeleteOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(UsergroupDeleteOutlined);

// This icon file is generated automatically.
var VerifiedOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M447.8 588.8l-7.3-32.5c-.2-1-.6-1.9-1.1-2.7a7.94 7.94 0 00-11.1-2.2L405 567V411c0-4.4-3.6-8-8-8h-81c-4.4 0-8 3.6-8 8v36c0 4.4 3.6 8 8 8h37v192.4a8 8 0 0012.7 6.5l79-56.8c2.6-1.9 3.8-5.1 3.1-8.3zm-56.7-216.6l.2.2c3.2 3 8.3 2.8 11.3-.5l24.1-26.2a8.1 8.1 0 00-.3-11.2l-53.7-52.1a8 8 0 00-11.2.1l-24.7 24.7c-3.1 3.1-3.1 8.2.1 11.3l54.2 53.7z" } }, { "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z" } }, { "tag": "path", "attrs": { "d": "M452 297v36c0 4.4 3.6 8 8 8h108v274h-38V405c0-4.4-3.6-8-8-8h-35c-4.4 0-8 3.6-8 8v210h-31c-4.4 0-8 3.6-8 8v37c0 4.4 3.6 8 8 8h244c4.4 0 8-3.6 8-8v-37c0-4.4-3.6-8-8-8h-72V493h58c4.4 0 8-3.6 8-8v-35c0-4.4-3.6-8-8-8h-58V341h63c4.4 0 8-3.6 8-8v-36c0-4.4-3.6-8-8-8H460c-4.4 0-8 3.6-8 8z" } }] }, "name": "verified", "theme": "outlined" };
var VerifiedOutlinedSvg = VerifiedOutlined$2;

var VerifiedOutlined = function VerifiedOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: VerifiedOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  VerifiedOutlined.displayName = 'VerifiedOutlined';
}
var VerifiedOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(VerifiedOutlined);

// This icon file is generated automatically.
var VerticalAlignBottomOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M859.9 780H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM505.7 669a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V176c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8z" } }] }, "name": "vertical-align-bottom", "theme": "outlined" };
var VerticalAlignBottomOutlinedSvg = VerticalAlignBottomOutlined$2;

var VerticalAlignBottomOutlined = function VerticalAlignBottomOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: VerticalAlignBottomOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  VerticalAlignBottomOutlined.displayName = 'VerticalAlignBottomOutlined';
}
var VerticalAlignBottomOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(VerticalAlignBottomOutlined);

// This icon file is generated automatically.
var VerticalAlignMiddleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M859.9 474H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zm-353.6-74.7c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H550V104c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v156h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.6zm11.4 225.4a7.14 7.14 0 00-11.3 0L405.6 752.3a7.23 7.23 0 005.7 11.7H474v156c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V764h62.8c6 0 9.4-7 5.7-11.7L517.7 624.7z" } }] }, "name": "vertical-align-middle", "theme": "outlined" };
var VerticalAlignMiddleOutlinedSvg = VerticalAlignMiddleOutlined$2;

var VerticalAlignMiddleOutlined = function VerticalAlignMiddleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: VerticalAlignMiddleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  VerticalAlignMiddleOutlined.displayName = 'VerticalAlignMiddleOutlined';
}
var VerticalAlignMiddleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(VerticalAlignMiddleOutlined);

// This icon file is generated automatically.
var VerticalAlignTopOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M859.9 168H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM518.3 355a8 8 0 00-12.6 0l-112 141.7a7.98 7.98 0 006.3 12.9h73.9V848c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V509.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 355z" } }] }, "name": "vertical-align-top", "theme": "outlined" };
var VerticalAlignTopOutlinedSvg = VerticalAlignTopOutlined$2;

var VerticalAlignTopOutlined = function VerticalAlignTopOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: VerticalAlignTopOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  VerticalAlignTopOutlined.displayName = 'VerticalAlignTopOutlined';
}
var VerticalAlignTopOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(VerticalAlignTopOutlined);

// This icon file is generated automatically.
var VerticalLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M762 164h-64c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V172c0-4.4-3.6-8-8-8zm-508 0v72.4c0 9.5 4.2 18.4 11.4 24.5L564.6 512 265.4 763.1c-7.2 6.1-11.4 15-11.4 24.5V860c0 6.8 7.9 10.5 13.1 6.1L689 512 267.1 157.9A7.95 7.95 0 00254 164z" } }] }, "name": "vertical-left", "theme": "outlined" };
var VerticalLeftOutlinedSvg = VerticalLeftOutlined$2;

var VerticalLeftOutlined = function VerticalLeftOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: VerticalLeftOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  VerticalLeftOutlined.displayName = 'VerticalLeftOutlined';
}
var VerticalLeftOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(VerticalLeftOutlined);

// This icon file is generated automatically.
var VerticalRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M326 164h-64c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V172c0-4.4-3.6-8-8-8zm444 72.4V164c0-6.8-7.9-10.5-13.1-6.1L335 512l421.9 354.1c5.2 4.4 13.1.7 13.1-6.1v-72.4c0-9.4-4.2-18.4-11.4-24.5L459.4 512l299.2-251.1c7.2-6.1 11.4-15.1 11.4-24.5z" } }] }, "name": "vertical-right", "theme": "outlined" };
var VerticalRightOutlinedSvg = VerticalRightOutlined$2;

var VerticalRightOutlined = function VerticalRightOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: VerticalRightOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  VerticalRightOutlined.displayName = 'VerticalRightOutlined';
}
var VerticalRightOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(VerticalRightOutlined);

// This icon file is generated automatically.
var VideoCameraAddOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M368 724H252V608c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v116H72c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h116v116c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V788h116c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }, { "tag": "path", "attrs": { "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v352h72V232h576v560H448v72h272c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM888 625l-104-59.8V458.9L888 399v226z" } }, { "tag": "path", "attrs": { "d": "M320 360c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h112z" } }] }, "name": "video-camera-add", "theme": "outlined" };
var VideoCameraAddOutlinedSvg = VideoCameraAddOutlined$2;

var VideoCameraAddOutlined = function VideoCameraAddOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: VideoCameraAddOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  VideoCameraAddOutlined.displayName = 'VideoCameraAddOutlined';
}
var VideoCameraAddOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(VideoCameraAddOutlined);

// This icon file is generated automatically.
var VideoCameraFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM328 352c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v48zm560 273l-104-59.8V458.9L888 399v226z" } }] }, "name": "video-camera", "theme": "filled" };
var VideoCameraFilledSvg = VideoCameraFilled$2;

var VideoCameraFilled = function VideoCameraFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: VideoCameraFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  VideoCameraFilled.displayName = 'VideoCameraFilled';
}
var VideoCameraFilled$1 = /*#__PURE__*/React__namespace.forwardRef(VideoCameraFilled);

// This icon file is generated automatically.
var VideoCameraOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM712 792H136V232h576v560zm176-167l-104-59.8V458.9L888 399v226zM208 360h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }] }, "name": "video-camera", "theme": "outlined" };
var VideoCameraOutlinedSvg = VideoCameraOutlined$2;

var VideoCameraOutlined = function VideoCameraOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: VideoCameraOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  VideoCameraOutlined.displayName = 'VideoCameraOutlined';
}
var VideoCameraOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(VideoCameraOutlined);

// This icon file is generated automatically.
var VideoCameraTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M136 792h576V232H136v560zm64-488c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8v-48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM712 792H136V232h576v560zm176-167l-104-59.8V458.9L888 399v226z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M208 360h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z", "fill": primaryColor } }] }; }, "name": "video-camera", "theme": "twotone" };
var VideoCameraTwoToneSvg = VideoCameraTwoTone$2;

var VideoCameraTwoTone = function VideoCameraTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: VideoCameraTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  VideoCameraTwoTone.displayName = 'VideoCameraTwoTone';
}
var VideoCameraTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(VideoCameraTwoTone);

// This icon file is generated automatically.
var WalletFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-32 464H528V448h320v128zm-268-64a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "wallet", "theme": "filled" };
var WalletFilledSvg = WalletFilled$2;

var WalletFilled = function WalletFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: WalletFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  WalletFilled.displayName = 'WalletFilled';
}
var WalletFilled$1 = /*#__PURE__*/React__namespace.forwardRef(WalletFilled);

// This icon file is generated automatically.
var WalletOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 464H528V448h312v128zm0 264H184V184h656v200H496c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h344v200zM580 512a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "wallet", "theme": "outlined" };
var WalletOutlinedSvg = WalletOutlined$2;

var WalletOutlined = function WalletOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: WalletOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  WalletOutlined.displayName = 'WalletOutlined';
}
var WalletOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(WalletOutlined);

// This icon file is generated automatically.
var WalletTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 464H528V448h312v128zm0-192H496c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h344v200H184V184h656v200z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M528 576h312V448H528v128zm92-104c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M580 512a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V640H496c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32h344V184H184v656z", "fill": secondaryColor } }] }; }, "name": "wallet", "theme": "twotone" };
var WalletTwoToneSvg = WalletTwoTone$2;

var WalletTwoTone = function WalletTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: WalletTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  WalletTwoTone.displayName = 'WalletTwoTone';
}
var WalletTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(WalletTwoTone);

// This icon file is generated automatically.
var WarningFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "warning", "theme": "filled" };
var WarningFilledSvg = WarningFilled$2;

var WarningFilled = function WarningFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: WarningFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  WarningFilled.displayName = 'WarningFilled';
}
var WarningFilled$1 = /*#__PURE__*/React__namespace.forwardRef(WarningFilled);

// This icon file is generated automatically.
var WarningOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M464 720a48 48 0 1096 0 48 48 0 10-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zm475.7 440l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z" } }] }, "name": "warning", "theme": "outlined" };
var WarningOutlinedSvg = WarningOutlined$2;

var WarningOutlined = function WarningOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: WarningOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  WarningOutlined.displayName = 'WarningOutlined';
}
var WarningOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(WarningOutlined);

// This icon file is generated automatically.
var WarningTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M172.2 828.1h679.6L512 239.9 172.2 828.1zM560 720a48.01 48.01 0 01-96 0 48.01 48.01 0 0196 0zm-16-304v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M464 720a48 48 0 1096 0 48 48 0 10-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8z", "fill": primaryColor } }] }; }, "name": "warning", "theme": "twotone" };
var WarningTwoToneSvg = WarningTwoTone$2;

var WarningTwoTone = function WarningTwoTone(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: WarningTwoToneSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  WarningTwoTone.displayName = 'WarningTwoTone';
}
var WarningTwoTone$1 = /*#__PURE__*/React__namespace.forwardRef(WarningTwoTone);

// This icon file is generated automatically.
var WechatFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 019.1 17.6c0 2.4-.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-.1 17.8-.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8zm-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1zm-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1zm586.8 415.6c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7a9 9 0 006.4-2.6 9 9 0 002.6-6.4c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3-.5-1.9-.9-3.8-.9-5.7.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9zm179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9a36.08 36.08 0 01-36 35.9z" } }] }, "name": "wechat", "theme": "filled" };
var WechatFilledSvg = WechatFilled$2;

var WechatFilled = function WechatFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: WechatFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  WechatFilled.displayName = 'WechatFilled';
}
var WechatFilled$1 = /*#__PURE__*/React__namespace.forwardRef(WechatFilled);

// This icon file is generated automatically.
var WechatOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 019.1 17.6c0 2.4-.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-.1 17.8-.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8zm-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1zm-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1zm586.8 415.6c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7a9 9 0 006.4-2.6 9 9 0 002.6-6.4c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3-.5-1.9-.9-3.8-.9-5.7.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9zm179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9a36.08 36.08 0 01-36 35.9z" } }] }, "name": "wechat", "theme": "outlined" };
var WechatOutlinedSvg = WechatOutlined$2;

var WechatOutlined = function WechatOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: WechatOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  WechatOutlined.displayName = 'WechatOutlined';
}
var WechatOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(WechatOutlined);

// This icon file is generated automatically.
var WeiboCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-44.4 672C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 00-7.2-34.1 34.68 34.68 0 00-33.1-10.7 18.24 18.24 0 01-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 01-22.9 11.7 18.18 18.18 0 01-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 01-26.6 13.7 21.19 21.19 0 01-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 00-98.9-32.1 21.14 21.14 0 01-25.1-16.3 21.07 21.07 0 0116.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-93-32.2c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zm34.9-14.5c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z" } }] }, "name": "weibo-circle", "theme": "filled" };
var WeiboCircleFilledSvg = WeiboCircleFilled$2;

var WeiboCircleFilled = function WeiboCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: WeiboCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  WeiboCircleFilled.displayName = 'WeiboCircleFilled';
}
var WeiboCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(WeiboCircleFilled);

// This icon file is generated automatically.
var WeiboCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-44.4 672C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 00-7.2-34.1 34.68 34.68 0 00-33.1-10.7 18.24 18.24 0 01-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 01-22.9 11.7 18.18 18.18 0 01-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 01-26.6 13.7 21.19 21.19 0 01-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 00-98.9-32.1 21.14 21.14 0 01-25.1-16.3 21.07 21.07 0 0116.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-93-32.2c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zm34.9-14.5c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z" } }] }, "name": "weibo-circle", "theme": "outlined" };
var WeiboCircleOutlinedSvg = WeiboCircleOutlined$2;

var WeiboCircleOutlined = function WeiboCircleOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: WeiboCircleOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  WeiboCircleOutlined.displayName = 'WeiboCircleOutlined';
}
var WeiboCircleOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(WeiboCircleOutlined);

// This icon file is generated automatically.
var WeiboOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M457.3 543c-68.1-17.7-145 16.2-174.6 76.2-30.1 61.2-1 129.1 67.8 151.3 71.2 23 155.2-12.2 184.4-78.3 28.7-64.6-7.2-131-77.6-149.2zm-52 156.2c-13.8 22.1-43.5 31.7-65.8 21.6-22-10-28.5-35.7-14.6-57.2 13.7-21.4 42.3-31 64.4-21.7 22.4 9.5 29.6 35 16 57.3zm45.5-58.5c-5 8.6-16.1 12.7-24.7 9.1-8.5-3.5-11.2-13.1-6.4-21.5 5-8.4 15.6-12.4 24.1-9.1 8.7 3.2 11.8 12.9 7 21.5zm334.5-197.2c15 4.8 31-3.4 35.9-18.3 11.8-36.6 4.4-78.4-23.2-109a111.39 111.39 0 00-106-34.3 28.45 28.45 0 00-21.9 33.8 28.39 28.39 0 0033.8 21.8c18.4-3.9 38.3 1.8 51.9 16.7a54.2 54.2 0 0111.3 53.3 28.45 28.45 0 0018.2 36zm99.8-206c-56.7-62.9-140.4-86.9-217.7-70.5a32.98 32.98 0 00-25.4 39.3 33.12 33.12 0 0039.3 25.5c55-11.7 114.4 5.4 154.8 50.1 40.3 44.7 51.2 105.7 34 159.1-5.6 17.4 3.9 36 21.3 41.7 17.4 5.6 36-3.9 41.6-21.2v-.1c24.1-75.4 8.9-161.1-47.9-223.9zM729 499c-12.2-3.6-20.5-6.1-14.1-22.1 13.8-34.7 15.2-64.7.3-86-28-40.1-104.8-37.9-192.8-1.1 0 0-27.6 12.1-20.6-9.8 13.5-43.5 11.5-79.9-9.6-101-47.7-47.8-174.6 1.8-283.5 110.6C127.3 471.1 80 557.5 80 632.2 80 775.1 263.2 862 442.5 862c235 0 391.3-136.5 391.3-245 0-65.5-55.2-102.6-104.8-118zM443 810.8c-143 14.1-266.5-50.5-275.8-144.5-9.3-93.9 99.2-181.5 242.2-195.6 143-14.2 266.5 50.5 275.8 144.4C694.4 709 586 796.6 443 810.8z" } }] }, "name": "weibo", "theme": "outlined" };
var WeiboOutlinedSvg = WeiboOutlined$2;

var WeiboOutlined = function WeiboOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: WeiboOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  WeiboOutlined.displayName = 'WeiboOutlined';
}
var WeiboOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(WeiboOutlined);

// This icon file is generated automatically.
var WeiboSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M433.6 595.1c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM467.6 736C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 00-7.2-34.1 34.68 34.68 0 00-33.1-10.7 18.24 18.24 0 01-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 01-22.9 11.7 18.18 18.18 0 01-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 01-26.6 13.7 21.19 21.19 0 01-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 00-98.9-32.1 21.14 21.14 0 01-25.1-16.3 21.07 21.07 0 0116.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-58.1-46.7c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z" } }] }, "name": "weibo-square", "theme": "filled" };
var WeiboSquareFilledSvg = WeiboSquareFilled$2;

var WeiboSquareFilled = function WeiboSquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: WeiboSquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  WeiboSquareFilled.displayName = 'WeiboSquareFilled';
}
var WeiboSquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(WeiboSquareFilled);

// This icon file is generated automatically.
var WeiboSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M433.6 595.1c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM467.6 736C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 00-7.2-34.1 34.68 34.68 0 00-33.1-10.7 18.24 18.24 0 01-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 01-22.9 11.7 18.18 18.18 0 01-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 01-26.6 13.7 21.19 21.19 0 01-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 00-98.9-32.1 21.14 21.14 0 01-25.1-16.3 21.07 21.07 0 0116.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-58.1-46.7c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z" } }] }, "name": "weibo-square", "theme": "outlined" };
var WeiboSquareOutlinedSvg = WeiboSquareOutlined$2;

var WeiboSquareOutlined = function WeiboSquareOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: WeiboSquareOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  WeiboSquareOutlined.displayName = 'WeiboSquareOutlined';
}
var WeiboSquareOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(WeiboSquareOutlined);

// This icon file is generated automatically.
var WhatsAppOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M713.5 599.9c-10.9-5.6-65.2-32.2-75.3-35.8-10.1-3.8-17.5-5.6-24.8 5.6-7.4 11.1-28.4 35.8-35 43.3-6.4 7.4-12.9 8.3-23.8 2.8-64.8-32.4-107.3-57.8-150-131.1-11.3-19.5 11.3-18.1 32.4-60.2 3.6-7.4 1.8-13.7-1-19.3-2.8-5.6-24.8-59.8-34-81.9-8.9-21.5-18.1-18.5-24.8-18.9-6.4-.4-13.7-.4-21.1-.4-7.4 0-19.3 2.8-29.4 13.7-10.1 11.1-38.6 37.8-38.6 92s39.5 106.7 44.9 114.1c5.6 7.4 77.7 118.6 188.4 166.5 70 30.2 97.4 32.8 132.4 27.6 21.3-3.2 65.2-26.6 74.3-52.5 9.1-25.8 9.1-47.9 6.4-52.5-2.7-4.9-10.1-7.7-21-13z" } }, { "tag": "path", "attrs": { "d": "M925.2 338.4c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 00-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 00-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 00112 714v152a46 46 0 0046 46h152.1A449.4 449.4 0 00510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 00142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z" } }] }, "name": "whats-app", "theme": "outlined" };
var WhatsAppOutlinedSvg = WhatsAppOutlined$2;

var WhatsAppOutlined = function WhatsAppOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: WhatsAppOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  WhatsAppOutlined.displayName = 'WhatsAppOutlined';
}
var WhatsAppOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(WhatsAppOutlined);

// This icon file is generated automatically.
var WifiOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M723 620.5C666.8 571.6 593.4 542 513 542s-153.8 29.6-210.1 78.6a8.1 8.1 0 00-.8 11.2l36 42.9c2.9 3.4 8 3.8 11.4.9C393.1 637.2 450.3 614 513 614s119.9 23.2 163.5 61.5c3.4 2.9 8.5 2.5 11.4-.9l36-42.9c2.8-3.3 2.4-8.3-.9-11.2zm117.4-140.1C751.7 406.5 637.6 362 513 362s-238.7 44.5-327.5 118.4a8.05 8.05 0 00-1 11.3l36 42.9c2.8 3.4 7.9 3.8 11.2 1C308 472.2 406.1 434 513 434s205 38.2 281.2 101.6c3.4 2.8 8.4 2.4 11.2-1l36-42.9c2.8-3.4 2.4-8.5-1-11.3zm116.7-139C835.7 241.8 680.3 182 511 182c-168.2 0-322.6 59-443.7 157.4a8 8 0 00-1.1 11.4l36 42.9c2.8 3.3 7.8 3.8 11.1 1.1C222 306.7 360.3 254 511 254c151.8 0 291 53.5 400 142.7 3.4 2.8 8.4 2.3 11.2-1.1l36-42.9c2.9-3.4 2.4-8.5-1.1-11.3zM448 778a64 64 0 10128 0 64 64 0 10-128 0z" } }] }, "name": "wifi", "theme": "outlined" };
var WifiOutlinedSvg = WifiOutlined$2;

var WifiOutlined = function WifiOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: WifiOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  WifiOutlined.displayName = 'WifiOutlined';
}
var WifiOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(WifiOutlined);

// This icon file is generated automatically.
var WindowsFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M523.8 191.4v288.9h382V128.1zm0 642.2l382 62.2v-352h-382zM120.1 480.2H443V201.9l-322.9 53.5zm0 290.4L443 823.2V543.8H120.1z" } }] }, "name": "windows", "theme": "filled" };
var WindowsFilledSvg = WindowsFilled$2;

var WindowsFilled = function WindowsFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: WindowsFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  WindowsFilled.displayName = 'WindowsFilled';
}
var WindowsFilled$1 = /*#__PURE__*/React__namespace.forwardRef(WindowsFilled);

// This icon file is generated automatically.
var WindowsOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M120.1 770.6L443 823.2V543.8H120.1v226.8zm63.4-163.5h196.2v141.6l-196.2-31.9V607.1zm340.3 226.5l382 62.2v-352h-382v289.8zm63.4-226.5h255.3v214.4l-255.3-41.6V607.1zm-63.4-415.7v288.8h382V128.1l-382 63.3zm318.7 225.5H587.3V245l255.3-42.3v214.2zm-722.4 63.3H443V201.9l-322.9 53.5v224.8zM183.5 309l196.2-32.5v140.4H183.5V309z" } }] }, "name": "windows", "theme": "outlined" };
var WindowsOutlinedSvg = WindowsOutlined$2;

var WindowsOutlined = function WindowsOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: WindowsOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  WindowsOutlined.displayName = 'WindowsOutlined';
}
var WindowsOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(WindowsOutlined);

// This icon file is generated automatically.
var WomanOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M712.8 548.8c53.6-53.6 83.2-125 83.2-200.8 0-75.9-29.5-147.2-83.2-200.8C659.2 93.6 587.8 64 512 64s-147.2 29.5-200.8 83.2C257.6 200.9 228 272.1 228 348c0 63.8 20.9 124.4 59.4 173.9 7.3 9.4 15.2 18.3 23.7 26.9 8.5 8.5 17.5 16.4 26.8 23.7 39.6 30.8 86.3 50.4 136.1 57V736H360c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h114v140c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V812h114c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H550V629.5c61.5-8.2 118.2-36.1 162.8-80.7zM512 556c-55.6 0-107.7-21.6-147.1-60.9C325.6 455.8 304 403.6 304 348s21.6-107.7 60.9-147.1C404.2 161.5 456.4 140 512 140s107.7 21.6 147.1 60.9C698.4 240.2 720 292.4 720 348s-21.6 107.7-60.9 147.1C619.7 534.4 567.6 556 512 556z" } }] }, "name": "woman", "theme": "outlined" };
var WomanOutlinedSvg = WomanOutlined$2;

var WomanOutlined = function WomanOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: WomanOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  WomanOutlined.displayName = 'WomanOutlined';
}
var WomanOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(WomanOutlined);

// This icon file is generated automatically.
var YahooFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M937.3 231H824.7c-15.5 0-27.7 12.6-27.1 28.1l13.1 366h84.4l65.4-366.4c2.7-15.2-7.8-27.7-23.2-27.7zm-77.4 450.4h-14.1c-27.1 0-49.2 22.2-49.2 49.3v14.1c0 27.1 22.2 49.3 49.2 49.3h14.1c27.1 0 49.2-22.2 49.2-49.3v-14.1c0-27.1-22.2-49.3-49.2-49.3zM402.6 231C216.2 231 65 357 65 512.5S216.2 794 402.6 794s337.6-126 337.6-281.5S589.1 231 402.6 231zm225.2 225.2h-65.3L458.9 559.8v65.3h84.4v56.3H318.2v-56.3h84.4v-65.3L242.9 399.9h-37v-56.3h168.5v56.3h-37l93.4 93.5 28.1-28.1V400h168.8v56.2z" } }] }, "name": "yahoo", "theme": "filled" };
var YahooFilledSvg = YahooFilled$2;

var YahooFilled = function YahooFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: YahooFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  YahooFilled.displayName = 'YahooFilled';
}
var YahooFilled$1 = /*#__PURE__*/React__namespace.forwardRef(YahooFilled);

// This icon file is generated automatically.
var YahooOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M859.9 681.4h-14.1c-27.1 0-49.2 22.2-49.2 49.3v14.1c0 27.1 22.2 49.3 49.2 49.3h14.1c27.1 0 49.2-22.2 49.2-49.3v-14.1c0-27.1-22.2-49.3-49.2-49.3zM402.6 231C216.2 231 65 357 65 512.5S216.2 794 402.6 794s337.6-126 337.6-281.5S589.1 231 402.6 231zm0 507C245.1 738 121 634.6 121 512.5c0-62.3 32.3-119.7 84.9-161v48.4h37l159.8 159.9v65.3h-84.4v56.3h225.1v-56.3H459v-65.3l103.5-103.6h65.3v-56.3H459v65.3l-28.1 28.1-93.4-93.5h37v-56.3H216.4c49.4-35 114.3-56.6 186.2-56.6 157.6 0 281.6 103.4 281.6 225.5S560.2 738 402.6 738zm534.7-507H824.7c-15.5 0-27.7 12.6-27.1 28.1l13.1 366h84.4l65.4-366.4c2.7-15.2-7.8-27.7-23.2-27.7z" } }] }, "name": "yahoo", "theme": "outlined" };
var YahooOutlinedSvg = YahooOutlined$2;

var YahooOutlined = function YahooOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: YahooOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  YahooOutlined.displayName = 'YahooOutlined';
}
var YahooOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(YahooOutlined);

// This icon file is generated automatically.
var YoutubeFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M941.3 296.1a112.3 112.3 0 00-79.2-79.3C792.2 198 512 198 512 198s-280.2 0-350.1 18.7A112.12 112.12 0 0082.7 296C64 366 64 512 64 512s0 146 18.7 215.9c10.3 38.6 40.7 69 79.2 79.3C231.8 826 512 826 512 826s280.2 0 350.1-18.8c38.6-10.3 68.9-40.7 79.2-79.3C960 658 960 512 960 512s0-146-18.7-215.9zM423 646V378l232 133-232 135z" } }] }, "name": "youtube", "theme": "filled" };
var YoutubeFilledSvg = YoutubeFilled$2;

var YoutubeFilled = function YoutubeFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: YoutubeFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  YoutubeFilled.displayName = 'YoutubeFilled';
}
var YoutubeFilled$1 = /*#__PURE__*/React__namespace.forwardRef(YoutubeFilled);

// This icon file is generated automatically.
var YoutubeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M960 509.2c0-2.2 0-4.7-.1-7.6-.1-8.1-.3-17.2-.5-26.9-.8-27.9-2.2-55.7-4.4-81.9-3-36.1-7.4-66.2-13.4-88.8a139.52 139.52 0 00-98.3-98.5c-28.3-7.6-83.7-12.3-161.7-15.2-37.1-1.4-76.8-2.3-116.5-2.8-13.9-.2-26.8-.3-38.4-.4h-29.4c-11.6.1-24.5.2-38.4.4-39.7.5-79.4 1.4-116.5 2.8-78 3-133.5 7.7-161.7 15.2A139.35 139.35 0 0082.4 304C76.3 326.6 72 356.7 69 392.8c-2.2 26.2-3.6 54-4.4 81.9-.3 9.7-.4 18.8-.5 26.9 0 2.9-.1 5.4-.1 7.6v5.6c0 2.2 0 4.7.1 7.6.1 8.1.3 17.2.5 26.9.8 27.9 2.2 55.7 4.4 81.9 3 36.1 7.4 66.2 13.4 88.8 12.8 47.9 50.4 85.7 98.3 98.5 28.2 7.6 83.7 12.3 161.7 15.2 37.1 1.4 76.8 2.3 116.5 2.8 13.9.2 26.8.3 38.4.4h29.4c11.6-.1 24.5-.2 38.4-.4 39.7-.5 79.4-1.4 116.5-2.8 78-3 133.5-7.7 161.7-15.2 47.9-12.8 85.5-50.5 98.3-98.5 6.1-22.6 10.4-52.7 13.4-88.8 2.2-26.2 3.6-54 4.4-81.9.3-9.7.4-18.8.5-26.9 0-2.9.1-5.4.1-7.6v-5.6zm-72 5.2c0 2.1 0 4.4-.1 7.1-.1 7.8-.3 16.4-.5 25.7-.7 26.6-2.1 53.2-4.2 77.9-2.7 32.2-6.5 58.6-11.2 76.3-6.2 23.1-24.4 41.4-47.4 47.5-21 5.6-73.9 10.1-145.8 12.8-36.4 1.4-75.6 2.3-114.7 2.8-13.7.2-26.4.3-37.8.3h-28.6l-37.8-.3c-39.1-.5-78.2-1.4-114.7-2.8-71.9-2.8-124.9-7.2-145.8-12.8-23-6.2-41.2-24.4-47.4-47.5-4.7-17.7-8.5-44.1-11.2-76.3-2.1-24.7-3.4-51.3-4.2-77.9-.3-9.3-.4-18-.5-25.7 0-2.7-.1-5.1-.1-7.1v-4.8c0-2.1 0-4.4.1-7.1.1-7.8.3-16.4.5-25.7.7-26.6 2.1-53.2 4.2-77.9 2.7-32.2 6.5-58.6 11.2-76.3 6.2-23.1 24.4-41.4 47.4-47.5 21-5.6 73.9-10.1 145.8-12.8 36.4-1.4 75.6-2.3 114.7-2.8 13.7-.2 26.4-.3 37.8-.3h28.6l37.8.3c39.1.5 78.2 1.4 114.7 2.8 71.9 2.8 124.9 7.2 145.8 12.8 23 6.2 41.2 24.4 47.4 47.5 4.7 17.7 8.5 44.1 11.2 76.3 2.1 24.7 3.4 51.3 4.2 77.9.3 9.3.4 18 .5 25.7 0 2.7.1 5.1.1 7.1v4.8zM423 646l232-135-232-133z" } }] }, "name": "youtube", "theme": "outlined" };
var YoutubeOutlinedSvg = YoutubeOutlined$2;

var YoutubeOutlined = function YoutubeOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: YoutubeOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  YoutubeOutlined.displayName = 'YoutubeOutlined';
}
var YoutubeOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(YoutubeOutlined);

// This icon file is generated automatically.
var YuqueFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 370.6c-9.9-39.4 9.9-102.2 73.4-124.4l-67.9-3.6s-25.7-90-143.6-98c-117.9-8.1-195-3-195-3s87.4 55.6 52.4 154.7c-25.6 52.5-65.8 95.6-108.8 144.7-1.3 1.3-2.5 2.6-3.5 3.7C319.4 605 96 860 96 860c245.9 64.4 410.7-6.3 508.2-91.1 20.5-.2 35.9-.3 46.3-.3 135.8 0 250.6-117.6 245.9-248.4-3.2-89.9-31.9-110.2-41.8-149.6z" } }] }, "name": "yuque", "theme": "filled" };
var YuqueFilledSvg = YuqueFilled$2;

var YuqueFilled = function YuqueFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: YuqueFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  YuqueFilled.displayName = 'YuqueFilled';
}
var YuqueFilled$1 = /*#__PURE__*/React__namespace.forwardRef(YuqueFilled);

// This icon file is generated automatically.
var YuqueOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 370.6c-9.9-39.4 9.9-102.2 73.4-124.4l-67.9-3.6s-25.7-90-143.6-98c-117.8-8.1-194.9-3-195-3 .1 0 87.4 55.6 52.4 154.7-25.6 52.5-65.8 95.6-108.8 144.7-1.3 1.3-2.5 2.6-3.5 3.7C319.4 605 96 860 96 860c245.9 64.4 410.7-6.3 508.2-91.1 20.5-.2 35.9-.3 46.3-.3 135.8 0 250.6-117.6 245.9-248.4-3.2-89.9-31.9-110.2-41.8-149.6zm-204.1 334c-10.6 0-26.2.1-46.8.3l-23.6.2-17.8 15.5c-47.1 41-104.4 71.5-171.4 87.6-52.5 12.6-110 16.2-172.7 9.6 18-20.5 36.5-41.6 55.4-63.1 92-104.6 173.8-197.5 236.9-268.5l1.4-1.4 1.3-1.5c4.1-4.6 20.6-23.3 24.7-28.1 9.7-11.1 17.3-19.9 24.5-28.6 30.7-36.7 52.2-67.8 69-102.2l1.6-3.3 1.2-3.4c13.7-38.8 15.4-76.9 6.2-112.8 22.5.7 46.5 1.9 71.7 3.6 33.3 2.3 55.5 12.9 71.1 29.2 5.8 6 10.2 12.5 13.4 18.7 1 2 1.7 3.6 2.3 5l5 17.7c-15.7 34.5-19.9 73.3-11.4 107.2 3 11.8 6.9 22.4 12.3 34.4 2.1 4.7 9.5 20.1 11 23.3 10.3 22.7 15.4 43 16.7 78.7 3.3 94.6-82.7 181.9-182 181.9z" } }] }, "name": "yuque", "theme": "outlined" };
var YuqueOutlinedSvg = YuqueOutlined$2;

var YuqueOutlined = function YuqueOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: YuqueOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  YuqueOutlined.displayName = 'YuqueOutlined';
}
var YuqueOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(YuqueOutlined);

// This icon file is generated automatically.
var ZhihuCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-90.7 477.8l-.1 1.5c-1.5 20.4-6.3 43.9-12.9 67.6l24-18.1 71 80.7c9.2 33-3.3 63.1-3.3 63.1l-95.7-111.9v-.1c-8.9 29-20.1 57.3-33.3 84.7-22.6 45.7-55.2 54.7-89.5 57.7-34.4 3-23.3-5.3-23.3-5.3 68-55.5 78-87.8 96.8-123.1 11.9-22.3 20.4-64.3 25.3-96.8H264.1s4.8-31.2 19.2-41.7h101.6c.6-15.3-1.3-102.8-2-131.4h-49.4c-9.2 45-41 56.7-48.1 60.1-7 3.4-23.6 7.1-21.1 0 2.6-7.1 27-46.2 43.2-110.7 16.3-64.6 63.9-62 63.9-62-12.8 22.5-22.4 73.6-22.4 73.6h159.7c10.1 0 10.6 39 10.6 39h-90.8c-.7 22.7-2.8 83.8-5 131.4H519s12.2 15.4 12.2 41.7H421.3zm346.5 167h-87.6l-69.5 46.6-16.4-46.6h-40.1V321.5h213.6v387.3zM408.2 611s0-.1 0 0zm216 94.3l56.8-38.1h45.6-.1V364.7H596.7v302.5h14.1z" } }] }, "name": "zhihu-circle", "theme": "filled" };
var ZhihuCircleFilledSvg = ZhihuCircleFilled$2;

var ZhihuCircleFilled = function ZhihuCircleFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ZhihuCircleFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ZhihuCircleFilled.displayName = 'ZhihuCircleFilled';
}
var ZhihuCircleFilled$1 = /*#__PURE__*/React__namespace.forwardRef(ZhihuCircleFilled);

// This icon file is generated automatically.
var ZhihuOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M564.7 230.1V803h60l25.2 71.4L756.3 803h131.5V230.1H564.7zm247.7 497h-59.9l-75.1 50.4-17.8-50.4h-18V308.3h170.7v418.8zM526.1 486.9H393.3c2.1-44.9 4.3-104.3 6.6-172.9h130.9l-.1-8.1c0-.6-.2-14.7-2.3-29.1-2.1-15-6.6-34.9-21-34.9H287.8c4.4-20.6 15.7-69.7 29.4-93.8l6.4-11.2-12.9-.7c-.8 0-19.6-.9-41.4 10.6-35.7 19-51.7 56.4-58.7 84.4-18.4 73.1-44.6 123.9-55.7 145.6-3.3 6.4-5.3 10.2-6.2 12.8-1.8 4.9-.8 9.8 2.8 13 10.5 9.5 38.2-2.9 38.5-3 .6-.3 1.3-.6 2.2-1 13.9-6.3 55.1-25 69.8-84.5h56.7c.7 32.2 3.1 138.4 2.9 172.9h-141l-2.1 1.5c-23.1 16.9-30.5 63.2-30.8 65.2l-1.4 9.2h167c-12.3 78.3-26.5 113.4-34 127.4-3.7 7-7.3 14-10.7 20.8-21.3 42.2-43.4 85.8-126.3 153.6-3.6 2.8-7 8-4.8 13.7 2.4 6.3 9.3 9.1 24.6 9.1 5.4 0 11.8-.3 19.4-1 49.9-4.4 100.8-18 135.1-87.6 17-35.1 31.7-71.7 43.9-108.9L497 850l5-12c.8-1.9 19-46.3 5.1-95.9l-.5-1.8-108.1-123-22 16.6c6.4-26.1 10.6-49.9 12.5-71.1h158.7v-8c0-40.1-18.5-63.9-19.2-64.9l-2.4-3z" } }] }, "name": "zhihu", "theme": "outlined" };
var ZhihuOutlinedSvg = ZhihuOutlined$2;

var ZhihuOutlined = function ZhihuOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ZhihuOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ZhihuOutlined.displayName = 'ZhihuOutlined';
}
var ZhihuOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ZhihuOutlined);

// This icon file is generated automatically.
var ZhihuSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM432.3 592.8l71 80.7c9.2 33-3.3 63.1-3.3 63.1l-95.7-111.9v-.1c-8.9 29-20.1 57.3-33.3 84.7-22.6 45.7-55.2 54.7-89.5 57.7-34.4 3-23.3-5.3-23.3-5.3 68-55.5 78-87.8 96.8-123.1 11.9-22.3 20.4-64.3 25.3-96.8H264.1s4.8-31.2 19.2-41.7h101.6c.6-15.3-1.3-102.8-2-131.4h-49.4c-9.2 45-41 56.7-48.1 60.1-7 3.4-23.6 7.1-21.1 0 2.6-7.1 27-46.2 43.2-110.7 16.3-64.6 63.9-62 63.9-62-12.8 22.5-22.4 73.6-22.4 73.6h159.7c10.1 0 10.6 39 10.6 39h-90.8c-.7 22.7-2.8 83.8-5 131.4H519s12.2 15.4 12.2 41.7h-110l-.1 1.5c-1.5 20.4-6.3 43.9-12.9 67.6l24.1-18.1zm335.5 116h-87.6l-69.5 46.6-16.4-46.6h-40.1V321.5h213.6v387.3zM408.2 611s0-.1 0 0zm216 94.3l56.8-38.1h45.6-.1V364.7H596.7v302.5h14.1z" } }] }, "name": "zhihu-square", "theme": "filled" };
var ZhihuSquareFilledSvg = ZhihuSquareFilled$2;

var ZhihuSquareFilled = function ZhihuSquareFilled(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ZhihuSquareFilledSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ZhihuSquareFilled.displayName = 'ZhihuSquareFilled';
}
var ZhihuSquareFilled$1 = /*#__PURE__*/React__namespace.forwardRef(ZhihuSquareFilled);

// This icon file is generated automatically.
var ZoomInOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" } }] }, "name": "zoom-in", "theme": "outlined" };
var ZoomInOutlinedSvg = ZoomInOutlined$2;

var ZoomInOutlined = function ZoomInOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ZoomInOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ZoomInOutlined.displayName = 'ZoomInOutlined';
}
var ZoomInOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ZoomInOutlined);

// This icon file is generated automatically.
var ZoomOutOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" } }] }, "name": "zoom-out", "theme": "outlined" };
var ZoomOutOutlinedSvg = ZoomOutOutlined$2;

var ZoomOutOutlined = function ZoomOutOutlined(props, ref) {
  return /*#__PURE__*/React__namespace.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ZoomOutOutlinedSvg
  }));
};
if (process$1.env.NODE_ENV !== 'production') {
  ZoomOutOutlined.displayName = 'ZoomOutOutlined';
}
var ZoomOutOutlined$1 = /*#__PURE__*/React__namespace.forwardRef(ZoomOutOutlined);

function useMemo(getValue, condition, shouldUpdate) {
  var cacheRef = React__namespace.useRef({});
  if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
    cacheRef.current.value = getValue();
    cacheRef.current.condition = condition;
  }
  return cacheRef.current.value;
}

function fillRef(ref, node) {
  if (typeof ref === 'function') {
    ref(node);
  } else if (_typeof(ref) === 'object' && ref && 'current' in ref) {
    ref.current = node;
  }
}

/**
 * Merge refs into one ref function to support ref passing.
 */
function composeRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  var refList = refs.filter(function (ref) {
    return ref;
  });
  if (refList.length <= 1) {
    return refList[0];
  }
  return function (node) {
    refs.forEach(function (ref) {
      fillRef(ref, node);
    });
  };
}
function useComposeRef() {
  for (var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    refs[_key2] = arguments[_key2];
  }
  return useMemo(function () {
    return composeRef.apply(void 0, refs);
  }, refs, function (prev, next) {
    return prev.length !== next.length || prev.every(function (ref, i) {
      return ref !== next[i];
    });
  });
}
/* eslint-enable */

var _excluded$3 = ["className", "component", "viewBox", "spin", "rotate", "tabIndex", "onClick", "children"];
var Icon = /*#__PURE__*/React__namespace.forwardRef(function (props, ref) {
  var className = props.className,
    Component = props.component,
    viewBox = props.viewBox,
    spin = props.spin,
    rotate = props.rotate,
    tabIndex = props.tabIndex,
    onClick = props.onClick,
    children = props.children,
    restProps = _objectWithoutProperties(props, _excluded$3);
  var iconRef = React__namespace.useRef();
  var mergedRef = useComposeRef(iconRef, ref);
  warning(Boolean(Component || children), 'Should have `component` prop or `children`.');
  useInsertStyles(iconRef);
  var _React$useContext = React__namespace.useContext(Context),
    _React$useContext$pre = _React$useContext.prefixCls,
    prefixCls = _React$useContext$pre === void 0 ? 'anticon' : _React$useContext$pre,
    rootClassName = _React$useContext.rootClassName;
  var classString = classnames(rootClassName, prefixCls, className);
  var svgClassString = classnames(_defineProperty({}, "".concat(prefixCls, "-spin"), !!spin));
  var svgStyle = rotate ? {
    msTransform: "rotate(".concat(rotate, "deg)"),
    transform: "rotate(".concat(rotate, "deg)")
  } : undefined;
  var innerSvgProps = _objectSpread2(_objectSpread2({}, svgBaseProps), {}, {
    className: svgClassString,
    style: svgStyle,
    viewBox: viewBox
  });
  if (!viewBox) {
    delete innerSvgProps.viewBox;
  }

  // component > children
  var renderInnerNode = function renderInnerNode() {
    if (Component) {
      return /*#__PURE__*/React__namespace.createElement(Component, innerSvgProps, children);
    }
    if (children) {
      warning(Boolean(viewBox) || React__namespace.Children.count(children) === 1 && /*#__PURE__*/React__namespace.isValidElement(children) && React__namespace.Children.only(children).type === 'use', 'Make sure that you provide correct `viewBox`' + ' prop (default `0 0 1024 1024`) to the icon.');
      return /*#__PURE__*/React__namespace.createElement("svg", _extends({}, innerSvgProps, {
        viewBox: viewBox
      }), children);
    }
    return null;
  };
  var iconTabIndex = tabIndex;
  if (iconTabIndex === undefined && onClick) {
    iconTabIndex = -1;
  }
  return /*#__PURE__*/React__namespace.createElement("span", _extends({
    role: "img"
  }, restProps, {
    ref: mergedRef,
    tabIndex: iconTabIndex,
    onClick: onClick,
    className: classString
  }), renderInnerNode());
});
Icon.displayName = 'AntdIcon';
var Icon$1 = Icon;

var _excluded$2 = ["type", "children"];
var customCache = new Set();
function isValidCustomScriptUrl(scriptUrl) {
  return Boolean(typeof scriptUrl === 'string' && scriptUrl.length && !customCache.has(scriptUrl));
}
function createScriptUrlElements(scriptUrls) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var currentScriptUrl = scriptUrls[index];
  if (isValidCustomScriptUrl(currentScriptUrl)) {
    var script = document.createElement('script');
    script.setAttribute('src', currentScriptUrl);
    script.setAttribute('data-namespace', currentScriptUrl);
    if (scriptUrls.length > index + 1) {
      script.onload = function () {
        createScriptUrlElements(scriptUrls, index + 1);
      };
      script.onerror = function () {
        createScriptUrlElements(scriptUrls, index + 1);
      };
    }
    customCache.add(currentScriptUrl);
    document.body.appendChild(script);
  }
}
function create() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var scriptUrl = options.scriptUrl,
    _options$extraCommonP = options.extraCommonProps,
    extraCommonProps = _options$extraCommonP === void 0 ? {} : _options$extraCommonP;

  /**
   * DOM API required.
   * Make sure in browser environment.
   * The Custom Icon will create a <script/>
   * that loads SVG symbols and insert the SVG Element into the document body.
   */
  if (scriptUrl && typeof document !== 'undefined' && typeof window !== 'undefined' && typeof document.createElement === 'function') {
    if (Array.isArray(scriptUrl)) {
      // 因为iconfont资源会把svg插入before，所以前加载相同type会覆盖后加载，为了数组覆盖顺序，倒叙插入
      createScriptUrlElements(scriptUrl.reverse());
    } else {
      createScriptUrlElements([scriptUrl]);
    }
  }
  var Iconfont = /*#__PURE__*/React__namespace.forwardRef(function (props, ref) {
    var type = props.type,
      children = props.children,
      restProps = _objectWithoutProperties(props, _excluded$2);

    // children > type
    var content = null;
    if (props.type) {
      content = /*#__PURE__*/React__namespace.createElement("use", {
        xlinkHref: "#".concat(type)
      });
    }
    if (children) {
      content = children;
    }
    return /*#__PURE__*/React__namespace.createElement(Icon$1, _extends({}, extraCommonProps, restProps, {
      ref: ref
    }), content);
  });
  Iconfont.displayName = 'Iconfont';
  return Iconfont;
}

var IconProvider = Context.Provider;

var Icons = /*#__PURE__*/Object.freeze({
  __proto__: null,
  IconProvider: IconProvider,
  createFromIconfontCN: create,
  'default': Icon$1,
  AccountBookFilled: AccountBookFilled$1,
  AccountBookOutlined: AccountBookOutlined$1,
  AccountBookTwoTone: AccountBookTwoTone$1,
  AimOutlined: AimOutlined$1,
  AlertFilled: AlertFilled$1,
  AlertOutlined: AlertOutlined$1,
  AlertTwoTone: AlertTwoTone$1,
  AlibabaOutlined: AlibabaOutlined$1,
  AlignCenterOutlined: AlignCenterOutlined$1,
  AlignLeftOutlined: AlignLeftOutlined$1,
  AlignRightOutlined: AlignRightOutlined$1,
  AlipayCircleFilled: AlipayCircleFilled$1,
  AlipayCircleOutlined: AlipayCircleOutlined$1,
  AlipayOutlined: AlipayOutlined$1,
  AlipaySquareFilled: AlipaySquareFilled$1,
  AliwangwangFilled: AliwangwangFilled$1,
  AliwangwangOutlined: AliwangwangOutlined$1,
  AliyunOutlined: AliyunOutlined$1,
  AmazonCircleFilled: AmazonCircleFilled$1,
  AmazonOutlined: AmazonOutlined$1,
  AmazonSquareFilled: AmazonSquareFilled$1,
  AndroidFilled: AndroidFilled$1,
  AndroidOutlined: AndroidOutlined$1,
  AntCloudOutlined: AntCloudOutlined$1,
  AntDesignOutlined: AntDesignOutlined$1,
  ApartmentOutlined: ApartmentOutlined$1,
  ApiFilled: ApiFilled$1,
  ApiOutlined: ApiOutlined$1,
  ApiTwoTone: ApiTwoTone$1,
  AppleFilled: AppleFilled$1,
  AppleOutlined: AppleOutlined$1,
  AppstoreAddOutlined: AppstoreAddOutlined$1,
  AppstoreFilled: AppstoreFilled$1,
  AppstoreOutlined: AppstoreOutlined$1,
  AppstoreTwoTone: AppstoreTwoTone$1,
  AreaChartOutlined: AreaChartOutlined$1,
  ArrowDownOutlined: ArrowDownOutlined$1,
  ArrowLeftOutlined: ArrowLeftOutlined$1,
  ArrowRightOutlined: ArrowRightOutlined$1,
  ArrowUpOutlined: ArrowUpOutlined$1,
  ArrowsAltOutlined: ArrowsAltOutlined$1,
  AudioFilled: AudioFilled$1,
  AudioMutedOutlined: AudioMutedOutlined$1,
  AudioOutlined: AudioOutlined$1,
  AudioTwoTone: AudioTwoTone$1,
  AuditOutlined: AuditOutlined$1,
  BackwardFilled: BackwardFilled$1,
  BackwardOutlined: BackwardOutlined$1,
  BankFilled: BankFilled$1,
  BankOutlined: BankOutlined$1,
  BankTwoTone: BankTwoTone$1,
  BarChartOutlined: BarChartOutlined$1,
  BarcodeOutlined: BarcodeOutlined$1,
  BarsOutlined: BarsOutlined$1,
  BehanceCircleFilled: BehanceCircleFilled$1,
  BehanceOutlined: BehanceOutlined$1,
  BehanceSquareFilled: BehanceSquareFilled$1,
  BehanceSquareOutlined: BehanceSquareOutlined$1,
  BellFilled: BellFilled$1,
  BellOutlined: BellOutlined$1,
  BellTwoTone: BellTwoTone$1,
  BgColorsOutlined: BgColorsOutlined$1,
  BlockOutlined: BlockOutlined$1,
  BoldOutlined: BoldOutlined$1,
  BookFilled: BookFilled$1,
  BookOutlined: BookOutlined$1,
  BookTwoTone: BookTwoTone$1,
  BorderBottomOutlined: BorderBottomOutlined$1,
  BorderHorizontalOutlined: BorderHorizontalOutlined$1,
  BorderInnerOutlined: BorderInnerOutlined$1,
  BorderLeftOutlined: BorderLeftOutlined$1,
  BorderOuterOutlined: BorderOuterOutlined$1,
  BorderOutlined: BorderOutlined$1,
  BorderRightOutlined: BorderRightOutlined$1,
  BorderTopOutlined: BorderTopOutlined$1,
  BorderVerticleOutlined: BorderVerticleOutlined$1,
  BorderlessTableOutlined: BorderlessTableOutlined$1,
  BoxPlotFilled: BoxPlotFilled$1,
  BoxPlotOutlined: BoxPlotOutlined$1,
  BoxPlotTwoTone: BoxPlotTwoTone$1,
  BranchesOutlined: BranchesOutlined$1,
  BugFilled: BugFilled$1,
  BugOutlined: BugOutlined$1,
  BugTwoTone: BugTwoTone$1,
  BuildFilled: BuildFilled$1,
  BuildOutlined: BuildOutlined$1,
  BuildTwoTone: BuildTwoTone$1,
  BulbFilled: BulbFilled$1,
  BulbOutlined: BulbOutlined$1,
  BulbTwoTone: BulbTwoTone$1,
  CalculatorFilled: CalculatorFilled$1,
  CalculatorOutlined: CalculatorOutlined$1,
  CalculatorTwoTone: CalculatorTwoTone$1,
  CalendarFilled: CalendarFilled$1,
  CalendarOutlined: CalendarOutlined$1,
  CalendarTwoTone: CalendarTwoTone$1,
  CameraFilled: CameraFilled$1,
  CameraOutlined: CameraOutlined$1,
  CameraTwoTone: CameraTwoTone$1,
  CarFilled: CarFilled$1,
  CarOutlined: CarOutlined$1,
  CarTwoTone: CarTwoTone$1,
  CaretDownFilled: CaretDownFilled$1,
  CaretDownOutlined: CaretDownOutlined$1,
  CaretLeftFilled: CaretLeftFilled$1,
  CaretLeftOutlined: CaretLeftOutlined$1,
  CaretRightFilled: CaretRightFilled$1,
  CaretRightOutlined: CaretRightOutlined$1,
  CaretUpFilled: CaretUpFilled$1,
  CaretUpOutlined: CaretUpOutlined$1,
  CarryOutFilled: CarryOutFilled$1,
  CarryOutOutlined: CarryOutOutlined$1,
  CarryOutTwoTone: CarryOutTwoTone$1,
  CheckCircleFilled: CheckCircleFilled$1,
  CheckCircleOutlined: CheckCircleOutlined$1,
  CheckCircleTwoTone: CheckCircleTwoTone$1,
  CheckOutlined: CheckOutlined$1,
  CheckSquareFilled: CheckSquareFilled$1,
  CheckSquareOutlined: CheckSquareOutlined$1,
  CheckSquareTwoTone: CheckSquareTwoTone$1,
  ChromeFilled: ChromeFilled$1,
  ChromeOutlined: ChromeOutlined$1,
  CiCircleFilled: CiCircleFilled$1,
  CiCircleOutlined: CiCircleOutlined$1,
  CiCircleTwoTone: CiCircleTwoTone$1,
  CiOutlined: CiOutlined$1,
  CiTwoTone: CiTwoTone$1,
  ClearOutlined: ClearOutlined$1,
  ClockCircleFilled: ClockCircleFilled$1,
  ClockCircleOutlined: ClockCircleOutlined$1,
  ClockCircleTwoTone: ClockCircleTwoTone$1,
  CloseCircleFilled: CloseCircleFilled$1,
  CloseCircleOutlined: CloseCircleOutlined$1,
  CloseCircleTwoTone: CloseCircleTwoTone$1,
  CloseOutlined: CloseOutlined$1,
  CloseSquareFilled: CloseSquareFilled$1,
  CloseSquareOutlined: CloseSquareOutlined$1,
  CloseSquareTwoTone: CloseSquareTwoTone$1,
  CloudDownloadOutlined: CloudDownloadOutlined$1,
  CloudFilled: CloudFilled$1,
  CloudOutlined: CloudOutlined$1,
  CloudServerOutlined: CloudServerOutlined$1,
  CloudSyncOutlined: CloudSyncOutlined$1,
  CloudTwoTone: CloudTwoTone$1,
  CloudUploadOutlined: CloudUploadOutlined$1,
  ClusterOutlined: ClusterOutlined$1,
  CodeFilled: CodeFilled$1,
  CodeOutlined: CodeOutlined$1,
  CodeSandboxCircleFilled: CodeSandboxCircleFilled$1,
  CodeSandboxOutlined: CodeSandboxOutlined$1,
  CodeSandboxSquareFilled: CodeSandboxSquareFilled$1,
  CodeTwoTone: CodeTwoTone$1,
  CodepenCircleFilled: CodepenCircleFilled$1,
  CodepenCircleOutlined: CodepenCircleOutlined$1,
  CodepenOutlined: CodepenOutlined$1,
  CodepenSquareFilled: CodepenSquareFilled$1,
  CoffeeOutlined: CoffeeOutlined$1,
  ColumnHeightOutlined: ColumnHeightOutlined$1,
  ColumnWidthOutlined: ColumnWidthOutlined$1,
  CommentOutlined: CommentOutlined$1,
  CompassFilled: CompassFilled$1,
  CompassOutlined: CompassOutlined$1,
  CompassTwoTone: CompassTwoTone$1,
  CompressOutlined: CompressOutlined$1,
  ConsoleSqlOutlined: ConsoleSqlOutlined$1,
  ContactsFilled: ContactsFilled$1,
  ContactsOutlined: ContactsOutlined$1,
  ContactsTwoTone: ContactsTwoTone$1,
  ContainerFilled: ContainerFilled$1,
  ContainerOutlined: ContainerOutlined$1,
  ContainerTwoTone: ContainerTwoTone$1,
  ControlFilled: ControlFilled$1,
  ControlOutlined: ControlOutlined$1,
  ControlTwoTone: ControlTwoTone$1,
  CopyFilled: CopyFilled$1,
  CopyOutlined: CopyOutlined$1,
  CopyTwoTone: CopyTwoTone$1,
  CopyrightCircleFilled: CopyrightCircleFilled$1,
  CopyrightCircleOutlined: CopyrightCircleOutlined$1,
  CopyrightCircleTwoTone: CopyrightCircleTwoTone$1,
  CopyrightOutlined: CopyrightOutlined$1,
  CopyrightTwoTone: CopyrightTwoTone$1,
  CreditCardFilled: CreditCardFilled$1,
  CreditCardOutlined: CreditCardOutlined$1,
  CreditCardTwoTone: CreditCardTwoTone$1,
  CrownFilled: CrownFilled$1,
  CrownOutlined: CrownOutlined$1,
  CrownTwoTone: CrownTwoTone$1,
  CustomerServiceFilled: CustomerServiceFilled$1,
  CustomerServiceOutlined: CustomerServiceOutlined$1,
  CustomerServiceTwoTone: CustomerServiceTwoTone$1,
  DashOutlined: DashOutlined$1,
  DashboardFilled: DashboardFilled$1,
  DashboardOutlined: DashboardOutlined$1,
  DashboardTwoTone: DashboardTwoTone$1,
  DatabaseFilled: DatabaseFilled$1,
  DatabaseOutlined: DatabaseOutlined$1,
  DatabaseTwoTone: DatabaseTwoTone$1,
  DeleteColumnOutlined: DeleteColumnOutlined$1,
  DeleteFilled: DeleteFilled$1,
  DeleteOutlined: DeleteOutlined$1,
  DeleteRowOutlined: DeleteRowOutlined$1,
  DeleteTwoTone: DeleteTwoTone$1,
  DeliveredProcedureOutlined: DeliveredProcedureOutlined$1,
  DeploymentUnitOutlined: DeploymentUnitOutlined$1,
  DesktopOutlined: DesktopOutlined$1,
  DiffFilled: DiffFilled$1,
  DiffOutlined: DiffOutlined$1,
  DiffTwoTone: DiffTwoTone$1,
  DingdingOutlined: DingdingOutlined$1,
  DingtalkCircleFilled: DingtalkCircleFilled$1,
  DingtalkOutlined: DingtalkOutlined$1,
  DingtalkSquareFilled: DingtalkSquareFilled$1,
  DisconnectOutlined: DisconnectOutlined$1,
  DislikeFilled: DislikeFilled$1,
  DislikeOutlined: DislikeOutlined$1,
  DislikeTwoTone: DislikeTwoTone$1,
  DollarCircleFilled: DollarCircleFilled$1,
  DollarCircleOutlined: DollarCircleOutlined$1,
  DollarCircleTwoTone: DollarCircleTwoTone$1,
  DollarOutlined: DollarOutlined$1,
  DollarTwoTone: DollarTwoTone$1,
  DotChartOutlined: DotChartOutlined$1,
  DoubleLeftOutlined: DoubleLeftOutlined$1,
  DoubleRightOutlined: DoubleRightOutlined$1,
  DownCircleFilled: DownCircleFilled$1,
  DownCircleOutlined: DownCircleOutlined$1,
  DownCircleTwoTone: DownCircleTwoTone$1,
  DownOutlined: DownOutlined$1,
  DownSquareFilled: DownSquareFilled$1,
  DownSquareOutlined: DownSquareOutlined$1,
  DownSquareTwoTone: DownSquareTwoTone$1,
  DownloadOutlined: DownloadOutlined$1,
  DragOutlined: DragOutlined$1,
  DribbbleCircleFilled: DribbbleCircleFilled$1,
  DribbbleOutlined: DribbbleOutlined$1,
  DribbbleSquareFilled: DribbbleSquareFilled$1,
  DribbbleSquareOutlined: DribbbleSquareOutlined$1,
  DropboxCircleFilled: DropboxCircleFilled$1,
  DropboxOutlined: DropboxOutlined$1,
  DropboxSquareFilled: DropboxSquareFilled$1,
  EditFilled: EditFilled$1,
  EditOutlined: EditOutlined$1,
  EditTwoTone: EditTwoTone$1,
  EllipsisOutlined: EllipsisOutlined$1,
  EnterOutlined: EnterOutlined$1,
  EnvironmentFilled: EnvironmentFilled$1,
  EnvironmentOutlined: EnvironmentOutlined$1,
  EnvironmentTwoTone: EnvironmentTwoTone$1,
  EuroCircleFilled: EuroCircleFilled$1,
  EuroCircleOutlined: EuroCircleOutlined$1,
  EuroCircleTwoTone: EuroCircleTwoTone$1,
  EuroOutlined: EuroOutlined$1,
  EuroTwoTone: EuroTwoTone$1,
  ExceptionOutlined: ExceptionOutlined$1,
  ExclamationCircleFilled: ExclamationCircleFilled$1,
  ExclamationCircleOutlined: ExclamationCircleOutlined$1,
  ExclamationCircleTwoTone: ExclamationCircleTwoTone$1,
  ExclamationOutlined: ExclamationOutlined$1,
  ExpandAltOutlined: ExpandAltOutlined$1,
  ExpandOutlined: ExpandOutlined$1,
  ExperimentFilled: ExperimentFilled$1,
  ExperimentOutlined: ExperimentOutlined$1,
  ExperimentTwoTone: ExperimentTwoTone$1,
  ExportOutlined: ExportOutlined$1,
  EyeFilled: EyeFilled$1,
  EyeInvisibleFilled: EyeInvisibleFilled$1,
  EyeInvisibleOutlined: EyeInvisibleOutlined$1,
  EyeInvisibleTwoTone: EyeInvisibleTwoTone$1,
  EyeOutlined: EyeOutlined$1,
  EyeTwoTone: EyeTwoTone$1,
  FacebookFilled: FacebookFilled$1,
  FacebookOutlined: FacebookOutlined$1,
  FallOutlined: FallOutlined$1,
  FastBackwardFilled: FastBackwardFilled$1,
  FastBackwardOutlined: FastBackwardOutlined$1,
  FastForwardFilled: FastForwardFilled$1,
  FastForwardOutlined: FastForwardOutlined$1,
  FieldBinaryOutlined: FieldBinaryOutlined$1,
  FieldNumberOutlined: FieldNumberOutlined$1,
  FieldStringOutlined: FieldStringOutlined$1,
  FieldTimeOutlined: FieldTimeOutlined$1,
  FileAddFilled: FileAddFilled$1,
  FileAddOutlined: FileAddOutlined$1,
  FileAddTwoTone: FileAddTwoTone$1,
  FileDoneOutlined: FileDoneOutlined$1,
  FileExcelFilled: FileExcelFilled$1,
  FileExcelOutlined: FileExcelOutlined$1,
  FileExcelTwoTone: FileExcelTwoTone$1,
  FileExclamationFilled: FileExclamationFilled$1,
  FileExclamationOutlined: FileExclamationOutlined$1,
  FileExclamationTwoTone: FileExclamationTwoTone$1,
  FileFilled: FileFilled$1,
  FileGifOutlined: FileGifOutlined$1,
  FileImageFilled: FileImageFilled$1,
  FileImageOutlined: FileImageOutlined$1,
  FileImageTwoTone: FileImageTwoTone$1,
  FileJpgOutlined: FileJpgOutlined$1,
  FileMarkdownFilled: FileMarkdownFilled$1,
  FileMarkdownOutlined: FileMarkdownOutlined$1,
  FileMarkdownTwoTone: FileMarkdownTwoTone$1,
  FileOutlined: FileOutlined$1,
  FilePdfFilled: FilePdfFilled$1,
  FilePdfOutlined: FilePdfOutlined$1,
  FilePdfTwoTone: FilePdfTwoTone$1,
  FilePptFilled: FilePptFilled$1,
  FilePptOutlined: FilePptOutlined$1,
  FilePptTwoTone: FilePptTwoTone$1,
  FileProtectOutlined: FileProtectOutlined$1,
  FileSearchOutlined: FileSearchOutlined$1,
  FileSyncOutlined: FileSyncOutlined$1,
  FileTextFilled: FileTextFilled$1,
  FileTextOutlined: FileTextOutlined$1,
  FileTextTwoTone: FileTextTwoTone$1,
  FileTwoTone: FileTwoTone$1,
  FileUnknownFilled: FileUnknownFilled$1,
  FileUnknownOutlined: FileUnknownOutlined$1,
  FileUnknownTwoTone: FileUnknownTwoTone$1,
  FileWordFilled: FileWordFilled$1,
  FileWordOutlined: FileWordOutlined$1,
  FileWordTwoTone: FileWordTwoTone$1,
  FileZipFilled: FileZipFilled$1,
  FileZipOutlined: FileZipOutlined$1,
  FileZipTwoTone: FileZipTwoTone$1,
  FilterFilled: FilterFilled$1,
  FilterOutlined: FilterOutlined$1,
  FilterTwoTone: FilterTwoTone$1,
  FireFilled: FireFilled$1,
  FireOutlined: FireOutlined$1,
  FireTwoTone: FireTwoTone$1,
  FlagFilled: FlagFilled$1,
  FlagOutlined: FlagOutlined$1,
  FlagTwoTone: FlagTwoTone$1,
  FolderAddFilled: FolderAddFilled$1,
  FolderAddOutlined: FolderAddOutlined$1,
  FolderAddTwoTone: FolderAddTwoTone$1,
  FolderFilled: FolderFilled$1,
  FolderOpenFilled: FolderOpenFilled$1,
  FolderOpenOutlined: FolderOpenOutlined$1,
  FolderOpenTwoTone: FolderOpenTwoTone$1,
  FolderOutlined: FolderOutlined$1,
  FolderTwoTone: FolderTwoTone$1,
  FolderViewOutlined: FolderViewOutlined$1,
  FontColorsOutlined: FontColorsOutlined$1,
  FontSizeOutlined: FontSizeOutlined$1,
  ForkOutlined: ForkOutlined$1,
  FormOutlined: FormOutlined$1,
  FormatPainterFilled: FormatPainterFilled$1,
  FormatPainterOutlined: FormatPainterOutlined$1,
  ForwardFilled: ForwardFilled$1,
  ForwardOutlined: ForwardOutlined$1,
  FrownFilled: FrownFilled$1,
  FrownOutlined: FrownOutlined$1,
  FrownTwoTone: FrownTwoTone$1,
  FullscreenExitOutlined: FullscreenExitOutlined$1,
  FullscreenOutlined: FullscreenOutlined$1,
  FunctionOutlined: FunctionOutlined$1,
  FundFilled: FundFilled$1,
  FundOutlined: FundOutlined$1,
  FundProjectionScreenOutlined: FundProjectionScreenOutlined$1,
  FundTwoTone: FundTwoTone$1,
  FundViewOutlined: FundViewOutlined$1,
  FunnelPlotFilled: FunnelPlotFilled$1,
  FunnelPlotOutlined: FunnelPlotOutlined$1,
  FunnelPlotTwoTone: FunnelPlotTwoTone$1,
  GatewayOutlined: GatewayOutlined$1,
  GifOutlined: GifOutlined$1,
  GiftFilled: GiftFilled$1,
  GiftOutlined: GiftOutlined$1,
  GiftTwoTone: GiftTwoTone$1,
  GithubFilled: GithubFilled$1,
  GithubOutlined: GithubOutlined$1,
  GitlabFilled: GitlabFilled$1,
  GitlabOutlined: GitlabOutlined$1,
  GlobalOutlined: GlobalOutlined$1,
  GoldFilled: GoldFilled$1,
  GoldOutlined: GoldOutlined$1,
  GoldTwoTone: GoldTwoTone$1,
  GoldenFilled: GoldenFilled$1,
  GoogleCircleFilled: GoogleCircleFilled$1,
  GoogleOutlined: GoogleOutlined$1,
  GooglePlusCircleFilled: GooglePlusCircleFilled$1,
  GooglePlusOutlined: GooglePlusOutlined$1,
  GooglePlusSquareFilled: GooglePlusSquareFilled$1,
  GoogleSquareFilled: GoogleSquareFilled$1,
  GroupOutlined: GroupOutlined$1,
  HddFilled: HddFilled$1,
  HddOutlined: HddOutlined$1,
  HddTwoTone: HddTwoTone$1,
  HeartFilled: HeartFilled$1,
  HeartOutlined: HeartOutlined$1,
  HeartTwoTone: HeartTwoTone$1,
  HeatMapOutlined: HeatMapOutlined$1,
  HighlightFilled: HighlightFilled$1,
  HighlightOutlined: HighlightOutlined$1,
  HighlightTwoTone: HighlightTwoTone$1,
  HistoryOutlined: HistoryOutlined$1,
  HolderOutlined: HolderOutlined$1,
  HomeFilled: HomeFilled$1,
  HomeOutlined: HomeOutlined$1,
  HomeTwoTone: HomeTwoTone$1,
  HourglassFilled: HourglassFilled$1,
  HourglassOutlined: HourglassOutlined$1,
  HourglassTwoTone: HourglassTwoTone$1,
  Html5Filled: Html5Filled$1,
  Html5Outlined: Html5Outlined$1,
  Html5TwoTone: Html5TwoTone$1,
  IdcardFilled: IdcardFilled$1,
  IdcardOutlined: IdcardOutlined$1,
  IdcardTwoTone: IdcardTwoTone$1,
  IeCircleFilled: IeCircleFilled$1,
  IeOutlined: IeOutlined$1,
  IeSquareFilled: IeSquareFilled$1,
  ImportOutlined: ImportOutlined$1,
  InboxOutlined: InboxOutlined$1,
  InfoCircleFilled: InfoCircleFilled$1,
  InfoCircleOutlined: InfoCircleOutlined$1,
  InfoCircleTwoTone: InfoCircleTwoTone$1,
  InfoOutlined: InfoOutlined$1,
  InsertRowAboveOutlined: InsertRowAboveOutlined$1,
  InsertRowBelowOutlined: InsertRowBelowOutlined$1,
  InsertRowLeftOutlined: InsertRowLeftOutlined$1,
  InsertRowRightOutlined: InsertRowRightOutlined$1,
  InstagramFilled: InstagramFilled$1,
  InstagramOutlined: InstagramOutlined$1,
  InsuranceFilled: InsuranceFilled$1,
  InsuranceOutlined: InsuranceOutlined$1,
  InsuranceTwoTone: InsuranceTwoTone$1,
  InteractionFilled: InteractionFilled$1,
  InteractionOutlined: InteractionOutlined$1,
  InteractionTwoTone: InteractionTwoTone$1,
  IssuesCloseOutlined: IssuesCloseOutlined$1,
  ItalicOutlined: ItalicOutlined$1,
  KeyOutlined: KeyOutlined$1,
  LaptopOutlined: LaptopOutlined$1,
  LayoutFilled: LayoutFilled$1,
  LayoutOutlined: LayoutOutlined$1,
  LayoutTwoTone: LayoutTwoTone$1,
  LeftCircleFilled: LeftCircleFilled$1,
  LeftCircleOutlined: LeftCircleOutlined$1,
  LeftCircleTwoTone: LeftCircleTwoTone$1,
  LeftOutlined: LeftOutlined$1,
  LeftSquareFilled: LeftSquareFilled$1,
  LeftSquareOutlined: LeftSquareOutlined$1,
  LeftSquareTwoTone: LeftSquareTwoTone$1,
  LikeFilled: LikeFilled$1,
  LikeOutlined: LikeOutlined$1,
  LikeTwoTone: LikeTwoTone$1,
  LineChartOutlined: LineChartOutlined$1,
  LineHeightOutlined: LineHeightOutlined$1,
  LineOutlined: LineOutlined$1,
  LinkOutlined: LinkOutlined$1,
  LinkedinFilled: LinkedinFilled$1,
  LinkedinOutlined: LinkedinOutlined$1,
  Loading3QuartersOutlined: Loading3QuartersOutlined$1,
  LoadingOutlined: LoadingOutlined$1,
  LockFilled: LockFilled$1,
  LockOutlined: LockOutlined$1,
  LockTwoTone: LockTwoTone$1,
  LoginOutlined: LoginOutlined$1,
  LogoutOutlined: LogoutOutlined$1,
  MacCommandFilled: MacCommandFilled$1,
  MacCommandOutlined: MacCommandOutlined$1,
  MailFilled: MailFilled$1,
  MailOutlined: MailOutlined$1,
  MailTwoTone: MailTwoTone$1,
  ManOutlined: ManOutlined$1,
  MedicineBoxFilled: MedicineBoxFilled$1,
  MedicineBoxOutlined: MedicineBoxOutlined$1,
  MedicineBoxTwoTone: MedicineBoxTwoTone$1,
  MediumCircleFilled: MediumCircleFilled$1,
  MediumOutlined: MediumOutlined$1,
  MediumSquareFilled: MediumSquareFilled$1,
  MediumWorkmarkOutlined: MediumWorkmarkOutlined$1,
  MehFilled: MehFilled$1,
  MehOutlined: MehOutlined$1,
  MehTwoTone: MehTwoTone$1,
  MenuFoldOutlined: MenuFoldOutlined$1,
  MenuOutlined: MenuOutlined$1,
  MenuUnfoldOutlined: MenuUnfoldOutlined$1,
  MergeCellsOutlined: MergeCellsOutlined$1,
  MessageFilled: MessageFilled$1,
  MessageOutlined: MessageOutlined$1,
  MessageTwoTone: MessageTwoTone$1,
  MinusCircleFilled: MinusCircleFilled$1,
  MinusCircleOutlined: MinusCircleOutlined$1,
  MinusCircleTwoTone: MinusCircleTwoTone$1,
  MinusOutlined: MinusOutlined$1,
  MinusSquareFilled: MinusSquareFilled$1,
  MinusSquareOutlined: MinusSquareOutlined$1,
  MinusSquareTwoTone: MinusSquareTwoTone$1,
  MobileFilled: MobileFilled$1,
  MobileOutlined: MobileOutlined$1,
  MobileTwoTone: MobileTwoTone$1,
  MoneyCollectFilled: MoneyCollectFilled$1,
  MoneyCollectOutlined: MoneyCollectOutlined$1,
  MoneyCollectTwoTone: MoneyCollectTwoTone$1,
  MonitorOutlined: MonitorOutlined$1,
  MoreOutlined: MoreOutlined$1,
  NodeCollapseOutlined: NodeCollapseOutlined$1,
  NodeExpandOutlined: NodeExpandOutlined$1,
  NodeIndexOutlined: NodeIndexOutlined$1,
  NotificationFilled: NotificationFilled$1,
  NotificationOutlined: NotificationOutlined$1,
  NotificationTwoTone: NotificationTwoTone$1,
  NumberOutlined: NumberOutlined$1,
  OneToOneOutlined: OneToOneOutlined$1,
  OrderedListOutlined: OrderedListOutlined$1,
  PaperClipOutlined: PaperClipOutlined$1,
  PartitionOutlined: PartitionOutlined$1,
  PauseCircleFilled: PauseCircleFilled$1,
  PauseCircleOutlined: PauseCircleOutlined$1,
  PauseCircleTwoTone: PauseCircleTwoTone$1,
  PauseOutlined: PauseOutlined$1,
  PayCircleFilled: PayCircleFilled$1,
  PayCircleOutlined: PayCircleOutlined$1,
  PercentageOutlined: PercentageOutlined$1,
  PhoneFilled: PhoneFilled$1,
  PhoneOutlined: PhoneOutlined$1,
  PhoneTwoTone: PhoneTwoTone$1,
  PicCenterOutlined: PicCenterOutlined$1,
  PicLeftOutlined: PicLeftOutlined$1,
  PicRightOutlined: PicRightOutlined$1,
  PictureFilled: PictureFilled$1,
  PictureOutlined: PictureOutlined$1,
  PictureTwoTone: PictureTwoTone$1,
  PieChartFilled: PieChartFilled$1,
  PieChartOutlined: PieChartOutlined$1,
  PieChartTwoTone: PieChartTwoTone$1,
  PlayCircleFilled: PlayCircleFilled$1,
  PlayCircleOutlined: PlayCircleOutlined$1,
  PlayCircleTwoTone: PlayCircleTwoTone$1,
  PlaySquareFilled: PlaySquareFilled$1,
  PlaySquareOutlined: PlaySquareOutlined$1,
  PlaySquareTwoTone: PlaySquareTwoTone$1,
  PlusCircleFilled: PlusCircleFilled$1,
  PlusCircleOutlined: PlusCircleOutlined$1,
  PlusCircleTwoTone: PlusCircleTwoTone$1,
  PlusOutlined: PlusOutlined$1,
  PlusSquareFilled: PlusSquareFilled$1,
  PlusSquareOutlined: PlusSquareOutlined$1,
  PlusSquareTwoTone: PlusSquareTwoTone$1,
  PoundCircleFilled: PoundCircleFilled$1,
  PoundCircleOutlined: PoundCircleOutlined$1,
  PoundCircleTwoTone: PoundCircleTwoTone$1,
  PoundOutlined: PoundOutlined$1,
  PoweroffOutlined: PoweroffOutlined$1,
  PrinterFilled: PrinterFilled$1,
  PrinterOutlined: PrinterOutlined$1,
  PrinterTwoTone: PrinterTwoTone$1,
  ProfileFilled: ProfileFilled$1,
  ProfileOutlined: ProfileOutlined$1,
  ProfileTwoTone: ProfileTwoTone$1,
  ProjectFilled: ProjectFilled$1,
  ProjectOutlined: ProjectOutlined$1,
  ProjectTwoTone: ProjectTwoTone$1,
  PropertySafetyFilled: PropertySafetyFilled$1,
  PropertySafetyOutlined: PropertySafetyOutlined$1,
  PropertySafetyTwoTone: PropertySafetyTwoTone$1,
  PullRequestOutlined: PullRequestOutlined$1,
  PushpinFilled: PushpinFilled$1,
  PushpinOutlined: PushpinOutlined$1,
  PushpinTwoTone: PushpinTwoTone$1,
  QqCircleFilled: QqCircleFilled$1,
  QqOutlined: QqOutlined$1,
  QqSquareFilled: QqSquareFilled$1,
  QrcodeOutlined: QrcodeOutlined$1,
  QuestionCircleFilled: QuestionCircleFilled$1,
  QuestionCircleOutlined: QuestionCircleOutlined$1,
  QuestionCircleTwoTone: QuestionCircleTwoTone$1,
  QuestionOutlined: QuestionOutlined$1,
  RadarChartOutlined: RadarChartOutlined$1,
  RadiusBottomleftOutlined: RadiusBottomleftOutlined$1,
  RadiusBottomrightOutlined: RadiusBottomrightOutlined$1,
  RadiusSettingOutlined: RadiusSettingOutlined$1,
  RadiusUpleftOutlined: RadiusUpleftOutlined$1,
  RadiusUprightOutlined: RadiusUprightOutlined$1,
  ReadFilled: ReadFilled$1,
  ReadOutlined: ReadOutlined$1,
  ReconciliationFilled: ReconciliationFilled$1,
  ReconciliationOutlined: ReconciliationOutlined$1,
  ReconciliationTwoTone: ReconciliationTwoTone$1,
  RedEnvelopeFilled: RedEnvelopeFilled$1,
  RedEnvelopeOutlined: RedEnvelopeOutlined$1,
  RedEnvelopeTwoTone: RedEnvelopeTwoTone$1,
  RedditCircleFilled: RedditCircleFilled$1,
  RedditOutlined: RedditOutlined$1,
  RedditSquareFilled: RedditSquareFilled$1,
  RedoOutlined: RedoOutlined$1,
  ReloadOutlined: ReloadOutlined$1,
  RestFilled: RestFilled$1,
  RestOutlined: RestOutlined$1,
  RestTwoTone: RestTwoTone$1,
  RetweetOutlined: RetweetOutlined$1,
  RightCircleFilled: RightCircleFilled$1,
  RightCircleOutlined: RightCircleOutlined$1,
  RightCircleTwoTone: RightCircleTwoTone$1,
  RightOutlined: RightOutlined$1,
  RightSquareFilled: RightSquareFilled$1,
  RightSquareOutlined: RightSquareOutlined$1,
  RightSquareTwoTone: RightSquareTwoTone$1,
  RiseOutlined: RiseOutlined$1,
  RobotFilled: RobotFilled$1,
  RobotOutlined: RobotOutlined$1,
  RocketFilled: RocketFilled$1,
  RocketOutlined: RocketOutlined$1,
  RocketTwoTone: RocketTwoTone$1,
  RollbackOutlined: RollbackOutlined$1,
  RotateLeftOutlined: RotateLeftOutlined$1,
  RotateRightOutlined: RotateRightOutlined$1,
  SafetyCertificateFilled: SafetyCertificateFilled$1,
  SafetyCertificateOutlined: SafetyCertificateOutlined$1,
  SafetyCertificateTwoTone: SafetyCertificateTwoTone$1,
  SafetyOutlined: SafetyOutlined$1,
  SaveFilled: SaveFilled$1,
  SaveOutlined: SaveOutlined$1,
  SaveTwoTone: SaveTwoTone$1,
  ScanOutlined: ScanOutlined$1,
  ScheduleFilled: ScheduleFilled$1,
  ScheduleOutlined: ScheduleOutlined$1,
  ScheduleTwoTone: ScheduleTwoTone$1,
  ScissorOutlined: ScissorOutlined$1,
  SearchOutlined: SearchOutlined$1,
  SecurityScanFilled: SecurityScanFilled$1,
  SecurityScanOutlined: SecurityScanOutlined$1,
  SecurityScanTwoTone: SecurityScanTwoTone$1,
  SelectOutlined: SelectOutlined$1,
  SendOutlined: SendOutlined$1,
  SettingFilled: SettingFilled$1,
  SettingOutlined: SettingOutlined$1,
  SettingTwoTone: SettingTwoTone$1,
  ShakeOutlined: ShakeOutlined$1,
  ShareAltOutlined: ShareAltOutlined$1,
  ShopFilled: ShopFilled$1,
  ShopOutlined: ShopOutlined$1,
  ShopTwoTone: ShopTwoTone$1,
  ShoppingCartOutlined: ShoppingCartOutlined$1,
  ShoppingFilled: ShoppingFilled$1,
  ShoppingOutlined: ShoppingOutlined$1,
  ShoppingTwoTone: ShoppingTwoTone$1,
  ShrinkOutlined: ShrinkOutlined$1,
  SignalFilled: SignalFilled$1,
  SisternodeOutlined: SisternodeOutlined$1,
  SketchCircleFilled: SketchCircleFilled$1,
  SketchOutlined: SketchOutlined$1,
  SketchSquareFilled: SketchSquareFilled$1,
  SkinFilled: SkinFilled$1,
  SkinOutlined: SkinOutlined$1,
  SkinTwoTone: SkinTwoTone$1,
  SkypeFilled: SkypeFilled$1,
  SkypeOutlined: SkypeOutlined$1,
  SlackCircleFilled: SlackCircleFilled$1,
  SlackOutlined: SlackOutlined$1,
  SlackSquareFilled: SlackSquareFilled$1,
  SlackSquareOutlined: SlackSquareOutlined$1,
  SlidersFilled: SlidersFilled$1,
  SlidersOutlined: SlidersOutlined$1,
  SlidersTwoTone: SlidersTwoTone$1,
  SmallDashOutlined: SmallDashOutlined$1,
  SmileFilled: SmileFilled$1,
  SmileOutlined: SmileOutlined$1,
  SmileTwoTone: SmileTwoTone$1,
  SnippetsFilled: SnippetsFilled$1,
  SnippetsOutlined: SnippetsOutlined$1,
  SnippetsTwoTone: SnippetsTwoTone$1,
  SolutionOutlined: SolutionOutlined$1,
  SortAscendingOutlined: SortAscendingOutlined$1,
  SortDescendingOutlined: SortDescendingOutlined$1,
  SoundFilled: SoundFilled$1,
  SoundOutlined: SoundOutlined$1,
  SoundTwoTone: SoundTwoTone$1,
  SplitCellsOutlined: SplitCellsOutlined$1,
  StarFilled: StarFilled$1,
  StarOutlined: StarOutlined$1,
  StarTwoTone: StarTwoTone$1,
  StepBackwardFilled: StepBackwardFilled$1,
  StepBackwardOutlined: StepBackwardOutlined$1,
  StepForwardFilled: StepForwardFilled$1,
  StepForwardOutlined: StepForwardOutlined$1,
  StockOutlined: StockOutlined$1,
  StopFilled: StopFilled$1,
  StopOutlined: StopOutlined$1,
  StopTwoTone: StopTwoTone$1,
  StrikethroughOutlined: StrikethroughOutlined$1,
  SubnodeOutlined: SubnodeOutlined$1,
  SwapLeftOutlined: SwapLeftOutlined$1,
  SwapOutlined: SwapOutlined$1,
  SwapRightOutlined: SwapRightOutlined$1,
  SwitcherFilled: SwitcherFilled$1,
  SwitcherOutlined: SwitcherOutlined$1,
  SwitcherTwoTone: SwitcherTwoTone$1,
  SyncOutlined: SyncOutlined$1,
  TableOutlined: TableOutlined$1,
  TabletFilled: TabletFilled$1,
  TabletOutlined: TabletOutlined$1,
  TabletTwoTone: TabletTwoTone$1,
  TagFilled: TagFilled$1,
  TagOutlined: TagOutlined$1,
  TagTwoTone: TagTwoTone$1,
  TagsFilled: TagsFilled$1,
  TagsOutlined: TagsOutlined$1,
  TagsTwoTone: TagsTwoTone$1,
  TaobaoCircleFilled: TaobaoCircleFilled$1,
  TaobaoCircleOutlined: TaobaoCircleOutlined$1,
  TaobaoOutlined: TaobaoOutlined$1,
  TaobaoSquareFilled: TaobaoSquareFilled$1,
  TeamOutlined: TeamOutlined$1,
  ThunderboltFilled: ThunderboltFilled$1,
  ThunderboltOutlined: ThunderboltOutlined$1,
  ThunderboltTwoTone: ThunderboltTwoTone$1,
  ToTopOutlined: ToTopOutlined$1,
  ToolFilled: ToolFilled$1,
  ToolOutlined: ToolOutlined$1,
  ToolTwoTone: ToolTwoTone$1,
  TrademarkCircleFilled: TrademarkCircleFilled$1,
  TrademarkCircleOutlined: TrademarkCircleOutlined$1,
  TrademarkCircleTwoTone: TrademarkCircleTwoTone$1,
  TrademarkOutlined: TrademarkOutlined$1,
  TransactionOutlined: TransactionOutlined$1,
  TranslationOutlined: TranslationOutlined$1,
  TrophyFilled: TrophyFilled$1,
  TrophyOutlined: TrophyOutlined$1,
  TrophyTwoTone: TrophyTwoTone$1,
  TwitterCircleFilled: TwitterCircleFilled$1,
  TwitterOutlined: TwitterOutlined$1,
  TwitterSquareFilled: TwitterSquareFilled$1,
  UnderlineOutlined: UnderlineOutlined$1,
  UndoOutlined: UndoOutlined$1,
  UngroupOutlined: UngroupOutlined$1,
  UnlockFilled: UnlockFilled$1,
  UnlockOutlined: UnlockOutlined$1,
  UnlockTwoTone: UnlockTwoTone$1,
  UnorderedListOutlined: UnorderedListOutlined$1,
  UpCircleFilled: UpCircleFilled$1,
  UpCircleOutlined: UpCircleOutlined$1,
  UpCircleTwoTone: UpCircleTwoTone$1,
  UpOutlined: UpOutlined$1,
  UpSquareFilled: UpSquareFilled$1,
  UpSquareOutlined: UpSquareOutlined$1,
  UpSquareTwoTone: UpSquareTwoTone$1,
  UploadOutlined: UploadOutlined$1,
  UsbFilled: UsbFilled$1,
  UsbOutlined: UsbOutlined$1,
  UsbTwoTone: UsbTwoTone$1,
  UserAddOutlined: UserAddOutlined$1,
  UserDeleteOutlined: UserDeleteOutlined$1,
  UserOutlined: UserOutlined$1,
  UserSwitchOutlined: UserSwitchOutlined$1,
  UsergroupAddOutlined: UsergroupAddOutlined$1,
  UsergroupDeleteOutlined: UsergroupDeleteOutlined$1,
  VerifiedOutlined: VerifiedOutlined$1,
  VerticalAlignBottomOutlined: VerticalAlignBottomOutlined$1,
  VerticalAlignMiddleOutlined: VerticalAlignMiddleOutlined$1,
  VerticalAlignTopOutlined: VerticalAlignTopOutlined$1,
  VerticalLeftOutlined: VerticalLeftOutlined$1,
  VerticalRightOutlined: VerticalRightOutlined$1,
  VideoCameraAddOutlined: VideoCameraAddOutlined$1,
  VideoCameraFilled: VideoCameraFilled$1,
  VideoCameraOutlined: VideoCameraOutlined$1,
  VideoCameraTwoTone: VideoCameraTwoTone$1,
  WalletFilled: WalletFilled$1,
  WalletOutlined: WalletOutlined$1,
  WalletTwoTone: WalletTwoTone$1,
  WarningFilled: WarningFilled$1,
  WarningOutlined: WarningOutlined$1,
  WarningTwoTone: WarningTwoTone$1,
  WechatFilled: WechatFilled$1,
  WechatOutlined: WechatOutlined$1,
  WeiboCircleFilled: WeiboCircleFilled$1,
  WeiboCircleOutlined: WeiboCircleOutlined$1,
  WeiboOutlined: WeiboOutlined$1,
  WeiboSquareFilled: WeiboSquareFilled$1,
  WeiboSquareOutlined: WeiboSquareOutlined$1,
  WhatsAppOutlined: WhatsAppOutlined$1,
  WifiOutlined: WifiOutlined$1,
  WindowsFilled: WindowsFilled$1,
  WindowsOutlined: WindowsOutlined$1,
  WomanOutlined: WomanOutlined$1,
  YahooFilled: YahooFilled$1,
  YahooOutlined: YahooOutlined$1,
  YoutubeFilled: YoutubeFilled$1,
  YoutubeOutlined: YoutubeOutlined$1,
  YuqueFilled: YuqueFilled$1,
  YuqueOutlined: YuqueOutlined$1,
  ZhihuCircleFilled: ZhihuCircleFilled$1,
  ZhihuOutlined: ZhihuOutlined$1,
  ZhihuSquareFilled: ZhihuSquareFilled$1,
  ZoomInOutlined: ZoomInOutlined$1,
  ZoomOutOutlined: ZoomOutOutlined$1,
  setTwoToneColor: setTwoToneColor,
  getTwoToneColor: getTwoToneColor
});

var pageValues = [10, 20, 50, 100];
function Pagination(_ref) {
  var _ref$page = _ref.page,
    page = _ref$page === void 0 ? 0 : _ref$page,
    _ref$totalPages = _ref.totalPages,
    totalPages = _ref$totalPages === void 0 ? 0 : _ref$totalPages,
    _ref$goPrev = _ref.goPrev,
    goPrev = _ref$goPrev === void 0 ? function () {} : _ref$goPrev,
    _ref$goNext = _ref.goNext,
    goNext = _ref$goNext === void 0 ? function () {} : _ref$goNext,
    _ref$canGoNext = _ref.canGoNext,
    canGoNext = _ref$canGoNext === void 0 ? false : _ref$canGoNext,
    _ref$canGoPrev = _ref.canGoPrev,
    canGoPrev = _ref$canGoPrev === void 0 ? false : _ref$canGoPrev,
    _ref$loaded = _ref.loaded,
    loaded = _ref$loaded === void 0 ? true : _ref$loaded,
    totalItems = _ref.totalItems,
    doTotalItems = _ref.doTotalItems,
    _ref$perPage = _ref.perPage,
    perPage = _ref$perPage === void 0 ? 10 : _ref$perPage,
    _ref$arrowIcons = _ref.arrowIcons,
    arrowIcons = _ref$arrowIcons === void 0 ? false : _ref$arrowIcons,
    onChangePagination = _ref.onChangePagination,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function (s) {
      return s;
    } : _ref$t,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: formatClassname(['default-pagination']),
    children: [typeof onChangePagination === 'function' ? /*#__PURE__*/jsxRuntime.jsx("div", {
      children: /*#__PURE__*/jsxRuntime.jsx(antd.Select, {
        value: perPage,
        onChange: onChangePagination,
        children: pageValues.map(function (v) {
          return /*#__PURE__*/jsxRuntime.jsxs(antd.Select.Option, {
            value: v,
            children: [v, " / ", t('Page')]
          }, "pages".concat(v));
        })
      })
    }) : null, /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "pages flex-column",
      children: /*#__PURE__*/jsxRuntime.jsx("span", {
        children: isMobile ? /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
          children: [page, ' ', t('of'), ' ', totalPages || 1]
        }) : doTotalItems ? totalItems ? /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
          children: [page === 1 ? 1 : (page - 1) * perPage, '-', totalItems <= perPage ? totalItems : canGoNext ? page * perPage : totalItems, loaded ? " ".concat(t('of'), " ").concat(totalItems || "") : '']
        }) : "0 ".concat(t('of'), " 0") : /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
          children: [t('Page'), ' ', page, ' ', loaded ? "/ ".concat(totalPages || "") : '']
        })
      })
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: formatClassname(['buttons', (arrowIcons || isMobile) && 'w-arrow-icons']),
      children: arrowIcons || isMobile ? /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [/*#__PURE__*/jsxRuntime.jsx(antd.Button, {
          onClick: goPrev,
          disabled: !canGoPrev,
          size: "middle",
          icon: /*#__PURE__*/jsxRuntime.jsx(LeftOutlined$1, {})
        }), /*#__PURE__*/jsxRuntime.jsx(antd.Button, {
          onClick: goNext,
          disabled: !canGoNext,
          size: "middle",
          icon: /*#__PURE__*/jsxRuntime.jsx(RightOutlined$1, {})
        })]
      }) : /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [/*#__PURE__*/jsxRuntime.jsx(antd.Button, {
          onClick: goPrev,
          disabled: !canGoPrev,
          size: "middle",
          children: t('Previous')
        }), /*#__PURE__*/jsxRuntime.jsx(antd.Button, {
          onClick: goNext,
          disabled: !canGoNext,
          size: "middle",
          children: t('Next')
        })]
      })
    })]
  });
}
Pagination.propTypes = {
  t: PropTypes__default["default"].func,
  page: PropTypes__default["default"].number,
  totalPages: PropTypes__default["default"].number,
  goPrev: PropTypes__default["default"].func,
  goNext: PropTypes__default["default"].func,
  canGoNext: PropTypes__default["default"].bool,
  canGoPrev: PropTypes__default["default"].bool,
  loaded: PropTypes__default["default"].bool,
  totalItems: PropTypes__default["default"].number,
  doTotalItems: PropTypes__default["default"].bool,
  perPage: PropTypes__default["default"].number,
  arrowIcons: PropTypes__default["default"].any,
  onChangePagination: PropTypes__default["default"].any,
  isMobile: PropTypes__default["default"].bool
};

var _excluded$1 = ["size", "maxHeight", "dataSource", "columns", "pagination"];
function StickyTable(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? null : _ref$size,
    _ref$maxHeight = _ref.maxHeight,
    maxHeight = _ref$maxHeight === void 0 ? 300 : _ref$maxHeight,
    _ref$dataSource = _ref.dataSource,
    dataSource = _ref$dataSource === void 0 ? [] : _ref$dataSource,
    _ref$columns = _ref.columns,
    columns = _ref$columns === void 0 ? {} : _ref$columns,
    _ref$pagination = _ref.pagination,
    pagination = _ref$pagination === void 0 ? false : _ref$pagination,
    props = _objectWithoutProperties$1(_ref, _excluded$1);
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    className: "daf-sticky-table",
    children: /*#__PURE__*/jsxRuntime.jsx(antd.Table, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
      size: size,
      scroll: true,
      sticky: true,
      style: {
        maxHeight: maxHeight
      },
      dataSource: dataSource,
      columns: columns,
      pagination: pagination
    }))
  });
}
StickyTable.propTypes = {
  size: PropTypes__default["default"].any,
  maxHeight: PropTypes__default["default"].number,
  dataSource: PropTypes__default["default"].array,
  columns: PropTypes__default["default"].object,
  pagination: PropTypes__default["default"].any
};

var BTN_TYPES = {
  DASHED: 'dashed',
  DEFAULT: 'default',
  GHOST: 'ghost',
  LINK: 'link',
  PRIMARY: 'primary',
  TEXT: 'text'
};
var BTN_SIZE = {
  SM: 'small',
  MD: 'middle',
  LG: 'large'
};

function DafButton(_ref) {
  var _ref$content = _ref.content,
    content = _ref$content === void 0 ? '' : _ref$content,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? BTN_SIZE.MD : _ref$size,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? BTN_TYPES.PRIMARY : _ref$type,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? null : _ref$icon;
  return /*#__PURE__*/jsxRuntime.jsx(antd.Button, {
    icon: icon,
    type: type,
    size: size,
    children: content
  });
}
DafButton.propTypes = {
  content: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOf(['large', 'middle', 'small']),
  type: PropTypes__default["default"].oneOf(['dashed', 'default', 'ghost', 'link', 'primary', 'text']),
  icon: PropTypes__default["default"].node
};
DafButton.defaultProps = {
  content: '',
  size: BTN_SIZE.MD,
  type: BTN_TYPES.PRIMARY
};

function FilterButton(_ref) {
  var onClick = _ref.onClick,
    isActive = _ref.isActive,
    children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    className: "daf-filter-btn",
    children: /*#__PURE__*/jsxRuntime.jsx(antd.Button, {
      onClick: onClick,
      icon: /*#__PURE__*/jsxRuntime.jsx(CustomIcon, {
        name: "Filter",
        width: 12,
        height: 12
      }),
      className: formatClassname(["ml-2 btn-icon custom-btn", isActive && 'selected', className]),
      children: children
    })
  });
}
FilterButton.propTypes = {
  onClick: PropTypes__default["default"].func,
  isActive: PropTypes__default["default"].bool,
  children: PropTypes__default["default"].any,
  className: PropTypes__default["default"].string
};

var _excluded = ["icon"];
function GetIcon(_ref) {
  var icon = _ref.icon,
    props = _objectWithoutProperties$1(_ref, _excluded);
  var Icon = CloseOutlined$1;
  if (Icons[icon]) {
    Icon = Icons[icon];
  } else {
    return /*#__PURE__*/jsxRuntime.jsx("span", {
      role: "img",
      className: "anticon ",
      style: props.spanStyle || {},
      children: /*#__PURE__*/jsxRuntime.jsx("i", {
        className: "ri-".concat(icon).concat(props.type ? "-".concat(props.type) : '', " ").concat(props.size ? "ri-".concat(props.size) : '1x', " remixicon"),
        style: props.style || {}
      })
    }); // <RemixIcon name={icon} {...props} />
  }

  return /*#__PURE__*/jsxRuntime.jsx(Icon, _objectSpread2$1({}, props));
}
GetIcon.propTypes = {
  icon: PropTypes__default["default"].any
};

var hasFilter = function hasFilter() {
  var activeFilters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(activeFilters || {}).find(function (k) {
    return !['page', 'pageSize', 'sortBy', 'sortDir', 'search', 'searchParams'].includes(k);
  });
};

var isNotEmpty = function isNotEmpty(myString) {
  return /\S/.test(myString);
};
var useOutsideAlerter = function useOutsideAlerter(ref, optionalRef, handler, dontCloseOnClickAway) {
  React.useEffect(function () {
    function handleClickOutside(event) {
      if (!dontCloseOnClickAway) {
        // First if with optional ref, the second with only one
        if (optionalRef) {
          if (ref.current && optionalRef.current && !ref.current.contains(event.target) && !optionalRef.current.contains(event.target)) {
            handler();
          }
        } else if (ref.current && !ref.current.contains(event.target)) {
          handler();
        }
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, dontCloseOnClickAway]);
};
var SearchFilters = function SearchFilters(_ref) {
  var _ref$filtersConfig = _ref.filtersConfig,
    filtersConfig = _ref$filtersConfig === void 0 ? {} : _ref$filtersConfig,
    _ref$onSearch = _ref.onSearch,
    onSearch = _ref$onSearch === void 0 ? function () {} : _ref$onSearch,
    _ref$setHasError = _ref.setHasError,
    setHasError = _ref$setHasError === void 0 ? function () {} : _ref$setHasError,
    _ref$hasError = _ref.hasError,
    hasError = _ref$hasError === void 0 ? false : _ref$hasError,
    _ref$setShowFilters = _ref.setShowFilters,
    setShowFilters = _ref$setShowFilters === void 0 ? function () {} : _ref$setShowFilters,
    _ref$activeFilters = _ref.activeFilters,
    activeFilters = _ref$activeFilters === void 0 ? {} : _ref$activeFilters,
    _ref$canClear = _ref.canClear,
    canClear = _ref$canClear === void 0 ? false : _ref$canClear,
    _ref$showFilter = _ref.showFilter,
    showFilter = _ref$showFilter === void 0 ? true : _ref$showFilter,
    className = _ref.className,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function (s) {
      return s;
    } : _ref$t;
  var ref = React.useRef();
  var optRef = React.useRef();
  var _useState = React.useState(false),
    _useState2 = _slicedToArray$1(_useState, 2),
    typeIsOpen = _useState2[0],
    setTypeIsOpen = _useState2[1];
  var _useState3 = React.useState(''),
    _useState4 = _slicedToArray$1(_useState3, 2),
    lastInputValue = _useState4[0],
    setLastInputValue = _useState4[1];
  var _useState5 = React.useState(activeFilters.searchParams || Object.keys(filtersConfig)),
    _useState6 = _slicedToArray$1(_useState5, 1),
    activeFilter = _useState6[0];
  var _useState7 = React.useState(false),
    _useState8 = _slicedToArray$1(_useState7, 2),
    isTyping = _useState8[0],
    setIsTyping = _useState8[1];
  var _useState9 = React.useState(''),
    _useState10 = _slicedToArray$1(_useState9, 2),
    inputValue = _useState10[0],
    setInputValue = _useState10[1];
  useOutsideAlerter(ref, optRef, function () {
    return setTypeIsOpen(false);
  }, !typeIsOpen);
  React.useEffect(function () {
    if (activeFilters.search) {
      setInputValue(activeFilters.search);
      setLastInputValue(activeFilters.search);
    }
  }, []);
  React.useEffect(function () {
    if (hasFilter(activeFilters || {})) {
      setShowFilters(true);
    }
  }, []);
  React.useEffect(function () {
    if (hasError) {
      setHasError(false);
    }
    if (isNotEmpty(inputValue)) {
      setIsTyping(true);
    } else if (isTyping) {
      setIsTyping(false);
    }
  }, [activeFilter, inputValue]);
  var closeClicked = function closeClicked() {
    setInputValue('');
    setLastInputValue('');
    onSearch(null, null);
  };
  var onSubmit = function onSubmit() {
    var isClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (lastInputValue === inputValue) {
      return;
    }
    setLastInputValue(inputValue);
    if (isNotEmpty(inputValue) && !isClose) {
      onSearch(activeFilter, inputValue);
    } else {
      onSearch(null, null);
    }
  };
  var openIfClosed = function openIfClosed() {
  };
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: formatClassname(['daf-search-filters', hasError && 'error', className]),
    children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "input-container",
      ref: ref,
      children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "input ".concat(typeIsOpen && 'type-is-open'),
        children: [/*#__PURE__*/jsxRuntime.jsx("div", {
          onClick: openIfClosed,
          className: "flex-1",
          children: /*#__PURE__*/jsxRuntime.jsx("input", {
            placeholder: t('Search'),
            value: inputValue,
            onKeyUp: function onKeyUp(e) {
              if (e.key === 'Enter') {
                onSubmit();
                // setTypeIsOpen(false);
              }
            },

            onBlur: function onBlur() {
              onSubmit();
            },
            onChange: function onChange(e) {
              e.persist();
              setInputValue(e.target.value);
            },
            style: {
              paddingRight: isTyping && 30
            }
          })
        }), /*#__PURE__*/jsxRuntime.jsx("div", {
          className: "search-icon",
          onClick: openIfClosed,
          children: /*#__PURE__*/jsxRuntime.jsx(SearchOutlined$1, {})
        }), (isTyping || canClear) && lastInputValue.length ? /*#__PURE__*/jsxRuntime.jsx("div", {
          className: "mr",
          onClick: closeClicked,
          children: /*#__PURE__*/jsxRuntime.jsx(CloseOutlined$1, {})
        }) : null]
      }), hasError && /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "error-container",
        children: [/*#__PURE__*/jsxRuntime.jsx(ExclamationCircleFilled$1, {}), /*#__PURE__*/jsxRuntime.jsx("label", {
          style: {
            fontSize: 12
          },
          children: t('Oops, looks like there are no search matches. Please try again!')
        })]
      })]
    }), showFilter && /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "flex flex-column",
      children: /*#__PURE__*/jsxRuntime.jsx(antd.Button, {
        className: "ml-3 flex-1",
        onClick: function onClick() {
          setShowFilters(function (p) {
            return !p;
          });
        },
        children: /*#__PURE__*/jsxRuntime.jsx("div", {
          className: "flex flex-column justify-content-center",
          children: /*#__PURE__*/jsxRuntime.jsx(CustomIcon, {
            name: "Filter",
            width: 16,
            height: 16
          })
        })
      })
    })]
  });
};
SearchFilters.propTypes = {
  filtersConfig: PropTypes__default["default"].any,
  onSearch: PropTypes__default["default"].func,
  setHasError: PropTypes__default["default"].func,
  hasError: PropTypes__default["default"].bool,
  setShowFilters: PropTypes__default["default"].func,
  showFilters: PropTypes__default["default"].bool,
  activeFilters: PropTypes__default["default"].object,
  canClear: PropTypes__default["default"].bool,
  showFilter: PropTypes__default["default"].any,
  clearFilters: PropTypes__default["default"].func,
  className: PropTypes__default["default"].string,
  t: PropTypes__default["default"].func
};

function SettingsPopover(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    className: "daf-settings-popover",
    children: children
  });
}
SettingsPopover.propTypes = {
  children: PropTypes__default["default"].node
};

function FormPopover(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    renderContent = _ref.renderContent,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? '' : _ref$description;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "daf-form-popover",
    children: [/*#__PURE__*/jsxRuntime.jsx("h2", {
      children: title
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "content",
      children: typeof renderContent === 'function' ? renderContent() : /*#__PURE__*/jsxRuntime.jsx("p", {
        children: description
      })
    })]
  });
}
FormPopover.propTypes = {
  title: PropTypes__default["default"].string,
  description: PropTypes__default["default"].string,
  renderContent: PropTypes__default["default"].any
};

var isChild = function isChild(obj, parentObj) {
  while (obj !== undefined && obj != null && obj.tagName.toUpperCase() !== 'BODY') {
    if (obj === parentObj) {
      return true;
    }
    obj = obj.parentNode;
  }
  return false;
};
function GoToSelect(_ref) {
  var value = _ref.value,
    children = _ref.children,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$setValue = _ref.setValue,
    setValue = _ref$setValue === void 0 ? function () {} : _ref$setValue,
    className = _ref.className,
    _ref$mainClassName = _ref.mainClassName,
    mainClassName = _ref$mainClassName === void 0 ? '.main-project-container' : _ref$mainClassName,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function (s) {
      return s;
    } : _ref$t;
  var ref = React.useRef();
  var clickCallback = React.useCallback(function (e) {
    if (e.target.className === 'ant-select-item-option-content' || e.target.className === 'ant-select-item ant-select-item-option ant-select-item-option-active ant-select-item-option-selected') {
      return;
    }
    if (!isChild(e.target, ref.current)) {
      setValue(undefined);
    }
  }, []);
  var scrollCallback = React.useCallback(function () {
    setValue(undefined);
  }, []);
  React.useEffect(function () {
    var _cont = document.querySelector(mainClassName);
    if (value) {
      window.addEventListener('click', clickCallback);
      setTimeout(function () {
        if (_cont) {
          _cont.addEventListener('scroll', scrollCallback);
        }
      }, 1000);
    }
    return function () {
      window.removeEventListener('click', clickCallback);
      if (_cont) {
        _cont.removeEventListener('scroll', scrollCallback);
      }
    };
  }, [value]);
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: formatClassname([className, 'daf-go-to-select']),
    children: [/*#__PURE__*/jsxRuntime.jsx("div", {
      className: "flex flex-1",
      ref: ref,
      children: /*#__PURE__*/jsxRuntime.jsx(antd.Select, {
        className: "flex-1",
        placeholder: t('Jump to key sections of the analysis'),
        value: value,
        onChange: onChange,
        showSearch: true,
        filterOption: filterSelectOptions,
        children: options.map(function (opt) {
          return /*#__PURE__*/jsxRuntime.jsx(antd.Select.Option, {
            value: opt.key,
            children: t(opt.label)
          }, "options-".concat(opt.key));
        })
      })
    }), children]
  });
}
GoToSelect.propTypes = {
  value: PropTypes__default["default"].any,
  children: PropTypes__default["default"].node,
  options: PropTypes__default["default"].array,
  onChange: PropTypes__default["default"].func,
  setValue: PropTypes__default["default"].func,
  className: PropTypes__default["default"].any,
  mainClassName: PropTypes__default["default"].string,
  t: PropTypes__default["default"].func
};

function Tags(_ref) {
  var _ref$tags = _ref.tags,
    tags = _ref$tags === void 0 ? [] : _ref$tags;
  var mainTags = _toConsumableArray(tags).splice(0, 3);
  var otherTags = _toConsumableArray(tags).splice(3, tags.length - 1);
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "flex ml-3",
    children: [mainTags.map(function (t, i) {
      return /*#__PURE__*/jsxRuntime.jsx(antd.Tag, {
        color: t.color || 'default',
        children: t.label
      }, "tag-".concat(i));
    }), !!otherTags.length && /*#__PURE__*/jsxRuntime.jsx(antd.Tooltip, {
      placement: "bottom",
      title: /*#__PURE__*/jsxRuntime.jsx("div", {
        children: otherTags.map(function (t, i) {
          return /*#__PURE__*/jsxRuntime.jsxs(React__default["default"].Fragment, {
            children: [t.label, i !== otherTags.length - 1 && /*#__PURE__*/jsxRuntime.jsx("br", {})]
          }, "other-tags-p-".concat(i));
        })
      }),
      children: /*#__PURE__*/jsxRuntime.jsxs(antd.Tag, {
        children: ["+", otherTags.length]
      })
    })]
  });
}

function Buttons(_ref) {
  var _ref$actionButtons = _ref.actionButtons,
    actionButtons = _ref$actionButtons === void 0 ? [] : _ref$actionButtons,
    _ref$extraButtons = _ref.extraButtons,
    extraButtons = _ref$extraButtons === void 0 ? [] : _ref$extraButtons;
  var _useState = React.useState(0),
    _useState2 = _slicedToArray$1(_useState, 2),
    minWidth = _useState2[0],
    setMinWidth = _useState2[1];
  React.useEffect(function () {
    var _minWidth = minWidth;
    actionButtons.forEach(function (_, i) {
      var _btn = document.getElementById("header-btn-".concat(i));
      var _width = parseInt(_btn.offsetWidth);
      if (_width > _minWidth) {
        _minWidth = _width;
      }
    });
    setMinWidth(_minWidth);
  }, [actionButtons]);
  var renderButtons = function renderButtons(b, i) {
    var _button = /*#__PURE__*/jsxRuntime.jsx("div", {
      children: /*#__PURE__*/jsxRuntime.jsx(antd.Tooltip, {
        title: b.tooltip,
        children: /*#__PURE__*/jsxRuntime.jsx(antd.Button, {
          type: b.type,
          id: "header-btn-".concat(i),
          icon: b.icon,
          onClick: b.onClick,
          className: b.className,
          disabled: b.disabled,
          style: _objectSpread2$1({
            minWidth: b.noMinWidth ? undefined : minWidth ? minWidth : undefined
          }, (b === null || b === void 0 ? void 0 : b.style) || {}),
          children: b.label
        })
      })
    }, "action-btn-".concat(i, "-").concat(b === null || b === void 0 ? void 0 : b.key));
    if (b.tooltip) {
      return /*#__PURE__*/jsxRuntime.jsx(antd.Tooltip, {
        title: b.tooltip,
        children: _button
      });
    }
    if (b.popConfirm) {
      return /*#__PURE__*/jsxRuntime.jsx(antd.Popconfirm, _objectSpread2$1(_objectSpread2$1({}, b.popConfirm), {}, {
        children: _button
      }));
    }
    return _button;
  };
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "buttons-cont",
    children: [actionButtons.map(renderButtons), !!extraButtons.length && /*#__PURE__*/jsxRuntime.jsx("div", {
      children: /*#__PURE__*/jsxRuntime.jsx(antd.Dropdown, {
        menu: {
          items: extraButtons
        },
        trigger: "click",
        placement: "bottomRight",
        children: /*#__PURE__*/jsxRuntime.jsx("a", {
          onClick: function onClick(e) {
            return e.preventDefault();
          },
          children: /*#__PURE__*/jsxRuntime.jsx(antd.Button, {
            icon: /*#__PURE__*/jsxRuntime.jsx(CustomIcon, {
              name: "More",
              width: 3,
              height: 13
            })
          })
        })
      })
    })]
  });
}

var Paragraph = antd.Typography.Paragraph;
var useHeader = function useHeader(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$tooltip = _ref.tooltip,
    tooltip = _ref$tooltip === void 0 ? '' : _ref$tooltip,
    _ref$supportText = _ref.supportText,
    supportText = _ref$supportText === void 0 ? '' : _ref$supportText,
    _ref$tags = _ref.tags,
    tags = _ref$tags === void 0 ? [] : _ref$tags,
    _ref$actionButtons = _ref.actionButtons,
    _actionButtons = _ref$actionButtons === void 0 ? [] : _ref$actionButtons,
    titleTooltip = _ref.titleTooltip,
    className = _ref.className,
    _ref$addedHeader = _ref.addedHeader,
    addedHeader = _ref$addedHeader === void 0 ? null : _ref$addedHeader,
    _ref$extraButtons = _ref.extraButtons,
    _extraButtons = _ref$extraButtons === void 0 ? [] : _ref$extraButtons,
    onDownload = _ref.onDownload;
  var actionButtons = onDownload && _actionButtons.length < 3 ? [].concat(_toConsumableArray(_actionButtons), [{
    onClick: onDownload,
    disabled: true,
    icon: /*#__PURE__*/jsxRuntime.jsx(DownloadOutlined$1, {}),
    key: 'download',
    noMinWidth: true,
    className: 'download-btn'
  }]) : _actionButtons;
  var extraButtons = onDownload && _actionButtons.length >= 3 ? [].concat(_toConsumableArray(_extraButtons), [{
    onClick: onDownload,
    disabled: true,
    label: 'Download',
    key: 'download'
  }]) : _extraButtons;
  var mainCont = React.useRef();
  var buttonCont = React.useRef();
  var _useState = React.useState(600),
    _useState2 = _slicedToArray$1(_useState, 2),
    mainContWidth = _useState2[0],
    setMainContWidth = _useState2[1];
  var _useState3 = React.useState(0),
    _useState4 = _slicedToArray$1(_useState3, 2),
    buttonContWidth = _useState4[0],
    setButtonContWidth = _useState4[1];
  var hasSupportText = !!(supportText !== null && supportText !== void 0 && supportText.length);
  var hasTags = !!(tags !== null && tags !== void 0 && tags.length);
  var hasButtons = !!(actionButtons !== null && actionButtons !== void 0 && actionButtons.length || extraButtons !== null && extraButtons !== void 0 && extraButtons.length);
  React.useEffect(function () {
    var mainContObserver = new ResizeObserver(function (entries) {
      var _mainEntry = entries[0];
      if (_mainEntry) {
        var _mainWidth = _mainEntry.contentRect.width;
        setMainContWidth(_mainWidth);
      }
    });
    mainContObserver.observe(mainCont.current);
    var buttonContObserver;
    if (hasButtons) {
      buttonContObserver = new ResizeObserver(function (entries) {
        var _buttonEntry = entries[0];
        if (_buttonEntry) {
          var _btnWidth = _buttonEntry.contentRect.width;
          setButtonContWidth(_btnWidth);
        }
      });
    }
    if (hasButtons) {
      buttonContObserver.observe(buttonCont.current);
    }
    return function () {
      mainContObserver.disconnect();
      if (hasButtons) {
        buttonContObserver.disconnect();
      }
    };
  }, []);
  var maxWidth = React.useMemo(function () {
    return mainContWidth - buttonContWidth;
  }, [mainContWidth, buttonContWidth]);
  var renderMainCont = function renderMainCont() {
    return /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: formatClassname(['main-cont flex', className]),
      ref: mainCont,
      children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "flex-1 flex flex-column justify-content-center",
        children: [typeof title === 'string' ? /*#__PURE__*/jsxRuntime.jsxs("div", {
          className: formatClassname(['title flex', hasSupportText && 'mb-1']),
          children: [/*#__PURE__*/jsxRuntime.jsx(antd.Tooltip, {
            title: titleTooltip || title,
            children: /*#__PURE__*/jsxRuntime.jsx("h2", {
              className: formatClassname(['mb-0 mr-1', hasButtons && 'limited']),
              children: title
            })
          }), !!tooltip && /*#__PURE__*/jsxRuntime.jsx("div", {
            className: "flex flex-column justify-content-center",
            children: typeof tooltip === 'string' ? /*#__PURE__*/jsxRuntime.jsx(antd.Tooltip, {
              title: tooltip,
              children: /*#__PURE__*/jsxRuntime.jsx(InfoCircleOutlined$1, {})
            }) : _typeof$1(tooltip) === 'object' ? /*#__PURE__*/jsxRuntime.jsx(antd.Popover, {
              rootClassName: formatClassname(['header-tooltip', tooltip.className]),
              title: tooltip.title,
              content: tooltip.content,
              children: /*#__PURE__*/jsxRuntime.jsx(InfoCircleOutlined$1, {})
            }) : null
          }), hasTags && /*#__PURE__*/jsxRuntime.jsx(Tags, {
            tags: tags
          })]
        }) : title, /*#__PURE__*/jsxRuntime.jsx("div", {
          className: "support-text",
          children: /*#__PURE__*/jsxRuntime.jsx(Paragraph, {
            ellipsis: {
              tooltip: supportText,
              rows: 1
            },
            style: {
              maxWidth: maxWidth
            },
            children: supportText
          })
        })]
      }), hasButtons && /*#__PURE__*/jsxRuntime.jsx("div", {
        ref: buttonCont,
        children: /*#__PURE__*/jsxRuntime.jsx(Buttons, {
          extraButtons: extraButtons,
          actionButtons: actionButtons
        })
      }), addedHeader]
    });
  };
  return {
    renderMainCont: renderMainCont,
    mainContWidth: mainContWidth
  };
};

function BreadCrumbs(_ref) {
  var _ref$breadcrumbs = _ref.breadcrumbs,
    breadcrumbs = _ref$breadcrumbs === void 0 ? [] : _ref$breadcrumbs,
    _ref$mainContWidth = _ref.mainContWidth,
    mainContWidth = _ref$mainContWidth === void 0 ? 0 : _ref$mainContWidth;
  var _useState = React.useState(0),
    _useState2 = _slicedToArray$1(_useState, 2),
    splitIndex = _useState2[0],
    setSplitIndex = _useState2[1];
  var _renderBreadcrumb = function _renderBreadcrumb(b, i, isLast) {
    var noOnClickLast = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    return /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex breadcrumb-item",
      onClick: noOnClickLast && isLast ? undefined : b === null || b === void 0 ? void 0 : b.onClick,
      children: [/*#__PURE__*/jsxRuntime.jsx("span", {
        children: b === null || b === void 0 ? void 0 : b.label
      }), !isLast && /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "flex flex-column justify-content-center",
        children: /*#__PURE__*/jsxRuntime.jsx(CustomIcon, {
          name: "ChevronRight",
          width: 6,
          height: 10
        })
      })]
    }, "breadcrumb-item-".concat(i));
  };
  React.useEffect(function () {
    var _placeholderCont = document.getElementById('header-breadcrumbs');
    if (_placeholderCont) {
      var _items = _placeholderCont.querySelectorAll('.breadcrumb-item');
      if (_items.length) {
        var _width = _items[0].offsetWidth + 30;
        var _splitIndex = 0;
        for (var i = _items.length - 1; i > 0; i--) {
          var _w = _items[i].offsetWidth + 10;
          if (_w + _width > mainContWidth) {
            if (!_splitIndex) {
              _splitIndex = i;
            }
          } else {
            _width += _w;
          }
        }
        setSplitIndex(_splitIndex);
      }
    }
  }, [mainContWidth]);
  var groupedBreadCrumbs = React.useMemo(function () {
    if (splitIndex) {
      var _firstGroup = [breadcrumbs[0]];
      var _secondGroup = _toConsumableArray(breadcrumbs).splice(splitIndex + 1, breadcrumbs.length - 1);
      var _third = _toConsumableArray(breadcrumbs).splice(1, splitIndex);
      return [_firstGroup, _secondGroup, _third];
    }
    return [breadcrumbs];
  }, [splitIndex, breadcrumbs]);
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [groupedBreadCrumbs.length === 1 ? /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "bread-crumbs flex",
      children: groupedBreadCrumbs[0].map(function (v, i) {
        return _renderBreadcrumb(v, i, i === groupedBreadCrumbs[0].length - 1, true);
      })
    }) : /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "bread-crumbs flex",
      children: [groupedBreadCrumbs[0].map(function (v, i) {
        return _renderBreadcrumb(v, i, false);
      }), /*#__PURE__*/jsxRuntime.jsx(antd.Dropdown, {
        trigger: "click",
        placement: "bottomRight",
        menu: {
          items: groupedBreadCrumbs[2].map(function (it, i) {
            return {
              key: "items-".concat(i),
              label: it.label,
              onClick: it.onClick
            };
          })
        },
        children: /*#__PURE__*/jsxRuntime.jsxs("div", {
          className: "flex breadcrumb-item",
          children: [/*#__PURE__*/jsxRuntime.jsx("span", {
            children: "..."
          }), /*#__PURE__*/jsxRuntime.jsx("div", {
            className: "flex flex-column justify-content-center",
            children: /*#__PURE__*/jsxRuntime.jsx(CustomIcon, {
              name: "ChevronRight",
              width: 6,
              height: 10
            })
          })]
        })
      }), groupedBreadCrumbs[1].map(function (v, i) {
        return _renderBreadcrumb(v, i, i === groupedBreadCrumbs[1].length - 1);
      })]
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "bread-crumbs flex placeholder",
      id: "header-breadcrumbs",
      children: breadcrumbs.map(function (v, i) {
        return _renderBreadcrumb(v, i, i === breadcrumbs.length - 1, true);
      })
    })]
  });
}

function DAFHeader(_ref) {
  var _ref$breadcrumbs = _ref.breadcrumbs,
    breadcrumbs = _ref$breadcrumbs === void 0 ? [] : _ref$breadcrumbs,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$tooltip = _ref.tooltip,
    tooltip = _ref$tooltip === void 0 ? '' : _ref$tooltip,
    titleTooltip = _ref.titleTooltip,
    _ref$supportText = _ref.supportText,
    supportText = _ref$supportText === void 0 ? '' : _ref$supportText,
    _ref$tags = _ref.tags,
    tags = _ref$tags === void 0 ? [] : _ref$tags,
    _ref$addedHeader = _ref.addedHeader,
    addedHeader = _ref$addedHeader === void 0 ? null : _ref$addedHeader,
    _ref$actionButtons = _ref.actionButtons,
    actionButtons = _ref$actionButtons === void 0 ? [] : _ref$actionButtons,
    _ref$extraButtons = _ref.extraButtons,
    extraButtons = _ref$extraButtons === void 0 ? [] : _ref$extraButtons,
    onDownload = _ref.onDownload;
  var showBreadcrumbs = !!breadcrumbs.length;
  var _useHeader = useHeader({
      title: title,
      tooltip: tooltip,
      supportText: supportText,
      tags: tags,
      onDownload: onDownload,
      actionButtons: actionButtons,
      extraButtons: extraButtons,
      addedHeader: addedHeader,
      titleTooltip: titleTooltip
    }),
    renderMainCont = _useHeader.renderMainCont,
    mainContWidth = _useHeader.mainContWidth;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "daf-header",
    children: [showBreadcrumbs && /*#__PURE__*/jsxRuntime.jsx(BreadCrumbs, {
      breadcrumbs: breadcrumbs,
      mainContWidth: mainContWidth
    }), renderMainCont()]
  });
}
DAFHeader.propTypes = {
  breadcrumbs: PropTypes__default["default"].array,
  tooltip: PropTypes__default["default"].any,
  titleTooltip: PropTypes__default["default"].any,
  addedHeader: PropTypes__default["default"].any,
  title: PropTypes__default["default"].string,
  supportText: PropTypes__default["default"].any,
  onDownload: PropTypes__default["default"].any,
  tags: PropTypes__default["default"].any,
  actionButtons: PropTypes__default["default"].array,
  extraButtons: PropTypes__default["default"].array
};

function TabsHeader(_ref) {
  var _ref$tabs = _ref.tabs,
    tabs = _ref$tabs === void 0 ? [] : _ref$tabs,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value;
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    className: "daf-tabs-header pl-6 pr-6 pt-2",
    children: /*#__PURE__*/jsxRuntime.jsx(antd.Tabs, {
      onChange: onChange,
      defaultActiveKey: value,
      activeKey: value,
      items: tabs.map(function (tab) {
        return {
          children: null,
          key: tab.value,
          label: tab.label,
          disabled: tab.disabled
        };
      })
    })
  });
}
TabsHeader.propTypes = {
  tabs: PropTypes__default["default"].array,
  onChange: PropTypes__default["default"].func,
  value: PropTypes__default["default"].string
};

function ModalHeader(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$tooltip = _ref.tooltip,
    tooltip = _ref$tooltip === void 0 ? '' : _ref$tooltip,
    _ref$supportText = _ref.supportText,
    supportText = _ref$supportText === void 0 ? '' : _ref$supportText,
    _ref$tags = _ref.tags,
    tags = _ref$tags === void 0 ? [] : _ref$tags,
    _ref$actionButtons = _ref.actionButtons,
    actionButtons = _ref$actionButtons === void 0 ? [] : _ref$actionButtons,
    _ref$extraButtons = _ref.extraButtons,
    extraButtons = _ref$extraButtons === void 0 ? [] : _ref$extraButtons,
    tabsConfig = _ref.tabsConfig;
  var hasTabs = !!tabsConfig;
  var className = hasTabs ? 'with-tabs' : undefined;
  var _useHeader = useHeader({
      title: title,
      tooltip: tooltip,
      supportText: supportText,
      tags: tags,
      className: className,
      actionButtons: actionButtons,
      extraButtons: extraButtons
    }),
    renderMainCont = _useHeader.renderMainCont;
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [renderMainCont(), !!tabsConfig && /*#__PURE__*/jsxRuntime.jsx(TabsHeader, _objectSpread2$1({}, tabsConfig))]
  });
}
ModalHeader.propTypes = {
  tooltip: PropTypes__default["default"].any,
  title: PropTypes__default["default"].string,
  supportText: PropTypes__default["default"].any,
  tags: PropTypes__default["default"].any,
  actionButtons: PropTypes__default["default"].array,
  extraButtons: PropTypes__default["default"].array,
  tabsConfig: PropTypes__default["default"].any
};

function DrawerHeader(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$tooltip = _ref.tooltip,
    tooltip = _ref$tooltip === void 0 ? '' : _ref$tooltip,
    _ref$supportText = _ref.supportText,
    supportText = _ref$supportText === void 0 ? '' : _ref$supportText,
    _ref$tags = _ref.tags,
    tags = _ref$tags === void 0 ? [] : _ref$tags,
    _ref$actionButtons = _ref.actionButtons,
    actionButtons = _ref$actionButtons === void 0 ? [] : _ref$actionButtons,
    _ref$extraButtons = _ref.extraButtons,
    extraButtons = _ref$extraButtons === void 0 ? [] : _ref$extraButtons,
    tabsConfig = _ref.tabsConfig;
  var hasTabs = !!tabsConfig;
  var className = hasTabs ? 'with-tabs' : undefined;
  var _useHeader = useHeader({
      title: title,
      tooltip: tooltip,
      supportText: supportText,
      tags: tags,
      className: className,
      actionButtons: actionButtons,
      extraButtons: extraButtons
    }),
    renderMainCont = _useHeader.renderMainCont;
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [renderMainCont(), !!tabsConfig && /*#__PURE__*/jsxRuntime.jsx(TabsHeader, _objectSpread2$1({}, tabsConfig))]
  });
}
DrawerHeader.propTypes = {
  tooltip: PropTypes__default["default"].any,
  title: PropTypes__default["default"].string,
  supportText: PropTypes__default["default"].any,
  tags: PropTypes__default["default"].any,
  actionButtons: PropTypes__default["default"].array,
  extraButtons: PropTypes__default["default"].array,
  tabsConfig: PropTypes__default["default"].any
};

var Loader = function Loader(_ref) {
  var _ref$background = _ref.background,
    background = _ref$background === void 0 ? 'rgba(255, 255, 255, 0.2)' : _ref$background,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    className: "daf-widget-loader",
    style: _objectSpread2$1({
      background: background
    }, style),
    children: /*#__PURE__*/jsxRuntime.jsx(LoadingOutlined$1, {})
  });
};
Loader.propTypes = {
  background: PropTypes__default["default"].string,
  style: PropTypes__default["default"].any
};

function Widget(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    children = _ref.children,
    _ref$addedHeader = _ref.addedHeader,
    addedHeader = _ref$addedHeader === void 0 ? null : _ref$addedHeader,
    tooltip = _ref.tooltip,
    className = _ref.className,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$fullWidgetLoadin = _ref.fullWidgetLoading,
    fullWidgetLoading = _ref$fullWidgetLoadin === void 0 ? false : _ref$fullWidgetLoadin,
    filtersConfig = _ref.filtersConfig,
    tabsConfig = _ref.tabsConfig;
  var _useState = React.useState(false),
    _useState2 = _slicedToArray$1(_useState, 2),
    showFilters = _useState2[0],
    setShowFilters = _useState2[1];
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: formatClassname(['daf-widget', className, !!tabsConfig && 'with-tabs']),
    children: [loading && fullWidgetLoading && /*#__PURE__*/jsxRuntime.jsx(Loader, {
      background: "white"
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "widget-header flex-column",
      children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "flex flex-row widget-header-items",
        children: [/*#__PURE__*/jsxRuntime.jsx("div", {
          className: "title cont",
          children: /*#__PURE__*/jsxRuntime.jsx("h1", {
            children: title
          })
        }), tooltip && /*#__PURE__*/jsxRuntime.jsx("div", {
          className: "cont icon-cont",
          children: /*#__PURE__*/jsxRuntime.jsx(antd.Tooltip, {
            rootClassName: "dashboard-tooltip",
            title: /*#__PURE__*/jsxRuntime.jsx("div", {
              className: "max-w-250",
              children: tooltip
            }),
            children: /*#__PURE__*/jsxRuntime.jsx(InfoCircleOutlined$1, {})
          })
        }), !!filtersConfig && /*#__PURE__*/jsxRuntime.jsx("div", {
          className: "flex-1 flex justify-content-end",
          children: /*#__PURE__*/jsxRuntime.jsx(antd.Button, {
            onClick: function onClick() {
              return setShowFilters(function (p) {
                return !p;
              });
            },
            children: /*#__PURE__*/jsxRuntime.jsx(CustomIcon, {
              name: "Filter",
              width: 14,
              height: 13,
              className: "mt-1"
            })
          })
        }), addedHeader]
      }), !!filtersConfig && /*#__PURE__*/jsxRuntime.jsx(SelectFilters, {
        t: filtersConfig.t,
        showFilters: showFilters,
        onApply: filtersConfig.onApply,
        options: filtersConfig.options,
        setShowFilters: setShowFilters,
        language: filtersConfig.language,
        type: filtersConfig.type,
        filtersConfig: filtersConfig.filtersConfig,
        selectedFilters: filtersConfig.selectedFilters,
        className: filtersConfig.className
      }), !!tabsConfig && /*#__PURE__*/jsxRuntime.jsx(TabsHeader, {
        tabs: tabsConfig.tabs,
        value: tabsConfig.value,
        onChange: tabsConfig.onChange
      })]
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "widget-body",
      children: [loading && !fullWidgetLoading && /*#__PURE__*/jsxRuntime.jsx(Loader, {
        background: "white"
      }), children]
    })]
  });
}
Widget.propTypes = {
  tooltip: PropTypes__default["default"].any,
  loading: PropTypes__default["default"].bool,
  title: PropTypes__default["default"].string,
  children: PropTypes__default["default"].any,
  className: PropTypes__default["default"].any,
  addedHeader: PropTypes__default["default"].any,
  fullWidgetLoading: PropTypes__default["default"].bool,
  filtersConfig: PropTypes__default["default"].any,
  tabsConfig: PropTypes__default["default"].any
};

function ActionWidget(_ref) {
  var loading = _ref.loading,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? '' : _ref$icon,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    className = _ref.className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$iconWidth = _ref.iconWidth,
    iconWidth = _ref$iconWidth === void 0 ? 18 : _ref$iconWidth,
    _ref$iconHeight = _ref.iconHeight,
    iconHeight = _ref$iconHeight === void 0 ? 18 : _ref$iconHeight,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: formatClassname(['daf-action-widget', className, disabled && 'disabled']),
    onClick: onClick,
    children: [loading && /*#__PURE__*/jsxRuntime.jsx(Loader, {
      background: "white"
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "flex-1 flex flex-column justify-content-center",
      children: /*#__PURE__*/jsxRuntime.jsx("label", {
        children: title
      })
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "flex  flex-column justify-content-center",
      children: /*#__PURE__*/jsxRuntime.jsx(CustomIcon, {
        name: icon,
        width: iconWidth,
        height: iconHeight
      })
    })]
  });
}
ActionWidget.propTypes = {
  disabled: PropTypes__default["default"].any,
  loading: PropTypes__default["default"].any,
  icon: PropTypes__default["default"].string,
  title: PropTypes__default["default"].string,
  className: PropTypes__default["default"].string,
  iconWidth: PropTypes__default["default"].any,
  iconHeight: PropTypes__default["default"].any,
  onClick: PropTypes__default["default"].func
};

exports.ActionWidget = ActionWidget;
exports.Button = DafButton;
exports.CustomIcon = CustomIcon;
exports.DafTheme = DafTheme;
exports.DrawerHeader = DrawerHeader;
exports.FilterButton = FilterButton;
exports.FormPopover = FormPopover;
exports.GetIcon = GetIcon;
exports.GoToSelect = GoToSelect;
exports.Header = DAFHeader;
exports.ModalHeader = ModalHeader;
exports.MoreMenu = MoreMenu;
exports.MoreTags = MoreTags;
exports.Pagination = Pagination;
exports.SearchFilters = SearchFilters;
exports.SelectFilters = SelectFilters;
exports.SelectFiltersAjaxSelect = AjaxSelect;
exports.SelectFiltersSelect = CustomSelect;
exports.SelectFiltersTimeFrame = Timeframe;
exports.SettingsPopover = SettingsPopover;
exports.StickyTable = StickyTable;
exports.Table = DAFTable;
exports.TabsHeader = TabsHeader;
exports.Widget = Widget;
exports.WidgetLoader = Loader;
exports.expandIcon = expandIcon;
